
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb14d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb14d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("caapT", function(module, exports) {

$parcel$export(module.exports, "ji", function () { return l; });
$parcel$export(module.exports, "Ai", function () { return f; });
$parcel$export(module.exports, "ki", function () { return m; });
$parcel$export(module.exports, "Oi", function () { return h; });
$parcel$export(module.exports, "Ei", function () { return g; });
$parcel$export(module.exports, "Di", function () { return v; });
$parcel$export(module.exports, "fi", function () { return b; });
$parcel$export(module.exports, "ui", function () { return x; });
$parcel$export(module.exports, "di", function () { return S; });
$parcel$export(module.exports, "gi", function () { return C; });
$parcel$export(module.exports, "_i", function () { return w; });
$parcel$export(module.exports, "vi", function () { return T; });
$parcel$export(module.exports, "Ti", function () { return E; });
$parcel$export(module.exports, "wi", function () { return D; });
$parcel$export(module.exports, "xi", function () { return O; });
$parcel$export(module.exports, "Si", function () { return k; });
$parcel$export(module.exports, "Ci", function () { return A; });
$parcel$export(module.exports, "hi", function () { return ee; });
$parcel$export(module.exports, "bi", function () { return ne; });
$parcel$export(module.exports, "yi", function () { return ie; });
$parcel$export(module.exports, "mi", function () { return ae; });
$parcel$export(module.exports, "pi", function () { return oe; });
$parcel$export(module.exports, "qr", function () { return ce; });
$parcel$export(module.exports, "Zr", function () { return le; });
$parcel$export(module.exports, "Kr", function () { return de; });
$parcel$export(module.exports, "ri", function () { return pe; });
$parcel$export(module.exports, "ii", function () { return me; });
$parcel$export(module.exports, "Qr", function () { return he; });
$parcel$export(module.exports, "$r", function () { return ge; });
$parcel$export(module.exports, "Yr", function () { return _e; });
$parcel$export(module.exports, "Jr", function () { return ve; });
$parcel$export(module.exports, "si", function () { return ye; });
$parcel$export(module.exports, "oi", function () { return be; });
$parcel$export(module.exports, "ci", function () { return xe; });
$parcel$export(module.exports, "ei", function () { return Se; });
$parcel$export(module.exports, "ti", function () { return Ce; });
$parcel$export(module.exports, "ni", function () { return we; });
$parcel$export(module.exports, "li", function () { return Te; });
$parcel$export(module.exports, "ai", function () { return Ee; });
$parcel$export(module.exports, "Xr", function () { return De; });
$parcel$export(module.exports, "Wr", function () { return Ae; });
$parcel$export(module.exports, "Gr", function () { return Me; });
$parcel$export(module.exports, "Ur", function () { return Ne; });
$parcel$export(module.exports, "Hr", function () { return Ie; });
$parcel$export(module.exports, "Vr", function () { return Re; });
$parcel$export(module.exports, "Fr", function () { return Be; });
$parcel$export(module.exports, "Lr", function () { return He; });
$parcel$export(module.exports, "Ir", function () { return Ue; });
$parcel$export(module.exports, "zr", function () { return Ke; });
$parcel$export(module.exports, "Br", function () { return qe; });
$parcel$export(module.exports, "Rr", function () { return Je; });
$parcel$export(module.exports, "Pr", function () { return Ye; });
$parcel$export(module.exports, "Nr", function () { return Xe; });
$parcel$export(module.exports, "Yn", function () { return Qe; });
$parcel$export(module.exports, "Hn", function () { return $e; });
$parcel$export(module.exports, "Vn", function () { return et; });
$parcel$export(module.exports, "Bn", function () { return tt; });
$parcel$export(module.exports, "zn", function () { return nt; });
$parcel$export(module.exports, "Rn", function () { return rt; });
$parcel$export(module.exports, "Or", function () { return it; });
$parcel$export(module.exports, "_r", function () { return at; });
$parcel$export(module.exports, "Dr", function () { return ot; });
$parcel$export(module.exports, "yr", function () { return st; });
$parcel$export(module.exports, "Mn", function () { return ct; });
$parcel$export(module.exports, "Kn", function () { return lt; });
$parcel$export(module.exports, "pr", function () { return dt; });
$parcel$export(module.exports, "qn", function () { return ut; });
$parcel$export(module.exports, "xr", function () { return ft; });
$parcel$export(module.exports, "dr", function () { return pt; });
$parcel$export(module.exports, "In", function () { return yt; });
$parcel$export(module.exports, "er", function () { return mt; });
$parcel$export(module.exports, "nr", function () { return ht; });
$parcel$export(module.exports, "Jn", function () { return gt; });
$parcel$export(module.exports, "Fn", function () { return _t; });
$parcel$export(module.exports, "Wn", function () { return vt; });
$parcel$export(module.exports, "jr", function () { return bt; });
$parcel$export(module.exports, "Zn", function () { return xt; });
$parcel$export(module.exports, "gr", function () { return St; });
$parcel$export(module.exports, "kr", function () { return wt; });
$parcel$export(module.exports, "mr", function () { return Et; });
$parcel$export(module.exports, "Mr", function () { return Dt; });
$parcel$export(module.exports, "wr", function () { return Ot; });
$parcel$export(module.exports, "Xn", function () { return kt; });
$parcel$export(module.exports, "fr", function () { return At; });
$parcel$export(module.exports, "Qn", function () { return jt; });
$parcel$export(module.exports, "Un", function () { return Mt; });
$parcel$export(module.exports, "Ln", function () { return Nt; });
$parcel$export(module.exports, "Ar", function () { return Ft; });
$parcel$export(module.exports, "$n", function () { return Lt; });
$parcel$export(module.exports, "Tr", function () { return Rt; });
$parcel$export(module.exports, "ur", function () { return zt; });
$parcel$export(module.exports, "hr", function () { return Bt; });
$parcel$export(module.exports, "sr", function () { return Ht; });
$parcel$export(module.exports, "ar", function () { return Ut; });
$parcel$export(module.exports, "Pn", function () { return Wt; });
$parcel$export(module.exports, "Nn", function () { return Kt; });
$parcel$export(module.exports, "br", function () { return Jt; });
$parcel$export(module.exports, "Er", function () { return $t; });
$parcel$export(module.exports, "Gn", function () { return en; });
$parcel$export(module.exports, "vr", function () { return tn; });
$parcel$export(module.exports, "Sr", function () { return nn; });
$parcel$export(module.exports, "ir", function () { return rn; });
$parcel$export(module.exports, "tr", function () { return an; });
$parcel$export(module.exports, "Cr", function () { return on; });
$parcel$export(module.exports, "jn", function () { return sn; });
$parcel$export(module.exports, "cr", function () { return un; });
$parcel$export(module.exports, "or", function () { return dn; });
$parcel$export(module.exports, "lr", function () { return fn; });
$parcel$export(module.exports, "Dn", function () { return mn; });
$parcel$export(module.exports, "On", function () { return hn; });
$parcel$export(module.exports, "kn", function () { return gn; });
$parcel$export(module.exports, "En", function () { return _n; });
$parcel$export(module.exports, "wn", function () { return vn; });
$parcel$export(module.exports, "gn", function () { return xn; });
$parcel$export(module.exports, "yn", function () { return Cn; });
$parcel$export(module.exports, "xn", function () { return Dn; });
$parcel$export(module.exports, "vn", function () { return On; });
$parcel$export(module.exports, "_n", function () { return kn; });
$parcel$export(module.exports, "Sn", function () { return An; });
$parcel$export(module.exports, "bn", function () { return jn; });
$parcel$export(module.exports, "pn", function () { return Pn; });
$parcel$export(module.exports, "fn", function () { return Fn; });
$parcel$export(module.exports, "mn", function () { return In; });
$parcel$export(module.exports, "dn", function () { return j; });
$parcel$export(module.exports, "an", function () { return zn; });
$parcel$export(module.exports, "on", function () { return Xn; });
$parcel$export(module.exports, "rn", function () { return N; });
$parcel$export(module.exports, "tn", function () { return z; });
$parcel$export(module.exports, "nn", function () { return ti; });
$parcel$export(module.exports, "un", function () { return Di; });
$parcel$export(module.exports, "cn", function () { return ps; });
$parcel$export(module.exports, "sn", function () { return Ts; });
$parcel$export(module.exports, "$t", function () { return Cc; });
$parcel$export(module.exports, "Xt", function () { return wc; });
$parcel$export(module.exports, "en", function () { return Ec; });
$parcel$export(module.exports, "Zt", function () { return Dc; });
$parcel$export(module.exports, "Qt", function () { return Oc; });
$parcel$export(module.exports, "Jt", function () { return Lc; });
$parcel$export(module.exports, "qt", function () { return Rc; });
$parcel$export(module.exports, "Gt", function () { return U; });
$parcel$export(module.exports, "Ut", function () { return il; });
$parcel$export(module.exports, "Wt", function () { return sl; });
$parcel$export(module.exports, "Vt", function () { return W; });
$parcel$export(module.exports, "Ht", function () { return gl; });
$parcel$export(module.exports, "Bt", function () { return Cl; });
$parcel$export(module.exports, "zt", function () { return q; });
$parcel$export(module.exports, "jt", function () { return eu; });
$parcel$export(module.exports, "Ft", function () { return du; });
$parcel$export(module.exports, "Pt", function () { return fu; });
$parcel$export(module.exports, "Lt", function () { return pu; });
$parcel$export(module.exports, "Mt", function () { return Tu; });
$parcel$export(module.exports, "It", function () { return Du; });
$parcel$export(module.exports, "Rt", function () { return Ou; });
$parcel$export(module.exports, "Nt", function () { return Au; });
$parcel$export(module.exports, "At", function () { return Nu; });
$parcel$export(module.exports, "St", function () { return Gu; });
$parcel$export(module.exports, "xt", function () { return Ku; });
$parcel$export(module.exports, "Ct", function () { return qu; });
$parcel$export(module.exports, "wt", function () { return Ju; });
$parcel$export(module.exports, "Tt", function () { return Yu; });
$parcel$export(module.exports, "Et", function () { return Xu; });
$parcel$export(module.exports, "Dt", function () { return Zu; });
$parcel$export(module.exports, "Ot", function () { return Qu; });
$parcel$export(module.exports, "kt", function () { return ed; });
$parcel$export(module.exports, "bt", function () { return _d; });
$parcel$export(module.exports, "yt", function () { return xd; });
$parcel$export(module.exports, "vt", function () { return Zd; });
$parcel$export(module.exports, "gt", function () { return sf; });
$parcel$export(module.exports, "_t", function () { return cf; });
$parcel$export(module.exports, "ht", function () { return uf; });
$parcel$export(module.exports, "pt", function () { return df; });
$parcel$export(module.exports, "mt", function () { return ff; });
$parcel$export(module.exports, "ft", function () { return _f; });
$parcel$export(module.exports, "dt", function () { return Cf; });
$parcel$export(module.exports, "lt", function () { return Ef; });
$parcel$export(module.exports, "st", function () { return Ep; });
$parcel$export(module.exports, "ct", function () { return Dp; });
$parcel$export(module.exports, "at", function () { return Op; });
$parcel$export(module.exports, "ot", function () { return kp; });
$parcel$export(module.exports, "rt", function () { return Kp; });
$parcel$export(module.exports, "et", function () { return fm; });
$parcel$export(module.exports, "Z", function () { return rg; });
$parcel$export(module.exports, "X", function () { return ug; });
$parcel$export(module.exports, "J", function () { return Yg; });
$parcel$export(module.exports, "q", function () { return Xg; });
$parcel$export(module.exports, "K", function () { return Zg; });
$parcel$export(module.exports, "G", function () { return Qg; });
$parcel$export(module.exports, "U", function () { return i_; });
$parcel$export(module.exports, "B", function () { return y_; });
$parcel$export(module.exports, "V", function () { return b_; });
$parcel$export(module.exports, "z", function () { return x_; });
$parcel$export(module.exports, "R", function () { return w_; });
$parcel$export(module.exports, "L", function () { return O_; });
$parcel$export(module.exports, "I", function () { return I_; });
$parcel$export(module.exports, "F", function () { return H_; });
$parcel$export(module.exports, "P", function () { return W_; });
$parcel$export(module.exports, "N", function () { return G_; });
$parcel$export(module.exports, "M", function () { return q_; });
$parcel$export(module.exports, "j", function () { return X_; });
$parcel$export(module.exports, "A", function () { return Z_; });
$parcel$export(module.exports, "k", function () { return Q_; });
$parcel$export(module.exports, "E", function () { return tv; });
$parcel$export(module.exports, "D", function () { return nv; });
$parcel$export(module.exports, "O", function () { return rv; });
$parcel$export(module.exports, "T", function () { return iv; });
$parcel$export(module.exports, "w", function () { return av; });
$parcel$export(module.exports, "C", function () { return ov; });
$parcel$export(module.exports, "S", function () { return cv; });
$parcel$export(module.exports, "x", function () { return uv; });
$parcel$export(module.exports, "g", function () { return dv; });
$parcel$export(module.exports, "y", function () { return mv; });
$parcel$export(module.exports, "v", function () { return fv; });
$parcel$export(module.exports, "_", function () { return pv; });
$parcel$export(module.exports, "b", function () { return yv; });
$parcel$export(module.exports, "h", function () { return bv; });
$parcel$export(module.exports, "f", function () { return Sv; });
$parcel$export(module.exports, "u", function () { return Pv; });
$parcel$export(module.exports, "s", function () { return zS; });
$parcel$export(module.exports, "a", function () { return VS; });
$parcel$export(module.exports, "r", function () { return gC; });
$parcel$export(module.exports, "t", function () { return xC; });
/**
* MapLibre GL JS
* @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v6.0.0/LICENSE.txt
*/ var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t)=>()=>(t || (e((t = {
            exports: {}
        }).exports, t), e = null), t.exports), s = (e, i, o, s)=>{
    if (i && typeof i == `object` || typeof i == `function`) for(var c = r(i), l = 0, u = c.length, d; l < u; l++)d = c[l], !a.call(e, d) && d !== o && t(e, d, {
        get: ((e)=>i[e]).bind(null, d),
        enumerable: !(s = n(i, d)) || s.enumerable
    });
    return e;
}, c = (n, r, a)=>(a = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule ? t(a, `default`, {
        value: n,
        enumerable: !0
    }) : a, n));
function l(e, t) {
    this.x = e, this.y = t;
}
l.prototype = {
    clone () {
        return new l(this.x, this.y);
    },
    add (e) {
        return this.clone()._add(e);
    },
    sub (e) {
        return this.clone()._sub(e);
    },
    multByPoint (e) {
        return this.clone()._multByPoint(e);
    },
    divByPoint (e) {
        return this.clone()._divByPoint(e);
    },
    mult (e) {
        return this.clone()._mult(e);
    },
    div (e) {
        return this.clone()._div(e);
    },
    rotate (e) {
        return this.clone()._rotate(e);
    },
    rotateAround (e, t) {
        return this.clone()._rotateAround(e, t);
    },
    matMult (e) {
        return this.clone()._matMult(e);
    },
    unit () {
        return this.clone()._unit();
    },
    perp () {
        return this.clone()._perp();
    },
    round () {
        return this.clone()._round();
    },
    mag () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    equals (e) {
        return this.x === e.x && this.y === e.y;
    },
    dist (e) {
        return Math.sqrt(this.distSqr(e));
    },
    distSqr (e) {
        let t = e.x - this.x, n = e.y - this.y;
        return t * t + n * n;
    },
    angle () {
        return Math.atan2(this.y, this.x);
    },
    angleTo (e) {
        return Math.atan2(this.y - e.y, this.x - e.x);
    },
    angleWith (e) {
        return this.angleWithSep(e.x, e.y);
    },
    angleWithSep (e, t) {
        return Math.atan2(this.x * t - this.y * e, this.x * e + this.y * t);
    },
    _matMult (e) {
        let t = e[0] * this.x + e[1] * this.y, n = e[2] * this.x + e[3] * this.y;
        return this.x = t, this.y = n, this;
    },
    _add (e) {
        return this.x += e.x, this.y += e.y, this;
    },
    _sub (e) {
        return this.x -= e.x, this.y -= e.y, this;
    },
    _mult (e) {
        return this.x *= e, this.y *= e, this;
    },
    _div (e) {
        return this.x /= e, this.y /= e, this;
    },
    _multByPoint (e) {
        return this.x *= e.x, this.y *= e.y, this;
    },
    _divByPoint (e) {
        return this.x /= e.x, this.y /= e.y, this;
    },
    _unit () {
        return this._div(this.mag()), this;
    },
    _perp () {
        let e = this.y;
        return this.y = this.x, this.x = -e, this;
    },
    _rotate (e) {
        let t = Math.cos(e), n = Math.sin(e), r = t * this.x - n * this.y, i = n * this.x + t * this.y;
        return this.x = r, this.y = i, this;
    },
    _rotateAround (e, t) {
        let n = Math.cos(e), r = Math.sin(e), i = t.x + n * (this.x - t.x) - r * (this.y - t.y), a = t.y + r * (this.x - t.x) + n * (this.y - t.y);
        return this.x = i, this.y = a, this;
    },
    _round () {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    },
    constructor: l
}, l.convert = function(e) {
    if (e instanceof l) return e;
    if (Array.isArray(e)) return new l(+e[0], +e[1]);
    if (e.x !== void 0 && e.y !== void 0) return new l(+e.x, +e.y);
    throw Error(`Expected [x, y] or {x, y} point format`);
};
function u(e, t, n, r) {
    let i = 3 * e, a = 3 * (n - e) - i, o = 1 - i - a, s = 3 * t, c = 3 * (r - t) - s, l = 1 - s - c;
    return function(e, t = 1e-6) {
        if (e <= 0) return 0;
        if (e >= 1) return 1;
        let n = e;
        for(let r = 0; r < 8; r++){
            let r = ((o * n + a) * n + i) * n - e;
            if (Math.abs(r) < t) return ((l * n + c) * n + s) * n;
            let u = (3 * o * n + 2 * a) * n + i;
            if (Math.abs(u) < 1e-6) break;
            n -= r / u;
        }
        let r = 0, u = 1;
        n = e;
        for(let s = 0; s < 20; s++){
            let s = ((o * n + a) * n + i) * n;
            if (Math.abs(s - e) < t) break;
            e > s ? r = n : u = n, n = (r + u) * .5;
        }
        return ((l * n + c) * n + s) * n;
    };
}
let d;
function f() {
    return d ??= typeof OffscreenCanvas < `u` && new OffscreenCanvas(1, 1).getContext(`2d`) && typeof createImageBitmap == `function`, d;
}
let p;
function m() {
    if (p == null && (p = !1, f())) {
        let e = new OffscreenCanvas(5, 5).getContext(`2d`, {
            willReadFrequently: !0
        });
        if (e) {
            for(let t = 0; t < 25; t++){
                let n = t * 4;
                e.fillStyle = `rgb(${n},${n + 1},${n + 2})`, e.fillRect(t % 5, Math.floor(t / 5), 1, 1);
            }
            let t = e.getImageData(0, 0, 5, 5).data;
            for(let e = 0; e < 100; e++)if (e % 4 != 3 && t[e] !== e) {
                p = !0;
                break;
            }
        }
    }
    return p || !1;
}
var h = typeof Float32Array < `u` ? Float32Array : Array;
Math.PI, Math.PI;
function g() {
    var e = new h(9);
    return h != Float32Array && (e[1] = 0, e[2] = 0, e[3] = 0, e[5] = 0, e[6] = 0, e[7] = 0), e[0] = 1, e[4] = 1, e[8] = 1, e;
}
function _(e) {
    var t = e[0], n = e[1], r = e[2], i = e[3], a = e[4], o = e[5], s = e[6], c = e[7], l = e[8];
    return t * (l * a - o * c) + n * (-l * i + o * s) + r * (c * i - a * s);
}
function v(e, t) {
    var n = Math.sin(t), r = Math.cos(t);
    return e[0] = r, e[1] = n, e[2] = 0, e[3] = -n, e[4] = r, e[5] = 0, e[6] = 0, e[7] = 0, e[8] = 1, e;
}
function y(e, t) {
    var n = t[0], r = t[1], i = t[2], a = t[3], o = n + n, s = r + r, c = i + i, l = n * o, u = r * o, d = r * s, f = i * o, p = i * s, m = i * c, h = a * o, g = a * s, _ = a * c;
    return e[0] = 1 - d - m, e[3] = u - _, e[6] = f + g, e[1] = u + _, e[4] = 1 - l - m, e[7] = p - h, e[2] = f - g, e[5] = p + h, e[8] = 1 - l - d, e;
}
function b() {
    var e = new h(16);
    return h != Float32Array && (e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0), e[0] = 1, e[5] = 1, e[10] = 1, e[15] = 1, e;
}
function x(e) {
    var t = new h(16);
    return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
}
function S(e, t) {
    return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
}
function C(e) {
    return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function w(e, t) {
    var n = t[0], r = t[1], i = t[2], a = t[3], o = t[4], s = t[5], c = t[6], l = t[7], u = t[8], d = t[9], f = t[10], p = t[11], m = t[12], h = t[13], g = t[14], _ = t[15], v = n * s - r * o, y = n * c - i * o, b = n * l - a * o, x = r * c - i * s, S = r * l - a * s, C = i * l - a * c, w = u * h - d * m, T = u * g - f * m, E = u * _ - p * m, D = d * g - f * h, O = d * _ - p * h, k = f * _ - p * g, A = v * k - y * O + b * D + x * E - S * T + C * w;
    return A ? (A = 1 / A, e[0] = (s * k - c * O + l * D) * A, e[1] = (i * O - r * k - a * D) * A, e[2] = (h * C - g * S + _ * x) * A, e[3] = (f * S - d * C - p * x) * A, e[4] = (c * E - o * k - l * T) * A, e[5] = (n * k - i * E + a * T) * A, e[6] = (g * b - m * C - _ * y) * A, e[7] = (u * C - f * b + p * y) * A, e[8] = (o * O - s * E + l * w) * A, e[9] = (r * E - n * O - a * w) * A, e[10] = (m * S - h * b + _ * v) * A, e[11] = (d * b - u * S - p * v) * A, e[12] = (s * T - o * D - c * w) * A, e[13] = (n * D - r * T + i * w) * A, e[14] = (h * y - m * x - g * v) * A, e[15] = (u * x - d * y + f * v) * A, e) : null;
}
function T(e, t, n) {
    var r = t[0], i = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8], f = t[9], p = t[10], m = t[11], h = t[12], g = t[13], _ = t[14], v = t[15], y = n[0], b = n[1], x = n[2], S = n[3];
    return e[0] = y * r + b * s + x * d + S * h, e[1] = y * i + b * c + x * f + S * g, e[2] = y * a + b * l + x * p + S * _, e[3] = y * o + b * u + x * m + S * v, y = n[4], b = n[5], x = n[6], S = n[7], e[4] = y * r + b * s + x * d + S * h, e[5] = y * i + b * c + x * f + S * g, e[6] = y * a + b * l + x * p + S * _, e[7] = y * o + b * u + x * m + S * v, y = n[8], b = n[9], x = n[10], S = n[11], e[8] = y * r + b * s + x * d + S * h, e[9] = y * i + b * c + x * f + S * g, e[10] = y * a + b * l + x * p + S * _, e[11] = y * o + b * u + x * m + S * v, y = n[12], b = n[13], x = n[14], S = n[15], e[12] = y * r + b * s + x * d + S * h, e[13] = y * i + b * c + x * f + S * g, e[14] = y * a + b * l + x * p + S * _, e[15] = y * o + b * u + x * m + S * v, e;
}
function E(e, t, n) {
    var r = n[0], i = n[1], a = n[2], o, s, c, l, u, d, f, p, m, h, g, _;
    return t === e ? (e[12] = t[0] * r + t[4] * i + t[8] * a + t[12], e[13] = t[1] * r + t[5] * i + t[9] * a + t[13], e[14] = t[2] * r + t[6] * i + t[10] * a + t[14], e[15] = t[3] * r + t[7] * i + t[11] * a + t[15]) : (o = t[0], s = t[1], c = t[2], l = t[3], u = t[4], d = t[5], f = t[6], p = t[7], m = t[8], h = t[9], g = t[10], _ = t[11], e[0] = o, e[1] = s, e[2] = c, e[3] = l, e[4] = u, e[5] = d, e[6] = f, e[7] = p, e[8] = m, e[9] = h, e[10] = g, e[11] = _, e[12] = o * r + u * i + m * a + t[12], e[13] = s * r + d * i + h * a + t[13], e[14] = c * r + f * i + g * a + t[14], e[15] = l * r + p * i + _ * a + t[15]), e;
}
function D(e, t, n) {
    var r = n[0], i = n[1], a = n[2];
    return e[0] = t[0] * r, e[1] = t[1] * r, e[2] = t[2] * r, e[3] = t[3] * r, e[4] = t[4] * i, e[5] = t[5] * i, e[6] = t[6] * i, e[7] = t[7] * i, e[8] = t[8] * a, e[9] = t[9] * a, e[10] = t[10] * a, e[11] = t[11] * a, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
}
function O(e, t, n) {
    var r = Math.sin(n), i = Math.cos(n), a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11];
    return t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[4] = a * i + l * r, e[5] = o * i + u * r, e[6] = s * i + d * r, e[7] = c * i + f * r, e[8] = l * i - a * r, e[9] = u * i - o * r, e[10] = d * i - s * r, e[11] = f * i - c * r, e;
}
function k(e, t, n) {
    var r = Math.sin(n), i = Math.cos(n), a = t[0], o = t[1], s = t[2], c = t[3], l = t[8], u = t[9], d = t[10], f = t[11];
    return t !== e && (e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = a * i - l * r, e[1] = o * i - u * r, e[2] = s * i - d * r, e[3] = c * i - f * r, e[8] = a * r + l * i, e[9] = o * r + u * i, e[10] = s * r + d * i, e[11] = c * r + f * i, e;
}
function A(e, t, n) {
    var r = Math.sin(n), i = Math.cos(n), a = t[0], o = t[1], s = t[2], c = t[3], l = t[4], u = t[5], d = t[6], f = t[7];
    return t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = a * i + l * r, e[1] = o * i + u * r, e[2] = s * i + d * r, e[3] = c * i + f * r, e[4] = l * i - a * r, e[5] = u * i - o * r, e[6] = d * i - s * r, e[7] = f * i - c * r, e;
}
function ee(e, t) {
    return e[0] = t[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = t[1], e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = t[2], e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function te(e, t, n, r, i) {
    var a = 1 / Math.tan(t / 2);
    if (e[0] = a / n, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[11] = -1, e[12] = 0, e[13] = 0, e[15] = 0, i != null && i !== 1 / 0) {
        var o = 1 / (r - i);
        e[10] = (i + r) * o, e[14] = 2 * i * r * o;
    } else e[10] = -1, e[14] = -2 * r;
    return e;
}
var ne = te;
function re(e, t, n, r, i, a, o) {
    var s = 1 / (t - n), c = 1 / (r - i), l = 1 / (a - o);
    return e[0] = -2 * s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * c, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * l, e[11] = 0, e[12] = (t + n) * s, e[13] = (i + r) * c, e[14] = (o + a) * l, e[15] = 1, e;
}
var ie = re;
function ae(e, t) {
    return e[0] === t[0] && e[1] === t[1] && e[2] === t[2] && e[3] === t[3] && e[4] === t[4] && e[5] === t[5] && e[6] === t[6] && e[7] === t[7] && e[8] === t[8] && e[9] === t[9] && e[10] === t[10] && e[11] === t[11] && e[12] === t[12] && e[13] === t[13] && e[14] === t[14] && e[15] === t[15];
}
function oe(e, t) {
    var n = e[0], r = e[1], i = e[2], a = e[3], o = e[4], s = e[5], c = e[6], l = e[7], u = e[8], d = e[9], f = e[10], p = e[11], m = e[12], h = e[13], g = e[14], _ = e[15], v = t[0], y = t[1], b = t[2], x = t[3], S = t[4], C = t[5], w = t[6], T = t[7], E = t[8], D = t[9], O = t[10], k = t[11], A = t[12], ee = t[13], te = t[14], ne = t[15];
    return Math.abs(n - v) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(r - y) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(y)) && Math.abs(i - b) <= 1e-6 * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(a - x) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(x)) && Math.abs(o - S) <= 1e-6 * Math.max(1, Math.abs(o), Math.abs(S)) && Math.abs(s - C) <= 1e-6 * Math.max(1, Math.abs(s), Math.abs(C)) && Math.abs(c - w) <= 1e-6 * Math.max(1, Math.abs(c), Math.abs(w)) && Math.abs(l - T) <= 1e-6 * Math.max(1, Math.abs(l), Math.abs(T)) && Math.abs(u - E) <= 1e-6 * Math.max(1, Math.abs(u), Math.abs(E)) && Math.abs(d - D) <= 1e-6 * Math.max(1, Math.abs(d), Math.abs(D)) && Math.abs(f - O) <= 1e-6 * Math.max(1, Math.abs(f), Math.abs(O)) && Math.abs(p - k) <= 1e-6 * Math.max(1, Math.abs(p), Math.abs(k)) && Math.abs(m - A) <= 1e-6 * Math.max(1, Math.abs(m), Math.abs(A)) && Math.abs(h - ee) <= 1e-6 * Math.max(1, Math.abs(h), Math.abs(ee)) && Math.abs(g - te) <= 1e-6 * Math.max(1, Math.abs(g), Math.abs(te)) && Math.abs(_ - ne) <= 1e-6 * Math.max(1, Math.abs(_), Math.abs(ne));
}
function se() {
    var e = new h(3);
    return h != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0), e;
}
function ce(e) {
    var t = new h(3);
    return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
}
function le(e) {
    var t = e[0], n = e[1], r = e[2];
    return Math.sqrt(t * t + n * n + r * r);
}
function ue(e, t, n) {
    var r = new h(3);
    return r[0] = e, r[1] = t, r[2] = n, r;
}
function de(e, t, n) {
    return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e;
}
function fe(e, t, n) {
    return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e;
}
function pe(e, t, n) {
    return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e;
}
function me(e, t, n, r) {
    return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e[2] = t[2] + n[2] * r, e;
}
function he(e, t) {
    return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e;
}
function ge(e, t) {
    var n = t[0], r = t[1], i = t[2], a = n * n + r * r + i * i;
    return a > 0 && (a = 1 / Math.sqrt(a)), e[0] = t[0] * a, e[1] = t[1] * a, e[2] = t[2] * a, e;
}
function _e(e, t) {
    return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
}
function ve(e, t, n) {
    var r = t[0], i = t[1], a = t[2], o = n[0], s = n[1], c = n[2];
    return e[0] = i * c - a * s, e[1] = a * o - r * c, e[2] = r * s - i * o, e;
}
function ye(e, t, n) {
    var r = t[0], i = t[1], a = t[2], o = n[3] * r + n[7] * i + n[11] * a + n[15];
    return o ||= 1, e[0] = (n[0] * r + n[4] * i + n[8] * a + n[12]) / o, e[1] = (n[1] * r + n[5] * i + n[9] * a + n[13]) / o, e[2] = (n[2] * r + n[6] * i + n[10] * a + n[14]) / o, e;
}
function be(e, t, n) {
    var r = t[0], i = t[1], a = t[2];
    return e[0] = r * n[0] + i * n[3] + a * n[6], e[1] = r * n[1] + i * n[4] + a * n[7], e[2] = r * n[2] + i * n[5] + a * n[8], e;
}
function xe(e, t, n) {
    var r = n[0], i = n[1], a = n[2], o = n[3], s = t[0], c = t[1], l = t[2], u = i * l - a * c, d = a * s - r * l, f = r * c - i * s;
    return u += u, d += d, f += f, e[0] = s + o * u + i * f - a * d, e[1] = c + o * d + a * u - r * f, e[2] = l + o * f + r * d - i * u, e;
}
function Se(e, t, n, r) {
    var i = [], a = [];
    return i[0] = t[0] - n[0], i[1] = t[1] - n[1], i[2] = t[2] - n[2], a[0] = i[0], a[1] = i[1] * Math.cos(r) - i[2] * Math.sin(r), a[2] = i[1] * Math.sin(r) + i[2] * Math.cos(r), e[0] = a[0] + n[0], e[1] = a[1] + n[1], e[2] = a[2] + n[2], e;
}
function Ce(e, t, n, r) {
    var i = [], a = [];
    return i[0] = t[0] - n[0], i[1] = t[1] - n[1], i[2] = t[2] - n[2], a[0] = i[2] * Math.sin(r) + i[0] * Math.cos(r), a[1] = i[1], a[2] = i[2] * Math.cos(r) - i[0] * Math.sin(r), e[0] = a[0] + n[0], e[1] = a[1] + n[1], e[2] = a[2] + n[2], e;
}
function we(e, t, n, r) {
    var i = [], a = [];
    return i[0] = t[0] - n[0], i[1] = t[1] - n[1], i[2] = t[2] - n[2], a[0] = i[0] * Math.cos(r) - i[1] * Math.sin(r), a[1] = i[0] * Math.sin(r) + i[1] * Math.cos(r), a[2] = i[2], e[0] = a[0] + n[0], e[1] = a[1] + n[1], e[2] = a[2] + n[2], e;
}
function Te(e) {
    return e[0] = 0, e[1] = 0, e[2] = 0, e;
}
var Ee = fe, De = le;
(function() {
    var e = se();
    return function(t, n, r, i, a, o) {
        var s, c;
        for(n ||= 3, r ||= 0, c = i ? Math.min(i * n + r, t.length) : t.length, s = r; s < c; s += n)e[0] = t[s], e[1] = t[s + 1], e[2] = t[s + 2], a(e, e, o), t[s] = e[0], t[s + 1] = e[1], t[s + 2] = e[2];
        return t;
    };
})();
function Oe() {
    var e = new h(4);
    return h != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0), e;
}
function ke(e, t, n) {
    return e[0] = t[0] * n[0], e[1] = t[1] * n[1], e[2] = t[2] * n[2], e[3] = t[3] * n[3], e;
}
function Ae(e, t, n) {
    return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e;
}
function je(e, t) {
    var n = t[0], r = t[1], i = t[2], a = t[3], o = n * n + r * r + i * i + a * a;
    return o > 0 && (o = 1 / Math.sqrt(o)), e[0] = n * o, e[1] = r * o, e[2] = i * o, e[3] = a * o, e;
}
function Me(e, t, n) {
    var r = t[0], i = t[1], a = t[2], o = t[3];
    return e[0] = n[0] * r + n[4] * i + n[8] * a + n[12] * o, e[1] = n[1] * r + n[5] * i + n[9] * a + n[13] * o, e[2] = n[2] * r + n[6] * i + n[10] * a + n[14] * o, e[3] = n[3] * r + n[7] * i + n[11] * a + n[15] * o, e;
}
var Ne = ke;
(function() {
    var e = Oe();
    return function(t, n, r, i, a, o) {
        var s, c;
        for(n ||= 4, r ||= 0, c = i ? Math.min(i * n + r, t.length) : t.length, s = r; s < c; s += n)e[0] = t[s], e[1] = t[s + 1], e[2] = t[s + 2], e[3] = t[s + 3], a(e, e, o), t[s] = e[0], t[s + 1] = e[1], t[s + 2] = e[2], t[s + 3] = e[3];
        return t;
    };
})();
function Pe() {
    var e = new h(4);
    return h != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0), e[3] = 1, e;
}
function Fe(e, t, n) {
    n *= .5;
    var r = Math.sin(n);
    return e[0] = r * t[0], e[1] = r * t[1], e[2] = r * t[2], e[3] = Math.cos(n), e;
}
function Ie(e, t, n, r) {
    var i = t[0], a = t[1], o = t[2], s = t[3], c = n[0], l = n[1], u = n[2], d = n[3], f, p = i * c + a * l + o * u + s * d, m, h, g;
    return p < 0 && (p = -p, c = -c, l = -l, u = -u, d = -d), 1 - p > 1e-6 ? (f = Math.acos(p), m = Math.sin(f), h = Math.sin((1 - r) * f) / m, g = Math.sin(r * f) / m) : (h = 1 - r, g = r), e[0] = h * i + g * c, e[1] = h * a + g * l, e[2] = h * o + g * u, e[3] = h * s + g * d, e;
}
function Le(e, t) {
    var n = t[0] + t[4] + t[8], r;
    if (n > 0) r = Math.sqrt(n + 1), e[3] = .5 * r, r = .5 / r, e[0] = (t[5] - t[7]) * r, e[1] = (t[6] - t[2]) * r, e[2] = (t[1] - t[3]) * r;
    else {
        var i = 0;
        t[4] > t[0] && (i = 1), t[8] > t[i * 3 + i] && (i = 2);
        var a = (i + 1) % 3, o = (i + 2) % 3;
        r = Math.sqrt(t[i * 3 + i] - t[a * 3 + a] - t[o * 3 + o] + 1), e[i] = .5 * r, r = .5 / r, e[3] = (t[a * 3 + o] - t[o * 3 + a]) * r, e[a] = (t[a * 3 + i] + t[i * 3 + a]) * r, e[o] = (t[o * 3 + i] + t[i * 3 + o]) * r;
    }
    return e;
}
function Re(e, t, n, r) {
    var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : `zyx`, a = Math.PI / 360;
    t *= a, r *= a, n *= a;
    var o = Math.sin(t), s = Math.cos(t), c = Math.sin(n), l = Math.cos(n), u = Math.sin(r), d = Math.cos(r);
    switch(i){
        case `xyz`:
            e[0] = o * l * d + s * c * u, e[1] = s * c * d - o * l * u, e[2] = s * l * u + o * c * d, e[3] = s * l * d - o * c * u;
            break;
        case `xzy`:
            e[0] = o * l * d - s * c * u, e[1] = s * c * d - o * l * u, e[2] = s * l * u + o * c * d, e[3] = s * l * d + o * c * u;
            break;
        case `yxz`:
            e[0] = o * l * d + s * c * u, e[1] = s * c * d - o * l * u, e[2] = s * l * u - o * c * d, e[3] = s * l * d + o * c * u;
            break;
        case `yzx`:
            e[0] = o * l * d + s * c * u, e[1] = s * c * d + o * l * u, e[2] = s * l * u - o * c * d, e[3] = s * l * d - o * c * u;
            break;
        case `zxy`:
            e[0] = o * l * d - s * c * u, e[1] = s * c * d + o * l * u, e[2] = s * l * u + o * c * d, e[3] = s * l * d - o * c * u;
            break;
        case `zyx`:
            e[0] = o * l * d - s * c * u, e[1] = s * c * d + o * l * u, e[2] = s * l * u - o * c * d, e[3] = s * l * d + o * c * u;
            break;
        default:
            throw Error(`Unknown angle order ` + i);
    }
    return e;
}
var ze = je;
(function() {
    var e = se(), t = ue(1, 0, 0), n = ue(0, 1, 0);
    return function(r, i, a) {
        var o = _e(i, a);
        return o < -0.999999 ? (ve(e, t, i), De(e) < 1e-6 && ve(e, n, i), ge(e, e), Fe(r, e, Math.PI), r) : o > .999999 ? (r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 1, r) : (ve(e, i, a), r[0] = e[0], r[1] = e[1], r[2] = e[2], r[3] = 1 + o, ze(r, r));
    };
})(), function() {
    var e = Pe(), t = Pe();
    return function(n, r, i, a, o, s) {
        return Ie(e, r, o, s), Ie(t, i, a, s), Ie(n, e, t, 2 * s * (1 - s)), n;
    };
}(), function() {
    var e = g();
    return function(t, n, r, i) {
        return e[0] = r[0], e[3] = r[1], e[6] = r[2], e[1] = i[0], e[4] = i[1], e[7] = i[2], e[2] = -n[0], e[5] = -n[1], e[8] = -n[2], ze(t, Le(t, e));
    };
}();
function Be() {
    var e = new h(2);
    return h != Float32Array && (e[0] = 0, e[1] = 0), e;
}
function Ve(e, t) {
    var n = new h(2);
    return n[0] = e, n[1] = t, n;
}
function He(e, t, n) {
    return e[0] = t[0] * n, e[1] = t[1] * n, e;
}
function Ue(e) {
    var t = e[0], n = e[1];
    return Math.sqrt(t * t + n * n);
}
function We(e) {
    var t = e[0], n = e[1];
    return t * t + n * n;
}
function Ge(e, t) {
    return e[0] * t[0] + e[1] * t[1];
}
function Ke(e, t, n) {
    var r = t[0], i = t[1];
    return e[0] = n[0] * r + n[4] * i + n[12], e[1] = n[1] * r + n[5] * i + n[13], e;
}
function qe(e) {
    return e[0] = 0, e[1] = 0, e;
}
var Je = We;
(function() {
    var e = Be();
    return function(t, n, r, i, a, o) {
        var s, c;
        for(n ||= 2, r ||= 0, c = i ? Math.min(i * n + r, t.length) : t.length, s = r; s < c; s += n)e[0] = t[s], e[1] = t[s + 1], a(e, e, o), t[s] = e[0], t[s + 1] = e[1];
        return t;
    };
})();
const Ye = 8192;
function Xe(e, t, n) {
    return t * (Ye / (e.tileSize * 2 ** (n - e.tileID.overscaledZ)));
}
const Ze = `__$json__:`;
function Qe(e) {
    return e instanceof Error ? e : Error(typeof e == `string` ? e : String(e));
}
function $e() {
    return new Float64Array(4);
}
function et() {
    return new Float64Array(3);
}
function tt() {
    return new Float64Array(16);
}
function nt() {
    let e = new Float64Array(16);
    return C(e), e;
}
function rt() {
    let e = new Float32Array(16);
    return C(e), e;
}
function it(e, t, n, r, i = !1) {
    if (!n[0] && !n[1]) return [
        0,
        0
    ];
    let a = i ? r === `map` ? -e.bearingInRadians : 0 : r === `viewport` ? e.bearingInRadians : 0;
    if (a) {
        let e = Math.sin(a), t = Math.cos(a);
        n = [
            n[0] * t - n[1] * e,
            n[0] * e + n[1] * t
        ];
    }
    return [
        i ? n[0] : Xe(t, n[0], e.zoom),
        i ? n[1] : Xe(t, n[1], e.zoom)
    ];
}
function at(e, t) {
    return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3];
}
function ot(e, t, n) {
    let r = _([
        e[0],
        e[1],
        e[2],
        t[0],
        t[1],
        t[2],
        n[0],
        n[1],
        n[2]
    ]);
    if (r === 0) return null;
    let i = ve([], [
        t[0],
        t[1],
        t[2]
    ], [
        n[0],
        n[1],
        n[2]
    ]), a = ve([], [
        n[0],
        n[1],
        n[2]
    ], [
        e[0],
        e[1],
        e[2]
    ]), o = ve([], [
        e[0],
        e[1],
        e[2]
    ], [
        t[0],
        t[1],
        t[2]
    ]), s = pe([], i, -e[3]);
    return de(s, s, pe([], a, -t[3])), de(s, s, pe([], o, -n[3])), pe(s, s, 1 / r), s;
}
function st(e, t, n) {
    let r = e[0] * n[0] + e[1] * n[1] + e[2] * n[2], i = t[0] * n[0] + t[1] * n[1] + t[2] * n[2];
    return i === 0 ? null : (-r - n[3]) / i;
}
function ct(e, t, n, r) {
    let i = Math.sqrt(e * e + t * t), a = Math.sqrt(n * n + r * r);
    e /= i, t /= i, n /= a, r /= a;
    let o = e * n + t * r, s = Math.acos(o);
    return -t * n + e * r > 0 ? s : -s;
}
function lt(e, t) {
    let n = dt(e, 360), r = dt(t, 360), i = r - n, a = r > n ? i - 360 : i + 360;
    return Math.abs(i) < Math.abs(a) ? i : a;
}
function ut(e, t) {
    let n = dt(e, Math.PI * 2), r = dt(t, Math.PI * 2);
    return Math.min(Math.abs(n - r), Math.abs(n - r + Math.PI * 2), Math.abs(n - r - Math.PI * 2));
}
function dt(e, t) {
    return (e % t + t) % t;
}
function ft(e, t, n, r, i) {
    return pt(r, i, yt((e - t) / (n - t), 0, 1));
}
function pt(e, t, n) {
    return e * (1 - n) + t * n;
}
function mt(e) {
    let t = 1 / 0, n = 1 / 0, r = -1 / 0, i = -1 / 0;
    for (let a of e)t = Math.min(t, a.x), n = Math.min(n, a.y), r = Math.max(r, a.x), i = Math.max(i, a.y);
    return [
        t,
        n,
        r,
        i
    ];
}
function ht(e) {
    if (!e.length) return new Set;
    let t = Math.max(...e.map((e)=>e.canonical.z)), n = 1 / 0, r = -1 / 0, i = 1 / 0, a = -1 / 0, o = [];
    for (let s of e){
        let { x: e, y: c, z: l } = s.canonical, u = 2 ** (t - l), d = e * u, f = c * u;
        o.push({
            id: s,
            x: d,
            y: f
        }), d < n && (n = d), d > r && (r = d), f < i && (i = f), f > a && (a = f);
    }
    let s = new Set;
    for (let e of o)(e.x === n || e.x === r || e.y === i || e.y === a) && s.add(e.id);
    return s;
}
function gt(e) {
    if (e <= 0) return 0;
    if (e >= 1) return 1;
    let t = e * e, n = t * e;
    return 4 * (e < .5 ? n : 3 * (e - t) + n - .75);
}
function _t(e, t, n, r) {
    return u(e, t, n, r);
}
const vt = _t(.25, .1, .25, 1);
function yt(e, t, n) {
    return Math.min(n, Math.max(t, e));
}
function bt(e, t, n) {
    let r = n - t, i = ((e - t) % r + r) % r + t;
    return i === t ? n : i;
}
function xt(e, ...t) {
    for (let n of t)for(let t in n)e[t] = n[t];
    return e;
}
function St(e, t) {
    let n = {};
    for (let r of t)r in e && (n[r] = e[r]);
    return n;
}
let Ct = 1;
function wt() {
    return Ct++;
}
function Tt(e) {
    return Math.log(e) / Math.LN2 % 1 == 0;
}
function Et(e) {
    return e <= 1 ? 1 : 2 ** Math.ceil(Math.log(e) / Math.LN2);
}
function Dt(e) {
    return 2 ** e;
}
function Ot(e) {
    return Math.log(e) / Math.LN2;
}
function kt(e, t, n) {
    if (t <= 0) return e;
    let r = 1 / t;
    return n === void 0 || Math.abs(n) < 1e-10 ? Math.round(e * r) / r : (n > 0 ? Math.ceil(e * r - 1e-9) : Math.floor(e * r + 1e-10)) / r;
}
function At(e, t, n) {
    let r = {};
    for(let i in e)r[i] = t.call(n || this, e[i], i, e);
    return r;
}
function jt(e, t, n) {
    let r = {};
    for(let i in e)t.call(n || this, e[i], i, e) && (r[i] = e[i]);
    return r;
}
function Mt(e, t) {
    if (Array.isArray(e)) {
        if (!Array.isArray(t) || e.length !== t.length) return !1;
        for(let n = 0; n < e.length; n++)if (!Mt(e[n], t[n])) return !1;
        return !0;
    }
    if (typeof e == `object` && e && t !== null) {
        if (typeof t != `object` || Object.keys(e).length !== Object.keys(t).length) return !1;
        for(let n in e)if (!Mt(e[n], t[n])) return !1;
        return !0;
    }
    return e === t;
}
function Nt(e) {
    return Array.isArray(e) ? e.map(Nt) : typeof e == `object` && e ? At(e, Nt) : e;
}
const Pt = {};
function Ft(e) {
    Pt[e] || (typeof console < `u` && console.warn(e), Pt[e] = !0);
}
function It(e, t, n) {
    return (n.y - e.y) * (t.x - e.x) > (t.y - e.y) * (n.x - e.x);
}
function Lt(e, t, n, r) {
    let i = t.y - e.y, a = t.x - e.x, o = r.y - n.y, s = r.x - n.x, c = o * a - s * i;
    if (c === 0) return null;
    let u = e.y - n.y, d = e.x - n.x, f = (s * u - o * d) / c;
    return new l(e.x + f * a, e.y + f * i);
}
function Rt([e, t, n]) {
    return t += 90, t *= Math.PI / 180, n *= Math.PI / 180, [
        e * Math.cos(t) * Math.sin(n),
        e * Math.sin(t) * Math.sin(n),
        e * Math.cos(n)
    ];
}
function zt(e) {
    return typeof WorkerGlobalScope < `u` && e !== void 0 && e instanceof WorkerGlobalScope;
}
function Bt(e) {
    let t = /(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, n = {};
    if (e.replace(t, (e, t, r, i)=>{
        let a = r || i;
        return n[t] = !a || a.toLowerCase(), ``;
    }), n[`max-age`]) {
        let e = parseInt(n[`max-age`], 10);
        isNaN(e) ? delete n[`max-age`] : n[`max-age`] = e;
    }
    return n;
}
let Vt = null;
function Ht(e) {
    if (Vt == null) {
        let t = e.navigator ? e.navigator.userAgent : null;
        Vt = !!e.safari || !!(t && (/\b(iPad|iPhone|iPod)\b/.test(t) || t.match(`Safari`) && !t.match(`Chrome`)));
    }
    return Vt;
}
function Ut(e) {
    return typeof ImageBitmap < `u` && e instanceof ImageBitmap;
}
const Wt = async (e, t)=>{
    if (e.byteLength === 0) return createImageBitmap(new ImageData(1, 1), t);
    let n = new Blob([
        new Uint8Array(e)
    ], {
        type: `image/png`
    });
    try {
        return createImageBitmap(n, t);
    } catch (e) {
        throw Error(`Could not load image because of ${Qe(e).message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
    }
}, Gt = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=`, Kt = (e)=>new Promise((t, n)=>{
        let r = new Image;
        r.onload = ()=>{
            t(r), URL.revokeObjectURL(r.src), r.onload = null, window.requestAnimationFrame(()=>r.src = Gt);
        }, r.onerror = ()=>n(Error(`Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
        let i = new Blob([
            new Uint8Array(e)
        ], {
            type: `image/png`
        });
        r.src = e.byteLength ? URL.createObjectURL(i) : Gt;
    });
function qt(e, t, n, r, i) {
    let a = Math.max(-t, 0) * 4, o = (Math.max(0, n) - n) * r * 4 + a, s = r * 4, c = Math.max(0, t), l = Math.max(0, n), u = Math.min(e.width, t + r), d = Math.min(e.height, n + i);
    return {
        rect: {
            x: c,
            y: l,
            width: u - c,
            height: d - l
        },
        layout: [
            {
                offset: o,
                stride: s
            }
        ]
    };
}
async function Jt(e, t, n, r, i) {
    if (typeof VideoFrame > `u`) throw Error(`VideoFrame not supported`);
    let a = new VideoFrame(e, {
        timestamp: 0
    });
    try {
        let o = a?.format;
        if (!o || !(o.startsWith(`BGR`) || o.startsWith(`RGB`))) throw Error(`Unrecognized format ${o}`);
        let s = o.startsWith(`BGR`), c = new Uint8ClampedArray(r * i * 4);
        if (await a.copyTo(c, qt(e, t, n, r, i)), s) for(let e = 0; e < c.length; e += 4){
            let t = c[e];
            c[e] = c[e + 2], c[e + 2] = t;
        }
        return c;
    } finally{
        a.close();
    }
}
let Yt, Xt;
function Zt(e, t, n, r, i) {
    let a = e.width, o = e.height;
    (!Yt || !Xt) && (Yt = new OffscreenCanvas(a, o), Xt = Yt.getContext(`2d`, {
        willReadFrequently: !0
    })), Yt.width = a, Yt.height = o, Xt.drawImage(e, 0, 0, a, o);
    let s = Xt.getImageData(t, n, r, i);
    return Xt.clearRect(0, 0, a, o), s.data;
}
async function Qt(e, t, n, r, i) {
    if (m()) try {
        return await Jt(e, t, n, r, i);
    } catch  {}
    return Zt(e, t, n, r, i);
}
function $t(e, t, n, r) {
    return e.addEventListener(t, n, r), {
        unsubscribe: ()=>{
            e.removeEventListener(t, n, r);
        }
    };
}
function en(e) {
    return e * Math.PI / 180;
}
function tn(e) {
    return e / Math.PI * 180;
}
function nn(e, t) {
    return e.roll == t.roll && e.pitch == t.pitch && e.bearing == t.bearing;
}
function rn(e) {
    let t = new Float64Array(9);
    y(t, e);
    let n = tn(-Math.asin(yt(t[2], -1, 1))), r, i;
    return Math.hypot(t[5], t[8]) < .001 ? (r = 0, i = -tn(Math.atan2(t[3], t[4]))) : (r = tn(t[5] === 0 && t[8] === 0 ? 0 : Math.atan2(t[5], t[8])), i = tn(t[1] === 0 && t[0] === 0 ? 0 : Math.atan2(t[1], t[0]))), {
        roll: r,
        pitch: n + 90,
        bearing: i
    };
}
function an(e, t, n) {
    let r = Ve(t.x - n.x, t.y - n.y), i = Ve(e.x - n.x, e.y - n.y), a = r[0] * i[1] - r[1] * i[0];
    return tn(Math.atan2(a, Ge(r, i)));
}
function on(e, t, n) {
    let r = new Float64Array(4);
    return Re(r, e, t - 90, n), r;
}
const sn = 85.051129, cn = {
    touchstart: !0,
    touchmove: !0,
    touchmoveWindow: !0,
    touchend: !0,
    touchcancel: !0
}, ln = {
    dblclick: !0,
    click: !0,
    mouseover: !0,
    mouseout: !0,
    mousedown: !0,
    mousemove: !0,
    mousemoveWindow: !0,
    mouseup: !0,
    mouseupWindow: !0,
    contextmenu: !0,
    wheel: !0
};
function un(e, t) {
    return cn[t] && `touches` in e;
}
function dn(e, t) {
    if (!ln[t]) return !1;
    let n = e, r = n?.target?.ownerDocument?.defaultView || window;
    return n instanceof r.MouseEvent || n instanceof r.WheelEvent;
}
function fn(e) {
    return cn[e] || ln[e];
}
const pn = `AbortError`;
var mn = class extends Error {
    constructor(e = pn){
        super(e instanceof Error ? e.message : e), this.name = pn, e instanceof Error && e.stack && (this.stack = e.stack);
    }
};
function hn(e) {
    return e instanceof Error && e.name === `AbortError`;
}
function gn(e) {
    if (e.aborted) throw new mn(e.reason);
}
const _n = {
    MAX_PARALLEL_IMAGE_REQUESTS: 16,
    MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
    MAX_TILE_CACHE_ZOOM_LEVELS: 5,
    REGISTERED_PROTOCOLS: {},
    WORKER_URL: ``
};
function vn(e) {
    return _n.REGISTERED_PROTOCOLS[e.substring(0, e.indexOf(`://`))];
}
function yn(e, t) {
    _n.REGISTERED_PROTOCOLS[e] = t;
}
function bn(e) {
    delete _n.REGISTERED_PROTOCOLS[e];
}
const xn = `global-dispatcher`;
var Sn = class extends Error {
    constructor(e, t, n, r){
        super(`AJAXError: ${t} (${e}): ${n}`), this.status = e, this.statusText = t, this.url = n, this.body = r;
    }
};
function Cn() {
    if (zt(self)) return self.worker?.referrer;
    if (window.location.protocol === `blob:`) try {
        return window.parent.location.href;
    } catch  {}
    return window.location.href;
}
const wn = (e)=>e.startsWith(`file:`) || Cn()?.startsWith(`file:`) && !/^\w+:/.test(e);
async function Tn(e, t) {
    let n = new Request(e.url, {
        method: e.method || `GET`,
        body: e.body,
        credentials: e.credentials,
        headers: e.headers,
        cache: e.cache,
        referrer: Cn(),
        referrerPolicy: e.referrerPolicy,
        signal: t.signal
    });
    e.type === `json` && !n.headers.has(`Accept`) && n.headers.set(`Accept`, `application/json`);
    let r;
    try {
        r = await fetch(n);
    } catch (t) {
        throw hn(t) ? t : new Sn(0, Qe(t).message, e.url, new Blob);
    }
    if (!r.ok) {
        let t = await r.blob();
        throw new Sn(r.status, r.statusText, e.url, t);
    }
    let i;
    i = e.type === `arrayBuffer` || e.type === `image` ? r.arrayBuffer() : e.type === `json` ? r.json() : r.text();
    let a = await i;
    return gn(t.signal), {
        data: a,
        cacheControl: r.headers.get(`Cache-Control`),
        expires: r.headers.get(`Expires`),
        etag: r.headers.get(`ETag`)
    };
}
function En(e, t) {
    return new Promise((n, r)=>{
        let i = new XMLHttpRequest;
        i.open(e.method || `GET`, e.url, !0), (e.type === `arrayBuffer` || e.type === `image`) && (i.responseType = `arraybuffer`);
        for(let t in e.headers)i.setRequestHeader(t, e.headers[t]);
        e.type === `json` && (i.responseType = `text`, e.headers?.Accept || i.setRequestHeader(`Accept`, `application/json`)), i.withCredentials = e.credentials === `include`, i.onerror = ()=>{
            r(Error(i.statusText));
        }, i.onload = ()=>{
            if (!t.signal.aborted) {
                if ((i.status >= 200 && i.status < 300 || i.status === 0) && i.response !== null) {
                    let t = i.response;
                    if (e.type === `json`) try {
                        t = JSON.parse(i.response);
                    } catch (e) {
                        r(e);
                        return;
                    }
                    n({
                        data: t,
                        cacheControl: i.getResponseHeader(`Cache-Control`),
                        expires: i.getResponseHeader(`Expires`),
                        etag: i.getResponseHeader(`ETag`)
                    });
                } else {
                    let t = new Blob([
                        i.response
                    ], {
                        type: i.getResponseHeader(`Content-Type`)
                    });
                    r(new Sn(i.status, i.statusText, e.url, t));
                }
            }
        }, t.signal.addEventListener(`abort`, ()=>{
            i.abort(), r(new mn(t.signal.reason));
        }), i.send(e.body);
    });
}
const Dn = async function(e, t) {
    if (e.url.includes(`://`) && !/^https?:|^file:/.test(e.url)) {
        let n = vn(e.url);
        if (n) {
            let r = await n(e, t);
            return !r.data && e.type === `arrayBuffer` ? xt(r, {
                data: new ArrayBuffer(0)
            }) : r;
        }
        if (zt(self) && self.worker?.actor) return self.worker.actor.sendAsync({
            type: `GR`,
            data: e,
            targetMapId: xn
        }, t);
    }
    if (!wn(e.url)) {
        if (fetch && Request && AbortController && Object.hasOwn(Request.prototype, `signal`)) return Tn(e, t);
        if (zt(self) && self.worker?.actor) return self.worker.actor.sendAsync({
            type: `GR`,
            data: e,
            mustQueue: !0,
            targetMapId: xn
        }, t);
    }
    return En(e, t);
}, On = (e, t)=>Dn(xt(e, {
        type: `json`
    }), t), kn = (e, t)=>Dn(xt(e, {
        type: `arrayBuffer`
    }), t);
function An(e) {
    if (!e || e.startsWith(`data:image/`)) return !0;
    if (e.startsWith(`blob:`) && (e = e.slice(5), e.startsWith(`null`))) return !1;
    if (e.indexOf(`://`) <= 0) return !0;
    let t = new URL(e), n = window.location;
    return t.protocol === n.protocol && t.host === n.host;
}
const jn = (e)=>{
    let t = window.document.createElement(`video`);
    return t.muted = !0, new Promise((n)=>{
        t.onloadstart = ()=>{
            n(t);
        };
        for (let n of e){
            let e = window.document.createElement(`source`);
            An(n) || (t.crossOrigin = `Anonymous`), e.src = n, t.appendChild(e);
        }
    });
};
function Mn(e, t, n) {
    n[e]?.includes(t) || (n[e] ||= [], n[e].push(t));
}
function Nn(e, t, n) {
    if (n?.[e]) {
        let r = n[e].indexOf(t);
        r !== -1 && n[e].splice(r, 1);
    }
}
var Pn = class {
    constructor(e, t = {}){
        xt(this, t), this.type = e;
    }
}, Fn = class extends Pn {
    constructor(e, t = {}){
        super(`error`, xt({
            error: e
        }, t));
    }
}, In = class {
    on(e, t) {
        return this._listeners ||= {}, Mn(e, t, this._listeners), {
            unsubscribe: ()=>{
                this.off(e, t);
            }
        };
    }
    off(e, t) {
        return Nn(e, t, this._listeners), Nn(e, t, this._oneTimeListeners), this;
    }
    once(e, t) {
        return t ? (this._oneTimeListeners ||= {}, Mn(e, t, this._oneTimeListeners), this) : new Promise((t)=>this.once(e, t));
    }
    fire(e, t) {
        typeof e == `string` && (e = new Pn(e, t || {}));
        let n = e.type;
        if (this.listens(n)) {
            e.target = this;
            let t = this._listeners?.[n] ? this._listeners[n].slice() : [];
            for (let n of t)n.call(this, e);
            let r = this._oneTimeListeners?.[n] ? this._oneTimeListeners[n].slice() : [];
            for (let t of r)Nn(n, t, this._oneTimeListeners), t.call(this, e);
            let i = this._eventedParent;
            i && (xt(e, typeof this._eventedParentData == `function` ? this._eventedParentData() : this._eventedParentData), i.fire(e));
        } else e instanceof Fn && console.error(e.error);
        return this;
    }
    listens(e) {
        return this._listeners?.[e]?.length > 0 || this._oneTimeListeners?.[e]?.length > 0 || this._eventedParent?.listens(e);
    }
    setEventedParent(e, t) {
        return this._eventedParent = e, this._eventedParentData = t, this;
    }
};
const j = {
    $version: 8,
    $root: {
        version: {
            required: !0,
            type: `enum`,
            values: [
                8
            ]
        },
        name: {
            type: `string`
        },
        metadata: {
            type: `*`
        },
        center: {
            type: `array`,
            value: `number`,
            length: 2
        },
        centerAltitude: {
            type: `number`
        },
        zoom: {
            type: `number`
        },
        bearing: {
            type: `number`,
            default: 0,
            period: 360,
            units: `degrees`
        },
        pitch: {
            type: `number`,
            default: 0,
            units: `degrees`
        },
        roll: {
            type: `number`,
            default: 0,
            units: `degrees`
        },
        state: {
            type: `state`,
            default: {}
        },
        light: {
            type: `light`
        },
        sky: {
            type: `sky`
        },
        projection: {
            type: `projection`
        },
        terrain: {
            type: `terrain`
        },
        sources: {
            required: !0,
            type: `sources`
        },
        sprite: {
            type: `sprite`
        },
        glyphs: {
            type: `string`
        },
        "font-faces": {
            type: `fontFaces`
        },
        transition: {
            type: `transition`
        },
        layers: {
            required: !0,
            type: `array`,
            value: `layer`
        }
    },
    sources: {
        "*": {
            type: `source`
        }
    },
    source: [
        `source_vector`,
        `source_raster`,
        `source_raster_dem`,
        `source_geojson`,
        `source_video`,
        `source_image`
    ],
    source_vector: {
        type: {
            required: !0,
            type: `enum`,
            values: {
                vector: {}
            }
        },
        url: {
            type: `string`
        },
        tiles: {
            type: `array`,
            value: `string`
        },
        bounds: {
            type: `array`,
            value: `number`,
            length: 4,
            default: [
                -180,
                -85.051129,
                180,
                85.051129
            ]
        },
        scheme: {
            type: `enum`,
            values: {
                xyz: {},
                tms: {}
            },
            default: `xyz`
        },
        minzoom: {
            type: `number`,
            default: 0
        },
        maxzoom: {
            type: `number`,
            default: 22
        },
        attribution: {
            type: `string`
        },
        promoteId: {
            type: `promoteId`
        },
        volatile: {
            type: `boolean`,
            default: !1
        },
        encoding: {
            type: `enum`,
            values: {
                mvt: {},
                mlt: {}
            },
            default: `mvt`
        },
        "*": {
            type: `*`
        }
    },
    source_raster: {
        type: {
            required: !0,
            type: `enum`,
            values: {
                raster: {}
            }
        },
        url: {
            type: `string`
        },
        tiles: {
            type: `array`,
            value: `string`
        },
        bounds: {
            type: `array`,
            value: `number`,
            length: 4,
            default: [
                -180,
                -85.051129,
                180,
                85.051129
            ]
        },
        minzoom: {
            type: `number`,
            default: 0
        },
        maxzoom: {
            type: `number`,
            default: 22
        },
        tileSize: {
            type: `number`,
            default: 512,
            units: `pixels`
        },
        scheme: {
            type: `enum`,
            values: {
                xyz: {},
                tms: {}
            },
            default: `xyz`
        },
        attribution: {
            type: `string`
        },
        volatile: {
            type: `boolean`,
            default: !1
        },
        "*": {
            type: `*`
        }
    },
    source_raster_dem: {
        type: {
            required: !0,
            type: `enum`,
            values: {
                "raster-dem": {}
            }
        },
        url: {
            type: `string`
        },
        tiles: {
            type: `array`,
            value: `string`
        },
        bounds: {
            type: `array`,
            value: `number`,
            length: 4,
            default: [
                -180,
                -85.051129,
                180,
                85.051129
            ]
        },
        minzoom: {
            type: `number`,
            default: 0
        },
        maxzoom: {
            type: `number`,
            default: 22
        },
        tileSize: {
            type: `number`,
            default: 512,
            units: `pixels`
        },
        attribution: {
            type: `string`
        },
        encoding: {
            type: `enum`,
            values: {
                terrarium: {},
                mapbox: {},
                custom: {}
            },
            default: `mapbox`
        },
        redFactor: {
            type: `number`,
            default: 1
        },
        blueFactor: {
            type: `number`,
            default: 1
        },
        greenFactor: {
            type: `number`,
            default: 1
        },
        baseShift: {
            type: `number`,
            default: 0
        },
        volatile: {
            type: `boolean`,
            default: !1
        },
        "*": {
            type: `*`
        }
    },
    source_geojson: {
        type: {
            required: !0,
            type: `enum`,
            values: {
                geojson: {}
            }
        },
        data: {
            required: !0,
            type: `*`
        },
        maxzoom: {
            type: `number`,
            default: 18
        },
        attribution: {
            type: `string`
        },
        buffer: {
            type: `number`,
            default: 128,
            maximum: 512,
            minimum: 0
        },
        filter: {
            type: `filter`
        },
        tolerance: {
            type: `number`,
            default: .375
        },
        cluster: {
            type: `boolean`,
            default: !1
        },
        clusterRadius: {
            type: `number`,
            default: 50,
            minimum: 0
        },
        clusterMaxZoom: {
            type: `number`
        },
        clusterMinPoints: {
            type: `number`
        },
        clusterProperties: {
            type: `*`
        },
        lineMetrics: {
            type: `boolean`,
            default: !1
        },
        generateId: {
            type: `boolean`,
            default: !1
        },
        promoteId: {
            type: `promoteId`
        }
    },
    source_video: {
        type: {
            required: !0,
            type: `enum`,
            values: {
                video: {}
            }
        },
        urls: {
            required: !0,
            type: `array`,
            value: `string`
        },
        coordinates: {
            required: !0,
            type: `array`,
            length: 4,
            value: {
                type: `array`,
                length: 2,
                value: `number`
            }
        }
    },
    source_image: {
        type: {
            required: !0,
            type: `enum`,
            values: {
                image: {}
            }
        },
        url: {
            required: !0,
            type: `string`
        },
        coordinates: {
            required: !0,
            type: `array`,
            length: 4,
            value: {
                type: `array`,
                length: 2,
                value: `number`
            }
        }
    },
    layer: {
        id: {
            type: `string`,
            required: !0
        },
        type: {
            type: `enum`,
            values: {
                fill: {},
                line: {},
                symbol: {},
                circle: {},
                heatmap: {},
                "fill-extrusion": {},
                raster: {},
                hillshade: {},
                "color-relief": {},
                background: {}
            },
            required: !0
        },
        metadata: {
            type: `*`
        },
        source: {
            type: `string`
        },
        "source-layer": {
            type: `string`
        },
        minzoom: {
            type: `number`,
            minimum: 0,
            maximum: 24
        },
        maxzoom: {
            type: `number`,
            minimum: 0,
            maximum: 24
        },
        filter: {
            type: `filter`
        },
        layout: {
            type: `layout`
        },
        paint: {
            type: `paint`
        }
    },
    layout: [
        `layout_fill`,
        `layout_line`,
        `layout_circle`,
        `layout_heatmap`,
        `layout_fill-extrusion`,
        `layout_symbol`,
        `layout_raster`,
        `layout_hillshade`,
        `layout_color-relief`,
        `layout_background`
    ],
    layout_background: {
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    layout_fill: {
        "fill-sort-key": {
            type: `number`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    layout_circle: {
        "circle-sort-key": {
            type: `number`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    layout_heatmap: {
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    "layout_fill-extrusion": {
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    layout_line: {
        "line-cap": {
            type: `enum`,
            values: {
                butt: {},
                round: {},
                square: {}
            },
            default: `butt`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "line-join": {
            type: `enum`,
            values: {
                bevel: {},
                round: {},
                miter: {}
            },
            default: `miter`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "line-miter-limit": {
            type: `number`,
            default: 2,
            requires: [
                {
                    "line-join": `miter`
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "line-round-limit": {
            type: `number`,
            default: 1.05,
            requires: [
                {
                    "line-join": `round`
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "line-sort-key": {
            type: `number`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    layout_symbol: {
        "symbol-placement": {
            type: `enum`,
            values: {
                point: {},
                line: {},
                "line-center": {}
            },
            default: `point`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "symbol-spacing": {
            type: `number`,
            default: 250,
            minimum: 1,
            units: `pixels`,
            requires: [
                {
                    "symbol-placement": `line`
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "symbol-avoid-edges": {
            type: `boolean`,
            default: !1,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "symbol-sort-key": {
            type: `number`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "symbol-z-order": {
            type: `enum`,
            values: {
                auto: {},
                "viewport-y": {},
                source: {}
            },
            default: `auto`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-allow-overlap": {
            type: `boolean`,
            default: !1,
            requires: [
                `icon-image`,
                {
                    "!": `icon-overlap`
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-overlap": {
            type: `enum`,
            values: {
                never: {},
                always: {},
                cooperative: {}
            },
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-ignore-placement": {
            type: `boolean`,
            default: !1,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-optional": {
            type: `boolean`,
            default: !1,
            requires: [
                `icon-image`,
                `text-field`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-rotation-alignment": {
            type: `enum`,
            values: {
                map: {},
                viewport: {},
                auto: {}
            },
            default: `auto`,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-size": {
            type: `number`,
            default: 1,
            minimum: 0,
            units: `factor of the original icon size`,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-text-fit": {
            type: `enum`,
            values: {
                none: {},
                width: {},
                height: {},
                both: {}
            },
            default: `none`,
            requires: [
                `icon-image`,
                `text-field`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-text-fit-padding": {
            type: `array`,
            value: `number`,
            length: 4,
            default: [
                0,
                0,
                0,
                0
            ],
            units: `pixels`,
            requires: [
                `icon-image`,
                `text-field`,
                {
                    "icon-text-fit": [
                        `both`,
                        `width`,
                        `height`
                    ]
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-image": {
            type: `resolvedImage`,
            tokens: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-rotate": {
            type: `number`,
            default: 0,
            period: 360,
            units: `degrees`,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-padding": {
            type: `padding`,
            default: [
                2
            ],
            units: `pixels`,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-keep-upright": {
            type: `boolean`,
            default: !1,
            requires: [
                `icon-image`,
                {
                    "icon-rotation-alignment": `map`
                },
                {
                    "symbol-placement": [
                        `line`,
                        `line-center`
                    ]
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-offset": {
            type: `array`,
            value: `number`,
            length: 2,
            default: [
                0,
                0
            ],
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-anchor": {
            type: `enum`,
            values: {
                center: {},
                left: {},
                right: {},
                top: {},
                bottom: {},
                "top-left": {},
                "top-right": {},
                "bottom-left": {},
                "bottom-right": {}
            },
            default: `center`,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-pitch-alignment": {
            type: `enum`,
            values: {
                map: {},
                viewport: {},
                auto: {}
            },
            default: `auto`,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-pitch-alignment": {
            type: `enum`,
            values: {
                map: {},
                viewport: {},
                auto: {}
            },
            default: `auto`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-rotation-alignment": {
            type: `enum`,
            values: {
                map: {},
                viewport: {},
                "viewport-glyph": {},
                auto: {}
            },
            default: `auto`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-field": {
            type: `formatted`,
            default: ``,
            tokens: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-font": {
            type: `array`,
            value: `string`,
            default: [
                `Open Sans Regular`,
                `Arial Unicode MS Regular`
            ],
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-size": {
            type: `number`,
            default: 16,
            minimum: 0,
            units: `pixels`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-max-width": {
            type: `number`,
            default: 10,
            minimum: 0,
            units: `ems`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-line-height": {
            type: `number`,
            default: 1.2,
            units: `ems`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-letter-spacing": {
            type: `number`,
            default: 0,
            units: `ems`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-justify": {
            type: `enum`,
            values: {
                auto: {},
                left: {},
                center: {},
                right: {}
            },
            default: `center`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-radial-offset": {
            type: `number`,
            units: `ems`,
            default: 0,
            requires: [
                `text-field`
            ],
            "property-type": `data-driven`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            }
        },
        "text-variable-anchor": {
            type: `array`,
            value: `enum`,
            values: {
                center: {},
                left: {},
                right: {},
                top: {},
                bottom: {},
                "top-left": {},
                "top-right": {},
                "bottom-left": {},
                "bottom-right": {}
            },
            requires: [
                `text-field`,
                {
                    "symbol-placement": [
                        `point`
                    ]
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-variable-anchor-offset": {
            type: `variableAnchorOffsetCollection`,
            requires: [
                `text-field`,
                {
                    "symbol-placement": [
                        `point`
                    ]
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-anchor": {
            type: `enum`,
            values: {
                center: {},
                left: {},
                right: {},
                top: {},
                bottom: {},
                "top-left": {},
                "top-right": {},
                "bottom-left": {},
                "bottom-right": {}
            },
            default: `center`,
            requires: [
                `text-field`,
                {
                    "!": `text-variable-anchor`
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-max-angle": {
            type: `number`,
            default: 45,
            units: `degrees`,
            requires: [
                `text-field`,
                {
                    "symbol-placement": [
                        `line`,
                        `line-center`
                    ]
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-writing-mode": {
            type: `array`,
            value: `enum`,
            values: {
                horizontal: {},
                vertical: {}
            },
            requires: [
                `text-field`,
                {
                    "symbol-placement": [
                        `point`
                    ]
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-rotate": {
            type: `number`,
            default: 0,
            period: 360,
            units: `degrees`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-padding": {
            type: `number`,
            default: 2,
            minimum: 0,
            units: `pixels`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-keep-upright": {
            type: `boolean`,
            default: !0,
            requires: [
                `text-field`,
                {
                    "text-rotation-alignment": `map`
                },
                {
                    "symbol-placement": [
                        `line`,
                        `line-center`
                    ]
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-transform": {
            type: `enum`,
            values: {
                none: {},
                uppercase: {},
                lowercase: {}
            },
            default: `none`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-offset": {
            type: `array`,
            value: `number`,
            units: `ems`,
            length: 2,
            default: [
                0,
                0
            ],
            requires: [
                `text-field`,
                {
                    "!": `text-radial-offset`
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `data-driven`
        },
        "text-allow-overlap": {
            type: `boolean`,
            default: !1,
            requires: [
                `text-field`,
                {
                    "!": `text-overlap`
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-overlap": {
            type: `enum`,
            values: {
                never: {},
                always: {},
                cooperative: {}
            },
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-ignore-placement": {
            type: `boolean`,
            default: !1,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-optional": {
            type: `boolean`,
            default: !1,
            requires: [
                `text-field`,
                `icon-image`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    layout_raster: {
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    layout_hillshade: {
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    "layout_color-relief": {
        visibility: {
            type: `enum`,
            values: {
                visible: {},
                none: {}
            },
            default: `visible`,
            expression: {
                interpolated: !1,
                parameters: [
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        }
    },
    filter: {
        type: `boolean`,
        expression: {
            interpolated: !1,
            parameters: [
                `zoom`,
                `feature`
            ]
        },
        "property-type": `data-driven`
    },
    filter_operator: {
        type: `enum`,
        values: {
            "==": {},
            "!=": {},
            ">": {},
            ">=": {},
            "<": {},
            "<=": {},
            in: {},
            "!in": {},
            all: {},
            any: {},
            none: {},
            has: {},
            "!has": {}
        }
    },
    geometry_type: {
        type: `enum`,
        values: {
            Point: {},
            LineString: {},
            Polygon: {}
        }
    },
    function: {
        expression: {
            type: `expression`
        },
        stops: {
            type: `array`,
            value: `function_stop`
        },
        base: {
            type: `number`,
            default: 1,
            minimum: 0
        },
        property: {
            type: `string`,
            default: `$zoom`
        },
        type: {
            type: `enum`,
            values: {
                identity: {},
                exponential: {},
                interval: {},
                categorical: {}
            },
            default: `exponential`
        },
        colorSpace: {
            type: `enum`,
            values: {
                rgb: {},
                lab: {},
                hcl: {}
            },
            default: `rgb`
        },
        default: {
            type: `*`,
            required: !1
        }
    },
    function_stop: {
        type: `array`,
        minimum: 0,
        maximum: 24,
        value: [
            `number`,
            `color`
        ],
        length: 2
    },
    expression: {
        type: `array`,
        value: `expression_name`,
        minimum: 1
    },
    light: {
        anchor: {
            type: `enum`,
            default: `viewport`,
            values: {
                map: {},
                viewport: {}
            },
            "property-type": `data-constant`,
            transition: !1,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            }
        },
        position: {
            type: `array`,
            default: [
                1.15,
                210,
                30
            ],
            length: 3,
            value: `number`,
            "property-type": `data-constant`,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            }
        },
        color: {
            type: `color`,
            "property-type": `data-constant`,
            default: `#ffffff`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            transition: !0
        },
        intensity: {
            type: `number`,
            "property-type": `data-constant`,
            default: .5,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            transition: !0
        }
    },
    sky: {
        "sky-color": {
            type: `color`,
            "property-type": `data-constant`,
            default: `#88C6FC`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            transition: !0
        },
        "horizon-color": {
            type: `color`,
            "property-type": `data-constant`,
            default: `#ffffff`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            transition: !0
        },
        "fog-color": {
            type: `color`,
            "property-type": `data-constant`,
            default: `#ffffff`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            transition: !0
        },
        "fog-ground-blend": {
            type: `number`,
            "property-type": `data-constant`,
            default: .5,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            transition: !0
        },
        "horizon-fog-blend": {
            type: `number`,
            "property-type": `data-constant`,
            default: .8,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            transition: !0
        },
        "sky-horizon-blend": {
            type: `number`,
            "property-type": `data-constant`,
            default: .8,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            transition: !0
        },
        "atmosphere-blend": {
            type: `number`,
            "property-type": `data-constant`,
            default: .8,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            transition: !0
        }
    },
    terrain: {
        source: {
            type: `string`,
            required: !0
        },
        exaggeration: {
            type: `number`,
            minimum: 0,
            default: 1
        }
    },
    projection: {
        type: {
            type: `projectionDefinition`,
            default: `mercator`,
            "property-type": `data-constant`,
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            }
        }
    },
    paint: [
        `paint_fill`,
        `paint_line`,
        `paint_circle`,
        `paint_heatmap`,
        `paint_fill-extrusion`,
        `paint_symbol`,
        `paint_raster`,
        `paint_hillshade`,
        `paint_color-relief`,
        `paint_background`
    ],
    paint_fill: {
        "fill-antialias": {
            type: `boolean`,
            default: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "fill-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "fill-layer-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        },
        "fill-color": {
            type: `color`,
            default: `#000000`,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "fill-outline-color": {
            type: `color`,
            transition: !0,
            requires: [
                {
                    "!": `fill-pattern`
                },
                {
                    "fill-antialias": !0
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "fill-translate": {
            type: `array`,
            value: `number`,
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "fill-translate-anchor": {
            type: `enum`,
            values: {
                map: {},
                viewport: {}
            },
            default: `map`,
            requires: [
                `fill-translate`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "fill-pattern": {
            type: `resolvedImage`,
            transition: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `cross-faded-data-driven`
        }
    },
    "paint_fill-extrusion": {
        "fill-extrusion-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "fill-extrusion-color": {
            type: `color`,
            default: `#000000`,
            transition: !0,
            requires: [
                {
                    "!": `fill-extrusion-pattern`
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "fill-extrusion-translate": {
            type: `array`,
            value: `number`,
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "fill-extrusion-translate-anchor": {
            type: `enum`,
            values: {
                map: {},
                viewport: {}
            },
            default: `map`,
            requires: [
                `fill-extrusion-translate`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "fill-extrusion-pattern": {
            type: `resolvedImage`,
            transition: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `cross-faded-data-driven`
        },
        "fill-extrusion-height": {
            type: `number`,
            default: 0,
            minimum: 0,
            units: `meters`,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "fill-extrusion-base": {
            type: `number`,
            default: 0,
            minimum: 0,
            units: `meters`,
            transition: !0,
            requires: [
                `fill-extrusion-height`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "fill-extrusion-vertical-gradient": {
            type: `boolean`,
            default: !0,
            transition: !1,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        }
    },
    paint_line: {
        "line-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "line-layer-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `global-state`
                ]
            },
            "property-type": `data-constant`
        },
        "line-color": {
            type: `color`,
            default: `#000000`,
            transition: !0,
            requires: [
                {
                    "!": `line-pattern`
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "line-translate": {
            type: `array`,
            value: `number`,
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "line-translate-anchor": {
            type: `enum`,
            values: {
                map: {},
                viewport: {}
            },
            default: `map`,
            requires: [
                `line-translate`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "line-width": {
            type: `number`,
            default: 1,
            minimum: 0,
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "line-gap-width": {
            type: `number`,
            default: 0,
            minimum: 0,
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "line-offset": {
            type: `number`,
            default: 0,
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "line-blur": {
            type: `number`,
            default: 0,
            minimum: 0,
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "line-dasharray": {
            type: `array`,
            value: `number`,
            minimum: 0,
            transition: !0,
            units: `line widths`,
            requires: [
                {
                    "!": `line-pattern`
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `cross-faded-data-driven`
        },
        "line-pattern": {
            type: `resolvedImage`,
            transition: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`,
                    `feature`
                ]
            },
            "property-type": `cross-faded-data-driven`
        },
        "line-gradient": {
            type: `color`,
            transition: !1,
            requires: [
                {
                    "!": `line-dasharray`
                },
                {
                    "!": `line-pattern`
                },
                {
                    source: `geojson`,
                    has: {
                        lineMetrics: !0
                    }
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `line-progress`
                ]
            },
            "property-type": `color-ramp`
        }
    },
    paint_circle: {
        "circle-radius": {
            type: `number`,
            default: 5,
            minimum: 0,
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "circle-color": {
            type: `color`,
            default: `#000000`,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "circle-blur": {
            type: `number`,
            default: 0,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "circle-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "circle-translate": {
            type: `array`,
            value: `number`,
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "circle-translate-anchor": {
            type: `enum`,
            values: {
                map: {},
                viewport: {}
            },
            default: `map`,
            requires: [
                `circle-translate`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "circle-pitch-scale": {
            type: `enum`,
            values: {
                map: {},
                viewport: {}
            },
            default: `map`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "circle-pitch-alignment": {
            type: `enum`,
            values: {
                map: {},
                viewport: {}
            },
            default: `viewport`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "circle-stroke-width": {
            type: `number`,
            default: 0,
            minimum: 0,
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "circle-stroke-color": {
            type: `color`,
            default: `#000000`,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "circle-stroke-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        }
    },
    paint_heatmap: {
        "heatmap-radius": {
            type: `number`,
            default: 30,
            minimum: 1,
            transition: !0,
            units: `pixels`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "heatmap-weight": {
            type: `number`,
            default: 1,
            minimum: 0,
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "heatmap-intensity": {
            type: `number`,
            default: 1,
            minimum: 0,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "heatmap-color": {
            type: `color`,
            default: [
                `interpolate`,
                [
                    `linear`
                ],
                [
                    `heatmap-density`
                ],
                0,
                `rgba(0, 0, 255, 0)`,
                .1,
                `royalblue`,
                .3,
                `cyan`,
                .5,
                `lime`,
                .7,
                `yellow`,
                1,
                `red`
            ],
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    `heatmap-density`
                ]
            },
            "property-type": `color-ramp`
        },
        "heatmap-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        }
    },
    paint_symbol: {
        "icon-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-color": {
            type: `color`,
            default: `#000000`,
            transition: !0,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-halo-color": {
            type: `color`,
            default: `rgba(0, 0, 0, 0)`,
            transition: !0,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-halo-width": {
            type: `number`,
            default: 0,
            minimum: 0,
            transition: !0,
            units: `pixels`,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-halo-blur": {
            type: `number`,
            default: 0,
            minimum: 0,
            transition: !0,
            units: `pixels`,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "icon-translate": {
            type: `array`,
            value: `number`,
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: `pixels`,
            requires: [
                `icon-image`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "icon-translate-anchor": {
            type: `enum`,
            values: {
                map: {},
                viewport: {}
            },
            default: `map`,
            requires: [
                `icon-image`,
                `icon-translate`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "text-color": {
            type: `color`,
            default: `#000000`,
            transition: !0,
            overridable: !0,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "text-halo-color": {
            type: `color`,
            default: `rgba(0, 0, 0, 0)`,
            transition: !0,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "text-halo-width": {
            type: `number`,
            default: 0,
            minimum: 0,
            transition: !0,
            units: `pixels`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "text-halo-blur": {
            type: `number`,
            default: 0,
            minimum: 0,
            transition: !0,
            units: `pixels`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`,
                    `feature`,
                    `feature-state`
                ]
            },
            "property-type": `data-driven`
        },
        "text-translate": {
            type: `array`,
            value: `number`,
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: `pixels`,
            requires: [
                `text-field`
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "text-translate-anchor": {
            type: `enum`,
            values: {
                map: {},
                viewport: {}
            },
            default: `map`,
            requires: [
                `text-field`,
                `text-translate`
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        }
    },
    paint_raster: {
        "raster-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "raster-hue-rotate": {
            type: `number`,
            default: 0,
            period: 360,
            transition: !0,
            units: `degrees`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "raster-brightness-min": {
            type: `number`,
            default: 0,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "raster-brightness-max": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "raster-saturation": {
            type: `number`,
            default: 0,
            minimum: -1,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "raster-contrast": {
            type: `number`,
            default: 0,
            minimum: -1,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        resampling: {
            type: `enum`,
            values: {
                linear: {},
                nearest: {}
            },
            default: `linear`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "raster-resampling": {
            type: `enum`,
            values: {
                linear: {},
                nearest: {}
            },
            default: `linear`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "raster-fade-duration": {
            type: `number`,
            default: 300,
            minimum: 0,
            transition: !1,
            units: `milliseconds`,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        }
    },
    paint_hillshade: {
        "hillshade-illumination-direction": {
            type: `numberArray`,
            default: 335,
            minimum: 0,
            maximum: 359,
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "hillshade-illumination-altitude": {
            type: `numberArray`,
            default: 45,
            minimum: 0,
            maximum: 90,
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "hillshade-illumination-anchor": {
            type: `enum`,
            values: {
                map: {},
                viewport: {}
            },
            default: `viewport`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "hillshade-exaggeration": {
            type: `number`,
            default: .5,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "hillshade-shadow-color": {
            type: `colorArray`,
            default: `#000000`,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "hillshade-highlight-color": {
            type: `colorArray`,
            default: `#FFFFFF`,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "hillshade-accent-color": {
            type: `color`,
            default: `#000000`,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "hillshade-method": {
            type: `enum`,
            values: {
                standard: {},
                basic: {},
                combined: {},
                igor: {},
                multidirectional: {}
            },
            default: `standard`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        resampling: {
            type: `enum`,
            values: {
                linear: {},
                nearest: {}
            },
            default: `linear`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        }
    },
    "paint_color-relief": {
        "color-relief-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "color-relief-color": {
            type: `color`,
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    `elevation`
                ]
            },
            "property-type": `color-ramp`
        },
        resampling: {
            type: `enum`,
            values: {
                linear: {},
                nearest: {}
            },
            default: `linear`,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        }
    },
    paint_background: {
        "background-color": {
            type: `color`,
            default: `#000000`,
            transition: !0,
            requires: [
                {
                    "!": `background-pattern`
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        },
        "background-pattern": {
            type: `resolvedImage`,
            transition: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `cross-faded`
        },
        "background-opacity": {
            type: `number`,
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    `zoom`
                ]
            },
            "property-type": `data-constant`
        }
    },
    transition: {
        duration: {
            type: `number`,
            default: 300,
            minimum: 0,
            units: `milliseconds`
        },
        delay: {
            type: `number`,
            default: 0,
            minimum: 0,
            units: `milliseconds`
        }
    },
    "property-type": {
        "data-driven": {
            type: `property-type`
        },
        "cross-faded": {
            type: `property-type`
        },
        "cross-faded-data-driven": {
            type: `property-type`
        },
        "color-ramp": {
            type: `property-type`
        },
        "data-constant": {
            type: `property-type`
        },
        constant: {
            type: `property-type`
        }
    },
    promoteId: {
        "*": {
            type: `string`
        }
    },
    interpolation: {
        type: `array`,
        value: `interpolation_name`,
        minimum: 1
    },
    interpolation_name: {
        type: `enum`,
        values: {
            linear: {
                syntax: {
                    overloads: [
                        {
                            parameters: [],
                            "output-type": `interpolation`
                        }
                    ],
                    parameters: []
                }
            },
            exponential: {
                syntax: {
                    overloads: [
                        {
                            parameters: [
                                `base`
                            ],
                            "output-type": `interpolation`
                        }
                    ],
                    parameters: [
                        {
                            name: `base`,
                            type: `number literal`
                        }
                    ]
                }
            },
            "cubic-bezier": {
                syntax: {
                    overloads: [
                        {
                            parameters: [
                                `x1`,
                                `y1`,
                                `x2`,
                                `y2`
                            ],
                            "output-type": `interpolation`
                        }
                    ],
                    parameters: [
                        {
                            name: `x1`,
                            type: `number literal`
                        },
                        {
                            name: `y1`,
                            type: `number literal`
                        },
                        {
                            name: `x2`,
                            type: `number literal`
                        },
                        {
                            name: `y2`,
                            type: `number literal`
                        }
                    ]
                }
            }
        }
    }
}, Ln = [
    `type`,
    `source`,
    `source-layer`,
    `minzoom`,
    `maxzoom`,
    `filter`,
    `layout`
];
function Rn(e, t) {
    let n = {};
    for(let t in e)t !== `ref` && (n[t] = e[t]);
    return Ln.forEach((e)=>{
        e in t && (n[e] = t[e]);
    }), n;
}
function zn(e) {
    e = e.slice();
    let t = Object.create(null);
    for(let n = 0; n < e.length; n++)t[e[n].id] = e[n];
    for(let n = 0; n < e.length; n++)`ref` in e[n] && (e[n] = Rn(e[n], t[e[n].ref]));
    return e;
}
function M(e, t) {
    if (Array.isArray(e)) {
        if (!Array.isArray(t) || e.length !== t.length) return !1;
        for(let n = 0; n < e.length; n++)if (!M(e[n], t[n])) return !1;
        return !0;
    }
    if (typeof e == `object` && e && t !== null) {
        if (typeof t != `object` || Object.keys(e).length !== Object.keys(t).length) return !1;
        for(let n in e)if (!M(e[n], t[n])) return !1;
        return !0;
    }
    return e === t;
}
function Bn(e, t) {
    e.push(t);
}
function Vn(e, t, n) {
    Bn(n, {
        command: `addSource`,
        args: [
            e,
            t[e]
        ]
    });
}
function Hn(e, t, n) {
    Bn(t, {
        command: `removeSource`,
        args: [
            e
        ]
    }), n[e] = !0;
}
function Un(e, t, n, r) {
    Hn(e, n, r), Vn(e, t, n);
}
function Wn(e, t, n) {
    let r;
    for(r in e[n])if (Object.prototype.hasOwnProperty.call(e[n], r) && r !== `data` && !M(e[n][r], t[n][r])) return !1;
    for(r in t[n])if (Object.prototype.hasOwnProperty.call(t[n], r) && r !== `data` && !M(e[n][r], t[n][r])) return !1;
    return !0;
}
function Gn(e, t, n, r) {
    e ||= {}, t ||= {};
    let i;
    for(i in e)Object.prototype.hasOwnProperty.call(e, i) && (Object.prototype.hasOwnProperty.call(t, i) || Hn(i, n, r));
    for(i in t)Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e, i) ? M(e[i], t[i]) || (e[i].type === `geojson` && t[i].type === `geojson` && Wn(e, t, i) ? Bn(n, {
        command: `setGeoJSONSourceData`,
        args: [
            i,
            t[i].data
        ]
    }) : Un(i, t, n, r)) : Vn(i, t, n));
}
function Kn(e, t, n, r, i, a) {
    e ||= {}, t ||= {};
    for(let o in e)Object.prototype.hasOwnProperty.call(e, o) && (M(e[o], t[o]) || n.push({
        command: a,
        args: [
            r,
            o,
            t[o],
            i
        ]
    }));
    for(let o in t)!Object.prototype.hasOwnProperty.call(t, o) || Object.prototype.hasOwnProperty.call(e, o) || M(e[o], t[o]) || n.push({
        command: a,
        args: [
            r,
            o,
            t[o],
            i
        ]
    });
}
function qn(e) {
    return e.id;
}
function Jn(e, t) {
    return e[t.id] = t, e;
}
function Yn(e, t, n) {
    e ||= [], t ||= [];
    let r = e.map(qn), i = t.map(qn), a = e.reduce(Jn, {}), o = t.reduce(Jn, {}), s = r.slice(), c = Object.create(null), l, u, d, f, p;
    for(let e = 0, t = 0; e < r.length; e++)l = r[e], Object.prototype.hasOwnProperty.call(o, l) ? t++ : (Bn(n, {
        command: `removeLayer`,
        args: [
            l
        ]
    }), s.splice(s.indexOf(l, t), 1));
    for(let e = 0, t = 0; e < i.length; e++)l = i[i.length - 1 - e], s[s.length - 1 - e] !== l && (Object.prototype.hasOwnProperty.call(a, l) ? (Bn(n, {
        command: `removeLayer`,
        args: [
            l
        ]
    }), s.splice(s.lastIndexOf(l, s.length - t), 1)) : t++, f = s[s.length - e], Bn(n, {
        command: `addLayer`,
        args: [
            o[l],
            f
        ]
    }), s.splice(s.length - e, 0, l), c[l] = !0);
    for(let e = 0; e < i.length; e++)if (l = i[e], u = a[l], d = o[l], !(c[l] || M(u, d))) {
        if (!M(u.source, d.source) || !M(u[`source-layer`], d[`source-layer`]) || !M(u.type, d.type)) {
            Bn(n, {
                command: `removeLayer`,
                args: [
                    l
                ]
            }), f = s[s.lastIndexOf(l) + 1], Bn(n, {
                command: `addLayer`,
                args: [
                    d,
                    f
                ]
            });
            continue;
        }
        for(p in Kn(u.layout, d.layout, n, l, null, `setLayoutProperty`), Kn(u.paint, d.paint, n, l, null, `setPaintProperty`), M(u.filter, d.filter) || Bn(n, {
            command: `setFilter`,
            args: [
                l,
                d.filter
            ]
        }), (!M(u.minzoom, d.minzoom) || !M(u.maxzoom, d.maxzoom)) && Bn(n, {
            command: `setLayerZoomRange`,
            args: [
                l,
                d.minzoom,
                d.maxzoom
            ]
        }), u)Object.prototype.hasOwnProperty.call(u, p) && p !== `layout` && p !== `paint` && p !== `filter` && p !== `metadata` && p !== `minzoom` && p !== `maxzoom` && (p.indexOf(`paint.`) === 0 ? Kn(u[p], d[p], n, l, p.slice(6), `setPaintProperty`) : M(u[p], d[p]) || Bn(n, {
            command: `setLayerProperty`,
            args: [
                l,
                p,
                d[p]
            ]
        }));
        for(p in d)!Object.prototype.hasOwnProperty.call(d, p) || Object.prototype.hasOwnProperty.call(u, p) || p !== `layout` && p !== `paint` && p !== `filter` && p !== `metadata` && p !== `minzoom` && p !== `maxzoom` && (p.indexOf(`paint.`) === 0 ? Kn(u[p], d[p], n, l, p.slice(6), `setPaintProperty`) : M(u[p], d[p]) || Bn(n, {
            command: `setLayerProperty`,
            args: [
                l,
                p,
                d[p]
            ]
        }));
    }
}
function Xn(e, t) {
    if (!e) return [
        {
            command: `setStyle`,
            args: [
                t
            ]
        }
    ];
    let n = [];
    try {
        if (!M(e.version, t.version)) return [
            {
                command: `setStyle`,
                args: [
                    t
                ]
            }
        ];
        M(e.center, t.center) || n.push({
            command: `setCenter`,
            args: [
                t.center
            ]
        }), M(e.state, t.state) || n.push({
            command: `setGlobalState`,
            args: [
                t.state
            ]
        }), M(e.centerAltitude, t.centerAltitude) || n.push({
            command: `setCenterAltitude`,
            args: [
                t.centerAltitude
            ]
        }), M(e.zoom, t.zoom) || n.push({
            command: `setZoom`,
            args: [
                t.zoom
            ]
        }), M(e.bearing, t.bearing) || n.push({
            command: `setBearing`,
            args: [
                t.bearing
            ]
        }), M(e.pitch, t.pitch) || n.push({
            command: `setPitch`,
            args: [
                t.pitch
            ]
        }), M(e.roll, t.roll) || n.push({
            command: `setRoll`,
            args: [
                t.roll
            ]
        }), M(e.sprite, t.sprite) || n.push({
            command: `setSprite`,
            args: [
                t.sprite
            ]
        }), M(e.glyphs, t.glyphs) || n.push({
            command: `setGlyphs`,
            args: [
                t.glyphs
            ]
        }), M(e.transition, t.transition) || n.push({
            command: `setTransition`,
            args: [
                t.transition
            ]
        }), M(e.light, t.light) || n.push({
            command: `setLight`,
            args: [
                t.light
            ]
        }), M(e.terrain, t.terrain) || n.push({
            command: `setTerrain`,
            args: [
                t.terrain
            ]
        }), M(e.sky, t.sky) || n.push({
            command: `setSky`,
            args: [
                t.sky
            ]
        }), M(e.projection, t.projection) || n.push({
            command: `setProjection`,
            args: [
                t.projection
            ]
        });
        let r = {}, i = [];
        Gn(e.sources, t.sources, i, r);
        let a = [];
        e.layers && e.layers.forEach((e)=>{
            `source` in e && r[e.source] ? n.push({
                command: `removeLayer`,
                args: [
                    e.id
                ]
            }) : a.push(e);
        }), n = n.concat(i), Yn(a, t.layers, n);
    } catch (e) {
        console.warn(`Unable to compute style diff:`, e), n = [
            {
                command: `setStyle`,
                args: [
                    t
                ]
            }
        ];
    }
    return n;
}
var N = class {
    constructor(e, t, n, r, i = `error`){
        this.message = (e ? `${e}: ` : ``) + n, r && (this.identifier = r), this.severity = i, t != null && t.__line__ && (this.line = t.__line__);
    }
}, Zn = class extends Error {
    constructor(e, t){
        super(t), this.message = t, this.key = e;
    }
}, Qn = class e {
    constructor(e, t = []){
        this.parent = e, this.bindings = {};
        for (let [e, n] of t)this.bindings[e] = n;
    }
    concat(t) {
        return new e(this, t);
    }
    get(e) {
        if (this.bindings[e]) return this.bindings[e];
        if (this.parent) return this.parent.get(e);
        throw Error(`${e} not found in scope.`);
    }
    has(e) {
        return this.bindings[e] ? !0 : this.parent ? this.parent.has(e) : !1;
    }
};
const $n = {
    kind: `null`
}, P = {
    kind: `number`
}, F = {
    kind: `string`
}, I = {
    kind: `boolean`
}, er = {
    kind: `color`
}, tr = {
    kind: `projectionDefinition`
}, nr = {
    kind: `object`
}, L = {
    kind: `value`
}, rr = {
    kind: `error`
}, ir = {
    kind: `collator`
}, ar = {
    kind: `formatted`
}, or = {
    kind: `padding`
}, sr = {
    kind: `colorArray`
}, cr = {
    kind: `numberArray`
}, lr = {
    kind: `resolvedImage`
}, ur = {
    kind: `variableAnchorOffsetCollection`
};
function dr(e, t) {
    return {
        kind: `array`,
        itemType: e,
        N: t
    };
}
function R(e) {
    if (e.kind === `array`) {
        let t = R(e.itemType);
        return typeof e.N == `number` ? `array<${t}, ${e.N}>` : e.itemType.kind === `value` ? `array` : `array<${t}>`;
    } else return e.kind;
}
const fr = [
    $n,
    P,
    F,
    I,
    er,
    tr,
    ar,
    nr,
    dr(L),
    or,
    cr,
    sr,
    lr,
    ur
];
function pr(e, t) {
    if (t.kind === `error`) return null;
    if (e.kind === `array`) {
        if (t.kind === `array` && (t.N === 0 && t.itemType.kind === `value` || !pr(e.itemType, t.itemType)) && (typeof e.N != `number` || e.N === t.N)) return null;
    } else if (e.kind === t.kind) return null;
    else if (e.kind === `value`) {
        for (let e of fr)if (!pr(e, t)) return null;
    }
    return `Expected ${R(e)} but found ${R(t)} instead.`;
}
function mr(e, t) {
    return t.some((t)=>t.kind === e.kind);
}
function hr(e, t) {
    return t.some((t)=>t === `null` ? e === null : t === `array` ? Array.isArray(e) : t === `object` ? e && !Array.isArray(e) && typeof e == `object` : t === typeof e);
}
function gr(e, t) {
    return e.kind === `array` && t.kind === `array` ? e.itemType.kind === t.itemType.kind && typeof e.N == `number` : e.kind === t.kind;
}
const _r = .96422, vr = .82521, yr = 4 / 29, br = 6 / 29, xr = 3 * br * br, Sr = Math.PI / 180, Cr = 180 / Math.PI;
function wr(e) {
    return e %= 360, e < 0 && (e += 360), e;
}
function Tr([e, t, n, r]) {
    e = Er(e), t = Er(t), n = Er(n);
    let i, a, o = Dr((.2225045 * e + .7168786 * t + .0606169 * n) / 1);
    e === t && t === n ? i = a = o : (i = Dr((.4360747 * e + .3850649 * t + .1430804 * n) / _r), a = Dr((.0139322 * e + .0971045 * t + .7141733 * n) / vr));
    let s = 116 * o - 16;
    return [
        s < 0 ? 0 : s,
        500 * (i - o),
        200 * (o - a),
        r
    ];
}
function Er(e) {
    return e <= .04045 ? e / 12.92 : ((e + .055) / 1.055) ** 2.4;
}
function Dr(e) {
    return e > .008856451679035631 ? e ** (1 / 3) : e / xr + yr;
}
function Or([e, t, n, r]) {
    let i = (e + 16) / 116, a = isNaN(t) ? i : i + t / 500, o = isNaN(n) ? i : i - n / 200;
    return i = 1 * Ar(i), a = _r * Ar(a), o = vr * Ar(o), [
        kr(3.1338561 * a - 1.6168667 * i - .4906146 * o),
        kr(-0.9787684 * a + 1.9161415 * i + .033454 * o),
        kr(.0719453 * a - .2289914 * i + 1.4052427 * o),
        r
    ];
}
function kr(e) {
    return e = e <= .00304 ? 12.92 * e : 1.055 * e ** (1 / 2.4) - .055, e < 0 ? 0 : e > 1 ? 1 : e;
}
function Ar(e) {
    return e > br ? e * e * e : xr * (e - yr);
}
function jr(e) {
    let [t, n, r, i] = Tr(e), a = Math.sqrt(n * n + r * r);
    return [
        Math.round(a * 1e4) ? wr(Math.atan2(r, n) * Cr) : NaN,
        a,
        t,
        i
    ];
}
function Mr([e, t, n, r]) {
    return e = isNaN(e) ? 0 : e * Sr, Or([
        n,
        Math.cos(e) * t,
        Math.sin(e) * t,
        r
    ]);
}
function Nr([e, t, n, r]) {
    e = wr(e), t /= 100, n /= 100;
    function i(r) {
        let i = (r + e / 30) % 12, a = t * Math.min(n, 1 - n);
        return n - a * Math.max(-1, Math.min(i - 3, 9 - i, 1));
    }
    return [
        i(0),
        i(8),
        i(4),
        r
    ];
}
const Pr = Object.hasOwn || function(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
};
function Fr(e, t) {
    return Pr(e, t) ? e[t] : void 0;
}
function Ir(e) {
    if (e = e.toLowerCase().trim(), e === `transparent`) return [
        0,
        0,
        0,
        0
    ];
    let t = Fr(Vr, e);
    if (t) {
        let [e, n, r] = t;
        return [
            e / 255,
            n / 255,
            r / 255,
            1
        ];
    }
    if (e.startsWith(`#`) && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(e)) {
        let t = e.length < 6 ? 1 : 2, n = 1;
        return [
            Lr(e.slice(n, n += t)),
            Lr(e.slice(n, n += t)),
            Lr(e.slice(n, n += t)),
            Lr(e.slice(n, n + t) || `ff`)
        ];
    }
    if (e.startsWith(`rgb`)) {
        let t = e.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
        if (t) {
            let [e, n, r, i, a, o, s, c, l, u, d, f] = t, p = [
                i || ` `,
                s || ` `,
                u
            ].join(``);
            if (p === `  ` || p === `  /` || p === `,,` || p === `,,,`) {
                let e = [
                    r,
                    o,
                    l
                ].join(``), t = e === `%%%` ? 100 : e === `` ? 255 : 0;
                if (t) {
                    let e = [
                        zr(+n / t, 0, 1),
                        zr(+a / t, 0, 1),
                        zr(+c / t, 0, 1),
                        d ? Rr(+d, f) : 1
                    ];
                    if (Br(e)) return e;
                }
            }
            return;
        }
    }
    let n = e.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
    if (n) {
        let [e, t, r, i, a, o, s, c, l] = n, u = [
            r || ` `,
            a || ` `,
            s
        ].join(``);
        if (u === `  ` || u === `  /` || u === `,,` || u === `,,,`) {
            let e = [
                +t,
                zr(+i, 0, 100),
                zr(+o, 0, 100),
                c ? Rr(+c, l) : 1
            ];
            if (Br(e)) return Nr(e);
        }
    }
}
function Lr(e) {
    return parseInt(e.padEnd(2, e), 16) / 255;
}
function Rr(e, t) {
    return zr(t ? e / 100 : e, 0, 1);
}
function zr(e, t, n) {
    return Math.min(Math.max(t, e), n);
}
function Br(e) {
    return !e.some(Number.isNaN);
}
const Vr = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
function Hr(e, t, n) {
    return e + n * (t - e);
}
function Ur(e, t, n) {
    return e.map((e, r)=>Hr(e, t[r], n));
}
function Wr(e) {
    return e === `rgb` || e === `hcl` || e === `lab`;
}
var z = class e {
    constructor(e, t, n, r = 1, i = !0){
        this.r = e, this.g = t, this.b = n, this.a = r, i || (this.r *= r, this.g *= r, this.b *= r, r || this.overwriteGetter(`rgb`, [
            e,
            t,
            n,
            r
        ]));
    }
    static{
        this.black = new e(0, 0, 0, 1);
    }
    static{
        this.white = new e(1, 1, 1, 1);
    }
    static{
        this.transparent = new e(0, 0, 0, 0);
    }
    static{
        this.red = new e(1, 0, 0, 1);
    }
    static parse(t) {
        if (t instanceof e) return t;
        if (typeof t != `string`) return;
        let n = Ir(t);
        if (n) return new e(...n, !1);
    }
    get rgb() {
        let { r: e, g: t, b: n, a: r } = this, i = r || 1 / 0;
        return this.overwriteGetter(`rgb`, [
            e / i,
            t / i,
            n / i,
            r
        ]);
    }
    get hcl() {
        return this.overwriteGetter(`hcl`, jr(this.rgb));
    }
    get lab() {
        return this.overwriteGetter(`lab`, Tr(this.rgb));
    }
    overwriteGetter(e, t) {
        return Object.defineProperty(this, e, {
            value: t
        }), t;
    }
    toString() {
        let [e, t, n, r] = this.rgb;
        return `rgba(${[
            e,
            t,
            n
        ].map((e)=>Math.round(e * 255)).join(`,`)},${r})`;
    }
    static interpolate(t, n, r, i = `rgb`) {
        switch(i){
            case `rgb`:
                {
                    let [i, a, o, s] = Ur(t.rgb, n.rgb, r);
                    return new e(i, a, o, s, !1);
                }
            case `hcl`:
                {
                    let [i, a, o, s] = t.hcl, [c, l, u, d] = n.hcl, f, p;
                    if (!isNaN(i) && !isNaN(c)) {
                        let e = c - i;
                        c > i && e > 180 ? e -= 360 : c < i && i - c > 180 && (e += 360), f = i + r * e;
                    } else isNaN(i) ? isNaN(c) ? f = NaN : (f = c, (o === 1 || o === 0) && (p = l)) : (f = i, (u === 1 || u === 0) && (p = a));
                    let [m, h, g, _] = Mr([
                        f,
                        p ?? Hr(a, l, r),
                        Hr(o, u, r),
                        Hr(s, d, r)
                    ]);
                    return new e(m, h, g, _, !1);
                }
            case `lab`:
                {
                    let [i, a, o, s] = Or(Ur(t.lab, n.lab, r));
                    return new e(i, a, o, s, !1);
                }
        }
    }
}, Gr = class {
    constructor(e, t, n){
        e ? this.sensitivity = t ? `variant` : `case` : this.sensitivity = t ? `accent` : `base`, this.locale = n, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
            sensitivity: this.sensitivity,
            usage: `search`
        });
    }
    compare(e, t) {
        return this.collator.compare(e, t);
    }
    resolvedLocale() {
        return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
    }
};
const Kr = [
    `bottom`,
    `center`,
    `top`
];
var qr = class {
    constructor(e, t, n, r, i, a){
        this.text = e, this.image = t, this.scale = n, this.fontStack = r, this.textColor = i, this.verticalAlign = a;
    }
}, Jr = class e {
    constructor(e){
        this.sections = e;
    }
    static fromString(t) {
        return new e([
            new qr(t, null, null, null, null, null)
        ]);
    }
    isEmpty() {
        return this.sections.length === 0 || !this.sections.some((e)=>e.text.length !== 0 || e.image && e.image.name.length !== 0);
    }
    static factory(t) {
        return t instanceof e ? t : e.fromString(t);
    }
    toString() {
        return this.sections.length === 0 ? `` : this.sections.map((e)=>e.text).join(``);
    }
}, Yr = class e {
    constructor(e){
        this.values = e.slice();
    }
    static parse(t) {
        if (t instanceof e) return t;
        if (typeof t == `number`) return new e([
            t,
            t,
            t,
            t
        ]);
        if (Array.isArray(t) && !(t.length < 1 || t.length > 4)) {
            for (let e of t)if (typeof e != `number`) return;
            switch(t.length){
                case 1:
                    t = [
                        t[0],
                        t[0],
                        t[0],
                        t[0]
                    ];
                    break;
                case 2:
                    t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ];
                    break;
                case 3:
                    t = [
                        t[0],
                        t[1],
                        t[2],
                        t[1]
                    ];
                    break;
            }
            return new e(t);
        }
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(t, n, r) {
        return new e(Ur(t.values, n.values, r));
    }
}, Xr = class e {
    constructor(e){
        this.values = e.slice();
    }
    static parse(t) {
        if (t instanceof e) return t;
        if (typeof t == `number`) return new e([
            t
        ]);
        if (Array.isArray(t)) {
            for (let e of t)if (typeof e != `number`) return;
            return new e(t);
        }
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(t, n, r) {
        return new e(Ur(t.values, n.values, r));
    }
}, Zr = class e {
    constructor(e){
        this.values = e.slice();
    }
    static parse(t) {
        if (t instanceof e) return t;
        if (typeof t == `string`) {
            let n = z.parse(t);
            return n ? new e([
                n
            ]) : void 0;
        }
        if (!Array.isArray(t)) return;
        let n = [];
        for (let e of t){
            if (typeof e != `string`) return;
            let t = z.parse(e);
            if (!t) return;
            n.push(t);
        }
        return new e(n);
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(t, n, r, i = `rgb`) {
        let a = [];
        if (t.values.length != n.values.length) throw Error(`colorArray: Arrays have mismatched length (${t.values.length} vs. ${n.values.length}), cannot interpolate.`);
        for(let e = 0; e < t.values.length; e++)a.push(z.interpolate(t.values[e], n.values[e], r, i));
        return new e(a);
    }
}, B = class extends Error {
    constructor(e, t){
        super(e), this.name = `RuntimeError`, this.path = t;
    }
    toJSON() {
        return this.message;
    }
};
const Qr = new Set([
    `center`,
    `left`,
    `right`,
    `top`,
    `bottom`,
    `top-left`,
    `top-right`,
    `bottom-left`,
    `bottom-right`
]);
var $r = class e {
    constructor(e){
        this.values = e.slice();
    }
    static parse(t) {
        if (t instanceof e) return t;
        if (!(!Array.isArray(t) || t.length < 1 || t.length % 2 != 0)) {
            for(let e = 0; e < t.length; e += 2){
                let n = t[e], r = t[e + 1];
                if (typeof n != `string` || !Qr.has(n) || !Array.isArray(r) || r.length !== 2 || typeof r[0] != `number` || typeof r[1] != `number`) return;
            }
            return new e(t);
        }
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(t, n, r, i) {
        let a = t.values, o = n.values;
        if (a.length !== o.length) throw new B(`Cannot interpolate values of different length. from: ${t.toString()}, to: ${n.toString()}`, i);
        let s = [];
        for(let e = 0; e < a.length; e += 2){
            if (a[e] !== o[e]) throw new B(`Cannot interpolate values containing mismatched anchors. from[${e}]: ${a[e]}, to[${e}]: ${o[e]}`, i);
            s.push(a[e]);
            let [t, n] = a[e + 1], [c, l] = o[e + 1];
            s.push([
                Hr(t, c, r),
                Hr(n, l, r)
            ]);
        }
        return new e(s);
    }
}, ei = class e {
    constructor(e){
        this.name = e.name, this.available = e.available;
    }
    toString() {
        return this.name;
    }
    static fromString(t) {
        return t ? new e({
            name: t,
            available: !1
        }) : null;
    }
}, ti = class e {
    constructor(e, t, n){
        this.from = e, this.to = t, this.transition = n;
    }
    toString() {
        return this.from === this.to && this.transition === 1 ? this.from : JSON.stringify([
            this.from,
            this.to,
            this.transition
        ]);
    }
    static interpolate(t, n, r) {
        return new e(t, n, r);
    }
    static parse(t) {
        if (t instanceof e) return t;
        if (Array.isArray(t) && t.length === 3 && typeof t[0] == `string` && typeof t[1] == `string` && typeof t[2] == `number`) return new e(t[0], t[1], t[2]);
        if (typeof t == `object` && typeof t.from == `string` && typeof t.to == `string` && typeof t.transition == `number`) return new e(t.from, t.to, t.transition);
        if (typeof t == `string`) return new e(t, t, 1);
    }
};
function ni(e, t, n, r) {
    return typeof e == `number` && e >= 0 && e <= 255 && typeof t == `number` && t >= 0 && t <= 255 && typeof n == `number` && n >= 0 && n <= 255 ? r === void 0 || typeof r == `number` && r >= 0 && r <= 1 ? null : `Invalid rgba value [${[
        e,
        t,
        n,
        r
    ].join(`, `)}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${(typeof r == `number` ? [
        e,
        t,
        n,
        r
    ] : [
        e,
        t,
        n
    ]).join(`, `)}]: 'r', 'g', and 'b' must be between 0 and 255.`;
}
function ri(e) {
    if (e === null || typeof e == `string` || typeof e == `boolean` || typeof e == `number` || e instanceof ti || e instanceof z || e instanceof Gr || e instanceof Jr || e instanceof Yr || e instanceof Xr || e instanceof Zr || e instanceof $r || e instanceof ei) return !0;
    if (Array.isArray(e)) {
        for (let t of e)if (!ri(t)) return !1;
        return !0;
    } else if (typeof e == `object`) {
        for(let t in e)if (!ri(e[t])) return !1;
        return !0;
    } else return !1;
}
function ii(e) {
    if (e === null) return $n;
    if (typeof e == `string`) return F;
    if (typeof e == `boolean`) return I;
    if (typeof e == `number`) return P;
    if (e instanceof z) return er;
    if (e instanceof ti) return tr;
    if (e instanceof Gr) return ir;
    if (e instanceof Jr) return ar;
    if (e instanceof Yr) return or;
    if (e instanceof Xr) return cr;
    if (e instanceof Zr) return sr;
    if (e instanceof $r) return ur;
    if (e instanceof ei) return lr;
    if (Array.isArray(e)) {
        let t = e.length, n;
        for (let t of e){
            let e = ii(t);
            if (!n) n = e;
            else if (n === e) continue;
            else {
                n = L;
                break;
            }
        }
        return dr(n || L, t);
    } else return nr;
}
function ai(e) {
    let t = typeof e;
    return e === null ? `` : t === `string` || t === `number` || t === `boolean` ? String(e) : e instanceof z || e instanceof ti || e instanceof Jr || e instanceof Yr || e instanceof Xr || e instanceof Zr || e instanceof $r || e instanceof ei ? e.toString() : JSON.stringify(e);
}
var oi = class e {
    constructor(e, t){
        this.type = e, this.value = t;
    }
    static parse(t, n) {
        if (t.length !== 2) return n.error(`'literal' expression requires exactly one argument, but found ${t.length - 1} instead.`);
        if (!ri(t[1])) return n.error(`invalid value`);
        let r = t[1], i = ii(r), a = n.expectedType;
        return i.kind === `array` && i.N === 0 && a && a.kind === `array` && (typeof a.N != `number` || a.N === 0) && (i = a), new e(i, r);
    }
    evaluate() {
        return this.value;
    }
    eachChild() {}
    outputDefined() {
        return !0;
    }
};
const si = {
    string: F,
    number: P,
    boolean: I,
    object: nr
};
var ci = class e {
    constructor(e, t, n){
        this.type = e, this.args = t, this.key = n;
    }
    static parse(t, n) {
        if (t.length < 2) return n.error(`Expected at least one argument.`);
        let r = 1, i, a = t[0];
        if (a === `array`) {
            let e;
            if (t.length > 2) {
                let i = t[1];
                if (typeof i != `string` || !(i in si) || i === `object`) return n.error(`The item type argument of "array" must be one of string, number, boolean`, 1);
                e = si[i], r++;
            } else e = L;
            let a;
            if (t.length > 3) {
                if (t[2] !== null && (typeof t[2] != `number` || t[2] < 0 || t[2] !== Math.floor(t[2]))) return n.error(`The length argument to "array" must be a positive integer literal`, 2);
                a = t[2], r++;
            }
            i = dr(e, a);
        } else {
            if (!si[a]) throw Error(`Types doesn't contain name = ${a}`);
            i = si[a];
        }
        let o = [];
        for(; r < t.length; r++){
            let e = n.parse(t[r], r, L);
            if (!e) return null;
            o.push(e);
        }
        return new e(i, o, n.key);
    }
    evaluate(e) {
        for(let t = 0; t < this.args.length; t++){
            let n = this.args[t].evaluate(e);
            if (!pr(this.type, ii(n))) return n;
            if (t === this.args.length - 1) throw new B(`Expected value to be of type ${R(this.type)}, but found ${R(ii(n))} instead.`, this.key);
        }
        throw Error();
    }
    eachChild(e) {
        this.args.forEach(e);
    }
    outputDefined() {
        return this.args.every((e)=>e.outputDefined());
    }
};
const li = {
    "to-boolean": I,
    "to-color": er,
    "to-number": P,
    "to-string": F
};
var ui = class e {
    constructor(e, t, n){
        this.type = e, this.args = t, this.key = n;
    }
    static parse(t, n) {
        if (t.length < 2) return n.error(`Expected at least one argument.`);
        let r = t[0];
        if (!li[r]) throw Error(`Can't parse ${r} as it is not part of the known types`);
        if ((r === `to-boolean` || r === `to-string`) && t.length !== 2) return n.error(`Expected one argument.`);
        let i = li[r], a = [];
        for(let e = 1; e < t.length; e++){
            let r = n.parse(t[e], e, L);
            if (!r) return null;
            a.push(r);
        }
        return new e(i, a, n.key);
    }
    evaluate(e) {
        switch(this.type.kind){
            case `boolean`:
                return !!this.args[0].evaluate(e);
            case `color`:
                {
                    let t, n;
                    for (let r of this.args){
                        if (t = r.evaluate(e), n = null, t instanceof z) return t;
                        if (typeof t == `string`) {
                            let n = e.parseColor(t);
                            if (n) return n;
                        } else if (Array.isArray(t) && (n = t.length < 3 || t.length > 4 ? `Invalid rgba value ${JSON.stringify(t)}: expected an array containing either three or four numeric values.` : ni(t[0], t[1], t[2], t[3]), !n)) return new z(t[0] / 255, t[1] / 255, t[2] / 255, t[3]);
                    }
                    throw new B(n || `Could not parse color from value '${typeof t == `string` ? t : JSON.stringify(t)}'`, this.key);
                }
            case `padding`:
                {
                    let t;
                    for (let n of this.args){
                        t = n.evaluate(e);
                        let r = Yr.parse(t);
                        if (r) return r;
                    }
                    throw new B(`Could not parse padding from value '${typeof t == `string` ? t : JSON.stringify(t)}'`, this.key);
                }
            case `numberArray`:
                {
                    let t;
                    for (let n of this.args){
                        t = n.evaluate(e);
                        let r = Xr.parse(t);
                        if (r) return r;
                    }
                    throw new B(`Could not parse numberArray from value '${typeof t == `string` ? t : JSON.stringify(t)}'`, this.key);
                }
            case `colorArray`:
                {
                    let t;
                    for (let n of this.args){
                        t = n.evaluate(e);
                        let r = Zr.parse(t);
                        if (r) return r;
                    }
                    throw new B(`Could not parse colorArray from value '${typeof t == `string` ? t : JSON.stringify(t)}'`, this.key);
                }
            case `variableAnchorOffsetCollection`:
                {
                    let t;
                    for (let n of this.args){
                        t = n.evaluate(e);
                        let r = $r.parse(t);
                        if (r) return r;
                    }
                    throw new B(`Could not parse variableAnchorOffsetCollection from value '${typeof t == `string` ? t : JSON.stringify(t)}'`, this.key);
                }
            case `number`:
                {
                    let t = null;
                    for (let n of this.args){
                        if (t = n.evaluate(e), t === null) return 0;
                        let r = Number(t);
                        if (!isNaN(r)) return r;
                    }
                    throw new B(`Could not convert ${JSON.stringify(t)} to number.`, this.key);
                }
            case `formatted`:
                return Jr.fromString(ai(this.args[0].evaluate(e)));
            case `resolvedImage`:
                return ei.fromString(ai(this.args[0].evaluate(e)));
            case `projectionDefinition`:
                return this.args[0].evaluate(e);
            default:
                return ai(this.args[0].evaluate(e));
        }
    }
    eachChild(e) {
        this.args.forEach(e);
    }
    outputDefined() {
        return this.args.every((e)=>e.outputDefined());
    }
};
const di = [
    `Unknown`,
    `Point`,
    `LineString`,
    `Polygon`
];
var fi = class {
    constructor(){
        this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = new Map, this.availableImages = null, this.canonical = null;
    }
    id() {
        return this.feature && `id` in this.feature ? this.feature.id : null;
    }
    geometryType() {
        return this.feature ? typeof this.feature.type == `number` ? di[this.feature.type] : this.feature.type : null;
    }
    geometry() {
        return this.feature && `geometry` in this.feature ? this.feature.geometry : null;
    }
    canonicalID() {
        return this.canonical;
    }
    properties() {
        return this.feature && this.feature.properties || {};
    }
    parseColor(e) {
        let t = this._parseColorCache.get(e);
        return t || (t = z.parse(e), this._parseColorCache.set(e, t)), t;
    }
}, pi = class e {
    constructor(e, t, n = [], r, i = new Qn, a = []){
        this.registry = e, this.path = n, this.key = n.map((e)=>`[${e}]`).join(``), this.scope = i, this.errors = a, this.expectedType = r, this._isConstant = t;
    }
    parse(e, t, n, r, i = {}) {
        return t ? this.concat(t, n, r)._parse(e, i) : this._parse(e, i);
    }
    _parse(e, t) {
        (e === null || typeof e == `string` || typeof e == `boolean` || typeof e == `number`) && (e = [
            `literal`,
            e
        ]);
        let n = this.key;
        function r(e, t, r) {
            return r === `assert` ? new ci(t, [
                e
            ], n) : r === `coerce` ? new ui(t, [
                e
            ], n) : e;
        }
        if (Array.isArray(e)) {
            if (e.length === 0) return this.error(`Expected an array with at least one element. If you wanted a literal array, use ["literal", []].`);
            let n = e[0];
            if (typeof n != `string`) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
            let i = this.registry[n];
            if (i) {
                let n = i.parse(e, this);
                if (!n) return null;
                if (this.expectedType) {
                    let e = this.expectedType, i = n.type;
                    if ((e.kind === `string` || e.kind === `number` || e.kind === `boolean` || e.kind === `object` || e.kind === `array`) && i.kind === `value`) n = r(n, e, t.typeAnnotation || `assert`);
                    else if (e.kind === `projectionDefinition` && [
                        `string`,
                        `array`
                    ].includes(i.kind) || [
                        `color`,
                        `formatted`,
                        `resolvedImage`
                    ].includes(e.kind) && [
                        `value`,
                        `string`
                    ].includes(i.kind) || [
                        `padding`,
                        `numberArray`
                    ].includes(e.kind) && [
                        `value`,
                        `number`,
                        `array`
                    ].includes(i.kind) || e.kind === `colorArray` && [
                        `value`,
                        `string`,
                        `array`
                    ].includes(i.kind) || e.kind === `variableAnchorOffsetCollection` && [
                        `value`,
                        `array`
                    ].includes(i.kind)) n = r(n, e, t.typeAnnotation || `coerce`);
                    else if (this.checkSubtype(e, i)) return null;
                }
                if (!(n instanceof oi) && n.type.kind !== `resolvedImage` && this._isConstant(n)) {
                    let e = new fi;
                    try {
                        n = new oi(n.type, n.evaluate(e));
                    } catch (e) {
                        return this.error(e.message), null;
                    }
                }
                return n;
            }
            return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
        } else if (e === void 0) return this.error(`'undefined' value invalid. Use null instead.`);
        else if (typeof e == `object`) return this.error(`Bare objects invalid. Use ["literal", {...}] instead.`);
        else return this.error(`Expected an array, but found ${typeof e} instead.`);
    }
    concat(t, n, r) {
        let i = typeof t == `number` ? this.path.concat(t) : this.path, a = r ? this.scope.concat(r) : this.scope;
        return new e(this.registry, this._isConstant, i, n || null, a, this.errors);
    }
    error(e, ...t) {
        let n = `${this.key}${t.map((e)=>`[${e}]`).join(``)}`;
        this.errors.push(new Zn(n, e));
    }
    checkSubtype(e, t) {
        let n = pr(e, t);
        return n && this.error(n), n;
    }
}, mi = class e {
    constructor(e, t){
        this.type = t.type, this.bindings = [].concat(e), this.result = t;
    }
    evaluate(e) {
        return this.result.evaluate(e);
    }
    eachChild(e) {
        for (let t of this.bindings)e(t[1]);
        e(this.result);
    }
    static parse(t, n) {
        if (t.length < 4) return n.error(`Expected at least 3 arguments, but found ${t.length - 1} instead.`);
        let r = [];
        for(let e = 1; e < t.length - 1; e += 2){
            let i = t[e];
            if (typeof i != `string`) return n.error(`Expected string, but found ${typeof i} instead.`, e);
            if (/[^a-zA-Z0-9_]/.test(i)) return n.error(`Variable names must contain only alphanumeric characters or '_'.`, e);
            let a = n.parse(t[e + 1], e + 1);
            if (!a) return null;
            r.push([
                i,
                a
            ]);
        }
        let i = n.parse(t[t.length - 1], t.length - 1, n.expectedType, r);
        return i ? new e(r, i) : null;
    }
    outputDefined() {
        return this.result.outputDefined();
    }
}, hi = class e {
    constructor(e, t){
        this.type = t.type, this.name = e, this.boundExpression = t;
    }
    static parse(t, n) {
        if (t.length !== 2 || typeof t[1] != `string`) return n.error(`'var' expression requires exactly one string literal argument.`);
        let r = t[1];
        return n.scope.has(r) ? new e(r, n.scope.get(r)) : n.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
    }
    evaluate(e) {
        return this.boundExpression.evaluate(e);
    }
    eachChild() {}
    outputDefined() {
        return !1;
    }
}, gi = class e {
    constructor(e, t, n, r){
        this.type = e, this.index = t, this.input = n, this.key = r;
    }
    static parse(t, n) {
        if (t.length !== 3) return n.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
        let r = n.parse(t[1], 1, P), i = n.parse(t[2], 2, dr(n.expectedType || L));
        if (!r || !i) return null;
        let a = i.type;
        return new e(a.itemType, r, i, n.key);
    }
    evaluate(e) {
        let t = this.index.evaluate(e), n = this.input.evaluate(e);
        if (t < 0) throw new B(`Array index out of bounds: ${t} < 0.`, this.key);
        if (t >= n.length) throw new B(`Array index out of bounds: ${t} > ${n.length - 1}.`, this.key);
        if (t !== Math.floor(t)) throw new B(`Array index must be an integer, but found ${t} instead.`, this.key);
        return n[t];
    }
    eachChild(e) {
        e(this.index), e(this.input);
    }
    outputDefined() {
        return !1;
    }
}, _i = class e {
    constructor(e, t, n){
        this.needle = e, this.haystack = t, this.key = n, this.type = I;
    }
    static parse(t, n) {
        if (t.length !== 3) return n.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
        let r = n.parse(t[1], 1, L), i = n.parse(t[2], 2, L);
        return !r || !i ? null : mr(r.type, [
            I,
            F,
            P,
            $n,
            L
        ]) ? new e(r, i, n.key) : n.error(`Expected first argument to be of type boolean, string, number or null, but found ${R(r.type)} instead`);
    }
    evaluate(e) {
        let t = this.needle.evaluate(e), n = this.haystack.evaluate(e);
        if (!n) return !1;
        if (!hr(t, [
            `boolean`,
            `string`,
            `number`,
            `null`
        ])) throw new B(`Expected first argument to be of type boolean, string, number or null, but found ${R(ii(t))} instead.`, this.key);
        if (!hr(n, [
            `string`,
            `array`
        ])) throw new B(`Expected second argument to be of type array or string, but found ${R(ii(n))} instead.`, this.key);
        return n.indexOf(t) >= 0;
    }
    eachChild(e) {
        e(this.needle), e(this.haystack);
    }
    outputDefined() {
        return !0;
    }
}, vi = class e {
    constructor(e, t, n, r){
        this.needle = e, this.haystack = t, this.key = n, this.fromIndex = r, this.type = P;
    }
    static parse(t, n) {
        if (t.length <= 2 || t.length >= 5) return n.error(`Expected 2 or 3 arguments, but found ${t.length - 1} instead.`);
        let r = n.parse(t[1], 1, L), i = n.parse(t[2], 2, L);
        if (!r || !i) return null;
        if (!mr(r.type, [
            I,
            F,
            P,
            $n,
            L
        ])) return n.error(`Expected first argument to be of type boolean, string, number or null, but found ${R(r.type)} instead`);
        if (t.length === 4) {
            let a = n.parse(t[3], 3, P);
            return a ? new e(r, i, n.key, a) : null;
        } else return new e(r, i, n.key);
    }
    evaluate(e) {
        let t = this.needle.evaluate(e), n = this.haystack.evaluate(e);
        if (!hr(t, [
            `boolean`,
            `string`,
            `number`,
            `null`
        ])) throw new B(`Expected first argument to be of type boolean, string, number or null, but found ${R(ii(t))} instead.`, this.key);
        let r;
        if (this.fromIndex && (r = this.fromIndex.evaluate(e)), hr(n, [
            `string`
        ])) {
            let e = n.indexOf(t, r);
            return e === -1 ? -1 : [
                ...n.slice(0, e)
            ].length;
        } else if (hr(n, [
            `array`
        ])) return n.indexOf(t, r);
        else throw new B(`Expected second argument to be of type array or string, but found ${R(ii(n))} instead.`, this.key);
    }
    eachChild(e) {
        e(this.needle), e(this.haystack), this.fromIndex && e(this.fromIndex);
    }
    outputDefined() {
        return !1;
    }
}, yi = class e {
    constructor(e, t, n, r, i, a){
        this.inputType = e, this.type = t, this.input = n, this.cases = r, this.outputs = i, this.otherwise = a;
    }
    static parse(t, n) {
        if (t.length < 5) return n.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
        if (t.length % 2 != 1) return n.error(`Expected an even number of arguments.`);
        let r, i;
        n.expectedType && n.expectedType.kind !== `value` && (i = n.expectedType);
        let a = {}, o = [];
        for(let e = 2; e < t.length - 1; e += 2){
            let s = t[e], c = t[e + 1];
            Array.isArray(s) || (s = [
                s
            ]);
            let l = n.concat(e);
            if (s.length === 0) return l.error(`Expected at least one branch label.`);
            for (let e of s){
                if (typeof e != `number` && typeof e != `string`) return l.error(`Branch labels must be numbers or strings.`);
                if (typeof e == `number` && Math.abs(e) > 2 ** 53 - 1) return l.error(`Branch labels must be integers no larger than ${2 ** 53 - 1}.`);
                if (typeof e == `number` && Math.floor(e) !== e) return l.error(`Numeric branch labels must be integer values.`);
                if (!r) r = ii(e);
                else if (l.checkSubtype(r, ii(e))) return null;
                if (a[String(e)] !== void 0) return l.error(`Branch labels must be unique.`);
                a[String(e)] = o.length;
            }
            let u = n.parse(c, e, i);
            if (!u) return null;
            i ||= u.type, o.push(u);
        }
        let s = n.parse(t[1], 1, L);
        if (!s) return null;
        let c = n.parse(t[t.length - 1], t.length - 1, i);
        return !c || s.type.kind !== `value` && n.concat(1).checkSubtype(r, s.type) ? null : new e(r, i, s, a, o, c);
    }
    evaluate(e) {
        let t = this.input.evaluate(e);
        return (ii(t) === this.inputType && this.outputs[this.cases[t]] || this.otherwise).evaluate(e);
    }
    eachChild(e) {
        e(this.input), this.outputs.forEach(e), e(this.otherwise);
    }
    outputDefined() {
        return this.outputs.every((e)=>e.outputDefined()) && this.otherwise.outputDefined();
    }
}, bi = class e {
    constructor(e, t, n){
        this.type = e, this.branches = t, this.otherwise = n;
    }
    static parse(t, n) {
        if (t.length < 4) return n.error(`Expected at least 3 arguments, but found only ${t.length - 1}.`);
        if (t.length % 2 != 0) return n.error(`Expected an odd number of arguments.`);
        let r;
        n.expectedType && n.expectedType.kind !== `value` && (r = n.expectedType);
        let i = [];
        for(let e = 1; e < t.length - 1; e += 2){
            let a = n.parse(t[e], e, I);
            if (!a) return null;
            let o = n.parse(t[e + 1], e + 1, r);
            if (!o) return null;
            i.push([
                a,
                o
            ]), r ||= o.type;
        }
        let a = n.parse(t[t.length - 1], t.length - 1, r);
        if (!a) return null;
        if (!r) throw Error(`Can't infer output type`);
        return new e(r, i, a);
    }
    evaluate(e) {
        for (let [t, n] of this.branches)if (t.evaluate(e)) return n.evaluate(e);
        return this.otherwise.evaluate(e);
    }
    eachChild(e) {
        for (let [t, n] of this.branches)e(t), e(n);
        e(this.otherwise);
    }
    outputDefined() {
        return this.branches.every(([e, t])=>t.outputDefined()) && this.otherwise.outputDefined();
    }
}, xi = class e {
    constructor(e, t, n, r, i){
        this.type = e, this.input = t, this.beginIndex = n, this.key = r, this.endIndex = i;
    }
    static parse(t, n) {
        if (t.length <= 2 || t.length >= 5) return n.error(`Expected 2 or 3 arguments, but found ${t.length - 1} instead.`);
        let r = n.parse(t[1], 1, L), i = n.parse(t[2], 2, P);
        if (!r || !i) return null;
        if (!mr(r.type, [
            dr(L),
            F,
            L
        ])) return n.error(`Expected first argument to be of type array or string, but found ${R(r.type)} instead`);
        if (t.length === 4) {
            let a = n.parse(t[3], 3, P);
            return a ? new e(r.type, r, i, n.key, a) : null;
        } else return new e(r.type, r, i, n.key);
    }
    evaluate(e) {
        let t = this.input.evaluate(e), n = this.beginIndex.evaluate(e), r;
        if (this.endIndex && (r = this.endIndex.evaluate(e)), hr(t, [
            `string`
        ])) return [
            ...t
        ].slice(n, r).join(``);
        if (hr(t, [
            `array`
        ])) return t.slice(n, r);
        throw new B(`Expected first argument to be of type array or string, but found ${R(ii(t))} instead.`, this.key);
    }
    eachChild(e) {
        e(this.input), e(this.beginIndex), this.endIndex && e(this.endIndex);
    }
    outputDefined() {
        return !1;
    }
};
function Si(e, t, n) {
    let r = e.length - 1, i = 0, a = r, o = 0, s, c;
    for(; i <= a;)if (o = Math.floor((i + a) / 2), s = e[o], c = e[o + 1], s <= t) {
        if (o === r || t < c) return o;
        i = o + 1;
    } else if (s > t) a = o - 1;
    else throw new B(`Input is not a number.`, n);
    return 0;
}
var Ci = class e {
    constructor(e, t, n, r){
        this.type = e, this.input = t, this.key = r, this.labels = [], this.outputs = [];
        for (let [e, t] of n)this.labels.push(e), this.outputs.push(t);
    }
    static parse(t, n) {
        if (t.length - 1 < 4) return n.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
        if ((t.length - 1) % 2 != 0) return n.error(`Expected an even number of arguments.`);
        let r = n.parse(t[1], 1, P);
        if (!r) return null;
        let i = [], a = null;
        n.expectedType && n.expectedType.kind !== `value` && (a = n.expectedType);
        for(let e = 1; e < t.length; e += 2){
            let r = e === 1 ? -1 / 0 : t[e], o = t[e + 1], s = e, c = e + 1;
            if (typeof r != `number`) return n.error(`Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.`, s);
            if (i.length && i[i.length - 1][0] >= r) return n.error(`Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.`, s);
            let l = n.parse(o, c, a);
            if (!l) return null;
            a ||= l.type, i.push([
                r,
                l
            ]);
        }
        return new e(a, r, i, n.key);
    }
    evaluate(e) {
        let t = this.labels, n = this.outputs;
        if (t.length === 1) return n[0].evaluate(e);
        let r = this.input.evaluate(e);
        if (r <= t[0]) return n[0].evaluate(e);
        let i = t.length;
        return r >= t[i - 1] ? n[i - 1].evaluate(e) : n[Si(t, r, this.key)].evaluate(e);
    }
    eachChild(e) {
        e(this.input);
        for (let t of this.outputs)e(t);
    }
    outputDefined() {
        return this.outputs.every((e)=>e.outputDefined());
    }
};
function wi(e, t, n, r) {
    let i = 3 * e, a = 3 * (n - e) - i, o = 1 - i - a, s = 3 * t, c = 3 * (r - t) - s, l = 1 - s - c;
    return function(e, t = 1e-6) {
        if (e <= 0) return 0;
        if (e >= 1) return 1;
        let n = e;
        for(let r = 0; r < 8; r++){
            let r = ((o * n + a) * n + i) * n - e;
            if (Math.abs(r) < t) return ((l * n + c) * n + s) * n;
            let u = (3 * o * n + 2 * a) * n + i;
            if (Math.abs(u) < 1e-6) break;
            n -= r / u;
        }
        let r = 0, u = 1;
        n = e;
        for(let s = 0; s < 20; s++){
            let s = ((o * n + a) * n + i) * n;
            if (Math.abs(s - e) < t) break;
            e > s ? r = n : u = n, n = (r + u) * .5;
        }
        return ((l * n + c) * n + s) * n;
    };
}
var Ti = class e {
    constructor(e, t, n, r, i, a){
        this.type = e, this.operator = t, this.interpolation = n, this.input = r, this.key = a, this.labels = [], this.outputs = [];
        for (let [e, t] of i)this.labels.push(e), this.outputs.push(t);
    }
    static interpolationFactor(e, t, n, r) {
        let i = 0;
        if (e.name === `exponential`) i = Ei(t, e.base, n, r);
        else if (e.name === `linear`) i = Ei(t, 1, n, r);
        else if (e.name === `cubic-bezier`) {
            let a = e.controlPoints;
            i = wi(a[0], a[1], a[2], a[3])(Ei(t, 1, n, r));
        }
        return i;
    }
    static parse(t, n) {
        let [r, i, a, ...o] = t;
        if (!Array.isArray(i) || i.length === 0) return n.error(`Expected an interpolation type expression.`, 1);
        if (i[0] === `linear`) i = {
            name: `linear`
        };
        else if (i[0] === `exponential`) {
            let e = i[1];
            if (typeof e != `number`) return n.error(`Exponential interpolation requires a numeric base.`, 1, 1);
            i = {
                name: `exponential`,
                base: e
            };
        } else if (i[0] === `cubic-bezier`) {
            let e = i.slice(1);
            if (e.length !== 4 || e.some((e)=>typeof e != `number` || e < 0 || e > 1)) return n.error(`Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.`, 1);
            i = {
                name: `cubic-bezier`,
                controlPoints: e
            };
        } else return n.error(`Unknown interpolation type ${String(i[0])}`, 1, 0);
        if (t.length - 1 < 4) return n.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
        if ((t.length - 1) % 2 != 0) return n.error(`Expected an even number of arguments.`);
        if (a = n.parse(a, 2, P), !a) return null;
        let s = [], c = null;
        (r === `interpolate-hcl` || r === `interpolate-lab`) && n.expectedType != sr ? c = er : n.expectedType && n.expectedType.kind !== `value` && (c = n.expectedType);
        for(let e = 0; e < o.length; e += 2){
            let t = o[e], r = o[e + 1], i = e + 3, a = e + 4;
            if (typeof t != `number`) return n.error(`Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.`, i);
            if (s.length && s[s.length - 1][0] >= t) return n.error(`Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.`, i);
            let l = n.parse(r, a, c);
            if (!l) return null;
            c ||= l.type, s.push([
                t,
                l
            ]);
        }
        return !gr(c, P) && !gr(c, tr) && !gr(c, er) && !gr(c, or) && !gr(c, cr) && !gr(c, sr) && !gr(c, ur) && !gr(c, dr(P)) ? n.error(`Type ${R(c)} is not interpolatable.`) : new e(c, r, i, a, s, n.key);
    }
    evaluate(t) {
        let n = this.labels, r = this.outputs;
        if (n.length === 1) return r[0].evaluate(t);
        let i = this.input.evaluate(t);
        if (i <= n[0]) return r[0].evaluate(t);
        let a = n.length;
        if (i >= n[a - 1]) return r[a - 1].evaluate(t);
        let o = Si(n, i, this.key), s = n[o], c = n[o + 1], l = e.interpolationFactor(this.interpolation, i, s, c), u = r[o].evaluate(t), d = r[o + 1].evaluate(t);
        switch(this.operator){
            case `interpolate`:
                switch(this.type.kind){
                    case `number`:
                        return Hr(u, d, l);
                    case `color`:
                        return z.interpolate(u, d, l);
                    case `padding`:
                        return Yr.interpolate(u, d, l);
                    case `colorArray`:
                        return Zr.interpolate(u, d, l);
                    case `numberArray`:
                        return Xr.interpolate(u, d, l);
                    case `variableAnchorOffsetCollection`:
                        return $r.interpolate(u, d, l, this.key);
                    case `array`:
                        return Ur(u, d, l);
                    case `projectionDefinition`:
                        return ti.interpolate(u, d, l);
                }
            case `interpolate-hcl`:
                switch(this.type.kind){
                    case `color`:
                        return z.interpolate(u, d, l, `hcl`);
                    case `colorArray`:
                        return Zr.interpolate(u, d, l, `hcl`);
                }
            case `interpolate-lab`:
                switch(this.type.kind){
                    case `color`:
                        return z.interpolate(u, d, l, `lab`);
                    case `colorArray`:
                        return Zr.interpolate(u, d, l, `lab`);
                }
        }
    }
    eachChild(e) {
        e(this.input);
        for (let t of this.outputs)e(t);
    }
    outputDefined() {
        return this.outputs.every((e)=>e.outputDefined());
    }
};
function Ei(e, t, n, r) {
    let i = r - n, a = e - n;
    return i === 0 ? 0 : t === 1 ? a / i : (t ** +a - 1) / (t ** +i - 1);
}
const Di = {
    color: z.interpolate,
    number: Hr,
    padding: Yr.interpolate,
    numberArray: Xr.interpolate,
    colorArray: Zr.interpolate,
    variableAnchorOffsetCollection: $r.interpolate,
    array: Ur
};
var Oi = class e {
    constructor(e, t){
        this.type = e, this.args = t;
    }
    static parse(t, n) {
        if (t.length < 2) return n.error(`Expected at least one argument.`);
        let r = null, i = n.expectedType;
        i && i.kind !== `value` && (r = i);
        let a = [];
        for (let e of t.slice(1)){
            let t = n.parse(e, 1 + a.length, r, void 0, {
                typeAnnotation: `omit`
            });
            if (!t) return null;
            r ||= t.type, a.push(t);
        }
        if (!r) throw Error(`No output type`);
        return i && a.some((e)=>pr(i, e.type)) ? new e(L, a) : new e(r, a);
    }
    evaluate(e) {
        let t = null, n = 0, r;
        for (let i of this.args)if (n++, t = i.evaluate(e), t && t instanceof ei && !t.available && (r ||= t.name, t = null, n === this.args.length && (t = r)), t !== null) break;
        return t;
    }
    eachChild(e) {
        this.args.forEach(e);
    }
    outputDefined() {
        return this.args.every((e)=>e.outputDefined());
    }
};
function ki(e, t) {
    return e === `==` || e === `!=` ? t.kind === `boolean` || t.kind === `string` || t.kind === `number` || t.kind === `null` || t.kind === `value` : t.kind === `string` || t.kind === `number` || t.kind === `value`;
}
function Ai(e, t, n) {
    return t === n;
}
function ji(e, t, n) {
    return t !== n;
}
function Mi(e, t, n) {
    return t < n;
}
function Ni(e, t, n) {
    return t > n;
}
function Pi(e, t, n) {
    return t <= n;
}
function Fi(e, t, n) {
    return t >= n;
}
function Ii(e, t, n, r) {
    return r.compare(t, n) === 0;
}
function Li(e, t, n, r) {
    return !Ii(e, t, n, r);
}
function Ri(e, t, n, r) {
    return r.compare(t, n) < 0;
}
function zi(e, t, n, r) {
    return r.compare(t, n) > 0;
}
function Bi(e, t, n, r) {
    return r.compare(t, n) <= 0;
}
function Vi(e, t, n, r) {
    return r.compare(t, n) >= 0;
}
function Hi(e, t, n) {
    let r = e !== `==` && e !== `!=`;
    return class i {
        constructor(e, t, n, r){
            this.lhs = e, this.rhs = t, this.key = n, this.collator = r, this.type = I, this.hasUntypedArgument = e.type.kind === `value` || t.type.kind === `value`;
        }
        static parse(e, t) {
            if (e.length !== 3 && e.length !== 4) return t.error(`Expected two or three arguments.`);
            let n = e[0], a = t.parse(e[1], 1, L);
            if (!a) return null;
            if (!ki(n, a.type)) return t.concat(1).error(`"${n}" comparisons are not supported for type '${R(a.type)}'.`);
            let o = t.parse(e[2], 2, L);
            if (!o) return null;
            if (!ki(n, o.type)) return t.concat(2).error(`"${n}" comparisons are not supported for type '${R(o.type)}'.`);
            if (a.type.kind !== o.type.kind && a.type.kind !== `value` && o.type.kind !== `value`) return t.error(`Cannot compare types '${R(a.type)}' and '${R(o.type)}'.`);
            r && (a.type.kind === `value` && o.type.kind !== `value` ? a = new ci(o.type, [
                a
            ], t.key) : a.type.kind !== `value` && o.type.kind === `value` && (o = new ci(a.type, [
                o
            ], t.key)));
            let s = null;
            if (e.length === 4) {
                if (a.type.kind !== `string` && o.type.kind !== `string` && a.type.kind !== `value` && o.type.kind !== `value`) return t.error(`Cannot use collator to compare non-string types.`);
                if (s = t.parse(e[3], 3, ir), !s) return null;
            }
            return new i(a, o, t.key, s);
        }
        evaluate(i) {
            let a = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
            if (r && this.hasUntypedArgument) {
                let t = ii(a), n = ii(o);
                if (t.kind !== n.kind || t.kind !== `string` && t.kind !== `number`) throw new B(`Expected arguments for "${e}" to be (string, string) or (number, number), but found (${t.kind}, ${n.kind}) instead.`, this.key);
            }
            if (this.collator && !r && this.hasUntypedArgument) {
                let e = ii(a), n = ii(o);
                if (e.kind !== `string` || n.kind !== `string`) return t(i, a, o);
            }
            return this.collator ? n(i, a, o, this.collator.evaluate(i)) : t(i, a, o);
        }
        eachChild(e) {
            e(this.lhs), e(this.rhs), this.collator && e(this.collator);
        }
        outputDefined() {
            return !0;
        }
    };
}
const Ui = Hi(`==`, Ai, Ii), Wi = Hi(`!=`, ji, Li), Gi = Hi(`<`, Mi, Ri), Ki = Hi(`>`, Ni, zi), qi = Hi(`<=`, Pi, Bi), Ji = Hi(`>=`, Fi, Vi);
var Yi = class e {
    constructor(e, t, n){
        this.type = ir, this.locale = n, this.caseSensitive = e, this.diacriticSensitive = t;
    }
    static parse(t, n) {
        if (t.length !== 2) return n.error(`Expected one argument.`);
        let r = t[1];
        if (typeof r != `object` || Array.isArray(r)) return n.error(`Collator options argument must be an object.`);
        let i = n.parse(r[`case-sensitive`] !== void 0 && r[`case-sensitive`], 1, I);
        if (!i) return null;
        let a = n.parse(r[`diacritic-sensitive`] !== void 0 && r[`diacritic-sensitive`], 1, I);
        if (!a) return null;
        let o = null;
        return r.locale && (o = n.parse(r.locale, 1, F), !o) ? null : new e(i, a, o);
    }
    evaluate(e) {
        return new Gr(this.caseSensitive.evaluate(e), this.diacriticSensitive.evaluate(e), this.locale ? this.locale.evaluate(e) : null);
    }
    eachChild(e) {
        e(this.caseSensitive), e(this.diacriticSensitive), this.locale && e(this.locale);
    }
    outputDefined() {
        return !1;
    }
}, Xi = class e {
    constructor(e, t, n, r, i, a){
        this.type = F, this.number = e, this.locale = t, this.currency = n, this.unit = r, this.minFractionDigits = i, this.maxFractionDigits = a;
    }
    static parse(t, n) {
        if (t.length !== 3) return n.error(`Expected two arguments.`);
        let r = n.parse(t[1], 1, P);
        if (!r) return null;
        let i = t[2];
        if (typeof i != `object` || Array.isArray(i)) return n.error(`NumberFormat options argument must be an object.`);
        let a = null;
        if (i.locale && (a = n.parse(i.locale, 1, F), !a)) return null;
        let o = null;
        if (i.currency && (o = n.parse(i.currency, 1, F), !o)) return null;
        let s = null;
        if (i.unit && (s = n.parse(i.unit, 1, F), !s)) return null;
        if (o && s) return n.error("NumberFormat options `currency` and `unit` are mutually exclusive");
        let c = null;
        if (i[`min-fraction-digits`] && (c = n.parse(i[`min-fraction-digits`], 1, P), !c)) return null;
        let l = null;
        return i[`max-fraction-digits`] && (l = n.parse(i[`max-fraction-digits`], 1, P), !l) ? null : new e(r, a, o, s, c, l);
    }
    evaluate(e) {
        return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e) : [], {
            style: this.currency ? `currency` : this.unit ? `unit` : `decimal`,
            currency: this.currency ? this.currency.evaluate(e) : void 0,
            unit: this.unit ? this.unit.evaluate(e) : void 0,
            minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e) : void 0,
            maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e) : void 0
        }).format(this.number.evaluate(e));
    }
    eachChild(e) {
        e(this.number), this.locale && e(this.locale), this.currency && e(this.currency), this.unit && e(this.unit), this.minFractionDigits && e(this.minFractionDigits), this.maxFractionDigits && e(this.maxFractionDigits);
    }
    outputDefined() {
        return !1;
    }
}, Zi = class e {
    constructor(e){
        this.type = ar, this.sections = e;
    }
    static parse(t, n) {
        if (t.length < 2) return n.error(`Expected at least one argument.`);
        let r = t[1];
        if (!Array.isArray(r) && typeof r == `object`) return n.error(`First argument must be an image or text section.`);
        let i = [], a = !1;
        for(let e = 1; e <= t.length - 1; ++e){
            let r = t[e];
            if (a && typeof r == `object` && !Array.isArray(r)) {
                a = !1;
                let e = null;
                if (r[`font-scale`] && (e = n.parse(r[`font-scale`], 1, P), !e)) return null;
                let t = null;
                if (r[`text-font`] && (t = n.parse(r[`text-font`], 1, dr(F)), !t)) return null;
                let o = null;
                if (r[`text-color`] && (o = n.parse(r[`text-color`], 1, er), !o)) return null;
                let s = null;
                if (r[`vertical-align`]) {
                    if (typeof r[`vertical-align`] == `string` && !Kr.includes(r[`vertical-align`])) return n.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${r[`vertical-align`]}' instead.`);
                    if (s = n.parse(r[`vertical-align`], 1, F), !s) return null;
                }
                let c = i[i.length - 1];
                c.scale = e, c.font = t, c.textColor = o, c.verticalAlign = s;
            } else {
                let r = n.parse(t[e], 1, L);
                if (!r) return null;
                let o = r.type.kind;
                if (o !== `string` && o !== `value` && o !== `null` && o !== `resolvedImage`) return n.error(`Formatted text type must be 'string', 'value', 'image' or 'null'.`);
                a = !0, i.push({
                    content: r,
                    scale: null,
                    font: null,
                    textColor: null,
                    verticalAlign: null
                });
            }
        }
        return new e(i);
    }
    evaluate(e) {
        return new Jr(this.sections.map((t)=>{
            let n = t.content.evaluate(e);
            return ii(n) === lr ? new qr(``, n, null, null, null, t.verticalAlign ? t.verticalAlign.evaluate(e) : null) : new qr(ai(n), null, t.scale ? t.scale.evaluate(e) : null, t.font ? t.font.evaluate(e).join(`,`) : null, t.textColor ? t.textColor.evaluate(e) : null, t.verticalAlign ? t.verticalAlign.evaluate(e) : null);
        }));
    }
    eachChild(e) {
        for (let t of this.sections)e(t.content), t.scale && e(t.scale), t.font && e(t.font), t.textColor && e(t.textColor), t.verticalAlign && e(t.verticalAlign);
    }
    outputDefined() {
        return !1;
    }
}, Qi = class e {
    constructor(e){
        this.type = lr, this.input = e;
    }
    static parse(t, n) {
        if (t.length !== 2) return n.error(`Expected two arguments.`);
        let r = n.parse(t[1], 1, F);
        return r ? new e(r) : n.error(`No image name provided.`);
    }
    evaluate(e) {
        let t = this.input.evaluate(e), n = ei.fromString(t);
        return n && e.availableImages && (n.available = e.availableImages.indexOf(t) > -1), n;
    }
    eachChild(e) {
        e(this.input);
    }
    outputDefined() {
        return !1;
    }
}, $i = class e {
    constructor(e, t){
        this.input = e, this.key = t, this.type = P;
    }
    static parse(t, n) {
        if (t.length !== 2) return n.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
        let r = n.parse(t[1], 1);
        return r ? r.type.kind !== `array` && r.type.kind !== `string` && r.type.kind !== `value` ? n.error(`Expected argument of type string or array, but found ${R(r.type)} instead.`) : new e(r, n.key) : null;
    }
    evaluate(e) {
        let t = this.input.evaluate(e);
        if (typeof t == `string`) return [
            ...t
        ].length;
        if (Array.isArray(t)) return t.length;
        throw new B(`Expected value to be of type string or array, but found ${R(ii(t))} instead.`, this.key);
    }
    eachChild(e) {
        e(this.input);
    }
    outputDefined() {
        return !1;
    }
};
const ea = 8192;
function ta(e, t) {
    let n = ra(e[0]), r = aa(e[1]), i = 2 ** t.z;
    return [
        Math.round(n * i * ea),
        Math.round(r * i * ea)
    ];
}
function na(e, t) {
    let n = 2 ** t.z, r = (e[0] / ea + t.x) / n, i = (e[1] / ea + t.y) / n;
    return [
        ia(r),
        oa(i)
    ];
}
function ra(e) {
    return (180 + e) / 360;
}
function ia(e) {
    return e * 360 - 180;
}
function aa(e) {
    return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e * Math.PI / 360))) / 360;
}
function oa(e) {
    return 360 / Math.PI * Math.atan(Math.exp((180 - e * 360) * Math.PI / 180)) - 90;
}
function sa(e, t) {
    e[0] = Math.min(e[0], t[0]), e[1] = Math.min(e[1], t[1]), e[2] = Math.max(e[2], t[0]), e[3] = Math.max(e[3], t[1]);
}
function ca(e, t) {
    return !(e[0] <= t[0] || e[2] >= t[2] || e[1] <= t[1] || e[3] >= t[3]);
}
function la(e, t, n) {
    return t[1] > e[1] != n[1] > e[1] && e[0] < (n[0] - t[0]) * (e[1] - t[1]) / (n[1] - t[1]) + t[0];
}
function ua(e, t, n) {
    let r = e[0] - t[0], i = e[1] - t[1], a = e[0] - n[0], o = e[1] - n[1];
    return r * o - a * i === 0 && r * a <= 0 && i * o <= 0;
}
function da(e, t, n, r) {
    let i = [
        t[0] - e[0],
        t[1] - e[1]
    ];
    return _a([
        r[0] - n[0],
        r[1] - n[1]
    ], i) !== 0 && !!(va(e, t, n, r) && va(n, r, e, t));
}
function fa(e, t, n) {
    for (let r of n)for(let n = 0; n < r.length - 1; ++n)if (da(e, t, r[n], r[n + 1])) return !0;
    return !1;
}
function pa(e, t, n = !1) {
    let r = !1;
    for (let i of t)for(let t = 0; t < i.length - 1; t++){
        if (ua(e, i[t], i[t + 1])) return n;
        la(e, i[t], i[t + 1]) && (r = !r);
    }
    return r;
}
function ma(e, t) {
    for (let n of t)if (pa(e, n)) return !0;
    return !1;
}
function ha(e, t) {
    for (let n of e)if (!pa(n, t)) return !1;
    for(let n = 0; n < e.length - 1; ++n)if (fa(e[n], e[n + 1], t)) return !1;
    return !0;
}
function ga(e, t) {
    for (let n of t)if (ha(e, n)) return !0;
    return !1;
}
function _a(e, t) {
    return e[0] * t[1] - e[1] * t[0];
}
function va(e, t, n, r) {
    let i = e[0] - n[0], a = e[1] - n[1], o = t[0] - n[0], s = t[1] - n[1], c = r[0] - n[0], l = r[1] - n[1], u = i * l - c * a, d = o * l - c * s;
    return u > 0 && d < 0 || u < 0 && d > 0;
}
function ya(e, t, n) {
    let r = [];
    for(let i = 0; i < e.length; i++){
        let a = [];
        for(let r = 0; r < e[i].length; r++){
            let o = ta(e[i][r], n);
            sa(t, o), a.push(o);
        }
        r.push(a);
    }
    return r;
}
function ba(e, t, n) {
    let r = [];
    for(let i = 0; i < e.length; i++){
        let a = ya(e[i], t, n);
        r.push(a);
    }
    return r;
}
function xa(e, t, n, r) {
    if (e[0] < n[0] || e[0] > n[2]) {
        let t = r * .5, i = e[0] - n[0] > t ? -r : n[0] - e[0] > t ? r : 0;
        i === 0 && (i = e[0] - n[2] > t ? -r : n[2] - e[0] > t ? r : 0), e[0] += i;
    }
    sa(t, e);
}
function Sa(e) {
    e[0] = e[1] = 1 / 0, e[2] = e[3] = -1 / 0;
}
function Ca(e, t, n, r) {
    let i = 2 ** r.z * ea, a = [
        r.x * ea,
        r.y * ea
    ], o = [];
    for (let r of e)for (let e of r){
        let r = [
            e.x + a[0],
            e.y + a[1]
        ];
        xa(r, t, n, i), o.push(r);
    }
    return o;
}
function wa(e, t, n, r) {
    let i = 2 ** r.z * ea, a = [
        r.x * ea,
        r.y * ea
    ], o = [];
    for (let n of e){
        let e = [];
        for (let r of n){
            let n = [
                r.x + a[0],
                r.y + a[1]
            ];
            sa(t, n), e.push(n);
        }
        o.push(e);
    }
    if (t[2] - t[0] <= i / 2) {
        Sa(t);
        for (let e of o)for (let r of e)xa(r, t, n, i);
    }
    return o;
}
function Ta(e, t) {
    let n = [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ], r = [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ], i = e.canonicalID();
    if (t.type === `Polygon`) {
        let a = ya(t.coordinates, r, i), o = Ca(e.geometry(), n, r, i);
        if (!ca(n, r)) return !1;
        for (let e of o)if (!pa(e, a)) return !1;
    }
    if (t.type === `MultiPolygon`) {
        let a = ba(t.coordinates, r, i), o = Ca(e.geometry(), n, r, i);
        if (!ca(n, r)) return !1;
        for (let e of o)if (!ma(e, a)) return !1;
    }
    return !0;
}
function Ea(e, t) {
    let n = [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ], r = [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ], i = e.canonicalID();
    if (t.type === `Polygon`) {
        let a = ya(t.coordinates, r, i), o = wa(e.geometry(), n, r, i);
        if (!ca(n, r)) return !1;
        for (let e of o)if (!ha(e, a)) return !1;
    }
    if (t.type === `MultiPolygon`) {
        let a = ba(t.coordinates, r, i), o = wa(e.geometry(), n, r, i);
        if (!ca(n, r)) return !1;
        for (let e of o)if (!ga(e, a)) return !1;
    }
    return !0;
}
var Da = class e {
    constructor(e, t){
        this.type = I, this.geojson = e, this.geometries = t;
    }
    static parse(t, n) {
        if (t.length !== 2) return n.error(`'within' expression requires exactly one argument, but found ${t.length - 1} instead.`);
        if (ri(t[1])) {
            let n = t[1];
            if (n.type === `FeatureCollection`) {
                let t = [];
                for (let e of n.features){
                    let { type: n, coordinates: r } = e.geometry;
                    n === `Polygon` && t.push(r), n === `MultiPolygon` && t.push(...r);
                }
                if (t.length) return new e(n, {
                    type: `MultiPolygon`,
                    coordinates: t
                });
            } else if (n.type === `Feature`) {
                let t = n.geometry.type;
                if (t === `Polygon` || t === `MultiPolygon`) return new e(n, n.geometry);
            } else if (n.type === `Polygon` || n.type === `MultiPolygon`) return new e(n, n);
        }
        return n.error(`'within' expression requires valid geojson object that contains polygon geometry type.`);
    }
    evaluate(e) {
        if (e.geometry() != null && e.canonicalID() != null) {
            if (e.geometryType() === `Point`) return Ta(e, this.geometries);
            if (e.geometryType() === `LineString`) return Ea(e, this.geometries);
        }
        return !1;
    }
    eachChild() {}
    outputDefined() {
        return !0;
    }
}, Oa = class {
    constructor(e = [], t = (e, t)=>e < t ? -1 : +(e > t)){
        if (this.data = e, this.length = this.data.length, this.compare = t, this.length > 0) for(let e = (this.length >> 1) - 1; e >= 0; e--)this._down(e);
    }
    push(e) {
        this.data.push(e), this._up(this.length++);
    }
    pop() {
        if (this.length === 0) return;
        let e = this.data[0], t = this.data.pop();
        return --this.length > 0 && (this.data[0] = t, this._down(0)), e;
    }
    peek() {
        return this.data[0];
    }
    _up(e) {
        let { data: t, compare: n } = this, r = t[e];
        for(; e > 0;){
            let i = e - 1 >> 1, a = t[i];
            if (n(r, a) >= 0) break;
            t[e] = a, e = i;
        }
        t[e] = r;
    }
    _down(e) {
        let { data: t, compare: n } = this, r = this.length >> 1, i = t[e];
        for(; e < r;){
            let r = (e << 1) + 1, a = r + 1;
            if (a < this.length && n(t[a], t[r]) < 0 && (r = a), n(t[r], i) >= 0) break;
            t[e] = t[r], e = r;
        }
        t[e] = i;
    }
};
function ka(e, t, n = 0, r = e.length - 1, i = ja) {
    for(; r > n;){
        if (r - n > 600) {
            let a = r - n + 1, o = t - n + 1, s = Math.log(a), c = .5 * Math.exp(2 * s / 3), l = .5 * Math.sqrt(s * c * (a - c) / a) * (o - a / 2 < 0 ? -1 : 1);
            ka(e, t, Math.max(n, Math.floor(t - o * c / a + l)), Math.min(r, Math.floor(t + (a - o) * c / a + l)), i);
        }
        let a = e[t], o = n, s = r;
        for(Aa(e, n, t), i(e[r], a) > 0 && Aa(e, n, r); o < s;){
            for(Aa(e, o, s), o++, s--; i(e[o], a) < 0;)o++;
            for(; i(e[s], a) > 0;)s--;
        }
        i(e[n], a) === 0 ? Aa(e, n, s) : (s++, Aa(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
    }
}
function Aa(e, t, n) {
    let r = e[t];
    e[t] = e[n], e[n] = r;
}
function ja(e, t) {
    return e < t ? -1 : +(e > t);
}
function Ma(e, t) {
    if (e.length <= 1) return [
        e
    ];
    let n = [], r, i;
    for (let t of e){
        let e = Pa(t);
        e !== 0 && (t.area = Math.abs(e), i === void 0 && (i = e < 0), i === e < 0 ? (r && n.push(r), r = [
            t
        ]) : r.push(t));
    }
    if (r && n.push(r), t > 1) for(let e = 0; e < n.length; e++)n[e].length <= t || (ka(n[e], t, 1, n[e].length - 1, Na), n[e] = n[e].slice(0, t));
    return n;
}
function Na(e, t) {
    return t.area - e.area;
}
function Pa(e) {
    let t = 0;
    for(let n = 0, r = e.length, i = r - 1, a, o; n < r; i = n++)a = e[n], o = e[i], t += (o.x - a.x) * (a.y + o.y);
    return t;
}
const Fa = 1 / 298.257223563, Ia = Fa * (2 - Fa), La = Math.PI / 180;
var Ra = class {
    constructor(e){
        let t = La * 6378137, n = Math.cos(e * La), r = 1 / (1 - Ia * (1 - n * n)), i = Math.sqrt(r);
        this.kx = t * i * n, this.ky = t * i * r * (1 - Ia);
    }
    distance(e, t) {
        let n = this.wrap(e[0] - t[0]) * this.kx, r = (e[1] - t[1]) * this.ky;
        return Math.sqrt(n * n + r * r);
    }
    pointOnLine(e, t) {
        let n = 1 / 0, r, i, a, o;
        for(let s = 0; s < e.length - 1; s++){
            let c = e[s][0], l = e[s][1], u = this.wrap(e[s + 1][0] - c) * this.kx, d = (e[s + 1][1] - l) * this.ky, f = 0;
            (u !== 0 || d !== 0) && (f = (this.wrap(t[0] - c) * this.kx * u + (t[1] - l) * this.ky * d) / (u * u + d * d), f > 1 ? (c = e[s + 1][0], l = e[s + 1][1]) : f > 0 && (c += u / this.kx * f, l += d / this.ky * f)), u = this.wrap(t[0] - c) * this.kx, d = (t[1] - l) * this.ky;
            let p = u * u + d * d;
            p < n && (n = p, r = c, i = l, a = s, o = f);
        }
        return {
            point: [
                r,
                i
            ],
            index: a,
            t: Math.max(0, Math.min(1, o))
        };
    }
    wrap(e) {
        for(; e < -180;)e += 360;
        for(; e > 180;)e -= 360;
        return e;
    }
};
function za(e, t) {
    return t[0] - e[0];
}
function Ba(e) {
    return e[1] - e[0] + 1;
}
function Va(e, t) {
    return e[1] >= e[0] && e[1] < t;
}
function Ha(e, t) {
    if (e[0] > e[1]) return [
        null,
        null
    ];
    let n = Ba(e);
    if (t) {
        if (n === 2) return [
            e,
            null
        ];
        let t = Math.floor(n / 2);
        return [
            [
                e[0],
                e[0] + t
            ],
            [
                e[0] + t,
                e[1]
            ]
        ];
    }
    if (n === 1) return [
        e,
        null
    ];
    let r = Math.floor(n / 2) - 1;
    return [
        [
            e[0],
            e[0] + r
        ],
        [
            e[0] + r + 1,
            e[1]
        ]
    ];
}
function Ua(e, t) {
    if (!Va(t, e.length)) return [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ];
    let n = [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ];
    for(let r = t[0]; r <= t[1]; ++r)sa(n, e[r]);
    return n;
}
function Wa(e) {
    let t = [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ];
    for (let n of e)for (let e of n)sa(t, e);
    return t;
}
function Ga(e) {
    return e[0] !== -1 / 0 && e[1] !== -1 / 0 && e[2] !== 1 / 0 && e[3] !== 1 / 0;
}
function Ka(e, t, n) {
    if (!Ga(e) || !Ga(t)) return NaN;
    let r = 0, i = 0;
    return e[2] < t[0] && (r = t[0] - e[2]), e[0] > t[2] && (r = e[0] - t[2]), e[1] > t[3] && (i = e[1] - t[3]), e[3] < t[1] && (i = t[1] - e[3]), n.distance([
        0,
        0
    ], [
        r,
        i
    ]);
}
function qa(e, t, n) {
    let r = n.pointOnLine(t, e);
    return n.distance(e, r.point);
}
function Ja(e, t, n, r, i) {
    let a = Math.min(qa(e, [
        n,
        r
    ], i), qa(t, [
        n,
        r
    ], i)), o = Math.min(qa(n, [
        e,
        t
    ], i), qa(r, [
        e,
        t
    ], i));
    return Math.min(a, o);
}
function Ya(e, t, n, r, i) {
    if (!(Va(t, e.length) && Va(r, n.length))) return 1 / 0;
    let a = 1 / 0;
    for(let o = t[0]; o < t[1]; ++o){
        let t = e[o], s = e[o + 1];
        for(let e = r[0]; e < r[1]; ++e){
            let r = n[e], o = n[e + 1];
            if (da(t, s, r, o)) return 0;
            a = Math.min(a, Ja(t, s, r, o, i));
        }
    }
    return a;
}
function Xa(e, t, n, r, i) {
    if (!(Va(t, e.length) && Va(r, n.length))) return NaN;
    let a = 1 / 0;
    for(let o = t[0]; o <= t[1]; ++o)for(let t = r[0]; t <= r[1]; ++t)if (a = Math.min(a, i.distance(e[o], n[t])), a === 0) return a;
    return a;
}
function Za(e, t, n) {
    if (pa(e, t, !0)) return 0;
    let r = 1 / 0;
    for (let i of t){
        let t = i[0], a = i[i.length - 1];
        if (t !== a && (r = Math.min(r, qa(e, [
            a,
            t
        ], n)), r === 0)) return r;
        let o = n.pointOnLine(i, e);
        if (r = Math.min(r, n.distance(e, o.point)), r === 0) return r;
    }
    return r;
}
function Qa(e, t, n, r) {
    if (!Va(t, e.length)) return NaN;
    for(let r = t[0]; r <= t[1]; ++r)if (pa(e[r], n, !0)) return 0;
    let i = 1 / 0;
    for(let a = t[0]; a < t[1]; ++a){
        let t = e[a], o = e[a + 1];
        for (let e of n)for(let n = 0, a = e.length, s = a - 1; n < a; s = n++){
            let a = e[s], c = e[n];
            if (da(t, o, a, c)) return 0;
            i = Math.min(i, Ja(t, o, a, c, r));
        }
    }
    return i;
}
function $a(e, t) {
    for (let n of e)for (let e of n)if (pa(e, t, !0)) return !0;
    return !1;
}
function eo(e, t, n, r = 1 / 0) {
    let i = Wa(e), a = Wa(t);
    if (r !== 1 / 0 && Ka(i, a, n) >= r) return r;
    if (ca(i, a)) {
        if ($a(e, t)) return 0;
    } else if ($a(t, e)) return 0;
    let o = 1 / 0;
    for (let r of e)for(let e = 0, i = r.length, a = i - 1; e < i; a = e++){
        let i = r[a], s = r[e];
        for (let e of t)for(let t = 0, r = e.length, a = r - 1; t < r; a = t++){
            let r = e[a], c = e[t];
            if (da(i, s, r, c)) return 0;
            o = Math.min(o, Ja(i, s, r, c, n));
        }
    }
    return o;
}
function to(e, t, n, r, i, a) {
    if (!a) return;
    let o = Ka(Ua(r, a), i, n);
    o < t && e.push([
        o,
        a,
        [
            0,
            0
        ]
    ]);
}
function no(e, t, n, r, i, a, o) {
    if (!a || !o) return;
    let s = Ka(Ua(r, a), Ua(i, o), n);
    s < t && e.push([
        s,
        a,
        o
    ]);
}
function ro(e, t, n, r, i = 1 / 0) {
    let a = Math.min(r.distance(e[0], n[0][0]), i);
    if (a === 0) return a;
    let o = new Oa([
        [
            0,
            [
                0,
                e.length - 1
            ],
            [
                0,
                0
            ]
        ]
    ], za), s = Wa(n);
    for(; o.length > 0;){
        let i = o.pop();
        if (i[0] >= a) continue;
        let c = i[1], l = t ? 50 : 100;
        if (Ba(c) <= l) {
            if (!Va(c, e.length)) return NaN;
            if (t) {
                let t = Qa(e, c, n, r);
                if (isNaN(t) || t === 0) return t;
                a = Math.min(a, t);
            } else for(let t = c[0]; t <= c[1]; ++t){
                let i = Za(e[t], n, r);
                if (a = Math.min(a, i), a === 0) return 0;
            }
        } else {
            let n = Ha(c, t);
            to(o, a, r, e, s, n[0]), to(o, a, r, e, s, n[1]);
        }
    }
    return a;
}
function io(e, t, n, r, i, a = 1 / 0) {
    let o = Math.min(a, i.distance(e[0], n[0]));
    if (o === 0) return o;
    let s = new Oa([
        [
            0,
            [
                0,
                e.length - 1
            ],
            [
                0,
                n.length - 1
            ]
        ]
    ], za);
    for(; s.length > 0;){
        let a = s.pop();
        if (a[0] >= o) continue;
        let c = a[1], l = a[2], u = t ? 50 : 100, d = r ? 50 : 100;
        if (Ba(c) <= u && Ba(l) <= d) {
            if (!Va(c, e.length) && Va(l, n.length)) return NaN;
            let a;
            if (t && r) a = Ya(e, c, n, l, i), o = Math.min(o, a);
            else if (t && !r) {
                let t = e.slice(c[0], c[1] + 1);
                for(let e = l[0]; e <= l[1]; ++e)if (a = qa(n[e], t, i), o = Math.min(o, a), o === 0) return o;
            } else if (!t && r) {
                let t = n.slice(l[0], l[1] + 1);
                for(let n = c[0]; n <= c[1]; ++n)if (a = qa(e[n], t, i), o = Math.min(o, a), o === 0) return o;
            } else a = Xa(e, c, n, l, i), o = Math.min(o, a);
        } else {
            let a = Ha(c, t), u = Ha(l, r);
            no(s, o, i, e, n, a[0], u[0]), no(s, o, i, e, n, a[0], u[1]), no(s, o, i, e, n, a[1], u[0]), no(s, o, i, e, n, a[1], u[1]);
        }
    }
    return o;
}
function ao(e, t) {
    let n = e.geometry(), r = n.flat().map((t)=>na([
            t.x,
            t.y
        ], e.canonical));
    if (n.length === 0) return NaN;
    let i = new Ra(r[0][1]), a = 1 / 0;
    for (let e of t){
        switch(e.type){
            case `Point`:
                a = Math.min(a, io(r, !1, [
                    e.coordinates
                ], !1, i, a));
                break;
            case `LineString`:
                a = Math.min(a, io(r, !1, e.coordinates, !0, i, a));
                break;
            case `Polygon`:
                a = Math.min(a, ro(r, !1, e.coordinates, i, a));
                break;
        }
        if (a === 0) return a;
    }
    return a;
}
function oo(e, t) {
    let n = e.geometry(), r = n.flat().map((t)=>na([
            t.x,
            t.y
        ], e.canonical));
    if (n.length === 0) return NaN;
    let i = new Ra(r[0][1]), a = 1 / 0;
    for (let e of t){
        switch(e.type){
            case `Point`:
                a = Math.min(a, io(r, !0, [
                    e.coordinates
                ], !1, i, a));
                break;
            case `LineString`:
                a = Math.min(a, io(r, !0, e.coordinates, !0, i, a));
                break;
            case `Polygon`:
                a = Math.min(a, ro(r, !0, e.coordinates, i, a));
                break;
        }
        if (a === 0) return a;
    }
    return a;
}
function so(e, t) {
    let n = e.geometry();
    if (n.length === 0 || n[0].length === 0) return NaN;
    let r = Ma(n, 0).map((t)=>t.map((t)=>t.map((t)=>na([
                    t.x,
                    t.y
                ], e.canonical)))), i = new Ra(r[0][0][0][1]), a = 1 / 0;
    for (let e of t)for (let t of r){
        switch(e.type){
            case `Point`:
                a = Math.min(a, ro([
                    e.coordinates
                ], !1, t, i, a));
                break;
            case `LineString`:
                a = Math.min(a, ro(e.coordinates, !0, t, i, a));
                break;
            case `Polygon`:
                a = Math.min(a, eo(t, e.coordinates, i, a));
                break;
        }
        if (a === 0) return a;
    }
    return a;
}
function co(e) {
    return e.type === `MultiPolygon` ? e.coordinates.map((e)=>({
            type: `Polygon`,
            coordinates: e
        })) : e.type === `MultiLineString` ? e.coordinates.map((e)=>({
            type: `LineString`,
            coordinates: e
        })) : e.type === `MultiPoint` ? e.coordinates.map((e)=>({
            type: `Point`,
            coordinates: e
        })) : [
        e
    ];
}
var lo = class e {
    constructor(e, t){
        this.type = P, this.geojson = e, this.geometries = t;
    }
    static parse(t, n) {
        if (t.length !== 2) return n.error(`'distance' expression requires exactly one argument, but found ${t.length - 1} instead.`);
        if (ri(t[1])) {
            let n = t[1];
            if (n.type === `FeatureCollection`) return new e(n, n.features.map((e)=>co(e.geometry)).flat());
            if (n.type === `Feature`) return new e(n, co(n.geometry));
            if (`type` in n && `coordinates` in n) return new e(n, co(n));
        }
        return n.error(`'distance' expression requires valid geojson object that contains polygon geometry type.`);
    }
    evaluate(e) {
        if (e.geometry() != null && e.canonicalID() != null) {
            if (e.geometryType() === `Point`) return ao(e, this.geometries);
            if (e.geometryType() === `LineString`) return oo(e, this.geometries);
            if (e.geometryType() === `Polygon`) return so(e, this.geometries);
        }
        return NaN;
    }
    eachChild() {}
    outputDefined() {
        return !0;
    }
}, uo = class e {
    constructor(e){
        this.key = e, this.type = L;
    }
    static parse(t, n) {
        if (t.length !== 2) return n.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
        let r = t[1];
        return r == null ? n.error(`Global state property must be defined.`) : typeof r == `string` ? new e(r) : n.error(`Global state property must be string, but found ${typeof t[1]} instead.`);
    }
    evaluate(e) {
        let t = e.globals?.globalState;
        return !t || Object.keys(t).length === 0 ? null : Fr(t, this.key) ?? null;
    }
    eachChild() {}
    outputDefined() {
        return !1;
    }
};
const fo = {
    "==": Ui,
    "!=": Wi,
    ">": Ki,
    "<": Gi,
    ">=": Ji,
    "<=": qi,
    array: ci,
    at: gi,
    boolean: ci,
    case: bi,
    coalesce: Oi,
    collator: Yi,
    format: Zi,
    image: Qi,
    in: _i,
    "index-of": vi,
    interpolate: Ti,
    "interpolate-hcl": Ti,
    "interpolate-lab": Ti,
    length: $i,
    let: mi,
    literal: oi,
    match: yi,
    number: ci,
    "number-format": Xi,
    object: ci,
    slice: xi,
    step: Ci,
    string: ci,
    "to-boolean": ui,
    "to-color": ui,
    "to-number": ui,
    "to-string": ui,
    var: hi,
    within: Da,
    distance: lo,
    "global-state": uo
};
var po = class e {
    constructor(e, t, n, r, i){
        this.name = e, this.type = t, this._evaluate = n, this.args = r, this.key = i;
    }
    evaluate(e) {
        return this._evaluate(e, this.args, this.key);
    }
    eachChild(e) {
        this.args.forEach(e);
    }
    outputDefined() {
        return !1;
    }
    static parse(t, n) {
        let r = t[0], i = e.definitions[r];
        if (!i) return n.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
        let a = Array.isArray(i) ? i[0] : i.type, o = Array.isArray(i) ? [
            [
                i[1],
                i[2]
            ]
        ] : i.overloads, s = o.filter(([e])=>!Array.isArray(e) || e.length === t.length - 1), c = null;
        for (let [i, o] of s){
            c = new pi(n.registry, bo, n.path, null, n.scope);
            let s = [], l = !1;
            for(let e = 1; e < t.length; e++){
                let n = t[e], r = Array.isArray(i) ? i[e - 1] : i.type, a = c.parse(n, 1 + s.length, r);
                if (!a) {
                    l = !0;
                    break;
                }
                s.push(a);
            }
            if (!l) {
                if (Array.isArray(i) && i.length !== s.length) {
                    c.error(`Expected ${i.length} arguments, but found ${s.length} instead.`);
                    continue;
                }
                for(let e = 0; e < s.length; e++){
                    let t = Array.isArray(i) ? i[e] : i.type, n = s[e];
                    c.concat(e + 1).checkSubtype(t, n.type);
                }
                if (c.errors.length === 0) return new e(r, a, o, s, n.key);
            }
        }
        if (s.length === 1) n.errors.push(...c.errors);
        else {
            let e = (s.length ? s : o).map(([e])=>yo(e)).join(` | `), r = [];
            for(let e = 1; e < t.length; e++){
                let i = n.parse(t[e], 1 + r.length);
                if (!i) return null;
                r.push(R(i.type));
            }
            n.error(`Expected arguments of type ${e}, but found (${r.join(`, `)}) instead.`);
        }
        return null;
    }
    static register(t, n) {
        e.definitions = n;
        for(let r in n)t[r] = e;
    }
};
function mo(e, [t, n, r, i], a) {
    t = t.evaluate(e), n = n.evaluate(e), r = r.evaluate(e);
    let o = i ? i.evaluate(e) : 1, s = ni(t, n, r, o);
    if (s) throw new B(s, a);
    return new z(t / 255, n / 255, r / 255, o, !1);
}
function ho(e, t) {
    return e in t && t[e] !== void 0;
}
function go(e, t) {
    let n = t[e];
    return n === void 0 ? null : n;
}
function _o(e, t, n, r) {
    for(; n <= r;){
        let i = n + r >> 1;
        if (t[i] === e) return !0;
        t[i] > e ? r = i - 1 : n = i + 1;
    }
    return !1;
}
function vo(e) {
    return {
        type: e
    };
}
po.register(fo, {
    error: [
        rr,
        [
            F
        ],
        (e, [t], n)=>{
            throw new B(t.evaluate(e), n);
        }
    ],
    typeof: [
        F,
        [
            L
        ],
        (e, [t])=>R(ii(t.evaluate(e)))
    ],
    "to-rgba": [
        dr(P, 4),
        [
            er
        ],
        (e, [t])=>{
            let [n, r, i, a] = t.evaluate(e).rgb;
            return [
                n * 255,
                r * 255,
                i * 255,
                a
            ];
        }
    ],
    rgb: [
        er,
        [
            P,
            P,
            P
        ],
        mo
    ],
    rgba: [
        er,
        [
            P,
            P,
            P,
            P
        ],
        mo
    ],
    has: {
        type: I,
        overloads: [
            [
                [
                    F
                ],
                (e, [t])=>ho(t.evaluate(e), e.properties())
            ],
            [
                [
                    F,
                    nr
                ],
                (e, [t, n])=>ho(t.evaluate(e), n.evaluate(e))
            ]
        ]
    },
    get: {
        type: L,
        overloads: [
            [
                [
                    F
                ],
                (e, [t])=>go(t.evaluate(e), e.properties())
            ],
            [
                [
                    F,
                    nr
                ],
                (e, [t, n])=>go(t.evaluate(e), n.evaluate(e))
            ]
        ]
    },
    "feature-state": [
        L,
        [
            F
        ],
        (e, [t])=>go(t.evaluate(e), e.featureState || {})
    ],
    properties: [
        nr,
        [],
        (e)=>e.properties()
    ],
    "geometry-type": [
        F,
        [],
        (e)=>e.geometryType()
    ],
    id: [
        L,
        [],
        (e)=>e.id()
    ],
    zoom: [
        P,
        [],
        (e)=>e.globals.zoom
    ],
    "heatmap-density": [
        P,
        [],
        (e)=>e.globals.heatmapDensity || 0
    ],
    elevation: [
        P,
        [],
        (e)=>e.globals.elevation || 0
    ],
    "line-progress": [
        P,
        [],
        (e)=>e.globals.lineProgress || 0
    ],
    accumulated: [
        L,
        [],
        (e)=>e.globals.accumulated === void 0 ? null : e.globals.accumulated
    ],
    "+": [
        P,
        vo(P),
        (e, t)=>{
            let n = 0;
            for (let r of t)n += r.evaluate(e);
            return n;
        }
    ],
    "*": [
        P,
        vo(P),
        (e, t)=>{
            let n = 1;
            for (let r of t)n *= r.evaluate(e);
            return n;
        }
    ],
    "-": {
        type: P,
        overloads: [
            [
                [
                    P,
                    P
                ],
                (e, [t, n])=>t.evaluate(e) - n.evaluate(e)
            ],
            [
                [
                    P
                ],
                (e, [t])=>-t.evaluate(e)
            ]
        ]
    },
    "/": [
        P,
        [
            P,
            P
        ],
        (e, [t, n])=>t.evaluate(e) / n.evaluate(e)
    ],
    "%": [
        P,
        [
            P,
            P
        ],
        (e, [t, n])=>t.evaluate(e) % n.evaluate(e)
    ],
    ln2: [
        P,
        [],
        ()=>Math.LN2
    ],
    pi: [
        P,
        [],
        ()=>Math.PI
    ],
    e: [
        P,
        [],
        ()=>Math.E
    ],
    "^": [
        P,
        [
            P,
            P
        ],
        (e, [t, n])=>t.evaluate(e) ** +n.evaluate(e)
    ],
    sqrt: [
        P,
        [
            P
        ],
        (e, [t])=>Math.sqrt(t.evaluate(e))
    ],
    log10: [
        P,
        [
            P
        ],
        (e, [t])=>Math.log(t.evaluate(e)) / Math.LN10
    ],
    ln: [
        P,
        [
            P
        ],
        (e, [t])=>Math.log(t.evaluate(e))
    ],
    log2: [
        P,
        [
            P
        ],
        (e, [t])=>Math.log(t.evaluate(e)) / Math.LN2
    ],
    sin: [
        P,
        [
            P
        ],
        (e, [t])=>Math.sin(t.evaluate(e))
    ],
    cos: [
        P,
        [
            P
        ],
        (e, [t])=>Math.cos(t.evaluate(e))
    ],
    tan: [
        P,
        [
            P
        ],
        (e, [t])=>Math.tan(t.evaluate(e))
    ],
    asin: [
        P,
        [
            P
        ],
        (e, [t])=>Math.asin(t.evaluate(e))
    ],
    acos: [
        P,
        [
            P
        ],
        (e, [t])=>Math.acos(t.evaluate(e))
    ],
    atan: [
        P,
        [
            P
        ],
        (e, [t])=>Math.atan(t.evaluate(e))
    ],
    min: [
        P,
        vo(P),
        (e, t)=>Math.min(...t.map((t)=>t.evaluate(e)))
    ],
    max: [
        P,
        vo(P),
        (e, t)=>Math.max(...t.map((t)=>t.evaluate(e)))
    ],
    abs: [
        P,
        [
            P
        ],
        (e, [t])=>Math.abs(t.evaluate(e))
    ],
    round: [
        P,
        [
            P
        ],
        (e, [t])=>{
            let n = t.evaluate(e);
            return n < 0 ? -Math.round(-n) : Math.round(n);
        }
    ],
    floor: [
        P,
        [
            P
        ],
        (e, [t])=>Math.floor(t.evaluate(e))
    ],
    ceil: [
        P,
        [
            P
        ],
        (e, [t])=>Math.ceil(t.evaluate(e))
    ],
    "filter-==": [
        I,
        [
            F,
            L
        ],
        (e, [t, n])=>e.properties()[t.value] === n.value
    ],
    "filter-id-==": [
        I,
        [
            L
        ],
        (e, [t])=>e.id() === t.value
    ],
    "filter-type-==": [
        I,
        [
            F
        ],
        (e, [t])=>e.geometryType() === t.value
    ],
    "filter-<": [
        I,
        [
            F,
            L
        ],
        (e, [t, n])=>{
            let r = e.properties()[t.value], i = n.value;
            return typeof r == typeof i && r < i;
        }
    ],
    "filter-id-<": [
        I,
        [
            L
        ],
        (e, [t])=>{
            let n = e.id(), r = t.value;
            return typeof n == typeof r && n < r;
        }
    ],
    "filter->": [
        I,
        [
            F,
            L
        ],
        (e, [t, n])=>{
            let r = e.properties()[t.value], i = n.value;
            return typeof r == typeof i && r > i;
        }
    ],
    "filter-id->": [
        I,
        [
            L
        ],
        (e, [t])=>{
            let n = e.id(), r = t.value;
            return typeof n == typeof r && n > r;
        }
    ],
    "filter-<=": [
        I,
        [
            F,
            L
        ],
        (e, [t, n])=>{
            let r = e.properties()[t.value], i = n.value;
            return typeof r == typeof i && r <= i;
        }
    ],
    "filter-id-<=": [
        I,
        [
            L
        ],
        (e, [t])=>{
            let n = e.id(), r = t.value;
            return typeof n == typeof r && n <= r;
        }
    ],
    "filter->=": [
        I,
        [
            F,
            L
        ],
        (e, [t, n])=>{
            let r = e.properties()[t.value], i = n.value;
            return typeof r == typeof i && r >= i;
        }
    ],
    "filter-id->=": [
        I,
        [
            L
        ],
        (e, [t])=>{
            let n = e.id(), r = t.value;
            return typeof n == typeof r && n >= r;
        }
    ],
    "filter-has": [
        I,
        [
            L
        ],
        (e, [t])=>{
            let n = t.value, r = e.properties();
            return n in r && r[n] !== void 0;
        }
    ],
    "filter-has-id": [
        I,
        [],
        (e)=>e.id() !== null && e.id() !== void 0
    ],
    "filter-type-in": [
        I,
        [
            dr(F)
        ],
        (e, [t])=>t.value.indexOf(e.geometryType()) >= 0
    ],
    "filter-id-in": [
        I,
        [
            dr(L)
        ],
        (e, [t])=>t.value.indexOf(e.id()) >= 0
    ],
    "filter-in-small": [
        I,
        [
            F,
            dr(L)
        ],
        (e, [t, n])=>n.value.indexOf(e.properties()[t.value]) >= 0
    ],
    "filter-in-large": [
        I,
        [
            F,
            dr(L)
        ],
        (e, [t, n])=>_o(e.properties()[t.value], n.value, 0, n.value.length - 1)
    ],
    all: {
        type: I,
        overloads: [
            [
                [
                    I,
                    I
                ],
                (e, [t, n])=>t.evaluate(e) && n.evaluate(e)
            ],
            [
                vo(I),
                (e, t)=>{
                    for (let n of t)if (!n.evaluate(e)) return !1;
                    return !0;
                }
            ]
        ]
    },
    any: {
        type: I,
        overloads: [
            [
                [
                    I,
                    I
                ],
                (e, [t, n])=>t.evaluate(e) || n.evaluate(e)
            ],
            [
                vo(I),
                (e, t)=>{
                    for (let n of t)if (n.evaluate(e)) return !0;
                    return !1;
                }
            ]
        ]
    },
    "!": [
        I,
        [
            I
        ],
        (e, [t])=>!t.evaluate(e)
    ],
    "is-supported-script": [
        I,
        [
            F
        ],
        (e, [t])=>{
            let n = e.globals && e.globals.isSupportedScript;
            return !n || n(t.evaluate(e));
        }
    ],
    upcase: [
        F,
        [
            F
        ],
        (e, [t])=>t.evaluate(e).toUpperCase()
    ],
    downcase: [
        F,
        [
            F
        ],
        (e, [t])=>t.evaluate(e).toLowerCase()
    ],
    concat: [
        F,
        vo(L),
        (e, t)=>t.map((t)=>ai(t.evaluate(e))).join(``)
    ],
    split: [
        dr(F),
        [
            F,
            F
        ],
        (e, [t, n])=>t.evaluate(e).split(n.evaluate(e))
    ],
    join: [
        F,
        [
            dr(F),
            F
        ],
        (e, [t, n])=>t.evaluate(e).join(n.evaluate(e))
    ],
    "resolved-locale": [
        F,
        [
            ir
        ],
        (e, [t])=>t.evaluate(e).resolvedLocale()
    ]
});
function yo(e) {
    return Array.isArray(e) ? `(${e.map(R).join(`, `)})` : `(${R(e.type)}...)`;
}
function bo(e) {
    if (e instanceof hi) return bo(e.boundExpression);
    if (e instanceof po && e.name === `error` || e instanceof Yi || e instanceof Da || e instanceof lo || e instanceof uo) return !1;
    let t = e instanceof ui || e instanceof ci, n = !0;
    return e.eachChild((e)=>{
        t ? n &&= bo(e) : n &&= e instanceof oi;
    }), n ? xo(e) && Co(e, [
        `zoom`,
        `heatmap-density`,
        `elevation`,
        `line-progress`,
        `accumulated`,
        `is-supported-script`
    ]) : !1;
}
function xo(e) {
    if (e instanceof po && (e.name === `get` && e.args.length === 1 || e.name === `feature-state` || e.name === `has` && e.args.length === 1 || e.name === `properties` || e.name === `geometry-type` || e.name === `id` || /^filter-/.test(e.name)) || e instanceof Da || e instanceof lo) return !1;
    let t = !0;
    return e.eachChild((e)=>{
        t && !xo(e) && (t = !1);
    }), t;
}
function So(e) {
    if (e instanceof po && e.name === `feature-state`) return !1;
    let t = !0;
    return e.eachChild((e)=>{
        t && !So(e) && (t = !1);
    }), t;
}
function Co(e, t) {
    if (e instanceof po && t.indexOf(e.name) >= 0) return !1;
    let n = !0;
    return e.eachChild((e)=>{
        n && !Co(e, t) && (n = !1);
    }), n;
}
function wo(e) {
    return {
        result: `success`,
        value: e
    };
}
function To(e) {
    return {
        result: `error`,
        value: e
    };
}
function Eo(e) {
    return e[`property-type`] === `data-driven` || e[`property-type`] === `cross-faded-data-driven`;
}
function Do(e) {
    return !!e.expression && e.expression.parameters.indexOf(`zoom`) > -1;
}
function Oo(e) {
    return !!e.expression && e.expression.interpolated;
}
function ko(e, ...t) {
    for (let n of t)for(let t in n)e[t] = n[t];
    return e;
}
function V(e) {
    return e instanceof Number ? `number` : e instanceof String ? `string` : e instanceof Boolean ? `boolean` : Array.isArray(e) ? `array` : e === null ? `null` : typeof e;
}
function Ao(e) {
    return typeof e == `object` && !!e && !Array.isArray(e) && ii(e) === nr;
}
function jo(e) {
    return e;
}
function Mo(e) {
    switch(e.type){
        case `color`:
            return z.parse;
        case `padding`:
            return Yr.parse;
        case `numberArray`:
            return Xr.parse;
        case `colorArray`:
            return Zr.parse;
        default:
            return null;
    }
}
function No(e) {
    switch(e){
        case `exponential`:
            return Ro;
        case `interval`:
            return Lo;
        case `categorical`:
            return Io;
        case `identity`:
            return zo;
        default:
            throw Error(`Unknown function type "${e}"`);
    }
}
function Po(e, t) {
    let n = e.stops && typeof e.stops[0][0] == `object`, r = n || e.property !== void 0, i = n || !r, a = e.type || (Oo(t) ? `exponential` : `interval`), o = Mo(t);
    if (o && (e = ko({}, e), e.stops &&= e.stops.map((e)=>[
            e[0],
            o(e[1])
        ]), e.default ? e.default = o(e.default) : e.default = o(t.default)), e.colorSpace && !Wr(e.colorSpace)) throw Error(`Unknown color space: "${e.colorSpace}"`);
    let s = No(a), c, l;
    if (a === `categorical`) {
        c = Object.create(null);
        for (let t of e.stops)c[t[0]] = t[1];
        l = typeof e.stops[0][0];
    }
    if (n) {
        let n = {}, r = [];
        for(let t = 0; t < e.stops.length; t++){
            let i = e.stops[t], a = i[0].zoom;
            n[a] === void 0 && (n[a] = {
                zoom: a,
                type: e.type,
                property: e.property,
                default: e.default,
                stops: []
            }, r.push(a)), n[a].stops.push([
                i[0].value,
                i[1]
            ]);
        }
        let i = [];
        for (let e of r)i.push([
            n[e].zoom,
            Po(n[e], t)
        ]);
        let a = {
            name: `linear`
        };
        return {
            kind: `composite`,
            interpolationType: a,
            interpolationFactor: Ti.interpolationFactor.bind(void 0, a),
            zoomStops: i.map((e)=>e[0]),
            evaluate ({ zoom: n }, r) {
                return Ro({
                    stops: i,
                    base: e.base
                }, t, n).evaluate(n, r);
            }
        };
    } else if (i) {
        let n = a === `exponential` ? {
            name: `exponential`,
            base: e.base === void 0 ? 1 : e.base
        } : null;
        return {
            kind: `camera`,
            interpolationType: n,
            interpolationFactor: Ti.interpolationFactor.bind(void 0, n),
            zoomStops: e.stops.map((e)=>e[0]),
            evaluate: ({ zoom: n })=>s(e, t, n, c, l)
        };
    } else return {
        kind: `source`,
        evaluate (n, r) {
            let i = r && r.properties ? r.properties[e.property] : void 0;
            return i === void 0 ? Fo(e.default, t.default) : s(e, t, i, c, l);
        }
    };
}
function Fo(e, t, n) {
    if (e !== void 0) return e;
    if (t !== void 0) return t;
    if (n !== void 0) return n;
}
function Io(e, t, n, r, i) {
    return Fo(typeof n === i ? r[n] : void 0, e.default, t.default);
}
function Lo(e, t, n) {
    if (V(n) !== `number`) return Fo(e.default, t.default);
    let r = e.stops.length;
    if (r === 1 || n <= e.stops[0][0]) return e.stops[0][1];
    if (n >= e.stops[r - 1][0]) return e.stops[r - 1][1];
    let i = Si(e.stops.map((e)=>e[0]), n, ``);
    return e.stops[i][1];
}
function Ro(e, t, n) {
    let r = e.base === void 0 ? 1 : e.base;
    if (V(n) !== `number`) return Fo(e.default, t.default);
    let i = e.stops.length;
    if (i === 1 || n <= e.stops[0][0]) return e.stops[0][1];
    if (n >= e.stops[i - 1][0]) return e.stops[i - 1][1];
    let a = Si(e.stops.map((e)=>e[0]), n, ``), o = Bo(n, r, e.stops[a][0], e.stops[a + 1][0]), s = e.stops[a][1], c = e.stops[a + 1][1], l = Di[t.type] || jo;
    return typeof s.evaluate == `function` ? {
        evaluate (...t) {
            let n = s.evaluate.apply(void 0, t), r = c.evaluate.apply(void 0, t);
            if (n !== void 0 && r !== void 0) return l(n, r, o, e.colorSpace);
        }
    } : l(s, c, o, e.colorSpace);
}
function zo(e, t, n) {
    switch(t.type){
        case `color`:
            n = z.parse(n);
            break;
        case `formatted`:
            n = Jr.fromString(n.toString());
            break;
        case `resolvedImage`:
            n = ei.fromString(n.toString());
            break;
        case `padding`:
            n = Yr.parse(n);
            break;
        case `colorArray`:
            n = Zr.parse(n);
            break;
        case `numberArray`:
            n = Xr.parse(n);
            break;
        default:
            V(n) !== t.type && (t.type !== `enum` || !t.values[n]) && (n = void 0);
    }
    return Fo(n, e.default, t.default);
}
function Bo(e, t, n, r) {
    let i = r - n, a = e - n;
    return i === 0 ? 0 : t === 1 ? a / i : (t ** +a - 1) / (t ** +i - 1);
}
var Vo = class {
    constructor(e, t, n, r){
        this.expression = e, this._warningHistory = {}, this._evaluator = new fi, this._defaultValue = n ? ts(n) : null, this._enumValues = n && n.type === `enum` ? n.values : null, this._globalState = r, this._rootKey = t;
    }
    evaluateWithoutErrorHandling(e, t, n, r, i, a) {
        return this._globalState && (e = ns(e, this._globalState)), this._evaluator.globals = e, this._evaluator.feature = t, this._evaluator.featureState = n, this._evaluator.canonical = r, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
    }
    evaluate(e, t, n, r, i, a) {
        this._globalState && (e = ns(e, this._globalState)), this._evaluator.globals = e, this._evaluator.feature = t || null, this._evaluator.featureState = n || null, this._evaluator.canonical = r, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
        try {
            let e = this.expression.evaluate(this._evaluator);
            if (e == null || typeof e == `number` && e !== e) return this._defaultValue;
            if (this._enumValues && !(e in this._enumValues)) throw new B(`Expected value to be one of ${Object.keys(this._enumValues).map((e)=>JSON.stringify(e)).join(`, `)}, but found ${JSON.stringify(e)} instead.`, ``);
            return e;
        } catch (e) {
            let t = e instanceof B ? e.path : ``, n = `${t}|${e.message}`;
            return this._warningHistory[n] || (this._warningHistory[n] = !0, typeof console < `u` && console.warn(Ho(this._rootKey, t, e.message, this._defaultValue))), this._defaultValue;
        }
    }
};
function Ho(e, t, n, r) {
    return `${e}${t}: ${n}${r == null ? `` : ` Falling back to ${String(r)}.`}`;
}
function Uo(e) {
    if (!e) throw Error(`rootKey must identify the location of the expression in the style JSON, e.g. "layers[3].paint.line-width".`);
}
function Wo(e) {
    return Array.isArray(e) && e.length > 0 && typeof e[0] == `string` && e[0] in fo;
}
function Go(e, t, n, r) {
    Uo(t);
    let i = new pi(fo, bo, [], n ? es(n) : void 0), a = i.parse(e, void 0, void 0, void 0, n && n.type === `string` ? {
        typeAnnotation: `coerce`
    } : void 0);
    return a ? wo(new Vo(a, t, n, r)) : To(i.errors);
}
var Ko = class {
    constructor(e, t, n){
        this.kind = e, this._styleExpression = t, this.isStateDependent = e !== `constant` && !So(t.expression), this.globalStateRefs = $o(t.expression), this._globalState = n;
    }
    evaluateWithoutErrorHandling(e, t, n, r, i, a) {
        return this._globalState && (e = ns(e, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(e, t, n, r, i, a);
    }
    evaluate(e, t, n, r, i, a) {
        return this._globalState && (e = ns(e, this._globalState)), this._styleExpression.evaluate(e, t, n, r, i, a);
    }
}, qo = class {
    constructor(e, t, n, r, i){
        this.kind = e, this.zoomStops = n, this._styleExpression = t, this.isStateDependent = e !== `camera` && !So(t.expression), this.globalStateRefs = $o(t.expression), this.interpolationType = r, this._globalState = i;
    }
    evaluateWithoutErrorHandling(e, t, n, r, i, a) {
        return this._globalState && (e = ns(e, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(e, t, n, r, i, a);
    }
    evaluate(e, t, n, r, i, a) {
        return this._globalState && (e = ns(e, this._globalState)), this._styleExpression.evaluate(e, t, n, r, i, a);
    }
    interpolationFactor(e, t, n) {
        return this.interpolationType ? Ti.interpolationFactor(this.interpolationType, e, t, n) : 0;
    }
};
function Jo(e) {
    return e._styleExpression !== void 0;
}
function Yo(e, t, n, r) {
    let i = Go(e, t, n, r);
    if (i.result === `error`) return i;
    let a = i.value.expression, o = xo(a);
    if (!o && !Eo(n)) return To([
        new Zn(``, `data expressions not supported`)
    ]);
    let s = Co(a, [
        `zoom`
    ]);
    if (!s && !Do(n)) return To([
        new Zn(``, `zoom expressions not supported`)
    ]);
    let c = Qo(a);
    if (!c && !s) return To([
        new Zn(``, `"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.`)
    ]);
    if (c instanceof Zn) return To([
        c
    ]);
    if (c instanceof Ti && !Oo(n)) return To([
        new Zn(``, `"interpolate" expressions cannot be used with this property`)
    ]);
    if (!c) return wo(o ? new Ko(`constant`, i.value, r) : new Ko(`source`, i.value, r));
    let l = c instanceof Ti ? c.interpolation : void 0;
    return wo(o ? new qo(`camera`, i.value, c.labels, l, r) : new qo(`composite`, i.value, c.labels, l, r));
}
var Xo = class e {
    constructor(e, t, n){
        this.isStateDependent = !1, this.globalStateRefs = new Set, this._globalState = null, Uo(t), this._parameters = e, this._specification = n, this._rootKey = t, this._defaultValue = ts(n), this._warningHistory = {};
        let r = Po(this._parameters, this._specification);
        this.kind = r.kind, this.interpolationFactor = r.interpolationFactor, this.zoomStops = r.zoomStops, this.interpolationType = r.interpolationType, this._innerEvaluate = r.evaluate;
    }
    evaluate(e, t) {
        try {
            return this._innerEvaluate(e, t);
        } catch (e) {
            let t = e instanceof Error ? e.message : String(e), n = `|${t}`;
            return this._warningHistory[n] || (this._warningHistory[n] = !0, typeof console < `u` && console.warn(Ho(this._rootKey, ``, t, this._defaultValue))), this._defaultValue;
        }
    }
    static deserialize(t) {
        return new e(t._parameters, t._rootKey, t._specification);
    }
    static serialize(e) {
        return {
            _parameters: e._parameters,
            _specification: e._specification,
            _rootKey: e._rootKey
        };
    }
};
function Zo(e, t, n, r) {
    if (Ao(e)) return new Xo(e, t, n);
    if (Wo(e)) {
        let i = Yo(e, t, n, r);
        if (i.result === `error`) throw Error(i.value.map((e)=>`${e.key}: ${e.message}`).join(`, `));
        return i.value;
    } else {
        let t = e;
        return n.type === `color` && typeof e == `string` ? t = z.parse(e) : n.type === `padding` && (typeof e == `number` || Array.isArray(e)) ? t = Yr.parse(e) : n.type === `numberArray` && (typeof e == `number` || Array.isArray(e)) ? t = Xr.parse(e) : n.type === `colorArray` && (typeof e == `string` || Array.isArray(e)) ? t = Zr.parse(e) : n.type === `variableAnchorOffsetCollection` && Array.isArray(e) ? t = $r.parse(e) : n.type === `projectionDefinition` && typeof e == `string` && (t = ti.parse(e)), {
            globalStateRefs: new Set,
            _globalState: null,
            kind: `constant`,
            evaluate: ()=>t
        };
    }
}
function Qo(e) {
    let t = null;
    if (e instanceof mi) t = Qo(e.result);
    else if (e instanceof Oi) {
        for (let n of e.args)if (t = Qo(n), t) break;
    } else (e instanceof Ci || e instanceof Ti) && e.input instanceof po && e.input.name === `zoom` && (t = e);
    return t instanceof Zn || e.eachChild((e)=>{
        let n = Qo(e);
        n instanceof Zn ? t = n : !t && n ? t = new Zn(``, `"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.`) : t && n && t !== n && (t = new Zn(``, `Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.`));
    }), t;
}
function $o(e, t = new Set) {
    return e instanceof uo && t.add(e.key), e.eachChild((e)=>{
        $o(e, t);
    }), t;
}
function es(e) {
    let t = {
        color: er,
        string: F,
        number: P,
        enum: F,
        boolean: I,
        formatted: ar,
        padding: or,
        numberArray: cr,
        colorArray: sr,
        projectionDefinition: tr,
        resolvedImage: lr,
        variableAnchorOffsetCollection: ur
    };
    return e.type === `array` ? dr(t[e.value] || L, e.length) : t[e.type];
}
function ts(e) {
    if (e.type === `color` && Ao(e.default)) return new z(0, 0, 0, 0);
    switch(e.type){
        case `color`:
            return z.parse(e.default) || null;
        case `padding`:
            return Yr.parse(e.default) || null;
        case `numberArray`:
            return Xr.parse(e.default) || null;
        case `colorArray`:
            return Zr.parse(e.default) || null;
        case `variableAnchorOffsetCollection`:
            return $r.parse(e.default) || null;
        case `projectionDefinition`:
            return ti.parse(e.default) || null;
        default:
            return e.default === void 0 ? null : e.default;
    }
}
function ns(e, t) {
    let { zoom: n, heatmapDensity: r, elevation: i, lineProgress: a, isSupportedScript: o, accumulated: s } = e ?? {};
    return {
        zoom: n,
        heatmapDensity: r,
        elevation: i,
        lineProgress: a,
        isSupportedScript: o,
        accumulated: s,
        globalState: t
    };
}
function rs(e) {
    let t = !1;
    for (let n of e){
        let e = is(n);
        if (e === `expression`) return `expression`;
        e === `legacy` && (t = !0);
    }
    return t ? `legacy` : `neutral`;
}
function is(e) {
    if (typeof e == `boolean`) return `neutral`;
    if (!Array.isArray(e) || e.length === 0) return `legacy`;
    switch(e[0]){
        case `has`:
            return e.length < 2 || e[1] === `$id` || e[1] === `$type` ? `legacy` : e.length === 2 ? `neutral` : `expression`;
        case `in`:
            return e.length >= 3 && (typeof e[1] != `string` || Array.isArray(e[2])) ? `expression` : `legacy`;
        case `!in`:
        case `!has`:
            return `legacy`;
        case `==`:
        case `!=`:
        case `>`:
        case `>=`:
        case `<`:
        case `<=`:
            return e.length !== 3 || Array.isArray(e[1]) || Array.isArray(e[2]) ? `expression` : `legacy`;
        case `none`:
            return `legacy`;
        case `any`:
        case `all`:
            return rs(e.slice(1));
        default:
            return `expression`;
    }
}
function as(e) {
    return is(e) !== `legacy`;
}
function os(e) {
    return e === `$type` ? [
        `geometry-type`
    ] : e === `$id` ? [
        `id`
    ] : [
        `get`,
        e
    ];
}
function ss(e) {
    switch(e[0]){
        case `==`:
        case `!=`:
        case `<`:
        case `<=`:
        case `>`:
        case `>=`:
            return e.length !== 3 || typeof e[1] != `string` ? null : [
                e[0],
                os(e[1]),
                e[2]
            ];
        case `in`:
        case `!in`:
            {
                if (e.length < 2 || typeof e[1] != `string`) return null;
                let t = [
                    `in`,
                    os(e[1]),
                    [
                        `literal`,
                        e.slice(2)
                    ]
                ];
                return e[0] === `!in` ? [
                    `!`,
                    t
                ] : t;
            }
        case `has`:
        case `!has`:
            {
                if (e.length !== 2 || typeof e[1] != `string` || e[1] === `$type` || e[1] === `$id`) return null;
                let t = [
                    `has`,
                    e[1]
                ];
                return e[0] === `!has` ? [
                    `!`,
                    t
                ] : t;
            }
        default:
            return null;
    }
}
function cs(e) {
    if ((e[0] === `<` || e[0] === `<=` || e[0] === `>` || e[0] === `>=`) && e[1] === `$type`) return `"$type" cannot be use with operator "${e[0]}"`;
    let t = ss(e);
    return t ? `Mixing deprecated filter syntax with expression syntax is not supported. Replace ${JSON.stringify(e)} with ${JSON.stringify(t)}.` : `Mixing deprecated filter syntax with expression syntax is not supported. Convert ${JSON.stringify(e)} to expression syntax.`;
}
function ls(e, t, n) {
    let r = n[e];
    return Array.isArray(r) ? as(r) ? us(r, t.concat(e)) : {
        path: t.concat(e),
        legacyFilter: r
    } : null;
}
function us(e, t = []) {
    if (!Array.isArray(e) || e.length < 1) return null;
    switch(e[0]){
        case `all`:
        case `any`:
        case `none`:
            for(let n = 1; n < e.length; n++){
                let r = ls(n, t, e);
                if (r) return r;
            }
            break;
        case `!`:
            {
                let n = ls(1, t, e);
                if (n) return n;
                break;
            }
        case `case`:
            for(let n = 1; n < e.length - 1; n += 2){
                let r = ls(n, t, e);
                if (r) return r;
            }
            break;
    }
    return null;
}
function ds(e, t) {
    let n = us(e);
    if (!n || typeof console > `u`) return;
    let r = n.path.map((e)=>`[${e}]`).join(``);
    console.warn(`${t}${r}: ${cs(n.legacyFilter)}`);
}
const fs = {
    type: `boolean`,
    default: !1,
    transition: !1,
    "property-type": `data-driven`,
    expression: {
        interpolated: !1,
        parameters: [
            `zoom`,
            `feature`
        ]
    }
};
function ps(e, t, n) {
    if (e == null) return {
        filter: ()=>!0,
        needGeometry: !1,
        getGlobalStateRefs: ()=>new Set
    };
    as(e) ? ds(e, t) : e = gs(e);
    let r = Go(e, t, fs, n);
    if (r.result === `error`) throw Error(r.value.map((e)=>`${e.key}: ${e.message}`).join(`, `));
    return {
        filter: (e, t, n)=>r.value.evaluate(e, t, {}, n),
        needGeometry: hs(e),
        getGlobalStateRefs: ()=>$o(r.value.expression)
    };
}
function ms(e, t) {
    return e < t ? -1 : +(e > t);
}
function hs(e) {
    if (!Array.isArray(e)) return !1;
    if (e[0] === `within` || e[0] === `distance`) return !0;
    for(let t = 1; t < e.length; t++)if (hs(e[t])) return !0;
    return !1;
}
function gs(e) {
    if (!e) return !0;
    let t = e[0];
    return e.length <= 1 ? t !== `any` : t === `==` ? _s(e[1], e[2], `==`) : t === `!=` ? xs(_s(e[1], e[2], `==`)) : t === `<` || t === `>` || t === `<=` || t === `>=` ? _s(e[1], e[2], t) : t === `any` ? vs(e.slice(1)) : t === `all` ? [
        `all`
    ].concat(e.slice(1).map(gs)) : t === `none` ? [
        `all`
    ].concat(e.slice(1).map(gs).map(xs)) : t === `in` ? ys(e[1], e.slice(2)) : t === `!in` ? xs(ys(e[1], e.slice(2))) : t === `has` ? bs(e[1]) : t !== `!has` || xs(bs(e[1]));
}
function _s(e, t, n) {
    switch(e){
        case `$type`:
            return [
                `filter-type-${n}`,
                t
            ];
        case `$id`:
            return [
                `filter-id-${n}`,
                t
            ];
        default:
            return [
                `filter-${n}`,
                e,
                t
            ];
    }
}
function vs(e) {
    return [
        `any`
    ].concat(e.map(gs));
}
function ys(e, t) {
    if (t.length === 0) return !1;
    switch(e){
        case `$type`:
            return [
                `filter-type-in`,
                [
                    `literal`,
                    t
                ]
            ];
        case `$id`:
            return [
                `filter-id-in`,
                [
                    `literal`,
                    t
                ]
            ];
        default:
            return t.length > 200 && !t.some((e)=>typeof e != typeof t[0]) ? [
                `filter-in-large`,
                e,
                [
                    `literal`,
                    t.sort(ms)
                ]
            ] : [
                `filter-in-small`,
                e,
                [
                    `literal`,
                    t
                ]
            ];
    }
}
function bs(e) {
    switch(e){
        case `$type`:
            return !0;
        case `$id`:
            return [
                `filter-has-id`
            ];
        default:
            return [
                `filter-has`,
                e
            ];
    }
}
function xs(e) {
    return [
        `!`,
        e
    ];
}
function Ss(e) {
    let t = typeof e;
    if (t === `number` || t === `boolean` || t === `string` || e == null) return JSON.stringify(e);
    if (Array.isArray(e)) {
        let t = `[`;
        for (let n of e)t += `${Ss(n)},`;
        return `${t}]`;
    }
    let n = Object.keys(e).sort(), r = `{`;
    for(let t = 0; t < n.length; t++)r += `${JSON.stringify(n[t])}:${Ss(e[n[t]])},`;
    return `${r}}`;
}
function Cs(e) {
    let t = ``;
    for (let n of Ln)t += `/${Ss(e[n])}`;
    return t;
}
function ws(e, t) {
    let n = {};
    for(let r = 0; r < e.length; r++){
        let i = t && t[e[r].id] || Cs(e[r]);
        t && (t[e[r].id] = i);
        let a = n[i];
        a ||= n[i] = [], a.push(e[r]);
    }
    let r = [];
    for(let e in n)r.push(n[e]);
    return r;
}
function Ts() {
    let e = {}, t = j.$version;
    for(let n in j.$root){
        let r = j.$root[n];
        if (r.required) {
            let i = null;
            i = n === `version` ? t : r.type === `array` ? [] : {}, i != null && (e[n] = i);
        }
    }
    return e;
}
function Es(e) {
    let t = e.key, n = e.value;
    return n ? [
        new N(t, n, `constants have been deprecated as of v8`)
    ] : [];
}
function Ds(e) {
    return e instanceof Number || e instanceof String || e instanceof Boolean ? e.valueOf() : e;
}
function Os(e) {
    if (Array.isArray(e)) return e.map(Os);
    if (e instanceof Object && !(e instanceof Number || e instanceof String || e instanceof Boolean)) {
        let t = {};
        for(let n in e)t[n] = Os(e[n]);
        return t;
    }
    return Ds(e);
}
function ks(e) {
    let t = e.key, n = e.value, r = e.valueSpec || {}, i = e.objectElementValidators || {}, a = e.style, o = e.styleSpec, s = e.validateSpec, c = [], l = V(n);
    if (l !== `object`) return [
        new N(t, n, `object expected, ${l} found`)
    ];
    for(let e in n){
        let l = e.split(`.`)[0], u = Fr(r, l) || r[`*`], d;
        if (Fr(i, l)) d = i[l];
        else if (Fr(r, l)) {
            if (n[e] === void 0) continue;
            d = s;
        } else if (i[`*`]) d = i[`*`];
        else if (r[`*`]) d = s;
        else {
            c.push(new N(t, n[e], `unknown property "${e}"`));
            continue;
        }
        c = c.concat(d({
            key: (t && `${t}.`) + e,
            value: n[e],
            valueSpec: u,
            style: a,
            styleSpec: o,
            object: n,
            objectKey: e,
            validateSpec: s
        }, n));
    }
    for(let e in r)i[e] || r[e].required && r[e].default === void 0 && n[e] === void 0 && c.push(new N(t, n, `missing required property "${e}"`));
    return c;
}
function As(e) {
    let t = e.value, n = e.valueSpec, r = e.validateSpec, i = e.style, a = e.styleSpec, o = e.key, s = e.arrayElementValidator || r;
    if (V(t) !== `array`) return [
        new N(o, t, `array expected, ${V(t)} found`)
    ];
    if (n.length && t.length !== n.length) return [
        new N(o, t, `array length ${n.length} expected, length ${t.length} found`)
    ];
    let c = {
        type: n.value,
        values: n.values
    };
    a.$version < 7 && (c.function = n.function), V(n.value) === `object` && (c = n.value);
    let l = [];
    for(let n = 0; n < t.length; n++)l = l.concat(s({
        array: t,
        arrayIndex: n,
        value: t[n],
        valueSpec: c,
        validateSpec: e.validateSpec,
        style: i,
        styleSpec: a,
        key: `${o}[${n}]`
    }));
    return l;
}
function js(e) {
    let t = e.key, n = e.value, r = e.valueSpec, i = V(n);
    return i === `number` && n !== n && (i = `NaN`), i === `number` ? `minimum` in r && n < r.minimum ? [
        new N(t, n, `${n} is less than the minimum value ${r.minimum}`)
    ] : `maximum` in r && n > r.maximum ? [
        new N(t, n, `${n} is greater than the maximum value ${r.maximum}`)
    ] : [] : [
        new N(t, n, `number expected, ${i} found`)
    ];
}
function Ms(e) {
    let t = e.valueSpec, n = Ds(e.value.type), r, i = {}, a, o, s = n !== `categorical` && e.value.property === void 0, c = !s, l = V(e.value.stops) === `array` && V(e.value.stops[0]) === `array` && V(e.value.stops[0][0]) === `object`, u = ks({
        key: e.key,
        value: e.value,
        valueSpec: e.styleSpec.function,
        validateSpec: e.validateSpec,
        style: e.style,
        styleSpec: e.styleSpec,
        objectElementValidators: {
            stops: d,
            default: m
        }
    });
    return n === `identity` && s && u.push(new N(e.key, e.value, `missing required property "property"`)), n !== `identity` && !e.value.stops && u.push(new N(e.key, e.value, `missing required property "stops"`)), n === `exponential` && e.valueSpec.expression && !Oo(e.valueSpec) && u.push(new N(e.key, e.value, `exponential functions not supported`)), e.styleSpec.$version >= 8 && (c && !Eo(e.valueSpec) ? u.push(new N(e.key, e.value, `property functions not supported`)) : s && !Do(e.valueSpec) && u.push(new N(e.key, e.value, `zoom functions not supported`))), (n === `categorical` || l) && e.value.property === void 0 && u.push(new N(e.key, e.value, `"property" property is required`)), u;
    function d(e) {
        if (n === `identity`) return [
            new N(e.key, e.value, `identity function may not have a "stops" property`)
        ];
        let t = [], r = e.value;
        return t = t.concat(As({
            key: e.key,
            value: r,
            valueSpec: e.valueSpec,
            validateSpec: e.validateSpec,
            style: e.style,
            styleSpec: e.styleSpec,
            arrayElementValidator: f
        })), V(r) === `array` && r.length === 0 && t.push(new N(e.key, r, `array must have at least one stop`)), t;
    }
    function f(e) {
        let n = [], r = e.value, s = e.key;
        if (V(r) !== `array`) return [
            new N(s, r, `array expected, ${V(r)} found`)
        ];
        if (r.length !== 2) return [
            new N(s, r, `array length 2 expected, length ${r.length} found`)
        ];
        if (l) {
            if (V(r[0]) !== `object`) return [
                new N(s, r, `object expected, ${V(r[0])} found`)
            ];
            if (r[0].zoom === void 0) return [
                new N(s, r, `object stop key must have zoom`)
            ];
            if (r[0].value === void 0) return [
                new N(s, r, `object stop key must have value`)
            ];
            if (o && o > Ds(r[0].zoom)) return [
                new N(s, r[0].zoom, `stop zoom values must appear in ascending order`)
            ];
            Ds(r[0].zoom) !== o && (o = Ds(r[0].zoom), a = void 0, i = {}), n = n.concat(ks({
                key: `${s}[0]`,
                value: r[0],
                valueSpec: {
                    zoom: {}
                },
                validateSpec: e.validateSpec,
                style: e.style,
                styleSpec: e.styleSpec,
                objectElementValidators: {
                    zoom: js,
                    value: p
                }
            }));
        } else n = n.concat(p({
            key: `${s}[0]`,
            value: r[0],
            valueSpec: {},
            validateSpec: e.validateSpec,
            style: e.style,
            styleSpec: e.styleSpec
        }, r));
        return Wo(Os(r[1])) ? n.concat([
            new N(`${s}[1]`, r[1], `expressions are not allowed in function stops.`)
        ]) : n.concat(e.validateSpec({
            key: `${s}[1]`,
            value: r[1],
            valueSpec: t,
            validateSpec: e.validateSpec,
            style: e.style,
            styleSpec: e.styleSpec
        }));
    }
    function p(e, o) {
        let s = V(e.value), c = Ds(e.value), l = e.value === null ? o : e.value;
        if (!r) r = s;
        else if (s !== r) return [
            new N(e.key, l, `${s} stop domain type must match previous stop domain type ${r}`)
        ];
        if (s !== `number` && s !== `string` && s !== `boolean`) return [
            new N(e.key, l, `stop domain value must be a number, string, or boolean`)
        ];
        if (s !== `number` && n !== `categorical`) {
            let r = `number expected, ${s} found`;
            return Eo(t) && n === void 0 && (r += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                new N(e.key, l, r)
            ];
        }
        return n === `categorical` && s === `number` && (!isFinite(c) || Math.floor(c) !== c) ? [
            new N(e.key, l, `integer expected, found ${c}`)
        ] : n !== `categorical` && s === `number` && a !== void 0 && c < a ? [
            new N(e.key, l, `stop domain values must appear in ascending order`)
        ] : (a = c, n === `categorical` && c in i ? [
            new N(e.key, l, `stop domain values must be unique`)
        ] : (i[c] = !0, []));
    }
    function m(e) {
        return e.validateSpec({
            key: e.key,
            value: e.value,
            valueSpec: t,
            validateSpec: e.validateSpec,
            style: e.style,
            styleSpec: e.styleSpec
        });
    }
}
function Ns(e) {
    let t = (e.expressionContext === `property` ? Yo : Go)(Os(e.value), e.key, e.valueSpec);
    if (t.result === `error`) return t.value.map((t)=>new N(`${e.key}${t.key}`, e.value, t.message));
    let n = t.value.expression || t.value._styleExpression.expression;
    if (e.expressionContext === `property` && e.propertyKey === `text-font` && !n.outputDefined()) return [
        new N(e.key, e.value, `Invalid data expression for "${e.propertyKey}". Output values must be contained as literals within the expression.`)
    ];
    if (e.expressionContext === `property` && e.propertyType === `layout` && !So(n)) return [
        new N(e.key, e.value, `"feature-state" data expressions are not supported with layout properties.`)
    ];
    if (e.expressionContext === `filter` && !So(n)) return [
        new N(e.key, e.value, `"feature-state" data expressions are not supported with filters.`)
    ];
    if (e.expressionContext && e.expressionContext.indexOf(`cluster`) === 0) {
        if (!Co(n, [
            `zoom`,
            `feature-state`
        ])) return [
            new N(e.key, e.value, `"zoom" and "feature-state" expressions are not supported with cluster properties.`)
        ];
        if (e.expressionContext === `cluster-initial` && !xo(n)) return [
            new N(e.key, e.value, `Feature data expressions are not supported with initial expression part of cluster properties.`)
        ];
    }
    return [];
}
function Ps(e) {
    let t = e.value, n = e.key, r = V(t);
    return r === `boolean` ? [] : [
        new N(n, t, `boolean expected, ${r} found`)
    ];
}
function Fs(e) {
    let t = e.key, n = e.value, r = V(n);
    return r === `string` ? z.parse(String(n)) ? [] : [
        new N(t, n, `color expected, "${n}" found`)
    ] : [
        new N(t, n, `color expected, ${r} found`)
    ];
}
function Is(e) {
    let t = e.key, n = e.value, r = e.valueSpec, i = [];
    return Array.isArray(r.values) ? r.values.indexOf(Ds(n)) === -1 && i.push(new N(t, n, `expected one of [${r.values.join(`, `)}], ${JSON.stringify(n)} found`)) : Object.keys(r.values).indexOf(Ds(n)) === -1 && i.push(new N(t, n, `expected one of [${Object.keys(r.values).join(`, `)}], ${JSON.stringify(n)} found`)), i;
}
function Ls(e, t) {
    let n = e;
    for (let e of t)n = n[e];
    return n;
}
function Rs(e, t) {
    let n = us(t);
    return n ? [
        new N(`${e.key}${n.path.map((e)=>`[${e}]`).join(``)}`, Ls(e.value, n.path), cs(n.legacyFilter), null, `warning`)
    ] : [];
}
function zs(e) {
    let t = Os(e.value);
    return as(t) ? [
        ...Rs(e, t),
        ...Ns(ko({}, e, {
            expressionContext: `filter`,
            valueSpec: {
                value: `boolean`
            }
        }))
    ] : Bs(e);
}
function Bs(e) {
    let t = e.value, n = e.key;
    if (V(t) !== `array`) return [
        new N(n, t, `array expected, ${V(t)} found`)
    ];
    let r = e.styleSpec, i, a = [];
    if (t.length < 1) return [
        new N(n, t, `filter array must have at least 1 element`)
    ];
    switch(a = a.concat(Is({
        key: `${n}[0]`,
        value: t[0],
        valueSpec: r.filter_operator,
        style: e.style,
        styleSpec: e.styleSpec
    })), Ds(t[0])){
        case `<`:
        case `<=`:
        case `>`:
        case `>=`:
            t.length >= 2 && Ds(t[1]) === `$type` && a.push(new N(n, t, `"$type" cannot be use with operator "${t[0]}"`));
        case `==`:
        case `!=`:
            t.length !== 3 && a.push(new N(n, t, `filter array for operator "${t[0]}" must have 3 elements`));
        case `in`:
        case `!in`:
            t.length >= 2 && (i = V(t[1]), i !== `string` && a.push(new N(`${n}[1]`, t[1], `string expected, ${i} found`)));
            for(let o = 2; o < t.length; o++)i = V(t[o]), Ds(t[1]) === `$type` ? a = a.concat(Is({
                key: `${n}[${o}]`,
                value: t[o],
                valueSpec: r.geometry_type,
                style: e.style,
                styleSpec: e.styleSpec
            })) : i !== `string` && i !== `number` && i !== `boolean` && a.push(new N(`${n}[${o}]`, t[o], `string, number, or boolean expected, ${i} found`));
            break;
        case `any`:
        case `all`:
        case `none`:
            for(let r = 1; r < t.length; r++)a = a.concat(Bs({
                key: `${n}[${r}]`,
                value: t[r],
                style: e.style,
                styleSpec: e.styleSpec
            }));
            break;
        case `has`:
        case `!has`:
            i = V(t[1]), t.length === 2 ? i !== `string` && a.push(new N(`${n}[1]`, t[1], `string expected, ${i} found`)) : a.push(new N(n, t, `filter array for "${t[0]}" operator must have 2 elements`));
            break;
    }
    return a;
}
function Vs(e, t) {
    let n = e.key, r = e.validateSpec, i = e.style, a = e.styleSpec, o = e.value, s = e.objectKey, c = a[`${t}_${e.layerType}`];
    if (!c) return [];
    let l = s.match(/^(.*)-transition$/);
    if (t === `paint` && l && c[l[1]] && c[l[1]].transition) return r({
        key: n,
        value: o,
        valueSpec: a.transition,
        style: i,
        styleSpec: a
    });
    let u = e.valueSpec || c[s];
    if (!u) return [
        new N(n, o, `unknown property "${s}"`)
    ];
    let d;
    if (V(o) === `string` && Eo(u) && !u.tokens && (d = /^{([^}]+)}$/.exec(o))) return [
        new N(n, o, `"${s}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(d[1])} }\`.`)
    ];
    let f = [];
    return e.layerType === `symbol` && s === `text-font` && Ao(Os(o)) && Ds(o.type) === `identity` && f.push(new N(n, o, `"text-font" does not support identity functions`)), f.concat(r({
        key: e.key,
        value: o,
        valueSpec: u,
        style: i,
        styleSpec: a,
        expressionContext: `property`,
        propertyType: t,
        propertyKey: s
    }));
}
function Hs(e) {
    return Vs(e, `paint`);
}
function Us(e) {
    return Vs(e, `layout`);
}
function Ws(e) {
    let t = [], n = e.value, r = e.key, i = e.style, a = e.styleSpec;
    if (V(n) !== `object`) return [
        new N(r, n, `object expected, ${V(n)} found`)
    ];
    !n.type && !n.ref && t.push(new N(r, n, `either "type" or "ref" is required`));
    let o = Ds(n.type), s = Ds(n.ref);
    if (n.id) {
        let a = Ds(n.id);
        for(let o = 0; o < e.arrayIndex; o++){
            let e = i.layers[o];
            Ds(e.id) === a && t.push(new N(r, n.id, `duplicate layer id "${n.id}", previously used at line ${e.id.__line__}`));
        }
    }
    if (`ref` in n) {
        [
            `type`,
            `source`,
            `source-layer`,
            `filter`,
            `layout`
        ].forEach((e)=>{
            e in n && t.push(new N(r, n[e], `"${e}" is prohibited for ref layers`));
        });
        let e;
        i.layers.forEach((t)=>{
            Ds(t.id) === s && (e = t);
        }), e ? e.ref ? t.push(new N(r, n.ref, `ref cannot reference another ref layer`)) : o = Ds(e.type) : t.push(new N(r, n.ref, `ref layer "${s}" not found`));
    } else if (o !== `background`) {
        if (!n.source) t.push(new N(r, n, `missing required property "source"`));
        else {
            let e = i.sources && i.sources[n.source], a = e && Ds(e.type);
            e ? a === `vector` && o === `raster` ? t.push(new N(r, n.source, `layer "${n.id}" requires a raster source`)) : a !== `raster-dem` && o === `hillshade` || a !== `raster-dem` && o === `color-relief` ? t.push(new N(r, n.source, `layer "${n.id}" requires a raster-dem source`)) : a === `raster` && o !== `raster` ? t.push(new N(r, n.source, `layer "${n.id}" requires a vector source`)) : a === `vector` && !n[`source-layer`] ? t.push(new N(r, n, `layer "${n.id}" must specify a "source-layer"`)) : a === `raster-dem` && o !== `hillshade` && o !== `color-relief` ? t.push(new N(r, n.source, `raster-dem source can only be used with layer type 'hillshade' or 'color-relief'.`)) : o === `line` && n.paint && n.paint[`line-gradient`] && (a !== `geojson` || !e.lineMetrics) && t.push(new N(r, n, `layer "${n.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : t.push(new N(r, n.source, `source "${n.source}" not found`));
        }
    }
    return o === `raster` && n.paint?.resampling && n.paint?.[`raster-resampling`] && t.push(new N(r, n.paint, `layer "${n.id}" redundantly specifies "resampling" and "raster-resampling" paint properties, but only one is allowed. It is advised to use "resampling".`)), t = t.concat(ks({
        key: r,
        value: n,
        valueSpec: a.layer,
        style: e.style,
        styleSpec: e.styleSpec,
        validateSpec: e.validateSpec,
        objectElementValidators: {
            "*" () {
                return [];
            },
            type () {
                return e.validateSpec({
                    key: `${r}.type`,
                    value: n.type,
                    valueSpec: a.layer.type,
                    style: e.style,
                    styleSpec: e.styleSpec,
                    validateSpec: e.validateSpec,
                    object: n,
                    objectKey: `type`
                });
            },
            filter: zs,
            layout (e) {
                return ks({
                    layer: n,
                    key: e.key,
                    value: e.value,
                    style: e.style,
                    styleSpec: e.styleSpec,
                    validateSpec: e.validateSpec,
                    objectElementValidators: {
                        "*" (e) {
                            return Us(ko({
                                layerType: o
                            }, e));
                        }
                    }
                });
            },
            paint (e) {
                return ks({
                    layer: n,
                    key: e.key,
                    value: e.value,
                    style: e.style,
                    styleSpec: e.styleSpec,
                    validateSpec: e.validateSpec,
                    objectElementValidators: {
                        "*" (e) {
                            return Hs(ko({
                                layerType: o
                            }, e));
                        }
                    }
                });
            }
        }
    })), t;
}
function Gs(e) {
    let t = e.value, n = e.key, r = V(t);
    return r === `string` ? [] : [
        new N(n, t, `string expected, ${r} found`)
    ];
}
function Ks(e) {
    let t = e.sourceName ?? ``, n = e.value, r = e.styleSpec, i = r.source_raster_dem, a = e.style, o = [], s = V(n);
    if (n === void 0) return o;
    if (s !== `object`) return o.push(new N(`source_raster_dem`, n, `object expected, ${s} found`)), o;
    let c = Ds(n.encoding) === `custom`, l = [
        `redFactor`,
        `greenFactor`,
        `blueFactor`,
        `baseShift`
    ], u = e.value.encoding ? `"${e.value.encoding}"` : `Default`;
    for(let s in n)!c && l.includes(s) ? o.push(new N(s, n[s], `In "${t}": "${s}" is only valid when "encoding" is set to "custom". ${u} encoding found`)) : i[s] ? o = o.concat(e.validateSpec({
        key: s,
        value: n[s],
        valueSpec: i[s],
        validateSpec: e.validateSpec,
        style: a,
        styleSpec: r
    })) : o.push(new N(s, n[s], `unknown property "${s}"`));
    return o;
}
const qs = {
    promoteId: Ys
};
function Js(e) {
    let t = e.value, n = e.key, r = e.styleSpec, i = e.style, a = e.validateSpec;
    if (!t.type) return [
        new N(n, t, `"type" is required`)
    ];
    let o = Ds(t.type), s;
    switch(o){
        case `vector`:
        case `raster`:
            return s = ks({
                key: n,
                value: t,
                valueSpec: r[`source_${o.replace(`-`, `_`)}`],
                style: e.style,
                styleSpec: r,
                objectElementValidators: qs,
                validateSpec: a
            }), s;
        case `raster-dem`:
            return s = Ks({
                sourceName: n,
                value: t,
                style: e.style,
                styleSpec: r,
                validateSpec: a
            }), s;
        case `geojson`:
            if (s = ks({
                key: n,
                value: t,
                valueSpec: r.source_geojson,
                style: i,
                styleSpec: r,
                validateSpec: a,
                objectElementValidators: qs
            }), t.cluster) for(let e in t.clusterProperties){
                let [r, i] = t.clusterProperties[e], o = typeof r == `string` ? [
                    r,
                    [
                        `accumulated`
                    ],
                    [
                        `get`,
                        e
                    ]
                ] : r;
                s.push(...Ns({
                    key: `${n}.${e}.map`,
                    value: i,
                    validateSpec: a,
                    expressionContext: `cluster-map`
                })), s.push(...Ns({
                    key: `${n}.${e}.reduce`,
                    value: o,
                    validateSpec: a,
                    expressionContext: `cluster-reduce`
                }));
            }
            return s;
        case `video`:
            return ks({
                key: n,
                value: t,
                valueSpec: r.source_video,
                style: i,
                validateSpec: a,
                styleSpec: r
            });
        case `image`:
            return ks({
                key: n,
                value: t,
                valueSpec: r.source_image,
                style: i,
                validateSpec: a,
                styleSpec: r
            });
        case `canvas`:
            return [
                new N(n, null, `Please use runtime APIs to add canvas sources, rather than including them in stylesheets.`, `source.canvas`)
            ];
        default:
            return Is({
                key: `${n}.type`,
                value: t.type,
                valueSpec: {
                    values: [
                        `vector`,
                        `raster`,
                        `raster-dem`,
                        `geojson`,
                        `video`,
                        `image`
                    ]
                },
                style: i,
                validateSpec: a,
                styleSpec: r
            });
    }
}
function Ys({ key: e, value: t }) {
    if (V(t) === `string`) return Gs({
        key: e,
        value: t
    });
    {
        let n = [];
        for(let r in t)n.push(...Gs({
            key: `${e}.${r}`,
            value: t[r]
        }));
        return n;
    }
}
function Xs(e) {
    let t = e.value, n = e.styleSpec, r = n.light, i = e.style, a = [], o = V(t);
    if (t === void 0) return a;
    if (o !== `object`) return a = a.concat([
        new N(`light`, t, `object expected, ${o} found`)
    ]), a;
    for(let o in t){
        let s = o.match(/^(.*)-transition$/);
        a = s && r[s[1]] && r[s[1]].transition ? a.concat(e.validateSpec({
            key: o,
            value: t[o],
            valueSpec: n.transition,
            validateSpec: e.validateSpec,
            style: i,
            styleSpec: n
        })) : r[o] ? a.concat(e.validateSpec({
            key: o,
            value: t[o],
            valueSpec: r[o],
            validateSpec: e.validateSpec,
            style: i,
            styleSpec: n
        })) : a.concat([
            new N(o, t[o], `unknown property "${o}"`)
        ]);
    }
    return a;
}
function Zs(e) {
    let t = e.value, n = e.styleSpec, r = n.sky, i = e.style, a = V(t);
    if (t === void 0) return [];
    if (a !== `object`) return [
        new N(`sky`, t, `object expected, ${a} found`)
    ];
    let o = [];
    for(let a in t)o = r[a] ? o.concat(e.validateSpec({
        key: a,
        value: t[a],
        valueSpec: r[a],
        style: i,
        styleSpec: n
    })) : o.concat([
        new N(a, t[a], `unknown property "${a}"`)
    ]);
    return o;
}
function Qs(e) {
    let t = e.value, n = e.styleSpec, r = n.terrain, i = e.style, a = [], o = V(t);
    if (t === void 0) return a;
    if (o !== `object`) return a = a.concat([
        new N(`terrain`, t, `object expected, ${o} found`)
    ]), a;
    for(let o in t)a = r[o] ? a.concat(e.validateSpec({
        key: o,
        value: t[o],
        valueSpec: r[o],
        validateSpec: e.validateSpec,
        style: i,
        styleSpec: n
    })) : a.concat([
        new N(o, t[o], `unknown property "${o}"`)
    ]);
    return a;
}
function $s(e) {
    return Gs(e).length === 0 ? [] : Ns(e);
}
function ec(e) {
    return Gs(e).length === 0 ? [] : Ns(e);
}
function tc(e) {
    let t = e.key, n = e.value;
    if (V(n) === `array`) {
        if (n.length < 1 || n.length > 4) return [
            new N(t, n, `padding requires 1 to 4 values; ${n.length} values found`)
        ];
        let r = {
            type: `number`
        }, i = [];
        for(let a = 0; a < n.length; a++)i = i.concat(e.validateSpec({
            key: `${t}[${a}]`,
            value: n[a],
            validateSpec: e.validateSpec,
            valueSpec: r
        }));
        return i;
    } else return js({
        key: t,
        value: n,
        valueSpec: {}
    });
}
function nc(e) {
    let t = e.key, n = e.value;
    if (V(n) === `array`) {
        let r = {
            type: `number`
        };
        if (n.length < 1) return [
            new N(t, n, `array length at least 1 expected, length 0 found`)
        ];
        let i = [];
        for(let a = 0; a < n.length; a++)i = i.concat(e.validateSpec({
            key: `${t}[${a}]`,
            value: n[a],
            validateSpec: e.validateSpec,
            valueSpec: r
        }));
        return i;
    } else return js({
        key: t,
        value: n,
        valueSpec: {}
    });
}
function rc(e) {
    let t = e.key, n = e.value;
    if (V(n) === `array`) {
        if (n.length < 1) return [
            new N(t, n, `array length at least 1 expected, length 0 found`)
        ];
        let e = [];
        for(let r = 0; r < n.length; r++)e = e.concat(Fs({
            key: `${t}[${r}]`,
            value: n[r],
            valueSpec: {}
        }));
        return e;
    } else return Fs({
        key: t,
        value: n,
        valueSpec: {}
    });
}
function ic(e) {
    let t = e.key, n = e.value, r = V(n), i = e.styleSpec;
    if (r !== `array` || n.length < 1 || n.length % 2 != 0) return [
        new N(t, n, `variableAnchorOffsetCollection requires a non-empty array of even length`)
    ];
    let a = [];
    for(let r = 0; r < n.length; r += 2)a = a.concat(Is({
        key: `${t}[${r}]`,
        value: n[r],
        valueSpec: i.layout_symbol[`text-anchor`]
    })), a = a.concat(As({
        key: `${t}[${r + 1}]`,
        value: n[r + 1],
        valueSpec: {
            length: 2,
            value: `number`
        },
        validateSpec: e.validateSpec,
        style: e.style,
        styleSpec: i
    }));
    return a;
}
function ac(e) {
    let t = [], n = e.value, r = e.key;
    if (Array.isArray(n)) {
        let i = [], a = [];
        for(let o in n)n[o].id && i.includes(n[o].id) && t.push(new N(r, n, `all the sprites' ids must be unique, but ${n[o].id} is duplicated`)), i.push(n[o].id), n[o].url && a.includes(n[o].url) && t.push(new N(r, n, `all the sprites' URLs must be unique, but ${n[o].url} is duplicated`)), a.push(n[o].url), t = t.concat(ks({
            key: `${r}[${o}]`,
            value: n[o],
            valueSpec: {
                id: {
                    type: `string`,
                    required: !0
                },
                url: {
                    type: `string`,
                    required: !0
                }
            },
            validateSpec: e.validateSpec
        }));
        return t;
    } else return Gs({
        key: r,
        value: n
    });
}
function oc(e) {
    let t = e.value, n = e.styleSpec, r = n.projection, i = e.style, a = V(t);
    if (t === void 0) return [];
    if (a !== `object`) return [
        new N(`projection`, t, `object expected, ${a} found`)
    ];
    let o = [];
    for(let a in t)o = r[a] ? o.concat(e.validateSpec({
        key: a,
        value: t[a],
        valueSpec: r[a],
        style: i,
        styleSpec: n
    })) : o.concat([
        new N(a, t[a], `unknown property "${a}"`)
    ]);
    return o;
}
function sc(e) {
    let t = e.key, n = e.value;
    n = n instanceof String ? n.valueOf() : n;
    let r = V(n);
    return r === `array` && !lc(n) && !cc(n) ? [
        new N(t, n, `projection expected, invalid array ${JSON.stringify(n)} found`)
    ] : [
        `array`,
        `string`
    ].includes(r) ? [] : [
        new N(t, n, `projection expected, invalid type "${r}" found`)
    ];
}
function cc(e) {
    return !![
        `interpolate`,
        `step`,
        `literal`
    ].includes(e[0]);
}
function lc(e) {
    return Array.isArray(e) && e.length === 3 && typeof e[0] == `string` && typeof e[1] == `string` && typeof e[2] == `number`;
}
function uc(e) {
    return !!e && e.constructor === Object;
}
function dc(e) {
    return uc(e.value) ? [] : [
        new N(e.key, e.value, `object expected, ${V(e.value)} found`)
    ];
}
function fc(e) {
    let t = e.key, n = e.value, r = e.validateSpec, i = e.styleSpec, a = e.style;
    if (!uc(n)) return [
        new N(t, n, `object expected, ${V(n)} found`)
    ];
    let o = [];
    for(let e in n){
        let s = n[e], c = V(s);
        if (c === `string`) o.push(...Gs({
            key: `${t}.${e}`,
            value: s
        }));
        else if (c === `array`) {
            let n = {
                url: {
                    type: `string`,
                    required: !0
                },
                "unicode-range": {
                    type: `array`,
                    value: `string`
                }
            };
            for (let [c, l] of s.entries())o.push(...ks({
                key: `${t}.${e}[${c}]`,
                value: l,
                valueSpec: n,
                styleSpec: i,
                style: a,
                validateSpec: r
            }));
        } else o.push(new N(`${t}.${e}`, s, `string or array expected, ${c} found`));
    }
    return o;
}
const pc = {
    "*" () {
        return [];
    },
    array: As,
    boolean: Ps,
    number: js,
    color: Fs,
    constants: Es,
    enum: Is,
    filter: zs,
    function: Ms,
    layer: Ws,
    object: ks,
    source: Js,
    light: Xs,
    sky: Zs,
    terrain: Qs,
    projection: oc,
    projectionDefinition: sc,
    string: Gs,
    formatted: $s,
    resolvedImage: ec,
    padding: tc,
    numberArray: nc,
    colorArray: rc,
    variableAnchorOffsetCollection: ic,
    sprite: ac,
    state: dc,
    fontFaces: fc
};
function mc(e) {
    let t = e.value, n = e.valueSpec, r = e.styleSpec;
    return e.validateSpec = mc, n.expression && Ao(Ds(t)) ? Ms(e) : n.expression && Wo(Os(t)) ? Ns(e) : n.type && pc[n.type] ? pc[n.type](e) : ks(ko({}, e, {
        valueSpec: n.type ? r[n.type] : n
    }));
}
function hc(e) {
    let t = e.value, n = e.key, r = Gs(e);
    return r.length ? r : (t.indexOf(`{fontstack}`) === -1 && r.push(new N(n, t, `"glyphs" url must include a "{fontstack}" token`)), t.indexOf(`{range}`) === -1 && r.push(new N(n, t, `"glyphs" url must include a "{range}" token`)), r);
}
function gc(e, t = j) {
    let n = [];
    return n = n.concat(mc({
        key: ``,
        value: e,
        valueSpec: t.$root,
        styleSpec: t,
        style: e,
        validateSpec: mc,
        objectElementValidators: {
            glyphs: hc,
            "*" () {
                return [];
            }
        }
    })), e.constants && (n = n.concat(Es({
        key: `constants`,
        value: e.constants,
        style: e,
        styleSpec: t,
        validateSpec: mc
    }))), vc(n);
}
gc.source = yc(_c(Js)), gc.sprite = yc(_c(ac)), gc.glyphs = yc(_c(hc)), gc.light = yc(_c(Xs)), gc.sky = yc(_c(Zs)), gc.terrain = yc(_c(Qs)), gc.state = yc(_c(dc)), gc.layer = yc(_c(Ws)), gc.filter = yc(_c(zs)), gc.paintProperty = yc(_c(Hs)), gc.layoutProperty = yc(_c(Us));
function _c(e) {
    return function(t) {
        return e(Object.assign({}, t, {
            validateSpec: mc
        }));
    };
}
function vc(e) {
    return [].concat(e).sort((e, t)=>e.line - t.line);
}
function yc(e) {
    return function(...t) {
        return vc(e.apply(this, t));
    };
}
const bc = {
    type: `enum`,
    "property-type": `data-constant`,
    expression: {
        interpolated: !1,
        parameters: [
            `global-state`
        ]
    },
    values: {
        visible: {},
        none: {}
    },
    transition: !1,
    default: `visible`
};
var xc = class {
    constructor(e, t, n){
        this._rootKey = t, this._globalState = n, this.setValue(e);
    }
    evaluate() {
        return this._literalValue ?? this._compiledValue.evaluate({});
    }
    setValue(e) {
        if (e == null || e === `visible` || e === `none`) {
            this._literalValue = e === `none` ? `none` : `visible`, this._compiledValue = void 0, this._globalStateRefs = new Set;
            return;
        }
        let t = Go(e, this._rootKey, bc, this._globalState);
        if (t.result === `error`) throw this._literalValue = `visible`, this._compiledValue = void 0, Error(t.value.map((e)=>`${e.key}: ${e.message}`).join(`, `));
        this._literalValue = void 0, this._compiledValue = t.value, this._globalStateRefs = $o(t.value.expression);
    }
    getGlobalStateRefs() {
        return this._globalStateRefs;
    }
};
function Sc(e, t, n) {
    return new xc(e, t, n);
}
const Cc = gc, wc = new Set(Object.keys(j).filter((e)=>e.startsWith(`source_`)).map((e)=>e.slice(7).replaceAll(`_`, `-`)));
function Tc(e) {
    return Object.entries(e.sources ?? {}).filter(([, e])=>!wc.has(e.type)).map(([e])=>`sources.${e}`);
}
function Ec(e, t) {
    let n = Tc(t);
    return Dc(e, Cc(t).filter(({ message: e })=>!n.some((t)=>e.startsWith(`${t}:`) || e.startsWith(`${t}.`))));
}
function Dc(e, t) {
    let n = !1;
    for (let r of t){
        if (r.severity === `warning`) {
            Ft(r.message);
            continue;
        }
        e.fire(new Fn(Error(r.message))), n = !0;
    }
    return n;
}
function Oc(e, t, n, r) {
    return r?.validate !== !1 && Dc(e, t({
        styleSpec: j,
        ...n
    }));
}
var kc = class e {
    constructor(e, t, n){
        let r = this.cells = [];
        if (e instanceof ArrayBuffer) {
            this.arrayBuffer = e;
            let i = new Int32Array(this.arrayBuffer);
            e = i[0], t = i[1], n = i[2], this.d = t + 2 * n;
            for(let e = 0; e < this.d * this.d; e++){
                let t = i[3 + e], n = i[3 + e + 1];
                r.push(t === n ? null : i.subarray(t, n));
            }
            let a = i[3 + r.length], o = i[3 + r.length + 1];
            this.keys = i.subarray(a, o), this.bboxes = i.subarray(o), this.insert = this._insertReadonly;
        } else {
            this.d = t + 2 * n;
            for(let e = 0; e < this.d * this.d; e++)r.push([]);
            this.keys = [], this.bboxes = [];
        }
        this.n = t, this.extent = e, this.padding = n, this.scale = t / e, this.uid = 0;
        let i = n / t * e;
        this.min = -i, this.max = e + i;
    }
    insert(e, t, n, r, i) {
        this._forEachCell(t, n, r, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(e), this.bboxes.push(t), this.bboxes.push(n), this.bboxes.push(r), this.bboxes.push(i);
    }
    _insertReadonly() {
        throw Error(`Cannot insert into a GridIndex created from an ArrayBuffer.`);
    }
    _insertCell(e, t, n, r, i, a) {
        this.cells[i].push(a);
    }
    query(e, t, n, r, i) {
        let a = this.min, o = this.max;
        if (e <= a && t <= a && o <= n && o <= r && !i) return [
            ...this.keys
        ];
        {
            let a = [];
            return this._forEachCell(e, t, n, r, this._queryCell, a, {}, i), a;
        }
    }
    _queryCell(e, t, n, r, i, a, o, s) {
        let c = this.cells[i];
        if (c !== null) {
            let i = this.keys, l = this.bboxes;
            for (let u of c)if (o[u] === void 0) {
                let c = u * 4;
                (s ? s(l[c + 0], l[c + 1], l[c + 2], l[c + 3]) : e <= l[c + 2] && t <= l[c + 3] && n >= l[c + 0] && r >= l[c + 1]) ? (o[u] = !0, a.push(i[u])) : o[u] = !1;
            }
        }
    }
    _forEachCell(e, t, n, r, i, a, o, s) {
        let c = this._convertToCellCoord(e), l = this._convertToCellCoord(t), u = this._convertToCellCoord(n), d = this._convertToCellCoord(r);
        for(let f = c; f <= u; f++)for(let c = l; c <= d; c++){
            let l = this.d * c + f;
            if (!(s && !s(this._convertFromCellCoord(f), this._convertFromCellCoord(c), this._convertFromCellCoord(f + 1), this._convertFromCellCoord(c + 1))) && i.call(this, e, t, n, r, l, a, o, s)) return;
        }
    }
    _convertFromCellCoord(e) {
        return (e - this.padding) / this.scale;
    }
    _convertToCellCoord(e) {
        return Math.max(0, Math.min(this.d - 1, Math.floor(e * this.scale) + this.padding));
    }
    toArrayBuffer() {
        if (this.arrayBuffer) return this.arrayBuffer;
        let e = this.cells, t = 3 + this.cells.length + 1 + 1, n = 0;
        for (let e of this.cells)n += e.length;
        let r = new Int32Array(t + n + this.keys.length + this.bboxes.length);
        r[0] = this.extent, r[1] = this.n, r[2] = this.padding;
        let i = t;
        for(let t = 0; t < e.length; t++){
            let n = e[t];
            r[3 + t] = i, r.set(n, i), i += n.length;
        }
        return r[3 + e.length] = i, r.set(this.keys, i), i += this.keys.length, r[3 + e.length + 1] = i, r.set(this.bboxes, i), i += this.bboxes.length, r.buffer;
    }
    static serialize(e, t) {
        let n = e.toArrayBuffer();
        return t && t.push(n), {
            buffer: n
        };
    }
    static deserialize(t) {
        return new e(t.buffer);
    }
};
const Ac = {};
function H(e, t, n = {}) {
    if (Ac[e]) throw Error(`${e} is already registered.`);
    Object.defineProperty(t, "_classRegistryKey", {
        value: e,
        writeable: !1
    }), Ac[e] = {
        klass: t,
        omit: n.omit || [],
        shallow: n.shallow || []
    };
}
H(`Object`, Object), H(`Set`, Set), H(`TransferableGridIndex`, kc), H(`Color`, z), H(`Error`, Error), H(`AJAXError`, Sn), H(`ResolvedImage`, ei), H(`StylePropertyFunction`, Xo), H(`StyleExpression`, Vo, {
    omit: [
        `_evaluator`
    ]
}), H(`ZoomDependentExpression`, qo), H(`ZoomConstantExpression`, Ko), H(`CompoundExpression`, po, {
    omit: [
        `_evaluate`
    ]
});
for(let e in fo)fo[e]._classRegistryKey || H(`Expression_${e}`, fo[e]);
function jc(e) {
    return e && typeof ArrayBuffer < `u` && (e instanceof ArrayBuffer || e.constructor?.name === `ArrayBuffer`);
}
function Mc(e) {
    let t = e.constructor;
    return e.$name || t._classRegistryKey;
}
function Nc(e) {
    if (typeof e != `object` || !e) return !1;
    let t = Mc(e);
    return t && t !== `Object`;
}
function Pc(e) {
    return !Nc(e) && (e == null || typeof e == `boolean` || typeof e == `number` || typeof e == `string` || e instanceof Boolean || e instanceof Number || e instanceof String || e instanceof Date || e instanceof RegExp || e instanceof Blob || e instanceof Error || jc(e) || Ut(e) || ArrayBuffer.isView(e) || e instanceof ImageData);
}
function Fc(e, t) {
    if (Pc(e)) return (jc(e) || Ut(e)) && t && t.push(e), ArrayBuffer.isView(e) && t && t.push(e.buffer), e instanceof ImageData && t && t.push(e.data.buffer), e;
    if (Array.isArray(e)) {
        let n = [];
        for (let r of e)n.push(Fc(r, t));
        return n;
    }
    if (typeof e != `object`) throw Error(`can't serialize object of type ${typeof e}`);
    let n = Mc(e);
    if (!n) throw Error(`can't serialize object of unregistered class ${e.constructor.name}`);
    if (!Ac[n]) throw Error(`${n} is not registered.`);
    let { klass: r } = Ac[n], i = r.serialize ? r.serialize(e, t) : {};
    if (!r.serialize) {
        for(let r in e){
            if (!e.hasOwnProperty(r) || Ac[n].omit.includes(r)) continue;
            let a = e[r];
            a !== void 0 && (i[r] = Ac[n].shallow.includes(r) ? a : Fc(a, t));
        }
        e instanceof Error && (i.message = e.message);
    } else if (i === t?.[t.length - 1]) throw Error(`statically serialized object won't survive transfer of $name property`);
    if (i.$name) throw Error(`$name property is reserved for worker serialization logic.`);
    return n !== `Object` && (i.$name = n), i;
}
function Ic(e) {
    if (Pc(e)) return e;
    if (Array.isArray(e)) return e.map(Ic);
    if (typeof e != `object`) throw Error(`can't deserialize object of type ${typeof e}`);
    let t = Mc(e) || `Object`;
    if (!Ac[t]) throw Error(`can't deserialize unregistered class ${t}`);
    let { klass: n } = Ac[t];
    if (!n) throw Error(`can't deserialize unregistered class ${t}`);
    if (n.deserialize) return n.deserialize(e);
    let r = Object.create(n.prototype);
    for (let n of Object.keys(e)){
        if (n === `$name`) continue;
        let i = e[n];
        r[n] = Ac[t].shallow.includes(n) ? i : Ic(i);
    }
    return r;
}
var Lc = class {
    constructor(){
        this.first = !0;
    }
    update(e, t) {
        let n = Math.floor(e);
        return this.first ? (this.first = !1, this.lastIntegerZoom = n, this.lastIntegerZoomTime = 0, this.lastZoom = e, this.lastFloorZoom = n, !0) : (this.lastFloorZoom > n ? (this.lastIntegerZoom = n + 1, this.lastIntegerZoomTime = t) : this.lastFloorZoom < n && (this.lastIntegerZoom = n, this.lastIntegerZoomTime = t), e === this.lastZoom ? !1 : (this.lastZoom = e, this.lastFloorZoom = n, !0));
    }
};
function Rc(e) {
    return /[\u02EA\u02EB\u1100-\u11FF\u2E80-\u2FDF\u3000-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(e));
}
function zc(e) {
    return /[\u02EA\u02EB\u2E80-\u2FDF\u2FF0-\u303F\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FD-\u30FF\u3105-\u312F\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(e));
}
function Bc(e) {
    return /[\u02EA\u02EB\u1100-\u11FF\u1400-\u167F\u18B0-\u18F5\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u3007\u3012\u3013\u3020-\u302F\u3031-\u303F\u3041-\u3096\u309D-\u30FB\u30FD-\u30FF\u3105-\u312F\u3131-\u318E\u3190-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE48\uFE50-\uFE57\uFE5F-\uFE62\uFE67-\uFE6F\uFF00-\uFF07\uFF0A-\uFF0C\uFF0E-\uFF19\uFF1F-\uFF3A\uFF3C\uFF3E\uFF40-\uFF5A\uFFE0-\uFFE2\uFFE4-\uFFE7]|\uD802[\uDD80-\uDD9F]|\uD805[\uDD80-\uDDFF]|\uD806[\uDE00-\uDEBF]|\uD811[\uDC00-\uDE7F]|\uD81B[\uDFE0-\uDFE4\uDFF0-\uDFF6]|[\uD81C-\uD822\uD83D\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD30-\uDEFB]|\uD833[\uDEC0-\uDFCF]|\uD834[\uDC00-\uDDFF\uDEE0-\uDF7F]|\uD836[\uDC00-\uDEAF]|\uD83C[\uDC00-\uDE00\uDF00-\uDFFF]|\uD83E[\uDD00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(e));
}
function Vc(e) {
    return /[\xA7\xA9\xAE\xB1\xBC-\xBE\xD7\xF7\u2016\u2020\u2021\u2030\u2031\u203B\u203C\u2042\u2047-\u2049\u2051\u2100-\u218F\u221E\u2234\u2235\u2300-\u2307\u230C-\u231F\u2324-\u2328\u232B\u237D-\u239A\u23BE-\u23CD\u23CF\u23D1-\u23DB\u23E2-\u2422\u2424-\u24FF\u25A0-\u2619\u2620-\u2767\u2776-\u2793\u2B12-\u2B2F\u2B50-\u2B59\u2BB8-\u2BEB\u3000-\u303F\u30A0-\u30FF\uE000-\uF8FF\uFE30-\uFE6F\uFF00-\uFFEF\uFFFC\uFFFD]|[\uDB80-\uDBFF][\uDC00-\uDFFF]/gim.test(String.fromCodePoint(e));
}
function Hc(e) {
    return /[\u0900-\u0DFF\u0F00-\u109F\u1780-\u17FF]/gim.test(String.fromCodePoint(e));
}
function Uc(e) {
    return /\s/u.test(String.fromCodePoint(e));
}
function Wc(e) {
    for (let t of e)if (Bc(t.codePointAt(0))) return !0;
    return !1;
}
function Gc(e) {
    for (let t of e)if (!Jc(t.codePointAt(0))) return !1;
    return !0;
}
function Kc(e) {
    let t = e.map((e)=>{
        try {
            return RegExp(`\\p{sc=${e}}`, `u`).source;
        } catch  {
            return null;
        }
    }).filter((e)=>e);
    return new RegExp(t.join(`|`), `u`);
}
const qc = Kc([
    `Arab`,
    `Dupl`,
    `Mong`,
    `Ougr`,
    `Syrc`
]);
function Jc(e) {
    return !qc.test(String.fromCodePoint(e));
}
function Yc(e) {
    return !(Bc(e) || Vc(e));
}
function Xc(e) {
    return /\p{sc=Arab}/u.test(String.fromCodePoint(e));
}
const Zc = Kc(`Adlm.Arab.Armi.Avst.Chrs.Cprt.Egyp.Elym.Gara.Hatr.Hebr.Hung.Khar.Lydi.Mand.Mani.Mend.Merc.Mero.Narb.Nbat.Nkoo.Orkh.Palm.Phli.Phlp.Phnx.Prti.Rohg.Samr.Sarb.Sogo.Syrc.Thaa.Todr.Yezi`.split(`.`));
function Qc(e) {
    return Zc.test(String.fromCodePoint(e));
}
function $c(e, t) {
    return !t && Qc(e) ? !1 : !Hc(e);
}
function el(e) {
    for (let t of e)if (Qc(t.codePointAt(0))) return !0;
    return !1;
}
function tl(e, t) {
    for (let n of e)if (!$c(n.codePointAt(0), t)) return !1;
    return !0;
}
const nl = new class {
    constructor(){
        this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = `unavailable`, this.pluginURL = null, this.loadScriptResolve = ()=>{};
    }
    setState(e) {
        this.pluginStatus = e.pluginStatus, this.pluginURL = e.pluginURL;
    }
    getState() {
        return {
            pluginStatus: this.pluginStatus,
            pluginURL: this.pluginURL
        };
    }
    setMethods(e) {
        if (nl.isParsed()) throw Error(`RTL text plugin already registered.`);
        this.applyArabicShaping = e.applyArabicShaping, this.processBidirectionalText = e.processBidirectionalText, this.processStyledBidirectionalText = e.processStyledBidirectionalText, this.loadScriptResolve();
    }
    isParsed() {
        return this.applyArabicShaping != null && this.processBidirectionalText != null && this.processStyledBidirectionalText != null;
    }
    getRTLTextPluginStatus() {
        return this.pluginStatus;
    }
    async syncState(e, t) {
        if (this.isParsed()) return this.getState();
        if (e.pluginStatus !== `loading`) return this.setState(e), e;
        let n = e.pluginURL, r = new Promise((e)=>{
            this.loadScriptResolve = e;
        }), i = new Promise((e)=>setTimeout(()=>e(), this.TIMEOUT));
        if (await t(n), await Promise.race([
            r,
            i
        ]), this.isParsed()) {
            let e = {
                pluginStatus: `loaded`,
                pluginURL: n
            };
            return this.setState(e), e;
        }
        throw this.setState({
            pluginStatus: `error`,
            pluginURL: ``
        }), Error(`RTL Text Plugin failed to import scripts from ${n}`);
    }
};
var U = class {
    constructor(e, t){
        this.isSupportedScript = rl, this.zoom = e, t ? (this.now = t.now || 0, this.fadeDuration = t.fadeDuration || 0, this.zoomHistory = t.zoomHistory || new Lc, this.transition = t.transition || {}) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Lc, this.transition = {});
    }
    crossFadingFactor() {
        return this.fadeDuration === 0 ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
    }
    getCrossfadeParameters() {
        let e = this.zoom, t = e - Math.floor(e), n = this.crossFadingFactor();
        return e > this.zoomHistory.lastIntegerZoom ? {
            fromScale: 2,
            toScale: 1,
            t: t + (1 - t) * n
        } : {
            fromScale: .5,
            toScale: 1,
            t: 1 - (1 - n) * t
        };
    }
};
function rl(e) {
    return tl(e, nl.getRTLTextPluginStatus() === `loaded`);
}
const il = `-transition`;
var al = class {
    constructor(e, t, n, r){
        this.property = e, this.value = t, this.expression = Zo(t === void 0 ? e.specification.default : t, n, e.specification, r);
    }
    isDataDriven() {
        return this.expression.kind === `source` || this.expression.kind === `composite`;
    }
    getGlobalStateRefs() {
        return this.expression.globalStateRefs || new Set;
    }
    possiblyEvaluate(e, t, n) {
        return this.property.possiblyEvaluate(this, e, t, n);
    }
}, ol = class {
    constructor(e, t, n){
        this.property = e, this.value = new al(e, void 0, t, n);
    }
    transitioned(e, t) {
        return new cl(this.property, this.value, t, xt({}, e.transition, this.transition), e.now);
    }
    untransitioned() {
        return new cl(this.property, this.value, null, {}, 0);
    }
}, sl = class {
    constructor(e, t, n){
        this._properties = e, this._values = Object.create(e.defaultTransitionablePropertyValues), this._globalState = n, this._rootKey = t;
    }
    _propertyRootKey(e) {
        return `${this._rootKey}.${String(e)}`;
    }
    hasProperty(e) {
        return e in this._properties.defaultTransitionablePropertyValues;
    }
    getValue(e) {
        return Nt(this._values[e].value.value);
    }
    setValue(e, t) {
        Object.hasOwn(this._values, e) || (this._values[e] = new ol(this._values[e].property, this._propertyRootKey(e), this._globalState)), this._values[e].value = new al(this._values[e].property, t === null ? void 0 : Nt(t), this._propertyRootKey(e), this._globalState);
    }
    getTransition(e) {
        return Nt(this._values[e].transition);
    }
    setTransition(e, t) {
        Object.hasOwn(this._values, e) || (this._values[e] = new ol(this._values[e].property, this._propertyRootKey(e), this._globalState)), this._values[e].transition = Nt(t) || void 0;
    }
    serialize() {
        let e = {};
        for (let t of Object.keys(this._values)){
            let n = this.getValue(t);
            n !== void 0 && (e[t] = n);
            let r = this.getTransition(t);
            r !== void 0 && (e[`${t}${il}`] = r);
        }
        return e;
    }
    transitioned(e, t) {
        let n = new ll(this._properties);
        for (let r of Object.keys(this._values))n._values[r] = this._values[r].transitioned(e, t._values[r]);
        return n;
    }
    untransitioned() {
        let e = new ll(this._properties);
        for (let t of Object.keys(this._values))e._values[t] = this._values[t].untransitioned();
        return e;
    }
}, cl = class {
    constructor(e, t, n, r, i){
        this.property = e, this.value = t, this.begin = i + r.delay || 0, this.end = this.begin + r.duration || 0, e.specification.transition && (r.delay || r.duration) && (this.prior = n);
    }
    possiblyEvaluate(e, t, n) {
        let r = e.now || 0, i = this.value.possiblyEvaluate(e, t, n), a = this.prior;
        if (!a) return i;
        if (r > this.end || this.value.isDataDriven()) return this.prior = null, i;
        if (r < this.begin) return a.possiblyEvaluate(e, t, n);
        {
            let o = (r - this.begin) / (this.end - this.begin);
            return this.property.interpolate(a.possiblyEvaluate(e, t, n), i, gt(o));
        }
    }
}, ll = class {
    constructor(e){
        this._properties = e, this._values = Object.create(e.defaultTransitioningPropertyValues);
    }
    possiblyEvaluate(e, t, n) {
        let r = new fl(this._properties);
        for (let i of Object.keys(this._values))r._values[i] = this._values[i].possiblyEvaluate(e, t, n);
        return r;
    }
    hasTransition() {
        for (let e of Object.keys(this._values))if (this._values[e].prior) return !0;
        return !1;
    }
}, ul = class {
    constructor(e, t, n){
        this._properties = e, this._values = Object.create(e.defaultPropertyValues), this._globalState = n, this._rootKey = t;
    }
    _propertyRootKey(e) {
        return `${this._rootKey}.${String(e)}`;
    }
    hasValue(e) {
        return this._values[e].value !== void 0;
    }
    hasProperty(e) {
        return e in this._properties.defaultPropertyValues;
    }
    getValue(e) {
        return Nt(this._values[e].value);
    }
    setValue(e, t) {
        this._values[e] = new al(this._values[e].property, t === null ? void 0 : Nt(t), this._propertyRootKey(e), this._globalState);
    }
    serialize() {
        let e = {};
        for (let t of Object.keys(this._values)){
            let n = this.getValue(t);
            n !== void 0 && (e[t] = n);
        }
        return e;
    }
    possiblyEvaluate(e, t, n) {
        let r = new fl(this._properties);
        for (let i of Object.keys(this._values))r._values[i] = this._values[i].possiblyEvaluate(e, t, n);
        return r;
    }
}, dl = class {
    constructor(e, t, n){
        this.property = e, this.value = t, this.parameters = n;
    }
    isConstant() {
        return this.value.kind === `constant`;
    }
    constantOr(e) {
        return this.value.kind === `constant` ? this.value.value : e;
    }
    evaluate(e, t, n, r) {
        return this.property.evaluate(this.value, this.parameters, e, t, n, r);
    }
}, fl = class {
    constructor(e){
        this._properties = e, this._values = Object.create(e.defaultPossiblyEvaluatedValues);
    }
    get(e) {
        return this._values[e];
    }
}, W = class {
    constructor(e, t){
        this.specification = e, this.name = t;
    }
    possiblyEvaluate(e, t) {
        if (e.isDataDriven()) throw Error(`Value should not be data driven`);
        return e.expression.evaluate(t);
    }
    interpolate(e, t, n) {
        let r = Di[this.specification.type];
        return r ? r(e, t, n) : e;
    }
}, G = class {
    constructor(e, t, n){
        this.specification = e, this.name = t, this.overrides = n;
    }
    possiblyEvaluate(e, t, n, r) {
        return e.expression.kind === `constant` || e.expression.kind === `camera` ? new dl(this, {
            kind: `constant`,
            value: e.expression.evaluate(t, null, {}, n, r)
        }, t) : new dl(this, e.expression, t);
    }
    interpolate(e, t, n) {
        if (e.value.kind !== `constant` || t.value.kind !== `constant`) return e;
        if (e.value.value === void 0 || t.value.value === void 0) return new dl(this, {
            kind: `constant`,
            value: void 0
        }, e.parameters);
        let r = Di[this.specification.type];
        if (r) {
            let i = r(e.value.value, t.value.value, n);
            return new dl(this, {
                kind: `constant`,
                value: i
            }, e.parameters);
        } else return e;
    }
    evaluate(e, t, n, r, i, a) {
        return e.kind === `constant` ? e.value : e.evaluate(t, n, r, i, a);
    }
}, pl = class extends G {
    possiblyEvaluate(e, t, n, r) {
        if (e.value === void 0) return new dl(this, {
            kind: `constant`,
            value: void 0
        }, t);
        if (e.expression.kind === `constant`) {
            let i = e.expression.evaluate(t, null, {}, n, r), a = e.property.specification.type === `resolvedImage` && typeof i != `string` ? i.name : i, o = this._calculate(a, a, a, t);
            return new dl(this, {
                kind: `constant`,
                value: o
            }, t);
        } else if (e.expression.kind === `camera`) {
            let n = this._calculate(e.expression.evaluate({
                zoom: t.zoom - 1
            }), e.expression.evaluate({
                zoom: t.zoom
            }), e.expression.evaluate({
                zoom: t.zoom + 1
            }), t);
            return new dl(this, {
                kind: `constant`,
                value: n
            }, t);
        } else return new dl(this, e.expression, t);
    }
    evaluate(e, t, n, r, i, a) {
        if (e.kind === `source`) {
            let o = e.evaluate(t, n, r, i, a);
            return this._calculate(o, o, o, t);
        } else if (e.kind === `composite`) return this._calculate(e.evaluate({
            zoom: Math.floor(t.zoom) - 1
        }, n, r), e.evaluate({
            zoom: Math.floor(t.zoom)
        }, n, r), e.evaluate({
            zoom: Math.floor(t.zoom) + 1
        }, n, r), t);
        else return e.value;
    }
    _calculate(e, t, n, r) {
        return r.zoom > r.zoomHistory.lastIntegerZoom ? {
            from: e,
            to: t
        } : {
            from: n,
            to: t
        };
    }
    interpolate(e) {
        return e;
    }
}, ml = class {
    constructor(e, t){
        this.specification = e, this.name = t;
    }
    possiblyEvaluate(e, t, n, r) {
        if (e.value !== void 0) {
            if (e.expression.kind === `constant`) {
                let i = e.expression.evaluate(t, null, {}, n, r);
                return this._calculate(i, i, i, t);
            } else return this._calculate(e.expression.evaluate(new U(Math.floor(t.zoom - 1), t)), e.expression.evaluate(new U(Math.floor(t.zoom), t)), e.expression.evaluate(new U(Math.floor(t.zoom + 1), t)), t);
        }
    }
    _calculate(e, t, n, r) {
        return r.zoom > r.zoomHistory.lastIntegerZoom ? {
            from: e,
            to: t
        } : {
            from: n,
            to: t
        };
    }
    interpolate(e) {
        return e;
    }
}, hl = class {
    constructor(e, t){
        this.specification = e, this.name = t;
    }
    possiblyEvaluate(e, t, n, r) {
        return !!e.expression.evaluate(t, null, {}, n, r);
    }
    interpolate() {
        return !1;
    }
}, gl = class {
    constructor(e){
        this.properties = e, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
        for(let t in e){
            let n = e[t];
            n.specification.overridable && this.overridableProperties.push(t);
            let r = this.defaultPropertyValues[t] = new al(n, void 0, n.name, void 0), i = this.defaultTransitionablePropertyValues[t] = new ol(n, n.name, void 0);
            this.defaultTransitioningPropertyValues[t] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[t] = r.possiblyEvaluate({});
        }
    }
};
H(`DataDrivenProperty`, G), H(`DataConstantProperty`, W), H(`CrossFadedDataDrivenProperty`, pl), H(`CrossFadedProperty`, ml), H(`ColorRampProperty`, hl);
const _l = ` is a PAINT property not a LAYOUT property. Use get/setPaintProperty instead?`, vl = ` is a LAYOUT property not a PAINT property. Use get/setLayoutProperty instead?`;
var yl = class extends In {
    constructor(e, t, n){
        if (super(), this.id = e.id, this.type = e.type, this._globalState = n, this._featureFilter = {
            filter: ()=>!0,
            needGeometry: !1,
            getGlobalStateRefs: ()=>new Set
        }, this._visibilityExpression = Sc(this.visibility, `layers[${this.id}].layout.visibility`, n), e.type !== `custom` && (this.metadata = e.metadata, this.minzoom = e.minzoom, this.maxzoom = e.maxzoom, e.type !== `background` && (this.source = e.source, this.sourceLayer = e[`source-layer`], this.filter = e.filter, this._featureFilter = ps(e.filter, `layers[${this.id}].filter`, n)), t.layout && (this._unevaluatedLayout = new ul(t.layout, `layers[${this.id}].layout`, n)), t.paint)) {
            this._transitionablePaint = new sl(t.paint, `layers[${this.id}].paint`, n);
            for(let t in e.paint)this.setPaintProperty(t, e.paint[t], {
                validate: !1
            });
            for(let t in e.layout)this.setLayoutProperty(t, e.layout[t], {
                validate: !1
            });
            this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new fl(t.paint);
        }
    }
    setFilter(e) {
        this.filter = e, this._featureFilter = ps(e, `layers[${this.id}].filter`, this._globalState);
    }
    getCrossfadeParameters() {
        return this._crossfadeParameters;
    }
    getLayoutProperty(e) {
        if (e === `visibility`) return this.visibility;
        if (this._transitionablePaint?.hasProperty(e)) throw Error(e + _l);
        if (!this._unevaluatedLayout) throw Error(`Cannot get layout property "${e}" on layer type "${this.type}" which has no layout properties.`);
        return this._unevaluatedLayout.getValue(e);
    }
    getLayoutAffectingGlobalStateRefs() {
        let e = new Set;
        for (let t of this._visibilityExpression.getGlobalStateRefs())e.add(t);
        if (this._unevaluatedLayout) for(let t in this._unevaluatedLayout._values){
            let n = this._unevaluatedLayout._values[t];
            for (let t of n.getGlobalStateRefs())e.add(t);
        }
        for (let t of this._featureFilter.getGlobalStateRefs())e.add(t);
        return e;
    }
    getPaintAffectingGlobalStateRefs() {
        let e = new globalThis.Map;
        if (this._transitionablePaint) for(let t in this._transitionablePaint._values){
            let n = this._transitionablePaint._values[t].value;
            for (let r of n.getGlobalStateRefs()){
                let i = e.get(r) ?? [];
                i.push({
                    name: t,
                    value: n.value
                }), e.set(r, i);
            }
        }
        return e;
    }
    getVisibilityAffectingGlobalStateRefs() {
        return this._visibilityExpression.getGlobalStateRefs();
    }
    setLayoutProperty(e, t, n = {}) {
        if (e === `visibility`) {
            this.visibility = t, this._visibilityExpression.setValue(t), this.recalculateVisibility();
            return;
        }
        if (this._transitionablePaint?.hasProperty(e)) {
            this.fire(new Fn(Error(e + _l)));
            return;
        }
        t != null && this._validate(Cc.layoutProperty, `layers.${this.id}.layout.${e}`, e, t, n) || this._unevaluatedLayout.setValue(e, t);
    }
    getPaintProperty(e) {
        if (e.endsWith(`-transition`)) {
            let t = e.slice(0, -11);
            if (t === `visibility` || this._unevaluatedLayout?.hasProperty(t)) throw Error(e + vl);
            return this._transitionablePaint.getTransition(t);
        } else {
            if (e === `visibility` || this._unevaluatedLayout?.hasProperty(e)) throw Error(e + vl);
            return this._transitionablePaint.getValue(e);
        }
    }
    setPaintProperty(e, t, n = {}) {
        if (e === `visibility` || this._unevaluatedLayout?.hasProperty(e)) return this.fire(new Fn(Error(e + vl))), !1;
        if (t != null && this._validate(Cc.paintProperty, `layers.${this.id}.paint.${e}`, e, t, n)) return !1;
        if (e.endsWith(`-transition`)) return this._transitionablePaint.setTransition(e.slice(0, -11), t || void 0), !1;
        {
            let n = this._transitionablePaint._values[e], r = n.property.specification[`property-type`] === `cross-faded-data-driven`, i = n.value.isDataDriven(), a = n.value;
            this._transitionablePaint.setValue(e, t), this._handleSpecialPaintPropertyUpdate(e);
            let o = this._transitionablePaint._values[e].value;
            return o.isDataDriven() || i || r || this._handleOverridablePaintPropertyUpdate(e, a, o);
        }
    }
    _handleSpecialPaintPropertyUpdate(e) {}
    _handleOverridablePaintPropertyUpdate(e, t, n) {
        return !1;
    }
    isHidden(e = this.minzoom, t = !1) {
        return this.minzoom && e < (t ? Math.floor(this.minzoom) : this.minzoom) || this.maxzoom && e >= this.maxzoom ? !0 : this._evaluatedVisibility === `none`;
    }
    updateTransitions(e) {
        this._transitioningPaint = this._transitionablePaint.transitioned(e, this._transitioningPaint);
    }
    hasTransition() {
        return this._transitioningPaint.hasTransition();
    }
    recalculateVisibility() {
        this._evaluatedVisibility = this._visibilityExpression.evaluate();
    }
    recalculate(e, t) {
        e.getCrossfadeParameters && (this._crossfadeParameters = e.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(e, void 0, t)), this.paint = this._transitioningPaint.possiblyEvaluate(e, void 0, t);
    }
    serialize() {
        let e = {
            id: this.id,
            type: this.type,
            source: this.source,
            "source-layer": this.sourceLayer,
            metadata: this.metadata,
            minzoom: this.minzoom,
            maxzoom: this.maxzoom,
            filter: this.filter,
            layout: this._unevaluatedLayout?.serialize(),
            paint: this._transitionablePaint?.serialize()
        };
        return this.visibility && (e.layout ||= {}, e.layout.visibility = this.visibility), jt(e, (e, t)=>e !== void 0 && !(t === `layout` && !Object.keys(e).length) && !(t === `paint` && !Object.keys(e).length));
    }
    _validate(e, t, n, r, i = {}) {
        return Oc(this, e, {
            key: t,
            layerType: this.type,
            objectKey: n,
            value: r
        }, i);
    }
    is3D() {
        return !1;
    }
    isTileClipped() {
        return !1;
    }
    hasOffscreenPass() {
        return !1;
    }
    resize() {}
    isStateDependent() {
        for(let e in this.paint._values){
            let t = this.paint.get(e);
            if (!(!(t instanceof dl) || !Eo(t.property.specification)) && (t.value.kind === `source` || t.value.kind === `composite`) && t.value.isStateDependent) return !0;
        }
        return !1;
    }
};
let bl;
const xl = ()=>bl ||= new gl({
        "raster-opacity": new W(j.paint_raster[`raster-opacity`], `raster-opacity`),
        "raster-hue-rotate": new W(j.paint_raster[`raster-hue-rotate`], `raster-hue-rotate`),
        "raster-brightness-min": new W(j.paint_raster[`raster-brightness-min`], `raster-brightness-min`),
        "raster-brightness-max": new W(j.paint_raster[`raster-brightness-max`], `raster-brightness-max`),
        "raster-saturation": new W(j.paint_raster[`raster-saturation`], `raster-saturation`),
        "raster-contrast": new W(j.paint_raster[`raster-contrast`], `raster-contrast`),
        resampling: new W(j.paint_raster.resampling, `resampling`),
        "raster-resampling": new W(j.paint_raster[`raster-resampling`], `raster-resampling`),
        "raster-fade-duration": new W(j.paint_raster[`raster-fade-duration`], `raster-fade-duration`)
    });
var Sl = {
    get paint () {
        return xl();
    }
};
const Cl = (e)=>e.type === `raster`;
var wl = class extends yl {
    constructor(e, t){
        super(e, Sl, t);
    }
};
const Tl = {
    Int8: Int8Array,
    Uint8: Uint8Array,
    Int16: Int16Array,
    Uint16: Uint16Array,
    Int32: Int32Array,
    Uint32: Uint32Array,
    Float32: Float32Array
};
var El = class {
    constructor(e, t){
        this._structArray = e, this._pos1 = t * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
    }
}, K = class {
    constructor(){
        this.isTransferred = !1, this.capacity = -1, this.resize(0);
    }
    static serialize(e, t) {
        return e._trim(), t && (e.isTransferred = !0, t.push(e.arrayBuffer)), {
            length: e.length,
            arrayBuffer: e.arrayBuffer
        };
    }
    static deserialize(e) {
        let t = Object.create(this.prototype);
        return t.arrayBuffer = e.arrayBuffer, t.length = e.length, t.capacity = e.arrayBuffer.byteLength / t.bytesPerElement, t._refreshViews(), t;
    }
    _trim() {
        this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
    }
    clear() {
        this.length = 0;
    }
    resize(e) {
        this.reserve(e), this.length = e;
    }
    reserve(e) {
        if (e > this.capacity) {
            this.capacity = Math.max(e, Math.floor(this.capacity * 5), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
            let t = this.uint8;
            this._refreshViews(), t && this.uint8.set(t);
        }
    }
    _refreshViews() {
        throw Error(`_refreshViews() must be implemented by each concrete StructArray layout`);
    }
    freeBufferAfterUpload() {
        this.arrayBuffer = new ArrayBuffer(0), this._refreshViews();
    }
};
function q(e, t = 1) {
    let n = 0, r = 0;
    return {
        members: e.map((e)=>{
            let i = Dl(e.type), a = n = Ol(n, Math.max(t, i)), o = e.components || 1;
            return r = Math.max(r, i), n += i * o, {
                name: e.name,
                type: e.type,
                components: o,
                offset: a
            };
        }),
        size: Ol(n, Math.max(r, t)),
        alignment: t
    };
}
function Dl(e) {
    return Tl[e].BYTES_PER_ELEMENT;
}
function Ol(e, t) {
    return Math.ceil(e / t) * t;
}
var kl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e, t) {
        let n = this.length;
        return this.resize(n + 1), this.emplace(n, e, t);
    }
    emplace(e, t, n) {
        let r = e * 2;
        return this.int16[r + 0] = t, this.int16[r + 1] = n, e;
    }
};
kl.prototype.bytesPerElement = 4, H(`StructArrayLayout2i4`, kl);
var Al = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n) {
        let r = this.length;
        return this.resize(r + 1), this.emplace(r, e, t, n);
    }
    emplace(e, t, n, r) {
        let i = e * 3;
        return this.int16[i + 0] = t, this.int16[i + 1] = n, this.int16[i + 2] = r, e;
    }
};
Al.prototype.bytesPerElement = 6, H(`StructArrayLayout3i6`, Al);
var jl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r) {
        let i = this.length;
        return this.resize(i + 1), this.emplace(i, e, t, n, r);
    }
    emplace(e, t, n, r, i) {
        let a = e * 4;
        return this.int16[a + 0] = t, this.int16[a + 1] = n, this.int16[a + 2] = r, this.int16[a + 3] = i, e;
    }
};
jl.prototype.bytesPerElement = 8, H(`StructArrayLayout4i8`, jl);
var Ml = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a) {
        let o = this.length;
        return this.resize(o + 1), this.emplace(o, e, t, n, r, i, a);
    }
    emplace(e, t, n, r, i, a, o) {
        let s = e * 6;
        return this.int16[s + 0] = t, this.int16[s + 1] = n, this.int16[s + 2] = r, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, e;
    }
};
Ml.prototype.bytesPerElement = 12, H(`StructArrayLayout2i4i12`, Ml);
var Nl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a) {
        let o = this.length;
        return this.resize(o + 1), this.emplace(o, e, t, n, r, i, a);
    }
    emplace(e, t, n, r, i, a, o) {
        let s = e * 4, c = e * 8;
        return this.int16[s + 0] = t, this.int16[s + 1] = n, this.uint8[c + 4] = r, this.uint8[c + 5] = i, this.uint8[c + 6] = a, this.uint8[c + 7] = o, e;
    }
};
Nl.prototype.bytesPerElement = 8, H(`StructArrayLayout2i4ub8`, Nl);
var Pl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e, t) {
        let n = this.length;
        return this.resize(n + 1), this.emplace(n, e, t);
    }
    emplace(e, t, n) {
        let r = e * 2;
        return this.float32[r + 0] = t, this.float32[r + 1] = n, e;
    }
};
Pl.prototype.bytesPerElement = 8, H(`StructArrayLayout2f8`, Pl);
var Fl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a, o, s, c, l) {
        let u = this.length;
        return this.resize(u + 1), this.emplace(u, e, t, n, r, i, a, o, s, c, l);
    }
    emplace(e, t, n, r, i, a, o, s, c, l, u) {
        let d = e * 10;
        return this.uint16[d + 0] = t, this.uint16[d + 1] = n, this.uint16[d + 2] = r, this.uint16[d + 3] = i, this.uint16[d + 4] = a, this.uint16[d + 5] = o, this.uint16[d + 6] = s, this.uint16[d + 7] = c, this.uint16[d + 8] = l, this.uint16[d + 9] = u, e;
    }
};
Fl.prototype.bytesPerElement = 20, H(`StructArrayLayout10ui20`, Fl);
var Il = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a, o, s) {
        let c = this.length;
        return this.resize(c + 1), this.emplace(c, e, t, n, r, i, a, o, s);
    }
    emplace(e, t, n, r, i, a, o, s, c) {
        let l = e * 8;
        return this.uint16[l + 0] = t, this.uint16[l + 1] = n, this.uint16[l + 2] = r, this.uint16[l + 3] = i, this.uint16[l + 4] = a, this.uint16[l + 5] = o, this.uint16[l + 6] = s, this.uint16[l + 7] = c, e;
    }
};
Il.prototype.bytesPerElement = 16, H(`StructArrayLayout8ui16`, Il);
var Ll = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a, o, s, c, l, u, d) {
        let f = this.length;
        return this.resize(f + 1), this.emplace(f, e, t, n, r, i, a, o, s, c, l, u, d);
    }
    emplace(e, t, n, r, i, a, o, s, c, l, u, d, f) {
        let p = e * 12;
        return this.int16[p + 0] = t, this.int16[p + 1] = n, this.int16[p + 2] = r, this.int16[p + 3] = i, this.uint16[p + 4] = a, this.uint16[p + 5] = o, this.uint16[p + 6] = s, this.uint16[p + 7] = c, this.int16[p + 8] = l, this.int16[p + 9] = u, this.int16[p + 10] = d, this.int16[p + 11] = f, e;
    }
};
Ll.prototype.bytesPerElement = 24, H(`StructArrayLayout4i4ui4i24`, Ll);
var Rl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n) {
        let r = this.length;
        return this.resize(r + 1), this.emplace(r, e, t, n);
    }
    emplace(e, t, n, r) {
        let i = e * 3;
        return this.float32[i + 0] = t, this.float32[i + 1] = n, this.float32[i + 2] = r, e;
    }
};
Rl.prototype.bytesPerElement = 12, H(`StructArrayLayout3f12`, Rl);
var zl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
    }
    emplaceBack(e) {
        let t = this.length;
        return this.resize(t + 1), this.emplace(t, e);
    }
    emplace(e, t) {
        let n = e * 1;
        return this.uint32[n + 0] = t, e;
    }
};
zl.prototype.bytesPerElement = 4, H(`StructArrayLayout1ul4`, zl);
var Bl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a, o, s, c) {
        let l = this.length;
        return this.resize(l + 1), this.emplace(l, e, t, n, r, i, a, o, s, c);
    }
    emplace(e, t, n, r, i, a, o, s, c, l) {
        let u = e * 10, d = e * 5;
        return this.int16[u + 0] = t, this.int16[u + 1] = n, this.int16[u + 2] = r, this.int16[u + 3] = i, this.int16[u + 4] = a, this.int16[u + 5] = o, this.uint32[d + 3] = s, this.uint16[u + 8] = c, this.uint16[u + 9] = l, e;
    }
};
Bl.prototype.bytesPerElement = 20, H(`StructArrayLayout6i1ul2ui20`, Bl);
var Vl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a) {
        let o = this.length;
        return this.resize(o + 1), this.emplace(o, e, t, n, r, i, a);
    }
    emplace(e, t, n, r, i, a, o) {
        let s = e * 6;
        return this.int16[s + 0] = t, this.int16[s + 1] = n, this.int16[s + 2] = r, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, e;
    }
};
Vl.prototype.bytesPerElement = 12, H(`StructArrayLayout2i2i2i12`, Vl);
var Hl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i) {
        let a = this.length;
        return this.resize(a + 1), this.emplace(a, e, t, n, r, i);
    }
    emplace(e, t, n, r, i, a) {
        let o = e * 4, s = e * 8;
        return this.float32[o + 0] = t, this.float32[o + 1] = n, this.float32[o + 2] = r, this.int16[s + 6] = i, this.int16[s + 7] = a, e;
    }
};
Hl.prototype.bytesPerElement = 16, H(`StructArrayLayout2f1f2i16`, Hl);
var Ul = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a) {
        let o = this.length;
        return this.resize(o + 1), this.emplace(o, e, t, n, r, i, a);
    }
    emplace(e, t, n, r, i, a, o) {
        let s = e * 16, c = e * 4, l = e * 8;
        return this.uint8[s + 0] = t, this.uint8[s + 1] = n, this.float32[c + 1] = r, this.float32[c + 2] = i, this.int16[l + 6] = a, this.int16[l + 7] = o, e;
    }
};
Ul.prototype.bytesPerElement = 16, H(`StructArrayLayout2ub2f2i16`, Ul);
var Wl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n) {
        let r = this.length;
        return this.resize(r + 1), this.emplace(r, e, t, n);
    }
    emplace(e, t, n, r) {
        let i = e * 3;
        return this.uint16[i + 0] = t, this.uint16[i + 1] = n, this.uint16[i + 2] = r, e;
    }
};
Wl.prototype.bytesPerElement = 6, H(`StructArrayLayout3ui6`, Wl);
var Gl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g) {
        let _ = this.length;
        return this.resize(_ + 1), this.emplace(_, e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g);
    }
    emplace(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _) {
        let v = e * 24, y = e * 12, b = e * 48;
        return this.int16[v + 0] = t, this.int16[v + 1] = n, this.uint16[v + 2] = r, this.uint16[v + 3] = i, this.uint32[y + 2] = a, this.uint32[y + 3] = o, this.uint32[y + 4] = s, this.uint16[v + 10] = c, this.uint16[v + 11] = l, this.uint16[v + 12] = u, this.float32[y + 7] = d, this.float32[y + 8] = f, this.uint8[b + 36] = p, this.uint8[b + 37] = m, this.uint8[b + 38] = h, this.uint32[y + 10] = g, this.int16[v + 22] = _, e;
    }
};
Gl.prototype.bytesPerElement = 48, H(`StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48`, Gl);
var Kl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, D) {
        let O = this.length;
        return this.resize(O + 1), this.emplace(O, e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, D);
    }
    emplace(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, D, O) {
        let k = e * 32, A = e * 16;
        return this.int16[k + 0] = t, this.int16[k + 1] = n, this.int16[k + 2] = r, this.int16[k + 3] = i, this.int16[k + 4] = a, this.int16[k + 5] = o, this.int16[k + 6] = s, this.int16[k + 7] = c, this.uint16[k + 8] = l, this.uint16[k + 9] = u, this.uint16[k + 10] = d, this.uint16[k + 11] = f, this.uint16[k + 12] = p, this.uint16[k + 13] = m, this.uint16[k + 14] = h, this.uint16[k + 15] = g, this.uint16[k + 16] = _, this.uint16[k + 17] = v, this.uint16[k + 18] = y, this.uint16[k + 19] = b, this.uint16[k + 20] = x, this.uint16[k + 21] = S, this.uint16[k + 22] = C, this.uint32[A + 12] = w, this.float32[A + 13] = T, this.float32[A + 14] = E, this.uint16[k + 30] = D, this.uint16[k + 31] = O, e;
    }
};
Kl.prototype.bytesPerElement = 64, H(`StructArrayLayout8i15ui1ul2f2ui64`, Kl);
var ql = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e) {
        let t = this.length;
        return this.resize(t + 1), this.emplace(t, e);
    }
    emplace(e, t) {
        let n = e * 1;
        return this.float32[n + 0] = t, e;
    }
};
ql.prototype.bytesPerElement = 4, H(`StructArrayLayout1f4`, ql);
var Jl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n) {
        let r = this.length;
        return this.resize(r + 1), this.emplace(r, e, t, n);
    }
    emplace(e, t, n, r) {
        let i = e * 6, a = e * 3;
        return this.uint16[i + 0] = t, this.float32[a + 1] = n, this.float32[a + 2] = r, e;
    }
};
Jl.prototype.bytesPerElement = 12, H(`StructArrayLayout1ui2f12`, Jl);
var Yl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n) {
        let r = this.length;
        return this.resize(r + 1), this.emplace(r, e, t, n);
    }
    emplace(e, t, n, r) {
        let i = e * 2, a = e * 4;
        return this.uint32[i + 0] = t, this.uint16[a + 2] = n, this.uint16[a + 3] = r, e;
    }
};
Yl.prototype.bytesPerElement = 8, H(`StructArrayLayout1ul2ui8`, Yl);
var Xl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e, t) {
        let n = this.length;
        return this.resize(n + 1), this.emplace(n, e, t);
    }
    emplace(e, t, n) {
        let r = e * 2;
        return this.uint16[r + 0] = t, this.uint16[r + 1] = n, e;
    }
};
Xl.prototype.bytesPerElement = 4, H(`StructArrayLayout2ui4`, Xl);
var Zl = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e) {
        let t = this.length;
        return this.resize(t + 1), this.emplace(t, e);
    }
    emplace(e, t) {
        let n = e * 1;
        return this.uint16[n + 0] = t, e;
    }
};
Zl.prototype.bytesPerElement = 2, H(`StructArrayLayout1ui2`, Zl);
var Ql = class extends K {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e, t, n, r) {
        let i = this.length;
        return this.resize(i + 1), this.emplace(i, e, t, n, r);
    }
    emplace(e, t, n, r, i) {
        let a = e * 4;
        return this.float32[a + 0] = t, this.float32[a + 1] = n, this.float32[a + 2] = r, this.float32[a + 3] = i, e;
    }
};
Ql.prototype.bytesPerElement = 16, H(`StructArrayLayout4f16`, Ql);
var $l = class extends El {
    get anchorPointX() {
        return this._structArray.int16[this._pos2 + 0];
    }
    get anchorPointY() {
        return this._structArray.int16[this._pos2 + 1];
    }
    get x1() {
        return this._structArray.int16[this._pos2 + 2];
    }
    get y1() {
        return this._structArray.int16[this._pos2 + 3];
    }
    get x2() {
        return this._structArray.int16[this._pos2 + 4];
    }
    get y2() {
        return this._structArray.int16[this._pos2 + 5];
    }
    get featureIndex() {
        return this._structArray.uint32[this._pos4 + 3];
    }
    get sourceLayerIndex() {
        return this._structArray.uint16[this._pos2 + 8];
    }
    get bucketIndex() {
        return this._structArray.uint16[this._pos2 + 9];
    }
    get anchorPoint() {
        return new l(this.anchorPointX, this.anchorPointY);
    }
};
$l.prototype.size = 20;
var eu = class extends Bl {
    get(e) {
        return new $l(this, e);
    }
};
H(`CollisionBoxArray`, eu);
var tu = class extends El {
    get anchorX() {
        return this._structArray.int16[this._pos2 + 0];
    }
    get anchorY() {
        return this._structArray.int16[this._pos2 + 1];
    }
    get glyphStartIndex() {
        return this._structArray.uint16[this._pos2 + 2];
    }
    get numGlyphs() {
        return this._structArray.uint16[this._pos2 + 3];
    }
    get vertexStartIndex() {
        return this._structArray.uint32[this._pos4 + 2];
    }
    get lineStartIndex() {
        return this._structArray.uint32[this._pos4 + 3];
    }
    get lineLength() {
        return this._structArray.uint32[this._pos4 + 4];
    }
    get segment() {
        return this._structArray.uint16[this._pos2 + 10];
    }
    get lowerSize() {
        return this._structArray.uint16[this._pos2 + 11];
    }
    get upperSize() {
        return this._structArray.uint16[this._pos2 + 12];
    }
    get lineOffsetX() {
        return this._structArray.float32[this._pos4 + 7];
    }
    get lineOffsetY() {
        return this._structArray.float32[this._pos4 + 8];
    }
    get writingMode() {
        return this._structArray.uint8[this._pos1 + 36];
    }
    get placedOrientation() {
        return this._structArray.uint8[this._pos1 + 37];
    }
    set placedOrientation(e) {
        this._structArray.uint8[this._pos1 + 37] = e;
    }
    get hidden() {
        return this._structArray.uint8[this._pos1 + 38];
    }
    set hidden(e) {
        this._structArray.uint8[this._pos1 + 38] = e;
    }
    get crossTileID() {
        return this._structArray.uint32[this._pos4 + 10];
    }
    set crossTileID(e) {
        this._structArray.uint32[this._pos4 + 10] = e;
    }
    get associatedIconIndex() {
        return this._structArray.int16[this._pos2 + 22];
    }
};
tu.prototype.size = 48;
var nu = class extends Gl {
    get(e) {
        return new tu(this, e);
    }
};
H(`PlacedSymbolArray`, nu);
var ru = class extends El {
    get anchorX() {
        return this._structArray.int16[this._pos2 + 0];
    }
    get anchorY() {
        return this._structArray.int16[this._pos2 + 1];
    }
    get rightJustifiedTextSymbolIndex() {
        return this._structArray.int16[this._pos2 + 2];
    }
    get centerJustifiedTextSymbolIndex() {
        return this._structArray.int16[this._pos2 + 3];
    }
    get leftJustifiedTextSymbolIndex() {
        return this._structArray.int16[this._pos2 + 4];
    }
    get verticalPlacedTextSymbolIndex() {
        return this._structArray.int16[this._pos2 + 5];
    }
    get placedIconSymbolIndex() {
        return this._structArray.int16[this._pos2 + 6];
    }
    get verticalPlacedIconSymbolIndex() {
        return this._structArray.int16[this._pos2 + 7];
    }
    get key() {
        return this._structArray.uint16[this._pos2 + 8];
    }
    get textBoxStartIndex() {
        return this._structArray.uint16[this._pos2 + 9];
    }
    get textBoxEndIndex() {
        return this._structArray.uint16[this._pos2 + 10];
    }
    get verticalTextBoxStartIndex() {
        return this._structArray.uint16[this._pos2 + 11];
    }
    get verticalTextBoxEndIndex() {
        return this._structArray.uint16[this._pos2 + 12];
    }
    get iconBoxStartIndex() {
        return this._structArray.uint16[this._pos2 + 13];
    }
    get iconBoxEndIndex() {
        return this._structArray.uint16[this._pos2 + 14];
    }
    get verticalIconBoxStartIndex() {
        return this._structArray.uint16[this._pos2 + 15];
    }
    get verticalIconBoxEndIndex() {
        return this._structArray.uint16[this._pos2 + 16];
    }
    get featureIndex() {
        return this._structArray.uint16[this._pos2 + 17];
    }
    get numHorizontalGlyphVertices() {
        return this._structArray.uint16[this._pos2 + 18];
    }
    get numVerticalGlyphVertices() {
        return this._structArray.uint16[this._pos2 + 19];
    }
    get numIconVertices() {
        return this._structArray.uint16[this._pos2 + 20];
    }
    get numVerticalIconVertices() {
        return this._structArray.uint16[this._pos2 + 21];
    }
    get useRuntimeCollisionCircles() {
        return this._structArray.uint16[this._pos2 + 22];
    }
    get crossTileID() {
        return this._structArray.uint32[this._pos4 + 12];
    }
    set crossTileID(e) {
        this._structArray.uint32[this._pos4 + 12] = e;
    }
    get textBoxScale() {
        return this._structArray.float32[this._pos4 + 13];
    }
    get collisionCircleDiameter() {
        return this._structArray.float32[this._pos4 + 14];
    }
    get textAnchorOffsetStartIndex() {
        return this._structArray.uint16[this._pos2 + 30];
    }
    get textAnchorOffsetEndIndex() {
        return this._structArray.uint16[this._pos2 + 31];
    }
};
ru.prototype.size = 64;
var iu = class extends Kl {
    get(e) {
        return new ru(this, e);
    }
};
H(`SymbolInstanceArray`, iu);
var au = class extends ql {
    getoffsetX(e) {
        return this.float32[e * 1 + 0];
    }
};
H(`GlyphOffsetArray`, au);
var ou = class extends Al {
    getx(e) {
        return this.int16[e * 3 + 0];
    }
    gety(e) {
        return this.int16[e * 3 + 1];
    }
    gettileUnitDistanceFromAnchor(e) {
        return this.int16[e * 3 + 2];
    }
};
H(`SymbolLineVertexArray`, ou);
var su = class extends El {
    get textAnchor() {
        return this._structArray.uint16[this._pos2 + 0];
    }
    get textOffset0() {
        return this._structArray.float32[this._pos4 + 1];
    }
    get textOffset1() {
        return this._structArray.float32[this._pos4 + 2];
    }
};
su.prototype.size = 12;
var cu = class extends Jl {
    get(e) {
        return new su(this, e);
    }
};
H(`TextAnchorOffsetArray`, cu);
var lu = class extends El {
    get featureIndex() {
        return this._structArray.uint32[this._pos4 + 0];
    }
    get sourceLayerIndex() {
        return this._structArray.uint16[this._pos2 + 2];
    }
    get bucketIndex() {
        return this._structArray.uint16[this._pos2 + 3];
    }
};
lu.prototype.size = 8;
var uu = class extends Yl {
    get(e) {
        return new lu(this, e);
    }
};
H(`FeatureIndexArray`, uu);
var du = class extends kl {
}, fu = class extends Al {
}, pu = class extends jl {
}, mu = class extends kl {
}, hu = class extends kl {
}, gu = class extends Ml {
}, _u = class extends Nl {
}, vu = class extends Pl {
}, yu = class extends Fl {
}, bu = class extends Il {
}, xu = class extends Ll {
}, Su = class extends Rl {
}, Cu = class extends zl {
}, wu = class extends Vl {
}, Tu = class extends Hl {
}, Eu = class extends Ul {
}, Du = class extends Wl {
}, Ou = class extends Wl {
}, ku = class extends Xl {
}, Au = class extends Zl {
};
const ju = q([
    {
        name: `a_pos`,
        components: 2,
        type: `Int16`
    }
], 4), Mu = ju.members;
ju.size, ju.alignment;
var Nu = class e {
    constructor(e = []){
        this._forceNewSegmentOnNextPrepare = !1, this.segments = e;
    }
    prepareSegment(t, n, r, i) {
        let a = this.segments[this.segments.length - 1];
        return t > e.MAX_VERTEX_ARRAY_LENGTH && Ft(`Max vertices per segment is ${e.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${e.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !a || a.vertexLength + t > e.MAX_VERTEX_ARRAY_LENGTH || a.sortKey !== i ? this.createNewSegment(n, r, i) : a;
    }
    createNewSegment(e, t, n) {
        let r = {
            vertexOffset: e.length,
            primitiveOffset: t.length,
            vertexLength: 0,
            primitiveLength: 0,
            vaos: {}
        };
        return n !== void 0 && (r.sortKey = n), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(r), r;
    }
    getOrCreateLatestSegment(e, t, n) {
        return this.prepareSegment(0, e, t, n);
    }
    forceNewSegmentOnNextPrepare() {
        this._forceNewSegmentOnNextPrepare = !0;
    }
    get() {
        return this.segments;
    }
    destroy() {
        for (let e of this.segments)for(let t in e.vaos)e.vaos[t].destroy();
    }
    static simpleSegment(t, n, r, i) {
        return new e([
            {
                vertexOffset: t,
                primitiveOffset: n,
                vertexLength: r,
                primitiveLength: i,
                vaos: {},
                sortKey: 0
            }
        ]);
    }
};
Nu.MAX_VERTEX_ARRAY_LENGTH = 2 ** 16 - 1, H(`SegmentVector`, Nu);
function Pu(e, t) {
    return e = yt(Math.floor(e), 0, 255), t = yt(Math.floor(t), 0, 255), 256 * e + t;
}
const Fu = q([
    {
        name: `a_pattern_from`,
        components: 4,
        type: `Uint16`
    },
    {
        name: `a_pattern_to`,
        components: 4,
        type: `Uint16`
    },
    {
        name: `a_pixel_ratio_from`,
        components: 1,
        type: `Uint16`
    },
    {
        name: `a_pixel_ratio_to`,
        components: 1,
        type: `Uint16`
    }
]), Iu = q([
    {
        name: `a_dasharray_from`,
        components: 4,
        type: `Uint16`
    },
    {
        name: `a_dasharray_to`,
        components: 4,
        type: `Uint16`
    }
]);
var Lu = o((e, t)=>{
    function n(e, t) {
        for(var n = e.length & 3, r = e.length - n, i = t, a, o = 3432918353, s = 461845907, c, l = 0; l < r;)c = e.charCodeAt(l) & 255 | (e.charCodeAt(++l) & 255) << 8 | (e.charCodeAt(++l) & 255) << 16 | (e.charCodeAt(++l) & 255) << 24, ++l, c = (c & 65535) * o + (((c >>> 16) * o & 65535) << 16) & 4294967295, c = c << 15 | c >>> 17, c = (c & 65535) * s + (((c >>> 16) * s & 65535) << 16) & 4294967295, i ^= c, i = i << 13 | i >>> 19, a = (i & 65535) * 5 + (((i >>> 16) * 5 & 65535) << 16) & 4294967295, i = (a & 65535) + 27492 + (((a >>> 16) + 58964 & 65535) << 16);
        switch(c = 0, n){
            case 3:
                c ^= (e.charCodeAt(l + 2) & 255) << 16;
            case 2:
                c ^= (e.charCodeAt(l + 1) & 255) << 8;
            case 1:
                c ^= e.charCodeAt(l) & 255, c = (c & 65535) * o + (((c >>> 16) * o & 65535) << 16) & 4294967295, c = c << 15 | c >>> 17, c = (c & 65535) * s + (((c >>> 16) * s & 65535) << 16) & 4294967295, i ^= c;
        }
        return i ^= e.length, i ^= i >>> 16, i = (i & 65535) * 2246822507 + (((i >>> 16) * 2246822507 & 65535) << 16) & 4294967295, i ^= i >>> 13, i = (i & 65535) * 3266489909 + (((i >>> 16) * 3266489909 & 65535) << 16) & 4294967295, i ^= i >>> 16, i >>> 0;
    }
    t !== void 0 && (t.exports = n);
}), Ru = o((e, t)=>{
    function n(e, t) {
        for(var n = e.length, r = t ^ n, i = 0, a; n >= 4;)a = e.charCodeAt(i) & 255 | (e.charCodeAt(++i) & 255) << 8 | (e.charCodeAt(++i) & 255) << 16 | (e.charCodeAt(++i) & 255) << 24, a = (a & 65535) * 1540483477 + (((a >>> 16) * 1540483477 & 65535) << 16), a ^= a >>> 24, a = (a & 65535) * 1540483477 + (((a >>> 16) * 1540483477 & 65535) << 16), r = (r & 65535) * 1540483477 + (((r >>> 16) * 1540483477 & 65535) << 16) ^ a, n -= 4, ++i;
        switch(n){
            case 3:
                r ^= (e.charCodeAt(i + 2) & 255) << 16;
            case 2:
                r ^= (e.charCodeAt(i + 1) & 255) << 8;
            case 1:
                r ^= e.charCodeAt(i) & 255, r = (r & 65535) * 1540483477 + (((r >>> 16) * 1540483477 & 65535) << 16);
        }
        return r ^= r >>> 13, r = (r & 65535) * 1540483477 + (((r >>> 16) * 1540483477 & 65535) << 16), r ^= r >>> 15, r >>> 0;
    }
    t.exports = n;
}), zu = c(o((e, t)=>{
    var n = Lu(), r = Ru();
    t.exports = n, t.exports.murmur3 = n, t.exports.murmur2 = r;
})(), 1), Bu = class e {
    constructor(){
        this.ids = [], this.positions = [], this.indexed = !1;
    }
    add(e, t, n, r) {
        this.ids.push(Vu(e)), this.positions.push(t, n, r);
    }
    getPositions(e) {
        if (!this.indexed) throw Error(`Trying to get index, but feature positions are not indexed`);
        let t = Vu(e), n = 0, r = this.ids.length - 1;
        for(; n < r;){
            let e = n + r >> 1;
            this.ids[e] >= t ? r = e : n = e + 1;
        }
        let i = [];
        for(; this.ids[n] === t;){
            let e = this.positions[3 * n], t = this.positions[3 * n + 1], r = this.positions[3 * n + 2];
            i.push({
                index: e,
                start: t,
                end: r
            }), n++;
        }
        return i;
    }
    static serialize(e, t) {
        let n = new Float64Array(e.ids), r = new Uint32Array(e.positions);
        return Hu(n, r, 0, n.length - 1), t && t.push(n.buffer, r.buffer), {
            ids: n,
            positions: r
        };
    }
    static deserialize(t) {
        let n = new e;
        return n.ids = t.ids, n.positions = t.positions, n.indexed = !0, n;
    }
};
function Vu(e) {
    let t = +e;
    return !isNaN(t) && t <= 2 ** 53 - 1 ? t : (0, zu.default)(String(e));
}
function Hu(e, t, n, r) {
    for(; n < r;){
        let i = e[n + r >> 1], a = n - 1, o = r + 1;
        for(;;){
            do a++;
            while (e[a] < i);
            do o--;
            while (e[o] > i);
            if (a >= o) break;
            Uu(e, a, o), Uu(t, 3 * a, 3 * o), Uu(t, 3 * a + 1, 3 * o + 1), Uu(t, 3 * a + 2, 3 * o + 2);
        }
        o - n < r - o ? (Hu(e, t, n, o), n = o + 1) : (Hu(e, t, o + 1, r), r = o);
    }
}
function Uu(e, t, n) {
    let r = e[t];
    e[t] = e[n], e[n] = r;
}
H(`FeaturePositionMap`, Bu);
var Wu = class {
    constructor(e, t){
        this.gl = e.gl, this.location = t;
    }
}, Gu = class extends Wu {
    constructor(e, t){
        super(e, t), this.current = 0;
    }
    set(e) {
        this.current !== e && (this.current = e, this.gl.uniform1i(this.location, e));
    }
}, Ku = class extends Wu {
    constructor(e, t){
        super(e, t), this.current = 0;
    }
    set(e) {
        this.current !== e && (this.current = e, this.gl.uniform1f(this.location, e));
    }
}, qu = class extends Wu {
    constructor(e, t){
        super(e, t), this.current = [
            0,
            0
        ];
    }
    set(e) {
        (e[0] !== this.current[0] || e[1] !== this.current[1]) && (this.current = e, this.gl.uniform2f(this.location, e[0], e[1]));
    }
}, Ju = class extends Wu {
    constructor(e, t){
        super(e, t), this.current = [
            0,
            0,
            0
        ];
    }
    set(e) {
        (e[0] !== this.current[0] || e[1] !== this.current[1] || e[2] !== this.current[2]) && (this.current = e, this.gl.uniform3f(this.location, e[0], e[1], e[2]));
    }
}, Yu = class extends Wu {
    constructor(e, t){
        super(e, t), this.current = [
            0,
            0,
            0,
            0
        ];
    }
    set(e) {
        (e[0] !== this.current[0] || e[1] !== this.current[1] || e[2] !== this.current[2] || e[3] !== this.current[3]) && (this.current = e, this.gl.uniform4f(this.location, e[0], e[1], e[2], e[3]));
    }
}, Xu = class extends Wu {
    constructor(e, t){
        super(e, t), this.current = z.transparent;
    }
    set(e) {
        (e.r !== this.current.r || e.g !== this.current.g || e.b !== this.current.b || e.a !== this.current.a) && (this.current = e, this.gl.uniform4f(this.location, e.r, e.g, e.b, e.a));
    }
}, Zu = class extends Wu {
    constructor(e, t){
        super(e, t), this.current = [];
    }
    set(e) {
        if (e != this.current) {
            this.current = e;
            let t = new Float32Array(e.length * 4);
            for(let n = 0; n < e.length; n++)t[4 * n] = e[n].r, t[4 * n + 1] = e[n].g, t[4 * n + 2] = e[n].b, t[4 * n + 3] = e[n].a;
            this.gl.uniform4fv(this.location, t);
        }
    }
}, Qu = class extends Wu {
    constructor(e, t){
        super(e, t), this.current = [];
    }
    set(e) {
        if (e != this.current) {
            this.current = e;
            let t = new Float32Array(e);
            this.gl.uniform1fv(this.location, t);
        }
    }
};
const $u = new Float32Array(16);
var ed = class extends Wu {
    constructor(e, t){
        super(e, t), this.current = $u;
    }
    set(e) {
        if (e[12] !== this.current[12] || e[0] !== this.current[0]) {
            this.current = e, this.gl.uniformMatrix4fv(this.location, !1, e);
            return;
        }
        for(let t = 1; t < 16; t++)if (e[t] !== this.current[t]) {
            this.current = e, this.gl.uniformMatrix4fv(this.location, !1, e);
            break;
        }
    }
};
function td(e) {
    return [
        Pu(255 * e.r, 255 * e.g),
        Pu(255 * e.b, 255 * e.a)
    ];
}
var nd = class {
    constructor(e, t, n){
        this.value = e, this.uniformNames = t.map((e)=>`u_${e}`), this.type = n;
    }
    setUniform(e, t, n) {
        e.set(n.constantOr(this.value));
    }
    getBinding(e, t, n) {
        return this.type === `color` ? new Xu(e, t) : new Ku(e, t);
    }
}, rd = class {
    constructor(e, t){
        this.uniformNames = t.map((e)=>`u_${e}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
    }
    setConstantPatternPositions(e, t) {
        this.pixelRatioFrom = t.pixelRatio, this.pixelRatioTo = e.pixelRatio, this.patternFrom = t.tlbr, this.patternTo = e.tlbr;
    }
    setConstantDashPositions(e, t) {
        this.dashTo = [
            0,
            e.y,
            e.height,
            e.width
        ], this.dashFrom = [
            0,
            t.y,
            t.height,
            t.width
        ];
    }
    setUniform(e, t, n, r) {
        let i = null;
        r === `u_pattern_to` ? i = this.patternTo : r === `u_pattern_from` ? i = this.patternFrom : r === `u_dasharray_to` ? i = this.dashTo : r === `u_dasharray_from` ? i = this.dashFrom : r === `u_pixel_ratio_to` ? i = this.pixelRatioTo : r === `u_pixel_ratio_from` && (i = this.pixelRatioFrom), i !== null && e.set(i);
    }
    getBinding(e, t, n) {
        return n.startsWith(`u_pattern`) || n.startsWith(`u_dasharray_`) ? new Yu(e, t) : new Ku(e, t);
    }
}, id = class {
    constructor(e, t, n, r){
        this.expression = e, this.type = n, this.maxValue = 0, this.paintVertexAttributes = t.map((e)=>({
                name: `a_${e}`,
                type: `Float32`,
                components: n === `color` ? 2 : 1,
                offset: 0
            })), this.paintVertexArray = new r;
    }
    populatePaintArray(e, t, n) {
        let r = this.paintVertexArray.length, i = this.expression.evaluate(new U(0, n), t, {}, n.canonical, [], n.formattedSection);
        this.paintVertexArray.resize(e), this._setPaintValue(r, e, i);
    }
    updatePaintArray(e, t, n, r, i) {
        let a = this.expression.evaluate(new U(0, i), n, r);
        this._setPaintValue(e, t, a);
    }
    _setPaintValue(e, t, n) {
        if (this.type === `color`) {
            let r = td(n);
            for(let n = e; n < t; n++)this.paintVertexArray.emplace(n, r[0], r[1]);
        } else {
            for(let r = e; r < t; r++)this.paintVertexArray.emplace(r, n);
            this.maxValue = Math.max(this.maxValue, Math.abs(n));
        }
    }
    upload(e) {
        this.paintVertexArray?.arrayBuffer.byteLength && (this.paintVertexBuffer?.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
    }
    destroy() {
        this.paintVertexBuffer && this.paintVertexBuffer.destroy();
    }
}, ad = class {
    constructor(e, t, n, r, i, a){
        this.expression = e, this.uniformNames = t.map((e)=>`u_${e}_t`), this.type = n, this.useIntegerZoom = r, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = t.map((e)=>({
                name: `a_${e}`,
                type: `Float32`,
                components: n === `color` ? 4 : 2,
                offset: 0
            })), this.paintVertexArray = new a;
    }
    populatePaintArray(e, t, n) {
        let r = this.expression.evaluate(new U(this.zoom, n), t, {}, n.canonical, [], n.formattedSection), i = this.expression.evaluate(new U(this.zoom + 1, n), t, {}, n.canonical, [], n.formattedSection), a = this.paintVertexArray.length;
        this.paintVertexArray.resize(e), this._setPaintValue(a, e, r, i);
    }
    updatePaintArray(e, t, n, r, i) {
        let a = this.expression.evaluate(new U(this.zoom, i), n, r), o = this.expression.evaluate(new U(this.zoom + 1, i), n, r);
        this._setPaintValue(e, t, a, o);
    }
    _setPaintValue(e, t, n, r) {
        if (this.type === `color`) {
            let i = td(n), a = td(r);
            for(let n = e; n < t; n++)this.paintVertexArray.emplace(n, i[0], i[1], a[0], a[1]);
        } else {
            for(let i = e; i < t; i++)this.paintVertexArray.emplace(i, n, r);
            this.maxValue = Math.max(this.maxValue, Math.abs(n), Math.abs(r));
        }
    }
    upload(e) {
        this.paintVertexArray?.arrayBuffer.byteLength && (this.paintVertexBuffer?.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
    }
    destroy() {
        this.paintVertexBuffer && this.paintVertexBuffer.destroy();
    }
    setUniform(e, t) {
        let n = this.useIntegerZoom ? Math.floor(t.zoom) : t.zoom, r = yt(this.expression.interpolationFactor(n, this.zoom, this.zoom + 1), 0, 1);
        e.set(r);
    }
    getBinding(e, t, n) {
        return new Ku(e, t);
    }
}, od = class {
    constructor(e, t, n, r, i, a){
        this.expression = e, this.type = t, this.useIntegerZoom = n, this.zoom = r, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
    }
    populatePaintArray(e, t, n) {
        let r = this.zoomInPaintVertexArray.length;
        this.zoomInPaintVertexArray.resize(e), this.zoomOutPaintVertexArray.resize(e), this._setPaintValues(r, e, this.getPositionIds(t), n);
    }
    updatePaintArray(e, t, n, r, i) {
        this._setPaintValues(e, t, this.getPositionIds(n), i);
    }
    _setPaintValues(e, t, n, r) {
        let i = this.getPositions(r);
        if (!i || !n) return;
        let a = i[n.min], o = i[n.mid], s = i[n.max];
        if (!(!a || !o || !s)) for(let n = e; n < t; n++)this.emplace(this.zoomInPaintVertexArray, n, a, o), this.emplace(this.zoomOutPaintVertexArray, n, s, o);
    }
    upload(e) {
        if (this.zoomInPaintVertexArray?.arrayBuffer.byteLength && this.zoomOutPaintVertexArray?.arrayBuffer.byteLength) {
            let t = this.getVertexAttributes();
            this.zoomInPaintVertexBuffer = e.createVertexBuffer(this.zoomInPaintVertexArray, t, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = e.createVertexBuffer(this.zoomOutPaintVertexArray, t, this.expression.isStateDependent);
        }
    }
    destroy() {
        this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
    }
}, sd = class extends od {
    getPositions(e) {
        return e.imagePositions;
    }
    getPositionIds(e) {
        return e.patterns?.[this.layerId];
    }
    getVertexAttributes() {
        return Fu.members;
    }
    emplace(e, t, n, r) {
        e.emplace(t, n.tlbr[0], n.tlbr[1], n.tlbr[2], n.tlbr[3], r.tlbr[0], r.tlbr[1], r.tlbr[2], r.tlbr[3], n.pixelRatio, r.pixelRatio);
    }
}, cd = class extends od {
    getPositions(e) {
        return e.dashPositions;
    }
    getPositionIds(e) {
        return e.dashes?.[this.layerId];
    }
    getVertexAttributes() {
        return Iu.members;
    }
    emplace(e, t, n, r) {
        e.emplace(t, 0, n.y, n.height, n.width, 0, r.y, r.height, r.width);
    }
}, ld = class {
    constructor(e, t, n){
        this.binders = {}, this._buffers = [];
        let r = [];
        for(let i in e.paint._values){
            if (!n(i)) continue;
            let a = e.paint.get(i);
            if (!(a instanceof dl) || !Eo(a.property.specification)) continue;
            let o = dd(i, e.type), s = a.value, c = a.property.specification.type, l = a.property.useIntegerZoom, u = a.property.specification[`property-type`], d = u === `cross-faded` || u === `cross-faded-data-driven`;
            if (s.kind === `constant`) this.binders[i] = d ? new rd(s.value, o) : new nd(s.value, o, c), r.push(`/u_${i}`);
            else if (s.kind === `source` || d) {
                let n = pd(i, c, `source`);
                this.binders[i] = d ? i === `line-dasharray` ? new cd(s, c, l, t, n, e.id) : new sd(s, c, l, t, n, e.id) : new id(s, o, c, n), r.push(`/a_${i}`);
            } else {
                let e = pd(i, c, `composite`);
                this.binders[i] = new ad(s, o, c, l, t, e), r.push(`/z_${i}`);
            }
        }
        this.cacheKey = r.sort().join(``);
    }
    getMaxValue(e) {
        let t = this.binders[e];
        return t instanceof id || t instanceof ad ? t.maxValue : 0;
    }
    populatePaintArrays(e, t, n) {
        for(let r in this.binders){
            let i = this.binders[r];
            (i instanceof id || i instanceof ad || i instanceof od) && i.populatePaintArray(e, t, n);
        }
    }
    setConstantPatternPositions(e, t) {
        for(let n in this.binders){
            let r = this.binders[n];
            r instanceof rd && r.setConstantPatternPositions(e, t);
        }
    }
    setConstantDashPositions(e, t) {
        for(let n in this.binders){
            let r = this.binders[n];
            r instanceof rd && r.setConstantDashPositions(e, t);
        }
    }
    updatePaintArrays(e, t, n, r, i) {
        let a = !1;
        for (let o of e){
            let e = t.getPositions(o.id);
            for (let t of e){
                let e = n.feature(t.index);
                for(let n in this.binders){
                    let s = this.binders[n];
                    (s instanceof id || s instanceof ad || s instanceof od) && s.expression.isStateDependent === !0 && (s.expression = r.paint.get(n).value, s.updatePaintArray(t.start, t.end, e, o.state, i), a = !0);
                }
            }
        }
        return a;
    }
    defines() {
        let e = [];
        for(let t in this.binders){
            let n = this.binders[t];
            (n instanceof nd || n instanceof rd) && e.push(...n.uniformNames.map((e)=>`#define HAS_UNIFORM_${e}`));
        }
        return e;
    }
    getBinderAttributes() {
        let e = [];
        for(let t in this.binders){
            let n = this.binders[t];
            if (n instanceof id || n instanceof ad) for (let t of n.paintVertexAttributes)e.push(t.name);
            else if (n instanceof od) {
                let t = n.getVertexAttributes();
                for (let n of t)e.push(n.name);
            }
        }
        return e;
    }
    getBinderUniforms() {
        let e = [];
        for(let t in this.binders){
            let n = this.binders[t];
            if (n instanceof nd || n instanceof rd || n instanceof ad) for (let t of n.uniformNames)e.push(t);
        }
        return e;
    }
    getPaintVertexBuffers() {
        return this._buffers;
    }
    getUniforms(e, t) {
        let n = [];
        for(let r in this.binders){
            let i = this.binders[r];
            if (i instanceof nd || i instanceof rd || i instanceof ad) {
                for (let a of i.uniformNames)if (t[a]) {
                    let o = i.getBinding(e, t[a], a);
                    n.push({
                        name: a,
                        property: r,
                        binding: o
                    });
                }
            }
        }
        return n;
    }
    setUniforms(e, t, n, r) {
        for (let { name: e, property: i, binding: a } of t)this.binders[i].setUniform(a, r, n.get(i), e);
    }
    updatePaintBuffers(e) {
        this._buffers = [];
        for(let t in this.binders){
            let n = this.binders[t];
            if (e && n instanceof od) {
                let t = e.fromScale === 2 ? n.zoomInPaintVertexBuffer : n.zoomOutPaintVertexBuffer;
                t && this._buffers.push(t);
            } else (n instanceof id || n instanceof ad) && n.paintVertexBuffer && this._buffers.push(n.paintVertexBuffer);
        }
    }
    upload(e) {
        for(let t in this.binders){
            let n = this.binders[t];
            (n instanceof id || n instanceof ad || n instanceof od) && n.upload(e);
        }
        this.updatePaintBuffers();
    }
    destroy() {
        for(let e in this.binders){
            let t = this.binders[e];
            (t instanceof id || t instanceof ad || t instanceof od) && t.destroy();
        }
    }
}, ud = class {
    constructor(e, t, n = ()=>!0){
        this.programConfigurations = {};
        for (let r of e)this.programConfigurations[r.id] = new ld(r, t, n);
        this.needsUpload = !1, this._featureMap = new Bu, this._bufferOffset = 0;
    }
    populatePaintArrays(e, t, n, r) {
        for(let n in this.programConfigurations)this.programConfigurations[n].populatePaintArrays(e, t, r);
        t.id !== void 0 && this._featureMap.add(t.id, n, this._bufferOffset, e), this._bufferOffset = e, this.needsUpload = !0;
    }
    updatePaintArrays(e, t, n, r) {
        for (let i of n)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(e, this._featureMap, t, i, r) || this.needsUpload;
    }
    get(e) {
        return this.programConfigurations[e];
    }
    upload(e) {
        if (this.needsUpload) {
            for(let t in this.programConfigurations)this.programConfigurations[t].upload(e);
            this.needsUpload = !1;
        }
    }
    destroy() {
        for(let e in this.programConfigurations)this.programConfigurations[e].destroy();
    }
};
function dd(e, t) {
    return ({
        "text-opacity": [
            `opacity`
        ],
        "icon-opacity": [
            `opacity`
        ],
        "text-color": [
            `fill_color`
        ],
        "icon-color": [
            `fill_color`
        ],
        "text-halo-color": [
            `halo_color`
        ],
        "icon-halo-color": [
            `halo_color`
        ],
        "text-halo-blur": [
            `halo_blur`
        ],
        "icon-halo-blur": [
            `halo_blur`
        ],
        "text-halo-width": [
            `halo_width`
        ],
        "icon-halo-width": [
            `halo_width`
        ],
        "line-gap-width": [
            `gapwidth`
        ],
        "line-dasharray": [
            `dasharray_to`,
            `dasharray_from`
        ],
        "line-pattern": [
            `pattern_to`,
            `pattern_from`,
            `pixel_ratio_to`,
            `pixel_ratio_from`
        ],
        "fill-pattern": [
            `pattern_to`,
            `pattern_from`,
            `pixel_ratio_to`,
            `pixel_ratio_from`
        ],
        "fill-extrusion-pattern": [
            `pattern_to`,
            `pattern_from`,
            `pixel_ratio_to`,
            `pixel_ratio_from`
        ]
    })[e] || [
        e.replace(`${t}-`, ``).replace(/-/g, `_`)
    ];
}
function fd(e) {
    return ({
        "line-pattern": {
            source: yu,
            composite: yu
        },
        "fill-pattern": {
            source: yu,
            composite: yu
        },
        "fill-extrusion-pattern": {
            source: yu,
            composite: yu
        },
        "line-dasharray": {
            source: bu,
            composite: bu
        }
    })[e];
}
function pd(e, t, n) {
    let r = {
        color: {
            source: Pl,
            composite: Ql
        },
        number: {
            source: ql,
            composite: Pl
        }
    };
    return fd(e)?.[n] || r[t][n];
}
H(`ConstantBinder`, nd), H(`CrossFadedConstantBinder`, rd), H(`SourceExpressionBinder`, id), H(`CrossFadedPatternBinder`, sd), H(`CrossFadedDasharrayBinder`, cd), H(`CompositeExpressionBinder`, ad), H(`ProgramConfiguration`, ld, {
    omit: [
        `_buffers`
    ]
}), H(`ProgramConfigurationSet`, ud);
const md = 2 ** 14 - 1, hd = -md - 1;
function gd(e) {
    let t = Ye / e.extent, n = e.loadGeometry();
    for (let e of n)for (let n of e){
        let e = Math.round(n.x * t), r = Math.round(n.y * t);
        n.x = yt(e, hd, md), n.y = yt(r, hd, md), (e < n.x || e > n.x + 1 || r < n.y || r > n.y + 1) && Ft(`Geometry exceeds allowed extent, reduce your vector tile buffer size`);
    }
    return n;
}
function _d(e, t) {
    return {
        type: e.type,
        id: e.id,
        properties: e.properties,
        geometry: t ? gd(e) : []
    };
}
const vd = -32768;
function yd(e, t, n, r, i) {
    e.emplaceBack(vd + t * 8 + r, vd + n * 8 + i);
}
var bd = class {
    constructor(e){
        this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.id), this.index = e.index, this.hasDependencies = !1, this.layoutVertexArray = new mu, this.indexArray = new Ou, this.segments = new Nu, this.programConfigurations = new ud(e.layers, e.zoom), this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id);
    }
    populate(e, t, n) {
        let r = this.layers[0], i = [], a = null, o = !1, s = r.type === `heatmap`;
        if (r.type === `circle`) {
            let e = r;
            a = e.layout.get(`circle-sort-key`), o = !a.isConstant(), s ||= e.paint.get(`circle-pitch-alignment`) === `map`;
        }
        let c = s ? t.subdivisionGranularity.circle : 1;
        for (let { feature: t, id: r, index: s, sourceLayerIndex: c } of e){
            let e = this.layers[0]._featureFilter.needGeometry, l = _d(t, e);
            if (!this.layers[0]._featureFilter.filter(new U(this.zoom), l, n)) continue;
            let u = o ? a.evaluate(l, {}, n) : void 0, d = {
                id: r,
                properties: t.properties,
                type: t.type,
                sourceLayerIndex: c,
                index: s,
                geometry: e ? l.geometry : gd(t),
                patterns: {},
                sortKey: u
            };
            i.push(d);
        }
        o && i.sort((e, t)=>e.sortKey - t.sortKey);
        for (let r of i){
            let { geometry: i, index: a, sourceLayerIndex: o } = r, s = e[a].feature;
            this.addFeature(r, i, a, n, c), t.featureIndex.insert(s, i, a, o, this.index);
        }
    }
    update(e, t, n) {
        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e, t, this.stateDependentLayers, {
            imagePositions: n
        });
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(e) {
        this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, Mu), this.indexBuffer = e.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e), this.uploaded = !0;
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
    }
    addFeature(e, t, n, r, i = 1) {
        let a;
        switch(i){
            case 1:
                a = [
                    0,
                    7
                ];
                break;
            case 3:
                a = [
                    0,
                    2,
                    5,
                    7
                ];
                break;
            case 5:
                a = [
                    0,
                    1,
                    3,
                    4,
                    6,
                    7
                ];
                break;
            case 7:
                a = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ];
                break;
            default:
                throw Error(`Invalid circle bucket granularity: ${i}; valid values are 1, 3, 5, 7.`);
        }
        let o = a.length;
        for (let n of t)for (let t of n){
            let n = t.x, r = t.y;
            if (n < 0 || n >= 8192 || r < 0 || r >= 8192) continue;
            let i = this.segments.prepareSegment(o * o, this.layoutVertexArray, this.indexArray, e.sortKey), s = i.vertexLength;
            for(let e = 0; e < o; e++)for(let t = 0; t < o; t++)yd(this.layoutVertexArray, n, r, a[t], a[e]);
            for(let e = 0; e < o - 1; e++)for(let t = 0; t < o - 1; t++){
                let n = s + e * o + t, r = s + (e + 1) * o + t;
                this.indexArray.emplaceBack(n, r + 1, n + 1), this.indexArray.emplaceBack(n, r, r + 1);
            }
            i.vertexLength += o * o, i.primitiveLength += (o - 1) * (o - 1) * 2;
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, n, {
            imagePositions: {},
            canonical: r
        });
    }
};
H(`CircleBucket`, bd, {
    omit: [
        `layers`
    ]
});
function xd(e, t) {
    for (let n of e)if (jd(t, n)) return !0;
    for (let n of t)if (jd(e, n)) return !0;
    return Ed(e, t);
}
function Sd(e, t, n) {
    return jd(e, t) ? !0 : Od(t, e, n);
}
function Cd(e, t) {
    if (e.length === 1) return Ad(t, e[0]);
    for (let n of t)for (let t of n)if (jd(e, t)) return !0;
    for (let n of e)if (Ad(t, n)) return !0;
    for (let n of t)if (Ed(e, n)) return !0;
    return !1;
}
function wd(e, t, n) {
    for (let r of t){
        if (e.length >= 3) {
            for (let t of r)if (jd(e, t)) return !0;
        }
        if (Td(e, r, n)) return !0;
    }
    return !1;
}
function Td(e, t, n) {
    if (e.length > 1) {
        if (Ed(e, t)) return !0;
        for (let r of t)if (Od(r, e, n)) return !0;
    }
    for (let r of e)if (Od(r, t, n)) return !0;
    return !1;
}
function Ed(e, t) {
    if (e.length === 0 || t.length === 0) return !1;
    for(let n = 0; n < e.length - 1; n++){
        let r = e[n], i = e[n + 1];
        for(let e = 0; e < t.length - 1; e++){
            let n = t[e], a = t[e + 1];
            if (Dd(r, i, n, a)) return !0;
        }
    }
    return !1;
}
function Dd(e, t, n, r) {
    return It(e, n, r) !== It(t, n, r) && It(e, t, n) !== It(e, t, r);
}
function Od(e, t, n) {
    let r = n * n;
    if (t.length === 1) return e.distSqr(t[0]) < r;
    for(let n = 1; n < t.length; n++){
        let i = t[n - 1], a = t[n];
        if (kd(e, i, a) < r) return !0;
    }
    return !1;
}
function kd(e, t, n) {
    let r = t.distSqr(n);
    if (r === 0) return e.distSqr(t);
    let i = ((e.x - t.x) * (n.x - t.x) + (e.y - t.y) * (n.y - t.y)) / r;
    return i < 0 ? e.distSqr(t) : i > 1 ? e.distSqr(n) : e.distSqr(n.sub(t)._mult(i)._add(t));
}
function Ad(e, t) {
    let n = !1, r, i, a;
    for (let o of e){
        r = o;
        for(let e = 0, o = r.length - 1; e < r.length; o = e++)i = r[e], a = r[o], i.y > t.y != a.y > t.y && t.x < (a.x - i.x) * (t.y - i.y) / (a.y - i.y) + i.x && (n = !n);
    }
    return n;
}
function jd(e, t) {
    let n = !1;
    for(let r = 0, i = e.length - 1; r < e.length; i = r++){
        let a = e[r], o = e[i];
        a.y > t.y != o.y > t.y && t.x < (o.x - a.x) * (t.y - a.y) / (o.y - a.y) + a.x && (n = !n);
    }
    return n;
}
function Md(e, t, n, r, i) {
    for (let a of e)if (t <= a.x && n <= a.y && r >= a.x && i >= a.y) return !0;
    let a = [
        new l(t, n),
        new l(t, i),
        new l(r, i),
        new l(r, n)
    ];
    if (e.length > 2) {
        for (let t of a)if (jd(e, t)) return !0;
    }
    for(let t = 0; t < e.length - 1; t++){
        let n = e[t], r = e[t + 1];
        if (Nd(n, r, a)) return !0;
    }
    return !1;
}
function Nd(e, t, n) {
    let r = n[0], i = n[2];
    if (e.x < r.x && t.x < r.x || e.x > i.x && t.x > i.x || e.y < r.y && t.y < r.y || e.y > i.y && t.y > i.y) return !1;
    let a = It(e, t, n[0]);
    return a !== It(e, t, n[1]) || a !== It(e, t, n[2]) || a !== It(e, t, n[3]);
}
function Pd(e, t, n) {
    let r = t.paint.get(e).value;
    return r.kind === `constant` ? r.value : n.programConfigurations.get(t.id).getMaxValue(e);
}
function Fd(e) {
    return Math.sqrt(e[0] * e[0] + e[1] * e[1]);
}
function Id(e, t, n, r, i) {
    if (!t[0] && !t[1]) return e;
    let a = l.convert(t)._mult(i);
    n === `viewport` && a._rotate(-r);
    let o = [];
    for (let t of e)o.push(t.sub(a));
    return o;
}
function Ld(e) {
    let t = [];
    for(let n = 0; n < e.length; n++){
        let r = e[n], i = t.at(-1);
        (n === 0 || i && !r.equals(i)) && t.push(r);
    }
    return t;
}
function Rd(e, t) {
    let n = [];
    for (let r of e){
        let e = Ld(r), i = [];
        for(let n = 0; n < e.length; n++){
            let r = e[n], a = e[n - 1], o = e[n + 1], s = n === 0 ? new l(0, 0) : r.sub(a)._unit()._perp(), c = n === e.length - 1 ? new l(0, 0) : o.sub(r)._unit()._perp(), u = s._add(c)._unit(), d = u.x * c.x + u.y * c.y;
            d !== 0 && u._mult(1 / d), i.push(u._mult(t)._add(r));
        }
        n.push(i);
    }
    return n;
}
function zd({ queryGeometry: e, size: t }, n) {
    return Sd(e, n, t);
}
function Bd({ queryGeometry: e, size: t, transform: n, unwrappedTileID: r, getElevation: i }, a) {
    return Sd(e, a, t * (n.projectTileCoordinates(a.x, a.y, r, i).signedDistanceFromCamera / n.cameraToCenterDistance));
}
function Vd({ queryGeometry: e, size: t, transform: n, unwrappedTileID: r, getElevation: i }, a) {
    let o = n.projectTileCoordinates(a.x, a.y, r, i).signedDistanceFromCamera, s = t * (n.cameraToCenterDistance / o);
    return Sd(e, Wd(a, n, r, i), s);
}
function Hd({ queryGeometry: e, size: t, transform: n, unwrappedTileID: r, getElevation: i }, a) {
    return Sd(e, Wd(a, n, r, i), t);
}
function Ud({ queryGeometry: e, size: t, transform: n, unwrappedTileID: r, getElevation: i, pitchAlignment: a = `map`, pitchScale: o = `map` }, s) {
    let c = a === `map` ? o === `map` ? zd : Bd : o === `map` ? Vd : Hd, l = {
        queryGeometry: e,
        size: t,
        transform: n,
        unwrappedTileID: r,
        getElevation: i
    };
    for (let e of s)for (let t of e)if (c(l, t)) return !0;
    return !1;
}
function Wd(e, t, n, r) {
    let i = t.projectTileCoordinates(e.x, e.y, n, r).point;
    return new l((i.x * .5 + .5) * t.width, (-i.y * .5 + .5) * t.height);
}
function Gd(e, t, n, r) {
    return e.map((e)=>Wd(e, t, n, r));
}
let Kd;
const qd = ()=>Kd ||= new gl({
        "circle-sort-key": new G(j.layout_circle[`circle-sort-key`], `circle-sort-key`)
    });
let Jd;
const Yd = ()=>Jd ||= new gl({
        "circle-radius": new G(j.paint_circle[`circle-radius`], `circle-radius`),
        "circle-color": new G(j.paint_circle[`circle-color`], `circle-color`),
        "circle-blur": new G(j.paint_circle[`circle-blur`], `circle-blur`),
        "circle-opacity": new G(j.paint_circle[`circle-opacity`], `circle-opacity`),
        "circle-translate": new W(j.paint_circle[`circle-translate`], `circle-translate`),
        "circle-translate-anchor": new W(j.paint_circle[`circle-translate-anchor`], `circle-translate-anchor`),
        "circle-pitch-scale": new W(j.paint_circle[`circle-pitch-scale`], `circle-pitch-scale`),
        "circle-pitch-alignment": new W(j.paint_circle[`circle-pitch-alignment`], `circle-pitch-alignment`),
        "circle-stroke-width": new G(j.paint_circle[`circle-stroke-width`], `circle-stroke-width`),
        "circle-stroke-color": new G(j.paint_circle[`circle-stroke-color`], `circle-stroke-color`),
        "circle-stroke-opacity": new G(j.paint_circle[`circle-stroke-opacity`], `circle-stroke-opacity`)
    });
var Xd = {
    get paint () {
        return Yd();
    },
    get layout () {
        return qd();
    }
};
const Zd = (e)=>e.type === `circle`;
var Qd = class extends yl {
    constructor(e, t){
        super(e, Xd, t);
    }
    createBucket(e) {
        return new bd(e);
    }
    queryRadius(e) {
        let t = e;
        return Pd(`circle-radius`, this, t) + Pd(`circle-stroke-width`, this, t) + Fd(this.paint.get(`circle-translate`));
    }
    queryIntersectsFeature({ queryGeometry: e, feature: t, featureState: n, geometry: r, transform: i, pixelsToTileUnits: a, unwrappedTileID: o, getElevation: s }) {
        let c = Id(e, this.paint.get(`circle-translate`), this.paint.get(`circle-translate-anchor`), -i.bearingInRadians, a), l = this.paint.get(`circle-radius`).evaluate(t, n) + this.paint.get(`circle-stroke-width`).evaluate(t, n), u = this.paint.get(`circle-pitch-scale`), d = this.paint.get(`circle-pitch-alignment`), f, p;
        return d === `map` ? (f = c, p = l * a) : (f = Gd(c, i, o, s), p = l), Ud({
            queryGeometry: f,
            size: p,
            transform: i,
            unwrappedTileID: o,
            getElevation: s,
            pitchAlignment: d,
            pitchScale: u
        }, r);
    }
}, $d = class extends bd {
};
H(`HeatmapBucket`, $d, {
    omit: [
        `layers`
    ]
});
let ef;
const tf = ()=>ef ||= new gl({
        "heatmap-radius": new G(j.paint_heatmap[`heatmap-radius`], `heatmap-radius`),
        "heatmap-weight": new G(j.paint_heatmap[`heatmap-weight`], `heatmap-weight`),
        "heatmap-intensity": new W(j.paint_heatmap[`heatmap-intensity`], `heatmap-intensity`),
        "heatmap-color": new hl(j.paint_heatmap[`heatmap-color`], `heatmap-color`),
        "heatmap-opacity": new W(j.paint_heatmap[`heatmap-opacity`], `heatmap-opacity`)
    });
var nf = {
    get paint () {
        return tf();
    }
};
function rf(e, { width: t, height: n }, r, i) {
    if (!i) i = new Uint8Array(t * n * r);
    else if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
    else if (i.length !== t * n * r) throw RangeError(`mismatched image size. expected: ${i.length} but got: ${t * n * r}`);
    return e.width = t, e.height = n, e.data = i, e;
}
function af(e, { width: t, height: n }, r) {
    if (t === e.width && n === e.height) return;
    let i = rf({}, {
        width: t,
        height: n
    }, r);
    of(e, i, {
        x: 0,
        y: 0
    }, {
        x: 0,
        y: 0
    }, {
        width: Math.min(e.width, t),
        height: Math.min(e.height, n)
    }, r), e.width = t, e.height = n, e.data = i.data;
}
function of(e, t, n, r, i, a) {
    if (i.width === 0 || i.height === 0) return t;
    if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw RangeError(`out of range source coordinates for image copy`);
    if (i.width > t.width || i.height > t.height || r.x > t.width - i.width || r.y > t.height - i.height) throw RangeError(`out of range destination coordinates for image copy`);
    let o = e.data, s = t.data;
    if (o === s) throw Error(`srcData equals dstData, so image is already copied`);
    for(let c = 0; c < i.height; c++){
        let l = ((n.y + c) * e.width + n.x) * a, u = ((r.y + c) * t.width + r.x) * a;
        for(let e = 0; e < i.width * a; e++)s[u + e] = o[l + e];
    }
    return t;
}
var sf = class e {
    constructor(e, t){
        rf(this, e, 1, t);
    }
    resize(e) {
        af(this, e, 1);
    }
    clone() {
        return new e({
            width: this.width,
            height: this.height
        }, new Uint8Array(this.data));
    }
    static copy(e, t, n, r, i) {
        of(e, t, n, r, i, 1);
    }
}, cf = class e {
    constructor(e, t){
        rf(this, e, 4, t);
    }
    resize(e) {
        af(this, e, 4);
    }
    replace(e, t) {
        t ? this.data.set(e) : e instanceof Uint8ClampedArray ? this.data = new Uint8Array(e.buffer) : this.data = e;
    }
    clone() {
        return new e({
            width: this.width,
            height: this.height
        }, new Uint8Array(this.data));
    }
    static copy(e, t, n, r, i) {
        of(e, t, n, r, i, 4);
    }
    setPixel(e, t, n) {
        let r = (e * this.width + t) * 4;
        this.data[r + 0] = Math.round(n.r * 255 / n.a), this.data[r + 1] = Math.round(n.g * 255 / n.a), this.data[r + 2] = Math.round(n.b * 255 / n.a), this.data[r + 3] = Math.round(n.a * 255);
    }
};
function lf(e) {
    let t = new Uint8Array(e.length);
    for(let n = 0; n < e.length; n += 4){
        let r = e[n + 3];
        t[n + 0] = Math.round(e[n + 0] * r / 255), t[n + 1] = Math.round(e[n + 1] * r / 255), t[n + 2] = Math.round(e[n + 2] * r / 255), t[n + 3] = r;
    }
    return t;
}
H(`AlphaImage`, sf), H(`RGBAImage`, cf);
function uf(e) {
    let t = {}, n = e.resolution || 256, r = e.clips ? e.clips.length : 1, i = e.image || new cf({
        width: n,
        height: r
    });
    if (!Tt(n)) throw Error(`width is not a power of 2 - ${n}`);
    let a = (r, a, o)=>{
        t[e.evaluationKey] = o;
        let s = e.expression.evaluate(t);
        i.setPixel(r / 4 / n, a / 4, s);
    };
    if (e.clips) for(let t = 0, i = 0; t < r; ++t, i += n * 4)for(let r = 0, o = 0; r < n; r++, o += 4){
        let s = r / (n - 1), { start: c, end: l } = e.clips[t], u = c * (1 - s) + l * s;
        a(i, o, u);
    }
    else for(let e = 0, t = 0; e < n; e++, t += 4){
        let r = e / (n - 1);
        a(0, t, r);
    }
    return i;
}
const df = `big-fb`, ff = (e)=>e.type === `heatmap`;
var pf = class extends yl {
    createBucket(e) {
        return new $d(e);
    }
    constructor(e, t){
        super(e, nf, t), this.heatmapFbos = new Map, this._updateColorRamp();
    }
    _handleSpecialPaintPropertyUpdate(e) {
        e === `heatmap-color` && this._updateColorRamp();
    }
    _updateColorRamp() {
        let e = this._transitionablePaint._values[`heatmap-color`].value.expression;
        this.colorRamp = uf({
            expression: e,
            evaluationKey: `heatmapDensity`,
            image: this.colorRamp
        }), this.colorRampTexture = null;
    }
    resize() {
        this.heatmapFbos.has(`big-fb`) && this.heatmapFbos.delete(df);
    }
    queryRadius(e) {
        return Pd(`heatmap-radius`, this, e);
    }
    queryIntersectsFeature({ queryGeometry: e, feature: t, featureState: n, geometry: r, transform: i, pixelsToTileUnits: a, unwrappedTileID: o, getElevation: s }) {
        return Ud({
            queryGeometry: e,
            size: this.paint.get(`heatmap-radius`).evaluate(t, n) * a,
            transform: i,
            unwrappedTileID: o,
            getElevation: s
        }, r);
    }
    hasOffscreenPass() {
        return this.paint.get(`heatmap-opacity`) !== 0 && !this.isHidden();
    }
};
let mf;
const hf = ()=>mf ||= new gl({
        "hillshade-illumination-direction": new W(j.paint_hillshade[`hillshade-illumination-direction`], `hillshade-illumination-direction`),
        "hillshade-illumination-altitude": new W(j.paint_hillshade[`hillshade-illumination-altitude`], `hillshade-illumination-altitude`),
        "hillshade-illumination-anchor": new W(j.paint_hillshade[`hillshade-illumination-anchor`], `hillshade-illumination-anchor`),
        "hillshade-exaggeration": new W(j.paint_hillshade[`hillshade-exaggeration`], `hillshade-exaggeration`),
        "hillshade-shadow-color": new W(j.paint_hillshade[`hillshade-shadow-color`], `hillshade-shadow-color`),
        "hillshade-highlight-color": new W(j.paint_hillshade[`hillshade-highlight-color`], `hillshade-highlight-color`),
        "hillshade-accent-color": new W(j.paint_hillshade[`hillshade-accent-color`], `hillshade-accent-color`),
        "hillshade-method": new W(j.paint_hillshade[`hillshade-method`], `hillshade-method`),
        resampling: new W(j.paint_hillshade.resampling, `resampling`)
    });
var gf = {
    get paint () {
        return hf();
    }
};
const _f = (e)=>e.type === `hillshade`;
var vf = class extends yl {
    constructor(e, t){
        super(e, gf, t), this.recalculate({
            zoom: 0,
            zoomHistory: {}
        }, void 0);
    }
    getIlluminationProperties() {
        let e = this.paint.get(`hillshade-illumination-direction`).values, t = this.paint.get(`hillshade-illumination-altitude`).values, n = this.paint.get(`hillshade-highlight-color`).values, r = this.paint.get(`hillshade-shadow-color`).values, i = Math.max(e.length, t.length, n.length, r.length);
        e = e.concat(Array(i - e.length).fill(e.at(-1))), t = t.concat(Array(i - t.length).fill(t.at(-1))), n = n.concat(Array(i - n.length).fill(n.at(-1))), r = r.concat(Array(i - r.length).fill(r.at(-1)));
        let a = t.map(en);
        return {
            directionRadians: e.map(en),
            altitudeRadians: a,
            shadowColor: r,
            highlightColor: n
        };
    }
    hasOffscreenPass() {
        return this.paint.get(`hillshade-exaggeration`) !== 0 && !this.isHidden();
    }
};
let yf;
const bf = ()=>yf ||= new gl({
        "color-relief-opacity": new W(j[`paint_color-relief`][`color-relief-opacity`], `color-relief-opacity`),
        "color-relief-color": new hl(j[`paint_color-relief`][`color-relief-color`], `color-relief-color`),
        resampling: new W(j[`paint_color-relief`].resampling, `resampling`)
    });
var xf = {
    get paint () {
        return bf();
    }
};
function Sf(e) {
    return `data` in e;
}
var Cf = class {
    constructor(e, t, n, r){
        this.context = e, this.format = n, this.texture = e.gl.createTexture(), this._ownedHandle = this.texture, this.update(t, r);
    }
    update(e, t, n) {
        let { width: r, height: i } = e, a = (this.size?.[0] !== r || this.size[1] !== i) && !n, { context: o } = this, { gl: s } = o;
        this.useMipmap = !!t?.useMipmap, a && this.size && this.format === s.RGBA && (s.deleteTexture(this.texture), this.texture = s.createTexture(), this._ownedHandle = this.texture), s.bindTexture(s.TEXTURE_2D, this.texture), o.pixelStoreUnpackFlipY.set(!1), o.pixelStoreUnpack.set(1);
        let c = this.format === s.RGBA && t?.premultiply !== !1;
        if (a) {
            if (this.size = [
                r,
                i
            ], this.format === s.RGBA && r > 0 && i > 0) {
                let t = this.useMipmap ? Math.floor(Math.log2(Math.max(r, i))) + 1 : 1;
                if (s.texStorage2D(s.TEXTURE_2D, t, s.RGBA8, r, i), Sf(e)) {
                    o.pixelStoreUnpackPremultiplyAlpha.set(!1);
                    let { data: t } = e;
                    c && t && (t = lf(t)), t && s.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, r, i, s.RGBA, s.UNSIGNED_BYTE, t);
                } else o.pixelStoreUnpackPremultiplyAlpha.set(c), s.texSubImage2D(s.TEXTURE_2D, 0, 0, 0, s.RGBA, s.UNSIGNED_BYTE, e);
            } else Sf(e) ? (o.pixelStoreUnpackPremultiplyAlpha.set(!1), this._uploadRawData(e, c, r, i, s)) : (o.pixelStoreUnpackPremultiplyAlpha.set(c), this._uploadDomImage(e, s));
        } else {
            let { x: t, y: a } = n || {
                x: 0,
                y: 0
            };
            Sf(e) ? (o.pixelStoreUnpackPremultiplyAlpha.set(!1), this._updateRawData(e, c, t, a, r, i, s)) : (o.pixelStoreUnpackPremultiplyAlpha.set(c), this._updateDomImage(e, t, a, s));
        }
        this.useMipmap && s.generateMipmap(s.TEXTURE_2D), o.pixelStoreUnpackFlipY.setDefault(), o.pixelStoreUnpack.setDefault(), o.pixelStoreUnpackPremultiplyAlpha.setDefault();
    }
    _uploadDomImage(e, t) {
        t.texImage2D(t.TEXTURE_2D, 0, this.format, this.format, t.UNSIGNED_BYTE, e);
    }
    _uploadRawData(e, t, n, r, i) {
        let { data: a } = e;
        t && a && (a = lf(a)), i.texImage2D(i.TEXTURE_2D, 0, this.format, n, r, 0, this.format, i.UNSIGNED_BYTE, a);
    }
    _updateDomImage(e, t, n, r) {
        r.texSubImage2D(r.TEXTURE_2D, 0, t, n, r.RGBA, r.UNSIGNED_BYTE, e);
    }
    _updateRawData(e, t, n, r, i, a, o) {
        let { data: s } = e;
        t && s && (s = lf(s)), o.texSubImage2D(o.TEXTURE_2D, 0, n, r, i, a, o.RGBA, o.UNSIGNED_BYTE, s);
    }
    bind(e, t, n) {
        let { context: r } = this, { gl: i } = r;
        this.texture !== this._ownedHandle && (this.texture = this._ownedHandle), i.bindTexture(i.TEXTURE_2D, this.texture), n === i.LINEAR_MIPMAP_NEAREST && !this.useMipmap && (n = i.LINEAR), e !== this.filter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, e), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, n || e), this.filter = e), t !== this.wrap && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, t), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, t), this.wrap = t);
    }
    destroy() {
        let { gl: e } = this.context;
        e.deleteTexture(this.texture), this.texture = null, this._ownedHandle = null;
    }
}, wf = class e {
    static{
        this.byteViewCache = new WeakMap;
    }
    constructor(t, n, r, i = 1, a = 1, o = 1, s = 0){
        if (this.uid = t, n.height !== n.width) throw RangeError(`DEM tiles must be square`);
        if (r && ![
            `mapbox`,
            `terrarium`,
            `custom`
        ].includes(r)) {
            Ft(`"${r}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
            return;
        }
        this.stride = n.height;
        let c = this.dim = n.height - 2;
        switch(this.data = new Uint32Array(n.data.buffer), e.byteViewCache.set(this, new Uint8Array(this.data.buffer)), r){
            case `terrarium`:
                this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                break;
            case `custom`:
                this.redFactor = i, this.greenFactor = a, this.blueFactor = o, this.baseShift = s;
                break;
            default:
                this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                break;
        }
        for(let e = 0; e < c; e++)this.data[this._idx(-1, e)] = this.data[this._idx(0, e)], this.data[this._idx(c, e)] = this.data[this._idx(c - 1, e)], this.data[this._idx(e, -1)] = this.data[this._idx(e, 0)], this.data[this._idx(e, c)] = this.data[this._idx(e, c - 1)];
        this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(c, -1)] = this.data[this._idx(c - 1, 0)], this.data[this._idx(-1, c)] = this.data[this._idx(0, c - 1)], this.data[this._idx(c, c)] = this.data[this._idx(c - 1, c - 1)];
        let l = this._getByteView();
        this.min = 2 ** 53 - 1, this.max = -(2 ** 53 - 1);
        for(let e = 0; e < c; e++)for(let t = 0; t < c; t++){
            let n = this._idx(e, t) * 4, r = this._unpackAtIndex(l, n);
            r > this.max && (this.max = r), r < this.min && (this.min = r);
        }
    }
    get(e, t) {
        let n = this._getByteView(), r = this._idx(e, t) * 4;
        return this._unpackAtIndex(n, r);
    }
    sampleBilinear(e, t) {
        let n = Math.floor(e), r = Math.floor(t);
        if (n < -1 || n >= this.dim || r < -1 || r >= this.dim) throw RangeError(`Out of range source coordinates for DEM data. x: ${e}, y: ${t}, dim: ${this.dim}`);
        let i = this._getByteView(), a = ((r + 1) * this.stride + n + 1) * 4, o = this.stride * 4, s = e - n, c = t - r, l = this._unpackAtIndex(i, a), u = this._unpackAtIndex(i, a + 4), d = this._unpackAtIndex(i, a + o), f = this._unpackAtIndex(i, a + o + 4);
        return l * (1 - s) * (1 - c) + u * s * (1 - c) + d * (1 - s) * c + f * s * c;
    }
    getUnpackVector() {
        return [
            this.redFactor,
            this.greenFactor,
            this.blueFactor,
            this.baseShift
        ];
    }
    _idx(e, t) {
        if (e < -1 || e >= this.dim + 1 || t < -1 || t >= this.dim + 1) throw RangeError(`Out of range source coordinates for DEM data. x: ${e}, y: ${t}, dim: ${this.dim}`);
        return (t + 1) * this.stride + (e + 1);
    }
    unpack(e, t, n) {
        return e * this.redFactor + t * this.greenFactor + n * this.blueFactor - this.baseShift;
    }
    pack(e) {
        return Tf(e, this.getUnpackVector());
    }
    getPixels() {
        return new cf({
            width: this.stride,
            height: this.stride
        }, this._getByteView());
    }
    backfillBorder(e, t, n) {
        if (this.dim !== e.dim) throw Error(`dem dimension mismatch`);
        let r = t * this.dim, i = t * this.dim + this.dim, a = n * this.dim, o = n * this.dim + this.dim;
        switch(t){
            case -1:
                r = i - 1;
                break;
            case 1:
                i = r + 1;
                break;
        }
        switch(n){
            case -1:
                a = o - 1;
                break;
            case 1:
                o = a + 1;
                break;
        }
        let s = -t * this.dim, c = -n * this.dim;
        for(let t = a; t < o; t++)for(let n = r; n < i; n++)this.data[this._idx(n, t)] = e.data[this._idx(n + s, t + c)];
    }
    _getByteView() {
        let t = e.byteViewCache.get(this);
        return t?.buffer !== this.data.buffer && (t = new Uint8Array(this.data.buffer), e.byteViewCache.set(this, t)), t;
    }
    _unpackAtIndex(e, t) {
        return this.unpack(e[t], e[t + 1], e[t + 2]);
    }
};
function Tf(e, t) {
    let n = t[0], r = t[1], i = t[2], a = t[3], o = Math.min(n, r, i), s = Math.round((e + a) / o);
    return {
        r: Math.floor(s * o / n) % 256,
        g: Math.floor(s * o / r) % 256,
        b: Math.floor(s * o / i) % 256
    };
}
H(`DEMData`, wf);
const Ef = (e)=>e.type === `color-relief`;
var Df = class extends yl {
    constructor(e, t){
        super(e, xf, t);
    }
    _createColorRamp(e) {
        let t = {
            elevationStops: [],
            colorStops: []
        }, n = this._transitionablePaint._values[`color-relief-color`].value.expression;
        if (n instanceof Ko && n._styleExpression.expression instanceof Ti) {
            this.colorRampExpression = n;
            let e = n._styleExpression.expression;
            t.elevationStops = e.labels, t.colorStops = [];
            for (let n of t.elevationStops)t.colorStops.push(e.evaluate({
                globals: {
                    elevation: n
                }
            }));
        }
        if (t.elevationStops.length < 1 && (t.elevationStops = [
            0
        ], t.colorStops = [
            z.transparent
        ]), t.elevationStops.length < 2 && (t.elevationStops.push(t.elevationStops[0] + 1), t.colorStops.push(t.colorStops[0])), t.elevationStops.length <= e) return t;
        let r = {
            elevationStops: [],
            colorStops: []
        }, i = (t.elevationStops.length - 1) / (e - 1);
        for(let e = 0; e < t.elevationStops.length - .5; e += i)r.elevationStops.push(t.elevationStops[Math.round(e)]), r.colorStops.push(t.colorStops[Math.round(e)]);
        return Ft(`Too many colors in specification of ${this.id} color-relief layer, may not render properly. Max possible colors: ${e}, provided: ${t.elevationStops.length}`), r;
    }
    _colorRampChanged() {
        return this.colorRampExpression != this._transitionablePaint._values[`color-relief-color`].value.expression;
    }
    getColorRampTextures(e, t, n) {
        if (this.colorRampTextures && !this._colorRampChanged()) return this.colorRampTextures;
        let r = this._createColorRamp(t), i = new cf({
            width: r.colorStops.length,
            height: 1
        }), a = new cf({
            width: r.colorStops.length,
            height: 1
        });
        for(let e = 0; e < r.elevationStops.length; e++){
            let t = Tf(r.elevationStops[e], n);
            a.setPixel(0, e, new z(t.r / 255, t.g / 255, t.b / 255, 1)), i.setPixel(0, e, r.colorStops[e]);
        }
        return this.colorRampTextures = {
            elevationTexture: new Cf(e, a, e.gl.RGBA),
            colorTexture: new Cf(e, i, e.gl.RGBA)
        }, this.colorRampTextures;
    }
    hasOffscreenPass() {
        return !this.isHidden() && !!this.colorRampTextures;
    }
};
const Of = q([
    {
        name: `a_pos`,
        components: 2,
        type: `Int16`
    }
], 4), kf = Of.members;
Of.size, Of.alignment;
function Af(e, t, n) {
    let r = n.patternDependencies, i = !1;
    for (let n of t){
        let t = n.paint.get(`${e}-pattern`);
        t.isConstant() || (i = !0);
        let a = t.constantOr(null);
        a && (i = !0, r[a.to] = !0, r[a.from] = !0);
    }
    return i;
}
function jf(e, t, n, r, i) {
    let { zoom: a } = r, o = i.patternDependencies;
    for (let r of t){
        let t = r.paint.get(`${e}-pattern`).value;
        if (t.kind !== `constant`) {
            let e = t.evaluate({
                zoom: a - 1
            }, n, {}, i.availableImages), s = t.evaluate({
                zoom: a
            }, n, {}, i.availableImages), c = t.evaluate({
                zoom: a + 1
            }, n, {}, i.availableImages);
            e = e?.name ? e.name : e, s = s?.name ? s.name : s, c = c?.name ? c.name : c, o[e] = !0, o[s] = !0, o[c] = !0, n.patterns[r.id] = {
                min: e,
                mid: s,
                max: c
            };
        }
    }
    return n;
}
const Mf = new Set;
let Nf = !1;
function Pf(e, t, n = 2) {
    let r = t && t.length, i = r ? t[0] * n : e.length;
    Mf.size && Mf.clear();
    let a = Ff(e, 0, i, n, !0), o = [];
    if (!a || a.next === a.prev) return o;
    let s = 0, c = 0, l = 0;
    if (r && (a = Uf(e, t, a, n)), e.length > 80 * n) {
        s = e[0], c = e[1];
        let t = s, r = c;
        for(let a = n; a < i; a += n){
            let n = e[a], i = e[a + 1];
            n < s && (s = n), i < c && (c = i), n > t && (t = n), i > r && (r = i);
        }
        l = Math.max(t - s, r - c), l = l === 0 ? 0 : 32767 / l;
    }
    return Lf(a, o, s, c, l), o;
}
function Ff(e, t, n, r, i) {
    let a = null;
    if (i === Tp(e, t, n, r) > 0) for(let i = t; i < n; i += r)a = Sp(i / r | 0, e[i], e[i + 1], a);
    else for(let i = n - r; i >= t; i -= r)a = Sp(i / r | 0, e[i], e[i + 1], a);
    return a && hp(a, a.next) && (Cp(a), a = a.next), a;
}
function If(e, t = e) {
    let n = t === e, r = e, i;
    do i = !1, r !== r.next && (Mf.size === 0 || !Mf.has(r)) && (hp(r, r.next) || mp(r.prev, r, r.next) === 0) ? ((n || r === t) && (t = r.prev), Nf = !0, Cp(r), r = r.prev, i = !0) : (n || r !== t) && (r = r.next, i = !n);
    while (i || r !== t);
    return t;
}
function Lf(e, t, n, r, i) {
    i && sp(e, n, r, i);
    let a = e, o = !1;
    for(; e.prev !== e.next;){
        let s = e.prev, c = e.next;
        if (mp(s, e, c) < 0 && (i ? zf(e, n, r, i) : Rf(e))) {
            t.push(s.i, e.i, c.i), Cp(e), e = c, a = c;
            continue;
        }
        if (e = c, e === a) {
            if (Nf = !1, e = If(e), Nf) {
                a = e;
                continue;
            }
            if (!o) {
                e = Bf(e, t), a = e, o = !0;
                continue;
            }
            Vf(e, t, n, r, i);
            break;
        }
    }
}
function Rf(e) {
    let t = e.prev, n = e, r = e.next, i = t.x, a = n.x, o = r.x, s = t.y, c = n.y, l = r.y, u = Math.min(i, a, o), d = Math.min(s, c, l), f = Math.max(i, a, o), p = Math.max(s, c, l), m = r.next;
    for(; m !== t;){
        if (m.x >= u && m.x <= f && m.y >= d && m.y <= p && (i !== m.x || s !== m.y) && fp(i, s, a, c, o, l, m.x, m.y) && mp(m.prev, m, m.next) >= 0) return !1;
        m = m.next;
    }
    return !0;
}
function zf(e, t, n, r) {
    let i = e.prev, a = e, o = e.next, s = i.x, c = a.x, l = o.x, u = i.y, d = a.y, f = o.y, p = Math.min(s, c, l), m = Math.min(u, d, f), h = Math.max(s, c, l), g = Math.max(u, d, f), _ = up(p, m, t, n, r), v = up(h, g, t, n, r), y = e.prevZ;
    for(; y && y.z >= _;){
        if (y.x >= p && y.x <= h && y.y >= m && y.y <= g && y !== o && (s !== y.x || u !== y.y) && fp(s, u, c, d, l, f, y.x, y.y) && mp(y.prev, y, y.next) >= 0) return !1;
        y = y.prevZ;
    }
    let b = e.nextZ;
    for(; b && b.z <= v;){
        if (b.x >= p && b.x <= h && b.y >= m && b.y <= g && b !== o && (s !== b.x || u !== b.y) && fp(s, u, c, d, l, f, b.x, b.y) && mp(b.prev, b, b.next) >= 0) return !1;
        b = b.nextZ;
    }
    return !0;
}
function Bf(e, t) {
    let n = e, r = !1;
    do {
        let i = n.prev, a = n.next.next;
        gp(i, n, n.next, a, !1) && yp(i, a) && yp(a, i) && (t.push(i.i, n.i, a.i), Cp(n), Cp(n.next), n = e = a, r = !0), n = n.next;
    }while (n !== e);
    return r ? If(n) : n;
}
function Vf(e, t, n, r, i) {
    let a = e;
    do {
        let e = a.next.next;
        for(; e !== a.prev;){
            if (a.i !== e.i && pp(a, e)) {
                let o = xp(a, e);
                a = If(a, a.next), o = If(o, o.next), Lf(a, t, n, r, i), Lf(o, t, n, r, i);
                return;
            }
            e = e.next;
        }
        a = a.next;
    }while (a !== e);
}
let Hf = !1;
function Uf(e, t, n, r) {
    let i = [];
    for(let n = 0, a = t.length; n < a; n++){
        let o = Ff(e, t[n] * r, n < a - 1 ? t[n + 1] * r : e.length, r, !1);
        o === o.next && Mf.add(o), i.push(dp(o));
    }
    i.sort(Wf), Yf(e.length / r, t.length), Xf(n, n), Hf = !0;
    for(let e = 0; e < i.length; e++)n = Gf(i[e], n);
    return Hf = !1, If(n);
}
function Wf(e, t) {
    return e.x - t.x || e.y - t.y || (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x);
}
function Gf(e, t) {
    let n = ep(e, t);
    if (!n) return t;
    let r = xp(n, e), i = r.next;
    return Xf(n, i.next), If(r, r.next), If(n, n.next);
}
let J = new Float64Array, Kf = 0;
const qf = [], Jf = [];
function Yf(e, t) {
    let n = Math.ceil((e + 2 * t) / 16) + t + 2;
    J.length < n * 4 && (J = new Float64Array(n * 4)), Kf = 0;
}
function Xf(e, t) {
    let n = e;
    do {
        let e = Kf++;
        qf[e] = n;
        let r = 1 / 0, i = 1 / 0, a = -1 / 0, o = -1 / 0, s = 0;
        do {
            let t = n.next;
            n.z = e, n.x < r && (r = n.x), n.x > a && (a = n.x), n.y < i && (i = n.y), n.y > o && (o = n.y), t.x < r && (r = t.x), t.x > a && (a = t.x), t.y < i && (i = t.y), t.y > o && (o = t.y), n = t;
        }while (++s < 16 && n !== t);
        Jf[e] = n;
        let c = e * 4;
        J[c] = r, J[c + 1] = i, J[c + 2] = a, J[c + 3] = o;
    }while (n !== t);
}
function Zf(e, t) {
    let n = e.z * 4;
    t.x < J[n] && (J[n] = t.x), t.y < J[n + 1] && (J[n + 1] = t.y), t.x > J[n + 2] && (J[n + 2] = t.x), t.y > J[n + 3] && (J[n + 3] = t.y);
}
function Qf(e) {
    let t = Jf[e];
    for(; t.prev.next !== t;)t = t.next;
    return Jf[e] = t, t;
}
function $f(e) {
    let t = qf[e];
    for(; t.prev.next !== t;)t = t.next;
    return qf[e] = t, t;
}
function ep(e, t) {
    let n = t, r = e.x, i = e.y, a = -1 / 0, o;
    if (hp(e, n)) return n;
    for(let t = 0, s = 0; t < Kf; t++, s += 4){
        if (i < J[s + 1] || i > J[s + 3] || J[s] > r || J[s + 2] <= a) continue;
        let c = Qf(t);
        n = $f(t);
        do {
            if (n.prev.next === n) {
                if (hp(e, n.next)) return n.next;
                if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
                    let e = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                    if (e <= r && e > a && (a = e, o = n.x < n.next.x ? n : n.next, e === r)) return o;
                }
            }
            n = n.next;
        }while (n !== c);
    }
    if (!o) return null;
    let s = o.x, c = o.y, l = Math.min(i, c), u = Math.max(i, c), d = 1 / 0;
    for(let t = 0, f = 0; t < Kf; t++, f += 4){
        if (J[f + 2] < s || J[f] > r || J[f + 3] < l || J[f + 1] > u) continue;
        let p = Qf(t);
        n = $f(t);
        do {
            if (n.prev.next === n && r >= n.x && n.x >= s && r !== n.x && fp(i < c ? r : a, i, s, c, i < c ? a : r, i, n.x, n.y)) {
                let t = Math.abs(i - n.y) / (r - n.x);
                (yp(n, e) || n.y === i && n.next.y === i && n.next.x > r) && (t < d || t === d && (n.x > o.x || n.x === o.x && tp(o, n))) && (o = n, d = t);
            }
            n = n.next;
        }while (n !== p);
    }
    return o;
}
function tp(e, t) {
    return mp(e.prev, e, t.prev) < 0 && mp(t.next, e, e.next) < 0;
}
const np = [];
let rp = [], ip = new Uint32Array, ap = new Uint32Array;
const op = new Uint32Array(256);
function sp(e, t, n, r) {
    let i = e, a = 0;
    do i.z = up(i.x, i.y, t, n, r), np[a++] = i, i = i.next;
    while (i !== e);
    cp(a);
    let o = null;
    for(let e = 0; e < a; e++){
        let t = np[e];
        t.prevZ = o, o && (o.nextZ = t), o = t;
    }
    o.nextZ = null;
}
function cp(e) {
    if (e <= 32) {
        for(let t = 1; t < e; t++){
            let e = np[t], n = e.z, r = t - 1;
            for(; r >= 0 && np[r].z > n;)np[r + 1] = np[r], r--;
            np[r + 1] = e;
        }
        return;
    }
    ip.length < e && (ip = new Uint32Array(e), ap = new Uint32Array(e), rp = Array(e));
    for(let t = 0; t < e; t++)ip[t] = np[t].z;
    lp(e, np, ip, rp, ap, 0), lp(e, rp, ap, np, ip, 8), lp(e, np, ip, rp, ap, 16), lp(e, rp, ap, np, ip, 24);
}
function lp(e, t, n, r, i, a) {
    op.fill(0);
    for(let t = 0; t < e; t++)op[n[t] >>> a & 255]++;
    let o = 0;
    for(let e = 0; e < 256; e++){
        let t = op[e];
        op[e] = o, o += t;
    }
    for(let o = 0; o < e; o++){
        let e = n[o], s = op[e >>> a & 255]++;
        r[s] = t[o], i[s] = e;
    }
}
function up(e, t, n, r, i) {
    return e = (e - n) * i | 0, t = (t - r) * i | 0, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, e | t << 1;
}
function dp(e) {
    let t = e, n = e;
    do (t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
    while (t !== e);
    return n;
}
function fp(e, t, n, r, i, a, o, s) {
    return (i - o) * (t - s) >= (e - o) * (a - s) && (e - o) * (r - s) >= (n - o) * (t - s) && (n - o) * (a - s) >= (i - o) * (r - s);
}
function pp(e, t) {
    let n = hp(e, t) && mp(e.prev, e, e.next) > 0 && mp(t.prev, t, t.next) > 0;
    return e.next.i !== t.i && (n || yp(e, t) && yp(t, e) && (mp(e.prev, e, t.prev) !== 0 || mp(e, t.prev, t) !== 0)) && !vp(e, t) && (n || bp(e, t));
}
function mp(e, t, n) {
    return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
}
function hp(e, t) {
    return e.x === t.x && e.y === t.y;
}
function gp(e, t, n, r, i = !0) {
    let a = mp(e, t, n), o = mp(e, t, r), s = mp(n, r, e), c = mp(n, r, t);
    return (a > 0 && o < 0 || a < 0 && o > 0) && (s > 0 && c < 0 || s < 0 && c > 0) ? !0 : i ? !!(a === 0 && _p(e, n, t) || o === 0 && _p(e, r, t) || s === 0 && _p(n, e, r) || c === 0 && _p(n, t, r)) : !1;
}
function _p(e, t, n) {
    return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
}
function vp(e, t) {
    let n = Math.min(e.x, t.x), r = Math.max(e.x, t.x), i = Math.min(e.y, t.y), a = Math.max(e.y, t.y), o = e;
    do {
        let s = o.next;
        if (o.x > r && s.x > r || o.x < n && s.x < n || o.y > a && s.y > a || o.y < i && s.y < i) {
            o = s;
            continue;
        }
        if (o.i !== e.i && s.i !== e.i && o.i !== t.i && s.i !== t.i && gp(o, s, e, t)) return !0;
        o = s;
    }while (o !== e);
    return !1;
}
function yp(e, t) {
    return mp(e.prev, e, e.next) < 0 ? mp(e, t, e.next) >= 0 && mp(e, e.prev, t) >= 0 : mp(e, t, e.prev) < 0 || mp(e, e.next, t) < 0;
}
function bp(e, t) {
    let n = e, r = !1, i = (e.x + t.x) / 2, a = (e.y + t.y) / 2;
    do {
        let e = n.next;
        n.y > a != e.y > a && i < (e.x - n.x) * (a - n.y) / (e.y - n.y) + n.x && (r = !r), n = e;
    }while (n !== e);
    return r;
}
function xp(e, t) {
    let n = wp(e.i, e.x, e.y), r = wp(t.i, t.x, t.y), i = e.next, a = t.prev;
    return e.next = t, t.prev = e, n.next = i, i.prev = n, r.next = n, n.prev = r, a.next = r, r.prev = a, r;
}
function Sp(e, t, n, r) {
    let i = wp(e, t, n);
    return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function Cp(e) {
    e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ), Hf && Zf(e.prev, e.next);
}
function wp(e, t, n) {
    return {
        i: e,
        x: t,
        y: n,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null
    };
}
function Tp(e, t, n, r) {
    let i = 0;
    for(let a = t, o = n - r; a < n; a += r)i += (e[o] - e[a]) * (e[a + 1] + e[o + 1]), o = a;
    return i;
}
var Ep = class {
    constructor(e, t){
        if (t > e) throw Error(`Min granularity must not be greater than base granularity.`);
        this._baseZoomGranularity = e, this._minGranularity = t;
    }
    getGranularityForZoomLevel(e) {
        let t = 1 << e;
        return Math.max(Math.floor(this._baseZoomGranularity / t), this._minGranularity, 1);
    }
}, Dp = class e {
    constructor(e){
        this.fill = e.fill, this.line = e.line, this.tile = e.tile, this.stencil = e.stencil, this.circle = e.circle;
    }
    static{
        this.noSubdivision = new e({
            fill: new Ep(0, 0),
            line: new Ep(0, 0),
            tile: new Ep(0, 0),
            stencil: new Ep(0, 0),
            circle: 1
        });
    }
};
H(`SubdivisionGranularityExpression`, Ep), H(`SubdivisionGranularitySetting`, Dp);
const Op = -32768, kp = 32767;
var Ap = class {
    constructor(e, t){
        this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = e, this._granularityCellSize = Ye / e, this._canonical = t;
    }
    _getKey(e, t) {
        return e += 32768, t += 32768, e << 16 | t << 0;
    }
    _vertexToIndex(e, t) {
        if (e < -32768 || t < -32768 || e > 32767 || t > 32767) throw Error(`Vertex coordinates are out of signed 16 bit integer range.`);
        let n = Math.round(e) | 0, r = Math.round(t) | 0, i = this._getKey(n, r);
        if (this._vertexDictionary.has(i)) return this._vertexDictionary.get(i);
        let a = this._vertexBuffer.length / 2;
        return this._vertexDictionary.set(i, a), this._vertexBuffer.push(n, r), a;
    }
    _subdivideTrianglesScanline(e) {
        if (this._granularity < 2) return Pp(this._vertexBuffer, e);
        let t = [], n = e.length;
        for(let r = 0; r < n; r += 3){
            let n = [
                e[r + 0],
                e[r + 1],
                e[r + 2]
            ], i = [
                this._vertexBuffer[e[r + 0] * 2 + 0],
                this._vertexBuffer[e[r + 0] * 2 + 1],
                this._vertexBuffer[e[r + 1] * 2 + 0],
                this._vertexBuffer[e[r + 1] * 2 + 1],
                this._vertexBuffer[e[r + 2] * 2 + 0],
                this._vertexBuffer[e[r + 2] * 2 + 1]
            ], a = 1 / 0, o = 1 / 0, s = -1 / 0, c = -1 / 0;
            for(let e = 0; e < 3; e++){
                let t = i[e * 2], n = i[e * 2 + 1];
                a = Math.min(a, t), s = Math.max(s, t), o = Math.min(o, n), c = Math.max(c, n);
            }
            if (a === s || o === c) continue;
            let l = Math.floor(a / this._granularityCellSize), u = Math.ceil(s / this._granularityCellSize), d = Math.floor(o / this._granularityCellSize), f = Math.ceil(c / this._granularityCellSize);
            if (l === u && d === f) {
                t.push(...n);
                continue;
            }
            for(let e = d; e < f; e++){
                let r = this._scanlineGenerateVertexRingForCellRow(e, i, n);
                Fp(this._vertexBuffer, r, t);
            }
        }
        return t;
    }
    _scanlineGenerateVertexRingForCellRow(e, t, n) {
        let r = e * this._granularityCellSize, i = r + this._granularityCellSize, a = [];
        for(let e = 0; e < 3; e++){
            let o = t[e * 2], s = t[e * 2 + 1], c = t[(e + 1) * 2 % 6], l = t[((e + 1) * 2 + 1) % 6], u = t[(e + 2) * 2 % 6], d = t[((e + 2) * 2 + 1) % 6], f = c - o, p = l - s, m = f === 0, h = p === 0, g = (r - s) / p, _ = (i - s) / p, v = Math.min(g, _), y = Math.max(g, _);
            if (!h && (v >= 1 || y <= 0) || h && (s < r || s > i)) {
                l >= r && l <= i && a.push(n[(e + 1) % 3]);
                continue;
            }
            if (!h && v > 0) {
                let e = o + f * v, t = s + p * v;
                a.push(this._vertexToIndex(e, t));
            }
            let b = o + f * Math.max(v, 0), x = o + f * Math.min(y, 1);
            if (m || this._generateIntraEdgeVertices(a, o, s, c, l, b, x), !h && y < 1) {
                let e = o + f * y, t = s + p * y;
                a.push(this._vertexToIndex(e, t));
            }
            (h || l >= r && l <= i) && a.push(n[(e + 1) % 3]), !h && (l <= r || l >= i) && this._generateInterEdgeVertices(a, o, s, c, l, u, d, x, r, i);
        }
        return a;
    }
    _generateIntraEdgeVertices(e, t, n, r, i, a, o) {
        let s = r - t, c = i - n, l = c === 0, u = l ? Math.min(t, r) : Math.min(a, o), d = l ? Math.max(t, r) : Math.max(a, o), f = Math.floor(u / this._granularityCellSize) + 1, p = Math.ceil(d / this._granularityCellSize) - 1;
        if (l ? t < r : a < o) for(let r = f; r <= p; r++){
            let i = r * this._granularityCellSize, a = n + c * (i - t) / s;
            e.push(this._vertexToIndex(i, a));
        }
        else for(let r = p; r >= f; r--){
            let i = r * this._granularityCellSize, a = n + c * (i - t) / s;
            e.push(this._vertexToIndex(i, a));
        }
    }
    _generateInterEdgeVertices(e, t, n, r, i, a, o, s, c, l) {
        let u = i - n, d = a - r, f = o - i, p = (c - i) / f, m = (l - i) / f, h = Math.min(p, m), g = Math.max(p, m), _ = r + d * h, v = Math.floor(Math.min(_, s) / this._granularityCellSize) + 1, y = Math.ceil(Math.max(_, s) / this._granularityCellSize) - 1, b = s < _, x = f === 0;
        if (x && (o === c || o === l)) return;
        if (x || h >= 1 || g <= 0) {
            let e = t - a, r = n - o, i = (c - o) / r, u = (l - o) / r, d = a + e * Math.min(i, u);
            v = Math.floor(Math.min(d, s) / this._granularityCellSize) + 1, y = Math.ceil(Math.max(d, s) / this._granularityCellSize) - 1, b = s < d;
        }
        let S = u > 0 ? l : c;
        if (b) for(let t = v; t <= y; t++){
            let n = t * this._granularityCellSize;
            e.push(this._vertexToIndex(n, S));
        }
        else for(let t = y; t >= v; t--){
            let n = t * this._granularityCellSize;
            e.push(this._vertexToIndex(n, S));
        }
    }
    _generateOutline(e) {
        let t = [];
        for (let n of e){
            let e = Mp(n, this._granularity, !0), r = this._pointArrayToIndices(e), i = [];
            for(let e = 1; e < r.length; e++)i.push(r[e - 1]), i.push(r[e]);
            t.push(i);
        }
        return t;
    }
    _handlePoles(e) {
        let t = !1, n = !1;
        this._canonical && (this._canonical.y === 0 && (t = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (n = !0)), (t || n) && this._fillPoles(e, t, n);
    }
    _ensureNoPoleVertices() {
        let e = this._vertexBuffer;
        for(let t = 0; t < e.length; t += 2){
            let n = e[t + 1];
            n === -32768 && (e[t + 1] = -32767), n === 32767 && (e[t + 1] = kp - 1);
        }
    }
    _generatePoleQuad(e, t, n, r, i, a) {
        r > i == (a === -32768) ? (e.push(n), e.push(t), e.push(this._vertexToIndex(r, a)), e.push(this._vertexToIndex(i, a)), e.push(n), e.push(this._vertexToIndex(r, a))) : (e.push(t), e.push(n), e.push(this._vertexToIndex(r, a)), e.push(n), e.push(this._vertexToIndex(i, a)), e.push(this._vertexToIndex(r, a)));
    }
    _fillPoles(e, t, n) {
        let r = this._vertexBuffer, i = Ye, a = e.length;
        for(let o = 2; o < a; o += 3){
            let a = e[o - 2], s = e[o - 1], c = e[o], l = r[a * 2], u = r[a * 2 + 1], d = r[s * 2], f = r[s * 2 + 1], p = r[c * 2], m = r[c * 2 + 1];
            t && (u === 0 && f === 0 && this._generatePoleQuad(e, a, s, l, d, Op), f === 0 && m === 0 && this._generatePoleQuad(e, s, c, d, p, Op), m === 0 && u === 0 && this._generatePoleQuad(e, c, a, p, l, Op)), n && (u === i && f === i && this._generatePoleQuad(e, a, s, l, d, kp), f === i && m === i && this._generatePoleQuad(e, s, c, d, p, kp), m === i && u === i && this._generatePoleQuad(e, c, a, p, l, kp));
        }
    }
    _initializeVertices(e) {
        for(let t = 0; t < e.length; t += 2)this._vertexToIndex(e[t], e[t + 1]);
    }
    subdividePolygonInternal(e, t) {
        if (this._used) throw Error(`Subdivision: multiple use not allowed.`);
        this._used = !0;
        let { flattened: n, holeIndices: r } = Np(e);
        this._initializeVertices(n);
        let i;
        try {
            let e = Pf(n, r), t = this._convertIndices(n, e);
            i = this._subdivideTrianglesScanline(t);
        } catch (e) {
            console.error(e);
        }
        let a = [];
        return t && (a = this._generateOutline(e)), this._ensureNoPoleVertices(), this._handlePoles(i), {
            verticesFlattened: this._vertexBuffer,
            indicesTriangles: i,
            indicesLineList: a
        };
    }
    _convertIndices(e, t) {
        let n = [];
        for (let r of t){
            let t = e[r * 2], i = e[r * 2 + 1];
            n.push(this._vertexToIndex(t, i));
        }
        return n;
    }
    _pointArrayToIndices(e) {
        let t = [];
        for (let n of e)t.push(this._vertexToIndex(n.x, n.y));
        return t;
    }
};
function jp(e, t, n, r = !0) {
    return new Ap(n, t).subdividePolygonInternal(e, r);
}
function Mp(e, t, n = !1) {
    if (!e || e.length < 1 || e.length < 2) return [];
    let r = e[0], i = e[e.length - 1], a = n && (r.x !== i.x || r.y !== i.y);
    if (t < 2) return a ? [
        ...e,
        e[0]
    ] : [
        ...e
    ];
    let o = Math.floor(Ye / t), s = [];
    s.push(new l(e[0].x, e[0].y));
    let c = e.length, u = a ? c : c - 1;
    for(let t = 0; t < u; t++){
        let n = e[t], r = t < c - 1 ? e[t + 1] : e[0], i = n.x, a = n.y, u = r.x, d = r.y, f = i !== u, p = a !== d;
        if (!f && !p) continue;
        let m = u - i, h = d - a, g = Math.abs(m), _ = Math.abs(h), v = i, y = a;
        for(;;){
            let e = m > 0 ? (Math.floor(v / o) + 1) * o : (Math.ceil(v / o) - 1) * o, t = h > 0 ? (Math.floor(y / o) + 1) * o : (Math.ceil(y / o) - 1) * o, n = Math.abs(v - e), r = Math.abs(y - t), i = Math.abs(v - u), a = Math.abs(y - d), c = f ? n / g : 1 / 0, b = p ? r / _ : 1 / 0;
            if ((i <= n || !f) && (a <= r || !p)) break;
            if (c < b && f || !p) {
                v = e, y += h * c;
                let t = new l(v, Math.round(y));
                (s[s.length - 1].x !== t.x || s[s.length - 1].y !== t.y) && s.push(t);
            } else {
                v += m * b, y = t;
                let e = new l(Math.round(v), y);
                (s[s.length - 1].x !== e.x || s[s.length - 1].y !== e.y) && s.push(e);
            }
        }
        let b = new l(u, d);
        (s[s.length - 1].x !== b.x || s[s.length - 1].y !== b.y) && s.push(b);
    }
    return s;
}
function Np(e) {
    let t = [], n = [];
    for (let r of e)if (r.length !== 0) {
        r !== e[0] && t.push(n.length / 2);
        for (let e of r)n.push(e.x), n.push(e.y);
    }
    return {
        flattened: n,
        holeIndices: t
    };
}
function Pp(e, t) {
    let n = [];
    for(let r = 0; r < t.length; r += 3){
        let i = t[r], a = t[r + 1], o = t[r + 2], s = e[i * 2], c = e[i * 2 + 1], l = e[a * 2], u = e[a * 2 + 1], d = e[o * 2], f = e[o * 2 + 1], p = l - s, m = u - c, h = d - s;
        p * (f - c) - m * h > 0 ? (n.push(i), n.push(o), n.push(a)) : (n.push(i), n.push(a), n.push(o));
    }
    return n;
}
function Fp(e, t, n) {
    if (t.length === 0) throw Error(`Subdivision vertex ring is empty.`);
    let r = 0, i = e[t[0] * 2];
    for(let n = 1; n < t.length; n++){
        let a = e[t[n] * 2];
        a < i && (i = a, r = n);
    }
    let a = t.length, o = r, s = (o + 1) % a;
    for(;;){
        let r = o - 1 >= 0 ? o - 1 : a - 1, i = (s + 1) % a, c = e[t[r] * 2], l = e[t[r] * 2 + 1], u = e[t[i] * 2], d = e[t[i] * 2 + 1], f = e[t[o] * 2], p = e[t[o] * 2 + 1], m = e[t[s] * 2], h = e[t[s] * 2 + 1], g = !1;
        if (c < u) g = !0;
        else if (c > u) g = !1;
        else {
            let e = h - p, t = -(m - f), n = p < h ? 1 : -1;
            ((c - f) * e + (l - p) * t) * n > ((u - f) * e + (d - p) * t) * n && (g = !0);
        }
        if (g) {
            let e = t[r], i = t[o], c = t[s];
            e !== i && e !== c && i !== c && n.push(c, i, e), o--, o < 0 && (o = a - 1);
        } else {
            let e = t[i], r = t[o], c = t[s];
            e !== r && e !== c && r !== c && n.push(c, r, e), s++, s >= a && (s = 0);
        }
        if (r === i) break;
    }
}
function Ip(e, t, n, r, i, a, o, s, c) {
    let l = i.length / 2, u = o && s && c;
    if (l < Nu.MAX_VERTEX_ARRAY_LENGTH) {
        let d = t.prepareSegment(l, n, r), f = d.vertexLength;
        for(let e = 0; e < a.length; e += 3)r.emplaceBack(f + a[e], f + a[e + 1], f + a[e + 2]);
        d.vertexLength += l, d.primitiveLength += a.length / 3;
        let p, m;
        u && (m = o.prepareSegment(l, n, s), p = m.vertexLength, m.vertexLength += l);
        for(let t = 0; t < i.length; t += 2)e(i[t], i[t + 1]);
        if (u) for (let e of c){
            for(let t = 1; t < e.length; t += 2)s.emplaceBack(p + e[t - 1], p + e[t]);
            m.primitiveLength += e.length / 2;
        }
    } else Rp(t, n, r, i, a, e), u && zp(o, n, s, i, c, e), t.forceNewSegmentOnNextPrepare(), o?.forceNewSegmentOnNextPrepare();
}
function Lp(e, t, n, r, i, a, o) {
    if (a) {
        let a = r.count;
        return n(t[i * 2], t[i * 2 + 1]), e[i] = r.count, r.count++, o.vertexLength++, a;
    } else return e[i];
}
function Rp(e, t, n, r, i, a) {
    let o = [];
    for(let e = 0; e < r.length / 2; e++)o.push(-1);
    let s = {
        count: 0
    }, c = 0, l = e.getOrCreateLatestSegment(t, n), u = l.vertexLength;
    for(let d = 2; d < i.length; d += 3){
        let f = i[d - 2], p = i[d - 1], m = i[d], h = o[f] < c, g = o[p] < c, _ = o[m] < c, v = +!!h + +!!g + +!!_;
        l.vertexLength + v > Nu.MAX_VERTEX_ARRAY_LENGTH && (l = e.createNewSegment(t, n), c = s.count, h = !0, g = !0, _ = !0, u = 0);
        let y = Lp(o, r, a, s, f, h, l), b = Lp(o, r, a, s, p, g, l), x = Lp(o, r, a, s, m, _, l);
        n.emplaceBack(u + y - c, u + b - c, u + x - c), l.primitiveLength++;
    }
}
function zp(e, t, n, r, i, a) {
    let o = [];
    for(let e = 0; e < r.length / 2; e++)o.push(-1);
    let s = {
        count: 0
    }, c = 0, l = e.getOrCreateLatestSegment(t, n), u = l.vertexLength;
    for (let d of i)for(let i = 1; i < d.length; i += 2){
        let f = d[i - 1], p = d[i], m = o[f] < c, h = o[p] < c, g = +!!m + +!!h;
        l.vertexLength + g > Nu.MAX_VERTEX_ARRAY_LENGTH && (l = e.createNewSegment(t, n), c = s.count, m = !0, h = !0, u = 0);
        let _ = Lp(o, r, a, s, f, m, l), v = Lp(o, r, a, s, p, h, l);
        n.emplaceBack(u + _ - c, u + v - c), l.primitiveLength++;
    }
}
var Bp = class {
    constructor(e){
        this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.id), this.index = e.index, this.hasDependencies = !1, this.patternFeatures = [], this.layoutVertexArray = new hu, this.indexArray = new Ou, this.indexArray2 = new ku, this.programConfigurations = new ud(e.layers, e.zoom), this.segments = new Nu, this.segments2 = new Nu, this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id);
    }
    populate(e, t, n) {
        this.hasDependencies = Af(`fill`, this.layers, t);
        let r = this.layers[0].layout.get(`fill-sort-key`), i = !r.isConstant(), a = [];
        for (let { feature: o, id: s, index: c, sourceLayerIndex: l } of e){
            let e = this.layers[0]._featureFilter.needGeometry, u = _d(o, e);
            if (!this.layers[0]._featureFilter.filter(new U(this.zoom), u, n)) continue;
            let d = i ? r.evaluate(u, {}, n, t.availableImages) : void 0, f = {
                id: s,
                properties: o.properties,
                type: o.type,
                sourceLayerIndex: l,
                index: c,
                geometry: e ? u.geometry : gd(o),
                patterns: {},
                sortKey: d
            };
            a.push(f);
        }
        i && a.sort((e, t)=>e.sortKey - t.sortKey);
        for (let r of a){
            let { geometry: i, index: a, sourceLayerIndex: o } = r;
            if (this.hasDependencies) {
                let e = jf(`fill`, this.layers, r, {
                    zoom: this.zoom
                }, t);
                this.patternFeatures.push(e);
            } else this.addFeature(r, i, a, n, {}, t.subdivisionGranularity);
            let s = e[a].feature;
            t.featureIndex.insert(s, i, a, o, this.index);
        }
    }
    update(e, t, n) {
        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e, t, this.stateDependentLayers, {
            imagePositions: n
        });
    }
    addFeatures(e, t, n) {
        for (let r of this.patternFeatures)this.addFeature(r, r.geometry, r.index, t, n, e.subdivisionGranularity);
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(e) {
        this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, kf), this.indexBuffer = e.createIndexBuffer(this.indexArray), this.indexBuffer2 = e.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(e), this.uploaded = !0;
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
    }
    addFeature(e, t, n, r, i, a) {
        for (let e of Ma(t, 500)){
            let t = jp(e, r, a.fill.getGranularityForZoomLevel(r.z)), n = this.layoutVertexArray;
            Ip((e, t)=>{
                n.emplaceBack(e, t);
            }, this.segments, this.layoutVertexArray, this.indexArray, t.verticesFlattened, t.indicesTriangles, this.segments2, this.indexArray2, t.indicesLineList);
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, n, {
            imagePositions: i,
            canonical: r
        });
    }
};
H(`FillBucket`, Bp, {
    omit: [
        `layers`,
        `patternFeatures`
    ]
});
let Vp;
const Hp = ()=>Vp ||= new gl({
        "fill-sort-key": new G(j.layout_fill[`fill-sort-key`], `fill-sort-key`)
    });
let Up;
const Wp = ()=>Up ||= new gl({
        "fill-antialias": new W(j.paint_fill[`fill-antialias`], `fill-antialias`),
        "fill-opacity": new G(j.paint_fill[`fill-opacity`], `fill-opacity`),
        "fill-layer-opacity": new W(j.paint_fill[`fill-layer-opacity`], `fill-layer-opacity`),
        "fill-color": new G(j.paint_fill[`fill-color`], `fill-color`),
        "fill-outline-color": new G(j.paint_fill[`fill-outline-color`], `fill-outline-color`),
        "fill-translate": new W(j.paint_fill[`fill-translate`], `fill-translate`),
        "fill-translate-anchor": new W(j.paint_fill[`fill-translate-anchor`], `fill-translate-anchor`),
        "fill-pattern": new pl(j.paint_fill[`fill-pattern`], `fill-pattern`)
    });
var Gp = {
    get paint () {
        return Wp();
    },
    get layout () {
        return Hp();
    }
};
const Kp = (e)=>e.type === `fill`;
var qp = class extends yl {
    constructor(e, t){
        super(e, Gp, t);
    }
    recalculate(e, t) {
        super.recalculate(e, t);
        let n = this.paint._values[`fill-outline-color`];
        n.value.kind === `constant` && n.value.value === void 0 && (this.paint._values[`fill-outline-color`] = this.paint._values[`fill-color`]);
    }
    createBucket(e) {
        return new Bp(e);
    }
    queryRadius() {
        return Fd(this.paint.get(`fill-translate`));
    }
    queryIntersectsFeature({ queryGeometry: e, geometry: t, transform: n, pixelsToTileUnits: r }) {
        return Cd(Id(e, this.paint.get(`fill-translate`), this.paint.get(`fill-translate-anchor`), -n.bearingInRadians, r), t);
    }
    isTileClipped() {
        return !0;
    }
};
const Jp = q([
    {
        name: `a_pos`,
        components: 2,
        type: `Int16`
    },
    {
        name: `a_normal_ed`,
        components: 4,
        type: `Int16`
    }
], 4), Yp = q([
    {
        name: `a_centroid`,
        components: 2,
        type: `Int16`
    }
], 4), Xp = Jp.members;
Jp.size, Jp.alignment;
var Zp = class {
    constructor(e, t, n, r, i){
        for(this.properties = Object.create(null), this.extent = n, this.type = 0, this.id = void 0, this._pbf = e, this._geometry = -1, this._keys = r, this._values = i; e.pos < t;){
            let t = e.readVarint();
            if (t === 8) this.id = e.readVarint();
            else if (t === 18) {
                let t = e.readVarint() + e.pos;
                for(; e.pos < t;){
                    let t = r[e.readVarint()], n = i[e.readVarint()];
                    this.properties[t] = n;
                }
            } else t === 24 ? this.type = e.readVarint() : (t === 34 && (this._geometry = e.pos), e.skip(t));
        }
    }
    loadGeometry() {
        if (this._geometry < 0) throw Error(`feature has no geometry`);
        let e = this._pbf;
        e.pos = this._geometry;
        let t = e.readVarint() + e.pos, n = [], r, i = 1, a = 0, o = 0, s = 0;
        for(; e.pos < t;){
            if (a <= 0) {
                let t = e.readVarint();
                if (i = t & 7, a = t >> 3, a === 0) continue;
            }
            if (a--, i === 1) o += e.readSVarint(), s += e.readSVarint(), r && n.push(r), r = [
                new l(o, s)
            ];
            else if (i === 2) o += e.readSVarint(), s += e.readSVarint(), r && r.push(new l(o, s));
            else if (i === 7) r && r.push(r[0].clone());
            else throw Error(`unknown command ${i}`);
        }
        return r && n.push(r), n;
    }
    bbox() {
        if (this._geometry < 0) throw Error(`feature has no geometry`);
        let e = this._pbf;
        e.pos = this._geometry;
        let t = e.readVarint() + e.pos, n = 1, r = 0, i = 0, a = 0, o = 1 / 0, s = -1 / 0, c = 1 / 0, l = -1 / 0;
        for(; e.pos < t;){
            if (r <= 0) {
                let t = e.readVarint();
                if (n = t & 7, r = t >> 3, r === 0) continue;
            }
            if (r--, n === 1 || n === 2) i += e.readSVarint(), a += e.readSVarint(), i < o && (o = i), i > s && (s = i), a < c && (c = a), a > l && (l = a);
            else if (n !== 7) throw Error(`unknown command ${n}`);
        }
        return [
            o,
            c,
            s,
            l
        ];
    }
    toGeoJSON(e, t, n) {
        let r = this.extent * 2 ** n, i = this.extent * e, a = this.extent * t, o = this.loadGeometry();
        function s(e) {
            return [
                (e.x + i) * 360 / r - 180,
                360 / Math.PI * Math.atan(Math.exp((1 - (e.y + a) * 2 / r) * Math.PI)) - 90
            ];
        }
        function c(e) {
            return e.map(s);
        }
        let l;
        if (this.type === 1) {
            let e = [];
            for (let t of o)e.push(t[0]);
            let t = c(e);
            l = e.length === 1 ? {
                type: `Point`,
                coordinates: t[0]
            } : {
                type: `MultiPoint`,
                coordinates: t
            };
        } else if (this.type === 2) {
            let e = o.map(c);
            l = e.length === 1 ? {
                type: `LineString`,
                coordinates: e[0]
            } : {
                type: `MultiLineString`,
                coordinates: e
            };
        } else if (this.type === 3) {
            let e = Qp(o), t = [];
            for (let n of e)t.push(n.map(c));
            l = t.length === 1 ? {
                type: `Polygon`,
                coordinates: t[0]
            } : {
                type: `MultiPolygon`,
                coordinates: t
            };
        } else throw Error(`unknown feature type`);
        let u = {
            type: `Feature`,
            geometry: l,
            properties: this.properties
        };
        return this.id != null && (u.id = this.id), u;
    }
};
Zp.types = [
    `Unknown`,
    `Point`,
    `LineString`,
    `Polygon`
];
function Qp(e) {
    let t = e.length;
    if (t <= 1) return [
        e
    ];
    let n = [], r, i;
    for(let a = 0; a < t; a++){
        let t = $p(e[a]);
        t !== 0 && (i === void 0 && (i = t < 0), i === t < 0 ? (r && n.push(r), r = [
            e[a]
        ]) : r && r.push(e[a]));
    }
    return r && n.push(r), n;
}
function $p(e) {
    let t = 0;
    for(let n = 0, r = e.length, i = r - 1, a, o; n < r; i = n++)a = e[n], o = e[i], t += (o.x - a.x) * (a.y + o.y);
    return t;
}
var em = class {
    constructor(e, t){
        for(this.version = 1, this.name = ``, this.extent = 4096, this.length = 0, this._pbf = e, this._keys = [], this._values = [], this._features = [], t === void 0 && (t = e.length); e.pos < t;){
            let t = e.readVarint();
            t === 10 ? this.name = e.readString() : t === 18 ? (this._features.push(e.pos), e.skip(t)) : t === 26 ? this._keys.push(e.readString()) : t === 34 ? this._values.push(tm(e)) : t === 40 ? this.extent = e.readVarint() : t === 120 ? this.version = e.readVarint() : e.skip(t);
        }
        this.length = this._features.length;
    }
    feature(e) {
        if (e < 0 || e >= this._features.length) throw Error(`feature index out of bounds`);
        this._pbf.pos = this._features[e];
        let t = this._pbf.readVarint() + this._pbf.pos;
        return new Zp(this._pbf, t, this.extent, this._keys, this._values);
    }
};
function tm(e) {
    let t = null, n = e.readVarint() + e.pos;
    for(; e.pos < n;){
        let n = e.readVarint();
        t = n === 10 ? e.readString() : n === 21 ? e.readFloat() : n === 25 ? e.readDouble() : n === 32 ? e.readVarint(!0) : n === 40 ? e.readVarint() : n === 48 ? e.readSVarint() : n === 56 ? e.readBoolean() : (e.skip(n), null);
    }
    if (t == null) throw Error(`unknown feature value`);
    return t;
}
var nm = class {
    constructor(e, t = e.length){
        let n = Object.create(null);
        for(; e.pos < t;){
            let t = e.readVarint();
            if (t === 26) {
                let t = new em(e, e.readVarint() + e.pos);
                t.length && (n[t.name] = t);
            } else e.skip(t);
        }
        this.layers = n;
    }
};
const rm = 8192;
function im(e, t, n, r, i, a, o, s) {
    e.emplaceBack(t, n, Math.floor(r * rm) * 2 + o, i * rm * 2, a * rm * 2, Math.round(s));
}
var am = class {
    constructor(e){
        this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.id), this.index = e.index, this.hasDependencies = !1, this.layoutVertexArray = new gu, this.centroidVertexArray = new du, this.indexArray = new Ou, this.programConfigurations = new ud(e.layers, e.zoom), this.segments = new Nu, this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id);
    }
    populate(e, t, n) {
        this.features = [], this.hasDependencies = Af(`fill-extrusion`, this.layers, t);
        for (let { feature: r, id: i, index: a, sourceLayerIndex: o } of e){
            let e = this.layers[0]._featureFilter.needGeometry, s = _d(r, e);
            if (!this.layers[0]._featureFilter.filter(new U(this.zoom), s, n)) continue;
            let c = {
                id: i,
                sourceLayerIndex: o,
                index: a,
                geometry: e ? s.geometry : gd(r),
                properties: r.properties,
                type: r.type,
                patterns: {}
            };
            this.hasDependencies ? this.features.push(jf(`fill-extrusion`, this.layers, c, {
                zoom: this.zoom
            }, t)) : this.addFeature(c, c.geometry, a, n, {}, t.subdivisionGranularity), t.featureIndex.insert(r, c.geometry, a, o, this.index, !0);
        }
    }
    addFeatures(e, t, n) {
        for (let r of this.features){
            let { geometry: i } = r;
            this.addFeature(r, i, r.index, t, n, e.subdivisionGranularity);
        }
    }
    update(e, t, n) {
        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e, t, this.stateDependentLayers, {
            imagePositions: n
        });
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0 && this.centroidVertexArray.length === 0;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(e) {
        this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, Xp), this.centroidVertexBuffer = e.createVertexBuffer(this.centroidVertexArray, Yp.members, !0), this.indexBuffer = e.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e), this.uploaded = !0;
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
    }
    addFeature(e, t, n, r, i, a) {
        for (let n of Ma(t, 500)){
            let t = {
                x: 0,
                y: 0,
                sampleCount: 0
            }, i = this.layoutVertexArray.length;
            this.processPolygon(t, r, e, n, a);
            let o = this.layoutVertexArray.length - i, s = Math.floor(t.x / t.sampleCount), c = Math.floor(t.y / t.sampleCount);
            for(let e = 0; e < o; e++)this.centroidVertexArray.emplaceBack(s, c);
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, n, {
            imagePositions: i,
            canonical: r
        });
    }
    processPolygon(e, t, n, r, i) {
        if (r.length < 1 || cm(r[0])) return;
        for (let t of r)t.length !== 0 && om(e, t);
        let a = {
            segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
        }, o = i.fill.getGranularityForZoomLevel(t.z), s = Zp.types[n.type] === `Polygon`;
        for (let e of r){
            if (e.length === 0 || cm(e)) continue;
            let t = Mp(e, o, s);
            this._generateSideFaces(t, a);
        }
        if (!s) return;
        let c = jp(r, t, o, !1), l = this.layoutVertexArray;
        Ip((e, t)=>{
            im(l, e, t, 0, 0, 1, 1, 0);
        }, this.segments, this.layoutVertexArray, this.indexArray, c.verticesFlattened, c.indicesTriangles);
    }
    _generateSideFaces(e, t) {
        let n = 0;
        for(let r = 1; r < e.length; r++){
            let i = e[r], a = e[r - 1];
            if (sm(i, a)) continue;
            t.segment.vertexLength + 4 > Nu.MAX_VERTEX_ARRAY_LENGTH && (t.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
            let o = i.sub(a)._perp()._unit(), s = a.dist(i);
            n + s > 32768 && (n = 0), im(this.layoutVertexArray, i.x, i.y, o.x, o.y, 0, 0, n), im(this.layoutVertexArray, i.x, i.y, o.x, o.y, 0, 1, n), n += s, im(this.layoutVertexArray, a.x, a.y, o.x, o.y, 0, 0, n), im(this.layoutVertexArray, a.x, a.y, o.x, o.y, 0, 1, n);
            let c = t.segment.vertexLength;
            this.indexArray.emplaceBack(c, c + 2, c + 1), this.indexArray.emplaceBack(c + 1, c + 2, c + 3), t.segment.vertexLength += 4, t.segment.primitiveLength += 2;
        }
    }
};
function om(e, t) {
    for(let n = 0; n < t.length; n++){
        let r = t[n];
        (n !== t.length - 1 || t[0].x !== r.x || t[0].y !== r.y) && (e.x += r.x, e.y += r.y, e.sampleCount++);
    }
}
H(`FillExtrusionBucket`, am, {
    omit: [
        `layers`,
        `features`
    ]
});
function sm(e, t) {
    return e.x === t.x && (e.x < 0 || e.x > 8192) || e.y === t.y && (e.y < 0 || e.y > 8192);
}
function cm(e) {
    return e.every((e)=>e.x < 0) || e.every((e)=>e.x > 8192) || e.every((e)=>e.y < 0) || e.every((e)=>e.y > 8192);
}
let lm;
const um = ()=>lm ||= new gl({
        "fill-extrusion-opacity": new W(j[`paint_fill-extrusion`][`fill-extrusion-opacity`], `fill-extrusion-opacity`),
        "fill-extrusion-color": new G(j[`paint_fill-extrusion`][`fill-extrusion-color`], `fill-extrusion-color`),
        "fill-extrusion-translate": new W(j[`paint_fill-extrusion`][`fill-extrusion-translate`], `fill-extrusion-translate`),
        "fill-extrusion-translate-anchor": new W(j[`paint_fill-extrusion`][`fill-extrusion-translate-anchor`], `fill-extrusion-translate-anchor`),
        "fill-extrusion-pattern": new pl(j[`paint_fill-extrusion`][`fill-extrusion-pattern`], `fill-extrusion-pattern`),
        "fill-extrusion-height": new G(j[`paint_fill-extrusion`][`fill-extrusion-height`], `fill-extrusion-height`),
        "fill-extrusion-base": new G(j[`paint_fill-extrusion`][`fill-extrusion-base`], `fill-extrusion-base`),
        "fill-extrusion-vertical-gradient": new W(j[`paint_fill-extrusion`][`fill-extrusion-vertical-gradient`], `fill-extrusion-vertical-gradient`)
    });
var dm = {
    get paint () {
        return um();
    }
};
const fm = (e)=>e.type === `fill-extrusion`;
var pm = class extends yl {
    constructor(e, t){
        super(e, dm, t);
    }
    createBucket(e) {
        return new am(e);
    }
    queryRadius() {
        return Fd(this.paint.get(`fill-extrusion-translate`));
    }
    is3D() {
        return !0;
    }
    queryIntersectsFeature({ queryGeometry: e, feature: t, featureState: n, geometry: r, transform: i, pixelsToTileUnits: a, pixelPosMatrix: o }) {
        let s = Id(e, this.paint.get(`fill-extrusion-translate`), this.paint.get(`fill-extrusion-translate-anchor`), -i.bearingInRadians, a), c = this.paint.get(`fill-extrusion-height`).evaluate(t, n), l = this.paint.get(`fill-extrusion-base`).evaluate(t, n), u = vm(s, o, 0), d = _m(r, l, c, o), f = d[0], p = d[1];
        return gm(f, p, u);
    }
};
function mm(e, t) {
    return e.x * t.x + e.y * t.y;
}
function hm(e, t) {
    if (e.length === 1) {
        let n = 0, r = t[n++], i;
        for(; !i || r.equals(i);)if (i = t[n++], !i) return 1 / 0;
        for(; n < t.length; n++){
            let a = t[n], o = e[0], s = i.sub(r), c = a.sub(r), l = o.sub(r), u = mm(s, s), d = mm(s, c), f = mm(c, c), p = mm(l, s), m = mm(l, c), h = u * f - d * d, g = (f * p - d * m) / h, _ = (u * m - d * p) / h, v = 1 - g - _, y = r.z * v + i.z * g + a.z * _;
            if (isFinite(y)) return y;
        }
        return 1 / 0;
    } else {
        let e = 1 / 0;
        for (let n of t)e = Math.min(e, n.z);
        return e;
    }
}
function gm(e, t, n) {
    let r = 1 / 0;
    Cd(n, t) && (r = hm(n, t[0]));
    for(let i = 0; i < t.length; i++){
        let a = t[i], o = e[i];
        for(let e = 0; e < a.length - 1; e++){
            let t = a[e], i = a[e + 1], s = o[e], c = [
                t,
                i,
                o[e + 1],
                s,
                t
            ];
            xd(n, c) && (r = Math.min(r, hm(n, c)));
        }
    }
    return r !== 1 / 0 && r;
}
function _m(e, t, n, r) {
    let i = [], a = [], o = r[8] * t, s = r[9] * t, c = r[10] * t, u = r[11] * t, d = r[8] * n, f = r[9] * n, p = r[10] * n, m = r[11] * n;
    for (let t of e){
        let e = [], n = [];
        for (let i of t){
            let t = i.x, a = i.y, h = r[0] * t + r[4] * a + r[12], g = r[1] * t + r[5] * a + r[13], _ = r[2] * t + r[6] * a + r[14], v = r[3] * t + r[7] * a + r[15], y = h + o, b = g + s, x = _ + c, S = v + u, C = h + d, w = g + f, T = _ + p, E = v + m, D = new l(y / S, b / S);
            D.z = x / S, e.push(D);
            let O = new l(C / E, w / E);
            O.z = T / E, n.push(O);
        }
        i.push(e), a.push(n);
    }
    return [
        i,
        a
    ];
}
function vm(e, t, n) {
    let r = [];
    for (let i of e){
        let e = [
            i.x,
            i.y,
            n,
            1
        ];
        Me(e, e, t), r.push(new l(e[0] / e[3], e[1] / e[3]));
    }
    return r;
}
function ym(e, t, n, r) {
    let i = r, a = t + (n - t >> 1), o = n - t, s, c = e[t], l = e[t + 1], u = e[n], d = e[n + 1];
    for(let r = t + 3; r < n; r += 3){
        let t = bm(e[r], e[r + 1], c, l, u, d);
        if (t > i) {
            s = r, i = t;
            continue;
        }
        if (t === i) {
            let e = Math.abs(r - a);
            e < o && (s = r, o = e);
        }
    }
    i > r && (s - t > 3 && ym(e, t, s, r), e[s + 2] = i, n - s > 3 && ym(e, s, n, r));
}
function bm(e, t, n, r, i, a) {
    let o = i - n, s = a - r;
    if (o !== 0 || s !== 0) {
        let c = ((e - n) * o + (t - r) * s) / (o * o + s * s);
        c > 1 ? (n = i, r = a) : c > 0 && (n += o * c, r += s * c);
    }
    return o = e - n, s = t - r, o * o + s * s;
}
function xm(e, t, n, r) {
    let i = {
        type: t,
        geom: n
    }, a = {
        id: e ?? null,
        type: i.type,
        geometry: i.geom,
        tags: r,
        minX: 1 / 0,
        minY: 1 / 0,
        maxX: -1 / 0,
        maxY: -1 / 0
    };
    switch(i.type){
        case `Point`:
        case `MultiPoint`:
            Cm(a, i.geom);
            break;
        case `LineString`:
            Cm(a, i.geom.points);
            break;
        case `Polygon`:
            Cm(a, i.geom[0].points);
            break;
        case `MultiLineString`:
            for (let e of i.geom)Cm(a, e.points);
            break;
        case `MultiPolygon`:
            for (let e of i.geom)Cm(a, e[0].points);
            break;
    }
    return a;
}
function Sm(e) {
    let t = e;
    e.points.length > 64 && (t.points = new Float64Array(e.points));
}
function Cm(e, t) {
    for(let n = 0; n < t.length; n += 3)e.minX = Math.min(e.minX, t[n]), e.minY = Math.min(e.minY, t[n + 1]), e.maxX = Math.max(e.maxX, t[n]), e.maxY = Math.max(e.maxY, t[n + 1]);
}
function wm(e, t) {
    let n = [];
    switch(e.type){
        case `FeatureCollection`:
            for(let r = 0; r < e.features.length; r++)Tm(n, e.features[r], t, r);
            break;
        case `Feature`:
            Tm(n, e, t);
            break;
        default:
            Tm(n, {
                type: `Feature`,
                geometry: e,
                properties: void 0
            }, t);
    }
    return n;
}
function Tm(e, t, n, r, i = 0) {
    if (!t.geometry) return;
    if (i > 1024) throw Error(`GeometryCollection nesting exceeds supported depth: 1024`);
    if (t.geometry.type === `GeometryCollection`) {
        Dm(e, t, t.geometry, n, r, i + 1);
        return;
    }
    if (!t.geometry.coordinates?.length) return;
    let a = Em(t, n, r), o = (n.tolerance / ((1 << n.maxZoom) * n.extent)) ** 2;
    switch(t.geometry.type){
        case `Point`:
            Om(e, a, t.geometry, t.properties);
            return;
        case `MultiPoint`:
            km(e, a, t.geometry, t.properties);
            return;
        case `LineString`:
            Am(e, a, t.geometry, o, t.properties);
            return;
        case `MultiLineString`:
            jm(e, a, t.geometry, o, n, t.properties);
            return;
        case `Polygon`:
            Mm(e, a, t.geometry, o, t.properties);
            return;
        case `MultiPolygon`:
            Nm(e, a, t.geometry, o, t.properties);
            return;
        default:
            throw Error(`Input data is not a valid GeoJSON object.`);
    }
}
function Em(e, t, n) {
    return t.promoteId ? e.properties?.[t.promoteId] : t.generateId ? n || 0 : e.id;
}
function Dm(e, t, n, r, i, a = 0) {
    for (let o of n.geometries)Tm(e, {
        id: t.id,
        type: `Feature`,
        geometry: o,
        properties: t.properties
    }, r, i, a);
}
function Om(e, t, n, r) {
    let i = [];
    i.push(Im(n.coordinates[0]), Lm(n.coordinates[1]), 0), e.push(xm(t, `Point`, i, r));
}
function km(e, t, n, r) {
    let i = [];
    for (let e of n.coordinates)i.push(Im(e[0]), Lm(e[1]), 0);
    e.push(xm(t, `MultiPoint`, i, r));
}
function Am(e, t, n, r, i) {
    let a = {
        points: []
    };
    Pm(n.coordinates, a, r, !1), e.push(xm(t, `LineString`, a, i));
}
function jm(e, t, n, r, i, a) {
    if (i.lineMetrics) for (let i of n.coordinates){
        let n = {
            points: []
        };
        Pm(i, n, r, !1), e.push(xm(t, `LineString`, n, a));
    }
    else {
        let i = [];
        Fm(n.coordinates, i, r, !1), e.push(xm(t, `MultiLineString`, i, a));
    }
}
function Mm(e, t, n, r, i) {
    let a = [];
    Fm(n.coordinates, a, r, !0), e.push(xm(t, `Polygon`, a, i));
}
function Nm(e, t, n, r, i) {
    let a = [];
    for (let e of n.coordinates){
        let t = [];
        Fm(e, t, r, !0), a.push(t);
    }
    e.push(xm(t, `MultiPolygon`, a, i));
}
function Pm(e, t, n, r) {
    let i, a, o = 0;
    for(let n = 0; n < e.length; n++){
        let s = Im(e[n][0]), c = Lm(e[n][1]);
        t.points.push(s, c, 0), n > 0 && (r ? o += (i * c - s * a) / 2 : o += Math.sqrt((s - i) ** 2 + (c - a) ** 2)), i = s, a = c;
    }
    let s = t.points.length - 3;
    t.points[2] = 1, n > 0 && ym(t.points, 0, s, n), t.points[s + 2] = 1, Sm(t), t.size = Math.abs(o), t.start = 0, t.end = t.size;
}
function Fm(e, t, n, r) {
    for(let i = 0; i < e.length; i++){
        let a = {
            points: []
        };
        Pm(e[i], a, n, r), t.push(a);
    }
}
function Im(e) {
    return e / 360 + .5;
}
function Lm(e) {
    let t = Math.sin(e * Math.PI / 180), n = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
    return n < 0 ? 0 : n > 1 ? 1 : n;
}
function Rm(e) {
    return {
        type: `FeatureCollection`,
        features: e.map((e)=>zm(e))
    };
}
function zm(e) {
    let t = {
        type: `Feature`,
        geometry: Bm(e),
        properties: e.tags
    };
    return e.id != null && (t.id = e.id), t;
}
function Bm(e) {
    let { type: t, geometry: n } = e;
    switch(t){
        case `Point`:
            return {
                type: t,
                coordinates: Hm(n[0], n[1])
            };
        case `MultiPoint`:
            return {
                type: t,
                coordinates: Vm(n)
            };
        case `LineString`:
            return {
                type: t,
                coordinates: Vm(n.points)
            };
        case `MultiLineString`:
        case `Polygon`:
            return {
                type: t,
                coordinates: n.map((e)=>Vm(e.points))
            };
        case `MultiPolygon`:
            return {
                type: t,
                coordinates: n.map((e)=>e.map((e)=>Vm(e.points)))
            };
    }
}
function Vm(e) {
    let t = [];
    for(let n = 0; n < e.length; n += 3)t.push(Hm(e[n], e[n + 1]));
    return t;
}
function Hm(e, t) {
    return [
        Um(e),
        Wm(t)
    ];
}
function Um(e) {
    return (e - .5) * 360;
}
function Wm(e) {
    let t = (180 - e * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
}
function Gm(e, t, n, r, i, a, o, s) {
    if (n /= t, r /= t, a >= n && o < r) return e;
    if (o < n || a >= r) return null;
    let c = [];
    for (let t of e){
        let e = i === 0 ? t.minX : t.minY, a = i === 0 ? t.maxX : t.maxY;
        if (e >= n && a < r) {
            c.push(t);
            continue;
        }
        if (!(a < n || e >= r)) switch(t.type){
            case `Point`:
            case `MultiPoint`:
                Km(t, c, n, r, i);
                continue;
            case `LineString`:
                qm(t, c, n, r, i, s);
                continue;
            case `MultiLineString`:
                Jm(t, c, n, r, i);
                continue;
            case `Polygon`:
                Ym(t, c, n, r, i);
                continue;
            case `MultiPolygon`:
                Xm(t, c, n, r, i);
                continue;
        }
    }
    return c.length ? c : null;
}
function Km(e, t, n, r, i) {
    let a = [];
    if (Zm(e.geometry, a, n, r, i), !a.length) return;
    let o = a.length === 3 ? `Point` : `MultiPoint`;
    t.push(xm(e.id, o, a, e.tags));
}
function qm(e, t, n, r, i, a) {
    let o = [];
    if (Qm(e.geometry, o, n, r, i, !1, a.lineMetrics), o.length) {
        if (a.lineMetrics) {
            for (let n of o)t.push(xm(e.id, `LineString`, n, e.tags));
            return;
        }
        if (o.length > 1) {
            t.push(xm(e.id, `MultiLineString`, o, e.tags));
            return;
        }
        t.push(xm(e.id, `LineString`, o[0], e.tags));
    }
}
function Jm(e, t, n, r, i) {
    let a = [];
    if (eh(e.geometry, a, n, r, i, !1), a.length) {
        if (a.length === 1) {
            t.push(xm(e.id, `LineString`, a[0], e.tags));
            return;
        }
        t.push(xm(e.id, `MultiLineString`, a, e.tags));
    }
}
function Ym(e, t, n, r, i) {
    let a = [];
    eh(e.geometry, a, n, r, i, !0), a.length && t.push(xm(e.id, `Polygon`, a, e.tags));
}
function Xm(e, t, n, r, i) {
    let a = [];
    for (let t of e.geometry){
        let e = [];
        eh(t, e, n, r, i, !0), e.length && a.push(e);
    }
    a.length && t.push(xm(e.id, `MultiPolygon`, a, e.tags));
}
function Zm(e, t, n, r, i) {
    for(let a = 0; a < e.length; a += 3){
        let o = e[a + i];
        o >= n && o <= r && th(t, e[a], e[a + 1], e[a + 2]);
    }
}
function Qm(e, t, n, r, i, a, o) {
    let s = $m(e), c = i === 0 ? nh : rh, l = e.start, u, d;
    for(let f = 0; f < e.points.length - 3; f += 3){
        let p = e.points[f], m = e.points[f + 1], h = e.points[f + 2], g = e.points[f + 3], _ = e.points[f + 4], v = i === 0 ? p : m, y = i === 0 ? g : _, b = !1;
        o && (u = Math.sqrt((p - g) ** 2 + (m - _) ** 2)), v < n ? y > n && (d = c(s, p, m, g, _, n), o && (s.start = l + u * d)) : v > r ? y < r && (d = c(s, p, m, g, _, r), o && (s.start = l + u * d)) : th(s.points, p, m, h), y < n && v >= n && (d = c(s, p, m, g, _, n), b = !0), y > r && v <= r && (d = c(s, p, m, g, _, r), b = !0), !a && b && (o && (s.end = l + u * d), t.push(s), s = $m(e)), o && (l += u);
    }
    let f = e.points.length - 3, p = e.points[f], m = e.points[f + 1], h = e.points[f + 2], g = i === 0 ? p : m;
    g >= n && g <= r && th(s.points, p, m, h), f = s.points.length - 3, a && f >= 3 && (s.points[f] !== s.points[0] || s.points[f + 1] !== s.points[1]) && th(s.points, s.points[0], s.points[1], s.points[2]), s.points.length && (Sm(s), t.push(s));
}
function $m(e) {
    return {
        points: [],
        size: e.size,
        start: e.start,
        end: e.end
    };
}
function eh(e, t, n, r, i, a) {
    for (let o of e)Qm(o, t, n, r, i, a, !1);
}
function th(e, t, n, r) {
    e.push(t, n, r);
}
function nh(e, t, n, r, i, a) {
    let o = (a - t) / (r - t);
    return th(e.points, a, n + (i - n) * o, 1), o;
}
function rh(e, t, n, r, i, a) {
    let o = (a - n) / (i - n);
    return th(e.points, t + (r - t) * o, a, 1), o;
}
function ih(e, t) {
    let n = t.buffer / t.extent, r = e, i = Gm(e, 1, -1 - n, n, 0, -1, 2, t), a = Gm(e, 1, 1 - n, 2 + n, 0, -1, 2, t);
    return !i && !a ? r : (r = Gm(e, 1, -n, 1 + n, 0, -1, 2, t) || [], i && (r = ah(i, 1).concat(r)), a && (r = r.concat(ah(a, -1))), r);
}
function ah(e, t) {
    let n = [];
    for (let r of e)switch(r.type){
        case `Point`:
        case `MultiPoint`:
            {
                let e = oh(r.geometry, t);
                n.push(xm(r.id, r.type, e, r.tags));
                continue;
            }
        case `LineString`:
            {
                let e = sh(r.geometry, t);
                n.push(xm(r.id, r.type, e, r.tags));
                continue;
            }
        case `MultiLineString`:
        case `Polygon`:
            {
                let e = [];
                for (let n of r.geometry)e.push(sh(n, t));
                n.push(xm(r.id, r.type, e, r.tags));
                continue;
            }
        case `MultiPolygon`:
            {
                let e = [];
                for (let n of r.geometry){
                    let r = [];
                    for (let e of n)r.push(sh(e, t));
                    e.push(r);
                }
                n.push(xm(r.id, r.type, e, r.tags));
                continue;
            }
    }
    return n;
}
function oh(e, t) {
    let n = [];
    for(let r = 0; r < e.length; r += 3)n.push(e[r] + t, e[r + 1], e[r + 2]);
    return n;
}
function sh(e, t) {
    let n = {
        points: [],
        size: e.size
    };
    e.start !== void 0 && (n.start = e.start, n.end = e.end);
    for(let r = 0; r < e.points.length; r += 3)n.points.push(e.points[r] + t, e.points[r + 1], e.points[r + 2]);
    return Sm(n), n;
}
function ch(e, t, n) {
    let r = dh(t, n), i = [];
    if (r.removeAll && (i = e, e = []), r.remove.size || r.add.size) {
        let t = [];
        for (let n of e)(r.remove.has(n.id) || r.add.has(n.id)) && t.push(n);
        if (t.length) {
            i = i.concat(t);
            let n = new Set(t.map((e)=>e.id));
            e = e.filter((e)=>!n.has(e.id));
        }
        if (r.add.size) {
            let t = wm({
                type: `FeatureCollection`,
                features: Array.from(r.add.values())
            }, n);
            t = ih(t, n), i = i.concat(t), e = e.concat(t);
        }
    }
    if (r.update.size) {
        let t = new Map, a = [];
        for (let n of e)r.update.has(n.id) ? t.set(n.id, [
            ...t.get(n.id) || [],
            n
        ]) : a.push(n);
        for (let [e, o] of r.update){
            let r = t.get(e);
            if (!r || r.length === 0) continue;
            let s = lh(r, o, n);
            i = i.concat(r, s), a = a.concat(s);
        }
        e = a;
    }
    return {
        affected: i,
        source: e
    };
}
function lh(e, t, n) {
    let r = !!t.newGeometry, i = t.removeAllProperties || t.removeProperties?.length > 0 || t.addOrUpdateProperties?.length > 0;
    if (r) {
        let r = e[0], a = wm({
            type: `FeatureCollection`,
            features: [
                {
                    type: `Feature`,
                    id: r.id,
                    geometry: t.newGeometry,
                    properties: i ? uh(r.tags, t) : r.tags
                }
            ]
        }, n);
        return a = ih(a, n), a;
    }
    if (i) {
        let n = [];
        for (let r of e){
            let e = {
                ...r
            };
            e.tags = uh(e.tags, t), n.push(e);
        }
        return n;
    }
    return e;
}
function uh(e, t) {
    if (t.removeAllProperties) return {};
    let n = {
        ...e || {}
    };
    if (t.removeProperties) for (let e of t.removeProperties)delete n[e];
    if (t.addOrUpdateProperties) for (let { key: e, value: r } of t.addOrUpdateProperties)n[e] = r;
    return n;
}
function dh(e, t) {
    return e ? {
        removeAll: e.removeAll,
        remove: new Set(e.remove || []),
        add: new Map(e.add?.map((e)=>[
                t.promoteId ? e.properties[t.promoteId] : e.id,
                e
            ])),
        update: new Map(e.update?.map((e)=>[
                e.id,
                e
            ]))
    } : {
        remove: new Set,
        add: new Map,
        update: new Map
    };
}
const fh = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
], Y = new Uint32Array(96);
var ph = class e {
    static from(t) {
        if (!t || t.byteLength === void 0 || t.buffer) throw Error(`Data must be an instance of ArrayBuffer or SharedArrayBuffer.`);
        let [n, r] = new Uint8Array(t, 0, 2);
        if (n !== 219) throw Error(`Data does not appear to be in a KDBush format.`);
        let i = r >> 4;
        if (i !== 1) throw Error(`Got v${i} data when expected v1.`);
        let a = fh[r & 15];
        if (!a) throw Error(`Unrecognized array type.`);
        let [o] = new Uint16Array(t, 2, 1), [s] = new Uint32Array(t, 4, 1);
        return new e(s, o, a, void 0, t);
    }
    constructor(e, t = 64, n = Float64Array, r = ArrayBuffer, i){
        if (isNaN(e) || e < 0) throw Error(`Unexpected numItems value: ${e}.`);
        this.numItems = +e, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = n, this.IndexArrayType = e < 65536 ? Uint16Array : Uint32Array;
        let a = fh.indexOf(this.ArrayType), o = e * 2 * this.ArrayType.BYTES_PER_ELEMENT, s = e * this.IndexArrayType.BYTES_PER_ELEMENT, c = (8 - s % 8) % 8;
        if (a < 0) throw Error(`Unexpected typed array class: ${n}.`);
        if (i) this.data = i, this.ids = new this.IndexArrayType(i, 8, e), this.coords = new n(i, 8 + s + c, e * 2), this._pos = e * 2, this._finished = !0;
        else {
            let i = this.data = new r(8 + o + s + c);
            this.ids = new this.IndexArrayType(i, 8, e), this.coords = new n(i, 8 + s + c, e * 2), this._pos = 0, this._finished = !1, new Uint8Array(i, 0, 2).set([
                219,
                16 + a
            ]), new Uint16Array(i, 2, 1)[0] = t, new Uint32Array(i, 4, 1)[0] = e;
        }
    }
    add(e, t) {
        let n = this._pos >> 1;
        return this.ids[n] = n, this.coords[this._pos++] = e, this.coords[this._pos++] = t, n;
    }
    finish() {
        let e = this._pos >> 1;
        if (e !== this.numItems) throw Error(`Added ${e} items when expected ${this.numItems}.`);
        return mh(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
    }
    range(e, t, n, r) {
        if (!this._finished) throw Error(`Data not yet indexed - call index.finish().`);
        let { ids: i, coords: a, nodeSize: o } = this;
        Y[0] = 0, Y[1] = i.length - 1, Y[2] = 0;
        let s = 3, c = [];
        for(; s > 0;){
            let l = Y[--s], u = Y[--s], d = Y[--s];
            if (u - d <= o) {
                for(let o = d; o <= u; o++){
                    let s = a[2 * o], l = a[2 * o + 1];
                    s >= e && s <= n && l >= t && l <= r && c.push(i[o]);
                }
                continue;
            }
            let f = d + u >> 1, p = a[2 * f], m = a[2 * f + 1];
            p >= e && p <= n && m >= t && m <= r && c.push(i[f]), (l === 0 ? e <= p : t <= m) && (Y[s++] = d, Y[s++] = f - 1, Y[s++] = 1 - l), (l === 0 ? n >= p : r >= m) && (Y[s++] = f + 1, Y[s++] = u, Y[s++] = 1 - l);
        }
        return c;
    }
    within(e, t, n) {
        let r = [];
        return this.withinInto(e, t, n, r), r;
    }
    withinInto(e, t, n, r) {
        if (!this._finished) throw Error(`Data not yet indexed - call index.finish().`);
        let { ids: i, coords: a, nodeSize: o } = this;
        Y[0] = 0, Y[1] = i.length - 1, Y[2] = 0;
        let s = 3, c = 0, l = n * n;
        for(; s > 0;){
            let u = Y[--s], d = Y[--s], f = Y[--s];
            if (d - f <= o) {
                for(let n = f; n <= d; n++)vh(a[2 * n], a[2 * n + 1], e, t) <= l && (r[c++] = i[n]);
                continue;
            }
            let p = f + d >> 1, m = a[2 * p], h = a[2 * p + 1];
            vh(m, h, e, t) <= l && (r[c++] = i[p]), (u === 0 ? e - n <= m : t - n <= h) && (Y[s++] = f, Y[s++] = p - 1, Y[s++] = 1 - u), (u === 0 ? e + n >= m : t + n >= h) && (Y[s++] = p + 1, Y[s++] = d, Y[s++] = 1 - u);
        }
        return c;
    }
};
function mh(e, t, n, r, i, a) {
    if (i - r <= n) return;
    let o = r + i >> 1;
    hh(e, t, o, r, i, a), mh(e, t, n, r, o - 1, 1 - a), mh(e, t, n, o + 1, i, 1 - a);
}
function hh(e, t, n, r, i, a) {
    for(; i > r;){
        if (i - r > 600) {
            let o = i - r + 1, s = n - r + 1, c = Math.log(o), l = .5 * Math.exp(2 * c / 3), u = .5 * Math.sqrt(c * l * (o - l) / o) * (s - o / 2 < 0 ? -1 : 1);
            hh(e, t, n, Math.max(r, Math.floor(n - s * l / o + u)), Math.min(i, Math.floor(n + (o - s) * l / o + u)), a);
        }
        let o = t[2 * n + a], s = r, c = i;
        for(gh(e, t, r, n), t[2 * i + a] > o && gh(e, t, r, i); s < c;){
            for(gh(e, t, s, c), s++, c--; t[2 * s + a] < o;)s++;
            for(; t[2 * c + a] > o;)c--;
        }
        t[2 * r + a] === o ? gh(e, t, r, c) : (c++, gh(e, t, c, i)), c <= n && (r = c + 1), n <= c && (i = c - 1);
    }
}
function gh(e, t, n, r) {
    _h(e, n, r), _h(t, 2 * n, 2 * r), _h(t, 2 * n + 1, 2 * r + 1);
}
function _h(e, t, n) {
    let r = e[t];
    e[t] = e[n], e[n] = r;
}
function vh(e, t, n, r) {
    let i = e - n, a = t - r;
    return i * i + a * a;
}
const yh = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: !1,
    generateId: !1,
    reduce: null,
    map: (e)=>e
};
var bh = class {
    constructor(e){
        this.options = Object.assign(Object.create(yh), e), this.trees = Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [], this.points = [];
    }
    load(e) {
        let t = [];
        for (let n of e){
            if (!n.geometry) continue;
            let [e, r] = n.geometry.coordinates, [i, a] = [
                Im(e),
                Lm(r)
            ], o = {
                id: n.id,
                type: `Point`,
                geometry: [
                    i,
                    a
                ],
                tags: n.properties
            };
            t.push(o);
        }
        this.createIndex(t);
    }
    initialize(e) {
        let t = [];
        for (let n of e)n.type === `Point` && t.push(n);
        this.createIndex(t);
    }
    updateIndex(e, t, n) {
        this.options = Object.assign(Object.create(yh), n.clusterOptions), this.initialize(e);
    }
    createIndex(e) {
        let { log: t, minZoom: n, maxZoom: r } = this.options;
        t && console.time(`total time`);
        let i = `prepare ${e.length} points`;
        t && console.time(i), this.points = e;
        let a = [];
        for(let t = 0; t < e.length; t++){
            let n = e[t];
            if (!n?.geometry) continue;
            let [r, i] = n.geometry;
            r = Math.fround(r), i = Math.fround(i), a.push(r, i, 1 / 0, t, -1, 1), this.options.reduce && a.push(0);
        }
        let o = this.trees[r + 1] = this.createTree(a);
        t && console.timeEnd(i);
        for(let e = r; e >= n; e--){
            let n = Date.now();
            o = this.trees[e] = this.createTree(this.cluster(o, e)), t && console.log(`z%d: %d clusters in %dms`, e, o.numItems, Date.now() - n);
        }
        t && console.timeEnd(`total time`);
    }
    getClusters(e, t) {
        return this.getClustersInternal(e, t).map((e)=>zm(e));
    }
    getClustersInternal(e, t) {
        let n = ((e[0] + 180) % 360 + 360) % 360 - 180, r = Math.max(-90, Math.min(90, e[1])), i = e[2] === 180 ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180, a = Math.max(-90, Math.min(90, e[3]));
        if (e[2] - e[0] >= 360) n = -180, i = 180;
        else if (n > i) {
            let e = this.getClustersInternal([
                n,
                r,
                180,
                a
            ], t), o = this.getClustersInternal([
                -180,
                r,
                i,
                a
            ], t);
            return e.concat(o);
        }
        let o = this.trees[this.limitZoom(t)], s = o.range(Im(n), Lm(a), Im(i), Lm(r)), c = o.flatData, l = [];
        for (let e of s){
            let t = this.stride * e;
            l.push(c[t + 5] > 1 ? xh(c, t, this.clusterProps) : this.points[c[t + 3]]);
        }
        return l;
    }
    getChildren(e) {
        let t = this.getOriginId(e), n = this.getOriginZoom(e), r = Error(`No cluster with the specified id: ` + e), i = this.trees[n];
        if (!i) throw r;
        let a = i.flatData;
        if (t * this.stride >= a.length) throw r;
        let o = this.options.radius / (this.options.extent * 2 ** (n - 1)), s = a[t * this.stride], c = a[t * this.stride + 1], l = i.within(s, c, o), u = [];
        for (let t of l){
            let n = t * this.stride;
            a[n + 4] === e && u.push(a[n + 5] > 1 ? Sh(a, n, this.clusterProps) : zm(this.points[a[n + 3]]));
        }
        if (u.length === 0) throw r;
        return u;
    }
    getLeaves(e, t, n) {
        t ||= 10, n ||= 0;
        let r = [];
        return this.appendLeaves(r, e, t, n, 0), r;
    }
    getTile(e, t, n) {
        let r = this.trees[this.limitZoom(e)];
        if (!r) return null;
        let i = 2 ** e, { extent: a, radius: o } = this.options, s = o / a, c = (n - s) / i, l = (n + 1 + s) / i, u = {
            transformed: !0,
            features: [],
            source: null,
            x: t,
            y: n,
            z: e
        };
        return this.addTileFeatures(r.range((t - s) / i, c, (t + 1 + s) / i, l), r.flatData, t, n, i, u), t === 0 && this.addTileFeatures(r.range(1 - s / i, c, 1, l), r.flatData, i, n, i, u), t === i - 1 && this.addTileFeatures(r.range(0, c, s / i, l), r.flatData, -1, n, i, u), u;
    }
    getClusterExpansionZoom(e) {
        return this.getOriginZoom(e);
    }
    appendLeaves(e, t, n, r, i) {
        let a = this.getChildren(t);
        for (let t of a){
            let a = t.properties;
            if (a?.cluster ? i + a.point_count <= r ? i += a.point_count : i = this.appendLeaves(e, a.cluster_id, n, r, i) : i < r ? i++ : e.push(t), e.length === n) break;
        }
        return i;
    }
    createTree(e) {
        let t = new ph(e.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let n = 0; n < e.length; n += this.stride)t.add(e[n], e[n + 1]);
        return t.finish(), t.flatData = e, t.data = null, t;
    }
    addTileFeatures(e, t, n, r, i, a) {
        for (let o of e){
            let e = o * this.stride, s = t[e + 5] > 1, c, l, u;
            if (s) c = Ch(t, e, this.clusterProps), l = t[e], u = t[e + 1];
            else {
                let n = this.points[t[e + 3]];
                c = n.tags, [l, u] = n.geometry;
            }
            let d = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (l * i - n)),
                        Math.round(this.options.extent * (u * i - r))
                    ]
                ],
                tags: c
            }, f;
            f = s || this.options.generateId ? t[e + 3] : this.points[t[e + 3]].id, f !== void 0 && (d.id = f), a.features.push(d);
        }
    }
    limitZoom(e) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
    }
    cluster(e, t) {
        let { radius: n, extent: r, reduce: i, minPoints: a } = this.options, o = n / (r * 2 ** t), s = e.flatData, c = [], l = this.stride;
        for(let n = 0; n < s.length; n += l){
            if (s[n + 2] <= t) continue;
            s[n + 2] = t;
            let r = s[n], u = s[n + 1], d = e.within(s[n], s[n + 1], o), f = s[n + 5], p = f;
            for (let e of d){
                let n = e * l;
                s[n + 2] > t && (p += s[n + 5]);
            }
            if (p > f && p >= a) {
                let e = r * f, a = u * f, o, m = -1, h = ((n / l | 0) << 5) + (t + 1) + this.points.length;
                for (let r of d){
                    let c = r * l;
                    if (s[c + 2] <= t) continue;
                    s[c + 2] = t;
                    let u = s[c + 5];
                    e += s[c] * u, a += s[c + 1] * u, s[c + 4] = h, i && (o || (o = this.map(s, n, !0), m = this.clusterProps.length, this.clusterProps.push(o)), i(o, this.map(s, c)));
                }
                s[n + 4] = h, c.push(e / p, a / p, 1 / 0, h, -1, p), i && c.push(m);
            } else {
                for(let e = 0; e < l; e++)c.push(s[n + e]);
                if (p > 1) for (let e of d){
                    let n = e * l;
                    if (!(s[n + 2] <= t)) {
                        s[n + 2] = t;
                        for(let e = 0; e < l; e++)c.push(s[n + e]);
                    }
                }
            }
        }
        return c;
    }
    getOriginId(e) {
        return e - this.points.length >> 5;
    }
    getOriginZoom(e) {
        return (e - this.points.length) % 32;
    }
    map(e, t, n) {
        if (e[t + 5] > 1) {
            let r = this.clusterProps[e[t + 6]];
            return n ? Object.assign({}, r) : r;
        }
        let r = this.points[e[t + 3]].tags, i = this.options.map(r);
        return n && i === r ? Object.assign({}, i) : i;
    }
};
function xh(e, t, n) {
    return {
        id: e[t + 3],
        type: `Point`,
        tags: Ch(e, t, n),
        geometry: [
            e[t],
            e[t + 1]
        ]
    };
}
function Sh(e, t, n) {
    return {
        type: `Feature`,
        id: e[t + 3],
        properties: Ch(e, t, n),
        geometry: {
            type: `Point`,
            coordinates: [
                Um(e[t]),
                Wm(e[t + 1])
            ]
        }
    };
}
function Ch(e, t, n) {
    let r = e[t + 5], i = r >= 1e4 ? `${Math.round(r / 1e3)}k` : r >= 1e3 ? `${Math.round(r / 100) / 10}k` : r, a = e[t + 6], o = a === -1 ? {} : Object.assign({}, n[a]);
    return Object.assign(o, {
        cluster: !0,
        cluster_id: e[t + 3],
        point_count: r,
        point_count_abbreviated: i
    });
}
const wh = `geojsonvt_clip_start`, Th = `geojsonvt_clip_end`;
function Eh(e, t, n, r, i) {
    let a = t === i.maxZoom ? 0 : i.tolerance / ((1 << t) * i.extent), o = {
        transformed: !1,
        features: [],
        source: null,
        x: n,
        y: r,
        z: t,
        minX: 2,
        minY: 1,
        maxX: -1,
        maxY: 0,
        numPoints: 0,
        numSimplified: 0,
        numFeatures: e.length
    };
    for (let t of e)Dh(o, t, a, i);
    return o;
}
function Dh(e, t, n, r) {
    switch(e.minX = Math.min(e.minX, t.minX), e.minY = Math.min(e.minY, t.minY), e.maxX = Math.max(e.maxX, t.maxX), e.maxY = Math.max(e.maxY, t.maxY), t.type){
        case `Point`:
        case `MultiPoint`:
            Oh(e, t);
            return;
        case `LineString`:
            kh(e, t, n, r);
            return;
        case `MultiLineString`:
        case `Polygon`:
            Ah(e, t, n);
            return;
        case `MultiPolygon`:
            jh(e, t, n);
            return;
    }
}
function Oh(e, t) {
    let n = [];
    for(let r = 0; r < t.geometry.length; r += 3)n.push(t.geometry[r], t.geometry[r + 1]), e.numPoints++, e.numSimplified++;
    if (!n.length) return;
    let r = {
        type: 1,
        tags: t.tags || null,
        geometry: n
    };
    t.id !== null && (r.id = t.id), e.features.push(r);
}
function kh(e, t, n, r) {
    let i = [];
    if (Mh(i, t.geometry, e, n, !1, !1), !i.length) return;
    let a = t.tags || null;
    if (r.lineMetrics) {
        a = {};
        for(let e in t.tags)a[e] = t.tags[e];
        a[wh] = t.geometry.start / t.geometry.size, a[Th] = t.geometry.end / t.geometry.size;
    }
    let o = {
        type: 2,
        tags: a,
        geometry: i
    };
    t.id !== null && (o.id = t.id), e.features.push(o);
}
function Ah(e, t, n) {
    let r = [];
    for(let i = 0; i < t.geometry.length; i++)Mh(r, t.geometry[i], e, n, t.type === `Polygon`, i === 0);
    if (!r.length) return;
    let i = {
        type: t.type === `Polygon` ? 3 : 2,
        tags: t.tags || null,
        geometry: r
    };
    t.id !== null && (i.id = t.id), e.features.push(i);
}
function jh(e, t, n) {
    let r = [];
    for(let i = 0; i < t.geometry.length; i++){
        let a = t.geometry[i];
        for(let t = 0; t < a.length; t++)Mh(r, a[t], e, n, !0, t === 0);
    }
    if (!r.length) return;
    let i = {
        type: 3,
        tags: t.tags || null,
        geometry: r
    };
    t.id !== null && (i.id = t.id), e.features.push(i);
}
function Mh(e, t, n, r, i, a) {
    let o = r * r;
    if (r > 0 && t.size < (i ? o : r)) {
        n.numPoints += t.points.length / 3;
        return;
    }
    let s = [];
    for(let e = 0; e < t.points.length; e += 3)(r === 0 || t.points[e + 2] > o) && (n.numSimplified++, s.push(t.points[e], t.points[e + 1])), n.numPoints++;
    i && Nh(s, a), e.push(s);
}
function Nh(e, t) {
    let n = 0;
    for(let t = 0, r = e.length, i = r - 2; t < r; i = t, t += 2)n += (e[t] - e[i]) * (e[t + 1] + e[i + 1]);
    if (n > 0 === t) for(let t = 0, n = e.length; t < n / 2; t += 2){
        let r = e[t], i = e[t + 1];
        e[t] = e[n - 2 - t], e[t + 1] = e[n - 1 - t], e[n - 2 - t] = r, e[n - 1 - t] = i;
    }
}
function Ph(e, t) {
    if (e.transformed) return e;
    let n = 1 << e.z, r = e.x, i = e.y;
    for (let a of e.features)a.type === 1 ? Fh(a, t, n, r, i) : Ih(a, t, n, r, i);
    return e.transformed = !0, e;
}
function Fh(e, t, n, r, i) {
    let a = e, o = e.geometry, s = [];
    for(let e = 0; e < o.length; e += 2)s.push(Lh(o[e], o[e + 1], t, n, r, i));
    return a.geometry = s, a;
}
function Ih(e, t, n, r, i) {
    let a = e, o = e.geometry, s = [];
    for (let e of o){
        let a = [];
        for(let o = 0; o < e.length; o += 2)a.push(Lh(e[o], e[o + 1], t, n, r, i));
        s.push(a);
    }
    return a.geometry = s, a;
}
function Lh(e, t, n, r, i, a) {
    return [
        Math.round(n * (e * r - i)),
        Math.round(n * (t * r - a))
    ];
}
var Rh = class {
    constructor(e){
        this.options = e, this.total = 0, this.stats = {}, this.tiles = {}, this.tileCoords = [], this.stats = {}, this.total = 0;
    }
    initialize(e) {
        this.splitTile(e, 0, 0, 0), this.options.debug && (e.length && console.log(`features: %d, points: %d`, this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd(`generate tiles`), console.log(`tiles generated:`, this.total, JSON.stringify(this.stats)));
    }
    updateIndex(e, t, n) {
        n.debug > 1 && (console.log(`invalidating tiles`), console.time(`invalidating`)), this.invalidateTiles(t), n.debug > 1 && console.timeEnd(`invalidating`);
        let [r, i, a] = [
            0,
            0,
            0
        ], o = Eh(e, r, i, a, n);
        o.source = e;
        let s = zh(r, i, a);
        if (this.tiles[s] = o, this.tileCoords.push({
            z: r,
            x: i,
            y: a,
            id: s
        }), n.debug) {
            let e = `z${r}`;
            this.stats[e] = (this.stats[e] || 0) + 1, this.total++;
        }
    }
    getClusterExpansionZoom(e) {
        return null;
    }
    getChildren(e) {
        return null;
    }
    getLeaves(e, t, n) {
        return null;
    }
    getTile(e, t, n) {
        let { extent: r, debug: i } = this.options, a = 1 << e;
        t = t + a & a - 1;
        let o = zh(e, t, n);
        if (this.tiles[o]) return Ph(this.tiles[o], r);
        i > 1 && console.log(`drilling down to z%d-%d-%d`, e, t, n);
        let s = e, c = t, l = n, u;
        for(; !u && s > 0;)s--, c >>= 1, l >>= 1, u = this.tiles[zh(s, c, l)];
        return !u?.source || (i > 1 && (console.log(`found parent tile z%d-%d-%d`, s, c, l), console.time(`drilling down`)), this.splitTile(u.source, s, c, l, e, t, n), i > 1 && console.timeEnd(`drilling down`), !this.tiles[o]) ? null : Ph(this.tiles[o], r);
    }
    splitTile(e, t, n, r, i, a, o) {
        let s = [
            e,
            t,
            n,
            r
        ], c = this.options, l = c.debug;
        for(; s.length;){
            r = s.pop(), n = s.pop(), t = s.pop(), e = s.pop();
            let u = 1 << t, d = zh(t, n, r), f = this.tiles[d];
            if (!f && (l > 1 && console.time(`creation`), f = this.tiles[d] = Eh(e, t, n, r, c), this.tileCoords.push({
                z: t,
                x: n,
                y: r,
                id: d
            }), l)) {
                l > 1 && (console.log(`tile z%d-%d-%d (features: %d, points: %d, simplified: %d)`, t, n, r, f.numFeatures, f.numPoints, f.numSimplified), console.timeEnd(`creation`));
                let e = `z${t}`;
                this.stats[e] = (this.stats[e] || 0) + 1, this.total++;
            }
            if (f.source = e, i == null) {
                if (t === c.indexMaxZoom || f.numPoints <= c.indexMaxPoints) continue;
            } else if (t === c.maxZoom || t === i) continue;
            else if (i != null) {
                let e = i - t;
                if (n !== a >> e || r !== o >> e) continue;
            }
            if (f.source = null, !e.length) continue;
            l > 1 && console.time(`clipping`);
            let p = .5 * c.buffer / c.extent, m = .5 - p, h = .5 + p, g = 1 + p, _ = null, v = null, y = null, b = null, x = Gm(e, u, n - p, n + h, 0, f.minX, f.maxX, c), S = Gm(e, u, n + m, n + g, 0, f.minX, f.maxX, c);
            x && (_ = Gm(x, u, r - p, r + h, 1, f.minY, f.maxY, c), v = Gm(x, u, r + m, r + g, 1, f.minY, f.maxY, c)), S && (y = Gm(S, u, r - p, r + h, 1, f.minY, f.maxY, c), b = Gm(S, u, r + m, r + g, 1, f.minY, f.maxY, c)), l > 1 && console.timeEnd(`clipping`), s.push(_ || [], t + 1, n * 2, r * 2), s.push(v || [], t + 1, n * 2, r * 2 + 1), s.push(y || [], t + 1, n * 2 + 1, r * 2), s.push(b || [], t + 1, n * 2 + 1, r * 2 + 1);
        }
    }
    invalidateTiles(e) {
        if (!e.length) return;
        let t = this.options, { debug: n } = t, r = 1 / 0, i = -1 / 0, a = 1 / 0, o = -1 / 0;
        for (let t of e)r = Math.min(r, t.minX), i = Math.max(i, t.maxX), a = Math.min(a, t.minY), o = Math.max(o, t.maxY);
        let s = t.buffer / t.extent, c = new Set;
        for(let t in this.tiles){
            let l = this.tiles[t], u = 1 << l.z, d = (l.x - s) / u, f = (l.x + 1 + s) / u, p = (l.y - s) / u, m = (l.y + 1 + s) / u;
            if (i < d || r >= f || o < p || a >= m) continue;
            let h = !1;
            for (let t of e)if (t.maxX >= d && t.minX < f && t.maxY >= p && t.minY < m) {
                h = !0;
                break;
            }
            if (h) {
                if (n) {
                    n > 1 && console.log(`invalidate tile z%d-%d-%d (features: %d, points: %d, simplified: %d)`, l.z, l.x, l.y, l.numFeatures, l.numPoints, l.numSimplified);
                    let e = `z${l.z}`;
                    this.stats[e] = (this.stats[e] || 0) - 1, this.total--;
                }
                delete this.tiles[t], c.add(t);
            }
        }
        c.size && (this.tileCoords = this.tileCoords.filter((e)=>!c.has(e.id)));
    }
};
function zh(e, t, n) {
    return ((1 << e) * n + t) * 32 + e;
}
const Bh = {
    maxZoom: 14,
    indexMaxZoom: 5,
    indexMaxPoints: 1e5,
    tolerance: 3,
    extent: 4096,
    buffer: 64,
    lineMetrics: !1,
    promoteId: null,
    generateId: !1,
    updateable: !1,
    cluster: !1,
    clusterOptions: yh,
    debug: 0
};
var Vh = class {
    constructor(e, t){
        t = this.options = Object.assign({}, Bh, t);
        let n = t.debug;
        if (n && console.time(`preprocess data`), t.maxZoom < 0 || t.maxZoom > 24) throw Error(`maxZoom should be in the 0-24 range`);
        if (t.promoteId && t.generateId) throw Error(`promoteId and generateId cannot be used together.`);
        let r = wm(e, t);
        n && (console.timeEnd(`preprocess data`), console.log(`index: maxZoom: %d, maxPoints: %d`, t.indexMaxZoom, t.indexMaxPoints), console.time(`generate tiles`)), r = ih(r, t), t.updateable && (this.source = r), this.initializeIndex(r, t);
    }
    initializeIndex(e, t) {
        this.tileIndex = t.cluster ? new bh(t.clusterOptions) : new Rh(t), e.length && this.tileIndex.initialize(e);
    }
    getTile(e, t, n) {
        return e = +e, t = +t, n = +n, e < 0 || e > 24 ? null : this.tileIndex.getTile(e, t, n);
    }
    updateData(e, t) {
        let n = this.options;
        if (!n.updateable) throw Error("to update tile geojson `updateable` option must be set to true");
        let { affected: r, source: i } = ch(this.source, e, n);
        t && ({ affected: r, source: i } = this.filterUpdate(i, r, t)), r.length && (this.source = i, this.tileIndex.updateIndex(i, r, n));
    }
    filterUpdate(e, t, n) {
        let r = new Set;
        for (let i of e)i.id != null && (n(zm(i)) || (t.push(i), r.add(i.id)));
        return e = e.filter((e)=>!r.has(e.id)), {
            affected: t,
            source: e
        };
    }
    getData() {
        if (!this.options.updateable) throw Error("to retrieve data the `updateable` option must be set to true");
        return Rm(this.source);
    }
    updateClusterOptions(e, t) {
        let n = this.options.cluster;
        if (this.options.cluster = e, this.options.clusterOptions = t, n == e) {
            this.tileIndex.updateIndex(this.source, [], this.options);
            return;
        }
        this.initializeIndex(this.source, this.options);
    }
    getClusterExpansionZoom(e) {
        return this.tileIndex.getClusterExpansionZoom(e);
    }
    getClusterChildren(e) {
        return this.tileIndex.getChildren(e);
    }
    getClusterLeaves(e, t, n) {
        return this.tileIndex.getLeaves(e, t, n);
    }
};
const Hh = q([
    {
        name: `a_pos_normal`,
        components: 2,
        type: `Int16`
    },
    {
        name: `a_data`,
        components: 4,
        type: `Uint8`
    }
], 4), Uh = Hh.members;
Hh.size, Hh.alignment;
const Wh = q([
    {
        name: `a_uv_x`,
        components: 1,
        type: `Float32`
    },
    {
        name: `a_split_index`,
        components: 1,
        type: `Float32`
    }
]), Gh = Wh.members;
Wh.size, Wh.alignment;
const Kh = Math.cos(37.5 * (Math.PI / 180)), qh = 0.5, Jh = 2 ** 14 / qh;
var Yh = class {
    constructor(e){
        this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.id), this.index = e.index, this.hasDependencies = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {};
        for (let e of this.layers)this.gradients[e.id] = {};
        this.layoutVertexArray = new _u, this.layoutVertexArray2 = new vu, this.indexArray = new Ou, this.programConfigurations = new ud(e.layers, e.zoom), this.segments = new Nu, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id);
    }
    populate(e, t, n) {
        this.hasDependencies = Af(`line`, this.layers, t) || this.hasLineDasharray(this.layers);
        let r = this.layers[0].layout.get(`line-sort-key`), i = !r.isConstant(), a = [];
        for (let { feature: t, id: o, index: s, sourceLayerIndex: c } of e){
            let e = this.layers[0]._featureFilter.needGeometry, l = _d(t, e);
            if (!this.layers[0]._featureFilter.filter(new U(this.zoom), l, n)) continue;
            let u = i ? r.evaluate(l, {}, n) : void 0, d = {
                id: o,
                properties: t.properties,
                type: t.type,
                sourceLayerIndex: c,
                index: s,
                geometry: e ? l.geometry : gd(t),
                patterns: {},
                dashes: {},
                sortKey: u
            };
            a.push(d);
        }
        i && a.sort((e, t)=>e.sortKey - t.sortKey);
        for (let r of a){
            let { geometry: i, index: a, sourceLayerIndex: o } = r;
            this.hasDependencies ? (Af(`line`, this.layers, t) ? jf(`line`, this.layers, r, {
                zoom: this.zoom
            }, t) : this.hasLineDasharray(this.layers) && this.addLineDashDependencies(this.layers, r, this.zoom, t), this.patternFeatures.push(r)) : this.addFeature(r, i, a, n, {}, {}, t.subdivisionGranularity);
            let s = e[a].feature;
            t.featureIndex.insert(s, i, a, o, this.index);
        }
    }
    update(e, t, n, r) {
        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e, t, this.stateDependentLayers, {
            imagePositions: n,
            dashPositions: r
        });
    }
    addFeatures(e, t, n, r) {
        for (let i of this.patternFeatures)this.addFeature(i, i.geometry, i.index, t, n, r, e.subdivisionGranularity);
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(e) {
        this.uploaded || (this.layoutVertexArray2.length !== 0 && (this.layoutVertexBuffer2 = e.createVertexBuffer(this.layoutVertexArray2, Gh)), this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, Uh), this.indexBuffer = e.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e), this.uploaded = !0;
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
    }
    lineFeatureClips(e) {
        if (e.properties && Object.hasOwn(e.properties, `geojsonvt_clip_start`) && Object.hasOwn(e.properties, `geojsonvt_clip_end`)) return {
            start: +e.properties[wh],
            end: +e.properties[Th]
        };
    }
    addFeature(e, t, n, r, i, a, o) {
        let s = this.layers[0].layout, c = s.get(`line-join`).evaluate(e, {}), l = s.get(`line-cap`).evaluate(e, {}), u = s.get(`line-miter-limit`).evaluate(e, {}), d = s.get(`line-round-limit`).evaluate(e, {});
        this.lineClips = this.lineFeatureClips(e);
        for (let n of t)this.addLine(n, e, c, l, u, d, r, o);
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, n, {
            imagePositions: i,
            dashPositions: a,
            canonical: r
        });
    }
    addLine(e, t, n, r, i, a, o, s) {
        this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0;
        let c = o ? s.line.getGranularityForZoomLevel(o.z) : 1;
        if (e = Mp(e, c), this.lineClips) {
            this.lineClipsArray.push(this.lineClips);
            for(let t = 0; t < e.length - 1; t++)this.totalDistance += e[t].dist(e[t + 1]);
            this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
        }
        let l = Zp.types[t.type] === `Polygon`, u = e.length;
        for(; u >= 2 && e[u - 1].equals(e[u - 2]);)u--;
        let d = 0;
        for(; d < u - 1 && e[d].equals(e[d + 1]);)d++;
        if (u - d < (l ? 3 : 2)) return;
        n === `bevel` && (i = 1.05);
        let f = this.overscaling <= 16 ? 15 * Ye / (512 * this.overscaling) : 0, p = this.segments.prepareSegment(u * 10, this.layoutVertexArray, this.indexArray), m, h, g, _, v;
        this.e1 = this.e2 = -1, l && (m = e[u - 2], v = e[d].sub(m)._unit()._perp());
        for(let t = d; t < u; t++){
            if (g = t === u - 1 ? l ? e[d + 1] : void 0 : e[t + 1], g && e[t].equals(g)) continue;
            v && (_ = v), m && (h = m), m = e[t], v = g ? g.sub(m)._unit()._perp() : _, _ ||= v;
            let o = _.add(v);
            (o.x !== 0 || o.y !== 0) && o._unit();
            let s = _.x * v.x + _.y * v.y, c = o.x * v.x + o.y * v.y, y = c === 0 ? 1 / 0 : 1 / c, b = 2 * Math.sqrt(2 - 2 * c), x = c < Kh && h && g, S = _.x * v.y - _.y * v.x > 0;
            if (x && t > d) {
                let e = m.dist(h);
                if (e > 2 * f) {
                    let t = m.sub(m.sub(h)._mult(f / e)._round());
                    this.updateDistance(h, t), this.addCurrentVertex(t, _, 0, 0, p), h = t;
                }
            }
            let C = h && g, w = C ? n : l ? `butt` : r;
            if (C && w === `round` && (y < a ? w = `miter` : y <= 2 && (w = `fakeround`)), w === `miter` && y > i && (w = `bevel`), w === `bevel` && (y > 2 && (w = `flipbevel`), y < i && (w = `miter`)), h && this.updateDistance(h, m), w === `miter`) o._mult(y), this.addCurrentVertex(m, o, 0, 0, p);
            else if (w === `flipbevel`) {
                if (y > 100) o = v.mult(-1);
                else {
                    let e = y * _.add(v).mag() / _.sub(v).mag();
                    o._perp()._mult(e * (S ? -1 : 1));
                }
                this.addCurrentVertex(m, o, 0, 0, p), this.addCurrentVertex(m, o.mult(-1), 0, 0, p);
            } else if (w === `bevel` || w === `fakeround`) {
                let e = -Math.sqrt(y * y - 1), t = S ? e : 0, n = S ? 0 : e;
                if (h && this.addCurrentVertex(m, _, t, n, p), w === `fakeround`) {
                    let e = Math.round(b * 180 / Math.PI / 20);
                    for(let t = 1; t < e; t++){
                        let n = t / e;
                        if (n !== .5) {
                            let e = n - .5, t = 1.0904 + s * (-3.2452 + s * (3.55645 - s * 1.43519)), r = .848013 + s * (-1.06021 + s * .215638);
                            n += n * e * (n - 1) * (t * e * e + r);
                        }
                        let r = v.sub(_)._mult(n)._add(_)._unit()._mult(S ? -1 : 1);
                        this.addHalfVertex(m, r.x, r.y, !1, S, 0, p);
                    }
                }
                g && this.addCurrentVertex(m, v, -t, -n, p);
            } else if (w === `butt`) this.addCurrentVertex(m, o, 0, 0, p);
            else if (w === `square`) {
                let e = h ? 1 : -1;
                this.addCurrentVertex(m, o, e, e, p);
            } else w === `round` && (h && (this.addCurrentVertex(m, _, 0, 0, p), this.addCurrentVertex(m, _, 1, 1, p, !0)), g && (this.addCurrentVertex(m, v, -1, -1, p, !0), this.addCurrentVertex(m, v, 0, 0, p)));
            if (x && t < u - 1) {
                let e = m.dist(g);
                if (e > 2 * f) {
                    let t = m.add(g.sub(m)._mult(f / e)._round());
                    this.updateDistance(m, t), this.addCurrentVertex(t, v, 0, 0, p), m = t;
                }
            }
        }
    }
    addCurrentVertex(e, t, n, r, i, a = !1) {
        let o = t.x + t.y * n, s = t.y - t.x * n, c = -t.x + t.y * r, l = -t.y - t.x * r;
        this.addHalfVertex(e, o, s, a, !1, n, i), this.addHalfVertex(e, c, l, a, !0, -r, i), this.distance > Jh / 2 && this.totalDistance === 0 && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(e, t, n, r, i, a));
    }
    addHalfVertex({ x: e, y: t }, n, r, i, a, o, s) {
        let c = (this.lineClips ? this.scaledDistance * (Jh - 1) : this.scaledDistance) * qh;
        if (this.layoutVertexArray.emplaceBack((e << 1) + +!!i, (t << 1) + +!!a, Math.round(63 * n) + 128, Math.round(63 * r) + 128, (o === 0 ? 0 : o < 0 ? -1 : 1) + 1 | (c & 63) << 2, c >> 6), this.lineClips) {
            let e = (this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start);
            this.layoutVertexArray2.emplaceBack(e, this.lineClipsArray.length);
        }
        let l = s.vertexLength++;
        this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, l, this.e2), s.primitiveLength++), a ? this.e2 = l : this.e1 = l;
    }
    updateScaledDistance() {
        this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
    }
    updateDistance(e, t) {
        this.distance += e.dist(t), this.updateScaledDistance();
    }
    hasLineDasharray(e) {
        for (let t of e){
            let e = t.paint.get(`line-dasharray`);
            if (e && !e.isConstant()) return !0;
        }
        return !1;
    }
    addLineDashDependencies(e, t, n, r) {
        for (let i of e){
            let e = i.paint.get(`line-dasharray`);
            if (!e || e.value.kind === `constant`) continue;
            let a = i.layout.get(`line-cap`).evaluate(t, {}) === `round`, o = {
                dasharray: e.value.evaluate({
                    zoom: n - 1
                }, t, {}),
                round: a
            }, s = {
                dasharray: e.value.evaluate({
                    zoom: n
                }, t, {}),
                round: a
            }, c = {
                dasharray: e.value.evaluate({
                    zoom: n + 1
                }, t, {}),
                round: a
            }, l = `${o.dasharray.join(`,`)},${o.round}`, u = `${s.dasharray.join(`,`)},${s.round}`, d = `${c.dasharray.join(`,`)},${c.round}`;
            r.dashDependencies[l] = o, r.dashDependencies[u] = s, r.dashDependencies[d] = c, t.dashes[i.id] = {
                min: l,
                mid: u,
                max: d
            };
        }
    }
};
H(`LineBucket`, Yh, {
    omit: [
        `layers`,
        `patternFeatures`
    ]
});
let Xh;
const Zh = ()=>Xh ||= new gl({
        "line-cap": new G(j.layout_line[`line-cap`], `line-cap`),
        "line-join": new G(j.layout_line[`line-join`], `line-join`),
        "line-miter-limit": new G(j.layout_line[`line-miter-limit`], `line-miter-limit`),
        "line-round-limit": new G(j.layout_line[`line-round-limit`], `line-round-limit`),
        "line-sort-key": new G(j.layout_line[`line-sort-key`], `line-sort-key`)
    });
let Qh;
const $h = ()=>Qh ||= new gl({
        "line-opacity": new G(j.paint_line[`line-opacity`], `line-opacity`),
        "line-layer-opacity": new W(j.paint_line[`line-layer-opacity`], `line-layer-opacity`),
        "line-color": new G(j.paint_line[`line-color`], `line-color`),
        "line-translate": new W(j.paint_line[`line-translate`], `line-translate`),
        "line-translate-anchor": new W(j.paint_line[`line-translate-anchor`], `line-translate-anchor`),
        "line-width": new G(j.paint_line[`line-width`], `line-width`),
        "line-gap-width": new G(j.paint_line[`line-gap-width`], `line-gap-width`),
        "line-offset": new G(j.paint_line[`line-offset`], `line-offset`),
        "line-blur": new G(j.paint_line[`line-blur`], `line-blur`),
        "line-dasharray": new pl(j.paint_line[`line-dasharray`], `line-dasharray`),
        "line-pattern": new pl(j.paint_line[`line-pattern`], `line-pattern`),
        "line-gradient": new hl(j.paint_line[`line-gradient`], `line-gradient`)
    });
var eg = {
    get paint () {
        return $h();
    },
    get layout () {
        return Zh();
    }
}, tg = class extends G {
    possiblyEvaluate(e, t) {
        return t = new U(Math.floor(t.zoom), {
            now: t.now,
            fadeDuration: t.fadeDuration,
            zoomHistory: t.zoomHistory,
            transition: t.transition
        }), super.possiblyEvaluate(e, t);
    }
    evaluate(e, t, n, r) {
        return t = xt({}, t, {
            zoom: Math.floor(t.zoom)
        }), super.evaluate(e, t, n, r);
    }
};
let ng;
const rg = (e)=>e.type === `line`;
var ig = class extends yl {
    constructor(e, t){
        super(e, eg, t), this.gradientVersion = 0, ng || (ng = new tg(eg.paint.properties[`line-width`].specification, `line-floorwidth`), ng.useIntegerZoom = !0);
    }
    _handleSpecialPaintPropertyUpdate(e) {
        if (e === `line-gradient`) {
            let e = this.gradientExpression();
            Jo(e) ? this.stepInterpolant = e._styleExpression.expression instanceof Ci : this.stepInterpolant = !1, this.gradientVersion = (this.gradientVersion + 1) % (2 ** 53 - 1);
        }
    }
    gradientExpression() {
        return this._transitionablePaint._values[`line-gradient`].value.expression;
    }
    recalculate(e, t) {
        super.recalculate(e, t), this.paint._values[`line-floorwidth`] = ng.possiblyEvaluate(this._transitioningPaint._values[`line-width`].value, e);
    }
    createBucket(e) {
        return new Yh(e);
    }
    queryRadius(e) {
        let t = e, n = ag(Pd(`line-width`, this, t), Pd(`line-gap-width`, this, t)), r = Pd(`line-offset`, this, t);
        return n / 2 + Math.abs(r) + Fd(this.paint.get(`line-translate`));
    }
    queryIntersectsFeature({ queryGeometry: e, feature: t, featureState: n, geometry: r, transform: i, pixelsToTileUnits: a }) {
        let o = Id(e, this.paint.get(`line-translate`), this.paint.get(`line-translate-anchor`), -i.bearingInRadians, a), s = a / 2 * ag(this.paint.get(`line-width`).evaluate(t, n), this.paint.get(`line-gap-width`).evaluate(t, n)), c = this.paint.get(`line-offset`).evaluate(t, n);
        return c && (r = Rd(r, c * a)), wd(o, r, s);
    }
    isTileClipped() {
        return !0;
    }
};
function ag(e, t) {
    return t > 0 ? t + 2 * e : e;
}
const og = q([
    {
        name: `a_pos_offset`,
        components: 4,
        type: `Int16`
    },
    {
        name: `a_data`,
        components: 4,
        type: `Uint16`
    },
    {
        name: `a_pixeloffset`,
        components: 4,
        type: `Int16`
    }
], 4), sg = q([
    {
        name: `a_projected_pos`,
        components: 3,
        type: `Float32`
    }
], 4);
q([
    {
        name: `a_fade_opacity`,
        components: 1,
        type: `Uint32`
    }
], 4);
const cg = q([
    {
        name: `a_placed`,
        components: 2,
        type: `Uint8`
    },
    {
        name: `a_shift`,
        components: 2,
        type: `Float32`
    },
    {
        name: `a_box_real`,
        components: 2,
        type: `Int16`
    }
]);
q([
    {
        type: `Int16`,
        name: `anchorPointX`
    },
    {
        type: `Int16`,
        name: `anchorPointY`
    },
    {
        type: `Int16`,
        name: `x1`
    },
    {
        type: `Int16`,
        name: `y1`
    },
    {
        type: `Int16`,
        name: `x2`
    },
    {
        type: `Int16`,
        name: `y2`
    },
    {
        type: `Uint32`,
        name: `featureIndex`
    },
    {
        type: `Uint16`,
        name: `sourceLayerIndex`
    },
    {
        type: `Uint16`,
        name: `bucketIndex`
    }
]);
const lg = q([
    {
        name: `a_pos`,
        components: 2,
        type: `Int16`
    },
    {
        name: `a_anchor_pos`,
        components: 2,
        type: `Int16`
    },
    {
        name: `a_extrude`,
        components: 2,
        type: `Int16`
    }
], 4), ug = q([
    {
        name: `a_pos`,
        components: 2,
        type: `Float32`
    },
    {
        name: `a_radius`,
        components: 1,
        type: `Float32`
    },
    {
        name: `a_flags`,
        components: 2,
        type: `Int16`
    }
], 4);
q([
    {
        name: `triangle`,
        components: 3,
        type: `Uint16`
    }
]), q([
    {
        type: `Int16`,
        name: `anchorX`
    },
    {
        type: `Int16`,
        name: `anchorY`
    },
    {
        type: `Uint16`,
        name: `glyphStartIndex`
    },
    {
        type: `Uint16`,
        name: `numGlyphs`
    },
    {
        type: `Uint32`,
        name: `vertexStartIndex`
    },
    {
        type: `Uint32`,
        name: `lineStartIndex`
    },
    {
        type: `Uint32`,
        name: `lineLength`
    },
    {
        type: `Uint16`,
        name: `segment`
    },
    {
        type: `Uint16`,
        name: `lowerSize`
    },
    {
        type: `Uint16`,
        name: `upperSize`
    },
    {
        type: `Float32`,
        name: `lineOffsetX`
    },
    {
        type: `Float32`,
        name: `lineOffsetY`
    },
    {
        type: `Uint8`,
        name: `writingMode`
    },
    {
        type: `Uint8`,
        name: `placedOrientation`
    },
    {
        type: `Uint8`,
        name: `hidden`
    },
    {
        type: `Uint32`,
        name: `crossTileID`
    },
    {
        type: `Int16`,
        name: `associatedIconIndex`
    }
]), q([
    {
        type: `Int16`,
        name: `anchorX`
    },
    {
        type: `Int16`,
        name: `anchorY`
    },
    {
        type: `Int16`,
        name: `rightJustifiedTextSymbolIndex`
    },
    {
        type: `Int16`,
        name: `centerJustifiedTextSymbolIndex`
    },
    {
        type: `Int16`,
        name: `leftJustifiedTextSymbolIndex`
    },
    {
        type: `Int16`,
        name: `verticalPlacedTextSymbolIndex`
    },
    {
        type: `Int16`,
        name: `placedIconSymbolIndex`
    },
    {
        type: `Int16`,
        name: `verticalPlacedIconSymbolIndex`
    },
    {
        type: `Uint16`,
        name: `key`
    },
    {
        type: `Uint16`,
        name: `textBoxStartIndex`
    },
    {
        type: `Uint16`,
        name: `textBoxEndIndex`
    },
    {
        type: `Uint16`,
        name: `verticalTextBoxStartIndex`
    },
    {
        type: `Uint16`,
        name: `verticalTextBoxEndIndex`
    },
    {
        type: `Uint16`,
        name: `iconBoxStartIndex`
    },
    {
        type: `Uint16`,
        name: `iconBoxEndIndex`
    },
    {
        type: `Uint16`,
        name: `verticalIconBoxStartIndex`
    },
    {
        type: `Uint16`,
        name: `verticalIconBoxEndIndex`
    },
    {
        type: `Uint16`,
        name: `featureIndex`
    },
    {
        type: `Uint16`,
        name: `numHorizontalGlyphVertices`
    },
    {
        type: `Uint16`,
        name: `numVerticalGlyphVertices`
    },
    {
        type: `Uint16`,
        name: `numIconVertices`
    },
    {
        type: `Uint16`,
        name: `numVerticalIconVertices`
    },
    {
        type: `Uint16`,
        name: `useRuntimeCollisionCircles`
    },
    {
        type: `Uint32`,
        name: `crossTileID`
    },
    {
        type: `Float32`,
        name: `textBoxScale`
    },
    {
        type: `Float32`,
        name: `collisionCircleDiameter`
    },
    {
        type: `Uint16`,
        name: `textAnchorOffsetStartIndex`
    },
    {
        type: `Uint16`,
        name: `textAnchorOffsetEndIndex`
    }
]), q([
    {
        type: `Float32`,
        name: `offsetX`
    }
]), q([
    {
        type: `Int16`,
        name: `x`
    },
    {
        type: `Int16`,
        name: `y`
    },
    {
        type: `Int16`,
        name: `tileUnitDistanceFromAnchor`
    }
]), q([
    {
        type: `Uint16`,
        name: `textAnchor`
    },
    {
        type: `Float32`,
        components: 2,
        name: `textOffset`
    }
]);
function dg(e, t, n) {
    let r = t.layout.get(`text-transform`).evaluate(n, {});
    return r === `uppercase` ? e = e.toLocaleUpperCase() : r === `lowercase` && (e = e.toLocaleLowerCase()), nl.applyArabicShaping && (e = nl.applyArabicShaping(e)), e;
}
function fg(e, t, n) {
    for (let r of e.sections)r.text = dg(r.text, t, n);
    return e;
}
function pg(e) {
    let t = {}, n = {}, r = [], i = 0;
    function a(t) {
        r.push(e[t]), i++;
    }
    function o(e, t, i) {
        let a = n[e];
        return delete n[e], n[t] = a, r[a].geometry[0].pop(), r[a].geometry[0] = r[a].geometry[0].concat(i[0]), a;
    }
    function s(e, n, i) {
        let a = t[n];
        return delete t[n], t[e] = a, r[a].geometry[0].shift(), r[a].geometry[0] = i[0].concat(r[a].geometry[0]), a;
    }
    function c(e, t, n) {
        let r = n ? t[0][t[0].length - 1] : t[0][0];
        return `${e}:${r.x}:${r.y}`;
    }
    for(let l = 0; l < e.length; l++){
        let u = e[l], d = u.geometry, f = u.text ? u.text.toString() : null;
        if (!f) {
            a(l);
            continue;
        }
        let p = c(f, d), m = c(f, d, !0);
        if (p in n && m in t && n[p] !== t[m]) {
            let e = s(p, m, d), i = o(p, m, r[e].geometry);
            delete t[p], delete n[m], n[c(f, r[i].geometry, !0)] = i, r[e].geometry = null;
        } else p in n ? o(p, m, d) : m in t ? s(p, m, d) : (a(l), t[p] = i - 1, n[m] = i - 1);
    }
    return r.filter((e)=>e.geometry);
}
const mg = {
    "!": `\u{FE15}`,
    "#": `\u{FF03}`,
    $: `\u{FF04}`,
    "%": `\u{FF05}`,
    "&": `\u{FF06}`,
    "(": `\u{FE35}`,
    ")": `\u{FE36}`,
    "*": `\u{FF0A}`,
    "+": `\u{FF0B}`,
    ",": `\u{FE10}`,
    "-": `\u{FE32}`,
    ".": `\u{30FB}`,
    "/": `\u{FF0F}`,
    ":": `\u{FE13}`,
    ";": `\u{FE14}`,
    "<": `\u{FE3F}`,
    "=": `\u{FF1D}`,
    ">": `\u{FE40}`,
    "?": `\u{FE16}`,
    "@": `\u{FF20}`,
    "[": `\u{FE47}`,
    "\\": `\u{FF3C}`,
    "]": `\u{FE48}`,
    "^": `\u{FF3E}`,
    _: `\u{FE33}`,
    "`": `\u{FF40}`,
    "{": `\u{FE37}`,
    "|": `\u{2015}`,
    "}": `\u{FE38}`,
    "~": `\u{FF5E}`,
    "\xa2": `\u{FFE0}`,
    "\xa3": `\u{FFE1}`,
    "\xa5": `\u{FFE5}`,
    "\xa6": `\u{FFE4}`,
    "\xac": `\u{FFE2}`,
    "\xaf": `\u{FFE3}`,
    "\u2013": `\u{FE32}`,
    "\u2014": `\u{FE31}`,
    "\u2018": `\u{FE43}`,
    "\u2019": `\u{FE44}`,
    "\u201C": `\u{FE41}`,
    "\u201D": `\u{FE42}`,
    "\u2026": `\u{FE19}`,
    "\u22EF": `\u{FE19}`,
    "\u2027": `\u{30FB}`,
    "\u20A9": `\u{FFE6}`,
    "\u3001": `\u{FE11}`,
    "\u3002": `\u{FE12}`,
    "\u3008": `\u{FE3F}`,
    "\u3009": `\u{FE40}`,
    "\u300A": `\u{FE3D}`,
    "\u300B": `\u{FE3E}`,
    "\u300C": `\u{FE41}`,
    "\u300D": `\u{FE42}`,
    "\u300E": `\u{FE43}`,
    "\u300F": `\u{FE44}`,
    "\u3010": `\u{FE3B}`,
    "\u3011": `\u{FE3C}`,
    "\u3014": `\u{FE39}`,
    "\u3015": `\u{FE3A}`,
    "\u3016": `\u{FE17}`,
    "\u3017": `\u{FE18}`,
    "\uFF01": `\u{FE15}`,
    "\uFF08": `\u{FE35}`,
    "\uFF09": `\u{FE36}`,
    "\uFF0C": `\u{FE10}`,
    "\uFF0D": `\u{FE32}`,
    "\uFF0E": `\u{30FB}`,
    "\uFF1A": `\u{FE13}`,
    "\uFF1B": `\u{FE14}`,
    "\uFF1C": `\u{FE3F}`,
    "\uFF1E": `\u{FE40}`,
    "\uFF1F": `\u{FE16}`,
    "\uFF3B": `\u{FE47}`,
    "\uFF3D": `\u{FE48}`,
    "\uFF3F": `\u{FE33}`,
    "\uFF5B": `\u{FE37}`,
    "\uFF5C": `\u{2015}`,
    "\uFF5D": `\u{FE38}`,
    "\uFF5F": `\u{FE35}`,
    "\uFF60": `\u{FE36}`,
    "\uFF61": `\u{FE12}`,
    "\uFF62": `\u{FE41}`,
    "\uFF63": `\u{FE42}`
};
function hg(e) {
    let t = ``, n = {
        premature: !0,
        value: void 0
    }, r = e[Symbol.iterator](), i = r.next(), a = e[Symbol.iterator]();
    a.next();
    let o = a.next();
    for(; !i.done;)(o.done || !Yc(o.value.codePointAt(0)) || mg[o.value]) && (n.premature || !Yc(n.value.codePointAt(0)) || mg[n.value]) && mg[i.value] ? t += mg[i.value] : t += i.value, n = {
        value: i.value,
        premature: !1
    }, i = r.next(), o = a.next();
    return t;
}
const gg = {
    10: !0,
    32: !0,
    38: !0,
    41: !0,
    43: !0,
    45: !0,
    47: !0,
    173: !0,
    183: !0,
    8203: !0,
    8208: !0,
    8211: !0,
    8231: !0
}, _g = {
    40: !0
};
function vg(e, t, n, r, i, a) {
    if (`fontStack` in t) {
        let r = n[t.fontStack]?.[e];
        return r ? r.metrics.advance * t.scale + i : 0;
    } else {
        let e = r[t.imageName];
        return e ? e.displaySize[0] * t.scale * 24 / a + i : 0;
    }
}
function yg(e, t, n, r) {
    let i = (e - t) ** 2;
    return r ? e < t ? i / 2 : i * 2 : i + Math.abs(n) * n;
}
function bg(e, t, n) {
    let r = 0;
    return e === 10 && (r -= 1e4), n && (r += 150), (e === 40 || e === 65288) && (r += 50), (t === 41 || t === 65289) && (r += 50), r;
}
function xg(e, t, n, r, i, a) {
    let o = null, s = yg(t, n, i, a);
    for (let e of r){
        let r = yg(t - e.x, n, i, a) + e.badness;
        r <= s && (o = e, s = r);
    }
    return {
        index: e,
        x: t,
        priorBreak: o,
        badness: s
    };
}
function Sg(e) {
    return e ? Sg(e.priorBreak).concat(e.index) : [];
}
var Cg = class e {
    constructor(e = ``, t = [], n = []){
        this.text = e, this.sections = t, this.sectionIndex = n, this.imageSectionID = null;
    }
    static fromFeature(t, n) {
        let r = new e;
        for (let e of t.sections)e.image ? r.addImageSection(e) : r.addTextSection(e, n);
        return r;
    }
    length() {
        return [
            ...this.text
        ].length;
    }
    getSection(e) {
        return this.sections[this.sectionIndex[e]];
    }
    getSectionIndex(e) {
        return this.sectionIndex[e];
    }
    verticalizePunctuation() {
        this.text = hg(this.text);
    }
    hasZeroWidthSpaces() {
        return this.text.includes(`\u{200B}`);
    }
    trim() {
        let e = this.text.match(/^\s*/), t = e ? e[0].length : 0, n = this.text.match(/\S\s*$/), r = n ? n[0].length - 1 : 0;
        this.text = this.text.substring(t, this.text.length - r), this.sectionIndex = this.sectionIndex.slice(t, this.sectionIndex.length - r);
    }
    substring(t, n) {
        let r = [
            ...this.text
        ].slice(t, n).join(``), i = this.sectionIndex.slice(t, n);
        return new e(r, this.sections, i);
    }
    toCodeUnitIndex(e) {
        return [
            ...this.text
        ].slice(0, e).join(``).length;
    }
    toString() {
        return this.text;
    }
    getMaxScale() {
        return this.sectionIndex.reduce((e, t)=>Math.max(e, this.sections[t].scale), 0);
    }
    getMaxImageSize(e) {
        let t = 0, n = 0;
        for(let r = 0; r < this.length(); r++){
            let i = this.getSection(r);
            if (`imageName` in i) {
                let r = e[i.imageName];
                if (!r) continue;
                let a = r.displaySize;
                t = Math.max(t, a[0]), n = Math.max(n, a[1]);
            }
        }
        return {
            maxImageWidth: t,
            maxImageHeight: n
        };
    }
    addTextSection(e, t) {
        this.text += e.text, this.sections.push({
            scale: e.scale || 1,
            verticalAlign: e.verticalAlign || `bottom`,
            fontStack: e.fontStack || t
        });
        let n = this.sections.length - 1;
        this.sectionIndex.push(...[
            ...e.text
        ].map(()=>n));
    }
    addImageSection(e) {
        let t = e.image ? e.image.name : ``;
        if (t.length === 0) {
            Ft(`Can't add FormattedSection with an empty image.`);
            return;
        }
        let n = this.getNextImageSectionCharCode();
        if (!n) {
            Ft(`Reached maximum number of images 6401`);
            return;
        }
        this.text += String.fromCharCode(n), this.sections.push({
            scale: 1,
            verticalAlign: e.verticalAlign || `bottom`,
            imageName: t
        }), this.sectionIndex.push(this.sections.length - 1);
    }
    getNextImageSectionCharCode() {
        return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
    }
    determineLineBreaks(e, t, n, r, i) {
        let a = [], o = this.determineAverageLineWidth(e, t, n, r, i), s = this.hasZeroWidthSpaces(), c = 0, l = 0, u = this.text[Symbol.iterator](), d = u.next(), f = this.text[Symbol.iterator]();
        f.next();
        let p = f.next(), m = this.text[Symbol.iterator]();
        m.next(), m.next();
        let h = m.next();
        for(; !d.done;){
            let t = this.getSection(l), g = d.value.codePointAt(0);
            if (Uc(g) || (c += vg(g, t, n, r, e, i)), !p.done) {
                let e = zc(g), n = p.value.codePointAt(0);
                (gg[g] || e || `imageName` in t || !h.done && _g[n]) && a.push(xg(l + 1, c, o, a, bg(g, n, e && s), !1));
            }
            l++, d = u.next(), p = f.next(), h = m.next();
        }
        return Sg(xg(this.length(), c, o, a, 0, !0));
    }
    determineAverageLineWidth(e, t, n, r, i) {
        let a = 0, o = 0;
        for (let t of this.text){
            let s = this.getSection(o);
            a += vg(t.codePointAt(0), s, n, r, e, i), o++;
        }
        let s = Math.max(1, Math.ceil(a / t));
        return a / s;
    }
};
const wg = 4294967296, Tg = 1 / wg, Eg = typeof TextDecoder > `u` ? null : new TextDecoder(`utf-8`);
var Dg = class {
    constructor(e){
        this.buf = ArrayBuffer.isView(e) ? e : new Uint8Array(e), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.type = 0, this._valueStart = -1, this.length = this.buf.length;
    }
    readFields(e, t, n = this.length) {
        let r;
        for(; r = this.nextField(n);)e(r, t, this);
        return t;
    }
    readMessage(e, t) {
        return this.readFields(e, t, this.readVarint() + this.pos);
    }
    readFixed32() {
        let e = this.dataView.getUint32(this.pos, !0);
        return this.pos += 4, e;
    }
    readSFixed32() {
        let e = this.dataView.getInt32(this.pos, !0);
        return this.pos += 4, e;
    }
    readFixed64() {
        let e = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * wg;
        return this.pos += 8, e;
    }
    readSFixed64() {
        let e = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * wg;
        return this.pos += 8, e;
    }
    readFloat() {
        let e = this.dataView.getFloat32(this.pos, !0);
        return this.pos += 4, e;
    }
    readDouble() {
        let e = this.dataView.getFloat64(this.pos, !0);
        return this.pos += 8, e;
    }
    readVarint(e) {
        let t = this.buf, n = t[this.pos++];
        if (n < 128) return n;
        let r = n & 127, i;
        return i = t[this.pos++], r |= (i & 127) << 7, i < 128 || (i = t[this.pos++], r |= (i & 127) << 14, i < 128) || (i = t[this.pos++], r |= (i & 127) << 21, i < 128) ? r : (i = t[this.pos], r |= (i & 15) << 28, kg(r, e, this));
    }
    readSVarint() {
        let e = this.readVarint();
        return e % 2 == 1 ? (e + 1) / -2 : e / 2;
    }
    readBoolean() {
        return !!this.readVarint();
    }
    readString() {
        let e = this.readVarint() + this.pos, t = this.pos;
        return this.pos = e, e - t >= 12 && Eg ? Eg.decode(this.buf.subarray(t, e)) : Wg(this.buf, t, e);
    }
    readBytes() {
        let e = this.readVarint() + this.pos, t = this.buf.subarray(this.pos, e);
        return this.pos = e, t;
    }
    readPackedVarint(e = [], t) {
        let n = this.readPackedEnd();
        for(; this.pos < n;)e.push(this.readVarint(t));
        return e;
    }
    readPackedSVarint(e = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e.push(this.readSVarint());
        return e;
    }
    readPackedBoolean(e = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e.push(this.readBoolean());
        return e;
    }
    readPackedFloat(e = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e.push(this.readFloat());
        return e;
    }
    readPackedDouble(e = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e.push(this.readDouble());
        return e;
    }
    readPackedFixed32(e = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e.push(this.readFixed32());
        return e;
    }
    readPackedSFixed32(e = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e.push(this.readSFixed32());
        return e;
    }
    readPackedFixed64(e = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e.push(this.readFixed64());
        return e;
    }
    readPackedSFixed64(e = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e.push(this.readSFixed64());
        return e;
    }
    readPackedEnd() {
        return this.type === 2 ? this.readVarint() + this.pos : this.pos + 1;
    }
    nextField(e = this.length) {
        if (this.pos === this._valueStart && this.skip(this.type), this.pos >= e) return 0;
        let t = this.readVarint();
        return this.type = t & 7, this._valueStart = this.pos, t >>> 3;
    }
    skip(e) {
        let t = e & 7;
        if (t === 0) for(; this.buf[this.pos++] > 127;);
        else if (t === 2) this.pos = this.readVarint() + this.pos;
        else if (t === 5) this.pos += 4;
        else if (t === 1) this.pos += 8;
        else throw Error(`Unimplemented type: ${t}`);
    }
}, Og = class {
    constructor(e = new Uint8Array(16)){
        this.buf = ArrayBuffer.isView(e) ? e : new Uint8Array(e), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.length = this.buf.length;
    }
    writeTag(e, t) {
        this.writeVarint(e << 3 | t);
    }
    realloc(e) {
        let t = this.length || 16;
        for(; t < this.pos + e;)t *= 2;
        if (t !== this.length) {
            let e = new Uint8Array(t);
            e.set(this.buf), this.buf = e, this.dataView = new DataView(e.buffer), this.length = t;
        }
    }
    finish() {
        return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
    }
    writeFixed32(e) {
        this.realloc(4), this.dataView.setInt32(this.pos, e, !0), this.pos += 4;
    }
    writeSFixed32(e) {
        this.realloc(4), this.dataView.setInt32(this.pos, e, !0), this.pos += 4;
    }
    writeFixed64(e) {
        this.realloc(8), this.dataView.setInt32(this.pos, e & -1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e * Tg), !0), this.pos += 8;
    }
    writeSFixed64(e) {
        this.realloc(8), this.dataView.setInt32(this.pos, e & -1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e * Tg), !0), this.pos += 8;
    }
    writeVarint(e) {
        if (e = +e || 0, e >= 0 && e < 128) {
            this.pos >= this.length && this.realloc(1), this.buf[this.pos++] = e;
            return;
        }
        if (e > 268435455 || e < 0) {
            jg(e, this);
            return;
        }
        this.realloc(4), this.buf[this.pos++] = e & 127 | (e > 127 ? 128 : 0), !(e <= 127) && (this.buf[this.pos++] = (e >>>= 7) & 127 | (e > 127 ? 128 : 0), !(e <= 127) && (this.buf[this.pos++] = (e >>>= 7) & 127 | (e > 127 ? 128 : 0), !(e <= 127) && (this.buf[this.pos++] = e >>> 7 & 127)));
    }
    writeSVarint(e) {
        this.writeVarint(e < 0 ? -e * 2 - 1 : e * 2);
    }
    writeBoolean(e) {
        this.writeVarint(+e);
    }
    writeString(e) {
        e = String(e), this.realloc(e.length * 4), this.pos++;
        let t = this.pos;
        this.pos = Gg(this.buf, e, this.pos);
        let n = this.pos - t;
        n >= 128 && Pg(t, n, this), this.pos = t - 1, this.writeVarint(n), this.pos += n;
    }
    writeFloat(e) {
        this.realloc(4), this.dataView.setFloat32(this.pos, e, !0), this.pos += 4;
    }
    writeDouble(e) {
        this.realloc(8), this.dataView.setFloat64(this.pos, e, !0), this.pos += 8;
    }
    writeBytes(e) {
        let t = e.length;
        this.writeVarint(t), this.realloc(t), this.buf.set(e, this.pos), this.pos += t;
    }
    writeRawMessage(e, t) {
        this.pos++;
        let n = this.pos;
        e(t, this);
        let r = this.pos - n;
        r >= 128 && Pg(n, r, this), this.pos = n - 1, this.writeVarint(r), this.pos += r;
    }
    writeMessage(e, t, n) {
        this.writeTag(e, 2), this.writeRawMessage(t, n);
    }
    writePackedVarint(e, t) {
        t.length && this.writeMessage(e, Fg, t);
    }
    writePackedSVarint(e, t) {
        t.length && this.writeMessage(e, Ig, t);
    }
    writePackedBoolean(e, t) {
        t.length && this.writeMessage(e, zg, t);
    }
    writePackedFloat(e, t) {
        t.length && this.writeMessage(e, Lg, t);
    }
    writePackedDouble(e, t) {
        t.length && this.writeMessage(e, Rg, t);
    }
    writePackedFixed32(e, t) {
        t.length && this.writeMessage(e, Bg, t);
    }
    writePackedSFixed32(e, t) {
        t.length && this.writeMessage(e, Vg, t);
    }
    writePackedFixed64(e, t) {
        t.length && this.writeMessage(e, Hg, t);
    }
    writePackedSFixed64(e, t) {
        t.length && this.writeMessage(e, Ug, t);
    }
    writeBytesField(e, t) {
        this.writeTag(e, 2), this.writeBytes(t);
    }
    writeFixed32Field(e, t) {
        this.writeTag(e, 5), this.writeFixed32(t);
    }
    writeSFixed32Field(e, t) {
        this.writeTag(e, 5), this.writeSFixed32(t);
    }
    writeFixed64Field(e, t) {
        this.writeTag(e, 1), this.writeFixed64(t);
    }
    writeSFixed64Field(e, t) {
        this.writeTag(e, 1), this.writeSFixed64(t);
    }
    writeVarintField(e, t) {
        this.writeTag(e, 0), this.writeVarint(t);
    }
    writeSVarintField(e, t) {
        this.writeTag(e, 0), this.writeSVarint(t);
    }
    writeStringField(e, t) {
        this.writeTag(e, 2), this.writeString(t);
    }
    writeFloatField(e, t) {
        this.writeTag(e, 5), this.writeFloat(t);
    }
    writeDoubleField(e, t) {
        this.writeTag(e, 1), this.writeDouble(t);
    }
    writeBooleanField(e, t) {
        this.writeVarintField(e, +t);
    }
};
function kg(e, t, n) {
    let r = n.buf, i, a;
    if (a = r[n.pos++], i = (a & 112) >> 4, a < 128 || (a = r[n.pos++], i |= (a & 127) << 3, a < 128) || (a = r[n.pos++], i |= (a & 127) << 10, a < 128) || (a = r[n.pos++], i |= (a & 127) << 17, a < 128) || (a = r[n.pos++], i |= (a & 127) << 24, a < 128) || (a = r[n.pos++], i |= (a & 1) << 31, a < 128)) return Ag(e, i, t);
    throw Error(`Expected varint not more than 10 bytes`);
}
function Ag(e, t, n) {
    return n ? t * 4294967296 + (e >>> 0) : (t >>> 0) * 4294967296 + (e >>> 0);
}
function jg(e, t) {
    let n, r;
    if (e >= 0 ? (n = e % 4294967296 | 0, r = e / 4294967296 | 0) : (n = ~(-e % 4294967296), r = ~(-e / 4294967296), n ^ 4294967295 ? n = n + 1 | 0 : (n = 0, r = r + 1 | 0)), e >= 0x10000000000000000 || e < -18446744073709552000) throw Error(`Given varint doesn't fit into 10 bytes`);
    t.realloc(10), Mg(n, r, t), Ng(r, t);
}
function Mg(e, t, n) {
    n.buf[n.pos++] = e & 127 | 128, e >>>= 7, n.buf[n.pos++] = e & 127 | 128, e >>>= 7, n.buf[n.pos++] = e & 127 | 128, e >>>= 7, n.buf[n.pos++] = e & 127 | 128, e >>>= 7, n.buf[n.pos] = e & 127;
}
function Ng(e, t) {
    let n = (e & 7) << 4;
    t.buf[t.pos++] |= n | ((e >>>= 3) ? 128 : 0), e && (t.buf[t.pos++] = e & 127 | ((e >>>= 7) ? 128 : 0), e && (t.buf[t.pos++] = e & 127 | ((e >>>= 7) ? 128 : 0), e && (t.buf[t.pos++] = e & 127 | ((e >>>= 7) ? 128 : 0), e && (t.buf[t.pos++] = e & 127 | ((e >>>= 7) ? 128 : 0), e && (t.buf[t.pos++] = e & 127)))));
}
function Pg(e, t, n) {
    let r = t <= 16383 ? 1 : t <= 2097151 ? 2 : t <= 268435455 ? 3 : Math.floor(Math.log(t) / (Math.LN2 * 7));
    n.realloc(r), n.buf.copyWithin(e + r, e, n.pos);
}
function Fg(e, t) {
    let n = e.length, r = t.buf, i = t.pos, a = t.length;
    for(let o = 0; o < n; o++){
        let n = e[o];
        if (n < 0 || i + 10 > a) {
            t.pos = i, t.writeVarint(n), r = t.buf, i = t.pos, a = t.length;
            continue;
        }
        for(; n > 127;)r[i++] = n % 128 | 128, n = Math.floor(n / 128);
        r[i++] = n;
    }
    t.pos = i;
}
function Ig(e, t) {
    for(let n = 0; n < e.length; n++)t.writeSVarint(e[n]);
}
function Lg(e, t) {
    for(let n = 0; n < e.length; n++)t.writeFloat(e[n]);
}
function Rg(e, t) {
    for(let n = 0; n < e.length; n++)t.writeDouble(e[n]);
}
function zg(e, t) {
    for(let n = 0; n < e.length; n++)t.writeBoolean(e[n]);
}
function Bg(e, t) {
    for(let n = 0; n < e.length; n++)t.writeFixed32(e[n]);
}
function Vg(e, t) {
    for(let n = 0; n < e.length; n++)t.writeSFixed32(e[n]);
}
function Hg(e, t) {
    for(let n = 0; n < e.length; n++)t.writeFixed64(e[n]);
}
function Ug(e, t) {
    for(let n = 0; n < e.length; n++)t.writeSFixed64(e[n]);
}
function Wg(e, t, n) {
    let r = ``, i = t;
    for(; i < n;){
        let t = e[i], a = null, o = t > 239 ? 4 : t > 223 ? 3 : t > 191 ? 2 : 1;
        if (i + o > n) break;
        let s, c, l;
        o === 1 ? t < 128 && (a = t) : o === 2 ? (s = e[i + 1], (s & 192) == 128 && (a = (t & 31) << 6 | s & 63, a <= 127 && (a = null))) : o === 3 ? (s = e[i + 1], c = e[i + 2], (s & 192) == 128 && (c & 192) == 128 && (a = (t & 15) << 12 | (s & 63) << 6 | c & 63, (a <= 2047 || a >= 55296 && a <= 57343) && (a = null))) : o === 4 && (s = e[i + 1], c = e[i + 2], l = e[i + 3], (s & 192) == 128 && (c & 192) == 128 && (l & 192) == 128 && (a = (t & 15) << 18 | (s & 63) << 12 | (c & 63) << 6 | l & 63, (a <= 65535 || a >= 1114112) && (a = null))), a === null ? (a = 65533, o = 1) : a > 65535 && (a -= 65536, r += String.fromCharCode(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), r += String.fromCharCode(a), i += o;
    }
    return r;
}
function Gg(e, t, n) {
    for(let r = 0, i, a; r < t.length; r++){
        if (i = t.charCodeAt(r), i > 55295 && i < 57344) {
            if (a) {
                if (i < 56320) {
                    e[n++] = 239, e[n++] = 191, e[n++] = 189, a = i;
                    continue;
                } else i = a - 55296 << 10 | i - 56320 | 65536, a = null;
            } else {
                i > 56319 || r + 1 === t.length ? (e[n++] = 239, e[n++] = 191, e[n++] = 189) : a = i;
                continue;
            }
        } else a &&= (e[n++] = 239, e[n++] = 191, e[n++] = 189, null);
        i < 128 ? e[n++] = i : (i < 2048 ? e[n++] = i >> 6 | 192 : (i < 65536 ? e[n++] = i >> 12 | 224 : (e[n++] = i >> 18 | 240, e[n++] = i >> 12 & 63 | 128), e[n++] = i >> 6 & 63 | 128), e[n++] = i & 63 | 128);
    }
    return n;
}
function Kg(e, t, n) {
    e === 1 && n.readMessage(qg, t);
}
function qg(e, t, n) {
    if (e === 3) {
        let { id: e, bitmap: r, width: i, height: a, left: o, top: s, advance: c } = n.readMessage(Jg, {});
        t.push({
            id: e,
            bitmap: new sf({
                width: i + 6,
                height: a + 6
            }, r),
            metrics: {
                width: i,
                height: a,
                left: o,
                top: s,
                advance: c
            }
        });
    }
}
function Jg(e, t, n) {
    e === 1 ? t.id = n.readVarint() : e === 2 ? t.bitmap = n.readBytes() : e === 3 ? t.width = n.readVarint() : e === 4 ? t.height = n.readVarint() : e === 5 ? t.left = n.readSVarint() : e === 6 ? t.top = n.readSVarint() : e === 7 && (t.advance = n.readVarint());
}
function Yg(e) {
    return new Dg(e).readFields(Kg, []);
}
function Xg(e) {
    let { userImage: t } = e;
    return t?.render && t.render() ? (e.data.replace(new Uint8Array(t.data.buffer)), !0) : !1;
}
function Zg(e) {
    let t = 0, n = 0;
    for (let r of e)t += r.w * r.h, n = Math.max(n, r.w);
    e.sort((e, t)=>t.h - e.h);
    let r = [
        {
            x: 0,
            y: 0,
            w: Math.max(Math.ceil(Math.sqrt(t / .95)), n),
            h: 1 / 0
        }
    ], i = 0, a = 0;
    for (let t of e)for(let e = r.length - 1; e >= 0; e--){
        let n = r[e];
        if (!(t.w > n.w || t.h > n.h)) {
            if (t.x = n.x, t.y = n.y, a = Math.max(a, t.y + t.h), i = Math.max(i, t.x + t.w), t.w === n.w && t.h === n.h) {
                let t = r.pop();
                t && e < r.length && (r[e] = t);
            } else t.h === n.h ? (n.x += t.w, n.w -= t.w) : t.w === n.w ? (n.y += t.h, n.h -= t.h) : (r.push({
                x: n.x + t.w,
                y: n.y,
                w: n.w - t.w,
                h: t.h
            }), n.y += t.h, n.h -= t.h);
            break;
        }
    }
    return {
        w: i,
        h: a,
        fill: t / (i * a) || 0
    };
}
var Qg = class {
    constructor(e, { pixelRatio: t, version: n, stretchX: r, stretchY: i, content: a, textFitWidth: o, textFitHeight: s }){
        this.paddedRect = e, this.pixelRatio = t, this.stretchX = r, this.stretchY = i, this.content = a, this.version = n, this.textFitWidth = o, this.textFitHeight = s;
    }
    get tl() {
        return [
            this.paddedRect.x + 1,
            this.paddedRect.y + 1
        ];
    }
    get br() {
        return [
            this.paddedRect.x + this.paddedRect.w - 1,
            this.paddedRect.y + this.paddedRect.h - 1
        ];
    }
    get tlbr() {
        return this.tl.concat(this.br);
    }
    get displaySize() {
        return [
            (this.paddedRect.w - 2) / this.pixelRatio,
            (this.paddedRect.h - 2) / this.pixelRatio
        ];
    }
}, $g = class {
    constructor(e, t){
        let n = {}, r = {};
        this.haveRenderCallbacks = [];
        let i = [];
        this.addImages(e, n, i), this.addImages(t, r, i);
        let { w: a, h: o } = Zg(i), s = new cf({
            width: a || 1,
            height: o || 1
        });
        for(let t in e){
            let r = e[t], i = n[t].paddedRect;
            cf.copy(r.data, s, {
                x: 0,
                y: 0
            }, {
                x: i.x + 1,
                y: i.y + 1
            }, r.data);
        }
        for(let e in t){
            let n = t[e], i = r[e].paddedRect, a = i.x + 1, o = i.y + 1, c = n.data.width, l = n.data.height;
            cf.copy(n.data, s, {
                x: 0,
                y: 0
            }, {
                x: a,
                y: o
            }, n.data), cf.copy(n.data, s, {
                x: 0,
                y: l - 1
            }, {
                x: a,
                y: o - 1
            }, {
                width: c,
                height: 1
            }), cf.copy(n.data, s, {
                x: 0,
                y: 0
            }, {
                x: a,
                y: o + l
            }, {
                width: c,
                height: 1
            }), cf.copy(n.data, s, {
                x: c - 1,
                y: 0
            }, {
                x: a - 1,
                y: o
            }, {
                width: 1,
                height: l
            }), cf.copy(n.data, s, {
                x: 0,
                y: 0
            }, {
                x: a + c,
                y: o
            }, {
                width: 1,
                height: l
            });
        }
        this.image = s, this.iconPositions = n, this.patternPositions = r;
    }
    addImages(e, t, n) {
        for(let r in e){
            let i = e[r], a = {
                x: 0,
                y: 0,
                w: i.data.width + 2,
                h: i.data.height + 2
            };
            n.push(a), t[r] = new Qg(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(r);
        }
    }
    patchUpdatedImages(e, t) {
        e.dispatchRenderCallbacks(this.haveRenderCallbacks);
        for(let n in e.updatedImages)this.patchUpdatedImage(this.iconPositions[n], e.getImage(n), t), this.patchUpdatedImage(this.patternPositions[n], e.getImage(n), t);
    }
    patchUpdatedImage(e, t, n) {
        if (!e || !t || e.version === t.version) return;
        e.version = t.version;
        let [r, i] = e.tl;
        n.update(t.data, void 0, {
            x: r,
            y: i
        });
    }
};
H(`ImagePosition`, Qg), H(`ImageAtlas`, $g);
var e_ = function(e) {
    return e[e.none = 0] = `none`, e[e.horizontal = 1] = `horizontal`, e[e.vertical = 2] = `vertical`, e[e.horizontalOnly = 3] = `horizontalOnly`, e;
}(e_ || {});
function t_(e) {
    for (let t of e)if (t.positionedGlyphs.length !== 0) return !1;
    return !0;
}
function n_(e, t) {
    let n = [], r = 0;
    for (let i of t)n.push(e.substring(r, i)), r = i;
    return r < e.length() && n.push(e.substring(r, e.length())), n;
}
function r_(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m) {
    let h = Cg.fromFeature(e, i);
    d === 2 && h.verticalizePunctuation();
    let g, _ = h.determineLineBreaks(l, a, t, r, p), { processBidirectionalText: v, processStyledBidirectionalText: y } = nl;
    if (v && h.sections.length === 1) {
        g = [], _ = _.map((e)=>h.toCodeUnitIndex(e));
        let e = v(h.toString(), _);
        for (let t of e){
            let e = [
                ...t
            ].map(()=>0);
            g.push(new Cg(t, h.sections, e));
        }
    } else if (y) {
        g = [], _ = _.map((e)=>h.toCodeUnitIndex(e));
        let e = 0, t = [];
        for (let n of h.text)t.push(...Array(n.length).fill(h.sectionIndex[e])), e++;
        let n = y(h.text, t, _);
        for (let e of n){
            let t = [], n = ``;
            for (let r of e[0])t.push(e[1][n.length]), n += r;
            g.push(new Cg(e[0], h.sections, t));
        }
    } else g = n_(h, _);
    let b = [], x = {
        positionedLines: b,
        text: h.toString(),
        top: u[1],
        bottom: u[1],
        left: u[0],
        right: u[0],
        writingMode: d,
        iconsInText: !1,
        verticalizable: !1
    };
    return l_(x, t, n, r, g, o, s, c, d, l, f, m), !t_(b) && x;
}
function i_(e) {
    let t = .5, n = .5;
    switch(e){
        case `right`:
        case `top-right`:
        case `bottom-right`:
            t = 1;
            break;
        case `left`:
        case `top-left`:
        case `bottom-left`:
            t = 0;
            break;
    }
    switch(e){
        case `bottom`:
        case `bottom-right`:
        case `bottom-left`:
            n = 1;
            break;
        case `top`:
        case `top-right`:
        case `top-left`:
            n = 0;
            break;
    }
    return {
        horizontalAlign: t,
        verticalAlign: n
    };
}
function a_(e, t, n) {
    let r = t.getMaxScale() * 24, { maxImageWidth: i, maxImageHeight: a } = t.getMaxImageSize(e), o = Math.max(r, a * n);
    return {
        verticalLineContentWidth: Math.max(r, i * n),
        horizontalLineContentHeight: o
    };
}
function o_(e) {
    switch(e){
        case `top`:
            return 0;
        case `center`:
            return .5;
        default:
            return 1;
    }
}
function s_(e, t, n, r) {
    if (e?.rect) return e;
    let i = t[n.fontStack]?.[r];
    return i ? {
        rect: null,
        metrics: i.metrics
    } : null;
}
function c_(e, t, n) {
    return !(e === 1 || !t && !Bc(n) || t && (Uc(n) || Xc(n)));
}
function l_(e, t, n, r, i, a, o, s, c, l, u, d) {
    let f = 0, p = 0, m = 0, h = 0, g = s === `right` ? 1 : s === `left` ? 0 : .5, _ = 24 / d, v = 0;
    for (let o of i){
        o.trim();
        let i = o.getMaxScale(), s = {
            positionedGlyphs: [],
            lineOffset: 0
        };
        e.positionedLines[v] = s;
        let d = s.positionedGlyphs, y = 0;
        if (!o.length()) {
            p += a, ++v;
            continue;
        }
        let b = a_(r, o, _), x = 0;
        for (let a of o.text){
            let s = o.getSection(x), m = a.codePointAt(0), h = c_(c, u, m), g = {
                glyph: m,
                imageName: null,
                x: f,
                y: p + -17,
                vertical: h,
                scale: 1,
                fontStack: ``,
                sectionIndex: o.getSectionIndex(x),
                metrics: null,
                rect: null
            }, v;
            if (`fontStack` in s) {
                if (v = u_(s, m, h, b, t, n), !v) continue;
                g.fontStack = s.fontStack;
            } else {
                if (e.iconsInText = !0, s.scale *= _, v = d_(s, h, i, b, r), !v) continue;
                y = Math.max(y, v.imageOffset), g.imageName = s.imageName;
            }
            let { rect: S, metrics: C, baselineOffset: w } = v;
            if (g.y += w, g.scale = s.scale, g.metrics = C, g.rect = S, d.push(g), !h) f += C.advance * s.scale + l;
            else {
                e.verticalizable = !0;
                let t = `imageName` in s ? C.advance : 24;
                f += t * s.scale + l;
            }
            x++;
        }
        if (d.length !== 0) {
            let e = f - l;
            m = Math.max(e, m), f_(d, 0, d.length - 1, g);
        }
        f = 0;
        let S = (i - 1) * 24;
        s.lineOffset = Math.max(y, S);
        let C = a * i + y;
        p += C, h = Math.max(C, h), ++v;
    }
    let { horizontalAlign: y, verticalAlign: b } = i_(o);
    p_(e.positionedLines, g, y, b, m, h, a, p, i.length), e.top += -b * p, e.bottom = e.top + p, e.left += -y * m, e.right = e.left + m;
}
function u_(e, t, n, r, i, a) {
    let o = a[e.fontStack]?.[t], s = s_(o, i, e, t);
    if (s === null) return null;
    let c;
    if (n) c = r.verticalLineContentWidth - e.scale * 24;
    else {
        let t = o_(e.verticalAlign);
        c = (r.horizontalLineContentHeight - e.scale * 24) * t;
    }
    return {
        rect: s.rect,
        metrics: s.metrics,
        baselineOffset: c
    };
}
function d_(e, t, n, r, i) {
    let a = i[e.imageName];
    if (!a) return null;
    let o = a.paddedRect, s = a.displaySize, c = {
        width: s[0],
        height: s[1],
        left: 1,
        top: -3,
        advance: t ? s[1] : s[0]
    }, l;
    if (t) l = r.verticalLineContentWidth - s[1] * e.scale;
    else {
        let t = o_(e.verticalAlign);
        l = (r.horizontalLineContentHeight - s[1] * e.scale) * t;
    }
    let u = (t ? s[0] : s[1]) * e.scale - 24 * n;
    return {
        rect: o,
        metrics: c,
        baselineOffset: l,
        imageOffset: u
    };
}
function f_(e, t, n, r) {
    if (r === 0) return;
    let i = e[n], a = i.metrics.advance * i.scale, o = (e[n].x + a) * r;
    for(let r = t; r <= n; r++)e[r].x -= o;
}
function p_(e, t, n, r, i, a, o, s, c) {
    let l = (t - n) * i, u = 0;
    u = a === o ? -r * c * o + .5 * o : -s * r - -17;
    for (let t of e)for (let e of t.positionedGlyphs)e.x += l, e.y += u;
}
function m_(e, t, n) {
    let { horizontalAlign: r, verticalAlign: i } = i_(n), a = t[0], o = t[1], s = a - e.displaySize[0] * r, c = s + e.displaySize[0], l = o - e.displaySize[1] * i;
    return {
        image: e,
        top: l,
        bottom: l + e.displaySize[1],
        left: s,
        right: c
    };
}
function h_(e) {
    let t = e.left, n = e.top, r = e.right - t, i = e.bottom - n, a = e.image.content[2] - e.image.content[0], o = e.image.content[3] - e.image.content[1], s = e.image.textFitWidth ?? `stretchOrShrink`, c = e.image.textFitHeight ?? `stretchOrShrink`, l = a / o;
    if (c === `proportional`) {
        if (s === `stretchOnly` && r / i < l || s === `proportional`) {
            let e = Math.ceil(i * l);
            t *= e / r, r = e;
        }
    } else if (s === `proportional` && c === `stretchOnly` && l !== 0 && r / i > l) {
        let e = Math.ceil(r / l);
        n *= e / i, i = e;
    }
    return {
        x1: t,
        y1: n,
        x2: t + r,
        y2: n + i
    };
}
function g_(e, t, n, r, i, a) {
    let o = e.image, s;
    if (o.content) {
        let e = o.content, t = o.pixelRatio || 1;
        s = [
            e[0] / t,
            e[1] / t,
            o.displaySize[0] - e[2] / t,
            o.displaySize[1] - e[3] / t
        ];
    }
    let c = t.left * a, l = t.right * a, u, d, f, p;
    n === `width` || n === `both` ? (p = i[0] + c - r[3], d = i[0] + l + r[1]) : (p = i[0] + (c + l - o.displaySize[0]) / 2, d = p + o.displaySize[0]);
    let m = t.top * a, h = t.bottom * a;
    return n === `height` || n === `both` ? (u = i[1] + m - r[0], f = i[1] + h + r[2]) : (u = i[1] + (m + h - o.displaySize[1]) / 2, f = u + o.displaySize[1]), {
        image: o,
        top: u,
        right: d,
        bottom: f,
        left: p,
        collisionPadding: s
    };
}
const __ = 32640;
function v_(e, t) {
    let { expression: n } = t;
    if (n.kind === `constant`) return {
        kind: `constant`,
        layoutSize: n.evaluate(new U(e + 1))
    };
    if (n.kind === `source`) return {
        kind: `source`
    };
    {
        let { zoomStops: t, interpolationType: r } = n, i = 0;
        for(; i < t.length && t[i] <= e;)i++;
        i = Math.max(0, i - 1);
        let a = i;
        for(; a < t.length && t[a] < e + 1;)a++;
        a = Math.min(t.length - 1, a);
        let o = t[i], s = t[a];
        return n.kind === `composite` ? {
            kind: `composite`,
            minZoom: o,
            maxZoom: s,
            interpolationType: r
        } : {
            kind: `camera`,
            minZoom: o,
            maxZoom: s,
            minSize: n.evaluate(new U(o)),
            maxSize: n.evaluate(new U(s)),
            interpolationType: r
        };
    }
}
function y_(e, { uSize: t, uSizeT: n }, { lowerSize: r, upperSize: i }) {
    return e.kind === `source` ? r / 128 : e.kind === `composite` ? Di.number(r / 128, i / 128, n) : t;
}
function b_(e, t) {
    let n = 0, r = 0;
    if (e.kind === `constant`) r = e.layoutSize;
    else if (e.kind !== `source`) {
        let { interpolationType: i, minZoom: a, maxZoom: o } = e, s = i ? yt(Ti.interpolationFactor(i, t, a, o), 0, 1) : 0;
        e.kind === `camera` ? r = Di.number(e.minSize, e.maxSize, s) : n = s;
    }
    return {
        uSizeT: n,
        uSize: r
    };
}
function x_(e, t, n) {
    let r = `never`, i = e.get(t);
    return i ? r = i : e.get(n) && (r = `always`), r;
}
const S_ = [
    {
        name: `a_fade_opacity`,
        components: 1,
        type: `Uint8`,
        offset: 0
    }
];
function C_(e, t, n, r, i, a, o, s, c, l, u, d, f) {
    let p = s ? Math.min(__, Math.round(s[0])) : 0, m = s ? Math.min(__, Math.round(s[1])) : 0;
    e.emplaceBack(t, n, Math.round(r * 32), Math.round(i * 32), a, o, (p << 1) + +!!c, m, l * 16, u * 16, d * 256, f * 256);
}
function w_(e, t, n) {
    e.emplaceBack(t.x, t.y, n), e.emplaceBack(t.x, t.y, n), e.emplaceBack(t.x, t.y, n), e.emplaceBack(t.x, t.y, n);
}
function T_(e) {
    for (let t of e.sections)if (el(t.text)) return !0;
    return !1;
}
var E_ = class {
    constructor(e){
        this.layoutVertexArray = new xu, this.indexArray = new Ou, this.programConfigurations = e, this.segments = new Nu, this.dynamicLayoutVertexArray = new Su, this.opacityVertexArray = new Cu, this.hasVisibleVertices = !1, this.placedSymbolArray = new nu;
    }
    isEmpty() {
        return this.layoutVertexArray.length === 0 && this.indexArray.length === 0 && this.dynamicLayoutVertexArray.length === 0 && this.opacityVertexArray.length === 0;
    }
    upload(e, t, n, r) {
        this.isEmpty() || (n && (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, og.members), this.indexBuffer = e.createIndexBuffer(this.indexArray, t), this.dynamicLayoutVertexBuffer = e.createVertexBuffer(this.dynamicLayoutVertexArray, sg.members, !0), this.opacityVertexBuffer = e.createVertexBuffer(this.opacityVertexArray, S_, !0), this.opacityVertexBuffer.itemSize = 1), (n || r) && this.programConfigurations.upload(e));
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
    }
};
H(`SymbolBuffers`, E_);
var D_ = class {
    constructor(e, t, n){
        this.layoutVertexArray = new e, this.layoutAttributes = t, this.indexArray = new n, this.segments = new Nu, this.collisionVertexArray = new Eu;
    }
    upload(e) {
        this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = e.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = e.createVertexBuffer(this.collisionVertexArray, cg.members, !0);
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
    }
};
H(`CollisionBuffers`, D_);
var O_ = class {
    constructor(e){
        this.collisionBoxArray = e.collisionBoxArray, this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.id), this.index = e.index, this.pixelRatio = e.pixelRatio, this.sourceLayerIndex = e.sourceLayerIndex, this.hasDependencies = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [];
        let t = this.layers[0]._unevaluatedLayout._values;
        this.textSizeData = v_(this.zoom, t[`text-size`]), this.iconSizeData = v_(this.zoom, t[`icon-size`]);
        let n = this.layers[0].layout, r = n.get(`symbol-sort-key`), i = n.get(`symbol-z-order`);
        this.canOverlap = x_(n, `text-overlap`, `text-allow-overlap`) !== `never` || x_(n, `icon-overlap`, `icon-allow-overlap`) !== `never` || n.get(`text-ignore-placement`) || n.get(`icon-ignore-placement`), this.sortFeaturesByKey = i !== `viewport-y` && !r.isConstant();
        let a = i === `viewport-y` || i === `auto` && !this.sortFeaturesByKey;
        this.sortFeaturesByY = a && this.canOverlap, n.get(`symbol-placement`) === `point` && (this.writingModes = n.get(`text-writing-mode`).map((e)=>e_[e])), this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.sourceID = e.sourceID;
    }
    createArrays() {
        this.text = new E_(new ud(this.layers, this.zoom, (e)=>e.startsWith(`text`))), this.icon = new E_(new ud(this.layers, this.zoom, (e)=>e.startsWith(`icon`))), this.glyphOffsetArray = new au, this.lineVertexArray = new ou, this.symbolInstances = new iu, this.textAnchorOffsets = new cu;
    }
    calculateGlyphDependencies(e, t, n, r, i) {
        for (let a of e)if (t[a.codePointAt(0)] = !0, (n || r) && i) {
            let e = mg[a];
            e && (t[e.codePointAt(0)] = !0);
        }
    }
    populate(e, t, n) {
        let r = this.layers[0], i = r.layout, a = i.get(`text-font`), o = i.get(`text-field`), s = i.get(`icon-image`), c = (o.value.kind !== `constant` || o.value.value instanceof Jr && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && (a.value.kind !== `constant` || a.value.value.length > 0), l = s.value.kind !== `constant` || !!s.value.value || Object.keys(s.parameters).length > 0, u = i.get(`symbol-sort-key`);
        if (this.features = [], !c && !l) return;
        let d = t.iconDependencies, f = t.glyphDependencies, p = t.availableImages, m = new U(this.zoom);
        for (let { feature: t, id: o, index: s, sourceLayerIndex: h } of e){
            let e = r._featureFilter.needGeometry, g = _d(t, e);
            if (!r._featureFilter.filter(m, g, n)) continue;
            e || (g.geometry = gd(t));
            let _;
            if (c) {
                let e = r.getValueAndResolveTokens(`text-field`, g, n, p), t = Jr.factory(e);
                this.hasRTLText ||= T_(t), (!this.hasRTLText || nl.getRTLTextPluginStatus() === `unavailable` || this.hasRTLText && nl.isParsed()) && (_ = fg(t, r, g));
            }
            let v;
            if (l) {
                let e = r.getValueAndResolveTokens(`icon-image`, g, n, p);
                v = e instanceof ei ? e : ei.fromString(e);
            }
            if (!_ && !v) continue;
            let y = this.sortFeaturesByKey ? u.evaluate(g, {}, n) : void 0, b = {
                id: o,
                text: _,
                icon: v,
                index: s,
                sourceLayerIndex: h,
                geometry: g.geometry,
                properties: t.properties,
                type: Zp.types[t.type],
                sortKey: y
            };
            if (this.features.push(b), v && (d[v.name] = !0), _) {
                let e = a.evaluate(g, {}, n).join(`,`), t = i.get(`text-rotation-alignment`) !== `viewport` && i.get(`symbol-placement`) !== `point`;
                this.allowVerticalPlacement = this.writingModes?.includes(2);
                for (let n of _.sections)if (n.image) d[n.image.name] = !0;
                else {
                    let r = Wc(_.toString()), i = n.fontStack || e;
                    f[i] ||= {}, this.calculateGlyphDependencies(n.text, f[i], t, this.allowVerticalPlacement, r);
                }
            }
        }
        i.get(`symbol-placement`) === `line` && (this.features = pg(this.features)), this.sortFeaturesByKey && this.features.sort((e, t)=>e.sortKey - t.sortKey);
    }
    update(e, t, n) {
        this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(e, t, this.layers, {
            imagePositions: n
        }), this.icon.programConfigurations.updatePaintArrays(e, t, this.layers, {
            imagePositions: n
        }));
    }
    isEmpty() {
        return this.symbolInstances.length === 0 && !this.hasRTLText;
    }
    uploadPending() {
        return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
    }
    upload(e) {
        !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(e), this.iconCollisionBox.upload(e)), this.text.upload(e, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(e, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
    }
    destroyDebugData() {
        this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
    }
    destroy() {
        this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
    }
    addToLineVertexArray(e, t) {
        let n = this.lineVertexArray.length;
        if (e.segment !== void 0) {
            let n = e.dist(t[e.segment + 1]), r = e.dist(t[e.segment]), i = {};
            for(let r = e.segment + 1; r < t.length; r++)i[r] = {
                x: t[r].x,
                y: t[r].y,
                tileUnitDistanceFromAnchor: n
            }, r < t.length - 1 && (n += t[r + 1].dist(t[r]));
            for(let n = e.segment || 0; n >= 0; n--)i[n] = {
                x: t[n].x,
                y: t[n].y,
                tileUnitDistanceFromAnchor: r
            }, n > 0 && (r += t[n - 1].dist(t[n]));
            for(let e = 0; e < t.length; e++){
                let t = i[e];
                this.lineVertexArray.emplaceBack(t.x, t.y, t.tileUnitDistanceFromAnchor);
            }
        }
        return {
            lineStartIndex: n,
            lineLength: this.lineVertexArray.length - n
        };
    }
    addSymbols(e, t, n, r, i, a, o, s, c, l, u, d) {
        let f = e.indexArray, p = e.layoutVertexArray, m = e.segments.prepareSegment(4 * t.length, p, f, this.canOverlap ? a.sortKey : void 0), h = this.glyphOffsetArray.length, g = m.vertexLength, _ = this.allowVerticalPlacement && o === 2 ? Math.PI / 2 : 0, v = a.text && a.text.sections;
        for(let r = 0; r < t.length; r++){
            let { tl: i, tr: o, bl: c, br: l, tex: u, pixelOffsetTL: h, pixelOffsetBR: g, minFontScaleX: y, minFontScaleY: b, glyphOffset: x, isSDF: S, sectionIndex: C } = t[r], w = m.vertexLength, T = x[1];
            C_(p, s.x, s.y, i.x, T + i.y, u.x, u.y, n, S, h.x, h.y, y, b), C_(p, s.x, s.y, o.x, T + o.y, u.x + u.w, u.y, n, S, g.x, h.y, y, b), C_(p, s.x, s.y, c.x, T + c.y, u.x, u.y + u.h, n, S, h.x, g.y, y, b), C_(p, s.x, s.y, l.x, T + l.y, u.x + u.w, u.y + u.h, n, S, g.x, g.y, y, b), w_(e.dynamicLayoutVertexArray, s, _), f.emplaceBack(w, w + 2, w + 1), f.emplaceBack(w + 1, w + 2, w + 3), m.vertexLength += 4, m.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(x[0]), (r === t.length - 1 || C !== t[r + 1].sectionIndex) && e.programConfigurations.populatePaintArrays(p.length, a, a.index, {
                imagePositions: {},
                canonical: d,
                formattedSection: v?.[C]
            });
        }
        e.placedSymbolArray.emplaceBack(s.x, s.y, h, this.glyphOffsetArray.length - h, g, c, l, s.segment, n ? n[0] : 0, n ? n[1] : 0, r[0], r[1], o, 0, !1, 0, u);
    }
    _addCollisionDebugVertex(e, t, n, r, i, a) {
        return t.emplaceBack(0, 0), e.emplaceBack(n.x, n.y, r, i, Math.round(a.x), Math.round(a.y));
    }
    addCollisionDebugVertices(e, t, n, r, i, a, o) {
        let s = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), c = s.vertexLength, u = i.layoutVertexArray, d = i.collisionVertexArray, f = o.anchorX, p = o.anchorY;
        this._addCollisionDebugVertex(u, d, a, f, p, new l(e, t)), this._addCollisionDebugVertex(u, d, a, f, p, new l(n, t)), this._addCollisionDebugVertex(u, d, a, f, p, new l(n, r)), this._addCollisionDebugVertex(u, d, a, f, p, new l(e, r)), s.vertexLength += 4;
        let m = i.indexArray;
        m.emplaceBack(c, c + 1), m.emplaceBack(c + 1, c + 2), m.emplaceBack(c + 2, c + 3), m.emplaceBack(c + 3, c), s.primitiveLength += 4;
    }
    addDebugCollisionBoxes(e, t, n, r) {
        for(let i = e; i < t; i++){
            let e = this.collisionBoxArray.get(i), t = e.x1, a = e.y1, o = e.x2, s = e.y2;
            this.addCollisionDebugVertices(t, a, o, s, r ? this.textCollisionBox : this.iconCollisionBox, e.anchorPoint, n);
        }
    }
    generateCollisionDebugBuffers() {
        this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new D_(wu, lg.members, ku), this.iconCollisionBox = new D_(wu, lg.members, ku);
        for(let e = 0; e < this.symbolInstances.length; e++){
            let t = this.symbolInstances.get(e);
            this.addDebugCollisionBoxes(t.textBoxStartIndex, t.textBoxEndIndex, t, !0), this.addDebugCollisionBoxes(t.verticalTextBoxStartIndex, t.verticalTextBoxEndIndex, t, !0), this.addDebugCollisionBoxes(t.iconBoxStartIndex, t.iconBoxEndIndex, t, !1), this.addDebugCollisionBoxes(t.verticalIconBoxStartIndex, t.verticalIconBoxEndIndex, t, !1);
        }
    }
    _deserializeCollisionBoxesForSymbol(e, t, n, r, i, a, o, s, c) {
        let l = {};
        for(let r = t; r < n; r++){
            let t = e.get(r);
            l.textBox = {
                x1: t.x1,
                y1: t.y1,
                x2: t.x2,
                y2: t.y2,
                anchorPointX: t.anchorPointX,
                anchorPointY: t.anchorPointY
            }, l.textFeatureIndex = t.featureIndex;
            break;
        }
        for(let t = r; t < i; t++){
            let n = e.get(t);
            l.verticalTextBox = {
                x1: n.x1,
                y1: n.y1,
                x2: n.x2,
                y2: n.y2,
                anchorPointX: n.anchorPointX,
                anchorPointY: n.anchorPointY
            }, l.verticalTextFeatureIndex = n.featureIndex;
            break;
        }
        for(let t = a; t < o; t++){
            let n = e.get(t);
            l.iconBox = {
                x1: n.x1,
                y1: n.y1,
                x2: n.x2,
                y2: n.y2,
                anchorPointX: n.anchorPointX,
                anchorPointY: n.anchorPointY
            }, l.iconFeatureIndex = n.featureIndex;
            break;
        }
        for(let t = s; t < c; t++){
            let n = e.get(t);
            l.verticalIconBox = {
                x1: n.x1,
                y1: n.y1,
                x2: n.x2,
                y2: n.y2,
                anchorPointX: n.anchorPointX,
                anchorPointY: n.anchorPointY
            }, l.verticalIconFeatureIndex = n.featureIndex;
            break;
        }
        return l;
    }
    deserializeCollisionBoxes(e) {
        this.collisionArrays = [];
        for(let t = 0; t < this.symbolInstances.length; t++){
            let n = this.symbolInstances.get(t);
            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(e, n.textBoxStartIndex, n.textBoxEndIndex, n.verticalTextBoxStartIndex, n.verticalTextBoxEndIndex, n.iconBoxStartIndex, n.iconBoxEndIndex, n.verticalIconBoxStartIndex, n.verticalIconBoxEndIndex));
        }
    }
    hasTextData() {
        return this.text.segments.get().length > 0;
    }
    hasIconData() {
        return this.icon.segments.get().length > 0;
    }
    hasDebugData() {
        return this.textCollisionBox && this.iconCollisionBox;
    }
    hasTextCollisionBoxData() {
        return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
    }
    hasIconCollisionBoxData() {
        return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
    }
    addIndicesForPlacedSymbol(e, t) {
        let n = e.placedSymbolArray.get(t), r = n.vertexStartIndex + n.numGlyphs * 4;
        for(let t = n.vertexStartIndex; t < r; t += 4)e.indexArray.emplaceBack(t, t + 2, t + 1), e.indexArray.emplaceBack(t + 1, t + 2, t + 3);
    }
    getSortedSymbolIndexes(e) {
        if (this.sortedAngle === e && this.symbolInstanceIndexes !== void 0) return this.symbolInstanceIndexes;
        let t = Math.sin(e), n = Math.cos(e), r = [], i = [], a = [];
        for(let e = 0; e < this.symbolInstances.length; ++e){
            a.push(e);
            let o = this.symbolInstances.get(e);
            r.push(Math.round(t * o.anchorX + n * o.anchorY) | 0), i.push(o.featureIndex);
        }
        return a.sort((e, t)=>r[e] - r[t] || i[t] - i[e]), a;
    }
    addToSortKeyRanges(e, t) {
        let n = this.sortKeyRanges[this.sortKeyRanges.length - 1];
        n?.sortKey === t ? n.symbolInstanceEnd = e + 1 : this.sortKeyRanges.push({
            sortKey: t,
            symbolInstanceStart: e,
            symbolInstanceEnd: e + 1
        });
    }
    sortFeatures(e) {
        if (this.sortFeaturesByY && this.sortedAngle !== e && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
            this.symbolInstanceIndexes = this.getSortedSymbolIndexes(e), this.sortedAngle = e, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
            for (let e of this.symbolInstanceIndexes){
                let t = this.symbolInstances.get(e);
                this.featureSortOrder.push(t.featureIndex);
                let n = [
                    t.rightJustifiedTextSymbolIndex,
                    t.centerJustifiedTextSymbolIndex,
                    t.leftJustifiedTextSymbolIndex
                ];
                for(let e = 0; e < n.length; e++){
                    let t = n[e];
                    t >= 0 && n.indexOf(t) === e && this.addIndicesForPlacedSymbol(this.text, t);
                }
                t.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, t.verticalPlacedTextSymbolIndex), t.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, t.placedIconSymbolIndex), t.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, t.verticalPlacedIconSymbolIndex);
            }
            this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
        }
    }
};
H(`SymbolBucket`, O_, {
    omit: [
        `layers`,
        `collisionBoxArray`,
        `features`,
        `compareText`
    ]
}), O_.MAX_GLYPHS = 65535, O_.addDynamicAttributes = w_;
function k_(e, t) {
    return t.replace(/{([^{}]+)}/g, (t, n)=>e && n in e ? String(e[n]) : ``);
}
let A_;
const j_ = ()=>A_ ||= new gl({
        "symbol-placement": new W(j.layout_symbol[`symbol-placement`], `symbol-placement`),
        "symbol-spacing": new W(j.layout_symbol[`symbol-spacing`], `symbol-spacing`),
        "symbol-avoid-edges": new W(j.layout_symbol[`symbol-avoid-edges`], `symbol-avoid-edges`),
        "symbol-sort-key": new G(j.layout_symbol[`symbol-sort-key`], `symbol-sort-key`),
        "symbol-z-order": new W(j.layout_symbol[`symbol-z-order`], `symbol-z-order`),
        "icon-allow-overlap": new W(j.layout_symbol[`icon-allow-overlap`], `icon-allow-overlap`),
        "icon-overlap": new W(j.layout_symbol[`icon-overlap`], `icon-overlap`),
        "icon-ignore-placement": new W(j.layout_symbol[`icon-ignore-placement`], `icon-ignore-placement`),
        "icon-optional": new W(j.layout_symbol[`icon-optional`], `icon-optional`),
        "icon-rotation-alignment": new W(j.layout_symbol[`icon-rotation-alignment`], `icon-rotation-alignment`),
        "icon-size": new G(j.layout_symbol[`icon-size`], `icon-size`),
        "icon-text-fit": new W(j.layout_symbol[`icon-text-fit`], `icon-text-fit`),
        "icon-text-fit-padding": new W(j.layout_symbol[`icon-text-fit-padding`], `icon-text-fit-padding`),
        "icon-image": new G(j.layout_symbol[`icon-image`], `icon-image`),
        "icon-rotate": new G(j.layout_symbol[`icon-rotate`], `icon-rotate`),
        "icon-padding": new G(j.layout_symbol[`icon-padding`], `icon-padding`),
        "icon-keep-upright": new W(j.layout_symbol[`icon-keep-upright`], `icon-keep-upright`),
        "icon-offset": new G(j.layout_symbol[`icon-offset`], `icon-offset`),
        "icon-anchor": new G(j.layout_symbol[`icon-anchor`], `icon-anchor`),
        "icon-pitch-alignment": new W(j.layout_symbol[`icon-pitch-alignment`], `icon-pitch-alignment`),
        "text-pitch-alignment": new W(j.layout_symbol[`text-pitch-alignment`], `text-pitch-alignment`),
        "text-rotation-alignment": new W(j.layout_symbol[`text-rotation-alignment`], `text-rotation-alignment`),
        "text-field": new G(j.layout_symbol[`text-field`], `text-field`),
        "text-font": new G(j.layout_symbol[`text-font`], `text-font`),
        "text-size": new G(j.layout_symbol[`text-size`], `text-size`),
        "text-max-width": new G(j.layout_symbol[`text-max-width`], `text-max-width`),
        "text-line-height": new W(j.layout_symbol[`text-line-height`], `text-line-height`),
        "text-letter-spacing": new G(j.layout_symbol[`text-letter-spacing`], `text-letter-spacing`),
        "text-justify": new G(j.layout_symbol[`text-justify`], `text-justify`),
        "text-radial-offset": new G(j.layout_symbol[`text-radial-offset`], `text-radial-offset`),
        "text-variable-anchor": new W(j.layout_symbol[`text-variable-anchor`], `text-variable-anchor`),
        "text-variable-anchor-offset": new G(j.layout_symbol[`text-variable-anchor-offset`], `text-variable-anchor-offset`),
        "text-anchor": new G(j.layout_symbol[`text-anchor`], `text-anchor`),
        "text-max-angle": new W(j.layout_symbol[`text-max-angle`], `text-max-angle`),
        "text-writing-mode": new W(j.layout_symbol[`text-writing-mode`], `text-writing-mode`),
        "text-rotate": new G(j.layout_symbol[`text-rotate`], `text-rotate`),
        "text-padding": new W(j.layout_symbol[`text-padding`], `text-padding`),
        "text-keep-upright": new W(j.layout_symbol[`text-keep-upright`], `text-keep-upright`),
        "text-transform": new G(j.layout_symbol[`text-transform`], `text-transform`),
        "text-offset": new G(j.layout_symbol[`text-offset`], `text-offset`),
        "text-allow-overlap": new W(j.layout_symbol[`text-allow-overlap`], `text-allow-overlap`),
        "text-overlap": new W(j.layout_symbol[`text-overlap`], `text-overlap`),
        "text-ignore-placement": new W(j.layout_symbol[`text-ignore-placement`], `text-ignore-placement`),
        "text-optional": new W(j.layout_symbol[`text-optional`], `text-optional`)
    });
let M_;
const N_ = ()=>M_ ||= new gl({
        "icon-opacity": new G(j.paint_symbol[`icon-opacity`], `icon-opacity`),
        "icon-color": new G(j.paint_symbol[`icon-color`], `icon-color`),
        "icon-halo-color": new G(j.paint_symbol[`icon-halo-color`], `icon-halo-color`),
        "icon-halo-width": new G(j.paint_symbol[`icon-halo-width`], `icon-halo-width`),
        "icon-halo-blur": new G(j.paint_symbol[`icon-halo-blur`], `icon-halo-blur`),
        "icon-translate": new W(j.paint_symbol[`icon-translate`], `icon-translate`),
        "icon-translate-anchor": new W(j.paint_symbol[`icon-translate-anchor`], `icon-translate-anchor`),
        "text-opacity": new G(j.paint_symbol[`text-opacity`], `text-opacity`),
        "text-color": new G(j.paint_symbol[`text-color`], `text-color`, {
            runtimeType: er,
            getOverride: (e)=>e.textColor,
            hasOverride: (e)=>!!e.textColor
        }),
        "text-halo-color": new G(j.paint_symbol[`text-halo-color`], `text-halo-color`),
        "text-halo-width": new G(j.paint_symbol[`text-halo-width`], `text-halo-width`),
        "text-halo-blur": new G(j.paint_symbol[`text-halo-blur`], `text-halo-blur`),
        "text-translate": new W(j.paint_symbol[`text-translate`], `text-translate`),
        "text-translate-anchor": new W(j.paint_symbol[`text-translate-anchor`], `text-translate-anchor`)
    });
var P_ = {
    get paint () {
        return N_();
    },
    get layout () {
        return j_();
    }
}, F_ = class {
    constructor(e){
        if (e.property.overrides === void 0) throw Error(`overrides must be provided to instantiate FormatSectionOverride class`);
        this.type = e.property.overrides ? e.property.overrides.runtimeType : $n, this.defaultValue = e;
    }
    evaluate(e) {
        if (e.formattedSection) {
            let t = this.defaultValue.property.overrides;
            if (t?.hasOverride(e.formattedSection)) return t.getOverride(e.formattedSection);
        }
        return e.feature && e.featureState ? this.defaultValue.evaluate(e.feature, e.featureState) : this.defaultValue.property.specification.default;
    }
    eachChild(e) {
        if (!this.defaultValue.isConstant()) {
            let t = this.defaultValue.value;
            e(t._styleExpression.expression);
        }
    }
    outputDefined() {
        return !1;
    }
    serialize() {
        return null;
    }
};
H(`FormatSectionOverride`, F_, {
    omit: [
        `defaultValue`
    ]
});
const I_ = (e)=>e.type === `symbol`;
var L_ = class e extends yl {
    constructor(e, t){
        super(e, P_, t);
    }
    recalculate(e, t) {
        if (super.recalculate(e, t), this.layout.get(`icon-rotation-alignment`) === `auto` && (this.layout.get(`symbol-placement`) === `point` ? this.layout._values[`icon-rotation-alignment`] = `viewport` : this.layout._values[`icon-rotation-alignment`] = `map`), this.layout.get(`text-rotation-alignment`) === `auto` && (this.layout.get(`symbol-placement`) === `point` ? this.layout._values[`text-rotation-alignment`] = `viewport` : this.layout._values[`text-rotation-alignment`] = `map`), this.layout.get(`text-pitch-alignment`) === `auto` && (this.layout._values[`text-pitch-alignment`] = this.layout.get(`text-rotation-alignment`) === `map` ? `map` : `viewport`), this.layout.get(`icon-pitch-alignment`) === `auto` && (this.layout._values[`icon-pitch-alignment`] = this.layout.get(`icon-rotation-alignment`)), this.layout.get(`symbol-placement`) === `point`) {
            let e = this.layout.get(`text-writing-mode`);
            if (e) {
                let t = [];
                for (let n of e)t.includes(n) || t.push(n);
                this.layout._values[`text-writing-mode`] = t;
            } else this.layout._values[`text-writing-mode`] = [
                `horizontal`
            ];
        }
        this._setPaintOverrides();
    }
    getValueAndResolveTokens(e, t, n, r) {
        let i = this.layout.get(e).evaluate(t, {}, n, r), a = this._unevaluatedLayout._values[e];
        return !a.isDataDriven() && !Wo(a.value) && i ? k_(t.properties, i) : i;
    }
    createBucket(e) {
        return new O_(e);
    }
    queryRadius() {
        return 0;
    }
    queryIntersectsFeature() {
        throw Error(`Should take a different path in FeatureIndex`);
    }
    _setPaintOverrides() {
        for (let t of P_.paint.overridableProperties){
            if (!e.hasPaintOverride(this.layout, t)) continue;
            let n = this.paint.get(t), r = new Vo(new F_(n), `layers[${this.id}].paint.${n.property.name}`, n.property.specification), i = null;
            i = n.value.kind === `constant` || n.value.kind === `source` ? new Ko(`source`, r) : new qo(`composite`, r, n.value.zoomStops), this.paint._values[t] = new dl(n.property, i, n.parameters);
        }
    }
    _handleOverridablePaintPropertyUpdate(t, n, r) {
        return !this.layout || n.isDataDriven() || r.isDataDriven() ? !1 : e.hasPaintOverride(this.layout, t);
    }
    static hasPaintOverride(e, t) {
        let n = e.get(`text-field`), r = P_.paint.properties[t], i = !1, a = (e)=>{
            for (let t of e)if (r.overrides?.hasOverride(t)) {
                i = !0;
                return;
            }
        };
        if (n.value.kind === `constant` && n.value.value instanceof Jr) a(n.value.value.sections);
        else if (n.value.kind === `source` || n.value.kind === `composite`) {
            let e = (t)=>{
                if (!i) {
                    if (t instanceof oi && ii(t.value) === ar) {
                        let e = t.value;
                        a(e.sections);
                    } else t instanceof Zi ? a(t.sections) : t.eachChild(e);
                }
            }, t = n.value;
            t._styleExpression && e(t._styleExpression.expression);
        }
        return i;
    }
};
function R_(e, t, n, r = 1) {
    let i = e.get(`icon-padding`).evaluate(t, {}, n)?.values;
    return [
        i[0] * r,
        i[1] * r,
        i[2] * r,
        i[3] * r
    ];
}
let z_;
const B_ = ()=>z_ ||= new gl({
        "background-color": new W(j.paint_background[`background-color`], `background-color`),
        "background-pattern": new ml(j.paint_background[`background-pattern`], `background-pattern`),
        "background-opacity": new W(j.paint_background[`background-opacity`], `background-opacity`)
    });
var V_ = {
    get paint () {
        return B_();
    }
};
const H_ = (e)=>e.type === `background`;
var U_ = class extends yl {
    constructor(e, t){
        super(e, V_, t);
    }
};
function W_(e) {
    let t = [], n = e.id;
    return n === void 0 && t.push(new N(`layers.${n}`, null, `missing required property "id"`)), e.render === void 0 && t.push(new N(`layers.${n}`, null, `missing required method "render"`)), e.renderingMode && e.renderingMode !== `2d` && e.renderingMode !== `3d` && t.push(new N(`layers.${n}`, null, `property "renderingMode" must be either "2d" or "3d"`)), t;
}
const G_ = (e)=>e.type === `custom`;
var K_ = class extends yl {
    constructor(e, t){
        super(e, {}, t), this.onAdd = (e)=>{
            this.implementation.onAdd && this.implementation.onAdd(e, e.painter.context.gl);
        }, this.onRemove = (e)=>{
            this.implementation.onRemove && this.implementation.onRemove(e, e.painter.context.gl);
        }, this.implementation = e;
    }
    is3D() {
        return this.implementation.renderingMode === `3d`;
    }
    hasOffscreenPass() {
        return this.implementation.prerender !== void 0;
    }
    recalculate() {}
    updateTransitions() {}
    hasTransition() {
        return !1;
    }
    serialize() {
        throw Error(`Custom layers cannot be serialized`);
    }
};
function q_(e, t) {
    if (e.type === `custom`) return new K_(e, t);
    switch(e.type){
        case `background`:
            return new U_(e, t);
        case `circle`:
            return new Qd(e, t);
        case `color-relief`:
            return new Df(e, t);
        case `fill`:
            return new qp(e, t);
        case `fill-extrusion`:
            return new pm(e, t);
        case `heatmap`:
            return new pf(e, t);
        case `hillshade`:
            return new vf(e, t);
        case `line`:
            return new ig(e, t);
        case `raster`:
            return new wl(e, t);
        case `symbol`:
            return new L_(e, t);
    }
}
var J_ = class {
    constructor(e){
        this._methodToThrottle = e, this._triggered = !1, this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
            this._triggered = !1, this._methodToThrottle();
        };
    }
    trigger() {
        this._triggered || (this._triggered = !0, this._channel?.port1.postMessage(!0));
    }
    remove() {
        delete this._channel, this._methodToThrottle = ()=>{};
    }
};
const Y_ = {
    once: !0
};
var X_ = class {
    constructor(e, t){
        this.target = e, this.mapId = t, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new J_(()=>this.process()), this.subscription = $t(this.target, `message`, (e)=>this.receive(e), !1), this.globalScope = zt(self) ? e : window;
    }
    registerMessageHandler(e, t) {
        this.messageHandlers[e] = t;
    }
    unregisterMessageHandler(e) {
        delete this.messageHandlers[e];
    }
    sendAsync(e, t) {
        return new Promise((n, r)=>{
            let i = Math.round(Math.random() * 0xde0b6b3a7640000).toString(36).substring(0, 10), a = t ? $t(t.signal, `abort`, ()=>{
                a?.unsubscribe(), delete this.resolveRejects[i];
                let n = {
                    id: i,
                    type: `<cancel>`,
                    origin: location.origin,
                    targetMapId: e.targetMapId,
                    sourceMapId: this.mapId
                };
                this.target.postMessage(n), r(new mn(t.signal.reason));
            }, Y_) : null;
            this.resolveRejects[i] = {
                resolve: (e)=>{
                    a?.unsubscribe(), n(e);
                },
                reject: (e)=>{
                    a?.unsubscribe(), r(e);
                }
            };
            let o = [], s = {
                ...e,
                id: i,
                sourceMapId: this.mapId,
                origin: location.origin,
                data: Fc(e.data, o)
            };
            this.target.postMessage(s, {
                transfer: o
            });
        });
    }
    receive(e) {
        let t = e.data, n = t.id, r = [
            `file://`,
            `resource://android`,
            `null`
        ], i = [
            t.origin,
            location.origin
        ], a = t.origin === location.origin, o = i.some((e)=>r.includes(e));
        if (!(!a && !o) && !(t.targetMapId && this.mapId !== t.targetMapId)) {
            if (t.type === `<cancel>`) {
                delete this.tasks[n];
                let e = this.abortControllers[n];
                delete this.abortControllers[n], e && e.abort();
                return;
            }
            if (zt(self) || t.mustQueue) {
                this.tasks[n] = t, this.taskQueue.push(n), this.invoker.trigger();
                return;
            }
            this.processTask(n, t);
        }
    }
    process() {
        if (this.taskQueue.length === 0) return;
        let e = this.taskQueue.shift(), t = this.tasks[e];
        delete this.tasks[e], this.taskQueue.length > 0 && this.invoker.trigger(), t && this.processTask(e, t);
    }
    async processTask(e, t) {
        if (t.type === `<response>`) {
            let n = this.resolveRejects[e];
            if (delete this.resolveRejects[e], !n) return;
            t.error ? n.reject(Qe(Ic(t.error))) : n.resolve(Ic(t.data));
            return;
        }
        if (!this.messageHandlers[t.type]) {
            this.completeTask(e, null, null);
            return;
        }
        let n = Ic(t.data), r = new AbortController;
        this.abortControllers[e] = r;
        try {
            let i = await this.messageHandlers[t.type](t.sourceMapId, n, r);
            this.completeTask(e, null, i);
        } catch (t) {
            this.completeTask(e, Qe(t));
        }
    }
    completeTask(e, t, n) {
        let r = [];
        delete this.abortControllers[e];
        let i = {
            id: e,
            type: `<response>`,
            sourceMapId: this.mapId,
            origin: location.origin,
            error: t ? Fc(t) : null,
            data: Fc(n, r)
        };
        this.target.postMessage(i, {
            transfer: r
        });
    }
    remove() {
        this.invoker.remove(), this.subscription.unsubscribe();
    }
};
const Z_ = 6371008.8;
var Q_ = class e {
    constructor(e, t){
        if (isNaN(e) || isNaN(t)) throw Error(`Invalid LngLat object: (${e}, ${t})`);
        if (this.lng = +e, this.lat = +t, this.lat > 90 || this.lat < -90) throw Error(`Invalid LngLat latitude value: must be between -90 and 90`);
    }
    wrap() {
        return new e(bt(this.lng, -180, 180), this.lat);
    }
    toArray() {
        return [
            this.lng,
            this.lat
        ];
    }
    toString() {
        return `LngLat(${this.lng}, ${this.lat})`;
    }
    distanceTo(e) {
        let t = Math.PI / 180, n = this.lat * t, r = e.lat * t, i = Math.sin(n) * Math.sin(r) + Math.cos(n) * Math.cos(r) * Math.cos((e.lng - this.lng) * t);
        return Z_ * Math.acos(Math.min(i, 1));
    }
    static convert(t) {
        if (t instanceof e) return t;
        if (Array.isArray(t) && (t.length === 2 || t.length === 3)) return new e(Number(t[0]), Number(t[1]));
        if (!Array.isArray(t) && typeof t == `object` && t) return new e(Number(`lng` in t ? t.lng : t.lon), Number(t.lat));
        throw Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
    }
};
const $_ = 2 * Math.PI * Z_;
function ev(e) {
    return $_ * Math.cos(e * Math.PI / 180);
}
function tv(e) {
    return (180 + e) / 360;
}
function nv(e) {
    return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e * Math.PI / 360))) / 360;
}
function rv(e, t) {
    return e / ev(t);
}
function iv(e) {
    return e * 360 - 180;
}
function av(e) {
    let t = 180 - e * 360;
    return 360 / Math.PI * Math.atan(Math.exp(t * Math.PI / 180)) - 90;
}
function ov(e, t) {
    return e * ev(av(t));
}
function sv(e) {
    return 1 / Math.cos(e * Math.PI / 180);
}
var cv = class e {
    constructor(e, t, n = 0){
        this.x = +e, this.y = +t, this.z = +n;
    }
    static fromLngLat(t, n = 0) {
        let r = Q_.convert(t);
        return new e(tv(r.lng), nv(r.lat), rv(n, r.lat));
    }
    toLngLat() {
        return new Q_(iv(this.x), av(this.y));
    }
    toAltitude() {
        return ov(this.z, this.y);
    }
    meterInMercatorCoordinateUnits() {
        return 1 / $_ * sv(av(this.y));
    }
};
function lv(e, t, n) {
    return !(e < 0 || e > 25 || n < 0 || n >= 2 ** e || t < 0 || t >= 2 ** e);
}
function uv(e, t) {
    let { x: n, y: r } = cv.fromLngLat(t);
    return !(e < 0 || e > 25 || r < 0 || r >= 1 || n < 0 || n >= 1);
}
var dv = class {
    constructor(e, t, n){
        if (!lv(e, t, n)) throw Error(`x=${t}, y=${n}, z=${e} outside of bounds. 0<=x<${2 ** e}, 0<=y<${2 ** e} 0<=z<=25 `);
        this.z = e, this.x = t, this.y = n, this.key = mv(0, e, e, t, n);
    }
    equals(e) {
        return this.z === e.z && this.x === e.x && this.y === e.y;
    }
    url(e, t, n) {
        let r = gv(this.x, this.y, this.z), i = vv(this.z, this.x, this.y);
        return e[(this.x + this.y) % e.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String(n === `tms` ? 2 ** this.z - this.y - 1 : this.y)).replace(/{ratio}/g, t > 1 ? `@2x` : ``).replace(/{quadkey}/g, i).replace(/{bbox-epsg-3857}/g, r);
    }
    isChildOf(e) {
        let t = this.z - e.z;
        return t > 0 && e.x === this.x >> t && e.y === this.y >> t;
    }
    getTilePoint(e) {
        let t = 2 ** this.z;
        return new l((e.x * t - this.x) * Ye, (e.y * t - this.y) * Ye);
    }
    toString() {
        return `${this.z}/${this.x}/${this.y}`;
    }
}, fv = class {
    constructor(e, t){
        this.wrap = e, this.canonical = t, this.key = mv(e, t.z, t.z, t.x, t.y);
    }
}, pv = class e {
    constructor(e, t, n, r, i){
        if (this.terrainRttPosMatrix32f = null, e < n) throw Error(`overscaledZ should be >= z; overscaledZ = ${e}; z = ${n}`);
        this.overscaledZ = e, this.wrap = t, this.canonical = new dv(n, +r, +i), this.key = mv(t, e, n, r, i);
    }
    clone() {
        return new e(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
    }
    equals(e) {
        return this.overscaledZ === e.overscaledZ && this.wrap === e.wrap && this.canonical.equals(e.canonical);
    }
    scaledTo(t) {
        if (t > this.overscaledZ) throw Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
        let n = this.canonical.z - t;
        return t > this.canonical.z ? new e(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new e(t, this.wrap, t, this.canonical.x >> n, this.canonical.y >> n);
    }
    isOverscaled() {
        return this.overscaledZ > this.canonical.z;
    }
    calculateScaledKey(e, t) {
        if (e > this.overscaledZ) throw Error(`targetZ > this.overscaledZ; targetZ = ${e}; overscaledZ = ${this.overscaledZ}`);
        let n = this.canonical.z - e;
        return e > this.canonical.z ? mv(this.wrap * +t, e, this.canonical.z, this.canonical.x, this.canonical.y) : mv(this.wrap * +t, e, e, this.canonical.x >> n, this.canonical.y >> n);
    }
    isChildOf(e) {
        if (e.wrap !== this.wrap || this.overscaledZ - e.overscaledZ <= 0) return !1;
        if (e.overscaledZ === 0) return this.overscaledZ > 0;
        let t = this.canonical.z - e.canonical.z;
        return t < 0 ? !1 : e.canonical.x === this.canonical.x >> t && e.canonical.y === this.canonical.y >> t;
    }
    children(t) {
        if (this.overscaledZ >= t) return [
            new e(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
        ];
        let n = this.canonical.z + 1, r = this.canonical.x * 2, i = this.canonical.y * 2;
        return [
            new e(n, this.wrap, n, r, i),
            new e(n, this.wrap, n, r + 1, i),
            new e(n, this.wrap, n, r, i + 1),
            new e(n, this.wrap, n, r + 1, i + 1)
        ];
    }
    isLessThan(e) {
        return this.wrap < e.wrap ? !0 : this.wrap > e.wrap ? !1 : this.overscaledZ < e.overscaledZ ? !0 : this.overscaledZ > e.overscaledZ ? !1 : this.canonical.x < e.canonical.x ? !0 : this.canonical.x > e.canonical.x ? !1 : this.canonical.y < e.canonical.y;
    }
    wrapped() {
        return new e(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
    }
    unwrapTo(t) {
        return new e(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
    }
    overscaleFactor() {
        return 2 ** (this.overscaledZ - this.canonical.z);
    }
    toUnwrapped() {
        return new fv(this.wrap, this.canonical);
    }
    toString() {
        return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
    }
    getTilePoint(e) {
        return this.canonical.getTilePoint(new cv(e.x - this.wrap, e.y));
    }
    normalizeCoordinates(t, n, r = Ye) {
        if (t >= 0 && t < r && n >= 0 && n < r) return {
            tileID: this,
            x: t,
            y: n
        };
        let i = Math.floor(t / r), a = Math.floor(n / r), o = t - i * r, s = n - a * r, c = this.canonical.z, l = 1 << c, u = this.canonical.y + a;
        if (u < 0 || u >= l) return null;
        let d = this.canonical.x + i, f = this.wrap;
        return d < 0 ? (f -= Math.ceil(-d / l), d = (d % l + l) % l) : d >= l && (f += Math.floor(d / l), d %= l), {
            tileID: new e(this.overscaledZ, f, c, d, u),
            x: o,
            y: s
        };
    }
};
function mv(e, t, n, r, i) {
    e *= 2, e < 0 && (e = e * -1 - 1);
    let a = 1 << n;
    return (a * a * e + a * i + r).toString(36) + n.toString(36) + t.toString(36);
}
const hv = Math.PI * 6378137;
function gv(e, t, n) {
    t = 2 ** n - t - 1;
    let r = _v(e * 256, t * 256, n), i = _v((e + 1) * 256, (t + 1) * 256, n);
    return `${r[0]},${r[1]},${i[0]},${i[1]}`;
}
function _v(e, t, n) {
    let r = 2 * hv / 256 / 2 ** n;
    return [
        e * r - hv,
        t * r - hv
    ];
}
function vv(e, t, n) {
    let r = ``;
    for(let i = e; i > 0; i--){
        let e = 1 << i - 1;
        r += (t & e ? 1 : 0) + (n & e ? 2 : 0);
    }
    return r;
}
function yv(e, t) {
    let n = Math.abs(e.wrap * 2) - +(e.wrap < 0), r = Math.abs(t.wrap * 2) - +(t.wrap < 0);
    return e.overscaledZ - t.overscaledZ || r - n || t.canonical.y - e.canonical.y || t.canonical.x - e.canonical.x;
}
H(`CanonicalTileID`, dv), H(`OverscaledTileID`, pv, {
    omit: [
        `terrainRttPosMatrix32f`
    ]
});
var bv = class e {
    constructor(){
        this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0;
    }
    extend(e) {
        return this.minX = Math.min(this.minX, e.x), this.minY = Math.min(this.minY, e.y), this.maxX = Math.max(this.maxX, e.x), this.maxY = Math.max(this.maxY, e.y), this;
    }
    expandBy(e) {
        return this.minX -= e, this.minY -= e, this.maxX += e, this.maxY += e, (this.minX > this.maxX || this.minY > this.maxY) && (this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0), this;
    }
    shrinkBy(e) {
        return this.expandBy(-e);
    }
    map(t) {
        let n = new e;
        return n.extend(t(new l(this.minX, this.minY))), n.extend(t(new l(this.maxX, this.minY))), n.extend(t(new l(this.minX, this.maxY))), n.extend(t(new l(this.maxX, this.maxY))), n;
    }
    static fromPoints(t) {
        let n = new e;
        for (let e of t)n.extend(e);
        return n;
    }
    contains(e) {
        return e.x >= this.minX && e.x <= this.maxX && e.y >= this.minY && e.y <= this.maxY;
    }
    empty() {
        return this.minX > this.maxX;
    }
    width() {
        return this.maxX - this.minX;
    }
    height() {
        return this.maxY - this.minY;
    }
    covers(e) {
        return !this.empty() && !e.empty() && e.minX >= this.minX && e.maxX <= this.maxX && e.minY >= this.minY && e.maxY <= this.maxY;
    }
    intersects(e) {
        return !this.empty() && !e.empty() && e.minX <= this.maxX && e.maxX >= this.minX && e.minY <= this.maxY && e.maxY >= this.minY;
    }
}, xv = class {
    constructor(e, t){
        this.feature = e, this.type = e.type, this.properties = e.tags ? e.tags : {}, this.extent = t, `id` in e && (typeof e.id == `string` ? this.id = parseInt(e.id, 10) : typeof e.id == `number` && !isNaN(e.id) && (this.id = e.id));
    }
    loadGeometry() {
        let e = [], t = this.feature.type === 1 ? [
            this.feature.geometry
        ] : this.feature.geometry;
        for (let n of t){
            let t = [];
            for (let e of n)t.push(new l(e[0], e[1]));
            e.push(t);
        }
        return e;
    }
};
const Sv = `_geojsonTileLayer`;
var Cv = class {
    constructor(e, t){
        this.layers = {
            [Sv]: this
        }, this.name = Sv, this.version = t ? t.version : 1, this.extent = t ? t.extent : 4096, this.length = e.length, this.features = e;
    }
    feature(e) {
        return new xv(this.features[e], this.extent);
    }
};
function wv(e, t = ``) {
    let n = new Og;
    return Tv(e, n, t), n.finish();
}
function Tv(e, t, n = ``) {
    for(let r in e.layers)t.writeMessage(3, (e, t)=>Ev(e, t, n), e.layers[r]);
}
function Ev(e, t, n = ``) {
    t.writeVarintField(15, e.version || 1), t.writeStringField(1, e.name || ``), t.writeVarintField(5, e.extent || 4096);
    let r = {
        jsonPrefix: n,
        keys: [],
        values: [],
        keycache: {},
        valuecache: {}
    };
    for(let n = 0; n < e.length; n++)r.feature = e.feature(n), t.writeMessage(2, Dv, r);
    let i = r.keys;
    for (let e of i)t.writeStringField(3, e);
    let a = r.values;
    for (let e of a)t.writeMessage(4, Mv, e);
}
function Dv(e, t) {
    if (!e.feature) return;
    let n = e.feature;
    n.id !== void 0 && t.writeVarintField(1, n.id), t.writeMessage(2, Ov, e), t.writeVarintField(3, n.type), t.writeMessage(4, jv, n);
}
function Ov(e, t) {
    for(let n in e.feature?.properties){
        let r = e.feature.properties[n], i = e.keycache[n];
        if (r == null) continue;
        i === void 0 && (e.keys.push(n), i = e.keys.length - 1, e.keycache[n] = i), t.writeVarint(i), typeof r != `string` && typeof r != `boolean` && typeof r != `number` && (r = e.jsonPrefix + JSON.stringify(r));
        let a = typeof r + `:` + r, o = e.valuecache[a];
        o === void 0 && (e.values.push(r), o = e.values.length - 1, e.valuecache[a] = o), t.writeVarint(o);
    }
}
function kv(e, t) {
    return (t << 3) + (e & 7);
}
function Av(e) {
    return e << 1 ^ e >> 31;
}
function jv(e, t) {
    let n = e.loadGeometry(), r = e.type, i = 0, a = 0;
    for (let o of n){
        let n = 1;
        r === 1 && (n = o.length), t.writeVarint(kv(1, n));
        let s = r === 3 ? o.length - 1 : o.length;
        for(let e = 0; e < s; e++){
            e === 1 && r !== 1 && t.writeVarint(kv(2, s - 1));
            let n = o[e].x - i, c = o[e].y - a;
            t.writeVarint(Av(n)), t.writeVarint(Av(c)), i += n, a += c;
        }
        e.type === 3 && t.writeVarint(kv(7, 1));
    }
}
function Mv(e, t) {
    let n = typeof e;
    n === `string` ? t.writeStringField(1, e) : n === `boolean` ? t.writeBooleanField(7, e) : n === `number` && (e % 1 == 0 ? e < 0 ? t.writeSVarintField(6, e) : t.writeVarintField(5, e) : t.writeDoubleField(3, e));
}
var Nv = class {
    constructor(e){
        this._stringToNumber = {}, this._numberToString = [];
        for(let t = 0; t < e.length; t++){
            let n = e[t];
            this._stringToNumber[n] = t, this._numberToString[t] = n;
        }
    }
    encode(e) {
        return this._stringToNumber[e];
    }
    decode(e) {
        if (e >= this._numberToString.length) throw Error(`Out of bounds. Index requested n=${e} can't be >= this._numberToString.length ${this._numberToString.length}`);
        return this._numberToString[e];
    }
}, Pv = class {
    constructor(e, t, n, r, i){
        this.type = `Feature`, this._vectorTileFeature = e, this._x = n, this._y = r, this._z = t;
        for(let t in e.properties)typeof e.properties[t] != `string` || !e.properties[t].startsWith(`__$json__:`) || (e.properties[t] = JSON.parse(e.properties[t].slice(10)));
        this.properties = e.properties, this.id = i;
    }
    projectPoint(e, t, n, r) {
        return [
            (e.x + t) * 360 / r - 180,
            360 / Math.PI * Math.atan(Math.exp((1 - (e.y + n) * 2 / r) * Math.PI)) - 90
        ];
    }
    projectLine(e, t, n, r) {
        return e.map((e)=>this.projectPoint(e, t, n, r));
    }
    get geometry() {
        if (this._geometry) return this._geometry;
        let e = this._vectorTileFeature, t = e.extent * 2 ** this._z, n = e.extent * this._x, r = e.extent * this._y, i = e.loadGeometry();
        switch(e.type){
            case 1:
                {
                    let e = [];
                    for (let t of i)e.push(t[0]);
                    let a = this.projectLine(e, n, r, t);
                    this._geometry = e.length === 1 ? {
                        type: `Point`,
                        coordinates: a[0]
                    } : {
                        type: `MultiPoint`,
                        coordinates: a
                    };
                    break;
                }
            case 2:
                {
                    let e = i.map((e)=>this.projectLine(e, n, r, t));
                    this._geometry = e.length === 1 ? {
                        type: `LineString`,
                        coordinates: e[0]
                    } : {
                        type: `MultiLineString`,
                        coordinates: e
                    };
                    break;
                }
            case 3:
                {
                    let e = Qp(i), a = [];
                    for (let i of e)a.push(i.map((e)=>this.projectLine(e, n, r, t)));
                    this._geometry = a.length === 1 ? {
                        type: `Polygon`,
                        coordinates: a[0]
                    } : {
                        type: `MultiPolygon`,
                        coordinates: a
                    };
                    break;
                }
            default:
                throw Error(`unknown feature type: ${e.type}`);
        }
        return this._geometry;
    }
    set geometry(e) {
        this._geometry = e;
    }
    toJSON() {
        let e = {
            geometry: this.geometry
        };
        for(let t in this)t !== `_geometry` && t !== `_vectorTileFeature` && t !== `_x` && t !== `_y` && t !== `_z` && (e[t] = this[t]);
        return e;
    }
}, Fv = class {
    constructor(e, t, n){
        this._name = e, this.dataBuffer = t, typeof n == `number` ? this._size = n : (this.nullabilityBuffer = n, this._size = n.size());
    }
    getValue(e) {
        return this.nullabilityBuffer && !this.nullabilityBuffer.get(e) ? null : this.getValueFromBuffer(e);
    }
    has(e) {
        return this.nullabilityBuffer?.get(e) || !this.nullabilityBuffer;
    }
    get name() {
        return this._name;
    }
    get size() {
        return this._size;
    }
}, Iv = class extends Fv {
}, Lv = class extends Iv {
    getValueFromBuffer(e) {
        return this.dataBuffer[e];
    }
}, Rv = class extends Iv {
    getValueFromBuffer(e) {
        return this.dataBuffer[e];
    }
}, zv = class extends Fv {
    constructor(e, t, n, r){
        super(e, t, r), this.delta = n;
    }
}, Bv = class extends zv {
    constructor(e, t, n, r){
        super(e, Int32Array.of(t), n, r);
    }
    getValueFromBuffer(e) {
        return this.dataBuffer[0] + e * this.delta;
    }
}, Vv = class extends Fv {
    constructor(e, t, n, r){
        super(e, r ? Int32Array.of(t) : Uint32Array.of(t), n);
    }
    getValueFromBuffer(e) {
        return this.dataBuffer[0];
    }
}, Hv = class {
    constructor(e, t, n, r, i = 4096){
        if (this._name = e, this._geometryVector = t, this._idVector = n, this._propertyVectors = r, this._extent = i, e.length === 0) throw Error(`Missing layer name`);
    }
    get name() {
        return this._name;
    }
    get idVector() {
        return this._idVector;
    }
    get geometryVector() {
        return this._geometryVector;
    }
    get propertyVectors() {
        return this._propertyVectors;
    }
    getPropertyVector(e) {
        return this.propertyVectorsMap ||= new Map(this._propertyVectors.map((e)=>[
                e.name,
                e
            ])), this.propertyVectorsMap.get(e);
    }
    get numFeatures() {
        return this.geometryVector.numGeometries;
    }
    get extent() {
        return this._extent;
    }
    getFeatures() {
        let e = [], t = this.geometryVector.getGeometries();
        for(let n = 0; n < this.numFeatures; n++){
            let r;
            if (this.idVector) {
                let e = this.idVector.getValue(n);
                r = this.containsMaxSafeIntegerValues(this.idVector) && e !== null ? Number(e) : e;
            }
            let i = {
                coordinates: t[n],
                type: this.geometryVector.geometryType(n)
            }, a = {};
            for (let e of this.propertyVectors){
                if (!e) continue;
                let t = e.name, r = e.getValue(n);
                r !== null && (a[t] = r);
            }
            e.push({
                id: r,
                geometry: i,
                properties: a
            });
        }
        return e;
    }
    containsMaxSafeIntegerValues(e) {
        return e instanceof Lv || e instanceof Vv || e instanceof Bv || e instanceof Rv;
    }
};
const Uv = {
    FEATURE: 0,
    VERTEX: 1
}, X = {
    BOOLEAN: 0,
    INT_8: 1,
    UINT_8: 2,
    INT_32: 3,
    UINT_32: 4,
    INT_64: 5,
    UINT_64: 6,
    FLOAT: 7,
    DOUBLE: 8,
    STRING: 9
}, Wv = {
    GEOMETRY: 0,
    STRUCT: 1
}, Gv = {
    ID: 0
};
var Kv = class {
    constructor(e){
        this.value = e;
    }
    get() {
        return this.value;
    }
    set(e) {
        this.value = e;
    }
    increment() {
        return this.value++;
    }
    add(e) {
        this.value += e;
    }
}, Z;
(function(e) {
    e.NONE = `NONE`, e.DELTA = `DELTA`, e.COMPONENTWISE_DELTA = `COMPONENTWISE_DELTA`, e.RLE = `RLE`, e.MORTON = `MORTON`, e.PDE = `PDE`;
})(Z ||= {});
var qv;
(function(e) {
    e.NONE = `NONE`, e.FAST_PFOR = `FAST_PFOR`, e.VARINT = `VARINT`;
})(qv ||= {});
const Jv = new Uint32Array(33);
Jv[0] = 0;
for(let e = 1; e <= 32; e++)Jv[e] = e === 32 ? 4294967295 : 4294967295 >>> 32 - e;
const Yv = Jv, Xv = 65536;
function Zv(e, t) {
    return e - e % t;
}
function Qv(e) {
    return Zv(e + 31, 32);
}
function $v(e) {
    if (!Number.isFinite(e) || e <= 0) return Xv;
    let t = Zv(Math.floor(e), 256);
    return t === 0 ? 256 : t;
}
function ey(e) {
    let t = e >>> 0;
    return ((t & 255) << 24 | (t & 65280) << 8 | t >>> 8 & 65280 | t >>> 24 & 255) >>> 0;
}
function ty(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0;
    n[i++] = a >>> 0 & 3, n[i++] = a >>> 2 & 3, n[i++] = a >>> 4 & 3, n[i++] = a >>> 6 & 3, n[i++] = a >>> 8 & 3, n[i++] = a >>> 10 & 3, n[i++] = a >>> 12 & 3, n[i++] = a >>> 14 & 3, n[i++] = a >>> 16 & 3, n[i++] = a >>> 18 & 3, n[i++] = a >>> 20 & 3, n[i++] = a >>> 22 & 3, n[i++] = a >>> 24 & 3, n[i++] = a >>> 26 & 3, n[i++] = a >>> 28 & 3, n[i++] = a >>> 30 & 3, n[i++] = o >>> 0 & 3, n[i++] = o >>> 2 & 3, n[i++] = o >>> 4 & 3, n[i++] = o >>> 6 & 3, n[i++] = o >>> 8 & 3, n[i++] = o >>> 10 & 3, n[i++] = o >>> 12 & 3, n[i++] = o >>> 14 & 3, n[i++] = o >>> 16 & 3, n[i++] = o >>> 18 & 3, n[i++] = o >>> 20 & 3, n[i++] = o >>> 22 & 3, n[i++] = o >>> 24 & 3, n[i++] = o >>> 26 & 3, n[i++] = o >>> 28 & 3, n[i] = o >>> 30 & 3;
}
function ny(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0;
    n[i++] = a >>> 0 & 7, n[i++] = a >>> 3 & 7, n[i++] = a >>> 6 & 7, n[i++] = a >>> 9 & 7, n[i++] = a >>> 12 & 7, n[i++] = a >>> 15 & 7, n[i++] = a >>> 18 & 7, n[i++] = a >>> 21 & 7, n[i++] = a >>> 24 & 7, n[i++] = a >>> 27 & 7, n[i++] = (a >>> 30 | (o & 1) << 2) & 7, n[i++] = o >>> 1 & 7, n[i++] = o >>> 4 & 7, n[i++] = o >>> 7 & 7, n[i++] = o >>> 10 & 7, n[i++] = o >>> 13 & 7, n[i++] = o >>> 16 & 7, n[i++] = o >>> 19 & 7, n[i++] = o >>> 22 & 7, n[i++] = o >>> 25 & 7, n[i++] = o >>> 28 & 7, n[i++] = (o >>> 31 | (s & 3) << 1) & 7, n[i++] = s >>> 2 & 7, n[i++] = s >>> 5 & 7, n[i++] = s >>> 8 & 7, n[i++] = s >>> 11 & 7, n[i++] = s >>> 14 & 7, n[i++] = s >>> 17 & 7, n[i++] = s >>> 20 & 7, n[i++] = s >>> 23 & 7, n[i++] = s >>> 26 & 7, n[i] = s >>> 29 & 7;
}
function ry(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0;
    n[i++] = a >>> 0 & 15, n[i++] = a >>> 4 & 15, n[i++] = a >>> 8 & 15, n[i++] = a >>> 12 & 15, n[i++] = a >>> 16 & 15, n[i++] = a >>> 20 & 15, n[i++] = a >>> 24 & 15, n[i++] = a >>> 28 & 15, n[i++] = o >>> 0 & 15, n[i++] = o >>> 4 & 15, n[i++] = o >>> 8 & 15, n[i++] = o >>> 12 & 15, n[i++] = o >>> 16 & 15, n[i++] = o >>> 20 & 15, n[i++] = o >>> 24 & 15, n[i++] = o >>> 28 & 15, n[i++] = s >>> 0 & 15, n[i++] = s >>> 4 & 15, n[i++] = s >>> 8 & 15, n[i++] = s >>> 12 & 15, n[i++] = s >>> 16 & 15, n[i++] = s >>> 20 & 15, n[i++] = s >>> 24 & 15, n[i++] = s >>> 28 & 15, n[i++] = c >>> 0 & 15, n[i++] = c >>> 4 & 15, n[i++] = c >>> 8 & 15, n[i++] = c >>> 12 & 15, n[i++] = c >>> 16 & 15, n[i++] = c >>> 20 & 15, n[i++] = c >>> 24 & 15, n[i] = c >>> 28 & 15;
}
function iy(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0, l = e[t + 4] >>> 0;
    n[i++] = a >>> 0 & 31, n[i++] = a >>> 5 & 31, n[i++] = a >>> 10 & 31, n[i++] = a >>> 15 & 31, n[i++] = a >>> 20 & 31, n[i++] = a >>> 25 & 31, n[i++] = (a >>> 30 | (o & 7) << 2) & 31, n[i++] = o >>> 3 & 31, n[i++] = o >>> 8 & 31, n[i++] = o >>> 13 & 31, n[i++] = o >>> 18 & 31, n[i++] = o >>> 23 & 31, n[i++] = (o >>> 28 | (s & 1) << 4) & 31, n[i++] = s >>> 1 & 31, n[i++] = s >>> 6 & 31, n[i++] = s >>> 11 & 31, n[i++] = s >>> 16 & 31, n[i++] = s >>> 21 & 31, n[i++] = s >>> 26 & 31, n[i++] = (s >>> 31 | (c & 15) << 1) & 31, n[i++] = c >>> 4 & 31, n[i++] = c >>> 9 & 31, n[i++] = c >>> 14 & 31, n[i++] = c >>> 19 & 31, n[i++] = c >>> 24 & 31, n[i++] = (c >>> 29 | (l & 3) << 3) & 31, n[i++] = l >>> 2 & 31, n[i++] = l >>> 7 & 31, n[i++] = l >>> 12 & 31, n[i++] = l >>> 17 & 31, n[i++] = l >>> 22 & 31, n[i] = l >>> 27 & 31;
}
function ay(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0, l = e[t + 4] >>> 0, u = e[t + 5] >>> 0;
    n[i++] = a >>> 0 & 63, n[i++] = a >>> 6 & 63, n[i++] = a >>> 12 & 63, n[i++] = a >>> 18 & 63, n[i++] = a >>> 24 & 63, n[i++] = (a >>> 30 | (o & 15) << 2) & 63, n[i++] = o >>> 4 & 63, n[i++] = o >>> 10 & 63, n[i++] = o >>> 16 & 63, n[i++] = o >>> 22 & 63, n[i++] = (o >>> 28 | (s & 3) << 4) & 63, n[i++] = s >>> 2 & 63, n[i++] = s >>> 8 & 63, n[i++] = s >>> 14 & 63, n[i++] = s >>> 20 & 63, n[i++] = s >>> 26 & 63, n[i++] = c >>> 0 & 63, n[i++] = c >>> 6 & 63, n[i++] = c >>> 12 & 63, n[i++] = c >>> 18 & 63, n[i++] = c >>> 24 & 63, n[i++] = (c >>> 30 | (l & 15) << 2) & 63, n[i++] = l >>> 4 & 63, n[i++] = l >>> 10 & 63, n[i++] = l >>> 16 & 63, n[i++] = l >>> 22 & 63, n[i++] = (l >>> 28 | (u & 3) << 4) & 63, n[i++] = u >>> 2 & 63, n[i++] = u >>> 8 & 63, n[i++] = u >>> 14 & 63, n[i++] = u >>> 20 & 63, n[i] = u >>> 26 & 63;
}
function oy(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0, l = e[t + 4] >>> 0, u = e[t + 5] >>> 0, d = e[t + 6] >>> 0;
    n[i++] = a >>> 0 & 127, n[i++] = a >>> 7 & 127, n[i++] = a >>> 14 & 127, n[i++] = a >>> 21 & 127, n[i++] = (a >>> 28 | (o & 7) << 4) & 127, n[i++] = o >>> 3 & 127, n[i++] = o >>> 10 & 127, n[i++] = o >>> 17 & 127, n[i++] = o >>> 24 & 127, n[i++] = (o >>> 31 | (s & 63) << 1) & 127, n[i++] = s >>> 6 & 127, n[i++] = s >>> 13 & 127, n[i++] = s >>> 20 & 127, n[i++] = (s >>> 27 | (c & 3) << 5) & 127, n[i++] = c >>> 2 & 127, n[i++] = c >>> 9 & 127, n[i++] = c >>> 16 & 127, n[i++] = c >>> 23 & 127, n[i++] = (c >>> 30 | (l & 31) << 2) & 127, n[i++] = l >>> 5 & 127, n[i++] = l >>> 12 & 127, n[i++] = l >>> 19 & 127, n[i++] = (l >>> 26 | (u & 1) << 6) & 127, n[i++] = u >>> 1 & 127, n[i++] = u >>> 8 & 127, n[i++] = u >>> 15 & 127, n[i++] = u >>> 22 & 127, n[i++] = (u >>> 29 | (d & 15) << 3) & 127, n[i++] = d >>> 4 & 127, n[i++] = d >>> 11 & 127, n[i++] = d >>> 18 & 127, n[i] = d >>> 25 & 127;
}
function sy(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0, l = e[t + 4] >>> 0, u = e[t + 5] >>> 0, d = e[t + 6] >>> 0, f = e[t + 7] >>> 0;
    n[i++] = a >>> 0 & 255, n[i++] = a >>> 8 & 255, n[i++] = a >>> 16 & 255, n[i++] = a >>> 24 & 255, n[i++] = o >>> 0 & 255, n[i++] = o >>> 8 & 255, n[i++] = o >>> 16 & 255, n[i++] = o >>> 24 & 255, n[i++] = s >>> 0 & 255, n[i++] = s >>> 8 & 255, n[i++] = s >>> 16 & 255, n[i++] = s >>> 24 & 255, n[i++] = c >>> 0 & 255, n[i++] = c >>> 8 & 255, n[i++] = c >>> 16 & 255, n[i++] = c >>> 24 & 255, n[i++] = l >>> 0 & 255, n[i++] = l >>> 8 & 255, n[i++] = l >>> 16 & 255, n[i++] = l >>> 24 & 255, n[i++] = u >>> 0 & 255, n[i++] = u >>> 8 & 255, n[i++] = u >>> 16 & 255, n[i++] = u >>> 24 & 255, n[i++] = d >>> 0 & 255, n[i++] = d >>> 8 & 255, n[i++] = d >>> 16 & 255, n[i++] = d >>> 24 & 255, n[i++] = f >>> 0 & 255, n[i++] = f >>> 8 & 255, n[i++] = f >>> 16 & 255, n[i] = f >>> 24 & 255;
}
function cy(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0, l = e[t + 4] >>> 0, u = e[t + 5] >>> 0, d = e[t + 6] >>> 0, f = e[t + 7] >>> 0, p = e[t + 8] >>> 0;
    n[i++] = a >>> 0 & 511, n[i++] = a >>> 9 & 511, n[i++] = a >>> 18 & 511, n[i++] = (a >>> 27 | (o & 15) << 5) & 511, n[i++] = o >>> 4 & 511, n[i++] = o >>> 13 & 511, n[i++] = o >>> 22 & 511, n[i++] = (o >>> 31 | (s & 255) << 1) & 511, n[i++] = s >>> 8 & 511, n[i++] = s >>> 17 & 511, n[i++] = (s >>> 26 | (c & 7) << 6) & 511, n[i++] = c >>> 3 & 511, n[i++] = c >>> 12 & 511, n[i++] = c >>> 21 & 511, n[i++] = (c >>> 30 | (l & 127) << 2) & 511, n[i++] = l >>> 7 & 511, n[i++] = l >>> 16 & 511, n[i++] = (l >>> 25 | (u & 3) << 7) & 511, n[i++] = u >>> 2 & 511, n[i++] = u >>> 11 & 511, n[i++] = u >>> 20 & 511, n[i++] = (u >>> 29 | (d & 63) << 3) & 511, n[i++] = d >>> 6 & 511, n[i++] = d >>> 15 & 511, n[i++] = (d >>> 24 | (f & 1) << 8) & 511, n[i++] = f >>> 1 & 511, n[i++] = f >>> 10 & 511, n[i++] = f >>> 19 & 511, n[i++] = (f >>> 28 | (p & 31) << 4) & 511, n[i++] = p >>> 5 & 511, n[i++] = p >>> 14 & 511, n[i] = p >>> 23 & 511;
}
function ly(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0, l = e[t + 4] >>> 0, u = e[t + 5] >>> 0, d = e[t + 6] >>> 0, f = e[t + 7] >>> 0, p = e[t + 8] >>> 0, m = e[t + 9] >>> 0;
    n[i++] = a >>> 0 & 1023, n[i++] = a >>> 10 & 1023, n[i++] = a >>> 20 & 1023, n[i++] = (a >>> 30 | (o & 255) << 2) & 1023, n[i++] = o >>> 8 & 1023, n[i++] = o >>> 18 & 1023, n[i++] = (o >>> 28 | (s & 63) << 4) & 1023, n[i++] = s >>> 6 & 1023, n[i++] = s >>> 16 & 1023, n[i++] = (s >>> 26 | (c & 15) << 6) & 1023, n[i++] = c >>> 4 & 1023, n[i++] = c >>> 14 & 1023, n[i++] = (c >>> 24 | (l & 3) << 8) & 1023, n[i++] = l >>> 2 & 1023, n[i++] = l >>> 12 & 1023, n[i++] = l >>> 22 & 1023, n[i++] = u >>> 0 & 1023, n[i++] = u >>> 10 & 1023, n[i++] = u >>> 20 & 1023, n[i++] = (u >>> 30 | (d & 255) << 2) & 1023, n[i++] = d >>> 8 & 1023, n[i++] = d >>> 18 & 1023, n[i++] = (d >>> 28 | (f & 63) << 4) & 1023, n[i++] = f >>> 6 & 1023, n[i++] = f >>> 16 & 1023, n[i++] = (f >>> 26 | (p & 15) << 6) & 1023, n[i++] = p >>> 4 & 1023, n[i++] = p >>> 14 & 1023, n[i++] = (p >>> 24 | (m & 3) << 8) & 1023, n[i++] = m >>> 2 & 1023, n[i++] = m >>> 12 & 1023, n[i] = m >>> 22 & 1023;
}
function uy(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0, l = e[t + 4] >>> 0, u = e[t + 5] >>> 0, d = e[t + 6] >>> 0, f = e[t + 7] >>> 0, p = e[t + 8] >>> 0, m = e[t + 9] >>> 0, h = e[t + 10] >>> 0;
    n[i++] = a >>> 0 & 2047, n[i++] = a >>> 11 & 2047, n[i++] = (a >>> 22 | (o & 1) << 10) & 2047, n[i++] = o >>> 1 & 2047, n[i++] = o >>> 12 & 2047, n[i++] = (o >>> 23 | (s & 3) << 9) & 2047, n[i++] = s >>> 2 & 2047, n[i++] = s >>> 13 & 2047, n[i++] = (s >>> 24 | (c & 7) << 8) & 2047, n[i++] = c >>> 3 & 2047, n[i++] = c >>> 14 & 2047, n[i++] = (c >>> 25 | (l & 15) << 7) & 2047, n[i++] = l >>> 4 & 2047, n[i++] = l >>> 15 & 2047, n[i++] = (l >>> 26 | (u & 31) << 6) & 2047, n[i++] = u >>> 5 & 2047, n[i++] = u >>> 16 & 2047, n[i++] = (u >>> 27 | (d & 63) << 5) & 2047, n[i++] = d >>> 6 & 2047, n[i++] = d >>> 17 & 2047, n[i++] = (d >>> 28 | (f & 127) << 4) & 2047, n[i++] = f >>> 7 & 2047, n[i++] = f >>> 18 & 2047, n[i++] = (f >>> 29 | (p & 255) << 3) & 2047, n[i++] = p >>> 8 & 2047, n[i++] = p >>> 19 & 2047, n[i++] = (p >>> 30 | (m & 511) << 2) & 2047, n[i++] = m >>> 9 & 2047, n[i++] = m >>> 20 & 2047, n[i++] = (m >>> 31 | (h & 1023) << 1) & 2047, n[i++] = h >>> 10 & 2047, n[i] = h >>> 21 & 2047;
}
function dy(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0, l = e[t + 4] >>> 0, u = e[t + 5] >>> 0, d = e[t + 6] >>> 0, f = e[t + 7] >>> 0, p = e[t + 8] >>> 0, m = e[t + 9] >>> 0, h = e[t + 10] >>> 0, g = e[t + 11] >>> 0;
    n[i++] = a >>> 0 & 4095, n[i++] = a >>> 12 & 4095, n[i++] = (a >>> 24 | (o & 15) << 8) & 4095, n[i++] = o >>> 4 & 4095, n[i++] = o >>> 16 & 4095, n[i++] = (o >>> 28 | (s & 255) << 4) & 4095, n[i++] = s >>> 8 & 4095, n[i++] = s >>> 20 & 4095, n[i++] = c >>> 0 & 4095, n[i++] = c >>> 12 & 4095, n[i++] = (c >>> 24 | (l & 15) << 8) & 4095, n[i++] = l >>> 4 & 4095, n[i++] = l >>> 16 & 4095, n[i++] = (l >>> 28 | (u & 255) << 4) & 4095, n[i++] = u >>> 8 & 4095, n[i++] = u >>> 20 & 4095, n[i++] = d >>> 0 & 4095, n[i++] = d >>> 12 & 4095, n[i++] = (d >>> 24 | (f & 15) << 8) & 4095, n[i++] = f >>> 4 & 4095, n[i++] = f >>> 16 & 4095, n[i++] = (f >>> 28 | (p & 255) << 4) & 4095, n[i++] = p >>> 8 & 4095, n[i++] = p >>> 20 & 4095, n[i++] = m >>> 0 & 4095, n[i++] = m >>> 12 & 4095, n[i++] = (m >>> 24 | (h & 15) << 8) & 4095, n[i++] = h >>> 4 & 4095, n[i++] = h >>> 16 & 4095, n[i++] = (h >>> 28 | (g & 255) << 4) & 4095, n[i++] = g >>> 8 & 4095, n[i] = g >>> 20 & 4095;
}
function fy(e, t, n, r) {
    let i = r, a = e[t] >>> 0, o = e[t + 1] >>> 0, s = e[t + 2] >>> 0, c = e[t + 3] >>> 0, l = e[t + 4] >>> 0, u = e[t + 5] >>> 0, d = e[t + 6] >>> 0, f = e[t + 7] >>> 0, p = e[t + 8] >>> 0, m = e[t + 9] >>> 0, h = e[t + 10] >>> 0, g = e[t + 11] >>> 0, _ = e[t + 12] >>> 0, v = e[t + 13] >>> 0, y = e[t + 14] >>> 0, b = e[t + 15] >>> 0;
    n[i++] = a >>> 0 & 65535, n[i++] = a >>> 16 & 65535, n[i++] = o >>> 0 & 65535, n[i++] = o >>> 16 & 65535, n[i++] = s >>> 0 & 65535, n[i++] = s >>> 16 & 65535, n[i++] = c >>> 0 & 65535, n[i++] = c >>> 16 & 65535, n[i++] = l >>> 0 & 65535, n[i++] = l >>> 16 & 65535, n[i++] = u >>> 0 & 65535, n[i++] = u >>> 16 & 65535, n[i++] = d >>> 0 & 65535, n[i++] = d >>> 16 & 65535, n[i++] = f >>> 0 & 65535, n[i++] = f >>> 16 & 65535, n[i++] = p >>> 0 & 65535, n[i++] = p >>> 16 & 65535, n[i++] = m >>> 0 & 65535, n[i++] = m >>> 16 & 65535, n[i++] = h >>> 0 & 65535, n[i++] = h >>> 16 & 65535, n[i++] = g >>> 0 & 65535, n[i++] = g >>> 16 & 65535, n[i++] = _ >>> 0 & 65535, n[i++] = _ >>> 16 & 65535, n[i++] = v >>> 0 & 65535, n[i++] = v >>> 16 & 65535, n[i++] = y >>> 0 & 65535, n[i++] = y >>> 16 & 65535, n[i++] = b >>> 0 & 65535, n[i] = b >>> 16 & 65535;
}
function py(e, t, n, r) {
    let i = r, a = t;
    for(let t = 0; t < 8; t++){
        let t = e[a++] >>> 0;
        n[i++] = t >>> 0 & 1, n[i++] = t >>> 1 & 1, n[i++] = t >>> 2 & 1, n[i++] = t >>> 3 & 1, n[i++] = t >>> 4 & 1, n[i++] = t >>> 5 & 1, n[i++] = t >>> 6 & 1, n[i++] = t >>> 7 & 1, n[i++] = t >>> 8 & 1, n[i++] = t >>> 9 & 1, n[i++] = t >>> 10 & 1, n[i++] = t >>> 11 & 1, n[i++] = t >>> 12 & 1, n[i++] = t >>> 13 & 1, n[i++] = t >>> 14 & 1, n[i++] = t >>> 15 & 1, n[i++] = t >>> 16 & 1, n[i++] = t >>> 17 & 1, n[i++] = t >>> 18 & 1, n[i++] = t >>> 19 & 1, n[i++] = t >>> 20 & 1, n[i++] = t >>> 21 & 1, n[i++] = t >>> 22 & 1, n[i++] = t >>> 23 & 1, n[i++] = t >>> 24 & 1, n[i++] = t >>> 25 & 1, n[i++] = t >>> 26 & 1, n[i++] = t >>> 27 & 1, n[i++] = t >>> 28 & 1, n[i++] = t >>> 29 & 1, n[i++] = t >>> 30 & 1, n[i++] = t >>> 31 & 1;
    }
}
function my(e, t, n, r) {
    let i = r, a = t;
    for(let t = 0; t < 8; t++){
        let t = e[a++] >>> 0, r = e[a++] >>> 0;
        n[i++] = t >>> 0 & 3, n[i++] = t >>> 2 & 3, n[i++] = t >>> 4 & 3, n[i++] = t >>> 6 & 3, n[i++] = t >>> 8 & 3, n[i++] = t >>> 10 & 3, n[i++] = t >>> 12 & 3, n[i++] = t >>> 14 & 3, n[i++] = t >>> 16 & 3, n[i++] = t >>> 18 & 3, n[i++] = t >>> 20 & 3, n[i++] = t >>> 22 & 3, n[i++] = t >>> 24 & 3, n[i++] = t >>> 26 & 3, n[i++] = t >>> 28 & 3, n[i++] = t >>> 30 & 3, n[i++] = r >>> 0 & 3, n[i++] = r >>> 2 & 3, n[i++] = r >>> 4 & 3, n[i++] = r >>> 6 & 3, n[i++] = r >>> 8 & 3, n[i++] = r >>> 10 & 3, n[i++] = r >>> 12 & 3, n[i++] = r >>> 14 & 3, n[i++] = r >>> 16 & 3, n[i++] = r >>> 18 & 3, n[i++] = r >>> 20 & 3, n[i++] = r >>> 22 & 3, n[i++] = r >>> 24 & 3, n[i++] = r >>> 26 & 3, n[i++] = r >>> 28 & 3, n[i++] = r >>> 30 & 3;
    }
}
function hy(e, t, n, r) {
    let i = r, a = t;
    for(let t = 0; t < 8; t++){
        let t = e[a++] >>> 0, r = e[a++] >>> 0, o = e[a++] >>> 0;
        n[i++] = t >>> 0 & 7, n[i++] = t >>> 3 & 7, n[i++] = t >>> 6 & 7, n[i++] = t >>> 9 & 7, n[i++] = t >>> 12 & 7, n[i++] = t >>> 15 & 7, n[i++] = t >>> 18 & 7, n[i++] = t >>> 21 & 7, n[i++] = t >>> 24 & 7, n[i++] = t >>> 27 & 7, n[i++] = (t >>> 30 | (r & 1) << 2) & 7, n[i++] = r >>> 1 & 7, n[i++] = r >>> 4 & 7, n[i++] = r >>> 7 & 7, n[i++] = r >>> 10 & 7, n[i++] = r >>> 13 & 7, n[i++] = r >>> 16 & 7, n[i++] = r >>> 19 & 7, n[i++] = r >>> 22 & 7, n[i++] = r >>> 25 & 7, n[i++] = r >>> 28 & 7, n[i++] = (r >>> 31 | (o & 3) << 1) & 7, n[i++] = o >>> 2 & 7, n[i++] = o >>> 5 & 7, n[i++] = o >>> 8 & 7, n[i++] = o >>> 11 & 7, n[i++] = o >>> 14 & 7, n[i++] = o >>> 17 & 7, n[i++] = o >>> 20 & 7, n[i++] = o >>> 23 & 7, n[i++] = o >>> 26 & 7, n[i++] = o >>> 29 & 7;
    }
}
function gy(e, t, n, r) {
    let i = r, a = t;
    for(let t = 0; t < 8; t++){
        let t = e[a++] >>> 0, r = e[a++] >>> 0, o = e[a++] >>> 0, s = e[a++] >>> 0;
        n[i++] = t >>> 0 & 15, n[i++] = t >>> 4 & 15, n[i++] = t >>> 8 & 15, n[i++] = t >>> 12 & 15, n[i++] = t >>> 16 & 15, n[i++] = t >>> 20 & 15, n[i++] = t >>> 24 & 15, n[i++] = t >>> 28 & 15, n[i++] = r >>> 0 & 15, n[i++] = r >>> 4 & 15, n[i++] = r >>> 8 & 15, n[i++] = r >>> 12 & 15, n[i++] = r >>> 16 & 15, n[i++] = r >>> 20 & 15, n[i++] = r >>> 24 & 15, n[i++] = r >>> 28 & 15, n[i++] = o >>> 0 & 15, n[i++] = o >>> 4 & 15, n[i++] = o >>> 8 & 15, n[i++] = o >>> 12 & 15, n[i++] = o >>> 16 & 15, n[i++] = o >>> 20 & 15, n[i++] = o >>> 24 & 15, n[i++] = o >>> 28 & 15, n[i++] = s >>> 0 & 15, n[i++] = s >>> 4 & 15, n[i++] = s >>> 8 & 15, n[i++] = s >>> 12 & 15, n[i++] = s >>> 16 & 15, n[i++] = s >>> 20 & 15, n[i++] = s >>> 24 & 15, n[i++] = s >>> 28 & 15;
    }
}
function _y(e, t, n, r) {
    let i = r, a = t;
    for(let t = 0; t < 8; t++){
        let t = e[a++] >>> 0, r = e[a++] >>> 0, o = e[a++] >>> 0, s = e[a++] >>> 0, c = e[a++] >>> 0;
        n[i++] = t >>> 0 & 31, n[i++] = t >>> 5 & 31, n[i++] = t >>> 10 & 31, n[i++] = t >>> 15 & 31, n[i++] = t >>> 20 & 31, n[i++] = t >>> 25 & 31, n[i++] = (t >>> 30 | (r & 7) << 2) & 31, n[i++] = r >>> 3 & 31, n[i++] = r >>> 8 & 31, n[i++] = r >>> 13 & 31, n[i++] = r >>> 18 & 31, n[i++] = r >>> 23 & 31, n[i++] = (r >>> 28 | (o & 1) << 4) & 31, n[i++] = o >>> 1 & 31, n[i++] = o >>> 6 & 31, n[i++] = o >>> 11 & 31, n[i++] = o >>> 16 & 31, n[i++] = o >>> 21 & 31, n[i++] = o >>> 26 & 31, n[i++] = (o >>> 31 | (s & 15) << 1) & 31, n[i++] = s >>> 4 & 31, n[i++] = s >>> 9 & 31, n[i++] = s >>> 14 & 31, n[i++] = s >>> 19 & 31, n[i++] = s >>> 24 & 31, n[i++] = (s >>> 29 | (c & 3) << 3) & 31, n[i++] = c >>> 2 & 31, n[i++] = c >>> 7 & 31, n[i++] = c >>> 12 & 31, n[i++] = c >>> 17 & 31, n[i++] = c >>> 22 & 31, n[i++] = c >>> 27 & 31;
    }
}
function vy(e, t, n, r) {
    let i = r, a = t;
    for(let t = 0; t < 8; t++){
        let t = e[a++] >>> 0, r = e[a++] >>> 0, o = e[a++] >>> 0, s = e[a++] >>> 0, c = e[a++] >>> 0, l = e[a++] >>> 0;
        n[i++] = t >>> 0 & 63, n[i++] = t >>> 6 & 63, n[i++] = t >>> 12 & 63, n[i++] = t >>> 18 & 63, n[i++] = t >>> 24 & 63, n[i++] = (t >>> 30 | (r & 15) << 2) & 63, n[i++] = r >>> 4 & 63, n[i++] = r >>> 10 & 63, n[i++] = r >>> 16 & 63, n[i++] = r >>> 22 & 63, n[i++] = (r >>> 28 | (o & 3) << 4) & 63, n[i++] = o >>> 2 & 63, n[i++] = o >>> 8 & 63, n[i++] = o >>> 14 & 63, n[i++] = o >>> 20 & 63, n[i++] = o >>> 26 & 63, n[i++] = s >>> 0 & 63, n[i++] = s >>> 6 & 63, n[i++] = s >>> 12 & 63, n[i++] = s >>> 18 & 63, n[i++] = s >>> 24 & 63, n[i++] = (s >>> 30 | (c & 15) << 2) & 63, n[i++] = c >>> 4 & 63, n[i++] = c >>> 10 & 63, n[i++] = c >>> 16 & 63, n[i++] = c >>> 22 & 63, n[i++] = (c >>> 28 | (l & 3) << 4) & 63, n[i++] = l >>> 2 & 63, n[i++] = l >>> 8 & 63, n[i++] = l >>> 14 & 63, n[i++] = l >>> 20 & 63, n[i++] = l >>> 26 & 63;
    }
}
function yy(e, t, n, r) {
    let i = r, a = t;
    for(let t = 0; t < 8; t++){
        let t = e[a++] >>> 0, r = e[a++] >>> 0, o = e[a++] >>> 0, s = e[a++] >>> 0, c = e[a++] >>> 0, l = e[a++] >>> 0, u = e[a++] >>> 0;
        n[i++] = t >>> 0 & 127, n[i++] = t >>> 7 & 127, n[i++] = t >>> 14 & 127, n[i++] = t >>> 21 & 127, n[i++] = (t >>> 28 | (r & 7) << 4) & 127, n[i++] = r >>> 3 & 127, n[i++] = r >>> 10 & 127, n[i++] = r >>> 17 & 127, n[i++] = r >>> 24 & 127, n[i++] = (r >>> 31 | (o & 63) << 1) & 127, n[i++] = o >>> 6 & 127, n[i++] = o >>> 13 & 127, n[i++] = o >>> 20 & 127, n[i++] = (o >>> 27 | (s & 3) << 5) & 127, n[i++] = s >>> 2 & 127, n[i++] = s >>> 9 & 127, n[i++] = s >>> 16 & 127, n[i++] = s >>> 23 & 127, n[i++] = (s >>> 30 | (c & 31) << 2) & 127, n[i++] = c >>> 5 & 127, n[i++] = c >>> 12 & 127, n[i++] = c >>> 19 & 127, n[i++] = (c >>> 26 | (l & 1) << 6) & 127, n[i++] = l >>> 1 & 127, n[i++] = l >>> 8 & 127, n[i++] = l >>> 15 & 127, n[i++] = l >>> 22 & 127, n[i++] = (l >>> 29 | (u & 15) << 3) & 127, n[i++] = u >>> 4 & 127, n[i++] = u >>> 11 & 127, n[i++] = u >>> 18 & 127, n[i++] = u >>> 25 & 127;
    }
}
function by(e, t, n, r) {
    let i = r, a = t;
    for(let t = 0; t < 8; t++){
        let t = e[a++] >>> 0, r = e[a++] >>> 0, o = e[a++] >>> 0, s = e[a++] >>> 0, c = e[a++] >>> 0, l = e[a++] >>> 0, u = e[a++] >>> 0, d = e[a++] >>> 0;
        n[i++] = t >>> 0 & 255, n[i++] = t >>> 8 & 255, n[i++] = t >>> 16 & 255, n[i++] = t >>> 24 & 255, n[i++] = r >>> 0 & 255, n[i++] = r >>> 8 & 255, n[i++] = r >>> 16 & 255, n[i++] = r >>> 24 & 255, n[i++] = o >>> 0 & 255, n[i++] = o >>> 8 & 255, n[i++] = o >>> 16 & 255, n[i++] = o >>> 24 & 255, n[i++] = s >>> 0 & 255, n[i++] = s >>> 8 & 255, n[i++] = s >>> 16 & 255, n[i++] = s >>> 24 & 255, n[i++] = c >>> 0 & 255, n[i++] = c >>> 8 & 255, n[i++] = c >>> 16 & 255, n[i++] = c >>> 24 & 255, n[i++] = l >>> 0 & 255, n[i++] = l >>> 8 & 255, n[i++] = l >>> 16 & 255, n[i++] = l >>> 24 & 255, n[i++] = u >>> 0 & 255, n[i++] = u >>> 8 & 255, n[i++] = u >>> 16 & 255, n[i++] = u >>> 24 & 255, n[i++] = d >>> 0 & 255, n[i++] = d >>> 8 & 255, n[i++] = d >>> 16 & 255, n[i++] = d >>> 24 & 255;
    }
}
function xy(e, t, n, r) {
    let i = r, a = t;
    for(let t = 0; t < 128; t++){
        let t = e[a++] >>> 0;
        n[i++] = t & 65535, n[i++] = t >>> 16 & 65535;
    }
}
function Sy(e, t, n, r, i) {
    let a = Yv[i] >>> 0, o = t, s = 0, c = e[o] >>> 0, l = r;
    for(let t = 0; t < 8; t++){
        for(let t = 0; t < 32; t++)if (s + i <= 32) {
            let r = c >>> s & a;
            n[l + t] = r | 0, s += i, s === 32 && (s = 0, o++, t !== 31 && (c = e[o] >>> 0));
        } else {
            let r = 32 - s, u = c >>> s;
            o++, c = e[o] >>> 0;
            let d = i - r, f = -1 >>> 32 - d >>> 0, p = (u | (c & f) << r) & a;
            n[l + t] = p | 0, s = d;
        }
        l += 32, s = 0, t < 7 && (c = e[o] >>> 0);
    }
}
const Cy = $v(Xv), wy = 3 * Cy / 256 + Cy | 0;
function Ty() {
    let e = new Uint8Array(wy);
    return {
        dataToBePacked: Array(33),
        dataPointers: new Int32Array(33),
        byteContainer: e,
        byteContainerI32: new Int32Array(e.buffer, e.byteOffset, e.byteLength >>> 2),
        exceptionSizes: new Int32Array(33)
    };
}
function Ey(e = 16) {
    if (e < 0) throw RangeError(`initialEncodedWordCapacity must be >= 0, got ${e}`);
    let t = Math.max(16, e | 0);
    return {
        encodedWords: new Uint32Array(t),
        decoderWorkspace: Ty()
    };
}
function Dy(e, t) {
    if (t <= e.encodedWords.length) return e.encodedWords;
    let n = new Uint32Array(Math.max(16, t * 2));
    return e.encodedWords = n, n;
}
function Oy(e, t, n, r) {
    r.byteContainer.length < n && (r.byteContainer = new Uint8Array(n * 2), r.byteContainerI32 = void 0);
    let i = r.byteContainer, a = n >>> 2;
    if (i.byteOffset & 3) for(let n = 0; n < a; n = n + 1 | 0){
        let r = e[t + n | 0] | 0, a = n << 2;
        i[a] = r & 255, i[a + 1 | 0] = r >>> 8 & 255, i[a + 2 | 0] = r >>> 16 & 255, i[a + 3 | 0] = r >>> 24 & 255;
    }
    else {
        let n = r.byteContainerI32;
        (!n || n.buffer !== i.buffer || n.byteOffset !== i.byteOffset || n.length < a) && (n = r.byteContainerI32 = new Int32Array(i.buffer, i.byteOffset, i.byteLength >>> 2)), n.set(e.subarray(t, t + a));
    }
    let o = n & 3;
    if (o > 0) {
        let n = e[t + a | 0] | 0, r = a << 2;
        for(let e = 0; e < o; e = e + 1 | 0)i[r + e | 0] = n >>> (e << 3) & 255;
    }
    return i;
}
function ky(e, t, n) {
    let r = e[t++] | 0, i = n.dataToBePacked;
    for(let a = 2; a <= 32; a = a + 1 | 0){
        if (!(r >>> a - 1 & 1)) continue;
        if (t >= e.length) throw Error(`FastPFOR decode: truncated exception stream header (bitWidth=${a}, streamWordIndex=${t}, needWords=1, availableWords=${e.length - t}, encodedWords=${e.length})`);
        let o = e[t++] >>> 0, s = Qv(o), c = o * a + 31 >>> 5;
        if (t + c > e.length) throw Error(`FastPFOR decode: truncated exception stream (bitWidth=${a}, size=${o}, streamWordIndex=${t}, needWords=${c}, availableWords=${e.length - t}, encodedWords=${e.length})`);
        let l = i[a];
        (!l || l.length < s) && (l = i[a] = new Uint32Array(s));
        let u = 0;
        for(; u < o; u = u + 32 | 0)zy(e, t, l, u, a), t = t + a | 0;
        let d = u - o | 0;
        t = t - (d * a >>> 5) | 0, n.exceptionSizes[a] = o;
    }
    return t;
}
function Ay(e, t, n, r, i) {
    switch(i){
        case 1:
            py(e, t, n, r);
            break;
        case 2:
            my(e, t, n, r);
            break;
        case 3:
            hy(e, t, n, r);
            break;
        case 4:
            gy(e, t, n, r);
            break;
        case 5:
            _y(e, t, n, r);
            break;
        case 6:
            vy(e, t, n, r);
            break;
        case 7:
            yy(e, t, n, r);
            break;
        case 8:
            by(e, t, n, r);
            break;
        case 16:
            xy(e, t, n, r);
            break;
        default:
            Sy(e, t, n, r, i);
            break;
    }
    return t + (i << 3) | 0;
}
function jy(e, t, n, r) {
    if (n + 2 > t) throw Error(`FastPFOR decode: byteContainer underflow at block=${r} (need 2 bytes for [bitWidth, exceptionCount], bytePos=${n}, byteSize=${t})`);
    let i = e[n++], a = e[n++];
    if (i > 32) throw Error(`FastPFOR decode: invalid bitWidth=${i} at block=${r} (expected 0..32). This likely indicates corrupted or truncated input.`);
    return {
        bitWidth: i,
        exceptionCount: a,
        bytePosIn: n
    };
}
function My(e, t, n, r, i, a) {
    if (n + 1 > t) throw Error(`FastPFOR decode: exception header underflow at block=${a} (need 1 byte for maxBits, bytePos=${n}, byteSize=${t})`);
    let o = e[n++];
    if (o < r || o > 32) throw Error(`FastPFOR decode: invalid maxBits=${o} at block=${a} (bitWidth=${r}, expected ${r}..32)`);
    let s = o - r | 0;
    if (s < 1 || s > 32) throw Error(`FastPFOR decode: invalid exceptionBitWidth=${s} at block=${a} (bitWidth=${r}, maxBits=${o})`);
    if (n + i > t) throw Error(`FastPFOR decode: exception positions underflow at block=${a} (need=${i}, have=${t - n})`);
    return {
        maxBits: o,
        exceptionBitWidth: s,
        bytePosIn: n
    };
}
function Ny(e, t, n, r, i, a, o, s, c) {
    let { maxBits: l, exceptionBitWidth: u, bytePosIn: d } = My(i, a, o, n, r, c);
    if (o = d, u === 1) {
        let a = 1 << n;
        for(let n = 0; n < r; n = n + 1 | 0){
            let n = i[o++];
            e[n + t | 0] |= a;
        }
        return o;
    }
    let f = s.dataToBePacked[u];
    if (!f) throw Error(`FastPFOR decode: missing exception stream for exceptionBitWidth=${u} (bitWidth=${n}, maxBits=${l}) at block ${c}`);
    let p = s.dataPointers, m = p[u] | 0, h = s.exceptionSizes[u] | 0;
    if (m + r > h) throw Error(`FastPFOR decode: exception stream overflow for exceptionBitWidth=${u} (ptr=${m}, need ${r}, size=${h}) at block ${c}`);
    for(let a = 0; a < r; a = a + 1 | 0){
        let r = i[o++], a = f[m++] | 0;
        e[r + t | 0] |= a << n;
    }
    return p[u] = m, o;
}
function Py(e, t, n, r, i, a, o, s, c, l) {
    let u = n | 0, d = 0;
    for(let t = 0; t < o; t = t + 1 | 0){
        let n = jy(s, c, d, t);
        d = n.bytePosIn;
        let r = n.bitWidth, o = n.exceptionCount, f = a + t * 256 | 0;
        switch(r){
            case 0:
                i.fill(0, f, f + 256);
                break;
            case 32:
                for(let t = 0; t < 256; t = t + 1 | 0)i[f + t | 0] = e[u + t | 0] | 0;
                u = u + 256 | 0;
                break;
            default:
                u = Ay(e, u, i, f, r);
                break;
        }
        o > 0 && (d = Ny(i, f, r, o, s, c, d, l, t));
    }
    if (u !== r) throw Error(`FastPFOR decode: packed region mismatch (pageStart=${t}, packedStart=${n}, consumedPackedEnd=${u}, expectedPackedEnd=${r}, packedWords=${r - n}, encoded.length=${e.length})`);
}
function Fy(e, t, n, r, i, a) {
    let o = n | 0, s = e[o] | 0;
    if (s <= 0 || o + s > e.length - 1) throw Error(`FastPFOR decode: invalid whereMeta=${s} at pageStart=${o} (expected > 0 and pageStart+whereMeta < encoded.length=${e.length})`);
    let c = o + 1 | 0, l = o + s | 0, u = e[l] >>> 0, d = u + 3 >>> 2, f = l + 1, p = f + d;
    if (p >= e.length) throw Error(`FastPFOR decode: invalid byteSize=${u} (metaInts=${d}, pageStart=${o}, packedEnd=${l}, byteContainerStart=${f}) causes bitmapPos=${p} out of bounds (encoded.length=${e.length})`);
    let m = Oy(e, f, u, a), h = u, g = ky(e, p, a);
    return a.dataPointers.fill(0), Py(e, o, c, l, t, r | 0, i / 256 | 0, m, h, a), g;
}
function Iy(e, t, n, r, i, a) {
    let o = r + Zv(i, 256), s = r, c = n;
    for(; s !== o;){
        let n = Math.min(Cy, o - s);
        c = Fy(e, t, c, s, n, a), s = s + n | 0;
    }
    return c;
}
function Ly(e, t, n, r, i, a) {
    if (a === 0) return t;
    let o = 0, s = t, c = t + n, l = i, u = i, d = i + a, f = 0, p = 0;
    for(; s < c && u < d;){
        let t = e[s] >>> o & 255;
        if (o += 8, s += o >>> 5, o &= 31, f |= (t & 127) << p, t & 128) r[u++] = f | 0, f = 0, p = 0;
        else if (p += 7, p > 28) throw Error(`FastPFOR VByte: unterminated value (expected MSB=1 terminator within 5 bytes; shift=${p}, partial=${f}, decoded=${u - l}/${a}, inPos=${s}, inEnd=${c})`);
    }
    if (u !== d) throw Error(`FastPFOR VByte: truncated stream (decoded=${u - l}, expected=${a}, consumedWords=${s - t}/${n}, vbyteStart=${t}, vbyteEnd=${c})`);
    return s;
}
function Ry(e, t, n) {
    let r = 0, i = 0, a = new Uint32Array(t), o = n ?? Ty();
    if (e.length > 0) {
        let t = e[r] | 0;
        if (r = r + 1 | 0, t & 255) throw Error(`FastPFOR decode: invalid alignedLength=${t} (expected multiple of 256)`);
        if (i + t > a.length) throw Error(`FastPFOR decode: output buffer too small (outPos=${i}, alignedLength=${t}, out.length=${a.length})`);
        r = Iy(e, a, r, i, t, o), i = i + t | 0;
    }
    let s = e.length - r | 0, c = t - i | 0;
    return Ly(e, r, s, a, i, c), a;
}
function zy(e, t, n, r, i) {
    switch(i){
        case 2:
            ty(e, t, n, r);
            return;
        case 3:
            ny(e, t, n, r);
            return;
        case 4:
            ry(e, t, n, r);
            return;
        case 5:
            iy(e, t, n, r);
            return;
        case 6:
            ay(e, t, n, r);
            return;
        case 7:
            oy(e, t, n, r);
            return;
        case 8:
            sy(e, t, n, r);
            return;
        case 9:
            cy(e, t, n, r);
            return;
        case 10:
            ly(e, t, n, r);
            return;
        case 11:
            uy(e, t, n, r);
            return;
        case 12:
            dy(e, t, n, r);
            return;
        case 16:
            fy(e, t, n, r);
            return;
        case 32:
            for(let i = 0; i < 32; i = i + 1 | 0)n[r + i | 0] = e[t + i | 0] | 0;
            return;
        default:
            break;
    }
    let a = Yv[i] >>> 0, o = t, s = 0, c = e[o] >>> 0;
    for(let t = 0; t < 32; t++)if (s + i <= 32) {
        let l = c >>> s & a;
        n[r + t] = l | 0, s += i, s === 32 && (s = 0, o++, t !== 31 && (c = e[o] >>> 0));
    } else {
        let l = 32 - s, u = c >>> s;
        o++, c = e[o] >>> 0;
        let d = Yv[i - l] >>> 0, f = (u | (c & d) << l) & a;
        n[r + t] = f | 0, s = i - l;
    }
}
function By(e, t, n, r) {
    if (t < 0 || n < 0 || t + n > e.length) throw RangeError(`decodeBigEndianInt32sInto: out of bounds (offset=${t}, byteLength=${n}, bytes.length=${e.length})`);
    let i = Math.floor(n / 4), a = n % 4 != 0, o = a ? i + 1 : i;
    if (r.length < o) throw RangeError(`decodeBigEndianInt32sInto: out.length=${r.length} < ${o}`);
    if (i > 0) {
        let n = e.byteOffset + t;
        if (n & 3) for(let n = 0; n < i; n++){
            let i = t + n * 4;
            r[n] = e[i] << 24 | e[i + 1] << 16 | e[i + 2] << 8 | e[i + 3] | 0;
        }
        else {
            let t = new Uint32Array(e.buffer, n, i);
            for(let e = 0; e < i; e++)r[e] = ey(t[e]) | 0;
        }
    }
    if (a) {
        let a = t + i * 4, o = n - i * 4, s = 0;
        for(let t = 0; t < o; t++)s |= e[a + t] << 24 - t * 8;
        r[i] = s | 0;
    }
    return o;
}
function Vy(e, t, n) {
    let r = new Uint32Array(n), i = 0, a = t.get();
    for(let t = 0; t < r.length; t++){
        let t = e[a++], n = t & 127;
        if (t < 128) {
            r[i++] = n;
            continue;
        }
        if (t = e[a++], n |= (t & 127) << 7, t < 128) {
            r[i++] = n;
            continue;
        }
        if (t = e[a++], n |= (t & 127) << 14, t < 128) {
            r[i++] = n;
            continue;
        }
        if (t = e[a++], n |= (t & 127) << 21, t < 128) {
            r[i++] = n;
            continue;
        }
        t = e[a++], n |= (t & 15) << 28, r[i++] = n;
    }
    return t.set(a), r;
}
function Hy(e, t, n) {
    let r = new BigUint64Array(n);
    for(let n = 0; n < r.length; n++)r[n] = Uy(e, t);
    return r;
}
function Uy(e, t) {
    let n = 0n, r = 0, i = t.get();
    for(; i < e.length;){
        let t = e[i++];
        if (n |= BigInt(t & 127) << BigInt(r), !(t & 128)) break;
        if (r += 7, r >= 64) throw Error(`Varint too long`);
    }
    return t.set(i), n;
}
function Wy(e, t, n) {
    let r = new Float64Array(n);
    for(let i = 0; i < n; i++)r[i] = Gy(e, t);
    return r;
}
function Gy(e, t) {
    let n, r;
    return r = e[t.get()], t.increment(), n = r & 127, r < 128 || (r = e[t.get()], t.increment(), n |= (r & 127) << 7, r < 128) || (r = e[t.get()], t.increment(), n |= (r & 127) << 14, r < 128) || (r = e[t.get()], t.increment(), n |= (r & 127) << 21, r < 128) ? n : (r = e[t.get()], n |= (r & 15) << 28, Ky(n, e, t));
}
function Ky(e, t, n) {
    let r, i;
    if (i = t[n.get()], n.increment(), r = (i & 112) >> 4, i < 128 || (i = t[n.get()], n.increment(), r |= (i & 127) << 3, i < 128) || (i = t[n.get()], n.increment(), r |= (i & 127) << 10, i < 128) || (i = t[n.get()], n.increment(), r |= (i & 127) << 17, i < 128) || (i = t[n.get()], n.increment(), r |= (i & 127) << 24, i < 128) || (i = t[n.get()], n.increment(), r |= (i & 1) << 31, i < 128)) return r * 4294967296 + (e >>> 0);
    throw Error(`Expected varint not more than 10 bytes`);
}
function qy(e, t, n, r) {
    return Jy(e, t, n, r, Ey(n >>> 2));
}
function Jy(e, t, n, r, i) {
    let a = r.get();
    if (n & 3) throw Error(`FastPFOR: invalid encodedByteLength=${n} at offset=${a} (encodedBytes.length=${e.length}; expected a multiple of 4 bytes for an int32 big-endian word stream)`);
    let o = n >>> 2, s = Dy(i, o);
    By(e, a, n, s);
    let c = Ry(s.subarray(0, o), t, i.decoderWorkspace);
    return r.add(n), c;
}
function Q(e) {
    return e >>> 1 ^ -(e & 1);
}
function Yy(e) {
    return e >> 1n ^ -(e & 1n);
}
function Xy(e) {
    return e % 2 == 1 ? (e + 1) / -2 : e / 2;
}
function Zy(e) {
    let t = new Int32Array(e.length);
    for(let n = 0; n < e.length; n++)t[n] = Q(e[n]);
    return t;
}
function Qy(e) {
    let t = new BigInt64Array(e.length);
    for(let n = 0; n < e.length; n++)t[n] = Yy(e[n]);
    return t;
}
function $y(e) {
    for(let t = 0; t < e.length; t++)e[t] = Xy(e[t]);
}
function eb(e, t, n) {
    if (n === void 0) {
        n = 0;
        for(let r = 0; r < t; r++)n += e[r];
    }
    let r = new Uint32Array(n), i = 0;
    for(let n = 0; n < t; n++){
        let a = e[n], o = e[n + t];
        r.fill(o, i, i + a), i += a;
    }
    return r;
}
function tb(e, t, n) {
    if (n === void 0) {
        n = 0;
        for(let r = 0; r < t; r++)n += Number(e[r]);
    }
    let r = new BigUint64Array(n), i = 0;
    for(let n = 0; n < t; n++){
        let a = Number(e[n]), o = e[n + t];
        r.fill(o, i, i + a), i += a;
    }
    return r;
}
function nb(e, t, n) {
    let r = new Float64Array(n), i = 0;
    for(let n = 0; n < t; n++){
        let a = e[n], o = e[n + t];
        r.fill(o, i, i + a), i += a;
    }
    return r;
}
function rb(e) {
    let t = new Int32Array(e.length);
    t[0] = Q(e[0]);
    let n = e.length / 4 * 4, r = 1;
    if (n >= 4) for(; r < n - 4; r += 4){
        let n = e[r], i = e[r + 1], a = e[r + 2], o = e[r + 3];
        t[r] = Q(n) + t[r - 1], t[r + 1] = Q(i) + t[r], t[r + 2] = Q(a) + t[r + 1], t[r + 3] = Q(o) + t[r + 2];
    }
    for(; r !== e.length; ++r)t[r] = Q(e[r]) + t[r - 1];
    return t;
}
function ib(e) {
    let t = new BigInt64Array(e.length);
    t[0] = Yy(e[0]);
    let n = e.length / 4 * 4, r = 1;
    if (n >= 4) for(; r < n - 4; r += 4){
        let n = e[r], i = e[r + 1], a = e[r + 2], o = e[r + 3];
        t[r] = Yy(n) + t[r - 1], t[r + 1] = Yy(i) + t[r], t[r + 2] = Yy(a) + t[r + 1], t[r + 3] = Yy(o) + t[r + 2];
    }
    for(; r !== t.length; ++r)t[r] = Yy(e[r]) + t[r - 1];
    return t;
}
function ab(e) {
    e[0] = Xy(e[0]);
    let t = e.length / 4 * 4, n = 1;
    if (t >= 4) for(; n < t - 4; n += 4){
        let t = e[n], r = e[n + 1], i = e[n + 2], a = e[n + 3];
        e[n] = Xy(t) + e[n - 1], e[n + 1] = Xy(r) + e[n], e[n + 2] = Xy(i) + e[n + 1], e[n + 3] = Xy(a) + e[n + 2];
    }
    for(; n !== e.length; ++n)e[n] = Xy(e[n]) + e[n - 1];
}
function ob(e, t, n) {
    if (n === void 0) {
        n = 0;
        for(let r = 0; r < t; r++)n += e[r];
    }
    let r = new Int32Array(n), i = 0;
    for(let n = 0; n < t; n++){
        let a = e[n], o = e[n + t];
        o = Q(o), r.fill(o, i, i + a), i += a;
    }
    return r;
}
function sb(e, t, n) {
    if (n === void 0) {
        n = 0;
        for(let r = 0; r < t; r++)n += Number(e[r]);
    }
    let r = new BigInt64Array(n), i = 0;
    for(let n = 0; n < t; n++){
        let a = Number(e[n]), o = e[n + t];
        o = Yy(o), r.fill(o, i, i + a), i += a;
    }
    return r;
}
function cb(e, t, n) {
    let r = new Float64Array(n), i = 0;
    for(let n = 0; n < t; n++){
        let a = e[n], o = e[n + t];
        o = Xy(o), r.fill(o, i, i + a), i += a;
    }
    return r;
}
function lb(e) {
    let t = e.length / 4 * 4, n = 1;
    if (t >= 4) for(let r = e[0]; n < t - 4; n += 4)r = e[n] += r, r = e[n + 1] += r, r = e[n + 2] += r, r = e[n + 3] += r;
    for(; n !== e.length;)e[n] += e[n - 1], ++n;
}
function ub(e) {
    let t = 0;
    for(let n = 0; n < e.length; n++)e[n] += t, t = e[n];
}
function db(e) {
    if (e.length < 2) return new Int32Array(e);
    let t = new Int32Array(e.length);
    t[0] = Q(e[0]), t[1] = Q(e[1]);
    let n = e.length / 4 * 4, r = 2;
    if (n >= 4) for(; r < n - 4; r += 4){
        let n = e[r], i = e[r + 1], a = e[r + 2], o = e[r + 3];
        t[r] = Q(n) + t[r - 2], t[r + 1] = Q(i) + t[r - 1], t[r + 2] = Q(a) + t[r], t[r + 3] = Q(o) + t[r + 1];
    }
    for(; r !== e.length; r += 2)t[r] = Q(e[r]) + t[r - 2], t[r + 1] = Q(e[r + 1]) + t[r - 1];
    return t;
}
function fb(e, t, n, r) {
    if (e.length < 2) return new Int32Array(e);
    let i = new Int32Array(e.length), a = Q(e[0]), o = Q(e[1]);
    i[0] = pb(Math.round(a * t), n, r), i[1] = pb(Math.round(o * t), n, r);
    let s = e.length / 16, c = 2;
    if (s >= 4) for(; c < s - 4; c += 4){
        let s = e[c], l = e[c + 1], u = Q(s) + a, d = Q(l) + o;
        i[c] = pb(Math.round(u * t), n, r), i[c + 1] = pb(Math.round(d * t), n, r);
        let f = e[c + 2], p = e[c + 3];
        a = Q(f) + u, o = Q(p) + d, i[c + 2] = pb(Math.round(a * t), n, r), i[c + 3] = pb(Math.round(o * t), n, r);
    }
    for(; c !== e.length; c += 2)a += Q(e[c]), o += Q(e[c + 1]), i[c] = pb(Math.round(a * t), n, r), i[c + 1] = pb(Math.round(o * t), n, r);
    return i;
}
function pb(e, t, n) {
    return Math.min(n, Math.max(t, e));
}
function mb(e) {
    let t = new Int32Array(e.length + 1);
    t[0] = 0, t[1] = Q(e[0]);
    let n = t[1];
    for(let r = 2; r !== t.length; ++r){
        let i = e[r - 1], a = Q(i);
        n += a, t[r] = t[r - 1] + n;
    }
    return new Uint32Array(t);
}
function hb(e, t, n) {
    let r = new Int32Array(n + 1);
    r[0] = 0;
    let i = 1, a = r[0];
    for(let n = 0; n < t; n++){
        let o = e[n], s = e[n + t];
        s = Q(s);
        for(let e = i; e < i + o; e++)r[e] = s + a, a = r[e];
        i += o;
    }
    return r;
}
function gb(e, t, n) {
    let r = new Uint32Array(n + 1);
    r[0] = 0;
    let i = 1, a = r[0];
    for(let n = 0; n < t; n++){
        let o = e[n], s = e[n + t];
        for(let e = i; e < i + o; e++)r[e] = s + a, a = r[e];
        i += o;
    }
    return r;
}
function _b(e, t, n) {
    let r = new Int32Array(n), i = 0, a = 0;
    for(let n = 0; n < t; n++){
        let o = e[n], s = e[n + t], c = Q(s);
        for(let e = 0; e < o; e++)a += c, r[i++] = a;
    }
    return r;
}
function vb(e, t, n) {
    let r = new BigInt64Array(n), i = 0, a = 0n;
    for(let n = 0; n < t; n++){
        let o = Number(e[n]), s = e[n + t], c = Yy(s);
        for(let e = 0; e < o; e++)a += c, r[i++] = a;
    }
    return r;
}
function yb(e) {
    let t = new Uint32Array(e.length);
    t[0] = Q(e[0]) >>> 0;
    for(let n = 1; n < e.length; n++)t[n] = t[n - 1] + Q(e[n]) >>> 0;
    return t;
}
function bb(e) {
    let t = new BigUint64Array(e.length);
    t[0] = BigInt.asUintN(64, Yy(e[0]));
    for(let n = 1; n < e.length; n++)t[n] = BigInt.asUintN(64, t[n - 1] + Yy(e[n]));
    return t;
}
function xb(e) {
    if (e.length < 2) return new Uint32Array(e);
    let t = new Uint32Array(e.length);
    t[0] = Q(e[0]) >>> 0, t[1] = Q(e[1]) >>> 0;
    for(let n = 2; n < e.length; n += 2)t[n] = t[n - 2] + Q(e[n]) >>> 0, t[n + 1] = t[n - 1] + Q(e[n + 1]) >>> 0;
    return t;
}
function Sb(e, t, n, r) {
    let i = fb(e, t, n, r);
    return new Uint32Array(i);
}
function Cb(e) {
    return e[1];
}
function wb(e) {
    return Q(e[1]);
}
function Tb(e) {
    if (e.length === 2) {
        let t = Q(e[1]);
        return [
            t,
            t
        ];
    }
    return [
        Q(e[2]),
        Q(e[3])
    ];
}
function Eb(e) {
    return e[1];
}
function Db(e) {
    return Yy(e[1]);
}
function Ob(e) {
    if (e.length === 2) {
        let t = Yy(e[1]);
        return [
            t,
            t
        ];
    }
    return [
        Yy(e[2]),
        Yy(e[3])
    ];
}
var kb;
(function(e) {
    e.PRESENT = `PRESENT`, e.DATA = `DATA`, e.OFFSET = `OFFSET`, e.LENGTH = `LENGTH`;
})(kb ||= {});
var Ab;
(function(e) {
    e.NONE = `NONE`, e.SINGLE = `SINGLE`, e.SHARED = `SHARED`, e.VERTEX = `VERTEX`, e.MORTON = `MORTON`, e.FSST = `FSST`;
})(Ab ||= {});
var jb;
(function(e) {
    e.VERTEX = `VERTEX`, e.INDEX = `INDEX`, e.STRING = `STRING`, e.KEY = `KEY`;
})(jb ||= {});
var Mb;
(function(e) {
    e.VAR_BINARY = `VAR_BINARY`, e.GEOMETRIES = `GEOMETRIES`, e.PARTS = `PARTS`, e.RINGS = `RINGS`, e.TRIANGLES = `TRIANGLES`, e.SYMBOL = `SYMBOL`, e.DICTIONARY = `DICTIONARY`;
})(Mb ||= {});
const Nb = [
    kb.PRESENT,
    kb.DATA,
    kb.OFFSET,
    kb.LENGTH
], Pb = [
    Z.NONE,
    Z.DELTA,
    Z.COMPONENTWISE_DELTA,
    Z.RLE,
    Z.MORTON,
    Z.PDE
], Fb = [
    qv.NONE,
    qv.FAST_PFOR,
    qv.VARINT
], Ib = [
    Ab.NONE,
    Ab.SINGLE,
    Ab.SHARED,
    Ab.VERTEX,
    Ab.MORTON,
    Ab.FSST
], Lb = [
    jb.VERTEX,
    jb.INDEX,
    jb.STRING,
    jb.KEY
], Rb = [
    Mb.VAR_BINARY,
    Mb.GEOMETRIES,
    Mb.PARTS,
    Mb.RINGS,
    Mb.TRIANGLES,
    Mb.SYMBOL,
    Mb.DICTIONARY
];
function zb(e, t) {
    let n = Hb(e, t);
    return n.logicalLevelTechnique1 === Z.MORTON ? Bb(n, e, t) : (Z.RLE === n.logicalLevelTechnique1 || Z.RLE === n.logicalLevelTechnique2) && qv.NONE !== n.physicalLevelTechnique ? Vb(n, e, t) : n;
}
function Bb(e, t, n) {
    let r = Vy(t, n, 2);
    return {
        physicalStreamType: e.physicalStreamType,
        logicalStreamType: e.logicalStreamType,
        logicalLevelTechnique1: e.logicalLevelTechnique1,
        logicalLevelTechnique2: e.logicalLevelTechnique2,
        physicalLevelTechnique: e.physicalLevelTechnique,
        numValues: e.numValues,
        byteLength: e.byteLength,
        decompressedCount: e.decompressedCount,
        numBits: r[0],
        coordinateShift: r[1]
    };
}
function Vb(e, t, n) {
    let r = Vy(t, n, 2);
    return {
        physicalStreamType: e.physicalStreamType,
        logicalStreamType: e.logicalStreamType,
        logicalLevelTechnique1: e.logicalLevelTechnique1,
        logicalLevelTechnique2: e.logicalLevelTechnique2,
        physicalLevelTechnique: e.physicalLevelTechnique,
        numValues: e.numValues,
        byteLength: e.byteLength,
        decompressedCount: r[1],
        runs: r[0],
        numRleValues: r[1]
    };
}
function Hb(e, t) {
    let n = e[t.get()], r = Nb[n >> 4], i = {};
    switch(r){
        case kb.DATA:
            i = {
                dictionaryType: Ib[n & 15]
            };
            break;
        case kb.OFFSET:
            i = {
                offsetType: Lb[n & 15]
            };
            break;
        case kb.LENGTH:
            i = {
                lengthType: Rb[n & 15]
            };
            break;
    }
    t.increment();
    let a = e[t.get()], o = Pb[a >> 5], s = Pb[a >> 2 & 7], c = Fb[a & 3];
    t.increment();
    let l = Vy(e, t, 2), u = l[0], d = l[1];
    return {
        physicalStreamType: r,
        logicalStreamType: i,
        logicalLevelTechnique1: o,
        logicalLevelTechnique2: s,
        physicalLevelTechnique: c,
        numValues: u,
        byteLength: d,
        decompressedCount: u
    };
}
var $;
(function(e) {
    e[e.FLAT = 0] = `FLAT`, e[e.CONST = 1] = `CONST`, e[e.SEQUENCE = 2] = `SEQUENCE`, e[e.DICTIONARY = 3] = `DICTIONARY`, e[e.FSST_DICTIONARY = 4] = `FSST_DICTIONARY`;
})($ ||= {});
var Ub = class {
    constructor(e, t){
        this.values = e, this._size = t;
    }
    get(e) {
        let t = Math.floor(e / 8), n = e % 8;
        return (this.values[t] >> n & 1) == 1;
    }
    set(e, t) {
        let n = Math.floor(e / 8), r = e % 8;
        this.values[n] = this.values[n] | +!!t << r;
    }
    getInt(e) {
        let t = Math.floor(e / 8), n = e % 8;
        return this.values[t] >> n & 1;
    }
    size() {
        return this._size;
    }
    getBuffer() {
        return this.values;
    }
};
function Wb(e, t, n) {
    if (!t) return e;
    let r = t.size(), i = e.constructor, a = new i(r), o = 0;
    for(let i = 0; i < r; i++)a[i] = t.get(i) ? e[o++] : n;
    return a;
}
function Gb(e, t, n) {
    if (!n) return e;
    let r = n.size(), i = new Ub(e, t), a = new Ub(new Uint8Array(Math.ceil(r / 8)), r), o = 0;
    for(let e = 0; e < r; e++){
        let t = n.get(e) ? i.get(o++) : !1;
        a.set(e, t);
    }
    return a.getBuffer();
}
function Kb(e, t, n, r, i) {
    return ax(Yb(e, t, n), n, r, i);
}
function qb(e, t, n, r, i) {
    return ox(Yb(e, t, n), n, r, i);
}
function Jb(e, t, n) {
    return ux(Yb(e, t, n), n);
}
function Yb(e, t, n) {
    let r = n.physicalLevelTechnique;
    switch(r){
        case qv.FAST_PFOR:
            return qy(e, n.numValues, n.byteLength, t);
        case qv.VARINT:
            return Vy(e, t, n.numValues);
        case qv.NONE:
            {
                let r = t.get(), i = n.byteLength;
                t.add(i);
                let a = e.subarray(r, t.get());
                return new Uint32Array(a);
            }
        default:
            throw Error(`Specified physicalLevelTechnique ${r} is not supported (yet).`);
    }
}
function Xb(e, t, n) {
    let r = Yb(e, t, n);
    return r.length === 1 ? Q(r[0]) : wb(r);
}
function Zb(e, t, n) {
    let r = Yb(e, t, n);
    return r.length === 1 ? n.logicalLevelTechnique1 === Z.DELTA ? Q(r[0]) : r[0] : Cb(r);
}
function Qb(e, t, n) {
    return Tb(Yb(e, t, n));
}
function $b(e, t, n) {
    return Ob(Hy(e, t, n.numValues));
}
function ex(e, t, n, r) {
    return sx(Hy(e, t, n.numValues), n, r);
}
function tx(e, t, n, r) {
    return cx(Hy(e, t, n.numValues), n, r);
}
function nx(e, t, n) {
    return lx(Wy(e, t, n.numValues), n, !1);
}
function rx(e, t, n) {
    let r = Hy(e, t, n.numValues);
    return r.length === 1 ? Yy(r[0]) : Db(r);
}
function ix(e, t, n) {
    let r = Hy(e, t, n.numValues);
    return r.length === 1 ? n.logicalLevelTechnique1 === Z.DELTA ? Yy(r[0]) : r[0] : Eb(r);
}
function ax(e, t, n, r) {
    let i;
    switch(t.logicalLevelTechnique1){
        case Z.DELTA:
            if (t.logicalLevelTechnique2 === Z.RLE) {
                let n = t;
                if (!r) return _b(e, n.runs, n.numRleValues);
                e = eb(e, n.runs, n.numRleValues), i = rb(e);
            } else i = rb(e);
            break;
        case Z.RLE:
            i = ob(e, t.runs, t.numRleValues);
            break;
        case Z.MORTON:
            lb(e), i = new Int32Array(e);
            break;
        case Z.COMPONENTWISE_DELTA:
            if (n && !r) return fb(e, n.scale, n.min, n.max);
            i = db(e);
            break;
        case Z.NONE:
            i = Zy(e);
            break;
        default:
            throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
    }
    return r ? Wb(i, r, 0) : i;
}
function ox(e, t, n, r) {
    let i;
    switch(t.logicalLevelTechnique1){
        case Z.DELTA:
            if (t.logicalLevelTechnique2 === Z.RLE) {
                let n = t;
                i = yb(eb(e, n.runs, n.numRleValues));
            } else i = yb(e);
            break;
        case Z.RLE:
            i = eb(e, t.runs, t.numRleValues);
            break;
        case Z.MORTON:
            lb(e), i = e;
            break;
        case Z.COMPONENTWISE_DELTA:
            i = n && !r ? Sb(e, n.scale, n.min, n.max) : xb(e);
            break;
        case Z.NONE:
            i = e;
            break;
        default:
            throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
    }
    return r ? Wb(i, r, 0) : i;
}
function sx(e, t, n) {
    let r;
    switch(t.logicalLevelTechnique1){
        case Z.DELTA:
            if (t.logicalLevelTechnique2 === Z.RLE) {
                let i = t;
                if (!n) return vb(e, i.runs, i.numRleValues);
                e = tb(e, i.runs, i.numRleValues), r = ib(e);
            } else r = ib(e);
            break;
        case Z.RLE:
            r = sb(e, t.runs, t.numRleValues);
            break;
        case Z.NONE:
            r = Qy(e);
            break;
        default:
            throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
    }
    return n ? Wb(r, n, 0n) : r;
}
function cx(e, t, n) {
    let r;
    switch(t.logicalLevelTechnique1){
        case Z.DELTA:
            if (t.logicalLevelTechnique2 === Z.RLE) {
                let n = t;
                r = bb(tb(e, n.runs, n.numRleValues));
            } else r = bb(e);
            break;
        case Z.RLE:
            r = tb(e, t.runs, t.numRleValues);
            break;
        case Z.NONE:
            r = e;
            break;
        default:
            throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
    }
    return n ? Wb(r, n, 0n) : r;
}
function lx(e, t, n) {
    switch(t.logicalLevelTechnique1){
        case Z.DELTA:
            if (t.logicalLevelTechnique2 === Z.RLE) {
                let n = t;
                e = nb(e, n.runs, n.numRleValues);
            }
            return ab(e), e;
        case Z.RLE:
            return px(e, t, n);
        case Z.NONE:
            return n && $y(e), e;
        default:
            throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
    }
}
function ux(e, t) {
    if (t.logicalLevelTechnique1 === Z.DELTA && t.logicalLevelTechnique2 === Z.NONE) return mb(e);
    if (t.logicalLevelTechnique1 === Z.RLE && t.logicalLevelTechnique2 === Z.NONE) {
        let n = t;
        return gb(e, n.runs, n.numRleValues);
    }
    if (t.logicalLevelTechnique1 === Z.NONE && t.logicalLevelTechnique2 === Z.NONE) {
        ub(e);
        let n = new Uint32Array(t.numValues + 1);
        return n[0] = 0, n.set(e, 1), n;
    }
    if (t.logicalLevelTechnique1 === Z.DELTA && t.logicalLevelTechnique2 === Z.RLE) {
        let n = t, r = hb(e, n.runs, n.numRleValues);
        return lb(r), new Uint32Array(r);
    }
    throw Error(`Only delta encoding is supported for transforming length to offset streams yet.`);
}
function dx(e, t, n, r, i = `int32`) {
    let a = e.logicalLevelTechnique1;
    if (a === Z.RLE) return e.runs === 1 ? $.CONST : $.FLAT;
    if (a !== Z.DELTA || e.logicalLevelTechnique2 !== Z.RLE) return e.numValues === 1 ? $.CONST : $.FLAT;
    let o = t instanceof Ub ? t.size() : t, s = e;
    if (s.numRleValues !== o) return $.FLAT;
    if (s.runs === 1) return $.SEQUENCE;
    if (s.runs !== 2) return e.numValues === 1 ? $.CONST : $.FLAT;
    let c = r.get();
    if (e.physicalLevelTechnique === qv.VARINT) return fx(n, r, i) ? $.SEQUENCE : e.numValues === 1 ? $.CONST : $.FLAT;
    let l = r.get(), u = new Int32Array(n.buffer, n.byteOffset + l, 4);
    return r.set(c), u[2] === 2 && u[3] === 2 ? $.SEQUENCE : e.numValues === 1 ? $.CONST : $.FLAT;
}
function fx(e, t, n) {
    let r = new Kv(t.get());
    if (n === `int64`) {
        let t = Hy(e, r, 4);
        return t[2] === 2n && t[3] === 2n;
    }
    let i = Vy(e, r, 4);
    return i[2] === 2 && i[3] === 2;
}
function px(e, t, n) {
    return n ? cb(e, t.runs, t.numRleValues) : nb(e, t.runs, t.numRleValues);
}
var mx = class extends Iv {
    getValueFromBuffer(e) {
        return this.dataBuffer[e];
    }
}, hx = class extends zv {
    constructor(e, t, n, r){
        super(e, BigInt64Array.of(t), n, r);
    }
    getValueFromBuffer(e) {
        return this.dataBuffer[0] + BigInt(e) * this.delta;
    }
};
function gx(e, t, n) {
    return {
        x: _x(e, t) - n,
        y: _x(e >> 1, t) - n
    };
}
function _x(e, t) {
    let n = 0;
    for(let r = 0; r < t; r++)n |= (e & 1 << 2 * r) >> r;
    return n;
}
var vx;
(function(e) {
    e[e.POINT = 0] = `POINT`, e[e.LINESTRING = 1] = `LINESTRING`, e[e.POLYGON = 2] = `POLYGON`, e[e.MULTIPOINT = 3] = `MULTIPOINT`, e[e.MULTILINESTRING = 4] = `MULTILINESTRING`, e[e.MULTIPOLYGON = 5] = `MULTIPOLYGON`;
})(vx ||= {});
var yx;
(function(e) {
    e[e.POINT = 0] = `POINT`, e[e.LINESTRING = 1] = `LINESTRING`, e[e.POLYGON = 2] = `POLYGON`;
})(yx ||= {});
var bx;
(function(e) {
    e[e.MORTON = 0] = `MORTON`, e[e.VEC_2 = 1] = `VEC_2`, e[e.VEC_3 = 2] = `VEC_3`;
})(bx ||= {});
function xx(e) {
    let t = Array(e.numGeometries), n = 1, r = 1, i = 1, a = 0, o = 0, s = 0, c = e.mortonSettings, u = e.topologyVector, d = u.geometryOffsets, f = u.partOffsets, p = u.ringOffsets, m = e.vertexOffsets, h = !m || m.length === 0, g = e.containsPolygonGeometry(), _ = e.vertexBuffer;
    for(let u = 0; u < e.numGeometries; u++){
        let v = e.geometryType(u);
        switch(v){
            case vx.POINT:
                {
                    let u, g;
                    if (h) u = _[o++], g = _[o++];
                    else if (e.vertexBufferType === bx.MORTON) {
                        let e = _[m[s++]], t = gx(e, c.numBits, c.coordinateShift);
                        u = t.x, g = t.y;
                    } else {
                        let e = m[s++] * 2;
                        u = _[e], g = _[e + 1];
                    }
                    t[a++] = [
                        [
                            new l(u, g)
                        ]
                    ], d && i++, f && n++, p && r++;
                }
                break;
            case vx.MULTIPOINT:
                {
                    let e = d[i] - d[i - 1];
                    i++;
                    let c = Array(e);
                    if (h) for(let t = 0; t < e; t++){
                        let e = _[o++], n = _[o++];
                        c[t] = new l(e, n);
                    }
                    else for(let t = 0; t < e; t++){
                        let e = m[s++] * 2, n = _[e], r = _[e + 1];
                        c[t] = new l(n, r);
                    }
                    t[a++] = c.map((e)=>[
                            e
                        ]), n += e, r += e;
                }
                break;
            case vx.LINESTRING:
                {
                    let l;
                    g ? (l = p[r] - p[r - 1], r++) : l = f[n] - f[n - 1], n++;
                    let u;
                    h ? (u = Cx(_, o, l, !1), o += l * 2) : (u = Sx(e.vertexBufferType, _, m, s, l, !1, c), s += l), t[a++] = [
                        u
                    ], d && i++;
                }
                break;
            case vx.POLYGON:
                {
                    let l = f[n] - f[n - 1];
                    n++;
                    let u = Array(l - 1), g, v = p[r] - p[r - 1];
                    if (r++, h) {
                        g = Cx(_, o, v, !0), o += v * 2;
                        for(let e = 0; e < u.length; e++)v = p[r] - p[r - 1], r++, u[e] = Cx(_, o, v, !0), o += v * 2;
                    } else {
                        g = Sx(e.vertexBufferType, _, m, s, v, !0, c), s += v;
                        for(let t = 0; t < u.length; t++)v = p[r] - p[r - 1], r++, u[t] = Sx(e.vertexBufferType, _, m, s, v, !0, c), s += v;
                    }
                    t[a++] = [
                        g
                    ].concat(u), d && i++;
                }
                break;
            case vx.MULTILINESTRING:
                {
                    let l = d[i] - d[i - 1];
                    i++;
                    let u = Array(l);
                    for(let t = 0; t < l; t++){
                        let i;
                        g ? (i = p[r] - p[r - 1], r++) : i = f[n] - f[n - 1], n++, h ? (u[t] = Cx(_, o, i, !1), o += i * 2) : (u[t] = Sx(e.vertexBufferType, _, m, s, i, !1, c), s += i);
                    }
                    t[a++] = u;
                }
                break;
            case vx.MULTIPOLYGON:
                {
                    let l = d[i] - d[i - 1];
                    i++;
                    let u = Array(l);
                    for(let t = 0; t < l; t++){
                        let i = f[n] - f[n - 1];
                        n++;
                        let a, l = Array(i - 1), d = p[r] - p[r - 1];
                        r++, h ? (a = Cx(_, o, d, !0), o += d * 2) : (a = Sx(e.vertexBufferType, _, m, s, d, !0, c), s += d);
                        for(let t = 0; t < l.length; t++){
                            let n = p[r] - p[r - 1];
                            r++, h ? (l[t] = Cx(_, o, n, !0), o += n * 2) : (l[t] = Sx(e.vertexBufferType, _, m, s, n, !0, c), s += n);
                        }
                        u[t] = [
                            a
                        ].concat(l);
                    }
                    t[a++] = u.flat();
                }
                break;
            default:
                throw Error(`The specified geometry type (${v}) is currently not supported.`);
        }
    }
    return t;
}
function Sx(e, t, n, r, i, a, o) {
    return e === bx.MORTON ? Tx(t, n, r, i, a, o) : wx(t, n, r, i, a);
}
function Cx(e, t, n, r) {
    let i = Array(r ? n + 1 : n);
    for(let r = 0; r < n * 2; r += 2){
        let n = e[t + r], a = e[t + r + 1];
        i[r / 2] = new l(n, a);
    }
    return r && (i[i.length - 1] = i[0]), i;
}
function wx(e, t, n, r, i) {
    let a = Array(i ? r + 1 : r);
    for(let i = 0; i < r * 2; i += 2){
        let r = t[n + i / 2] * 2, o = e[r], s = e[r + 1];
        a[i / 2] = new l(o, s);
    }
    return i && (a[a.length - 1] = a[0]), a;
}
function Tx(e, t, n, r, i, a) {
    let o = Array(i ? r + 1 : r);
    for(let i = 0; i < r; i++){
        let r = e[t[n + i]], s = gx(r, a.numBits, a.coordinateShift);
        o[i] = new l(s.x, s.y);
    }
    return i && (o[o.length - 1] = o[0]), o;
}
var Ex = class {
    constructor(e, t, n, r, i){
        this._vertexBufferType = e, this._topologyVector = t, this._vertexOffsets = n, this._vertexBuffer = r, this._mortonSettings = i;
    }
    get vertexBufferType() {
        return this._vertexBufferType;
    }
    get topologyVector() {
        return this._topologyVector;
    }
    get vertexOffsets() {
        return this._vertexOffsets;
    }
    get vertexBuffer() {
        return this._vertexBuffer;
    }
    getSimpleEncodedVertex(e) {
        let t = this.vertexOffsets ? this.vertexOffsets[e] * 2 : e * 2;
        return [
            this.vertexBuffer[t],
            this.vertexBuffer[t + 1]
        ];
    }
    getVertex(e) {
        if (this.vertexOffsets && this.mortonSettings) {
            let t = this.vertexOffsets[e], n = this.vertexBuffer[t], r = gx(n, this.mortonSettings.numBits, this.mortonSettings.coordinateShift);
            return [
                r.x,
                r.y
            ];
        }
        let t = this.vertexOffsets ? this.vertexOffsets[e] * 2 : e * 2;
        return [
            this.vertexBuffer[t],
            this.vertexBuffer[t + 1]
        ];
    }
    getGeometries() {
        return xx(this);
    }
    get mortonSettings() {
        return this._mortonSettings;
    }
};
function Dx(e, t, n, r, i) {
    return new kx(e, t, bx.VEC_2, n, r, i);
}
function Ox(e, t, n, r, i, a) {
    return new kx(e, t, bx.MORTON, n, r, i, a);
}
var kx = class extends Ex {
    constructor(e, t, n, r, i, a, o){
        super(n, r, i, a, o), this._numGeometries = e, this._geometryType = t;
    }
    geometryType(e) {
        return this._geometryType;
    }
    get numGeometries() {
        return this._numGeometries;
    }
    containsPolygonGeometry() {
        return this._geometryType === vx.POLYGON || this._geometryType === vx.MULTIPOLYGON;
    }
    containsSingleGeometryType() {
        return !0;
    }
};
function Ax(e, t, n, r) {
    return new Mx(bx.VEC_2, e, t, n, r);
}
function jx(e, t, n, r, i) {
    return new Mx(bx.MORTON, e, t, n, r, i);
}
var Mx = class extends Ex {
    constructor(e, t, n, r, i, a){
        super(e, n, r, i, a), this._geometryTypes = t;
    }
    geometryType(e) {
        return this._geometryTypes[e];
    }
    get numGeometries() {
        return this._geometryTypes.length;
    }
    containsPolygonGeometry() {
        for(let e = 0; e < this.numGeometries; e++)if (this.geometryType(e) === vx.POLYGON || this.geometryType(e) === vx.MULTIPOLYGON) return !0;
        return !1;
    }
    containsSingleGeometryType() {
        return !1;
    }
}, Nx = class {
    constructor(e, t, n, r){
        this._triangleOffsets = e, this._indexBuffer = t, this._vertexBuffer = n, this._topologyVector = r;
    }
    get triangleOffsets() {
        return this._triangleOffsets;
    }
    get indexBuffer() {
        return this._indexBuffer;
    }
    get vertexBuffer() {
        return this._vertexBuffer;
    }
    get topologyVector() {
        return this._topologyVector;
    }
    getGeometries() {
        if (!this._topologyVector) throw Error(`Cannot convert GpuVector to coordinates without topology information`);
        let e = Array(this.numGeometries), t = this._topologyVector, n = t.partOffsets, r = t.ringOffsets, i = t.geometryOffsets, a = 0, o = 1, s = 1, c = 1;
        for(let t = 0; t < this.numGeometries; t++)switch(this.geometryType(t)){
            case vx.POLYGON:
                {
                    let u = n[o] - n[o - 1];
                    o++;
                    let d = [];
                    for(let e = 0; e < u; e++){
                        let e = r[s] - r[s - 1];
                        s++;
                        let t = [];
                        for(let n = 0; n < e; n++){
                            let e = this._vertexBuffer[a++], n = this._vertexBuffer[a++];
                            t.push(new l(e, n));
                        }
                        t.length > 0 && t.push(t[0]), d.push(t);
                    }
                    e[t] = d, i && c++;
                }
                break;
            case vx.MULTIPOLYGON:
                {
                    let u = i[c] - i[c - 1];
                    c++;
                    let d = [];
                    for(let e = 0; e < u; e++){
                        let e = n[o] - n[o - 1];
                        o++;
                        for(let t = 0; t < e; t++){
                            let e = r[s] - r[s - 1];
                            s++;
                            let t = [];
                            for(let n = 0; n < e; n++){
                                let e = this._vertexBuffer[a++], n = this._vertexBuffer[a++];
                                t.push(new l(e, n));
                            }
                            t.length > 0 && t.push(t[0]), d.push(t);
                        }
                    }
                    e[t] = d;
                }
                break;
        }
        return e;
    }
    [Symbol.iterator]() {
        return null;
    }
};
function Px(e, t, n, r, i, a) {
    return new Fx(e, t, n, r, i, a);
}
var Fx = class extends Nx {
    constructor(e, t, n, r, i, a){
        super(n, r, i, a), this._numGeometries = e, this._geometryType = t;
    }
    geometryType(e) {
        return this._geometryType;
    }
    get numGeometries() {
        return this._numGeometries;
    }
    containsSingleGeometryType() {
        return !0;
    }
};
function Ix(e, t, n, r, i) {
    return new Lx(e, t, n, r, i);
}
var Lx = class extends Nx {
    constructor(e, t, n, r, i){
        super(t, n, r, i), this._geometryTypes = e;
    }
    geometryType(e) {
        return this._geometryTypes[e];
    }
    get numGeometries() {
        return this._geometryTypes.length;
    }
    containsSingleGeometryType() {
        return !1;
    }
};
function Rx(e, t, n, r, i) {
    let a = zb(e, n), o = dx(a, r, e, n), s, c, l, u;
    if (o === $.CONST) {
        let o = Zb(e, n, a), d, f, p, m;
        for(let r = 0; r < t - 1; r++){
            let t = zb(e, n);
            switch(t.physicalStreamType){
                case kb.LENGTH:
                    switch(t.logicalStreamType.lengthType){
                        case Mb.GEOMETRIES:
                            d = Jb(e, n, t);
                            break;
                        case Mb.PARTS:
                            f = Jb(e, n, t);
                            break;
                        case Mb.RINGS:
                            p = Jb(e, n, t);
                            break;
                        case Mb.TRIANGLES:
                            m = Jb(e, n, t);
                    }
                    break;
                case kb.OFFSET:
                    switch(t.logicalStreamType.offsetType){
                        case jb.VERTEX:
                            s = qb(e, n, t);
                            break;
                        case jb.INDEX:
                            u = qb(e, n, t);
                            break;
                    }
                    break;
                case kb.DATA:
                    if (Ab.VERTEX === t.logicalStreamType.dictionaryType) c = Kb(e, n, t, i);
                    else {
                        let r = t;
                        l = {
                            numBits: r.numBits,
                            coordinateShift: r.coordinateShift
                        }, c = qb(e, n, t, i);
                    }
                    break;
            }
        }
        return u ? d !== void 0 || f !== void 0 ? Px(r, o, m, u, c, {
            geometryOffsets: d,
            partOffsets: f,
            ringOffsets: p
        }) : Px(r, o, m, u, c) : l === void 0 ? Dx(r, o, {
            geometryOffsets: d,
            partOffsets: f,
            ringOffsets: p
        }, s, c) : Ox(r, o, {
            geometryOffsets: d,
            partOffsets: f,
            ringOffsets: p
        }, s, c, l);
    }
    let d = qb(e, n, a), f, p, m, h;
    for(let r = 0; r < t - 1; r++){
        let t = zb(e, n);
        switch(t.physicalStreamType){
            case kb.LENGTH:
                switch(t.logicalStreamType.lengthType){
                    case Mb.GEOMETRIES:
                        f = qb(e, n, t);
                        break;
                    case Mb.PARTS:
                        p = qb(e, n, t);
                        break;
                    case Mb.RINGS:
                        m = qb(e, n, t);
                        break;
                    case Mb.TRIANGLES:
                        h = Jb(e, n, t);
                }
                break;
            case kb.OFFSET:
                switch(t.logicalStreamType.offsetType){
                    case jb.VERTEX:
                        s = qb(e, n, t);
                        break;
                    case jb.INDEX:
                        u = qb(e, n, t);
                        break;
                }
                break;
            case kb.DATA:
                if (Ab.VERTEX === t.logicalStreamType.dictionaryType) c = Kb(e, n, t, i);
                else {
                    let r = t;
                    l = {
                        numBits: r.numBits,
                        coordinateShift: r.coordinateShift
                    }, c = qb(e, n, t, i);
                }
                break;
        }
    }
    let g, _, v;
    return f ? (g = zx(d, f, 2), p && m ? (_ = Bx(d, g, p, !1), v = Hx(d, g, _, m)) : p && (_ = Vx(d, g, p))) : p && m ? (_ = zx(d, p, 1), v = Bx(d, _, m, !0)) : p && (_ = zx(d, p, 0)), u && !_ ? Ix(d, h, u, c) : u ? Ix(d, h, u, c, {
        geometryOffsets: g,
        partOffsets: _,
        ringOffsets: v
    }) : l === void 0 ? Ax(d, {
        geometryOffsets: g,
        partOffsets: _,
        ringOffsets: v
    }, s, c) : jx(d, {
        geometryOffsets: g,
        partOffsets: _,
        ringOffsets: v
    }, s, c, l);
}
function zx(e, t, n) {
    let r = new Uint32Array(e.length + 1), i = 0;
    r[0] = i;
    let a = 0;
    for(let o = 0; o < e.length; o++)i = r[o + 1] = i + (e[o] > n ? t[a++] : 1);
    return r;
}
function Bx(e, t, n, r) {
    let i = new Uint32Array(t[t.length - 1] + 1), a = 0;
    i[0] = a;
    let o = 1, s = 0;
    for(let c = 0; c < e.length; c++){
        let l = e[c], u = t[c + 1] - t[c];
        if (l === 5 || l === 2 || r && (l === 4 || l === 1)) for(let e = 0; e < u; e++)a = i[o++] = a + n[s++];
        else for(let e = 0; e < u; e++)i[o++] = ++a;
    }
    return i;
}
function Vx(e, t, n) {
    let r = new Uint32Array(t[t.length - 1] + 1), i = 0;
    r[0] = i;
    let a = 1, o = 0;
    for(let s = 0; s < e.length; s++){
        let c = e[s], l = t[s + 1] - t[s];
        if (c === 4 || c === 1) for(let e = 0; e < l; e++)i = r[a++] = i + n[o++];
        else for(let e = 0; e < l; e++)r[a++] = ++i;
    }
    return r;
}
function Hx(e, t, n, r) {
    let i = new Uint32Array(n[n.length - 1] + 1), a = 0;
    i[0] = a;
    let o = 1, s = 1, c = 0;
    for(let l = 0; l < e.length; l++){
        let u = e[l], d = t[l + 1] - t[l];
        if (u !== 0 && u !== 3) for(let e = 0; e < d; e++){
            let e = n[o] - n[o - 1];
            o++;
            for(let t = 0; t < e; t++)a = i[s++] = a + r[c++];
        }
        else for(let e = 0; e < d; e++)i[s++] = ++a, o++;
    }
    return i;
}
var Ux = class extends Fv {
    constructor(e, t, n){
        super(e, t.getBuffer(), n), this.dataVector = t;
    }
    getValueFromBuffer(e) {
        return this.dataVector.get(e);
    }
}, Wx = class extends Iv {
    getValueFromBuffer(e) {
        return this.dataBuffer[e];
    }
}, Gx = class extends Fv {
    constructor(e, t, n, r){
        super(e, r ? BigInt64Array.of(t) : BigUint64Array.of(t), n);
    }
    getValueFromBuffer(e) {
        return this.dataBuffer[0];
    }
};
function Kx(e, t, n) {
    for(let r = 0; r < e; r++){
        let e = zb(t, n);
        n.add(e.byteLength);
    }
}
function qx(e, t, n, r, i) {
    let a = Jx(e, Math.ceil(t / 8), n, r);
    return i ? Gb(a, t, i) : a;
}
function Jx(e, t, n, r) {
    let i = new Uint8Array(t), a = 0, o = r.get() + n;
    for(; a < t && !(r.get() >= o);){
        let n = e[r.increment()];
        if (n <= 127) {
            let o = n + 3, s = e[r.increment()], c = Math.min(a + o, t);
            i.fill(s, a, c), a = c;
        } else {
            let o = 256 - n;
            for(let n = 0; n < o && a < t; n++)i[a++] = e[r.increment()];
        }
    }
    return r.set(o), i;
}
function Yx(e, t, n, r) {
    let i = t.get(), a = i + n * Float32Array.BYTES_PER_ELEMENT, o = new Uint8Array(e.subarray(i, a)).buffer, s = new Float32Array(o);
    return t.set(a), r ? Wb(s, r, 0) : s;
}
function Xx(e, t, n, r) {
    let i = t.get(), a = i + n * Float64Array.BYTES_PER_ELEMENT, o = new Uint8Array(e.subarray(i, a)).buffer, s = new Float64Array(o);
    return t.set(a), r ? Wb(s, r, 0) : s;
}
const Zx = new TextDecoder;
function Qx(e, t, n) {
    return n - t >= 12 ? Zx.decode(e.subarray(t, n)) : $x(e, t, n);
}
function $x(e, t, n) {
    let r = ``, i = t;
    for(; i < n;){
        let t = e[i], a = null, o = t > 239 ? 4 : t > 223 ? 3 : t > 191 ? 2 : 1;
        if (i + o > n) break;
        let s, c, l;
        o === 1 ? t < 128 && (a = t) : o === 2 ? (s = e[i + 1], (s & 192) == 128 && (a = (t & 31) << 6 | s & 63, a <= 127 && (a = null))) : o === 3 ? (s = e[i + 1], c = e[i + 2], (s & 192) == 128 && (c & 192) == 128 && (a = (t & 15) << 12 | (s & 63) << 6 | c & 63, (a <= 2047 || a >= 55296 && a <= 57343) && (a = null))) : o === 4 && (s = e[i + 1], c = e[i + 2], l = e[i + 3], (s & 192) == 128 && (c & 192) == 128 && (l & 192) == 128 && (a = (t & 15) << 18 | (s & 63) << 12 | (c & 63) << 6 | l & 63, (a <= 65535 || a >= 1114112) && (a = null))), a === null ? (a = 65533, o = 1) : a > 65535 && (a -= 65536, r += String.fromCharCode(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), r += String.fromCharCode(a), i += o;
    }
    return r;
}
var eS = class extends Fv {
    constructor(e, t, n, r){
        super(e, n, r), this.offsetBuffer = t;
    }
}, tS = class extends eS {
    constructor(e, t, n, r){
        super(e, t, n, r ?? t.length - 1);
    }
    getValueFromBuffer(e) {
        let t = this.offsetBuffer[e], n = this.offsetBuffer[e + 1];
        return Qx(this.dataBuffer, t, n);
    }
}, nS = class extends eS {
    constructor(e, t, n, r, i){
        super(e, n, r, i ?? t.length), this.indexBuffer = t, this.indexBuffer = t;
    }
    getValueFromBuffer(e) {
        let t = this.indexBuffer[e], n = this.offsetBuffer[t], r = this.offsetBuffer[t + 1];
        return Qx(this.dataBuffer, n, r);
    }
};
function rS(e, t, n) {
    let r = [], i = Array(t.length).fill(0);
    for(let e = 1; e < t.length; e++)i[e] = i[e - 1] + t[e - 1];
    for(let a = 0; a < n.length; a++)if (n[a] === 255) r.push(n[++a]);
    else {
        let o = t[n[a]], s = i[n[a]];
        for(let t = 0; t < o; t++)r.push(e[s + t]);
    }
    return new Uint8Array(r);
}
var iS = class extends eS {
    constructor(e, t, n, r, i, a, o){
        super(e, n, r, o ?? t.length), this.indexBuffer = t, this.symbolOffsetBuffer = i, this.symbolTableBuffer = a;
    }
    getValueFromBuffer(e) {
        this.decodedDictionary ??= (this.symbolLengthBuffer ??= this.offsetToLengthBuffer(this.symbolOffsetBuffer), rS(this.symbolTableBuffer, this.symbolLengthBuffer, this.dataBuffer));
        let t = this.indexBuffer[e], n = this.offsetBuffer[t], r = this.offsetBuffer[t + 1];
        return Qx(this.decodedDictionary, n, r);
    }
    offsetToLengthBuffer(e) {
        let t = new Uint32Array(e.length - 1), n = e[0];
        for(let r = 1; r < e.length; r++){
            let i = e[r];
            t[r - 1] = i - n, n = i;
        }
        return t;
    }
};
function aS(e, t, n, r, i) {
    let a = null, o = null, s = null, c = null, l = null, u = i ?? null, d = null, f = null;
    for(let e = 0; e < r; e++){
        let e = zb(t, n);
        switch(e.physicalStreamType){
            case kb.PRESENT:
                {
                    let r = new Ub(qx(t, e.numValues, e.byteLength, n), e.numValues);
                    u = i ?? r;
                    break;
                }
            case kb.OFFSET:
                o = qb(t, n, e, void 0, u);
                break;
            case kb.LENGTH:
                {
                    let r = Jb(t, n, e);
                    Mb.DICTIONARY === e.logicalStreamType.lengthType ? a = r : Mb.SYMBOL === e.logicalStreamType.lengthType ? c = r : d = r;
                    break;
                }
            case kb.DATA:
                {
                    let r = t.subarray(n.get(), n.get() + e.byteLength);
                    n.add(e.byteLength);
                    let i = e.logicalStreamType.dictionaryType;
                    Ab.FSST === i ? l = r : Ab.SINGLE === i || Ab.SHARED === i ? s = r : Ab.NONE === i && (f = r);
                    break;
                }
        }
    }
    return oS(e, l, o, a, s, c, u) ?? sS(e, s, o, a, u) ?? cS(e, d, f, o, u);
}
function oS(e, t, n, r, i, a, o) {
    return t ? new iS(e, n, r, i, a, t, o) : null;
}
function sS(e, t, n, r, i) {
    return t ? i ? new nS(e, n, r, t, i) : new nS(e, n, r, t) : null;
}
function cS(e, t, n, r, i) {
    if (!t || !n) return null;
    if (r) return i ? new nS(e, r, t, n, i) : new nS(e, r, t, n);
    if (i && i.size() !== t.length - 1) {
        let r = new Uint32Array(i.size()), a = 0;
        for(let e = 0; e < i.size(); e++)i.get(e) ? r[e] = a++ : r[e] = 0;
        return new nS(e, r, t, n, i);
    }
    return i ? new tS(e, t, n, i) : new tS(e, t, n);
}
function lS(e, t, n, r) {
    let i = null, a = null, o = null, s = null, c = !1;
    for(; !c;){
        let n = zb(e, t);
        switch(n.physicalStreamType){
            case kb.LENGTH:
                Mb.DICTIONARY === n.logicalStreamType.lengthType ? i = Jb(e, t, n) : o = Jb(e, t, n);
                break;
            case kb.DATA:
                Ab.SINGLE === n.logicalStreamType.dictionaryType || Ab.SHARED === n.logicalStreamType.dictionaryType ? (a = e.subarray(t.get(), t.get() + n.byteLength), c = !0) : s = e.subarray(t.get(), t.get() + n.byteLength), t.add(n.byteLength);
                break;
        }
    }
    let l = n.complexType.children, u = [], d = 0;
    for (let c of l){
        let l = Vy(e, t, 1)[0];
        if (l === 0) continue;
        let f = c.name ? `${n.name}${c.name}` : n.name;
        if (r && !r.has(f)) {
            Kx(l, e, t);
            continue;
        }
        if (c.type !== `scalarField` || c.scalarField.physicalType !== X.STRING) throw Error(`Currently only scalar string fields are implemented for a struct.`);
        if (l > 1 && !c.nullable || l === 1 && c.nullable) throw Error(`The number of streams for the child field ${c.name} does not match its nullability. nullibilty: ${c.nullable}, numStreams: ${l}`);
        let p;
        if (c.nullable) {
            let n = zb(e, t);
            p = new Ub(qx(e, n.numValues, n.byteLength, t), n.numValues);
        }
        let m = qb(e, t, zb(e, t), void 0, p);
        u[d++] = s ? new iS(f, m, i, a, o, s, p) : new nS(f, m, i, a, p);
    }
    return u;
}
function uS(e, t, n, r, i, a) {
    return n.type === `scalarType` ? a && !a.has(n.name) ? (Kx(r, e, t), null) : dS(r, e, t, i, n.scalarType, n) : r === 0 ? null : lS(e, t, n, a);
}
function dS(e, t, n, r, i, a) {
    let o = null;
    if (e === 0) return null;
    if (a.nullable) {
        let e = zb(t, n), r = e.numValues, i = n.get(), a = qx(t, r, e.byteLength, n);
        n.set(i + e.byteLength), o = new Ub(a, e.numValues);
    }
    let s = o ?? r;
    switch(i.physicalType){
        case X.UINT_32:
        case X.INT_32:
            return gS(t, n, a, i, s);
        case X.STRING:
            {
                let r = a.nullable ? e - 1 : e;
                return aS(a.name, t, n, r, o);
            }
        case X.BOOLEAN:
            return fS(t, n, a, r, s);
        case X.UINT_64:
        case X.INT_64:
            return hS(t, n, a, s, i);
        case X.FLOAT:
            return pS(t, n, a, s);
        case X.DOUBLE:
            return mS(t, n, a, s);
        default:
            throw Error(`The specified data type for the field is currently not supported: ${i}`);
    }
}
function fS(e, t, n, r, i) {
    let a = zb(e, t), o = a.numValues, s = t.get(), c = _S(i) ? i : void 0, l = qx(e, o, a.byteLength, t, c);
    t.set(s + a.byteLength);
    let u = new Ub(l, o);
    return new Ux(n.name, u, i);
}
function pS(e, t, n, r) {
    let i = zb(e, t), a = _S(r) ? r : void 0, o = Yx(e, t, i.numValues, a);
    return new Wx(n.name, o, r);
}
function mS(e, t, n, r) {
    let i = zb(e, t), a = _S(r) ? r : void 0, o = Xx(e, t, i.numValues, a);
    return new Rv(n.name, o, r);
}
function hS(e, t, n, r, i) {
    let a = zb(e, t), o = dx(a, r, e, t, `int64`), s = i.physicalType === X.INT_64;
    if (o === $.FLAT) {
        let i = _S(r) ? r : void 0, o = s ? ex(e, t, a, i) : tx(e, t, a, i);
        return new mx(n.name, o, r);
    }
    if (o === $.SEQUENCE) {
        let r = $b(e, t, a);
        return new hx(n.name, r[0], r[1], a.numRleValues);
    }
    let c = s ? rx(e, t, a) : ix(e, t, a);
    return new Gx(n.name, c, r, s);
}
function gS(e, t, n, r, i) {
    let a = zb(e, t), o = dx(a, i, e, t), s = r.physicalType === X.INT_32;
    if (o === $.FLAT) {
        let r = _S(i) ? i : void 0, o = s ? Kb(e, t, a, void 0, r) : qb(e, t, a, void 0, r);
        return new Lv(n.name, o, i);
    }
    if (o === $.SEQUENCE) {
        let r = Qb(e, t, a);
        return new Bv(n.name, r[0], r[1], a.numRleValues);
    }
    let c = s ? Xb(e, t, a) : Zb(e, t, a);
    return new Vv(n.name, c, i, s);
}
function _S(e) {
    return e instanceof Ub;
}
function vS(e) {
    switch(e){
        case 0:
        case 1:
        case 2:
        case 3:
            {
                let t = {};
                t.nullable = (e & 1) != 0, t.columnScope = Uv.FEATURE;
                let n = {};
                return n.type = `logicalType`, n.logicalType = Gv.ID, n.longID = (e & 2) != 0, t.scalarType = n, t.type = `scalarType`, t;
            }
        case 4:
            {
                let e = {};
                e.nullable = !1, e.columnScope = Uv.FEATURE;
                let t = {};
                return t.type = `physicalType`, t.physicalType = Wv.GEOMETRY, e.type = `complexType`, e.complexType = t, e;
            }
        case 30:
            {
                let e = {};
                e.nullable = !1, e.columnScope = Uv.FEATURE;
                let t = {};
                return t.type = `physicalType`, t.physicalType = Wv.STRUCT, e.type = `complexType`, e.complexType = t, e;
            }
        default:
            return wS(e);
    }
}
function yS(e) {
    return e >= 10;
}
function bS(e) {
    return e === 30;
}
function xS(e) {
    if (e.type === `scalarType`) {
        let t = e.scalarType;
        if (t.type === `physicalType`) switch(t.physicalType){
            case X.BOOLEAN:
            case X.INT_8:
            case X.UINT_8:
            case X.INT_32:
            case X.UINT_32:
            case X.INT_64:
            case X.UINT_64:
            case X.FLOAT:
            case X.DOUBLE:
                return !1;
            case X.STRING:
                return !0;
            default:
                return !1;
        }
        if (t.type === `logicalType`) return !1;
    } else if (e.type === `complexType`) {
        let t = e.complexType;
        if (t.type === `physicalType`) switch(t.physicalType){
            case Wv.GEOMETRY:
            case Wv.STRUCT:
                return !0;
            default:
                return !1;
        }
    }
    return console.warn(`Unexpected column type in hasStreamCount`, e), !1;
}
function SS(e) {
    return e.type === `scalarType` && e.scalarType?.type === `logicalType` && e.scalarType.logicalType === Gv.ID;
}
function CS(e) {
    return e.type === `complexType` && e.complexType?.type === `physicalType` && e.complexType.physicalType === Wv.GEOMETRY;
}
function wS(e) {
    let t;
    switch(e){
        case 10:
        case 11:
            t = X.BOOLEAN;
            break;
        case 12:
        case 13:
            t = X.INT_8;
            break;
        case 14:
        case 15:
            t = X.UINT_8;
            break;
        case 16:
        case 17:
            t = X.INT_32;
            break;
        case 18:
        case 19:
            t = X.UINT_32;
            break;
        case 20:
        case 21:
            t = X.INT_64;
            break;
        case 22:
        case 23:
            t = X.UINT_64;
            break;
        case 24:
        case 25:
            t = X.FLOAT;
            break;
        case 26:
        case 27:
            t = X.DOUBLE;
            break;
        case 28:
        case 29:
            t = X.STRING;
            break;
        default:
            return null;
    }
    let n = {};
    n.nullable = (e & 1) != 0, n.columnScope = Uv.FEATURE;
    let r = {};
    return r.type = `physicalType`, r.physicalType = t, n.type = `scalarType`, n.scalarType = r, n;
}
const TS = new TextDecoder;
function ES(e, t) {
    let n = Vy(e, t, 1)[0];
    if (n === 0) return ``;
    let r = t.get(), i = r + n, a = e.subarray(r, i);
    return t.add(n), TS.decode(a);
}
function DS(e) {
    return {
        name: e.name,
        nullable: e.nullable,
        scalarField: e.scalarType,
        complexField: e.complexType,
        type: e.type === `scalarType` ? `scalarField` : `complexField`
    };
}
function OS(e, t) {
    let n = Vy(e, t, 1)[0] >>> 0;
    if (n < 10 || n > 30) throw Error(`Unsupported field type code ${n}. Supported: 10-29(scalars), 30(STRUCT)`);
    let r = vS(n);
    if (yS(n) && (r.name = ES(e, t)), bS(n)) {
        let n = Vy(e, t, 1)[0] >>> 0;
        r.complexType.children = Array(n);
        for(let i = 0; i < n; i++)r.complexType.children[i] = OS(e, t);
    }
    return DS(r);
}
function kS(e, t) {
    let n = Vy(e, t, 1)[0] >>> 0, r = vS(n);
    if (!r) throw Error(`Unsupported column type code ${n}. Supported: 0-3(ID), 4(GEOMETRY), 10-29(scalars), 30(STRUCT)`);
    if (yS(n) ? r.name = ES(e, t) : n >= 0 && n <= 3 ? r.name = `id` : n === 4 && (r.name = `geometry`), bS(n)) {
        let n = Vy(e, t, 1)[0] >>> 0, i = r.complexType;
        i.children = Array(n);
        for(let r = 0; r < n; r++)i.children[r] = OS(e, t);
    }
    return r;
}
function AS(e, t) {
    let n = {};
    n.featureTables = [];
    let r = {};
    if (r.name = ES(e, t), r.name.length === 0) throw Error(`Missing layer name`);
    let i = Vy(e, t, 1)[0] >>> 0, a = Vy(e, t, 1)[0] >>> 0;
    r.columns = Array(a);
    for(let n = 0; n < a; n++)r.columns[n] = kS(e, t);
    return n.featureTables.push(r), [
        n,
        i
    ];
}
function jS(e, t, n = !0) {
    let r = new Kv(0), i = [];
    for(; r.get() < e.length;){
        let a = Vy(e, r, 1)[0] >>> 0, o = r.get() + a;
        if (o > e.length) throw Error(`Block overruns tile: ${o} > ${e.length}`);
        if (Vy(e, r, 1)[0] >>> 0 != 1) {
            r.set(o);
            continue;
        }
        let [s, c] = AS(e, r), l = s.featureTables[0], u = null, d = null, f = [], p = 0;
        for (let i of l.columns){
            let a = i.name;
            if (SS(i)) {
                let t = null;
                if (i.nullable) {
                    let n = zb(e, r), i = r.get(), a = qx(e, n.numValues, n.byteLength, r);
                    r.set(i + n.byteLength), t = new Ub(a, n.numValues);
                }
                let o = zb(e, r);
                p = t ? t.size() : o.decompressedCount, u = MS(e, i, r, a, o, t ?? p, n);
            } else if (CS(i)) {
                let n = Vy(e, r, 1)[0];
                if (p === 0) {
                    let t = r.get();
                    p = zb(e, r).decompressedCount, r.set(t);
                }
                t && (t.scale = t.extent / c), d = Rx(e, n, r, p, t);
            } else {
                let t = xS(i) ? Vy(e, r, 1)[0] : 1;
                if (t === 0) continue;
                let n = uS(e, r, i, t, p, void 0);
                if (n) {
                    if (Array.isArray(n)) for (let e of n)f.push(e);
                    else f.push(n);
                }
            }
        }
        let m = new Hv(l.name, d, u, f, c);
        i.push(m), r.set(o);
    }
    return i;
}
function MS(e, t, n, r, i, a, o = !1) {
    let s = t.scalarType;
    if (s?.type !== `logicalType` || s.logicalType !== Gv.ID) throw Error(`ID column must be a logical ID scalar type: ${r}`);
    let c = s.longID ? X.UINT_64 : X.UINT_32, l = typeof a == `number` ? void 0 : a, u = dx(i, a, e, n, c === X.UINT_64 ? `int64` : `int32`);
    if (c === X.UINT_32) switch(u){
        case $.FLAT:
            return new Lv(r, qb(e, n, i, void 0, l), a);
        case $.SEQUENCE:
            {
                let t = Qb(e, n, i);
                return new Bv(r, t[0], t[1], i.numRleValues);
            }
        case $.CONST:
            return new Vv(r, Zb(e, n, i), a, !1);
    }
    switch(u){
        case $.FLAT:
            return o ? new Rv(r, nx(e, n, i), a) : new mx(r, tx(e, n, i, l), a);
        case $.SEQUENCE:
            {
                let t = $b(e, n, i);
                return new hx(r, t[0], t[1], i.numRleValues);
            }
        case $.CONST:
            return new Gx(r, ix(e, n, i), a, !1);
    }
    throw Error(`Vector type not supported for id column.`);
}
var NS = class {
    constructor(e, t){
        switch(this._featureData = e, this.properties = this._featureData.properties || {}, this._featureData.geometry?.type){
            case vx.POINT:
            case vx.MULTIPOINT:
                this.type = 1;
                break;
            case vx.LINESTRING:
            case vx.MULTILINESTRING:
                this.type = 2;
                break;
            case vx.POLYGON:
            case vx.MULTIPOLYGON:
                this.type = 3;
                break;
            default:
                this.type = 0;
        }
        this.extent = t, this.id = Number(this._featureData.id);
    }
    loadGeometry() {
        let e = [];
        for (let t of this._featureData.geometry.coordinates){
            let n = [];
            for (let e of t)n.push(new l(e.x, e.y));
            e.push(n);
        }
        return e;
    }
}, PS = class {
    constructor(e){
        this.features = [], this.featureTable = e, this.name = e.name, this.extent = e.extent, this.version = 2, this.features = e.getFeatures(), this.length = this.features.length;
    }
    feature(e) {
        return new NS(this.features[e], this.extent);
    }
}, FS = class {
    constructor(e){
        this.layers = {};
        let t = jS(new Uint8Array(e));
        this.layers = t.reduce((e, t)=>({
                ...e,
                [t.name]: new PS(t)
            }), {});
    }
}, IS = class {
    constructor(e, t){
        this.tileID = e, this.x = e.canonical.x, this.y = e.canonical.y, this.z = e.canonical.z, this.grid = new kc(Ye, 16, 0), this.grid3D = new kc(Ye, 16, 0), this.featureIndexArray = new uu, this.promoteId = t;
    }
    insert(e, t, n, r, i, a) {
        let o = this.featureIndexArray.length;
        this.featureIndexArray.emplaceBack(n, r, i);
        let s = a ? this.grid3D : this.grid;
        for (let e of t){
            let t = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for (let n of e)t[0] = Math.min(t[0], n.x), t[1] = Math.min(t[1], n.y), t[2] = Math.max(t[2], n.x), t[3] = Math.max(t[3], n.y);
            t[0] < 8192 && t[1] < 8192 && t[2] >= 0 && t[3] >= 0 && s.insert(o, t[0], t[1], t[2], t[3]);
        }
    }
    loadVTLayers() {
        if (!this.vtLayers) {
            switch(this.encoding){
                case `mlt`:
                    this.vtLayers = new FS(this.rawTileData).layers;
                    break;
                default:
                    this.vtLayers = new nm(new Dg(this.rawTileData)).layers;
            }
            this.sourceLayerCoder = new Nv(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                Sv
            ]);
        }
        return this.vtLayers;
    }
    query(e, t, n, r) {
        this.loadVTLayers();
        let i = e.params, a = Ye / e.tileSize / e.scale, o = ps(i.filter, `queryRenderedFeatures filter`, i.globalState), s = e.queryGeometry, c = e.queryPadding * a, l = bv.fromPoints(s), u = this.grid.query(l.minX - c, l.minY - c, l.maxX + c, l.maxY + c), d = bv.fromPoints(e.cameraQueryGeometry).expandBy(c), f = this.grid3D.query(d.minX, d.minY, d.maxX, d.maxY, (t, n, r, i)=>Md(e.cameraQueryGeometry, t - c, n - c, r + c, i + c));
        for (let e of f)u.push(e);
        u.sort(RS);
        let p = {}, m;
        for (let c of u){
            if (c === m) continue;
            m = c;
            let l = this.featureIndexArray.get(c), u = null;
            this.loadMatchingFeature(p, l.bucketIndex, l.sourceLayerIndex, l.featureIndex, o, i.layers, i.availableImages, t, n, r, (t, n, r)=>(u ||= gd(t), n.queryIntersectsFeature({
                    queryGeometry: s,
                    feature: t,
                    featureState: r,
                    geometry: u,
                    zoom: this.z,
                    transform: e.transform,
                    pixelsToTileUnits: a,
                    pixelPosMatrix: e.pixelPosMatrix,
                    unwrappedTileID: this.tileID.toUnwrapped(),
                    getElevation: e.getElevation
                })));
        }
        return p;
    }
    loadMatchingFeature(e, t, n, r, i, a, o, s, c, l, u) {
        let d = this.bucketLayerIDs[t];
        if (a && !d.some((e)=>a.has(e))) return;
        let f = this.sourceLayerCoder.decode(n), p = this.vtLayers[f].feature(r);
        if (i.needGeometry) {
            let e = _d(p, !0);
            if (!i.filter(new U(this.tileID.overscaledZ), e, this.tileID.canonical)) return;
        } else if (!i.filter(new U(this.tileID.overscaledZ), p)) return;
        let m = this.getId(p, f);
        for (let t of d){
            if (a && !a.has(t)) continue;
            let n = s[t];
            if (!n) continue;
            let i = {};
            m && l && (i = l.getState(n.sourceLayer || `_geojsonTileLayer`, m));
            let d = xt({}, c[t]);
            d.paint = LS(d.paint, n.paint, p, i, o), d.layout = LS(d.layout, n.layout, p, i, o);
            let f = !u || u(p, n, i);
            if (!f) continue;
            let h = new Pv(p, this.z, this.x, this.y, m);
            h.layer = d;
            let g = e[t];
            g === void 0 && (g = e[t] = []), g.push({
                featureIndex: r,
                feature: h,
                intersectionZ: f
            });
        }
    }
    lookupSymbolFeatures(e, t, n, r, i, a, o, s) {
        let c = {};
        this.loadVTLayers();
        let l = ps(i.filterSpec, `queryRenderedFeatures symbol filter`, i.globalState);
        for (let i of e)this.loadMatchingFeature(c, n, r, i, l, a, o, s, t);
        return c;
    }
    hasLayer(e) {
        for (let t of this.bucketLayerIDs)for (let n of t)if (e === n) return !0;
        return !1;
    }
    getId(e, t) {
        let n = e.id;
        if (this.promoteId) {
            let r = typeof this.promoteId == `string` ? this.promoteId : this.promoteId[t];
            n = e.properties[r], typeof n == `boolean` && (n = Number(n)), n === void 0 && e.properties?.cluster && this.promoteId && (n = Number(e.properties.cluster_id));
        }
        return n;
    }
};
H(`FeatureIndex`, IS, {
    omit: [
        `rawTileData`,
        `sourceLayerCoder`
    ]
});
function LS(e, t, n, r, i) {
    return At(e, (e, a)=>{
        let o = t instanceof fl ? t.get(a) : null;
        return o?.evaluate ? o.evaluate(n, r, i) : o;
    });
}
function RS(e, t) {
    return t - e;
}
var zS = class {
    constructor(e, t){
        this.max = e, this.onRemove = t, this.reset();
    }
    reset() {
        for(let e in this.data)for (let t of this.data[e])t.timeout && clearTimeout(t.timeout), this.onRemove(t.value);
        return this.data = {}, this.order = [], this;
    }
    add(e, t, n) {
        let r = e.wrapped().key;
        this.data[r] === void 0 && (this.data[r] = []);
        let i = {
            value: t,
            timeout: void 0
        };
        if (n !== void 0 && (i.timeout = setTimeout(()=>{
            this.remove(e, i);
        }, n)), this.data[r].push(i), this.order.push(r), this.order.length > this.max) {
            let e = this._getAndRemoveByKey(this.order[0]);
            e && this.onRemove(e);
        }
        return this;
    }
    has(e) {
        return e.wrapped().key in this.data;
    }
    getAndRemove(e) {
        return this.has(e) ? this._getAndRemoveByKey(e.wrapped().key) : null;
    }
    _getAndRemoveByKey(e) {
        let t = this.data[e].shift();
        return t.timeout && clearTimeout(t.timeout), this.data[e].length === 0 && delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t.value;
    }
    getByKey(e) {
        let t = this.data[e];
        return t ? t[0].value : null;
    }
    get(e) {
        return this.has(e) ? this.data[e.wrapped().key][0].value : null;
    }
    remove(e, t) {
        if (!this.has(e)) return this;
        let n = e.wrapped().key, r = t === void 0 ? 0 : this.data[n].indexOf(t), i = this.data[n][r];
        return this.data[n].splice(r, 1), i.timeout && clearTimeout(i.timeout), this.data[n].length === 0 && delete this.data[n], this.onRemove(i.value), this.order.splice(this.order.indexOf(n), 1), this;
    }
    setMaxSize(e) {
        for(this.max = e; this.order.length > this.max;){
            let e = this._getAndRemoveByKey(this.order[0]);
            e && this.onRemove(e);
        }
        return this;
    }
    filter(e) {
        let t = [];
        for(let n in this.data)for (let r of this.data[n])e(r.value) || t.push(r);
        for (let e of t)this.remove(e.value.tileID, e);
    }
}, BS = class {
    constructor(e){
        this.maxEntries = e, this.map = new Map;
    }
    get(e) {
        let t = this.map.get(e);
        return t !== void 0 && (this.map.delete(e), this.map.set(e, t)), t;
    }
    set(e, t) {
        if (this.map.has(e)) this.map.delete(e);
        else if (this.map.size >= this.maxEntries) {
            let e = this.map.keys().next().value;
            this.map.delete(e);
        }
        this.map.set(e, t);
    }
    clear() {
        this.map.clear();
    }
};
function VS(e, t, n, r, i) {
    let a = [];
    for (let o of e){
        let e;
        for(let s = 0; s < o.length - 1; s++){
            let c = o[s], u = o[s + 1];
            c.x < t && u.x < t || (c.x < t ? c = new l(t, c.y + (u.y - c.y) * ((t - c.x) / (u.x - c.x)))._round() : u.x < t && (u = new l(t, c.y + (u.y - c.y) * ((t - c.x) / (u.x - c.x)))._round()), !(c.y < n && u.y < n) && (c.y < n ? c = new l(c.x + (u.x - c.x) * ((n - c.y) / (u.y - c.y)), n)._round() : u.y < n && (u = new l(c.x + (u.x - c.x) * ((n - c.y) / (u.y - c.y)), n)._round()), !(c.x >= r && u.x >= r) && (c.x >= r ? c = new l(r, c.y + (u.y - c.y) * ((r - c.x) / (u.x - c.x)))._round() : u.x >= r && (u = new l(r, c.y + (u.y - c.y) * ((r - c.x) / (u.x - c.x)))._round()), !(c.y >= i && u.y >= i) && (c.y >= i ? c = new l(c.x + (u.x - c.x) * ((i - c.y) / (u.y - c.y)), i)._round() : u.y >= i && (u = new l(c.x + (u.x - c.x) * ((i - c.y) / (u.y - c.y)), i)._round()), (!e || !c.equals(e[e.length - 1])) && (e = [
                c
            ], a.push(e)), e.push(u)))));
        }
    }
    return a;
}
function HS(e, t, n, r, i, a) {
    let o = US(e, t, n, i, 0);
    return o = US(o, t, r, a, 1), o;
}
function US(e, t, n, r, i) {
    switch(t){
        case 1:
            return WS(e, n, r, i);
        case 2:
            return KS(e, n, r, i, !1);
        case 3:
            return KS(e, n, r, i, !0);
    }
    return [];
}
function WS(e, t, n, r) {
    let i = [];
    for (let a of e)for (let e of a){
        let a = r === 0 ? e.x : e.y;
        a >= t && a <= n && i.push([
            e
        ]);
    }
    return i;
}
function GS(e, t, n, r, i) {
    let a = r === 0 ? qS : JS, o = [], s = [];
    for(let c = 0; c < e.length - 1; c++){
        let l = e[c], u = e[c + 1], d = r === 0 ? l.x : l.y, f = r === 0 ? u.x : u.y, p = !1;
        d < t ? f > t && o.push(a(l, u, t)) : d > n ? f < n && o.push(a(l, u, n)) : o.push(l), f < t && d >= t && (o.push(a(l, u, t)), p = !0), f > n && d <= n && (o.push(a(l, u, n)), p = !0), !i && p && (s.push(o), o = []);
    }
    let c = e.length - 1, u = r === 0 ? e[c].x : e[c].y;
    return u >= t && u <= n && o.push(e[c]), i && o.length > 0 && !o[0].equals(o[o.length - 1]) && o.push(new l(o[0].x, o[0].y)), o.length > 0 && s.push(o), s;
}
function KS(e, t, n, r, i) {
    let a = [];
    for (let o of e){
        let e = GS(o, t, n, r, i);
        e.length > 0 && a.push(...e);
    }
    return a;
}
function qS(e, t, n) {
    let r = (n - e.x) / (t.x - e.x);
    return new l(n, e.y + (t.y - e.y) * r);
}
function JS(e, t, n) {
    let r = (n - e.y) / (t.y - e.y);
    return new l(e.x + (t.x - e.x) * r, n);
}
var YS = class e extends l {
    constructor(e, t, n, r){
        super(e, t), this.angle = n, r !== void 0 && (this.segment = r);
    }
    clone() {
        return new e(this.x, this.y, this.angle, this.segment);
    }
};
H(`Anchor`, YS);
function XS(e, t, n, r, i) {
    if (t.segment === void 0 || n === 0) return !0;
    let a = t, o = t.segment + 1, s = 0;
    for(; s > -n / 2;){
        if (o--, o < 0) return !1;
        s -= e[o].dist(a), a = e[o];
    }
    s += e[o].dist(e[o + 1]), o++;
    let c = [], l = 0;
    for(; s < n / 2;){
        let t = e[o - 1], n = e[o], a = e[o + 1];
        if (!a) return !1;
        let u = t.angleTo(n) - n.angleTo(a);
        for(u = Math.abs((u + 3 * Math.PI) % (Math.PI * 2) - Math.PI), c.push({
            distance: s,
            angleDelta: u
        }), l += u; s - c[0].distance > r;)l -= c.shift().angleDelta;
        if (l > i) return !1;
        o++, s += n.dist(a);
    }
    return !0;
}
function ZS(e) {
    let t = 0;
    for(let n = 0; n < e.length - 1; n++)t += e[n].dist(e[n + 1]);
    return t;
}
function QS(e, t, n) {
    return e ? 0.6 * t * n : 0;
}
function $S(e, t) {
    return Math.max(e ? e.right - e.left : 0, t ? t.right - t.left : 0);
}
function eC(e, t, n, r, i, a) {
    let o = QS(n, i, a), s = $S(n, r) * a, c = 0, l = ZS(e) / 2;
    for(let n = 0; n < e.length - 1; n++){
        let r = e[n], i = e[n + 1], a = r.dist(i);
        if (c + a > l) {
            let u = (l - c) / a, d = new YS(Di.number(r.x, i.x, u), Di.number(r.y, i.y, u), i.angleTo(r), n);
            return d._round(), !o || XS(e, d, s, o, t) ? d : void 0;
        }
        c += a;
    }
}
function tC(e, t, n, r, i, a, o, s, c) {
    let l = QS(r, a, o), u = $S(r, i), d = u * o, f = e[0].x === 0 || e[0].x === c || e[0].y === 0 || e[0].y === c;
    t - d < t / 4 && (t = d + t / 4);
    let p = a * 2;
    return nC(e, f ? t / 2 * s % t : (u / 2 + p) * o * s % t, t, l, n, d, f, !1, c);
}
function nC(e, t, n, r, i, a, o, s, c) {
    let l = a / 2, u = ZS(e), d = 0, f = t - n, p = [];
    for(let t = 0; t < e.length - 1; t++){
        let o = e[t], s = e[t + 1], m = o.dist(s), h = s.angleTo(o);
        for(; f + n < d + m;){
            f += n;
            let g = (f - d) / m, _ = Di.number(o.x, s.x, g), v = Di.number(o.y, s.y, g);
            if (_ >= 0 && _ < c && v >= 0 && v < c && f - l >= 0 && f + l <= u) {
                let n = new YS(_, v, h, t);
                n._round(), (!r || XS(e, n, a, r, i)) && p.push(n);
            }
        }
        d += m;
    }
    return !s && !p.length && !o && (p = nC(e, d / 2, n, r, i, a, o, !0, c)), p;
}
function rC(e, t, n, r) {
    let i = [], a = e.image, o = a.pixelRatio, s = a.paddedRect.w - 2, c = a.paddedRect.h - 2, u = {
        x1: e.left,
        y1: e.top,
        x2: e.right,
        y2: e.bottom
    }, d = a.stretchX || [
        [
            0,
            s
        ]
    ], f = a.stretchY || [
        [
            0,
            c
        ]
    ], p = (e, t)=>e + t[1] - t[0], m = d.reduce(p, 0), h = f.reduce(p, 0), g = s - m, _ = c - h, v = 0, y = m, b = 0, x = h, S = 0, C = g, w = 0, T = _;
    if (a.content && r) {
        let t = a.content, n = t[2] - t[0], r = t[3] - t[1];
        (a.textFitWidth || a.textFitHeight) && (u = h_(e)), v = iC(d, 0, t[0]), b = iC(f, 0, t[1]), y = iC(d, t[0], t[2]), x = iC(f, t[1], t[3]), S = t[0] - v, w = t[1] - b, C = n - y, T = r - x;
    }
    let E = u.x1, D = u.y1, O = u.x2 - E, k = u.y2 - D, A = (e, r, i, s)=>{
        let c = oC(e.stretch - v, y, O, E), u = sC(e.fixed - S, C, e.stretch, m), d = oC(r.stretch - b, x, k, D), f = sC(r.fixed - w, T, r.stretch, h), p = oC(i.stretch - v, y, O, E), g = sC(i.fixed - S, C, i.stretch, m), _ = oC(s.stretch - b, x, k, D), A = sC(s.fixed - w, T, s.stretch, h), ee = new l(c, d), te = new l(p, d), ne = new l(p, _), re = new l(c, _), ie = new l(u / o, f / o), ae = new l(g / o, A / o), oe = t * Math.PI / 180;
        if (oe) {
            let e = Math.sin(oe), t = Math.cos(oe), n = [
                t,
                -e,
                e,
                t
            ];
            ee._matMult(n), te._matMult(n), re._matMult(n), ne._matMult(n);
        }
        let se = e.stretch + e.fixed, ce = i.stretch + i.fixed, le = r.stretch + r.fixed, ue = s.stretch + s.fixed;
        return {
            tl: ee,
            tr: te,
            bl: re,
            br: ne,
            tex: {
                x: a.paddedRect.x + 1 + se,
                y: a.paddedRect.y + 1 + le,
                w: ce - se,
                h: ue - le
            },
            writingMode: void 0,
            glyphOffset: [
                0,
                0
            ],
            sectionIndex: 0,
            pixelOffsetTL: ie,
            pixelOffsetBR: ae,
            minFontScaleX: C / o / O,
            minFontScaleY: T / o / k,
            isSDF: n
        };
    };
    if (!r || !a.stretchX && !a.stretchY) i.push(A({
        fixed: 0,
        stretch: -1
    }, {
        fixed: 0,
        stretch: -1
    }, {
        fixed: 0,
        stretch: s + 1
    }, {
        fixed: 0,
        stretch: c + 1
    }));
    else {
        let e = aC(d, g, m), t = aC(f, _, h);
        for(let n = 0; n < e.length - 1; n++){
            let r = e[n], a = e[n + 1];
            for(let e = 0; e < t.length - 1; e++){
                let n = t[e], o = t[e + 1];
                i.push(A(r, n, a, o));
            }
        }
    }
    return i;
}
function iC(e, t, n) {
    let r = 0;
    for (let i of e)r += Math.max(t, Math.min(n, i[1])) - Math.max(t, Math.min(n, i[0]));
    return r;
}
function aC(e, t, n) {
    let r = [
        {
            fixed: -1,
            stretch: 0
        }
    ];
    for (let [t, n] of e){
        let e = r[r.length - 1];
        r.push({
            fixed: t - e.stretch,
            stretch: e.stretch
        }), r.push({
            fixed: t - e.stretch,
            stretch: e.stretch + (n - t)
        });
    }
    return r.push({
        fixed: t + 1,
        stretch: n
    }), r;
}
function oC(e, t, n, r) {
    return e / t * n + r;
}
function sC(e, t, n, r) {
    return e - t * n / r;
}
function cC(e, t, n, r, i, a, o, s) {
    let c = r.layout.get(`text-rotate`).evaluate(a, {}) * Math.PI / 180, u = [];
    for (let e of t.positionedLines)for (let r of e.positionedGlyphs){
        if (!r.rect) continue;
        let a = r.rect || {}, d = 4, f = !0, p = 1, m = 0, h = (i || s) && r.vertical, g = r.metrics.advance * r.scale / 2;
        if (s && t.verticalizable) {
            let t = (r.scale - 1) * 24, n = (24 - r.metrics.width * r.scale) / 2;
            m = e.lineOffset / 2 - (r.imageName ? -n : t);
        }
        if (r.imageName) {
            let e = o[r.imageName];
            f = e.sdf, p = e.pixelRatio, d = 1 / p;
        }
        let _ = i ? [
            r.x + g,
            r.y
        ] : [
            0,
            0
        ], v = i ? [
            0,
            0
        ] : [
            r.x + g + n[0],
            r.y + n[1] - m
        ], y = [
            0,
            0
        ];
        h && (y = v, v = [
            0,
            0
        ]);
        let b = r.metrics.isDoubleResolution ? 2 : 1, x = (r.metrics.left - d) * r.scale - g + v[0], S = (-r.metrics.top - d) * r.scale + v[1], C = x + a.w / b * r.scale / p, w = S + a.h / b * r.scale / p, T = new l(x, S), E = new l(C, S), D = new l(x, w), O = new l(C, w);
        if (h) {
            let e = new l(-g, g - -17), t = -Math.PI / 2, n = 12 - g, i = r.imageName ? n : 0, a = new l(22 - n, -i), o = new l(...y);
            T._rotateAround(t, e)._add(a)._add(o), E._rotateAround(t, e)._add(a)._add(o), D._rotateAround(t, e)._add(a)._add(o), O._rotateAround(t, e)._add(a)._add(o);
        }
        if (c) {
            let e = Math.sin(c), t = Math.cos(c), n = [
                t,
                -e,
                e,
                t
            ];
            T._matMult(n), E._matMult(n), D._matMult(n), O._matMult(n);
        }
        let k = new l(0, 0), A = new l(0, 0);
        u.push({
            tl: T,
            tr: E,
            bl: D,
            br: O,
            tex: a,
            writingMode: t.writingMode,
            glyphOffset: _,
            sectionIndex: r.sectionIndex,
            isSDF: f,
            pixelOffsetTL: k,
            pixelOffsetBR: A,
            minFontScaleX: 0,
            minFontScaleY: 0
        });
    }
    return u;
}
var lC = class {
    constructor(e, t, n, r, i, a, o, s, c, u){
        if (this.boxStartIndex = e.length, c) {
            let e = a.top, t = a.bottom, n = a.collisionPadding;
            n && (e -= n[1], t += n[3]);
            let r = t - e;
            r > 0 && (r = Math.max(10, r), this.circleDiameter = r);
        } else {
            let c = a.image?.content && (a.image.textFitWidth || a.image.textFitHeight) ? h_(a) : {
                x1: a.left,
                y1: a.top,
                x2: a.right,
                y2: a.bottom
            };
            c.y1 = c.y1 * o - s[0], c.y2 = c.y2 * o + s[2], c.x1 = c.x1 * o - s[3], c.x2 = c.x2 * o + s[1];
            let d = a.collisionPadding;
            if (d && (c.x1 -= d[0] * o, c.y1 -= d[1] * o, c.x2 += d[2] * o, c.y2 += d[3] * o), u) {
                let e = new l(c.x1, c.y1), t = new l(c.x2, c.y1), n = new l(c.x1, c.y2), r = new l(c.x2, c.y2), i = u * Math.PI / 180;
                e._rotate(i), t._rotate(i), n._rotate(i), r._rotate(i), c.x1 = Math.min(e.x, t.x, n.x, r.x), c.x2 = Math.max(e.x, t.x, n.x, r.x), c.y1 = Math.min(e.y, t.y, n.y, r.y), c.y2 = Math.max(e.y, t.y, n.y, r.y);
            }
            e.emplaceBack(t.x, t.y, c.x1, c.y1, c.x2, c.y2, n, r, i);
        }
        this.boxEndIndex = e.length;
    }
}, uC = class {
    constructor(e = [], t = (e, t)=>e < t ? -1 : +(e > t)){
        if (this.data = e, this.length = this.data.length, this.compare = t, this.length > 0) for(let e = (this.length >> 1) - 1; e >= 0; e--)this._down(e);
    }
    push(e) {
        this.data.push(e), this._up(this.length++);
    }
    pop() {
        if (this.length === 0) return;
        let e = this.data[0], t = this.data.pop();
        return --this.length > 0 && (this.data[0] = t, this._down(0)), e;
    }
    peek() {
        return this.data[0];
    }
    _up(e) {
        let { data: t, compare: n } = this, r = t[e];
        for(; e > 0;){
            let i = e - 1 >> 1, a = t[i];
            if (n(r, a) >= 0) break;
            t[e] = a, e = i;
        }
        t[e] = r;
    }
    _down(e) {
        let { data: t, compare: n } = this, r = this.length >> 1, i = t[e];
        for(; e < r;){
            let r = (e << 1) + 1, a = r + 1;
            if (a < this.length && n(t[a], t[r]) < 0 && (r = a), n(t[r], i) >= 0) break;
            t[e] = t[r], e = r;
        }
        t[e] = i;
    }
};
function dC(e, t = 1) {
    let n = bv.fromPoints(e[0]), r = Math.min(n.width(), n.height()), i = r / 2, a = new uC([], fC), { minX: o, minY: s, maxX: c, maxY: u } = n;
    if (r === 0) return new l(o, s);
    for(let t = o; t < c; t += r)for(let n = s; n < u; n += r)a.push(new pC(t + i, n + i, i, e));
    let d = hC(e), f = d;
    for(; a.length;){
        let n = a.pop();
        (n.d > f.d || !f.d) && (f = n), !(n.max - f.d <= t) && (i = n.h / 2, a.push(new pC(n.p.x - i, n.p.y - i, i, e)), a.push(new pC(n.p.x + i, n.p.y - i, i, e)), a.push(new pC(n.p.x - i, n.p.y + i, i, e)), a.push(new pC(n.p.x + i, n.p.y + i, i, e)));
    }
    return d.d > 0 && f.d - d.d <= t ? d.p : f.p;
}
function fC(e, t) {
    return t.max - e.max;
}
var pC = class {
    constructor(e, t, n, r){
        this.p = new l(e, t), this.h = n, this.d = mC(this.p, r), this.max = this.d + this.h * Math.SQRT2;
    }
};
function mC(e, t) {
    let n = !1, r = 1 / 0;
    for (let i of t)for(let t = 0, a = i.length, o = a - 1; t < a; o = t++){
        let a = i[t], s = i[o];
        a.y > e.y != s.y > e.y && e.x < (s.x - a.x) * (e.y - a.y) / (s.y - a.y) + a.x && (n = !n), r = Math.min(r, kd(e, a, s));
    }
    return (n ? 1 : -1) * Math.sqrt(r);
}
function hC(e) {
    let t = 0, n = 0, r = 0, i = e[0];
    for(let e = 0, a = i.length, o = a - 1; e < a; o = e++){
        let a = i[e], s = i[o], c = a.x * s.y - s.x * a.y;
        n += (a.x + s.x) * c, r += (a.y + s.y) * c, t += c * 3;
    }
    return new pC(n / t, r / t, 0, e);
}
let gC = function(e) {
    return e[e.center = 1] = `center`, e[e.left = 2] = `left`, e[e.right = 3] = `right`, e[e.top = 4] = `top`, e[e.bottom = 5] = `bottom`, e[e[`top-left`] = 6] = `top-left`, e[e[`top-right`] = 7] = `top-right`, e[e[`bottom-left`] = 8] = `bottom-left`, e[e[`bottom-right`] = 9] = `bottom-right`, e;
}({});
const _C = 1 / 0;
function vC(e, t) {
    function n(e, t) {
        let n = 0, r = 0;
        t < 0 && (t = 0);
        let i = t / Math.SQRT2;
        switch(e){
            case `top-right`:
            case `top-left`:
                r = i - 7;
                break;
            case `bottom-right`:
            case `bottom-left`:
                r = -i + 7;
                break;
            case `bottom`:
                r = -t + 7;
                break;
            case `top`:
                r = t - 7;
                break;
        }
        switch(e){
            case `top-right`:
            case `bottom-right`:
                n = -i;
                break;
            case `top-left`:
            case `bottom-left`:
                n = i;
                break;
            case `left`:
                n = t;
                break;
            case `right`:
                n = -t;
                break;
        }
        return [
            n,
            r
        ];
    }
    function r(e, t, n) {
        let r = 0, i = 0;
        switch(t = Math.abs(t), n = Math.abs(n), e){
            case `top-right`:
            case `top-left`:
            case `top`:
                i = n - 7;
                break;
            case `bottom-right`:
            case `bottom-left`:
            case `bottom`:
                i = -n + 7;
                break;
        }
        switch(e){
            case `top-right`:
            case `bottom-right`:
            case `right`:
                r = -t;
                break;
            case `top-left`:
            case `bottom-left`:
            case `left`:
                r = t;
                break;
        }
        return [
            r,
            i
        ];
    }
    return t[1] === _C ? n(e, t[0]) : r(e, t[0], t[1]);
}
function yC(e, t, n) {
    let r = e.layout, i = r.get(`text-variable-anchor-offset`)?.evaluate(t, {}, n);
    if (i) {
        let e = i.values, t = [];
        for(let n = 0; n < e.length; n += 2){
            let r = t[n] = e[n], i = e[n + 1].map((e)=>e * 24);
            r.startsWith(`top`) ? i[1] -= 7 : r.startsWith(`bottom`) && (i[1] += 7), t[n + 1] = i;
        }
        return new $r(t);
    }
    let a = r.get(`text-variable-anchor`);
    if (a) {
        let i;
        i = e._unevaluatedLayout.getValue(`text-radial-offset`) === void 0 ? r.get(`text-offset`).evaluate(t, {}, n).map((e)=>e * 24) : [
            r.get(`text-radial-offset`).evaluate(t, {}, n) * 24,
            _C
        ];
        let o = [];
        for (let e of a)o.push(e, vC(e, i));
        return new $r(o);
    }
    return null;
}
function bC(e) {
    e.bucket.createArrays();
    let t = 512 * e.bucket.overscaling;
    e.bucket.tilePixelRatio = Ye / t, e.bucket.compareText = {}, e.bucket.iconsNeedLinear = !1;
    let n = e.bucket.layers[0], r = n.layout, i = n._unevaluatedLayout._values, a = {
        layoutIconSize: i[`icon-size`].possiblyEvaluate(new U(e.bucket.zoom + 1), e.canonical),
        layoutTextSize: i[`text-size`].possiblyEvaluate(new U(e.bucket.zoom + 1), e.canonical),
        textMaxSize: i[`text-size`].possiblyEvaluate(new U(18))
    };
    if (e.bucket.textSizeData.kind === `composite`) {
        let { minZoom: t, maxZoom: n } = e.bucket.textSizeData;
        a.compositeTextSizes = [
            i[`text-size`].possiblyEvaluate(new U(t), e.canonical),
            i[`text-size`].possiblyEvaluate(new U(n), e.canonical)
        ];
    }
    if (e.bucket.iconSizeData.kind === `composite`) {
        let { minZoom: t, maxZoom: n } = e.bucket.iconSizeData;
        a.compositeIconSizes = [
            i[`icon-size`].possiblyEvaluate(new U(t), e.canonical),
            i[`icon-size`].possiblyEvaluate(new U(n), e.canonical)
        ];
    }
    let o = r.get(`text-line-height`) * 24, s = r.get(`text-rotation-alignment`) !== `viewport` && r.get(`symbol-placement`) !== `point`, c = r.get(`text-keep-upright`), l = r.get(`text-size`);
    for (let t of e.bucket.features){
        let i = r.get(`text-font`).evaluate(t, {}, e.canonical).join(`,`), u = l.evaluate(t, {}, e.canonical), d = a.layoutTextSize.evaluate(t, {}, e.canonical), f = a.layoutIconSize.evaluate(t, {}, e.canonical), p = {
            horizontal: {},
            vertical: void 0
        }, m = t.text, h = [
            0,
            0
        ];
        if (m) {
            let a = m.toString(), l = r.get(`text-letter-spacing`).evaluate(t, {}, e.canonical) * 24, f = Gc(a) ? l : 0, g = r.get(`text-anchor`).evaluate(t, {}, e.canonical), _ = yC(n, t, e.canonical);
            if (!_) {
                let n = r.get(`text-radial-offset`).evaluate(t, {}, e.canonical);
                h = n ? vC(g, [
                    n * 24,
                    _C
                ]) : r.get(`text-offset`).evaluate(t, {}, e.canonical).map((e)=>e * 24);
            }
            let v = s ? `center` : r.get(`text-justify`).evaluate(t, {}, e.canonical), y = r.get(`symbol-placement`) === `point` ? r.get(`text-max-width`).evaluate(t, {}, e.canonical) * 24 : 1 / 0, b = ()=>{
                e.bucket.allowVerticalPlacement && Wc(a) && (p.vertical = r_(m, e.glyphMap, e.glyphPositions, e.imagePositions, i, y, o, g, `left`, f, h, 2, !0, d, u));
            };
            if (!s && _) {
                let t = new Set;
                if (v === `auto`) for(let e = 0; e < _.values.length; e += 2)t.add(xC(_.values[e]));
                else t.add(v);
                let n = !1;
                for (let r of t)if (!p.horizontal[r]) {
                    if (n) p.horizontal[r] = p.horizontal[0];
                    else {
                        let t = r_(m, e.glyphMap, e.glyphPositions, e.imagePositions, i, y, o, `center`, r, f, h, 1, !1, d, u);
                        t && (p.horizontal[r] = t, n = t.positionedLines.length === 1);
                    }
                }
                b();
            } else {
                v === `auto` && (v = xC(g));
                let t = r_(m, e.glyphMap, e.glyphPositions, e.imagePositions, i, y, o, g, v, f, h, 1, !1, d, u);
                t && (p.horizontal[v] = t), b(), Wc(a) && s && c && (p.vertical = r_(m, e.glyphMap, e.glyphPositions, e.imagePositions, i, y, o, g, v, f, h, 2, !1, d, u));
            }
        }
        let g, _ = !1;
        if (t.icon?.name) {
            let n = e.imageMap[t.icon.name];
            n && (g = m_(e.imagePositions[t.icon.name], r.get(`icon-offset`).evaluate(t, {}, e.canonical), r.get(`icon-anchor`).evaluate(t, {}, e.canonical)), _ = !!n.sdf, e.bucket.sdfIcons === void 0 ? e.bucket.sdfIcons = _ : e.bucket.sdfIcons !== _ && Ft(`Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer`), n.pixelRatio === e.bucket.pixelRatio ? r.get(`icon-rotate`).constantOr(1) !== 0 && (e.bucket.iconsNeedLinear = !0) : e.bucket.iconsNeedLinear = !0);
        }
        let v = TC(p.horizontal) || p.vertical;
        e.bucket.iconsInText ||= v ? v.iconsInText : !1, (v || g) && SC(e.bucket, t, p, g, e.imageMap, a, d, f, h, _, e.canonical, e.subdivisionGranularity);
    }
    e.showCollisionBoxes && e.bucket.generateCollisionDebugBuffers();
}
function xC(e) {
    switch(e){
        case `right`:
        case `top-right`:
        case `bottom-right`:
            return `right`;
        case `left`:
        case `top-left`:
        case `bottom-left`:
            return `left`;
    }
    return `center`;
}
function SC(e, t, n, r, i, a, o, s, c, l, u, d) {
    let f = a.textMaxSize.evaluate(t, {});
    f === void 0 && (f = o);
    let p = e.layers[0].layout, m = p.get(`icon-offset`).evaluate(t, {}, u), h = TC(n.horizontal), g = o / 24, _ = e.tilePixelRatio * g, v = e.tilePixelRatio * f / 24, y = e.tilePixelRatio * s, b = e.tilePixelRatio * p.get(`symbol-spacing`), x = p.get(`text-padding`) * e.tilePixelRatio, S = R_(p, t, u, e.tilePixelRatio), C = p.get(`text-max-angle`) / 180 * Math.PI, w = p.get(`text-rotation-alignment`) !== `viewport` && p.get(`symbol-placement`) !== `point`, T = p.get(`icon-rotation-alignment`) === `map` && p.get(`symbol-placement`) !== `point`, E = p.get(`symbol-placement`), D = b / 2, O = p.get(`icon-text-fit`), k;
    r && O !== `none` && (e.allowVerticalPlacement && n.vertical && (k = g_(r, n.vertical, O, p.get(`icon-text-fit-padding`), m, g)), h && (r = g_(r, h, O, p.get(`icon-text-fit-padding`), m, g)));
    let A = u ? d.line.getGranularityForZoomLevel(u.z) : 1, ee = (s, d)=>{
        d.x < 0 || d.x >= 8192 || d.y < 0 || d.y >= 8192 || EC(e, d, s, n, r, i, k, e.layers[0], e.collisionBoxArray, t.index, t.sourceLayerIndex, e.index, _, [
            x,
            x,
            x,
            x
        ], w, c, y, S, T, m, t, a, l, u, o);
    };
    if (E === `line`) for (let i of VS(t.geometry, 0, 0, Ye, Ye)){
        let t = Mp(i, A), a = tC(t, b, C, n.vertical || h, r, 24, v, e.overscaling, Ye);
        for (let n of a){
            let r = h;
            (!r || !DC(e, r.text, D, n)) && ee(t, n);
        }
    }
    else if (E === `line-center`) {
        for (let e of t.geometry)if (e.length > 1) {
            let t = Mp(e, A), i = eC(t, C, n.vertical || h, r, 24, v);
            i && ee(t, i);
        }
    } else if (t.type === `Polygon`) for (let e of Ma(t.geometry, 0)){
        let t = dC(e, 16);
        ee(Mp(e[0], A, !0), new YS(t.x, t.y, 0));
    }
    else if (t.type === `LineString`) for (let e of t.geometry){
        let t = Mp(e, A);
        ee(t, new YS(t[0].x, t[0].y, 0));
    }
    else if (t.type === `Point`) for (let e of t.geometry)for (let t of e)ee([
        t
    ], new YS(t.x, t.y, 0));
}
function CC(e, t) {
    let n = e.length, r = t?.values;
    if (r?.length > 0) for(let t = 0; t < r.length; t += 2){
        let n = gC[r[t]], i = r[t + 1];
        e.emplaceBack(n, i[0], i[1]);
    }
    return [
        n,
        e.length
    ];
}
function wC(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m) {
    let h = cC(t, n, s, i, a, o, r, e.allowVerticalPlacement), g = e.textSizeData, _ = null;
    g.kind === `source` ? (_ = [
        128 * i.layout.get(`text-size`).evaluate(o, {})
    ], _[0] > 32640 && Ft(`${e.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : g.kind === `composite` && (_ = [
        128 * p.compositeTextSizes[0].evaluate(o, {}, m),
        128 * p.compositeTextSizes[1].evaluate(o, {}, m)
    ], (_[0] > 32640 || _[1] > 32640) && Ft(`${e.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), e.addSymbols(e.text, h, _, s, a, o, l, t, c.lineStartIndex, c.lineLength, f, m);
    for (let t of u)d[t] = e.text.placedSymbolArray.length - 1;
    return h.length * 4;
}
function TC(e) {
    for(let t in e)return e[t];
    return null;
}
function EC(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w) {
    let T = e.addToLineVertexArray(t, n), E, D, O, k, A = 0, ee = 0, te = 0, ne = 0, re = -1, ie = -1, ae = {}, oe = (0, zu.default)(``);
    if (e.allowVerticalPlacement && r.vertical) {
        let e = s.layout.get(`text-rotate`).evaluate(b, {}, C) + 90, n = r.vertical;
        O = new lC(c, t, l, u, d, n, f, p, m, e), o && (k = new lC(c, t, l, u, d, o, g, _, m, e));
    }
    if (i) {
        let n = s.layout.get(`icon-rotate`).evaluate(b, {}), r = s.layout.get(`icon-text-fit`) !== `none`, a = rC(i, n, S, r), f = o ? rC(o, n, S, r) : void 0;
        D = new lC(c, t, l, u, d, i, g, _, !1, n), A = a.length * 4;
        let p = e.iconSizeData, m = null;
        p.kind === `source` ? (m = [
            128 * s.layout.get(`icon-size`).evaluate(b, {})
        ], m[0] > 32640 && Ft(`${e.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : p.kind === `composite` && (m = [
            128 * x.compositeIconSizes[0].evaluate(b, {}, C),
            128 * x.compositeIconSizes[1].evaluate(b, {}, C)
        ], (m[0] > 32640 || m[1] > 32640) && Ft(`${e.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), e.addSymbols(e.icon, a, m, y, v, b, 0, t, T.lineStartIndex, T.lineLength, -1, C), re = e.icon.placedSymbolArray.length - 1, f && (ee = f.length * 4, e.addSymbols(e.icon, f, m, y, v, b, 2, t, T.lineStartIndex, T.lineLength, -1, C), ie = e.icon.placedSymbolArray.length - 1);
    }
    let se = Object.keys(r.horizontal);
    for (let n of se){
        let i = r.horizontal[n];
        E ||= (oe = (0, zu.default)(i.text), new lC(c, t, l, u, d, i, f, p, m, s.layout.get(`text-rotate`).evaluate(b, {}, C)));
        let o = i.positionedLines.length === 1;
        if (te += wC(e, t, i, a, s, m, b, h, T, r.vertical ? 1 : 3, o ? se : [
            n
        ], ae, re, x, C), o) break;
    }
    r.vertical && (ne += wC(e, t, r.vertical, a, s, m, b, h, T, 2, [
        `vertical`
    ], ae, ie, x, C));
    let ce = E ? E.boxStartIndex : e.collisionBoxArray.length, le = E ? E.boxEndIndex : e.collisionBoxArray.length, ue = O ? O.boxStartIndex : e.collisionBoxArray.length, de = O ? O.boxEndIndex : e.collisionBoxArray.length, fe = D ? D.boxStartIndex : e.collisionBoxArray.length, pe = D ? D.boxEndIndex : e.collisionBoxArray.length, me = k ? k.boxStartIndex : e.collisionBoxArray.length, he = k ? k.boxEndIndex : e.collisionBoxArray.length, ge = -1, _e = (e, t)=>e?.circleDiameter ? Math.max(e.circleDiameter, t) : t;
    ge = _e(E, ge), ge = _e(O, ge), ge = _e(D, ge), ge = _e(k, ge);
    let ve = +(ge > -1);
    ve && (ge *= w / 24), e.glyphOffsetArray.length >= O_.MAX_GLYPHS && Ft(`Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907`), b.sortKey !== void 0 && e.addToSortKeyRanges(e.symbolInstances.length, b.sortKey);
    let ye = yC(s, b, C), [be, xe] = CC(e.textAnchorOffsets, ye);
    e.symbolInstances.emplaceBack(t.x, t.y, ae.right >= 0 ? ae.right : -1, ae.center >= 0 ? ae.center : -1, ae.left >= 0 ? ae.left : -1, ae.vertical || -1, re, ie, oe, ce, le, ue, de, fe, pe, me, he, l, te, ne, A, ee, ve, 0, f, ge, be, xe);
}
function DC(e, t, n, r) {
    let i = e.compareText;
    if (!(t in i)) i[t] = [];
    else {
        let e = i[t];
        for(let t = e.length - 1; t >= 0; t--)if (r.dist(e[t]) < n) return !0;
    }
    return i[t].push(r), !1;
}

});

/**
* MapLibre GL JS
* @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v6.0.0/LICENSE.txt
*/ 
var $caapT = parcelRequire("caapT");
var $902e455d852cdfb8$var$br = `6.0.0`;
function $902e455d852cdfb8$var$xr() {
    var e1 = new (0, $caapT.Oi)(4);
    return (0, $caapT.Oi) != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
}
function $902e455d852cdfb8$var$Sr(e1, t) {
    var n = t[0], r = t[1], i = t[2], a = t[3], o = n * a - i * r;
    return o ? (o = 1 / o, e1[0] = a * o, e1[1] = -r * o, e1[2] = -i * o, e1[3] = n * o, e1) : null;
}
function $902e455d852cdfb8$var$Cr(e1, t, n) {
    var r = t[0], i = t[1], a = t[2], o = t[3], s = Math.sin(n), c = Math.cos(n);
    return e1[0] = r * c + a * s, e1[1] = i * c + o * s, e1[2] = r * -s + a * c, e1[3] = i * -s + o * c, e1;
}
let $902e455d852cdfb8$var$wr, $902e455d852cdfb8$var$Tr, $902e455d852cdfb8$var$Er;
const $902e455d852cdfb8$var$Dr = {
    frame (e1, t, n, r) {
        let i = r || window, a = i.requestAnimationFrame((e1)=>{
            o(), t(e1);
        }), { unsubscribe: o } = (0, $caapT.Er)(e1.signal, `abort`, ()=>{
            o(), i.cancelAnimationFrame(a), n(new (0, $caapT.Dn)(e1.signal.reason));
        }, !1);
    },
    frameAsync (e1, t) {
        return new Promise((n, r)=>{
            this.frame(e1, n, r, t);
        });
    },
    getImageData (e1, t = 0) {
        return this.getImageCanvasContext(e1).getImageData(-t, -t, e1.width + 2 * t, e1.height + 2 * t);
    },
    getImageCanvasContext (e1) {
        let t = window.document.createElement(`canvas`), n = t.getContext(`2d`, {
            willReadFrequently: !0
        });
        if (!n) throw Error(`failed to create canvas 2d context`);
        return t.width = e1.width, t.height = e1.height, n.drawImage(e1, 0, 0, e1.width, e1.height), n;
    },
    resolveURL (e1) {
        return $902e455d852cdfb8$var$wr ||= document.createElement(`a`), $902e455d852cdfb8$var$wr.href = e1, $902e455d852cdfb8$var$wr.href;
    },
    get hardwareConcurrency () {
        return typeof navigator < `u` && navigator.hardwareConcurrency || 4;
    },
    get prefersReducedMotion () {
        return $902e455d852cdfb8$var$Er === void 0 ? matchMedia ? ($902e455d852cdfb8$var$Tr ??= matchMedia(`(prefers-reduced-motion: reduce)`), $902e455d852cdfb8$var$Tr.matches) : !1 : $902e455d852cdfb8$var$Er;
    },
    set prefersReducedMotion (e){
        $902e455d852cdfb8$var$Er = e;
    }
}, $902e455d852cdfb8$var$Or = new class {
    constructor(){
        this._frozenAt = null;
    }
    getCurrentTime() {
        return this._frozenAt === null ? performance.now() : this._frozenAt;
    }
    setNow(e1) {
        this._frozenAt = e1;
    }
    restoreNow() {
        this._frozenAt = null;
    }
    isFrozen() {
        return this._frozenAt !== null;
    }
};
function $902e455d852cdfb8$export$461939dd4422153() {
    return $902e455d852cdfb8$var$Or.getCurrentTime();
}
function $902e455d852cdfb8$export$6b09b4ca4892be7e(e1) {
    $902e455d852cdfb8$var$Or.setNow(e1);
}
function $902e455d852cdfb8$export$c893a3a0ea8f2422() {
    $902e455d852cdfb8$var$Or.restoreNow();
}
function $902e455d852cdfb8$export$b034adc12b1cc7ef() {
    return $902e455d852cdfb8$var$Or.isFrozen();
}
var $902e455d852cdfb8$var$W = class e1 {
    static{
        this.docStyle = typeof window < `u` && window.document?.documentElement.style;
    }
    static{
        this.selectProp = !e1.docStyle || `userSelect` in e1.docStyle ? `userSelect` : `webkitUserSelect`;
    }
    static create(e1, t, n) {
        let r = window.document.createElement(e1);
        return t !== void 0 && (r.className = t), n && n.appendChild(r), r;
    }
    static createNS(e1, t) {
        return window.document.createElementNS(e1, t);
    }
    static disableDrag() {
        e1.docStyle && e1.selectProp && (e1.userSelect = e1.docStyle[e1.selectProp], e1.docStyle[e1.selectProp] = `none`);
    }
    static enableDrag() {
        e1.docStyle && e1.selectProp && (e1.docStyle[e1.selectProp] = e1.userSelect);
    }
    static suppressClickInternal(t) {
        t.preventDefault(), t.stopPropagation(), window.removeEventListener(`click`, e1.suppressClickInternal, !0);
    }
    static suppressClick() {
        window.addEventListener(`click`, e1.suppressClickInternal, !0), window.setTimeout(()=>{
            window.removeEventListener(`click`, e1.suppressClickInternal, !0);
        }, 0);
    }
    static getScale(e1) {
        let t = e1.getBoundingClientRect();
        return {
            x: t.width / e1.offsetWidth || 1,
            y: t.height / e1.offsetHeight || 1,
            boundingClientRect: t
        };
    }
    static getPoint(e1, t, n) {
        let r = t.boundingClientRect;
        return new (0, $caapT.ji)((n.clientX - r.left) / t.x - e1.clientLeft, (n.clientY - r.top) / t.y - e1.clientTop);
    }
    static mousePos(t, n) {
        let r = e1.getScale(t);
        return e1.getPoint(t, r, n);
    }
    static touchPos(t, n) {
        let r = [], i = e1.getScale(t);
        for (let a of n)r.push(e1.getPoint(t, i, a));
        return r;
    }
    static sanitize(t) {
        let n = new DOMParser().parseFromString(t, `text/html`).body || document.createElement(`body`), r = n.querySelectorAll(`script`);
        for (let e1 of r)e1.remove();
        return e1.clean(n), n.innerHTML;
    }
    static isPossiblyDangerous(e1, t) {
        let n = t.replace(/\s+/g, ``).toLowerCase();
        if ([
            `src`,
            `href`,
            `xlink:href`
        ].includes(e1) && (n.includes(`javascript:`) || n.includes(`data:`)) || e1.startsWith(`on`)) return !0;
    }
    static clean(t) {
        let n = t.children;
        for (let t of n)e1.removeAttributes(t), e1.clean(t);
    }
    static removeAttributes(t) {
        for (let { name: n, value: r } of t.attributes)e1.isPossiblyDangerous(n, r) && t.removeAttribute(n);
    }
};
let $902e455d852cdfb8$var$Mr;
(function(e1) {
    let t, n, r, i;
    e1.resetRequestQueue = ()=>{
        t = [], n = 0, r = 0, i = {};
    }, e1.addThrottleControl = (e1)=>{
        let t = r++;
        return i[t] = e1, t;
    }, e1.removeThrottleControl = (e1)=>{
        delete i[e1], c();
    };
    let a = ()=>{
        for (let e1 of Object.keys(i))if (i[e1]()) return !0;
        return !1;
    };
    e1.getImage = (e1, n, r = !0, i)=>new Promise((a, o)=>{
            e1.headers ||= {}, e1.headers.accept = `image/webp,*/*`, (0, $caapT.Zn)(e1, {
                type: `image`
            });
            let s = {
                abortController: n,
                requestParameters: e1,
                supportImageRefresh: r,
                imageBitmapOptions: i,
                state: `queued`,
                onError: (e1)=>{
                    o(e1);
                },
                onSuccess: (e1)=>{
                    a(e1);
                }
            };
            t.push(s), c();
        });
    let o = (e1, t)=>typeof createImageBitmap == `function` ? (0, $caapT.Pn)(e1, t) : (0, $caapT.Nn)(e1), s = async (e1)=>{
        e1.state = `running`;
        let { requestParameters: t, supportImageRefresh: r, imageBitmapOptions: i, onError: a, onSuccess: s, abortController: u } = e1, d = r === !1 && !i && !(0, $caapT.ur)(self) && !(0, $caapT.wn)(t.url) && (!t.headers || Object.keys(t.headers).reduce((e1, t)=>e1 && t === `accept`, !0));
        n++;
        let f = d ? l(t, u) : (0, $caapT.xn)(t, u);
        try {
            let t = await f;
            delete e1.abortController, e1.state = `completed`, t.data instanceof HTMLImageElement || (0, $caapT.ar)(t.data) ? s(t) : t.data && s({
                data: await o(t.data, i),
                cacheControl: t.cacheControl,
                expires: t.expires
            });
        } catch (t) {
            delete e1.abortController, a((0, $caapT.Yn)(t));
        } finally{
            n--, c();
        }
    }, c = ()=>{
        let e1 = a() ? (0, $caapT.En).MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : (0, $caapT.En).MAX_PARALLEL_IMAGE_REQUESTS;
        for(let r = n; r < e1 && t.length > 0; r++){
            let e1 = t.shift();
            if (e1.abortController.signal.aborted) {
                r--;
                continue;
            }
            s(e1);
        }
    }, l = (e1, t)=>new Promise((n, r)=>{
            let i = new Image, a = e1.url, o = e1.credentials;
            o && o === `include` ? i.crossOrigin = `use-credentials` : (o && o === `same-origin` || !(0, $caapT.Sn)(a)) && (i.crossOrigin = `anonymous`), t.signal.addEventListener(`abort`, ()=>{
                i.src = ``, r(new (0, $caapT.Dn)(t.signal.reason));
            }), i.fetchPriority = `high`, i.onload = ()=>{
                i.onerror = i.onload = null, n({
                    data: i
                });
            }, i.onerror = ()=>{
                i.onerror = i.onload = null, !t.signal.aborted && r(Error(`Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
            }, i.src = a;
        });
})($902e455d852cdfb8$var$Mr ||= {}), $902e455d852cdfb8$var$Mr.resetRequestQueue();
var $902e455d852cdfb8$var$Nr = class {
    constructor(e1){
        this._transformRequestFn = e1 ?? null;
    }
    transformRequest(e1, t) {
        return this._transformRequestFn && this._transformRequestFn(e1, t) || {
            url: e1
        };
    }
    setTransformRequest(e1) {
        this._transformRequestFn = e1;
    }
}, $902e455d852cdfb8$export$fc21b96c04d10d16 = class extends (0, $caapT.pn) {
}, $902e455d852cdfb8$export$534b7a2acb0e16da = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
}, $902e455d852cdfb8$export$444e55cd0e2f4f3a = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`style.load`, e1);
    }
}, $902e455d852cdfb8$export$49025a11e3fe5bd0 = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
    constructor(e1, t = {}){
        super(e1, t), this.dataType = `style`;
    }
}, $902e455d852cdfb8$export$ae09c661b7a299b2 = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
    constructor(e1, t = {}){
        super(e1, t), this.dataType = `source`;
    }
}, $902e455d852cdfb8$export$83f023c8e5acf676 = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t, n, r = {}){
        n = n instanceof MouseEvent ? n : new MouseEvent(e1, n);
        let i = $902e455d852cdfb8$var$W.mousePos(t.getCanvas(), n), a = t.unproject(i);
        super(e1, (0, $caapT.Zn)({
            point: i,
            lngLat: a,
            originalEvent: n
        }, r)), this._defaultPrevented = !1, this.target = t;
    }
}, $902e455d852cdfb8$export$706699378fec3ddd = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t, n){
        let r = e1 === `touchend` ? n.changedTouches : n.touches, i = $902e455d852cdfb8$var$W.touchPos(t.getCanvasContainer(), r), a = i.map((e1)=>t.unproject(e1)), o = i.reduce((e1, t, n, r)=>e1.add(t.div(r.length)), new (0, $caapT.ji)(0, 0)), s = t.unproject(o);
        super(e1, {
            points: i,
            point: o,
            lngLats: a,
            lngLat: s,
            originalEvent: n
        }), this._defaultPrevented = !1;
    }
}, $902e455d852cdfb8$export$10870e40d23509f = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t){
        super(`wheel`, {
            originalEvent: t
        }), this._defaultPrevented = !1;
    }
}, $902e455d852cdfb8$export$702e4d7a848278fa = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
}, $902e455d852cdfb8$export$da1f2ab236a92d66 = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`terrain`, e1);
    }
}, $902e455d852cdfb8$export$f966cee55553279 = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`projectiontransition`, e1);
    }
}, $902e455d852cdfb8$export$3238995171e25bd5 = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
}, $902e455d852cdfb8$export$14816c15d485a7b9 = class extends $902e455d852cdfb8$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`styleimagemissing`, e1);
    }
};
function $902e455d852cdfb8$var$Gr(e1) {
    let t = [];
    if (typeof e1 == `string`) t.push({
        id: `default`,
        url: e1
    });
    else if (e1 && e1.length > 0) {
        let n = [];
        for (let { id: r, url: i } of e1){
            let e1 = `${r}${i}`;
            n.includes(e1) || (n.push(e1), t.push({
                id: r,
                url: i
            }));
        }
    }
    return t;
}
function $902e455d852cdfb8$var$Kr(e1, t, n) {
    try {
        let r = new URL(e1);
        return r.pathname += `${t}${n}`, r.toString();
    } catch  {
        throw Error(`Invalid sprite URL "${e1}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
    }
}
async function $902e455d852cdfb8$var$qr(e1, t, n, r) {
    let i = $902e455d852cdfb8$var$Gr(e1), a = n > 1 ? `@2x` : ``, o = {}, s = {};
    for (let { id: e1, url: n } of i){
        o[e1] = (0, $caapT.vn)(await t.transformRequest($902e455d852cdfb8$var$Kr(n, a, `.json`), `SpriteJSON`), r);
        let i = await t.transformRequest($902e455d852cdfb8$var$Kr(n, a, `.png`), `SpriteImage`);
        s[e1] = $902e455d852cdfb8$var$Mr.getImage(i, r);
    }
    return await Promise.all([
        ...Object.values(o),
        ...Object.values(s)
    ]), $902e455d852cdfb8$var$Jr(o, s);
}
async function $902e455d852cdfb8$var$Jr(e1, t) {
    let n = {};
    for(let r in e1){
        n[r] = {};
        let i = $902e455d852cdfb8$var$Dr.getImageCanvasContext((await t[r]).data), a = (await e1[r]).data;
        for(let e1 in a){
            let { width: t, height: o, x: s, y: c, sdf: l, pixelRatio: u, stretchX: d, stretchY: f, content: p, textFitWidth: m, textFitHeight: h } = a[e1], g = {
                width: t,
                height: o,
                x: s,
                y: c,
                context: i
            };
            n[r][e1] = {
                data: null,
                pixelRatio: u,
                sdf: l,
                stretchX: d,
                stretchY: f,
                content: p,
                textFitWidth: m,
                textFitHeight: h,
                spriteData: g
            };
        }
    }
    return n;
}
var $902e455d852cdfb8$var$Yr = class extends (0, $caapT.mn) {
    constructor(){
        super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.missingImageResolver = null, this.patterns = {}, this.atlasImage = new (0, $caapT._t)({
            width: 1,
            height: 1
        }), this.dirty = !0;
    }
    destroy() {
        this.atlasTexture &&= (this.atlasTexture.destroy(), null);
        for (let e1 of Object.keys(this.images))this.removeImage(e1);
        this.patterns = {}, this.atlasImage = new (0, $caapT._t)({
            width: 1,
            height: 1
        }), this.dirty = !0;
    }
    isLoaded() {
        return this.loaded;
    }
    setLoaded(e1) {
        if (this.loaded !== e1 && (this.loaded = e1, e1)) {
            for (let { ids: e1, promiseResolve: t } of this.requestors)t(this._getImagesForIds(e1));
            this.requestors = [];
        }
    }
    getImage(e1) {
        let t = this.images[e1];
        if (t && !t.data && t.spriteData) {
            let e1 = t.spriteData;
            t.data = new (0, $caapT._t)({
                width: e1.width,
                height: e1.height
            }, e1.context.getImageData(e1.x, e1.y, e1.width, e1.height).data), t.spriteData = null;
        }
        return t;
    }
    addImage(e1, t) {
        if (this.images[e1]) throw Error(`Image id ${e1} already exist, use updateImage instead`);
        this._validate(e1, t) && (this.images[e1] = t);
    }
    _validate(e1, t) {
        let n = !0, r = t.data || t.spriteData;
        return this._validateStretch(t.stretchX, r?.width) || (this.fire(new (0, $caapT.fn)(Error(`Image "${e1}" has invalid "stretchX" value`))), n = !1), this._validateStretch(t.stretchY, r?.height) || (this.fire(new (0, $caapT.fn)(Error(`Image "${e1}" has invalid "stretchY" value`))), n = !1), this._validateContent(t.content, t) || (this.fire(new (0, $caapT.fn)(Error(`Image "${e1}" has invalid "content" value`))), n = !1), n;
    }
    _validateStretch(e1, t) {
        if (!e1) return !0;
        let n = 0;
        for (let r of e1){
            if (r[0] < n || r[1] < r[0] || t < r[1]) return !1;
            n = r[1];
        }
        return !0;
    }
    _validateContent(e1, t) {
        if (!e1) return !0;
        if (e1.length !== 4) return !1;
        let n = t.spriteData, r = n?.width || t.data.width, i = n?.height || t.data.height;
        return e1[0] < 0 || r < e1[0] || e1[1] < 0 || i < e1[1] || e1[2] < 0 || r < e1[2] || e1[3] < 0 || i < e1[3] || e1[2] < e1[0] ? !1 : e1[3] >= e1[1];
    }
    updateImage(e1, t, n = !0) {
        let r = this.getImage(e1);
        if (n && (r.data.width !== t.data.width || r.data.height !== t.data.height)) throw Error(`size mismatch between old image (${r.data.width}x${r.data.height}) and new image (${t.data.width}x${t.data.height}).`);
        t.version = r.version + 1, this.images[e1] = t, this.updatedImages[e1] = !0;
    }
    removeImage(e1) {
        let t = this.images[e1];
        delete this.images[e1], delete this.patterns[e1], t.userImage?.onRemove && t.userImage.onRemove();
    }
    listImages() {
        return Object.keys(this.images);
    }
    setMissingImageResolver(e1) {
        this.missingImageResolver = e1;
    }
    getImages(e1) {
        return new Promise((t, n)=>{
            let r = !0;
            if (!this.isLoaded()) for (let t of e1)this.images[t] || (r = !1);
            this.isLoaded() || r ? t(this._getImagesForIds(e1)) : this.requestors.push({
                ids: e1,
                promiseResolve: t
            });
        });
    }
    async _getImagesForIds(e1) {
        let t = new Set(e1.filter((e1)=>!this.getImage(e1))), n = this.missingImageResolver;
        n && await Promise.all(Array.from(t, (e1)=>n(e1)));
        let r = {};
        for (let n of e1){
            let e1 = this.getImage(n);
            e1 && (t.delete(n), r[n] = {
                data: e1.data.clone(),
                pixelRatio: e1.pixelRatio,
                sdf: e1.sdf,
                version: e1.version,
                stretchX: e1.stretchX,
                stretchY: e1.stretchY,
                content: e1.content,
                textFitWidth: e1.textFitWidth,
                textFitHeight: e1.textFitHeight,
                hasRenderCallback: !!e1.userImage?.render
            });
        }
        for (let e1 of t)this.fire(new $902e455d852cdfb8$export$14816c15d485a7b9({
            id: e1
        })), (0, $caapT.Ar)(`Image "${e1}" could not be loaded. Please make sure you have added the image before it is needed with map.addImage(), resolved it with map.setMissingStyleImageResolver(), or included it in a "sprite" property in your style.`);
        return r;
    }
    getPixelSize() {
        let { width: e1, height: t } = this.atlasImage;
        return {
            width: e1,
            height: t
        };
    }
    getPattern(e1) {
        let t = this.patterns[e1], n = this.getImage(e1);
        if (!n) return null;
        if (t && t.position.version === n.version) return t.position;
        if (t) t.position.version = n.version;
        else {
            let t = {
                w: n.data.width + 2,
                h: n.data.height + 2,
                x: 0,
                y: 0
            }, r = new (0, $caapT.G)(t, n);
            this.patterns[e1] = {
                bin: t,
                position: r
            };
        }
        return this._updatePatternAtlas(), this.patterns[e1].position;
    }
    bind(e1) {
        let t = e1.gl;
        this.atlasTexture ? this.dirty &&= (this.atlasTexture.update(this.atlasImage), !1) : this.atlasTexture = new (0, $caapT.dt)(e1, this.atlasImage, t.RGBA), this.atlasTexture.bind(t.LINEAR, t.CLAMP_TO_EDGE);
    }
    _updatePatternAtlas() {
        let e1 = [];
        for(let t in this.patterns)e1.push(this.patterns[t].bin);
        let { w: t, h: n } = (0, $caapT.K)(e1), r = this.atlasImage;
        r.resize({
            width: t || 1,
            height: n || 1
        });
        for(let e1 in this.patterns){
            let { bin: t } = this.patterns[e1], n = t.x + 1, i = t.y + 1, a = this.getImage(e1).data, o = a.width, s = a.height;
            (0, $caapT._t).copy(a, r, {
                x: 0,
                y: 0
            }, {
                x: n,
                y: i
            }, {
                width: o,
                height: s
            }), (0, $caapT._t).copy(a, r, {
                x: 0,
                y: s - 1
            }, {
                x: n,
                y: i - 1
            }, {
                width: o,
                height: 1
            }), (0, $caapT._t).copy(a, r, {
                x: 0,
                y: 0
            }, {
                x: n,
                y: i + s
            }, {
                width: o,
                height: 1
            }), (0, $caapT._t).copy(a, r, {
                x: o - 1,
                y: 0
            }, {
                x: n - 1,
                y: i
            }, {
                width: 1,
                height: s
            }), (0, $caapT._t).copy(a, r, {
                x: 0,
                y: 0
            }, {
                x: n + o,
                y: i
            }, {
                width: 1,
                height: s
            });
        }
        this.dirty = !0;
    }
    beginFrame() {
        this.callbackDispatchedThisFrame = {};
    }
    dispatchRenderCallbacks(e1) {
        for (let t of e1){
            if (this.callbackDispatchedThisFrame[t]) continue;
            this.callbackDispatchedThisFrame[t] = !0;
            let e1 = this.getImage(t);
            e1 || (0, $caapT.Ar)(`Image with ID: "${t}" was not found`), (0, $caapT.q)(e1) && this.updateImage(t, e1);
        }
    }
    cloneImages() {
        let e1 = {};
        for(let t in this.images){
            let n = this.images[t];
            e1[t] = {
                ...n,
                data: n.data ? n.data.clone() : null
            };
        }
        return e1;
    }
};
async function $902e455d852cdfb8$var$Xr(e1, t, n, r) {
    let i = t * 256, a = i + 255, o = await (0, $caapT._n)(await r.transformRequest(n.replace(`{fontstack}`, e1).replace(`{range}`, `${i}-${a}`), `Glyphs`), new AbortController);
    if (!o?.data) throw Error(`Could not load glyph range. range: ${t}, ${i}-${a}`);
    let s = {};
    for (let e1 of (0, $caapT.J)(o.data))s[e1.id] = e1;
    return s;
}
const $902e455d852cdfb8$var$Zr = 0x56bc75e2d63100000, $902e455d852cdfb8$var$Qr = new Float64Array(256);
for(let e1 = 0; e1 < 256; e1++){
    let t = .5 - (e1 / 255) ** (1 / 2.2);
    $902e455d852cdfb8$var$Qr[e1] = t * Math.abs(t);
}
$902e455d852cdfb8$var$Qr[255] = -100000000000000000000;
var $902e455d852cdfb8$var$$r = class {
    constructor({ fontSize: e1 = 24, buffer: t = 3, radius: n = 8, cutoff: r = .25, fontFamily: i = `sans-serif`, fontWeight: a = `normal`, fontStyle: o = `normal`, lang: s = null } = {}){
        this.buffer = t, this.radius = n, this.cutoff = r, this.lang = s;
        let c = this.size = e1 + t * 4, l = this._createCanvas(c), u = this.ctx = l.getContext(`2d`, {
            willReadFrequently: !0
        });
        u.font = `${o} ${a} ${e1}px ${i}`, u.textBaseline = `alphabetic`, u.textAlign = `left`, u.fillStyle = `black`, this.gridOuter = new Float64Array(c * c), this.gridInner = new Float64Array(c * c), this.f = new Float64Array(c), this.z = new Float64Array(c + 1), this.v = new Uint16Array(c);
    }
    _createCanvas(e1) {
        if (typeof OffscreenCanvas < `u`) return new OffscreenCanvas(e1, e1);
        let t = document.createElement(`canvas`);
        return t.width = t.height = e1, t;
    }
    draw(e1) {
        let { width: t, actualBoundingBoxAscent: n, actualBoundingBoxDescent: r, actualBoundingBoxLeft: i, actualBoundingBoxRight: a } = this.ctx.measureText(e1), o = Math.ceil(n), s = Math.floor(-i), c = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(a) - s)), l = Math.max(0, Math.min(this.size - this.buffer, o + Math.ceil(r))), u = c + 2 * this.buffer, d = l + 2 * this.buffer, f = Math.max(u * d, 0), p = new Uint8ClampedArray(f), m = {
            data: p,
            width: u,
            height: d,
            glyphWidth: c,
            glyphHeight: l,
            glyphTop: o,
            glyphLeft: s,
            glyphAdvance: t
        };
        if (c === 0 || l === 0) return m;
        let { ctx: h, buffer: g, gridInner: _, gridOuter: v } = this;
        this.lang && (h.lang = this.lang), h.clearRect(g, g, c, l), h.fillText(e1, g - s, g + o);
        let y = h.getImageData(g, g, c, l);
        v.fill($902e455d852cdfb8$var$Zr, 0, f), _.fill(0, 0, f);
        let b = 3;
        for(let e1 = 0; e1 < l; e1++){
            let t = (e1 + g) * u + g;
            for(let e1 = 0; e1 < c; e1++, b += 4, t++){
                let e1 = y.data[b];
                if (e1 === 0) continue;
                let n = $902e455d852cdfb8$var$Qr[e1];
                v[t] = Math.max(0, n), _[t] = Math.max(0, -n);
            }
        }
        $902e455d852cdfb8$var$ei(v, 0, 0, u, d, u, this.f, this.v, this.z);
        let x = Math.min(g, 1);
        $902e455d852cdfb8$var$ei(_, g - x, g - x, c + 2 * x, l + 2 * x, u, this.f, this.v, this.z);
        let S = 255 / this.radius, C = 255 * (1 - this.cutoff);
        for(let e1 = 0; e1 < f; e1++){
            let t = Math.sqrt(v[e1]) - Math.sqrt(_[e1]);
            p[e1] = Math.round(C - S * t);
        }
        return m;
    }
};
function $902e455d852cdfb8$var$ei(e1, t, n, r, i, a, o, s, c) {
    for(let l = t; l < t + r; l++)$902e455d852cdfb8$var$ti(e1, n * a + l, a, i, o, s, c);
    for(let l = n; l < n + i; l++)$902e455d852cdfb8$var$ti(e1, l * a + t, 1, r, o, s, c);
}
function $902e455d852cdfb8$var$ti(e1, t, n, r, i, a, o) {
    a[0] = 0, o[0] = -100000000000000000000, o[1] = $902e455d852cdfb8$var$Zr, i[0] = e1[t];
    for(let s = 1, c = 0, l = 0; s < r; s++){
        i[s] = e1[t + s * n];
        let r = s * s;
        do {
            let e1 = a[c];
            l = (i[s] - i[e1] + r - e1 * e1) / (s - e1) / 2;
        }while (l <= o[c] && --c > -1);
        c++, a[c] = s, o[c] = l, o[c + 1] = $902e455d852cdfb8$var$Zr;
    }
    for(let s = 0, c = 0; s < r; s++){
        for(; o[c + 1] < s;)c++;
        let r = a[c], l = s - r;
        e1[t + s * n] = i[r] + l * l;
    }
}
const $902e455d852cdfb8$var$ni = (0, $caapT.dn).layout_symbol[`text-font`].default.join(`,`);
var $902e455d852cdfb8$var$ri = class e1 {
    static{
        this.loadGlyphRange = $902e455d852cdfb8$var$Xr;
    }
    static{
        this.TinySDF = $902e455d852cdfb8$var$$r;
    }
    constructor(e1, t, n){
        this.requestManager = e1, this.localIdeographFontFamily = t, this.entries = {}, this.lang = n;
    }
    setURL(e1) {
        this.url = e1;
    }
    async getGlyphs(e1) {
        let t = [];
        for(let n in e1)for (let r of e1[n])t.push(this._getAndCacheGlyphsPromise(n, r));
        let n = await Promise.all(t), r = {};
        for (let { stack: e1, id: t, glyph: i } of n)r[e1] ||= {}, r[e1][t] = i && {
            id: i.id,
            bitmap: i.bitmap.clone(),
            metrics: i.metrics
        };
        return r;
    }
    async _getAndCacheGlyphsPromise(e1, t) {
        this.entries[e1] ??= {
            glyphs: {},
            requests: {},
            ranges: {}
        };
        let n = this.entries[e1], r = n.glyphs[t];
        return r === void 0 ? !this.url || this._charUsesLocalIdeographFontFamily(t) ? (r = n.glyphs[t] = await this._drawGlyph(n, e1, t), {
            stack: e1,
            id: t,
            glyph: r
        }) : await this._downloadAndCacheRangePromise(e1, t) : {
            stack: e1,
            id: t,
            glyph: r
        };
    }
    async _downloadAndCacheRangePromise(t, n) {
        let r = this.entries[t], i = Math.floor(n / 256);
        if (r.ranges[i]) return {
            stack: t,
            id: n,
            glyph: null
        };
        r.requests[i] ||= e1.loadGlyphRange(t, i, this.url, this.requestManager);
        try {
            let e1 = await r.requests[i];
            for(let t in e1)r.glyphs[+t] = e1[+t];
            return r.ranges[i] = !0, {
                stack: t,
                id: n,
                glyph: e1[n] || null
            };
        } catch (e1) {
            let a = r.glyphs[n] = await this._drawGlyph(r, t, n);
            return this._warnOnMissingGlyphRange(a, i, n, (0, $caapT.Yn)(e1)), {
                stack: t,
                id: n,
                glyph: a
            };
        }
    }
    _warnOnMissingGlyphRange(e1, t, n, r) {
        let i = t * 256;
        (0, $caapT.Ar)(`Unable to load glyph range ${t}, ${i}-${i + 255}. Rendering codepoint U+${n.toString(16).padStart(4, `0`).toUpperCase()} locally instead. ${r}`);
    }
    _charUsesLocalIdeographFontFamily(e1) {
        return !!this.localIdeographFontFamily && (0, $caapT.qt)(e1);
    }
    async _drawGlyph(e1, t, n) {
        let r = t === $902e455d852cdfb8$var$ni && this.localIdeographFontFamily !== `` && this._charUsesLocalIdeographFontFamily(n), i = r ? `ideographTinySDF` : `tinySDF`;
        e1[i] ||= this._createTinySDF(r ? this.localIdeographFontFamily : t);
        let a = (await e1[i]).draw(String.fromCodePoint(n)), o = /^\p{gc=Cf}+$/u.test(String.fromCodePoint(n));
        return {
            id: n,
            bitmap: new (0, $caapT.gt)({
                width: a.width || 60,
                height: a.height || 60
            }, a.data),
            metrics: {
                width: o ? 0 : a.glyphWidth / 2 || 24,
                height: a.glyphHeight / 2 || 24,
                left: a.glyphLeft / 2 + .5 || 0,
                top: a.glyphTop / 2 - 27.5 || -8,
                advance: o ? 0 : a.glyphAdvance / 2 || 24,
                isDoubleResolution: !0
            }
        };
    }
    async _createTinySDF(t) {
        let n = t ? t.split(`,`) : [];
        n.push(`sans-serif`);
        let r = n.map((e1)=>/[-\w]+/.test(e1) ? e1 : `'${CSS.escape(e1)}'`).join(`,`), i = this._fontWeight(n[0]), o = this._fontStyle(n[0]);
        if (typeof document < `u` && document.fonts?.load) try {
            await document.fonts.load(`${o} ${i || `normal`} 48px ${r}`);
        } catch (e1) {
            (0, $caapT.Ar)(`Failed to load font "${r}": ${(0, $caapT.Yn)(e1).message}`);
        }
        return new e1.TinySDF({
            fontSize: 48,
            buffer: 6,
            radius: 16,
            cutoff: .25,
            fontFamily: r,
            fontWeight: i,
            fontStyle: o,
            lang: this.lang
        });
    }
    _fontStyle(e1) {
        return /italic/i.test(e1) ? `italic` : /oblique/i.test(e1) ? `oblique` : `normal`;
    }
    _fontWeight(e1) {
        let t = {
            thin: 100,
            hairline: 100,
            "extra light": 200,
            "ultra light": 200,
            light: 300,
            normal: 400,
            regular: 400,
            medium: 500,
            semibold: 600,
            demibold: 600,
            bold: 700,
            "extra bold": 800,
            "ultra bold": 800,
            black: 900,
            heavy: 900,
            "extra black": 950,
            "ultra black": 950
        }, n;
        for (let [r, i] of Object.entries(t))RegExp(`\\b${r}\\b`, `i`).test(e1) && (n = `${i}`);
        return n;
    }
    destroy() {
        for(let e1 in this.entries){
            let t = this.entries[e1];
            t.tinySDF = null, t.ideographTinySDF = null, t.glyphs = {}, t.requests = {}, t.ranges = {};
        }
        this.entries = {};
    }
};
let $902e455d852cdfb8$var$ii;
const $902e455d852cdfb8$var$ai = ()=>$902e455d852cdfb8$var$ii ||= new (0, $caapT.Ht)({
        anchor: new (0, $caapT.Vt)((0, $caapT.dn).light.anchor, `anchor`),
        position: new (0, $caapT.Vt)((0, $caapT.dn).light.position, `position`),
        color: new (0, $caapT.Vt)((0, $caapT.dn).light.color, `color`),
        intensity: new (0, $caapT.Vt)((0, $caapT.dn).light.intensity, `intensity`)
    });
var $902e455d852cdfb8$var$oi = class extends (0, $caapT.mn) {
    constructor(e1){
        super(), this._transitionable = new (0, $caapT.Wt)($902e455d852cdfb8$var$ai(), `light`, void 0), this.setLight(e1), this._transitioning = this._transitionable.untransitioned();
    }
    getLight() {
        return this._transitionable.serialize();
    }
    getCartesianPosition() {
        return (0, $caapT.Tr)(this.properties.get(`position`));
    }
    setLight(e1, t = {}) {
        if (!this._validate((0, $caapT.$t).light, e1, t)) for(let t in e1){
            let n = e1[t];
            t.endsWith(`-transition`) ? this._transitionable.setTransition(t.slice(0, -(0, $caapT.Ut).length), n) : this._transitionable.setValue(t, n);
        }
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
    _validate(e1, t, n) {
        return (0, $caapT.Qt)(this, e1, {
            value: t
        }, n);
    }
};
let $902e455d852cdfb8$var$si;
const $902e455d852cdfb8$var$ci = ()=>$902e455d852cdfb8$var$si ||= new (0, $caapT.Ht)({
        "sky-color": new (0, $caapT.Vt)((0, $caapT.dn).sky[`sky-color`], `sky-color`),
        "horizon-color": new (0, $caapT.Vt)((0, $caapT.dn).sky[`horizon-color`], `horizon-color`),
        "fog-color": new (0, $caapT.Vt)((0, $caapT.dn).sky[`fog-color`], `fog-color`),
        "fog-ground-blend": new (0, $caapT.Vt)((0, $caapT.dn).sky[`fog-ground-blend`], `fog-ground-blend`),
        "horizon-fog-blend": new (0, $caapT.Vt)((0, $caapT.dn).sky[`horizon-fog-blend`], `horizon-fog-blend`),
        "sky-horizon-blend": new (0, $caapT.Vt)((0, $caapT.dn).sky[`sky-horizon-blend`], `sky-horizon-blend`),
        "atmosphere-blend": new (0, $caapT.Vt)((0, $caapT.dn).sky[`atmosphere-blend`], `atmosphere-blend`)
    });
var $902e455d852cdfb8$var$li = class extends (0, $caapT.mn) {
    constructor(e1){
        super(), this._transitionable = new (0, $caapT.Wt)($902e455d852cdfb8$var$ci(), `sky`, void 0), this.setSky(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new (0, $caapT.Gt)(0));
    }
    setSky(e1, t = {}) {
        if (!this._validate((0, $caapT.$t).sky, e1, t)) {
            e1 ||= {
                "sky-color": `transparent`,
                "horizon-color": `transparent`,
                "fog-color": `transparent`,
                "fog-ground-blend": 1,
                "atmosphere-blend": 0
            };
            for(let t in e1){
                let n = e1[t];
                t.endsWith(`-transition`) ? this._transitionable.setTransition(t.slice(0, -(0, $caapT.Ut).length), n) : this._transitionable.setValue(t, n);
            }
        }
    }
    getSky() {
        return this._transitionable.serialize();
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
    _validate(e1, t, n = {}) {
        return (0, $caapT.Qt)(this, e1, {
            value: t
        }, n);
    }
    calculateFogBlendOpacity(e1) {
        return e1 < 60 ? 0 : e1 < 70 ? (e1 - 60) / 10 : 1;
    }
}, $902e455d852cdfb8$var$ui = class {
    constructor(e1, t){
        this.width = e1, this.height = t, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
    }
    getDash(e1, t) {
        let n = e1.join(`,`) + String(t);
        return this.dashEntry[n] ||= this.addDash(e1, t), this.dashEntry[n];
    }
    getDashRanges(e1, t, n) {
        let r = e1.length % 2 == 1, i = [], a = r ? -e1[e1.length - 1] * n : 0, o = e1[0] * n, s = !0;
        i.push({
            left: a,
            right: o,
            isDash: s,
            zeroLength: e1[0] === 0
        });
        let c = e1[0];
        for(let t = 1; t < e1.length; t++){
            s = !s;
            let r = e1[t];
            a = c * n, c += r, o = c * n, i.push({
                left: a,
                right: o,
                isDash: s,
                zeroLength: r === 0
            });
        }
        return i;
    }
    addRoundDash(e1, t, n) {
        let r = t / 2;
        for(let t = -n; t <= n; t++){
            let i = this.nextRow + n + t, a = this.width * i, o = 0, s = e1[o];
            for(let i = 0; i < this.width; i++){
                i / s.right > 1 && (s = e1[++o]);
                let c = Math.abs(i - s.left), l = Math.abs(i - s.right), u = Math.min(c, l), d, f = t / n * (r + 1);
                if (s.isDash) {
                    let e1 = r - Math.abs(f);
                    d = Math.sqrt(u * u + e1 * e1);
                } else d = r - Math.sqrt(u * u + f * f);
                this.data[a + i] = Math.max(0, Math.min(255, d + 128));
            }
        }
    }
    addRegularDash(e1) {
        for(let t = e1.length - 1; t >= 0; --t){
            let n = e1[t], r = e1[t + 1];
            n.zeroLength ? e1.splice(t, 1) : r?.isDash === n.isDash && (r.left = n.left, e1.splice(t, 1));
        }
        let t = e1[0], n = e1[e1.length - 1];
        t.isDash === n.isDash && (t.left = n.left - this.width, n.right = t.right + this.width);
        let r = this.width * this.nextRow, i = 0, a = e1[i];
        for(let t = 0; t < this.width; t++){
            t / a.right > 1 && (a = e1[++i]);
            let n = Math.abs(t - a.left), o = Math.abs(t - a.right), s = Math.min(n, o), c = a.isDash ? s : -s;
            this.data[r + t] = Math.max(0, Math.min(255, c + 128));
        }
    }
    addDash(e1, t) {
        let n = t ? 7 : 0, r = 2 * n + 1;
        if (this.nextRow + r > this.height) return (0, $caapT.Ar)(`LineAtlas out of space`), null;
        let i = 0;
        for (let t of e1)i += t;
        if (i !== 0) {
            let r = this.width / i, a = this.getDashRanges(e1, this.width, r);
            t ? this.addRoundDash(a, r, n) : this.addRegularDash(a);
        }
        let o = {
            y: this.nextRow + n,
            height: 2 * n,
            width: i
        };
        return this.nextRow += r, this.dirty = !0, o;
    }
    bind(e1) {
        let t = e1.gl;
        this.texture ? (t.bindTexture(t.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, this.width, this.height, t.ALPHA, t.UNSIGNED_BYTE, this.data))) : (this.texture = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.texture), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texImage2D(t.TEXTURE_2D, 0, t.ALPHA, this.width, this.height, 0, t.ALPHA, t.UNSIGNED_BYTE, this.data));
    }
};
function $902e455d852cdfb8$var$di(e1) {
    if (!e1) return !1;
    let t = globalThis.location;
    if (!t) return !1;
    try {
        return new URL(e1, t.href).origin !== t.origin;
    } catch  {
        return !1;
    }
}
function $902e455d852cdfb8$var$fi() {
    let e1 = "file:///node_modules/maplibre-gl/dist/maplibre-gl.mjs";
    if (!/^https?:/.test(e1)) return ``;
    let t = e1.endsWith(`-dev.mjs`) ? `maplibre-gl-worker-dev.mjs` : `maplibre-gl-worker.mjs`;
    return new URL(`./${t}`, e1).href;
}
function $902e455d852cdfb8$var$pi(e1, t) {
    if (t) try {
        return new Worker(e1, {
            type: `module`
        });
    } catch (e1) {
        console.warn(`Module worker not supported, falling back to classic worker`, e1);
    }
    return new Worker(e1);
}
async function $902e455d852cdfb8$var$mi(e1) {
    let t = await fetch(e1);
    if (!t.ok) throw Error(`Failed to fetch worker script (${t.status}): ${e1}`);
    let n = await t.text(), r = new Blob([
        n
    ], {
        type: `text/javascript`
    });
    return URL.createObjectURL(r);
}
function $902e455d852cdfb8$var$hi(e1) {
    let t = new Blob([
        `import ${JSON.stringify(new URL(e1, "file:///node_modules/maplibre-gl/dist/maplibre-gl.mjs").href)}`
    ], {
        type: `text/javascript`
    });
    return URL.createObjectURL(t);
}
async function $902e455d852cdfb8$var$gi() {
    let e1 = (0, $caapT.En).WORKER_URL || $902e455d852cdfb8$var$fi(), t = !e1?.endsWith(`.cjs`);
    if (!$902e455d852cdfb8$var$di(e1)) return $902e455d852cdfb8$var$pi(e1, t);
    if (t) {
        let n = $902e455d852cdfb8$var$hi(e1);
        try {
            return $902e455d852cdfb8$var$pi(n, t);
        } finally{
            URL.revokeObjectURL(n);
        }
    }
    let n = await $902e455d852cdfb8$var$mi(e1);
    try {
        return $902e455d852cdfb8$var$pi(n, t);
    } finally{
        URL.revokeObjectURL(n);
    }
}
const $902e455d852cdfb8$var$_i = `maplibre_preloaded_worker_pool`;
var $902e455d852cdfb8$var$vi = class e1 {
    constructor(){
        this.active = {}, this.workersPromise = null;
    }
    async acquire(t) {
        if (this.active[t] = !0, !this.workersPromise) {
            let t = [];
            for(; t.length < e1.workerCount;)t.push($902e455d852cdfb8$var$gi());
            this.workersPromise = Promise.all(t);
        }
        return (await this.workersPromise).slice();
    }
    release(e1) {
        if (delete this.active[e1], this.numActive() === 0 && this.workersPromise) {
            let e1 = this.workersPromise;
            this.workersPromise = null, e1.then((e1)=>{
                for (let t of e1)t.terminate();
            });
        }
    }
    isPreloaded() {
        return !!this.active[$902e455d852cdfb8$var$_i];
    }
    numActive() {
        return Object.keys(this.active).length;
    }
};
const $902e455d852cdfb8$var$yi = Math.floor($902e455d852cdfb8$var$Dr.hardwareConcurrency / 2);
$902e455d852cdfb8$var$vi.workerCount = (0, $caapT.sr)(globalThis) ? Math.max(Math.min($902e455d852cdfb8$var$yi, 3), 1) : 1;
let $902e455d852cdfb8$var$bi;
function $902e455d852cdfb8$var$xi() {
    return $902e455d852cdfb8$var$bi ||= new $902e455d852cdfb8$var$vi, $902e455d852cdfb8$var$bi;
}
function $902e455d852cdfb8$export$ea453d9c8cc3d5d2() {
    $902e455d852cdfb8$var$xi().acquire($902e455d852cdfb8$var$_i);
}
function $902e455d852cdfb8$export$3b8bb46c10ecf86e() {
    let e1 = $902e455d852cdfb8$var$bi;
    e1 && (e1.isPreloaded() && e1.numActive() === 1 ? (e1.release($902e455d852cdfb8$var$_i), $902e455d852cdfb8$var$bi = null) : console.warn(`Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()`));
}
var $902e455d852cdfb8$var$wi = class {
    constructor(e1, t){
        this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = t, this.removed = !1, this.actorsPromise = this.initActors(t);
    }
    async initActors(e1) {
        let t = await this.workerPool.acquire(e1);
        if (this.removed) return [];
        if (this.actors = t.map((t, n)=>{
            let r = new (0, $caapT.j)(t, e1);
            return r.name = `Worker ${n}`, r;
        }), !this.actors.length) throw Error(`No actors found`);
        return this.actors;
    }
    async broadcast(e1, t) {
        let n = await this.actorsPromise;
        return Promise.all(n.map((n)=>n.sendAsync({
                type: e1,
                data: t
            })));
    }
    async getActor() {
        let e1 = await this.actorsPromise;
        return this.currentActor = (this.currentActor + 1) % e1.length, e1[this.currentActor];
    }
    async waitForInitComplete() {
        this.actors.length === 0 && await this.actorsPromise;
    }
    getReadyActor() {
        return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
    }
    remove(e1 = !0) {
        this.removed = !0;
        for (let e1 of this.actors)e1.remove();
        this.actors = [], e1 && this.workerPool.release(this.id);
    }
    async registerMessageHandler(e1, t) {
        let n = await this.actorsPromise;
        for (let r of n)r.registerMessageHandler(e1, t);
    }
    async unregisterMessageHandler(e1) {
        let t = await this.actorsPromise;
        for (let n of t)n.unregisterMessageHandler(e1);
    }
};
let $902e455d852cdfb8$var$Ti;
function $902e455d852cdfb8$export$6f0c702cbe7d6ed8() {
    return $902e455d852cdfb8$var$Ti || ($902e455d852cdfb8$var$Ti = new $902e455d852cdfb8$var$wi($902e455d852cdfb8$var$xi(), (0, $caapT.gn)), $902e455d852cdfb8$var$Ti.registerMessageHandler(`GR`, (e1, t, n)=>(0, $caapT.xn)(t, n))), $902e455d852cdfb8$var$Ti;
}
function $902e455d852cdfb8$var$Di(e1, t) {
    let n = (0, $caapT.fi)();
    return (0, $caapT.Ti)(n, n, [
        1,
        1,
        0
    ]), (0, $caapT.wi)(n, n, [
        e1.width * .5,
        e1.height * .5,
        1
    ]), e1.calculatePosMatrix ? (0, $caapT.vi)(n, n, e1.calculatePosMatrix(t.toUnwrapped())) : n;
}
function $902e455d852cdfb8$var$Oi(e1, t, n) {
    if (e1) for (let r of e1){
        let e1 = t[r];
        if (e1?.source === n && e1.type === `fill-extrusion`) return !0;
    }
    else for(let e1 in t){
        let r = t[e1];
        if (r.source === n && r.type === `fill-extrusion`) return !0;
    }
    return !1;
}
function $902e455d852cdfb8$var$ki(e1, t, n, r, i, a, o) {
    let s = $902e455d852cdfb8$var$Oi(i?.layers ?? null, t, e1.id), c = a.maxPitchScaleFactor(), l = e1.tilesIn(r, c, s);
    l.sort($902e455d852cdfb8$var$Mi);
    let u = [];
    for (let r of l)u.push({
        wrappedTileID: r.tileID.wrapped().key,
        queryResults: r.tile.queryRenderedFeatures(t, n, e1.getState(), r.queryGeometry, r.cameraQueryGeometry, r.scale, i, a, c, $902e455d852cdfb8$var$Di(a, r.tileID), o ? (e1, t)=>o(r.tileID, e1, t) : void 0)
    });
    return $902e455d852cdfb8$var$Pi($902e455d852cdfb8$var$Ni(u), e1);
}
function $902e455d852cdfb8$var$Ai(e1, t, n, r, i, a, o) {
    let s = {}, c = a.queryRenderedSymbols(r), l = [];
    for (let e1 of Object.keys(c).map(Number))l.push(o[e1]);
    l.sort($902e455d852cdfb8$var$Mi);
    for (let n of l){
        let r = n.featureIndex.lookupSymbolFeatures(c[n.bucketInstanceId], t, n.bucketIndex, n.sourceLayerIndex, {
            filterSpec: i.filter,
            globalState: i.globalState
        }, i.layers, i.availableImages, e1);
        for(let e1 in r){
            s[e1] ||= [];
            let t = r[e1];
            t.sort((e1, t)=>{
                let r = n.featureSortOrder;
                if (r) {
                    let n = r.indexOf(e1.featureIndex);
                    return r.indexOf(t.featureIndex) - n;
                } else return t.featureIndex - e1.featureIndex;
            });
            for (let n of t)s[e1].push(n);
        }
    }
    return $902e455d852cdfb8$var$Fi(s, e1, n);
}
function $902e455d852cdfb8$var$ji(e1, t) {
    let n = e1.getRenderableIds().map((t)=>e1.getTileByID(t)), r = [], i = {};
    for (let e1 of n){
        let n = e1.tileID.canonical.key;
        i[n] || (i[n] = !0, e1.querySourceFeatures(r, t));
    }
    return r;
}
function $902e455d852cdfb8$var$Mi(e1, t) {
    let n = e1.tileID, r = t.tileID;
    return n.overscaledZ - r.overscaledZ || n.canonical.y - r.canonical.y || n.wrap - r.wrap || n.canonical.x - r.canonical.x;
}
function $902e455d852cdfb8$var$Ni(e1) {
    let t = {}, n = {};
    for (let { queryResults: r, wrappedTileID: i } of e1){
        n[i] ||= {};
        let e1 = n[i];
        for(let n in r){
            let i = r[n];
            e1[n] ||= {};
            let a = e1[n];
            t[n] ||= [];
            for (let e1 of i)a[e1.featureIndex] || (a[e1.featureIndex] = !0, t[n].push(e1));
        }
    }
    return t;
}
function $902e455d852cdfb8$var$Pi(e1, t) {
    for(let n in e1)for (let r of e1[n])$902e455d852cdfb8$var$Ii(r, t);
    return e1;
}
function $902e455d852cdfb8$var$Fi(e1, t, n) {
    for(let r in e1)for (let i of e1[r]){
        let e1 = n[t[r].source];
        $902e455d852cdfb8$var$Ii(i, e1);
    }
    return e1;
}
function $902e455d852cdfb8$var$Ii(e1, t) {
    let n = e1.feature, r = t.getFeatureState(n.layer[`source-layer`], n.id);
    n.source = n.layer.source, n.layer[`source-layer`] && (n.sourceLayer = n.layer[`source-layer`]), n.state = r;
}
async function $902e455d852cdfb8$var$Li(e1, t, n, r) {
    let i = e1;
    if (e1.url ? i = (await (0, $caapT.vn)(await t.transformRequest(e1.url, `Source`), n)).data : await $902e455d852cdfb8$var$Dr.frameAsync(n, r), !i) return null;
    let a = (0, $caapT.gr)((0, $caapT.Zn)(i, e1), [
        `tiles`,
        `minzoom`,
        `maxzoom`,
        `attribution`,
        `bounds`,
        `scheme`,
        `tileSize`,
        `encoding`
    ]);
    return `vector_layers` in i && i.vector_layers && (a.vectorLayerIds = i.vector_layers.map((e1)=>e1.id)), a;
}
var $902e455d852cdfb8$export$266d2884f61535d3 = class e1 {
    constructor(e1, t){
        e1 && (t ? this.setSouthWest(e1).setNorthEast(t) : Array.isArray(e1) && (e1.length === 4 ? this.setSouthWest([
            e1[0],
            e1[1]
        ]).setNorthEast([
            e1[2],
            e1[3]
        ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1])));
    }
    setNorthEast(e1) {
        return this._ne = e1 instanceof (0, $caapT.k) ? new (0, $caapT.k)(e1.lng, e1.lat) : (0, $caapT.k).convert(e1), this;
    }
    setSouthWest(e1) {
        return this._sw = e1 instanceof (0, $caapT.k) ? new (0, $caapT.k)(e1.lng, e1.lat) : (0, $caapT.k).convert(e1), this;
    }
    extend(t) {
        let n = this._sw, r = this._ne, i, a;
        if (t instanceof (0, $caapT.k)) i = t, a = t;
        else if (t instanceof e1) {
            if (i = t._sw, a = t._ne, !i || !a) return this;
        } else {
            if (Array.isArray(t)) {
                if (t.length === 4 || t.every(Array.isArray)) {
                    let n = t;
                    return this.extend(e1.convert(n));
                } else {
                    let e1 = t;
                    return this.extend((0, $caapT.k).convert(e1));
                }
            } else if (t && (`lng` in t || `lon` in t) && `lat` in t) return this.extend((0, $caapT.k).convert(t));
            return this;
        }
        return !n && !r ? (this._sw = new (0, $caapT.k)(i.lng, i.lat), this._ne = new (0, $caapT.k)(a.lng, a.lat)) : (n.lng = Math.min(i.lng, n.lng), n.lat = Math.min(i.lat, n.lat), r.lng = Math.max(a.lng, r.lng), r.lat = Math.max(a.lat, r.lat)), this;
    }
    getCenter() {
        return new (0, $caapT.k)((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
    }
    getSouthWest() {
        return this._sw;
    }
    getNorthEast() {
        return this._ne;
    }
    getNorthWest() {
        return new (0, $caapT.k)(this.getWest(), this.getNorth());
    }
    getSouthEast() {
        return new (0, $caapT.k)(this.getEast(), this.getSouth());
    }
    getWest() {
        return this._sw.lng;
    }
    getSouth() {
        return this._sw.lat;
    }
    getEast() {
        return this._ne.lng;
    }
    getNorth() {
        return this._ne.lat;
    }
    toArray() {
        return [
            this._sw.toArray(),
            this._ne.toArray()
        ];
    }
    toString() {
        return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
    }
    isEmpty() {
        return !(this._sw && this._ne);
    }
    contains(e1) {
        let { lng: t, lat: n } = (0, $caapT.k).convert(e1), r = this._sw.lat <= n && n <= this._ne.lat, i = this._sw.lng <= t && t <= this._ne.lng;
        return this._sw.lng > this._ne.lng && (i = this._sw.lng >= t && t >= this._ne.lng), r && i;
    }
    intersects(t) {
        if (t = e1.convert(t), !(t.getNorth() >= this.getSouth() && t.getSouth() <= this.getNorth())) return !1;
        let n = Math.abs(this.getEast() - this.getWest()), r = Math.abs(t.getEast() - t.getWest());
        if (n >= 360 || r >= 360) return !0;
        let i = (0, $caapT.jr)(this.getWest(), -180, 180), a = (0, $caapT.jr)(this.getEast(), -180, 180), o = (0, $caapT.jr)(t.getWest(), -180, 180), s = (0, $caapT.jr)(t.getEast(), -180, 180), c = i > a, l = o > s;
        return c && l ? !0 : c ? s >= i || o <= a : l ? a >= o || i <= s : o <= a && s >= i;
    }
    static convert(t) {
        return t instanceof e1 || !t ? t : new e1(t);
    }
    static fromLngLat(t, n = 0) {
        let r = 360 * n / 40075017, i = r / Math.cos(Math.PI / 180 * t.lat);
        return new e1(new (0, $caapT.k)(t.lng - i, t.lat - r), new (0, $caapT.k)(t.lng + i, t.lat + r));
    }
    adjustAntiMeridian() {
        let t = new (0, $caapT.k)(this._sw.lng, this._sw.lat), n = new (0, $caapT.k)(this._ne.lng, this._ne.lat);
        return t.lng > n.lng ? new e1(t, new (0, $caapT.k)(n.lng + 360, n.lat)) : new e1(t, n);
    }
}, $902e455d852cdfb8$var$zi = class {
    constructor(e1, t, n){
        this.bounds = $902e455d852cdfb8$export$266d2884f61535d3.convert(this.validateBounds(e1)), this.minzoom = t || 0, this.maxzoom = n || 24;
    }
    validateBounds(e1) {
        return !Array.isArray(e1) || e1.length !== 4 ? [
            -180,
            -90,
            180,
            90
        ] : [
            Math.max(-180, e1[0]),
            Math.max(-90, e1[1]),
            Math.min(180, e1[2]),
            Math.min(90, e1[3])
        ];
    }
    contains(e1) {
        let t = 2 ** e1.z, n = {
            minX: Math.floor((0, $caapT.E)(this.bounds.getWest()) * t),
            minY: Math.floor((0, $caapT.D)(this.bounds.getNorth()) * t),
            maxX: Math.ceil((0, $caapT.E)(this.bounds.getEast()) * t),
            maxY: Math.ceil((0, $caapT.D)(this.bounds.getSouth()) * t)
        };
        return e1.x >= n.minX && e1.x < n.maxX && e1.y >= n.minY && e1.y < n.maxY;
    }
}, $902e455d852cdfb8$export$5feeb63c172810c5 = class extends (0, $caapT.mn) {
    constructor(e1, t, n, r){
        if (super(), this.id = e1, this.dispatcher = n, this.type = `vector`, this.minzoom = 0, this.maxzoom = 22, this.scheme = `xyz`, this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, (0, $caapT.Zn)(this, (0, $caapT.gr)(t, [
            `url`,
            `scheme`,
            `tileSize`,
            `promoteId`,
            `encoding`
        ])), this._options = (0, $caapT.Zn)({
            type: `vector`
        }, t), this._collectResourceTiming = t.collectResourceTiming, this.tileSize !== 512) throw Error(`vector tile sources must have a tileSize of 512`);
        this.setEventedParent(r);
    }
    async load(e1 = !1) {
        this._loaded = !1, this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`dataloading`)), this._tileJSONRequest = new AbortController;
        try {
            let t = await $902e455d852cdfb8$var$Li(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
            this._tileJSONRequest = null, this._loaded = !0, t && ((0, $caapT.Zn)(this, t), t.bounds && (this.tileBounds = new $902e455d852cdfb8$var$zi(t.bounds, this.minzoom, this.maxzoom)), this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `metadata`
            })), this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `content`,
                sourceDataChanged: e1
            })));
        } catch (e1) {
            this._tileJSONRequest = null, this._loaded = !0, (0, $caapT.On)(e1) || this.fire(new (0, $caapT.fn)((0, $caapT.Yn)(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    hasTile(e1) {
        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    setSourceProperty(e1) {
        this._tileJSONRequest && this._tileJSONRequest.abort(), e1(), this.load(!0);
    }
    setTiles(e1) {
        return this.setSourceProperty(()=>{
            this._options.tiles = e1;
        }), this;
    }
    setUrl(e1) {
        return this.setSourceProperty(()=>{
            this.url = e1, this._options.url = e1;
        }), this;
    }
    onRemove() {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null);
    }
    serialize() {
        return (0, $caapT.Zn)({}, this._options);
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), n = {
            request: await this.map._requestManager.transformRequest(t, `Tile`),
            uid: e1.uid,
            tileID: e1.tileID,
            zoom: e1.tileID.overscaledZ,
            tileSize: this.tileSize * e1.tileID.overscaleFactor(),
            type: this.type,
            source: this.id,
            pixelRatio: this.map.getPixelRatio(),
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId,
            subdivisionGranularity: this.map.style.projection.subdivisionGranularity,
            encoding: this.encoding,
            overzoomParameters: await this._getOverzoomParameters(e1),
            etag: e1.etag
        };
        n.request.collectResourceTiming = this._collectResourceTiming, await this.dispatcher.waitForInitComplete();
        let r = `RT`;
        if (!e1.actor || e1.state === `expired`) e1.actor = this.dispatcher.getReadyActor(), r = `LT`;
        else if (e1.state === `loading`) return new Promise((t, n)=>{
            e1.reloadPromise = {
                resolve: t,
                reject: n
            };
        });
        e1.abortController = new AbortController;
        try {
            let t = await e1.actor.sendAsync({
                type: r,
                data: n
            }, e1.abortController);
            if (delete e1.abortController, e1.aborted) return;
            this._afterTileLoadWorkerResponse(e1, t);
            let i = {};
            return t?.etagUnmodified && (i.unmodified = !0), i;
        } catch (t) {
            if (delete e1.abortController, e1.aborted || (0, $caapT.On)(t)) return;
            if (t && t.status !== 404) throw t;
            this._afterTileLoadWorkerResponse(e1, null);
        }
    }
    async _getOverzoomParameters(e1) {
        if (e1.tileID.canonical.z <= this.maxzoom || this.map._zoomLevelsToOverscale === void 0) return;
        let t = e1.tileID.scaledTo(this.maxzoom).canonical, n = t.url(this.tiles, this.map.getPixelRatio(), this.scheme);
        return {
            maxZoomTileID: t,
            overzoomRequest: await this.map._requestManager.transformRequest(n, `Tile`)
        };
    }
    _afterTileLoadWorkerResponse(e1, t) {
        if (t?.resourceTiming && (e1.resourceTiming = t.resourceTiming), t && this.map._refreshExpiredTiles && e1.setExpiryData(t), e1.etag = t?.etag, e1.loadVectorData(t, this.map.painter), e1.reloadPromise) {
            let t = e1.reloadPromise;
            e1.reloadPromise = null, this.loadTile(e1).then(t.resolve).catch(t.reject);
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.actor && await e1.actor.sendAsync({
            type: `AT`,
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    async unloadTile(e1) {
        e1.unloadVectorData(), e1.actor && await e1.actor.sendAsync({
            type: `RMT`,
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    hasTransition() {
        return !1;
    }
}, $902e455d852cdfb8$export$908e4015b805db3c = class extends (0, $caapT.mn) {
    constructor(e1, t, n, r){
        super(), this.id = e1, this.dispatcher = n, this.setEventedParent(r), this.type = `raster`, this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = `xyz`, this.tileSize = 512, this._loaded = !1, this._premultiplyAlpha = !0, this._options = (0, $caapT.Zn)({
            type: `raster`
        }, t), (0, $caapT.Zn)(this, (0, $caapT.gr)(t, [
            `url`,
            `scheme`,
            `tileSize`
        ]));
    }
    async load(e1 = !1) {
        this._loaded = !1, this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`dataloading`)), this._tileJSONRequest = new AbortController;
        try {
            let t = await $902e455d852cdfb8$var$Li(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
            this._tileJSONRequest = null, this._loaded = !0, t && ((0, $caapT.Zn)(this, t), t.bounds && (this.tileBounds = new $902e455d852cdfb8$var$zi(t.bounds, this.minzoom, this.maxzoom)), this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `metadata`
            })), this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `content`,
                sourceDataChanged: e1
            })));
        } catch (e1) {
            this._tileJSONRequest = null, this._loaded = !0, (0, $caapT.On)(e1) || this.fire(new (0, $caapT.fn)((0, $caapT.Yn)(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    onRemove() {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null);
    }
    setSourceProperty(e1) {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null), e1(), this.load(!0);
    }
    setTiles(e1) {
        return this.setSourceProperty(()=>{
            this._options.tiles = e1;
        }), this;
    }
    setUrl(e1) {
        return this.setSourceProperty(()=>{
            this.url = e1, this._options.url = e1;
        }), this;
    }
    serialize() {
        return (0, $caapT.Zn)({}, this._options);
    }
    setPremultiplyAlpha(e1) {
        return this._premultiplyAlpha === e1 || this.setSourceProperty(()=>{
            this._premultiplyAlpha = e1;
        }), this;
    }
    hasTile(e1) {
        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), n = this._premultiplyAlpha, r = n ? void 0 : {
            premultiplyAlpha: `none`
        };
        e1.abortController = new AbortController;
        try {
            let i = await $902e455d852cdfb8$var$Mr.getImage(await this.map._requestManager.transformRequest(t, `Tile`), e1.abortController, this.map._refreshExpiredTiles, r);
            if (delete e1.abortController, e1.aborted) {
                e1.state = `unloaded`;
                return;
            }
            if (i?.data) {
                this.map._refreshExpiredTiles && (i.cacheControl || i.expires) && e1.setExpiryData({
                    cacheControl: i.cacheControl,
                    expires: i.expires
                });
                let t = this.map.painter.context, r = t.gl, a = i.data;
                e1.texture = this.map.painter.getTileTexture(a.width), e1.texture ? e1.texture.update(a, {
                    useMipmap: !0,
                    premultiply: n
                }) : (e1.texture = new (0, $caapT.dt)(t, a, r.RGBA, {
                    useMipmap: !0,
                    premultiply: n
                }), e1.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE, r.LINEAR_MIPMAP_NEAREST)), e1.state = `loaded`;
            }
        } catch (t) {
            if (delete e1.abortController, e1.aborted) e1.state = `unloaded`;
            else if (t) throw e1.state = `errored`, t;
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController);
    }
    async unloadTile(e1) {
        e1.texture && this.map.painter.saveTileTexture(e1.texture);
    }
    hasTransition() {
        return !1;
    }
}, $902e455d852cdfb8$export$12673e0db63b98e3 = class extends $902e455d852cdfb8$export$908e4015b805db3c {
    constructor(e1, t, n, r){
        super(e1, t, n, r), this.type = `raster-dem`, this.maxzoom = 22, this._options = (0, $caapT.Zn)({
            type: `raster-dem`
        }, t), this.encoding = t.encoding || `mapbox`, this.redFactor = t.redFactor, this.greenFactor = t.greenFactor, this.blueFactor = t.blueFactor, this.baseShift = t.baseShift;
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), n = await this.map._requestManager.transformRequest(t, `Tile`);
        e1.neighboringTiles = this._getNeighboringTiles(e1.tileID), e1.abortController = new AbortController;
        try {
            let t = await $902e455d852cdfb8$var$Mr.getImage(n, e1.abortController, this.map._refreshExpiredTiles);
            if (delete e1.abortController, e1.aborted) {
                e1.state = `unloaded`;
                return;
            }
            if (t?.data) {
                let n = t.data;
                this.map._refreshExpiredTiles && (t.cacheControl || t.expires) && e1.setExpiryData({
                    cacheControl: t.cacheControl,
                    expires: t.expires
                });
                let r = (0, $caapT.ar)(n) && (0, $caapT.Ai)() ? n : await this.readImageNow(n), a = {
                    type: this.type,
                    uid: e1.uid,
                    source: this.id,
                    rawImageData: r,
                    encoding: this.encoding,
                    redFactor: this.redFactor,
                    greenFactor: this.greenFactor,
                    blueFactor: this.blueFactor,
                    baseShift: this.baseShift
                };
                if (e1.actor && e1.state !== `expired` && e1.state !== `reloading`) return;
                await this.dispatcher.waitForInitComplete(), (!e1.actor || e1.state === `expired`) && (e1.actor = this.dispatcher.getReadyActor()), e1.dem = await e1.actor.sendAsync({
                    type: `LDT`,
                    data: a
                }), e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.state = `loaded`;
            }
        } catch (t) {
            if (delete e1.abortController, e1.aborted) e1.state = `unloaded`;
            else if (t) throw e1.state = `errored`, t;
        }
    }
    async readImageNow(e1) {
        if (typeof VideoFrame < `u` && (0, $caapT.ki)()) {
            let t = e1.width + 2, n = e1.height + 2;
            try {
                return new (0, $caapT._t)({
                    width: t,
                    height: n
                }, await (0, $caapT.br)(e1, -1, -1, t, n));
            } catch  {}
        }
        return $902e455d852cdfb8$var$Dr.getImageData(e1, 1);
    }
    _getNeighboringTiles(e1) {
        let t = e1.canonical, n = 2 ** t.z, r = (t.x - 1 + n) % n, i = t.x === 0 ? e1.wrap - 1 : e1.wrap, a = (t.x + 1 + n) % n, o = t.x + 1 === n ? e1.wrap + 1 : e1.wrap, s = {};
        return s[new (0, $caapT._)(e1.overscaledZ, i, t.z, r, t.y).key] = {
            backfilled: !1
        }, s[new (0, $caapT._)(e1.overscaledZ, o, t.z, a, t.y).key] = {
            backfilled: !1
        }, t.y > 0 && (s[new (0, $caapT._)(e1.overscaledZ, i, t.z, r, t.y - 1).key] = {
            backfilled: !1
        }, s[new (0, $caapT._)(e1.overscaledZ, e1.wrap, t.z, t.x, t.y - 1).key] = {
            backfilled: !1
        }, s[new (0, $caapT._)(e1.overscaledZ, o, t.z, a, t.y - 1).key] = {
            backfilled: !1
        }), t.y + 1 < n && (s[new (0, $caapT._)(e1.overscaledZ, i, t.z, r, t.y + 1).key] = {
            backfilled: !1
        }, s[new (0, $caapT._)(e1.overscaledZ, e1.wrap, t.z, t.x, t.y + 1).key] = {
            backfilled: !1
        }, s[new (0, $caapT._)(e1.overscaledZ, o, t.z, a, t.y + 1).key] = {
            backfilled: !1
        }), s;
    }
    async unloadTile(e1) {
        e1.demTexture && this.map.painter.saveTileTexture(e1.demTexture), e1.fbo && (e1.fbo.destroy(), delete e1.fbo), e1.dem && delete e1.dem, delete e1.neighboringTiles, e1.state = `unloaded`, e1.actor && await e1.actor.sendAsync({
            type: `RDT`,
            data: {
                type: this.type,
                uid: e1.uid,
                source: this.id
            }
        });
    }
};
function $902e455d852cdfb8$var$Ui(e1, t) {
    return t ? e1.properties[t] : e1.id;
}
function $902e455d852cdfb8$var$Wi(e1, t) {
    let n = new Map;
    if (e1 == null || e1.type == null) return n;
    if (e1.type === `Feature`) {
        let r = $902e455d852cdfb8$var$Ui(e1, t);
        return r == null ? void 0 : (n.set(r, e1), n);
    }
    if (e1.type === `FeatureCollection`) {
        let r = new Set;
        for (let i of e1.features){
            let e1 = $902e455d852cdfb8$var$Ui(i, t);
            if (e1 == null || r.has(e1)) return;
            r.add(e1), n.set(e1, i);
        }
        return n;
    }
}
function $902e455d852cdfb8$var$Gi(e1, t, n) {
    let r = [];
    if (t.removeAll) e1.clear();
    else if (t.remove) for (let n of t.remove){
        let t = e1.get(n);
        t && (r.push(t.geometry), e1.delete(n));
    }
    if (t.add) for (let i of t.add){
        let t = $902e455d852cdfb8$var$Ui(i, n);
        if (t == null) continue;
        let a = e1.get(t);
        a && r.push(a.geometry), r.push(i.geometry), e1.set(t, i);
    }
    if (t.update) for (let n of t.update){
        let t = e1.get(n.id);
        if (!t) continue;
        let i = !!n.newGeometry, a = n.removeAllProperties || n.removeProperties?.length > 0 || n.addOrUpdateProperties?.length > 0;
        if (!i && !a) continue;
        r.push(t.geometry);
        let o = {
            ...t
        };
        if (e1.set(n.id, o), i && (r.push(n.newGeometry), o.geometry = n.newGeometry), a) {
            if (n.removeAllProperties ? o.properties = {} : o.properties = {
                ...o.properties || {}
            }, n.removeProperties) for (let e1 of n.removeProperties)delete o.properties[e1];
            if (n.addOrUpdateProperties) for (let { key: e1, value: t } of n.addOrUpdateProperties)o.properties[e1] = t;
        }
    }
    return r;
}
function $902e455d852cdfb8$var$Ki(e1, t, n) {
    if (!e1) return t || {};
    if (!t) return e1 || {};
    n && ($902e455d852cdfb8$var$Yi(e1.add, n), $902e455d852cdfb8$var$Yi(t.add, n));
    let r = $902e455d852cdfb8$var$Zi(e1), i = $902e455d852cdfb8$var$Zi(t);
    $902e455d852cdfb8$var$qi(r, i);
    let a = {};
    if ((r.removeAll || i.removeAll) && (a.removeAll = !0), a.remove = new Set([
        ...r.remove,
        ...i.remove
    ]), a.add = new Map([
        ...r.add,
        ...i.add
    ]), a.update = new Map([
        ...r.update,
        ...i.update
    ]), a.remove.size && a.add.size) for (let e1 of a.add.keys())a.remove.delete(e1);
    let o = $902e455d852cdfb8$var$Qi(a);
    return n && $902e455d852cdfb8$var$Xi(o.add, n), o;
}
function $902e455d852cdfb8$var$qi(e1, t) {
    t.removeAll && (e1.add.clear(), e1.update.clear(), e1.remove.clear(), t.remove.clear());
    for (let n of t.remove)e1.add.delete(n), e1.update.delete(n);
    for (let [n, r] of t.update){
        let i = e1.update.get(n);
        i && (t.update.set(n, $902e455d852cdfb8$var$Ji(i, r)), e1.update.delete(n));
    }
}
function $902e455d852cdfb8$var$Ji(e1, t) {
    let n = {
        id: e1.id
    };
    if (t.removeAllProperties && (delete e1.removeProperties, delete e1.addOrUpdateProperties, delete t.removeProperties), t.removeProperties) for (let n of t.removeProperties){
        let t = e1.addOrUpdateProperties.findIndex((e1)=>e1.key === n);
        t > -1 && e1.addOrUpdateProperties.splice(t, 1);
    }
    return (e1.removeAllProperties || t.removeAllProperties) && (n.removeAllProperties = !0), (e1.removeProperties || t.removeProperties) && (n.removeProperties = [
        ...e1.removeProperties || [],
        ...t.removeProperties || []
    ]), (e1.addOrUpdateProperties || t.addOrUpdateProperties) && (n.addOrUpdateProperties = [
        ...e1.addOrUpdateProperties || [],
        ...t.addOrUpdateProperties || []
    ]), (e1.newGeometry || t.newGeometry) && (n.newGeometry = t.newGeometry || e1.newGeometry), n;
}
function $902e455d852cdfb8$var$Yi(e1, t) {
    if (e1) for (let n of e1){
        let e1 = $902e455d852cdfb8$var$Ui(n, t);
        e1 != null && (n.id = e1);
    }
}
function $902e455d852cdfb8$var$Xi(e1, t) {
    if (e1) for (let n of e1)$902e455d852cdfb8$var$Ui(n, t) != null && delete n.id;
}
function $902e455d852cdfb8$var$Zi(e1) {
    if (!e1) return {};
    let t = {};
    return t.removeAll = e1.removeAll, t.remove = new Set(e1.remove || []), t.add = new Map(e1.add?.map((e1)=>[
            e1.id,
            e1
        ])), t.update = new Map(e1.update?.map((e1)=>[
            e1.id,
            e1
        ])), t;
}
function $902e455d852cdfb8$var$Qi(e1) {
    let t = {};
    return e1.removeAll && (t.removeAll = e1.removeAll), e1.remove && (t.remove = Array.from(e1.remove)), e1.add && (t.add = Array.from(e1.add.values())), e1.update && (t.update = Array.from(e1.update.values())), t;
}
function $902e455d852cdfb8$var$$i(e1) {
    return !e1 || e1.length === 0 ? [] : typeof e1[0] == `number` ? [
        e1
    ] : e1.flatMap((e1)=>$902e455d852cdfb8$var$$i(e1));
}
function $902e455d852cdfb8$var$ea(e1) {
    return e1.type === `GeometryCollection` ? e1.geometries.flatMap((e1)=>$902e455d852cdfb8$var$ea(e1)) : $902e455d852cdfb8$var$$i(e1.coordinates);
}
function $902e455d852cdfb8$var$ta(e1) {
    let t = new $902e455d852cdfb8$export$266d2884f61535d3, n;
    switch(e1.type){
        case `FeatureCollection`:
            n = e1.features.flatMap((e1)=>$902e455d852cdfb8$var$ea(e1.geometry));
            break;
        case `Feature`:
            n = $902e455d852cdfb8$var$ea(e1.geometry);
            break;
        default:
            n = $902e455d852cdfb8$var$ea(e1);
            break;
    }
    if (n.length === 0) return t;
    for (let e1 of n){
        let [n, r] = e1;
        t.extend([
            n,
            r
        ]);
    }
    return t;
}
function $902e455d852cdfb8$var$na({ x: e1, y: t, z: n }, r = 0) {
    let i = (0, $caapT.T)((e1 - r) / 2 ** n), a = (0, $caapT.w)((t + 1 + r) / 2 ** n), o = (0, $caapT.T)((e1 + 1 + r) / 2 ** n), s = (0, $caapT.w)((t - r) / 2 ** n);
    return new $902e455d852cdfb8$export$266d2884f61535d3([
        i,
        a
    ], [
        o,
        s
    ]);
}
var $902e455d852cdfb8$export$8a9e6af3bfd58eb9 = class extends (0, $caapT.mn) {
    constructor(e1, t, n, r){
        super(), this.id = e1, this.type = `geojson`, this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._isUpdatingWorker = !1, this._pendingWorkerUpdate = {
            data: t.data
        }, this.actorPromise = n.getActor(), this.setEventedParent(r), this._data = typeof t.data == `string` ? {
            url: t.data
        } : {
            geojson: t.data
        }, this._options = (0, $caapT.Zn)({}, t), this._collectResourceTiming = t.collectResourceTiming, t.maxzoom !== void 0 && (this.maxzoom = t.maxzoom), t.type && (this.type = t.type), t.attribution && (this.attribution = t.attribution), this.promoteId = t.promoteId, t.clusterMaxZoom !== void 0 && this.maxzoom <= t.clusterMaxZoom && (0, $caapT.Ar)(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${t.clusterMaxZoom}".`), this.workerOptions = (0, $caapT.Zn)({
            source: this.id,
            geojsonVtOptions: {
                buffer: this._pixelsToTileUnits(t.buffer === void 0 ? 128 : t.buffer),
                tolerance: this._pixelsToTileUnits(t.tolerance === void 0 ? .375 : t.tolerance),
                extent: (0, $caapT.Pr),
                maxZoom: this.maxzoom,
                lineMetrics: t.lineMetrics || !1,
                generateId: t.generateId || !1,
                promoteId: typeof t.promoteId == `string` ? t.promoteId : void 0,
                cluster: t.cluster || !1,
                clusterOptions: {
                    maxZoom: this._getClusterMaxZoom(t.clusterMaxZoom),
                    minPoints: Math.max(2, t.clusterMinPoints || 2),
                    extent: (0, $caapT.Pr),
                    radius: this._pixelsToTileUnits(t.clusterRadius || 50),
                    log: !1,
                    generateId: t.generateId || !1
                }
            },
            clusterProperties: t.clusterProperties,
            filter: t.filter
        }, t.workerOptions);
    }
    _hasPendingWorkerUpdate() {
        return this._pendingWorkerUpdate.data !== void 0 || this._pendingWorkerUpdate.diff !== void 0 || this._pendingWorkerUpdate.updateCluster;
    }
    _pixelsToTileUnits(e1) {
        return e1 * ((0, $caapT.Pr) / this.tileSize);
    }
    _getClusterMaxZoom(e1) {
        let t = e1 ? Math.round(e1) : this.maxzoom - 1;
        return Number.isInteger(e1) || e1 === void 0 || (0, $caapT.Ar)(`Integer expected for option 'clusterMaxZoom': provided value "${e1}" rounded to "${t}"`), t;
    }
    async load() {
        await this._updateWorkerData();
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    setData(e1) {
        return this._data = typeof e1 == `string` ? {
            url: e1
        } : {
            geojson: e1
        }, this._pendingWorkerUpdate = {
            data: e1
        }, this._updateWorkerData();
    }
    updateData(e1) {
        return this._pendingWorkerUpdate.diff = $902e455d852cdfb8$var$Ki(this._pendingWorkerUpdate.diff, e1), this._updateWorkerData();
    }
    async getData() {
        return this._data.url && await this.once(`data`), this._data.geojson ? this._data.geojson : {
            type: `FeatureCollection`,
            features: Array.from(this._data.updateable.values())
        };
    }
    async getBounds() {
        return $902e455d852cdfb8$var$ta(await this.getData());
    }
    setClusterOptions(e1) {
        return this.workerOptions.geojsonVtOptions.cluster = e1.cluster, e1.clusterRadius !== void 0 && (this.workerOptions.geojsonVtOptions.clusterOptions.radius = this._pixelsToTileUnits(e1.clusterRadius)), e1.clusterMaxZoom !== void 0 && (this.workerOptions.geojsonVtOptions.clusterOptions.maxZoom = this._getClusterMaxZoom(e1.clusterMaxZoom)), this._pendingWorkerUpdate.updateCluster = !0, this._updateWorkerData();
    }
    async getClusterExpansionZoom(e1) {
        return (await this.actorPromise).sendAsync({
            type: `GCEZ`,
            data: {
                type: this.type,
                clusterId: e1,
                source: this.id
            }
        });
    }
    async getClusterChildren(e1) {
        return (await this.actorPromise).sendAsync({
            type: `GCC`,
            data: {
                type: this.type,
                clusterId: e1,
                source: this.id
            }
        });
    }
    async getClusterLeaves(e1, t, n) {
        return (await this.actorPromise).sendAsync({
            type: `GCL`,
            data: {
                type: this.type,
                source: this.id,
                clusterId: e1,
                limit: t,
                offset: n
            }
        });
    }
    async _updateWorkerData() {
        if (this._isUpdatingWorker) return this._updatePromise;
        if (!this._hasPendingWorkerUpdate()) {
            (0, $caapT.Ar)(`No pending worker updates for GeoJSONSource ${this.id}.`);
            return;
        }
        let { data: e1, diff: t, updateCluster: n } = this._pendingWorkerUpdate, r = this._getLoadGeoJSONParameters(e1, t, n);
        e1 === void 0 ? t ? this._pendingWorkerUpdate.diff = void 0 : n && (this._pendingWorkerUpdate.updateCluster = void 0) : this._pendingWorkerUpdate.data = void 0, this._updatePromise = this._dispatchWorkerUpdate(r), await this._updatePromise;
    }
    async _getLoadGeoJSONParameters(e1, t, n) {
        let r = (0, $caapT.Zn)({
            type: this.type,
            source: this.id
        }, this.workerOptions);
        if (typeof e1 == `string`) return r.request = await this.map._requestManager.transformRequest($902e455d852cdfb8$var$Dr.resolveURL(e1), `Source`), r.request.collectResourceTiming = this._collectResourceTiming, r;
        if (e1 !== void 0) return r.data = e1, r;
        if (t) return r.dataDiff = t, r;
        if (n) return r.updateCluster = !0, r;
    }
    async _dispatchWorkerUpdate(e1) {
        this._isUpdatingWorker = !0, this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`dataloading`));
        try {
            let t = await e1, n = await (await this.actorPromise).sendAsync({
                type: `LD`,
                data: t
            });
            if (this._isUpdatingWorker = !1, this._removed || n.abandoned) {
                this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`dataabort`));
                return;
            }
            n.data && (this._data = {
                geojson: n.data
            });
            let r = this._applyDiffToSource(t.dataDiff), i = this._getShouldReloadTileOptions(r), a = {};
            this._applyResourceTiming(a, n), this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
                ...a,
                sourceDataType: `metadata`
            })), this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
                ...a,
                sourceDataType: `content`,
                shouldReloadTileOptions: i
            }));
        } catch (e1) {
            if (this._isUpdatingWorker = !1, this._removed) {
                this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`dataabort`));
                return;
            }
            this.fire(new (0, $caapT.fn)((0, $caapT.Yn)(e1)));
        } finally{
            this._hasPendingWorkerUpdate() && await this._updateWorkerData();
        }
    }
    _applyResourceTiming(e1, t) {
        if (!this._collectResourceTiming) return;
        let n = t.resourceTiming?.[this.id];
        if (!n) return;
        let r = n.slice(0);
        r?.length && (0, $caapT.Zn)(e1, {
            resourceTiming: r
        });
    }
    _applyDiffToSource(e1) {
        if (!e1) return;
        let t = typeof this.promoteId == `string` ? this.promoteId : void 0;
        if (!this._data.url && !this._data.updateable) {
            let e1 = $902e455d852cdfb8$var$Wi(this._data.geojson, t);
            if (!e1) throw Error(`GeoJSONSource "${this.id}": GeoJSON data is not compatible with updateData`);
            this._data = {
                updateable: e1
            };
        }
        if (!this._data.updateable) return;
        let n = $902e455d852cdfb8$var$Gi(this._data.updateable, e1, t);
        if (!(e1.removeAll || this._options.cluster)) return n;
    }
    _getShouldReloadTileOptions(e1) {
        if (e1) return {
            affectedBounds: e1.filter(Boolean).map((e1)=>$902e455d852cdfb8$var$ta(e1))
        };
    }
    shouldReloadTile(e1, { affectedBounds: t }) {
        if (e1.state === `loading`) return !0;
        if (e1.state === `unloaded`) return !1;
        let { buffer: n, extent: r } = this.workerOptions.geojsonVtOptions, i = $902e455d852cdfb8$var$na(e1.tileID.canonical, n / r);
        for (let e1 of t)if (i.intersects(e1)) return !0;
        return !1;
    }
    loaded() {
        return !this._isUpdatingWorker && !this._hasPendingWorkerUpdate();
    }
    async loadTile(e1) {
        let t = e1.actor ? `RT` : `LT`;
        e1.actor = await this.actorPromise;
        let n = {
            type: this.type,
            uid: e1.uid,
            tileID: e1.tileID,
            zoom: e1.tileID.overscaledZ,
            maxZoom: this.maxzoom,
            tileSize: this.tileSize,
            source: this.id,
            pixelRatio: this.map.getPixelRatio(),
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId,
            subdivisionGranularity: this.map.style.projection.subdivisionGranularity
        };
        e1.abortController = new AbortController;
        try {
            let r = await (await this.actorPromise).sendAsync({
                type: t,
                data: n
            }, e1.abortController);
            delete e1.abortController, e1.unloadVectorData(), e1.aborted || e1.loadVectorData(r, this.map.painter, t === `RT`);
        } catch (t) {
            if (delete e1.abortController, e1.aborted || (0, $caapT.On)(t)) return;
            throw t;
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.aborted = !0;
    }
    async unloadTile(e1) {
        e1.unloadVectorData(), await (await this.actorPromise).sendAsync({
            type: `RMT`,
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    onRemove() {
        this._removed = !0, this.actorPromise.then((e1)=>e1.sendAsync({
                type: `RS`,
                data: {
                    type: this.type,
                    source: this.id
                }
            }));
    }
    serialize() {
        return (0, $caapT.Zn)({}, this._options, {
            type: this.type,
            data: this._data.updateable ? {
                type: `FeatureCollection`,
                features: Array.from(this._data.updateable.values())
            } : this._data.url || this._data.geojson
        });
    }
    hasTransition() {
        return !1;
    }
}, $902e455d852cdfb8$export$280e9a68c3ffd919 = class extends (0, $caapT.mn) {
    constructor(e1, t, n, r){
        super(), this.flippedWindingOrder = !1, this.id = e1, this.dispatcher = n, this.coordinates = t.coordinates, this.type = `image`, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(r), this.options = t;
    }
    async load(e1) {
        this._loaded = !1, this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`dataloading`)), this.url = this.options.url, this._request = new AbortController;
        try {
            let t = await $902e455d852cdfb8$var$Mr.getImage(await this.map._requestManager.transformRequest(this.url, `Image`), this._request);
            this._request = null, this._loaded = !0, t?.data && (this.image = t.data, e1 && (this.coordinates = e1), this._finishLoading());
        } catch (e1) {
            this._request = null, this._loaded = !0, (0, $caapT.On)(e1) || this.fire(new (0, $caapT.fn)((0, $caapT.Yn)(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    updateImage(e1) {
        return e1.url ? (this._request &&= (this._request.abort(), null), this.options.url = e1.url, this.load(e1.coordinates).finally(()=>this.texture = null), this) : this;
    }
    _finishLoading() {
        this.map && (this.setCoordinates(this.coordinates), this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `metadata`
        })));
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    onRemove() {
        this._request &&= (this._request.abort(), null);
    }
    setCoordinates(e1) {
        this.coordinates = e1;
        let t = e1.map((0, $caapT.S).fromLngLat);
        return this.tileID = $902e455d852cdfb8$var$aa(t), this.terrainTileRanges = this._getOverlappingTileRanges(t), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = t.map((e1)=>this.tileID.getTilePoint(e1)._round()), this.flippedWindingOrder = $902e455d852cdfb8$var$oa(this.tileCoords), this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `content`
        })), this;
    }
    prepare() {
        if (Object.keys(this.tiles).length === 0 || !this.image) return;
        let e1 = this.map.painter.context, t = e1.gl;
        this.texture || (this.texture = new (0, $caapT.dt)(e1, this.image, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE));
        let n = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            t.state !== `loaded` && (t.state = `loaded`, t.texture = this.texture, n = !0);
        }
        n && this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
    }
    async loadTile(e1) {
        this.tileID?.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}) : e1.state = `errored`;
    }
    serialize() {
        return {
            type: `image`,
            url: this.options.url,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return !1;
    }
    _getOverlappingTileRanges(e1) {
        let { minX: t, minY: n, maxX: r, maxY: i } = (0, $caapT.h).fromPoints(e1), a = {};
        for(let e1 = 0; e1 <= 25; e1++){
            let o = 2 ** e1, s = Math.floor(t * o), c = Math.floor(n * o), l = Math.floor(r * o), u = Math.floor(i * o), d = (s % o + o) % o, f = l % o;
            a[e1] = {
                minWrap: Math.floor(s / o),
                maxWrap: Math.floor(l / o),
                minTileXWrapped: d,
                maxTileXWrapped: f,
                minTileY: c,
                maxTileY: u
            };
        }
        return a;
    }
};
function $902e455d852cdfb8$var$aa(e1) {
    let t = (0, $caapT.h).fromPoints(e1), n = t.width(), r = t.height(), i = Math.max(0, Math.floor(-Math.log(Math.max(n, r)) / Math.LN2)), a = 2 ** i;
    return new (0, $caapT.g)(i, Math.floor((t.minX + t.maxX) / 2 * a), Math.floor((t.minY + t.maxY) / 2 * a));
}
function $902e455d852cdfb8$var$oa(e1) {
    let t = e1[1].x - e1[0].x, n = e1[1].y - e1[0].y, r = e1[2].x - e1[0].x;
    return t * (e1[2].y - e1[0].y) - n * r < 0;
}
var $902e455d852cdfb8$export$f3a17123d80000c5 = class extends $902e455d852cdfb8$export$280e9a68c3ffd919 {
    constructor(e1, t, n, r){
        super(e1, t, n, r), this._onPlayingHandler = ()=>{
            this.map?.triggerRepaint();
        }, this.roundZoom = !0, this.type = `video`, this.options = t;
    }
    async load() {
        this._loaded = !1;
        let e1 = this.options;
        this.urls = [];
        for (let t of e1.urls)this.urls.push((await this.map._requestManager.transformRequest(t, `Source`)).url);
        try {
            let e1 = await (0, $caapT.bn)(this.urls);
            if (this._loaded = !0, !e1) return;
            this.video = e1, this.video.loop = !0, this.video.addEventListener(`playing`, this._onPlayingHandler), this.map && this.video.play(), this._finishLoading();
        } catch (e1) {
            this.fire(new (0, $caapT.fn)((0, $caapT.Yn)(e1)));
        }
    }
    pause() {
        this.video && this.video.pause();
    }
    play() {
        this.video && this.video.play();
    }
    seek(e1) {
        if (this.video) {
            let t = this.video.seekable;
            e1 < t.start(0) || e1 > t.end(0) ? this.fire(new (0, $caapT.fn)(new (0, $caapT.rn)(`sources.${this.id}`, null, `Playback for this video can be set only between the ${t.start(0)} and ${t.end(0)}-second mark.`))) : this.video.currentTime = e1;
        }
    }
    getVideo() {
        return this.video;
    }
    onAdd(e1) {
        this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
    }
    onRemove() {
        super.onRemove(), this.video && (this.video.removeEventListener(`playing`, this._onPlayingHandler), this.video.pause());
    }
    prepare() {
        if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2) return;
        let e1 = this.map.painter.context, t = e1.gl;
        this.texture ? this.video.paused || (this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE), t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, t.RGBA, t.UNSIGNED_BYTE, this.video)) : (this.texture = new (0, $caapT.dt)(e1, this.video, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE));
        let n = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            t.state !== `loaded` && (t.state = `loaded`, t.texture = this.texture, n = !0);
        }
        n && this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
    }
    serialize() {
        return {
            type: `video`,
            urls: this.urls,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this.video && !this.video.paused;
    }
}, $902e455d852cdfb8$export$ca65ccf5708c6a0c = class extends $902e455d852cdfb8$export$280e9a68c3ffd919 {
    constructor(e1, t, n, r){
        super(e1, t, n, r), t.coordinates ? (!Array.isArray(t.coordinates) || t.coordinates.length !== 4 || t.coordinates.some((e1)=>!Array.isArray(e1) || e1.length !== 2 || e1.some((e1)=>typeof e1 != `number`))) && this.fire(new (0, $caapT.fn)(new (0, $caapT.rn)(`sources.${e1}`, null, `"coordinates" property must be an array of 4 longitude/latitude array pairs`))) : this.fire(new (0, $caapT.fn)(new (0, $caapT.rn)(`sources.${e1}`, null, `missing required property "coordinates"`))), t.animate && typeof t.animate != `boolean` && this.fire(new (0, $caapT.fn)(new (0, $caapT.rn)(`sources.${e1}`, null, `optional "animate" property must be a boolean value`))), t.canvas ? typeof t.canvas != `string` && !(t.canvas instanceof HTMLCanvasElement) && this.fire(new (0, $caapT.fn)(new (0, $caapT.rn)(`sources.${e1}`, null, `"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance`))) : this.fire(new (0, $caapT.fn)(new (0, $caapT.rn)(`sources.${e1}`, null, `missing required property "canvas"`))), this.options = t, this.animate = t.animate === void 0 || t.animate;
    }
    async load() {
        if (this._loaded = !0, this.canvas ||= this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions()) {
            this.fire(new (0, $caapT.fn)(Error(`Canvas dimensions cannot be less than or equal to zero.`)));
            return;
        }
        this.play = function() {
            this._playing = !0, this.map.triggerRepaint();
        }, this.pause = function() {
            this._playing &&= (this.prepare(), !1);
        }, this._finishLoading();
    }
    getCanvas() {
        return this.canvas;
    }
    onAdd(e1) {
        this.map = e1, this.load(), this.canvas && this.animate && this.play();
    }
    onRemove() {
        this.pause();
    }
    prepare() {
        let e1 = !1;
        if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions() || Object.keys(this.tiles).length === 0) return;
        let t = this.map.painter.context, n = t.gl;
        this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
            premultiply: !0
        }) : (this.texture = new (0, $caapT.dt)(t, this.canvas, n.RGBA, {
            premultiply: !0
        }), this.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE));
        let r = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            t.state !== `loaded` && (t.state = `loaded`, t.texture = this.texture, r = !0);
        }
        r && this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
    }
    serialize() {
        return {
            type: `canvas`,
            animate: this.animate,
            canvas: this.options.canvas,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this._playing;
    }
    _hasInvalidDimensions() {
        for (let e1 of [
            this.canvas.width,
            this.canvas.height
        ])if (isNaN(e1) || e1 <= 0) return !0;
        return !1;
    }
};
const $902e455d852cdfb8$var$la = {}, $902e455d852cdfb8$var$ua = (e1, t, n, r)=>{
    let i = new ($902e455d852cdfb8$var$da(t.type))(e1, t, n, r);
    if (i.id !== e1) throw Error(`Expected Source id to be ${e1} instead of ${i.id}`);
    return i;
}, $902e455d852cdfb8$var$da = (e1)=>{
    switch(e1){
        case `geojson`:
            return $902e455d852cdfb8$export$8a9e6af3bfd58eb9;
        case `image`:
            return $902e455d852cdfb8$export$280e9a68c3ffd919;
        case `raster`:
            return $902e455d852cdfb8$export$908e4015b805db3c;
        case `raster-dem`:
            return $902e455d852cdfb8$export$12673e0db63b98e3;
        case `vector`:
            return $902e455d852cdfb8$export$5feeb63c172810c5;
        case `video`:
            return $902e455d852cdfb8$export$f3a17123d80000c5;
        case `canvas`:
            return $902e455d852cdfb8$export$ca65ccf5708c6a0c;
    }
    return $902e455d852cdfb8$var$la[e1];
}, $902e455d852cdfb8$var$fa = (e1, t)=>{
    $902e455d852cdfb8$var$la[e1] = t;
}, $902e455d852cdfb8$export$10a8414b48d62ec3 = async (e1, t)=>{
    if ($902e455d852cdfb8$var$da(e1)) throw Error(`A source type called "${e1}" already exists.`);
    $902e455d852cdfb8$var$fa(e1, t);
};
function $902e455d852cdfb8$var$ma(e1, t) {
    let n = {};
    if (!t) return n;
    for (let r of e1){
        let e1 = r.layerIds.map((e1)=>t.getLayer(e1)).filter(Boolean);
        if (e1.length !== 0) {
            r.layers = e1, r.stateDependentLayerIds && (r.stateDependentLayers = r.stateDependentLayerIds.map((t)=>e1.filter((e1)=>e1.id === t)[0]));
            for (let t of e1)n[t.id] = r;
        }
    }
    return n;
}
const $902e455d852cdfb8$var$ha = `RTLPluginLoaded`;
var $902e455d852cdfb8$var$ga = class extends (0, $caapT.mn) {
    constructor(...e1){
        super(...e1), this.status = `unavailable`, this.url = null, this.dispatcher = $902e455d852cdfb8$export$6f0c702cbe7d6ed8();
    }
    _syncState(e1) {
        return this.status = e1, this.dispatcher.broadcast(`SRPS`, {
            pluginStatus: e1,
            pluginURL: this.url
        }).catch((e1)=>{
            throw this.status = `error`, e1;
        });
    }
    getRTLTextPluginStatus() {
        return this.status;
    }
    clearRTLTextPlugin() {
        this.status = `unavailable`, this.url = null;
    }
    async setRTLTextPlugin(e1, t = !1) {
        if (this.url) throw Error(`setRTLTextPlugin cannot be called multiple times.`);
        if (this.url = $902e455d852cdfb8$var$Dr.resolveURL(e1), !this.url) throw Error(`requested url ${e1} is invalid`);
        if (this.status === `unavailable`) {
            if (t) this.status = `deferred`, this._syncState(this.status);
            else return this._requestImport();
        } else if (this.status === `requested`) return this._requestImport();
    }
    async _requestImport() {
        await this._syncState(`loading`), this.status = `loaded`, this.fire(new (0, $caapT.pn)($902e455d852cdfb8$var$ha));
    }
    lazyLoad() {
        this.status === `unavailable` ? this.status = `requested` : this.status === `deferred` && this._requestImport();
    }
};
let $902e455d852cdfb8$var$_a = null;
function $902e455d852cdfb8$var$va() {
    return $902e455d852cdfb8$var$_a ||= new $902e455d852cdfb8$var$ga, $902e455d852cdfb8$var$_a;
}
var $902e455d852cdfb8$var$ya = class {
    constructor(e1, t){
        this.timeAdded = 0, this.fadeEndTime = 0, this.fadeOpacity = 1, this.tileID = e1, this.uid = (0, $caapT.kr)(), this.uses = 0, this.tileSize = t, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rttObjects = [], this.rttFingerprint = {}, this.expiredRequestCount = 0, this.state = `loading`, this.featureStateRevision = -1;
    }
    isRenderable(e1) {
        return this.hasData() && (!this.fadeEndTime || this.fadeOpacity > 0) && (e1 || !this.holdingForSymbolFade());
    }
    setCrossFadeLogic({ fadingRole: e1, fadingDirection: t, fadingParentID: n, fadeEndTime: r }) {
        this.resetFadeLogic(), this.fadingRole = e1, this.fadingDirection = t, this.fadingParentID = n, this.fadeEndTime = r;
    }
    setSelfFadeLogic(e1) {
        this.resetFadeLogic(), this.selfFading = !0, this.fadeEndTime = e1;
    }
    resetFadeLogic() {
        this.fadingRole = null, this.fadingDirection = null, this.fadingParentID = null, this.selfFading = !1, this.timeAdded = $902e455d852cdfb8$export$461939dd4422153(), this.fadeEndTime = 0, this.fadeOpacity = 1;
    }
    wasRequested() {
        return this.state === `errored` || this.state === `loaded` || this.state === `reloading`;
    }
    clearTextures(e1) {
        this.demTexture && e1.saveTileTexture(this.demTexture), this.demTexture = null;
    }
    getRTT(e1) {
        return this.rttObjects[e1];
    }
    acquireRTT(e1, t, n) {
        return this.rttObjects[t] = e1.acquireRTT(n);
    }
    releaseRTT(e1) {
        if (this.rttObjects.length !== 0) {
            for (let t of this.rttObjects)t && e1.releaseRTT(t);
            this.rttObjects.length = 0;
        }
    }
    loadVectorData(e1, t, n) {
        if (e1?.etagUnmodified === !0) {
            this.state = `loaded`;
            return;
        }
        if (this.hasData() && this.unloadVectorData(), this.state = `loaded`, !e1) {
            this.collisionBoxArray = new (0, $caapT.jt);
            return;
        }
        e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestEncoding = e1.encoding, this.latestFeatureIndex.rawTileData = e1.rawTileData, this.latestFeatureIndex.encoding = e1.encoding) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData, this.latestFeatureIndex.encoding = this.latestEncoding)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = $902e455d852cdfb8$var$ma(e1.buckets, t?.style), this.hasSymbolBuckets = !1;
        for(let e1 in this.buckets){
            let t = this.buckets[e1];
            if (t instanceof (0, $caapT.L)) {
                if (this.hasSymbolBuckets = !0, n) t.justReloaded = !0;
                else break;
            }
        }
        if (this.hasRTLText = !1, this.hasSymbolBuckets) for(let e1 in this.buckets){
            let t = this.buckets[e1];
            if (t instanceof (0, $caapT.L) && t.hasRTLText) {
                this.hasRTLText = !0, $902e455d852cdfb8$var$va().lazyLoad();
                break;
            }
        }
        this.queryPadding = 0;
        for(let e1 in this.buckets){
            let n = this.buckets[e1];
            this.queryPadding = Math.max(this.queryPadding, t.style.getLayer(e1).queryRadius(n));
        }
        e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), this.dashPositions = e1.dashPositions;
    }
    unloadVectorData() {
        for(let e1 in this.buckets)this.buckets[e1].destroy();
        this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.imageAtlas = null, this.dashPositions = null, this.latestFeatureIndex = null, this.state = `unloaded`;
    }
    getBucket(e1) {
        return this.buckets[e1.id];
    }
    upload(e1) {
        for(let t in this.buckets){
            let n = this.buckets[t];
            n.uploadPending() && n.upload(e1);
        }
        let t = e1.gl;
        this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new (0, $caapT.dt)(e1, this.imageAtlas.image, t.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage &&= (this.glyphAtlasTexture = new (0, $caapT.dt)(e1, this.glyphAtlasImage, t.ALPHA), null);
    }
    prepare(e1) {
        this.imageAtlas && this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture);
    }
    queryRenderedFeatures(e1, t, n, r, i, a, o, s, c, l, u) {
        return this.latestFeatureIndex?.rawTileData ? this.latestFeatureIndex.query({
            queryGeometry: r,
            cameraQueryGeometry: i,
            scale: a,
            tileSize: this.tileSize,
            pixelPosMatrix: l,
            transform: s,
            params: o,
            queryPadding: this.queryPadding * c,
            getElevation: u
        }, e1, t, n) : {};
    }
    querySourceFeatures(e1, t) {
        let n = this.latestFeatureIndex;
        if (!n?.rawTileData) return;
        let r = n.loadVTLayers(), i = t?.sourceLayer ? t.sourceLayer : ``, a = r._geojsonTileLayer || r[i];
        if (!a) return;
        let o = (0, $caapT.cn)(t?.filter, `querySourceFeatures[${i}].filter`, t?.globalState), { z: s, x: c, y: l } = this.tileID.canonical, u = {
            z: s,
            x: c,
            y: l
        };
        for(let t = 0; t < a.length; t++){
            let r = a.feature(t);
            if (o.needGeometry) {
                let e1 = (0, $caapT.bt)(r, !0);
                if (!o.filter(new (0, $caapT.Gt)(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
            } else if (!o.filter(new (0, $caapT.Gt)(this.tileID.overscaledZ), r)) continue;
            let d = new (0, $caapT.u)(r, s, c, l, n.getId(r, i));
            d.tile = u, e1.push(d);
        }
    }
    hasData() {
        return this.state === `loaded` || this.state === `reloading` || this.state === `expired`;
    }
    patternsLoaded() {
        return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
    }
    setExpiryData(e1) {
        let t = this.expirationTime;
        if (e1.cacheControl) {
            let t = (0, $caapT.hr)(e1.cacheControl);
            t[`max-age`] && (this.expirationTime = Date.now() + t[`max-age`] * 1e3);
        } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
        if (this.expirationTime) {
            let e1 = Date.now(), n = !1;
            if (this.expirationTime > e1) n = !1;
            else if (!t) n = !0;
            else if (this.expirationTime < t) n = !0;
            else {
                let r = this.expirationTime - t;
                r ? this.expirationTime = e1 + Math.max(r, 3e4) : n = !0;
            }
            n ? (this.expiredRequestCount++, this.state = `expired`) : this.expiredRequestCount = 0;
        }
    }
    getExpiryTimeout() {
        if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - new Date().getTime(), 2 ** 31 - 1);
    }
    setFeatureState(e1, t, n) {
        if (!this.latestFeatureIndex?.rawTileData || Object.keys(e1).length === 0 || this.featureStateRevision === n) return;
        this.featureStateRevision = n;
        let r = this.latestFeatureIndex.loadVTLayers();
        for(let n in this.buckets){
            if (!t.style.hasLayer(n)) continue;
            let i = this.buckets[n], a = i.layers[0].sourceLayer || `_geojsonTileLayer`, o = r[a], s = e1[a];
            if (!o || !s || s.length === 0) continue;
            i.update(s, o, this.imageAtlas?.patternPositions || {}, this.dashPositions || {});
            let c = t?.style?.getLayer(n);
            c && (this.queryPadding = Math.max(this.queryPadding, c.queryRadius(i)));
        }
    }
    holdingForSymbolFade() {
        return this.symbolFadeHoldUntil !== void 0;
    }
    symbolFadeFinished() {
        return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < $902e455d852cdfb8$export$461939dd4422153();
    }
    clearSymbolFadeHold() {
        this.symbolFadeHoldUntil = void 0;
    }
    setSymbolHoldDuration(e1) {
        this.symbolFadeHoldUntil = $902e455d852cdfb8$export$461939dd4422153() + e1;
    }
    setDependencies(e1, t) {
        let n = {};
        for (let e1 of t)n[e1] = !0;
        this.dependencies[e1] = n;
    }
    hasDependency(e1, t) {
        for (let n of e1){
            let e1 = this.dependencies[n];
            if (e1) {
                for (let n of t)if (e1[n]) return !0;
            }
        }
        return !1;
    }
};
function $902e455d852cdfb8$var$ba(e1) {
    let t = [];
    for(let n in e1)t.push({
        id: n,
        state: e1[n]
    });
    return t;
}
var $902e455d852cdfb8$var$xa = class {
    constructor(){
        this.state = {}, this.stateChanges = {}, this.deletedStates = {}, this.revision = 0;
    }
    updateState(e1, t, n) {
        let r = String(t);
        if (this.stateChanges[e1] ||= {}, this.stateChanges[e1][r] ||= {}, (0, $caapT.Zn)(this.stateChanges[e1][r], n), this.deletedStates[e1] === null) {
            this.deletedStates[e1] = {};
            for(let t in this.state[e1])if (t === r) {
                this.deletedStates[e1][r] = {};
                for(let i in this.state[e1][t])n[i] === void 0 && (this.deletedStates[e1][r][i] = null);
            } else this.deletedStates[e1][t] = null;
        } else if (this.deletedStates[e1]?.[r] === null) {
            this.deletedStates[e1][r] = {};
            for(let t in this.state[e1][r])n[t] === void 0 && (this.deletedStates[e1][r][t] = null);
        } else for(let t in n)this.deletedStates[e1]?.[r]?.[t] === null && delete this.deletedStates[e1][r][t];
    }
    removeFeatureState(e1, t, n) {
        if (this.deletedStates[e1] === null) return;
        let r = String(t);
        if (this.deletedStates[e1] ||= {}, n && t !== void 0) this.deletedStates[e1][r] !== null && (this.deletedStates[e1][r] ||= {}, this.deletedStates[e1][r][n] = null);
        else if (t !== void 0) {
            if (this.stateChanges[e1]?.[r]) for(n in this.deletedStates[e1][r] = {}, this.stateChanges[e1][r])this.deletedStates[e1][r][n] = null;
            else this.deletedStates[e1][r] = null;
        } else this.deletedStates[e1] = null;
    }
    getState(e1, t) {
        let n = String(t), r = this.state[e1] || {}, i = this.stateChanges[e1] || {}, a = (0, $caapT.Zn)({}, r[n], i[n]);
        if (this.deletedStates[e1] === null) return {};
        if (this.deletedStates[e1]) {
            let n = this.deletedStates[e1][t];
            if (n === null) return {};
            for(let e1 in n)delete a[e1];
        }
        return a;
    }
    initializeTileState(e1, t) {
        let n = {};
        for(let e1 in this.state)n[e1] = $902e455d852cdfb8$var$ba(this.state[e1]);
        e1.setFeatureState(n, t, this.revision);
    }
    coalesceChanges(e1, t) {
        let n = {};
        for(let e1 in this.stateChanges){
            this.state[e1] ||= {}, n[e1] ||= {};
            for(let t in this.stateChanges[e1])this.state[e1][t] ||= {}, (0, $caapT.Zn)(this.state[e1][t], this.stateChanges[e1][t]), n[e1][t] = this.state[e1][t];
        }
        for(let e1 in this.deletedStates)if (this.state[e1] ||= {}, n[e1] ||= {}, this.deletedStates[e1] === null) for(let t in this.state[e1])this.state[e1][t] = {}, n[e1][t] = {};
        else for(let t in this.deletedStates[e1]){
            if (this.deletedStates[e1][t] === null) this.state[e1][t] = {};
            else for (let n of Object.keys(this.deletedStates[e1][t]))delete this.state[e1][t][n];
            n[e1][t] = this.state[e1][t];
        }
        if (this.stateChanges = {}, this.deletedStates = {}, Object.keys(n).length === 0) return;
        this.revision++;
        let r = {};
        for(let e1 in n)r[e1] = $902e455d852cdfb8$var$ba(n[e1]);
        e1.setFeatureState(r, t, this.revision);
    }
};
const $902e455d852cdfb8$var$Sa = 89.25;
function $902e455d852cdfb8$var$Ca(e1, t, n) {
    let r = 1 / (1 << n.z);
    return new (0, $caapT.S)(e1 / (0, $caapT.Pr) * r + n.x * r, t / (0, $caapT.Pr) * r + n.y * r);
}
function $902e455d852cdfb8$var$wa(e1, t) {
    let n = (0, $caapT.In)(t.lat, -(0, $caapT.jn), (0, $caapT.jn));
    return new (0, $caapT.ji)((0, $caapT.E)(t.lng) * e1, (0, $caapT.D)(n) * e1);
}
function $902e455d852cdfb8$var$Ta(e1, t) {
    return new (0, $caapT.S)(t.x / e1, t.y / e1).toLngLat();
}
function $902e455d852cdfb8$var$Ea(e1) {
    return e1.cameraToCenterDistance * Math.min(Math.tan((0, $caapT.Gn)(90 - e1.pitch)) * .85, Math.tan((0, $caapT.Gn)($902e455d852cdfb8$var$Sa - e1.pitch)));
}
function $902e455d852cdfb8$var$Da(e1, t) {
    let n = e1.canonical, r = t / (0, $caapT.Mr)(n.z), i = n.x + 2 ** n.z * e1.wrap, a = new Float64Array(16);
    return (0, $caapT.gi)(a), (0, $caapT.Ti)(a, a, [
        i * r,
        n.y * r,
        0
    ]), (0, $caapT.wi)(a, a, [
        r / (0, $caapT.Pr),
        r / (0, $caapT.Pr),
        1
    ]), a;
}
function $902e455d852cdfb8$var$Oa(e1, t, n, r, i) {
    let a = (0, $caapT.S).fromLngLat(e1, t), o = i * (0, $caapT.O)(1, e1.lat), { x: s, y: c, z: l } = $902e455d852cdfb8$var$ka(n, r), u = o * -s, d = o * -c, f = o * -l;
    return new (0, $caapT.S)(a.x + u, a.y + d, a.z + f);
}
function $902e455d852cdfb8$var$ka(e1, t) {
    let n = (0, $caapT.Gn)(e1), r = (0, $caapT.Gn)(t), i = Math.cos(-n), a = Math.sin(n);
    return {
        x: a * Math.sin(r),
        y: -a * Math.cos(r),
        z: i
    };
}
function $902e455d852cdfb8$var$Aa(e1, t, n) {
    let r = t.intersectsFrustum(e1);
    if (!n || r === 0) return r;
    let i = t.intersectsPlane(n);
    return i === 0 ? 0 : r === 2 && i === 2 ? 2 : 1;
}
function $902e455d852cdfb8$var$ja(e1, t, n) {
    let r = 0, i = (n - t) / 10;
    for(let a = 0; a < 10; a++){
        let o = t + (a + .5) / 10 * (n - t);
        r += i * Math.cos(o) ** +e1;
    }
    return r;
}
function $902e455d852cdfb8$var$Ma(e1, t) {
    return function(n, r, i, a, o) {
        let s = 2 * ((e1 - 1) / (0, $caapT.wr)(Math.cos((0, $caapT.Gn)($902e455d852cdfb8$var$Sa - o)) / Math.cos((0, $caapT.Gn)($902e455d852cdfb8$var$Sa))) - 1), c = Math.acos(i / a), l = 2 * $902e455d852cdfb8$var$ja(s - 1, 0, (0, $caapT.Gn)(o / 2)), u = Math.min((0, $caapT.Gn)($902e455d852cdfb8$var$Sa), c + (0, $caapT.Gn)(o / 2)), d = Math.min(u, c - (0, $caapT.Gn)(o / 2)), f = $902e455d852cdfb8$var$ja(s - 1, d, u), p = Math.atan(r / i), m = Math.hypot(r, i), h = n;
        return h += (0, $caapT.wr)(a / m / Math.max(.5, Math.cos((0, $caapT.Gn)(o / 2)))), h += s * (0, $caapT.wr)(Math.cos(p)) / 2, h -= (0, $caapT.wr)(Math.max(1, f / l / t)) / 2, h;
    };
}
const $902e455d852cdfb8$var$Na = $902e455d852cdfb8$var$Ma(9.314, 3);
function $902e455d852cdfb8$var$Pa(e1, t) {
    let n = (t.roundZoom ? Math.round : Math.floor)(e1.zoom + (0, $caapT.wr)(e1.tileSize / t.tileSize));
    return Math.max(0, n);
}
function $902e455d852cdfb8$var$Fa(e1, t) {
    let n = e1.getCameraFrustum(), r = e1.getClippingPlane(), i = e1.screenPointToMercatorCoordinate(e1.getCameraPoint()), a = (0, $caapT.S).fromLngLat(e1.center, e1.elevation);
    i.z = a.z + Math.cos(e1.pitchInRadians) * e1.cameraToCenterDistance / e1.worldSize;
    let o = e1.getCoveringTilesDetailsProvider(), s = o.allowVariableZoom(e1, t), c = $902e455d852cdfb8$var$Pa(e1, t), l = t.minzoom || 0, u = t.maxzoom === void 0 ? e1.maxZoom : t.maxzoom, d = Math.min(Math.max(0, c), u), f = 2 ** d, p = [
        f * i.x,
        f * i.y,
        0
    ], m = [
        f * a.x,
        f * a.y,
        0
    ], h = Math.hypot(a.x - i.x, a.y - i.y), g = Math.abs(a.z - i.z), _ = Math.hypot(h, g), v = (e1)=>({
            zoom: 0,
            x: 0,
            y: 0,
            wrap: e1,
            fullyVisible: !1
        }), y = [], b = [];
    if (e1.renderWorldCopies && o.allowWorldCopies()) for(let e1 = 1; e1 <= 3; e1++)y.push(v(-e1)), y.push(v(e1));
    for(y.push(v(0)); y.length > 0;){
        let f = y.pop(), h = f.x, v = f.y, x = f.fullyVisible, S = {
            x: h,
            y: v,
            z: f.zoom
        }, C = o.getTileBoundingVolume(S, f.wrap, e1.elevation, t);
        if (!x) {
            let e1 = $902e455d852cdfb8$var$Aa(n, C, r);
            if (e1 === 0) continue;
            x = e1 === 2;
        }
        let w = o.distanceToTile2d(i.x, i.y, S, C), T = c;
        s && (T = (t.calculateTileZoom || $902e455d852cdfb8$var$Na)(e1.zoom + (0, $caapT.wr)(e1.tileSize / t.tileSize), w, g, _, e1.fov)), T = (t.roundZoom ? Math.round : Math.floor)(T), T = Math.max(0, T);
        let ee = Math.min(T, u);
        if (f.wrap = o.getWrap(a, S, f.wrap), f.zoom >= ee) {
            if (f.zoom < l) continue;
            let e1 = d - f.zoom, n = p[0] - .5 - (h << e1), r = p[1] - .5 - (v << e1), i = t.reparseOverscaled ? Math.max(f.zoom, T) : f.zoom;
            b.push({
                tileID: new (0, $caapT._)(f.zoom === u ? i : f.zoom, f.wrap, f.zoom, h, v),
                distanceSq: (0, $caapT.Rr)([
                    m[0] - .5 - h,
                    m[1] - .5 - v
                ]),
                tileDistanceToCamera: Math.sqrt(n * n + r * r)
            });
            continue;
        }
        for(let e1 = 0; e1 < 4; e1++){
            let t = (h << 1) + e1 % 2, n = (v << 1) + (e1 >> 1), r = f.zoom + 1;
            y.push({
                zoom: r,
                x: t,
                y: n,
                wrap: f.wrap,
                fullyVisible: x
            });
        }
    }
    return b.sort((e1, t)=>e1.distanceSq - t.distanceSq).map((e1)=>e1.tileID);
}
const $902e455d852cdfb8$var$Ia = (0, $caapT.h).fromPoints([
    new (0, $caapT.ji)(0, 0),
    new (0, $caapT.ji)((0, $caapT.Pr), (0, $caapT.Pr))
]);
function $902e455d852cdfb8$var$La(e1) {
    return e1 === `raster` || e1 === `image` || e1 === `video`;
}
function $902e455d852cdfb8$var$Ra(e1, t, n, r, i, a, o) {
    let s = $902e455d852cdfb8$export$461939dd4422153(), c = (0, $caapT.nr)(t);
    for (let l of t){
        let t = e1.getTileById(l.key);
        (t.fadingDirection === 0 || t.fadeOpacity === 0) && t.resetFadeLogic(), !$902e455d852cdfb8$var$za(e1, t, n, s, r, i, o) && ($902e455d852cdfb8$var$Ba(e1, t, n, s, a, o) || $902e455d852cdfb8$var$Ha(t, c, s, o) || t.resetFadeLogic());
    }
}
function $902e455d852cdfb8$var$za(e1, t, n, r, i, a, o) {
    if (!t.hasData()) return !1;
    let { tileID: s, fadingRole: c, fadingDirection: l, fadingParentID: u } = t;
    if (c === 0 && l === 1 && u) return n[u.key] = u, !0;
    let d = Math.max(s.overscaledZ - i, a);
    for(let i = s.overscaledZ - 1; i >= d; i--){
        let a = s.scaledTo(i), c = e1.getLoadedTile(a);
        if (c) return t.setCrossFadeLogic({
            fadingRole: 0,
            fadingDirection: 1,
            fadingParentID: c.tileID,
            fadeEndTime: r + o
        }), c.setCrossFadeLogic({
            fadingRole: 1,
            fadingDirection: 0,
            fadeEndTime: r + o
        }), n[a.key] = a, !0;
    }
    return !1;
}
function $902e455d852cdfb8$var$Ba(e1, t, n, r, i, a) {
    if (!t.hasData()) return !1;
    let o = t.tileID.children(i), s = $902e455d852cdfb8$var$Va(e1, t, o, n, r, i, a);
    if (s) return !0;
    for (let c of o)$902e455d852cdfb8$var$Va(e1, t, c.children(i), n, r, i, a) && (s = !0);
    return s;
}
function $902e455d852cdfb8$var$Va(e1, t, n, r, i, a, o) {
    if (n[0].overscaledZ >= a) return !1;
    let s = !1;
    for (let a of n){
        let n = e1.getLoadedTile(a);
        if (!n) continue;
        let { fadingRole: c, fadingDirection: l, fadingParentID: u } = n;
        (c !== 0 || l !== 0 || !u) && (n.setCrossFadeLogic({
            fadingRole: 0,
            fadingDirection: 0,
            fadingParentID: t.tileID,
            fadeEndTime: i + o
        }), t.setCrossFadeLogic({
            fadingRole: 1,
            fadingDirection: 1,
            fadeEndTime: i + o
        })), r[a.key] = a, s = !0;
    }
    return s;
}
function $902e455d852cdfb8$var$Ha(e1, t, n, r) {
    let i = e1.tileID;
    if (e1.selfFading) return !0;
    if (e1.hasData()) return !1;
    if (t.has(i)) {
        let t = n + r;
        return e1.setSelfFadeLogic(t), !0;
    }
    return !1;
}
function $902e455d852cdfb8$var$Ua(e1, t) {
    if (t <= 0) return !1;
    let n = $902e455d852cdfb8$export$461939dd4422153();
    for (let t of e1.getAllTiles())if (t.fadeEndTime >= n) return !0;
    return !1;
}
function $902e455d852cdfb8$var$Wa(e1, t) {
    let n = t.getRenderableIds();
    for (let r of n){
        if (!e1.neighboringTiles?.[r]) continue;
        let n = t.getTileById(r);
        e1.neighboringTiles[r].backfilled || $902e455d852cdfb8$var$Ga(e1, n), !n.neighboringTiles?.[e1.tileID.key]?.backfilled && $902e455d852cdfb8$var$Ga(n, e1);
    }
}
function $902e455d852cdfb8$var$Ga(e1, t) {
    e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0;
    let n = t.tileID.canonical.x - e1.tileID.canonical.x, r = t.tileID.canonical.y - e1.tileID.canonical.y, i = 2 ** e1.tileID.canonical.z, a = t.tileID.key;
    (n !== 0 || r !== 0) && (Math.abs(r) > 1 || (Math.abs(n) > 1 && (Math.abs(n + i) === 1 ? n += i : Math.abs(n - i) === 1 && (n -= i)), !(!t.dem || !e1.dem) && (e1.dem.backfillBorder(t.dem, n, r), e1.neighboringTiles?.[a] && (e1.neighboringTiles[a].backfilled = !0))));
}
var $902e455d852cdfb8$var$Ka = class {
    constructor(){
        this._tiles = {};
    }
    handleWrapJump(e1) {
        let t = {};
        for(let n in this._tiles){
            let r = this._tiles[n];
            r.tileID = r.tileID.unwrapTo(r.tileID.wrap + e1), t[r.tileID.key] = r;
        }
        this._tiles = t;
    }
    setFeatureState(e1, t, n) {
        for(let r in this._tiles)this._tiles[r].setFeatureState(e1, t, n);
    }
    getAllTiles() {
        return Object.values(this._tiles);
    }
    getAllIds(e1 = !1) {
        return e1 ? Object.values(this._tiles).map((e1)=>e1.tileID).sort((0, $caapT.b)).map((e1)=>e1.key) : Object.keys(this._tiles);
    }
    getTileById(e1) {
        return this._tiles[e1];
    }
    setTile(e1, t) {
        this._tiles[e1] = t;
    }
    deleteTileById(e1) {
        delete this._tiles[e1];
    }
    getLoadedTile(e1) {
        let t = this.getTileById(e1.key);
        return t?.hasData() ? t : null;
    }
    isIdRenderable(e1, t = !1) {
        return this.getTileById(e1)?.isRenderable(t);
    }
    getRenderableIds(e1 = 0, t) {
        let n = [];
        for (let e1 of this.getAllIds())this.isIdRenderable(e1, t) && n.push(this.getTileById(e1));
        return t ? n.sort((t, n)=>{
            let r = t.tileID, i = n.tileID, a = new (0, $caapT.ji)(r.canonical.x, r.canonical.y)._rotate(-e1), o = new (0, $caapT.ji)(i.canonical.x, i.canonical.y)._rotate(-e1);
            return r.overscaledZ - i.overscaledZ || o.y - a.y || o.x - a.x;
        }).map((e1)=>e1.tileID.key) : n.map((e1)=>e1.tileID).sort((0, $caapT.b)).map((e1)=>e1.key);
    }
}, $902e455d852cdfb8$var$qa = class e1 extends (0, $caapT.mn) {
    static{
        this.maxUnderzooming = 10;
    }
    static{
        this.maxOverzooming = 3;
    }
    constructor(e1, t, n){
        super(), this.id = e1, this.dispatcher = n, this.on(`data`, (e1)=>{
            this._dataHandler(e1);
        }), this.on(`dataloading`, ()=>{
            this._sourceErrored = !1;
        }), this.on(`error`, ()=>{
            this._sourceErrored = this._source.loaded();
        }), this._source = $902e455d852cdfb8$var$ua(e1, t, n, this), this._inViewTiles = new $902e455d852cdfb8$var$Ka, this._outOfViewCache = new (0, $caapT.s)(0, (e1)=>this._unloadTile(e1)), this._timers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._rasterFadeDuration = 0, this._maxFadingAncestorLevels = 5, this._state = new $902e455d852cdfb8$var$xa, this._didEmitContent = !1, this._updated = !1;
    }
    onAdd(e1) {
        this.map = e1, this._maxTileCacheSize = e1 ? e1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = e1 ? e1._maxTileCacheZoomLevels : null, this._source?.onAdd && this._source.onAdd(e1);
    }
    onRemove(e1) {
        for (let e1 of this._inViewTiles.getAllTiles())e1.unloadVectorData();
        this.clearTiles(), this._source?.onRemove && this._source.onRemove(e1), this._inViewTiles = new $902e455d852cdfb8$var$Ka;
    }
    loaded() {
        if (this._sourceErrored) return !0;
        if (!this._sourceLoaded || !this._source.loaded()) return !1;
        if ((this.used !== void 0 || this.usedForTerrain !== void 0) && !this.used && !this.usedForTerrain) return !0;
        if (!this._updated) return !1;
        for (let e1 of this._inViewTiles.getAllTiles())if (e1.state !== `loaded` && e1.state !== `errored`) return !1;
        return !0;
    }
    getSource() {
        return this._source;
    }
    getState() {
        return this._state;
    }
    pause() {
        this._paused = !0;
    }
    resume() {
        if (!this._paused) return;
        let e1 = this._shouldReloadOnResume;
        this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
    }
    async _loadTile(e1, t, n) {
        try {
            let r = await this._source.loadTile(e1);
            this._tileLoaded(e1, t, n, r);
        } catch (t) {
            e1.state = `errored`, t.status === 404 ? this.update(this.transform, this.terrain) : this._source.fire(new (0, $caapT.fn)((0, $caapT.Yn)(t), {
                tile: e1
            }));
        }
    }
    _unloadTile(e1) {
        this._source.unloadTile && this._source.unloadTile(e1);
    }
    _abortTile(e1) {
        this._source.abortTile && this._source.abortTile(e1), this._source.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`dataabort`, {
            tile: e1,
            coord: e1.tileID
        }));
    }
    serialize() {
        return this._source.serialize();
    }
    prepare(e1) {
        this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._inViewTiles, this.map ? this.map.painter : null);
        for (let t of this._inViewTiles.getAllTiles())t.upload(e1), t.prepare(this.map.style.imageManager);
    }
    getIds() {
        return this._inViewTiles.getAllIds(!0);
    }
    getRenderableIds(e1) {
        return this._inViewTiles.getRenderableIds(this.transform?.bearingInRadians, e1);
    }
    hasRenderableParent(e1) {
        let t = e1.overscaledZ - 1;
        if (t >= this._source.minzoom) {
            let n = this.getLoadedTile(e1.scaledTo(t));
            if (n) return this._inViewTiles.isIdRenderable(n.tileID.key);
        }
        return !1;
    }
    reload(e1, t) {
        if (this._paused) {
            this._shouldReloadOnResume = !0;
            return;
        }
        this._outOfViewCache.reset();
        for (let n of this._inViewTiles.getAllIds()){
            let r = this._inViewTiles.getTileById(n);
            t && !this._source.shouldReloadTile(r, t) || (e1 ? this._reloadTile(n, `expired`) : r.state !== `errored` && this._reloadTile(n, `reloading`));
        }
    }
    async _reloadTile(e1, t) {
        let n = this._inViewTiles.getTileById(e1);
        n && (n.state !== `loading` && (n.state = t), await this._loadTile(n, e1, t));
    }
    _tileLoaded(e1, t, n, r) {
        e1.timeAdded = $902e455d852cdfb8$export$461939dd4422153(), e1.selfFading && (e1.fadeEndTime = e1.timeAdded + this._rasterFadeDuration), n === `expired` && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(t, e1), !r?.unmodified && (this.getSource().type === `raster-dem` && e1.dem && $902e455d852cdfb8$var$Wa(e1, this._inViewTiles), e1.featureStateRevision = -1, this._state.initializeTileState(e1, this.map ? this.map.painter : null), e1.aborted || this._source.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
            tile: e1,
            coord: e1.tileID
        })));
    }
    getTile(e1) {
        return this.getTileByID(e1.key);
    }
    getTileByID(e1) {
        return this._inViewTiles.getTileById(e1);
    }
    _retainLoadedChildren(t, n) {
        let r = this._getLoadedDescendents(n), i = new Set;
        for (let a of n){
            let n = r[a.key];
            if (!n?.length) {
                i.add(a);
                continue;
            }
            let o = a.overscaledZ + e1.maxOverzooming, s = n.filter((e1)=>e1.tileID.overscaledZ <= o);
            if (!s.length) {
                i.add(a);
                continue;
            }
            let c = Math.min(...s.map((e1)=>e1.tileID.overscaledZ)), l = s.filter((e1)=>e1.tileID.overscaledZ === c).map((e1)=>e1.tileID);
            for (let e1 of l)t[e1.key] = e1;
            this._areDescendentsComplete(l, c, a.overscaledZ) || i.add(a);
        }
        return i;
    }
    _getLoadedDescendents(e1) {
        let t = {};
        for (let n of this._inViewTiles.getAllTiles().filter((e1)=>e1.hasData()))for (let r of e1)n.tileID.isChildOf(r) && (t[r.key] ||= [], t[r.key].push(n));
        return t;
    }
    _areDescendentsComplete(e1, t, n) {
        return e1.length === 1 && e1[0].isOverscaled() ? e1[0].overscaledZ === t : 4 ** (t - n) === e1.length;
    }
    getLoadedTile(e1) {
        return this._inViewTiles.getLoadedTile(e1);
    }
    updateCacheSize(e1) {
        let t = (Math.ceil(e1.width / this._source.tileSize) + 1) * (Math.ceil(e1.height / this._source.tileSize) + 1), n = this._maxTileCacheZoomLevels === null ? (0, $caapT.En).MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels, r = Math.floor(t * n), i = typeof this._maxTileCacheSize == `number` ? Math.min(this._maxTileCacheSize, r) : r;
        this._outOfViewCache.setMaxSize(i);
    }
    handleWrapJump(e1) {
        let t = (e1 - (this._prevLng === void 0 ? e1 : this._prevLng)) / 360, n = Math.round(t);
        this._prevLng = e1, n && (this._inViewTiles.handleWrapJump(n), this._resetTileReloadTimers());
    }
    update(e1, t) {
        if (!this._sourceLoaded || this._paused) return;
        this.transform = e1, this.terrain = t, this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng);
        let n;
        !this.used && !this.usedForTerrain ? n = [] : this._source.tileID ? n = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new (0, $caapT._)(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (n = $902e455d852cdfb8$var$Fa(e1, {
            tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
            minzoom: this._source.minzoom,
            maxzoom: this._source.type === `vector` && this.map._zoomLevelsToOverscale !== void 0 ? Math.max(this._source.maxzoom, e1.maxZoom - this.map._zoomLevelsToOverscale) : this._source.maxzoom,
            roundZoom: !this.usedForTerrain && this._source.roundZoom,
            reparseOverscaled: this._source.reparseOverscaled,
            terrain: t,
            calculateTileZoom: this._source.calculateTileZoom
        }), this._source.hasTile && (n = n.filter((e1)=>this._source.hasTile(e1)))), this.usedForTerrain && (n = this._addTerrainIdealTiles(n));
        let r = n.length === 0 && !this._updated && this._didEmitContent;
        this._updated = !0, r && this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
        let i = $902e455d852cdfb8$var$Pa(e1, this._source), a = this._updateRetainedTiles(n, i), o = $902e455d852cdfb8$var$La(this._source.type);
        o && this._rasterFadeDuration > 0 && !t && $902e455d852cdfb8$var$Ra(this._inViewTiles, n, a, this._maxFadingAncestorLevels, this._source.minzoom, this._source.maxzoom, this._rasterFadeDuration), o ? this._cleanUpRasterTiles(a) : this._cleanUpVectorTiles(a);
    }
    _cleanUpRasterTiles(e1) {
        for (let t of this._inViewTiles.getAllIds())e1[t] || this._removeTile(t);
    }
    _cleanUpVectorTiles(e1) {
        for (let t of this._inViewTiles.getAllIds()){
            let n = this._inViewTiles.getTileById(t);
            if (e1[t]) {
                n.clearSymbolFadeHold();
                continue;
            }
            if (!n.hasSymbolBuckets) {
                this._removeTile(t);
                continue;
            }
            n.holdingForSymbolFade() ? n.symbolFadeFinished() && this._removeTile(t) : n.setSymbolHoldDuration(this.map._fadeDuration);
        }
    }
    _addTerrainIdealTiles(e1) {
        let t = [];
        for (let n of e1)if (n.canonical.z > this._source.minzoom) {
            let e1 = n.scaledTo(n.canonical.z - 1);
            t.push(e1);
            let r = n.scaledTo(Math.max(this._source.minzoom, Math.min(n.canonical.z, 5)));
            t.push(r);
        }
        return e1.concat(t);
    }
    releaseSymbolFadeTiles() {
        for (let e1 of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(e1).holdingForSymbolFade() && this._removeTile(e1);
    }
    _updateRetainedTiles(t, n) {
        let r = new Set;
        for (let e1 of t)this._addTile(e1).hasData() || r.add(e1);
        let i = t.reduce((e1, t)=>(e1[t.key] = t, e1), {}), a = this._retainLoadedChildren(i, r), o = {}, s = Math.max(n - e1.maxUnderzooming, this._source.minzoom);
        for (let e1 of a){
            let t = this._inViewTiles.getTileById(e1.key), n = t?.wasRequested();
            for(let r = e1.overscaledZ - 1; r >= s; --r){
                let a = e1.scaledTo(r);
                if (o[a.key]) break;
                if (o[a.key] = !0, t = this.getTile(a), !t && n && (t = this._addTile(a)), t) {
                    let e1 = t.hasData();
                    if ((e1 || !this.map?.cancelPendingTileRequestsWhileZooming || n) && (i[a.key] = a), n = t.wasRequested(), e1) break;
                }
            }
        }
        return i;
    }
    _addTile(e1) {
        let t = this._inViewTiles.getTileById(e1.key);
        if (t) return t;
        t = this._outOfViewCache.getAndRemove(e1), t && (t.resetFadeLogic(), this._setTileReloadTimer(e1.key, t), t.tileID = e1, this._state.initializeTileState(t, this.map ? this.map.painter : null));
        let n = t;
        return t || (t = new $902e455d852cdfb8$var$ya(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(t, e1.key, t.state)), t.uses++, this._inViewTiles.setTile(e1.key, t), n || this._source.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`dataloading`, {
            tile: t,
            coord: t.tileID
        })), t;
    }
    _setTileReloadTimer(e1, t) {
        this._clearTileReloadTimer(e1);
        let n = t.getExpiryTimeout();
        if (n) {
            let t = ()=>{
                this._reloadTile(e1, `expired`), delete this._timers[e1];
            };
            this._timers[e1] = setTimeout(t, n);
        }
    }
    _clearTileReloadTimer(e1) {
        let t = this._timers[e1];
        t && (clearTimeout(t), delete this._timers[e1]);
    }
    _resetTileReloadTimers() {
        for(let e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
        for (let e1 of this._inViewTiles.getAllIds()){
            let t = this._inViewTiles.getTileById(e1);
            this._setTileReloadTimer(e1, t);
        }
    }
    refreshTiles(e1) {
        for (let t of this._inViewTiles.getAllIds()){
            let n = this._inViewTiles.getTileById(t);
            !this._inViewTiles.isIdRenderable(t) && n.state != `errored` || e1.some((e1)=>e1.equals(n.tileID.canonical)) && this._reloadTile(t, `expired`);
        }
    }
    _removeTile(e1) {
        let t = this._inViewTiles.getTileById(e1);
        t && (t.uses--, this._inViewTiles.deleteTileById(e1), this._clearTileReloadTimer(e1), !(t.uses > 0) && (t.hasData() && t.state !== `reloading` ? this._outOfViewCache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0, this._abortTile(t), this._unloadTile(t))));
    }
    _dataHandler(e1) {
        if (e1.dataType === `source`) {
            if (e1.sourceDataType === `metadata`) {
                this._sourceLoaded = !0;
                return;
            }
            e1.sourceDataType !== `content` || !this._sourceLoaded || this._paused || (this.reload(e1.sourceDataChanged, e1.shouldReloadTileOptions), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
        }
    }
    clearTiles() {
        this._shouldReloadOnResume = !1, this._paused = !1;
        for (let e1 of this._inViewTiles.getAllIds())this._removeTile(e1);
        this._outOfViewCache.reset();
    }
    tilesIn(e1, t, n) {
        let r = [], i = this.transform;
        if (!i) return r;
        let a = i.getCoveringTilesDetailsProvider().allowWorldCopies(), o = n ? i.getCameraQueryGeometry(e1) : e1, s = (e1)=>i.screenPointToMercatorCoordinate(e1, this.terrain), c = this.transformBbox(e1, s, !a), l = this.transformBbox(o, s, !a), u = this.getIds(), d = (0, $caapT.h).fromPoints(l);
        for (let e1 of u){
            let n = this._inViewTiles.getTileById(e1);
            if (n.holdingForSymbolFade()) continue;
            let o = a ? [
                n.tileID
            ] : [
                n.tileID.unwrapTo(-1),
                n.tileID.unwrapTo(0)
            ], s = 2 ** (i.zoom - n.tileID.overscaledZ), u = t * n.queryPadding * (0, $caapT.Pr) / n.tileSize / s;
            for (let e1 of o){
                let t = d.map((t)=>e1.getTilePoint(new (0, $caapT.S)(t.x, t.y)));
                if (t.expandBy(u), t.intersects($902e455d852cdfb8$var$Ia)) {
                    let t = c.map((t)=>e1.getTilePoint(t)), i = l.map((t)=>e1.getTilePoint(t));
                    r.push({
                        tile: n,
                        tileID: a ? e1 : e1.unwrapTo(0),
                        queryGeometry: t,
                        cameraQueryGeometry: i,
                        scale: s
                    });
                }
            }
        }
        return r;
    }
    transformBbox(e1, t, n) {
        let r = e1.map(t);
        if (n) {
            let n = (0, $caapT.h).fromPoints(e1);
            n.shrinkBy(Math.min(n.width(), n.height()) * .001);
            let i = n.map(t);
            (0, $caapT.h).fromPoints(r).covers(i) || (r = r.map((e1)=>e1.x > .5 ? new (0, $caapT.S)(e1.x - 1, e1.y, e1.z) : e1));
        }
        return r;
    }
    getVisibleCoordinates(e1) {
        let t = this.getRenderableIds(e1).map((e1)=>this._inViewTiles.getTileById(e1).tileID);
        return this.transform && this.transform.populateCache(t), t;
    }
    hasTransition() {
        return this._source.hasTransition() ? !0 : $902e455d852cdfb8$var$La(this._source.type) && $902e455d852cdfb8$var$Ua(this._inViewTiles, this._rasterFadeDuration);
    }
    setRasterFadeDuration(e1) {
        this._rasterFadeDuration = e1;
    }
    setFeatureState(e1, t, n) {
        e1 ||= (0, $caapT.f), this._state.updateState(e1, t, n);
    }
    removeFeatureState(e1, t, n) {
        e1 ||= (0, $caapT.f), this._state.removeFeatureState(e1, t, n);
    }
    getFeatureState(e1, t) {
        return e1 ||= (0, $caapT.f), this._state.getState(e1, t);
    }
    setDependencies(e1, t, n) {
        let r = this._inViewTiles.getTileById(e1);
        r && r.setDependencies(t, n);
    }
    reloadTilesForDependencies(e1, t) {
        for (let n of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(n).hasDependency(e1, t) && this._reloadTile(n, `reloading`);
        this._outOfViewCache.filter((n)=>!n.hasDependency(e1, t));
    }
    areTilesLoaded() {
        for (let e1 of this._inViewTiles.getAllTiles())if (e1.state !== `loaded` && e1.state !== `errored`) return !1;
        return !0;
    }
}, $902e455d852cdfb8$var$Ja = class {
    constructor(e1, t){
        this.reset(e1, t);
    }
    reset(e1, t) {
        this.points = e1 || [], this._distances = [
            0
        ];
        for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
        this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, this.length * .5), this.paddedLength = this.length - this.padding * 2;
    }
    lerp(e1) {
        if (this.points.length === 1) return this.points[0];
        e1 = (0, $caapT.In)(e1, 0, 1);
        let t = 1, n = this._distances[t], r = e1 * this.paddedLength + this.padding;
        for(; n < r && t < this._distances.length;)n = this._distances[++t];
        let i = t - 1, a = this._distances[i], o = n - a, s = o > 0 ? (r - a) / o : 0;
        return this.points[i].mult(1 - s).add(this.points[t].mult(s));
    }
};
function $902e455d852cdfb8$var$Ya(e1, t) {
    let n = !0;
    return e1 === `always` || (e1 === `never` || t === `never`) && (n = !1), n;
}
var $902e455d852cdfb8$var$Xa = class {
    constructor(e1, t, n){
        let r = this.boxCells = [], i = this.circleCells = [];
        this.xCellCount = Math.ceil(e1 / n), this.yCellCount = Math.ceil(t / n);
        for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)r.push([]), i.push([]);
        this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
    }
    keysLength() {
        return this.boxKeys.length + this.circleKeys.length;
    }
    insert(e1, t, n, r, i) {
        this._forEachCell(t, n, r, i, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t), this.bboxes.push(n), this.bboxes.push(r), this.bboxes.push(i);
    }
    insertCircle(e1, t, n, r) {
        this._forEachCell(t - r, n - r, t + r, n + r, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t), this.circles.push(n), this.circles.push(r);
    }
    _insertBoxCell(e1, t, n, r, i, a) {
        this.boxCells[i].push(a);
    }
    _insertCircleCell(e1, t, n, r, i, a) {
        this.circleCells[i].push(a);
    }
    _query(e1, t, n, r, i, a, o) {
        if (n < 0 || e1 > this.width || r < 0 || t > this.height) return [];
        let s = [];
        if (e1 <= 0 && t <= 0 && this.width <= n && this.height <= r) {
            if (i) return [
                {
                    key: null,
                    x1: e1,
                    y1: t,
                    x2: n,
                    y2: r
                }
            ];
            for(let e1 = 0; e1 < this.boxKeys.length; e1++)s.push({
                key: this.boxKeys[e1],
                x1: this.bboxes[e1 * 4],
                y1: this.bboxes[e1 * 4 + 1],
                x2: this.bboxes[e1 * 4 + 2],
                y2: this.bboxes[e1 * 4 + 3]
            });
            for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                let t = this.circles[e1 * 3], n = this.circles[e1 * 3 + 1], r = this.circles[e1 * 3 + 2];
                s.push({
                    key: this.circleKeys[e1],
                    x1: t - r,
                    y1: n - r,
                    x2: t + r,
                    y2: n + r
                });
            }
        } else {
            let c = {
                hitTest: i,
                overlapMode: a,
                seenUids: {
                    box: {},
                    circle: {}
                }
            };
            this._forEachCell(e1, t, n, r, this._queryCell, s, c, o);
        }
        return s;
    }
    query(e1, t, n, r) {
        return this._query(e1, t, n, r, !1, null);
    }
    hitTest(e1, t, n, r, i, a) {
        return this._query(e1, t, n, r, !0, i, a).length > 0;
    }
    hitTestCircle(e1, t, n, r, i) {
        let a = e1 - n, o = e1 + n, s = t - n, c = t + n;
        if (o < 0 || a > this.width || c < 0 || s > this.height) return !1;
        let l = [], u = {
            hitTest: !0,
            overlapMode: r,
            circle: {
                x: e1,
                y: t,
                radius: n
            },
            seenUids: {
                box: {},
                circle: {}
            }
        };
        return this._forEachCell(a, s, o, c, this._queryCellCircle, l, u, i), l.length > 0;
    }
    _queryCell(e1, t, n, r, i, a, o, s) {
        let { seenUids: c, hitTest: l, overlapMode: u } = o, d = this.boxCells[i], f = 1e-6;
        if (d !== null) {
            let i = this.bboxes;
            for (let o of d)if (!c.box[o]) {
                c.box[o] = !0;
                let d = o * 4, p = this.boxKeys[o];
                if (e1 <= i[d + 2] + f && t <= i[d + 3] + f && n >= i[d + 0] - f && r >= i[d + 1] - f && (!s || s(p)) && (!l || !$902e455d852cdfb8$var$Ya(u, p.overlapMode)) && (a.push({
                    key: p,
                    x1: i[d],
                    y1: i[d + 1],
                    x2: i[d + 2],
                    y2: i[d + 3]
                }), l)) return !0;
            }
        }
        let p = this.circleCells[i];
        if (p !== null) {
            let i = this.circles;
            for (let o of p)if (!c.circle[o]) {
                c.circle[o] = !0;
                let d = o * 3, f = this.circleKeys[o];
                if (this._circleAndRectCollide(i[d], i[d + 1], i[d + 2], e1, t, n, r) && (!s || s(f)) && (!l || !$902e455d852cdfb8$var$Ya(u, f.overlapMode))) {
                    let e1 = i[d], t = i[d + 1], n = i[d + 2];
                    if (a.push({
                        key: f,
                        x1: e1 - n,
                        y1: t - n,
                        x2: e1 + n,
                        y2: t + n
                    }), l) return !0;
                }
            }
        }
        return !1;
    }
    _queryCellCircle(e1, t, n, r, i, a, o, s) {
        let { circle: c, seenUids: l, overlapMode: u } = o, d = this.boxCells[i];
        if (d !== null) {
            let e1 = this.bboxes;
            for (let t of d)if (!l.box[t]) {
                l.box[t] = !0;
                let n = t * 4, r = this.boxKeys[t];
                if (this._circleAndRectCollide(c.x, c.y, c.radius, e1[n + 0], e1[n + 1], e1[n + 2], e1[n + 3]) && (!s || s(r)) && !$902e455d852cdfb8$var$Ya(u, r.overlapMode)) return a.push(!0), !0;
            }
        }
        let f = this.circleCells[i];
        if (f !== null) {
            let e1 = this.circles;
            for (let t of f)if (!l.circle[t]) {
                l.circle[t] = !0;
                let n = t * 3, r = this.circleKeys[t];
                if (this._circlesCollide(e1[n], e1[n + 1], e1[n + 2], c.x, c.y, c.radius) && (!s || s(r)) && !$902e455d852cdfb8$var$Ya(u, r.overlapMode)) return a.push(!0), !0;
            }
        }
    }
    _forEachCell(e1, t, n, r, i, a, o, s) {
        let c = this._convertToXCellCoord(e1), l = this._convertToYCellCoord(t), u = this._convertToXCellCoord(n), d = this._convertToYCellCoord(r);
        for(let f = c; f <= u; f++)for(let c = l; c <= d; c++){
            let l = this.xCellCount * c + f;
            if (i.call(this, e1, t, n, r, l, a, o, s)) return;
        }
    }
    _convertToXCellCoord(e1) {
        return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
    }
    _convertToYCellCoord(e1) {
        return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
    }
    _circlesCollide(e1, t, n, r, i, a) {
        let o = r - e1, s = i - t, c = n + a;
        return c * c > o * o + s * s;
    }
    _circleAndRectCollide(e1, t, n, r, i, a, o) {
        let s = (a - r) / 2, c = Math.abs(e1 - (r + s));
        if (c > s + n) return !1;
        let l = (o - i) / 2, u = Math.abs(t - (i + l));
        if (u > l + n) return !1;
        if (c <= s || u <= l) return !0;
        let d = c - s, f = u - l;
        return d * d + f * f <= n * n;
    }
};
function $902e455d852cdfb8$var$Za(e1, t) {
    let n = 1 / (t[0] * t[0] + t[1] * t[1] + t[2] * t[2]), r = 1 / (t[8] * t[8] + t[9] * t[9] + t[10] * t[10]), i = t[0] * n, a = t[4] * n, o = t[8] * r, s = t[1] * n, c = t[5] * n, l = t[9] * r, u = t[2] * n, d = t[6] * n, f = t[10] * r;
    e1[0] = i, e1[1] = a, e1[2] = o, e1[4] = s, e1[5] = c, e1[6] = l, e1[8] = u, e1[9] = d, e1[10] = f;
    let p = t[12], m = t[13], h = t[14];
    return e1[12] = -i * p - s * m - u * h, e1[13] = -a * p - c * m - d * h, e1[14] = -o * p - l * m - f * h, e1[3] = 0, e1[7] = 0, e1[11] = 0, e1[15] = 1, e1;
}
function $902e455d852cdfb8$var$Qa(e1, t) {
    return e1[0] = 1 / t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1 / t[5], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 0, e1[11] = 1 / t[14], e1[12] = 0, e1[13] = 0, e1[14] = -1, e1[15] = t[10] / t[14], e1;
}
function $902e455d852cdfb8$var$$a(e1, t) {
    let n = 1 / (t[0] * t[5] - t[1] * t[4]);
    return e1[0] = t[5] * n, e1[1] = -t[1] * n, e1[2] = 0, e1[3] = 0, e1[4] = -t[4] * n, e1[5] = t[0] * n, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1 / t[10], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1 / t[15], e1;
}
const $902e455d852cdfb8$var$eo = (0, $caapT.fi)();
function $902e455d852cdfb8$var$to(e1, t, n) {
    let r = (0, $caapT.fi)();
    if (!e1) {
        let { vecSouth: e1, vecEast: n } = $902e455d852cdfb8$var$ro(t), i = $902e455d852cdfb8$var$xr();
        i[0] = n[0], i[1] = n[1], i[2] = e1[0], i[3] = e1[1], $902e455d852cdfb8$var$Sr(i, i), r[0] = i[0], r[1] = i[1], r[4] = i[2], r[5] = i[3];
    }
    return (0, $caapT.wi)(r, r, [
        1 / n,
        1 / n,
        1
    ]), r;
}
function $902e455d852cdfb8$var$no(e1, t, n, r) {
    if (e1) {
        let e1 = (0, $caapT.fi)();
        if (!t) {
            let { vecSouth: t, vecEast: r } = $902e455d852cdfb8$var$ro(n);
            e1[0] = r[0], e1[1] = r[1], e1[4] = t[0], e1[5] = t[1];
        }
        return (0, $caapT.wi)(e1, e1, [
            r,
            r,
            1
        ]), e1;
    } else return n.pixelsToClipSpaceMatrix;
}
function $902e455d852cdfb8$var$ro(e1) {
    let t = Math.cos(e1.rollInRadians), n = Math.sin(e1.rollInRadians), r = Math.cos(e1.pitchInRadians), i = Math.cos(e1.bearingInRadians), a = Math.sin(e1.bearingInRadians), o = (0, $caapT.Fr)();
    o[0] = -i * r * n - a * t, o[1] = -a * r * n + i * t;
    let s = (0, $caapT.Ir)(o);
    s < 1e-9 ? (0, $caapT.Br)(o) : (0, $caapT.Lr)(o, o, 1 / s);
    let c = (0, $caapT.Fr)();
    c[0] = i * r * t - a * n, c[1] = a * r * t + i * n;
    let u = (0, $caapT.Ir)(c);
    return u < 1e-9 ? (0, $caapT.Br)(c) : (0, $caapT.Lr)(c, c, 1 / u), {
        vecEast: c,
        vecSouth: o
    };
}
function $902e455d852cdfb8$var$io(e1, t, n, r) {
    let i;
    r ? (i = [
        e1,
        t,
        r(e1, t),
        1
    ], (0, $caapT.Gr)(i, i, n)) : (i = [
        e1,
        t,
        0,
        1
    ], $902e455d852cdfb8$var$So(i, i, n));
    let a = i[3];
    return {
        point: new (0, $caapT.ji)(i[0] / a, i[1] / a),
        signedDistanceFromCamera: a,
        isOccluded: !1
    };
}
function $902e455d852cdfb8$var$ao(e1, t) {
    return .5 + e1 / t * .5;
}
function $902e455d852cdfb8$var$oo(e1, t) {
    return e1.x >= -t[0] && e1.x <= t[0] && e1.y >= -t[1] && e1.y <= t[1];
}
function $902e455d852cdfb8$var$so(e1, t, n, r, i, a, o, c, l, u, d, f, p) {
    let m = n ? e1.textSizeData : e1.iconSizeData, h = (0, $caapT.V)(m, t.transform.zoom), g = [
        256 / t.width * 2 + 1,
        256 / t.height * 2 + 1
    ], _ = n ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
    _.clear();
    let v = e1.lineVertexArray, y = n ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, b = t.transform.width / t.transform.height, x = !1;
    for(let n = 0; n < y.length; n++){
        let S = y.get(n);
        if (S.hidden || S.writingMode === 2 && !x) {
            $902e455d852cdfb8$var$xo(S.numGlyphs, _);
            continue;
        }
        x = !1;
        let C = new (0, $caapT.ji)(S.anchorX, S.anchorY), w = {
            getElevation: p,
            pitchedLabelPlaneMatrix: r,
            lineVertexArray: v,
            pitchWithMap: a,
            projectionCache: {
                projections: {},
                offsets: {},
                cachedAnchorPoint: void 0,
                anyProjectionOccluded: !1
            },
            transform: t.transform,
            tileAnchorPoint: C,
            unwrappedTileID: l,
            width: u,
            height: d,
            translation: f
        }, T = $902e455d852cdfb8$var$go(S.anchorX, S.anchorY, w);
        if (!$902e455d852cdfb8$var$oo(T.point, g)) {
            $902e455d852cdfb8$var$xo(S.numGlyphs, _);
            continue;
        }
        let ee = T.signedDistanceFromCamera, E = $902e455d852cdfb8$var$ao(t.transform.cameraToCenterDistance, ee), D = (0, $caapT.B)(m, h, S), O = a ? D * t.transform.getPitchedTextCorrection(S.anchorX, S.anchorY, l) / E : D * E, te = $902e455d852cdfb8$var$uo({
            projectionContext: w,
            pitchedLabelPlaneMatrixInverse: i,
            symbol: S,
            fontSize: O,
            flip: !1,
            keepUpright: o,
            glyphOffsetArray: e1.glyphOffsetArray,
            dynamicLayoutVertexArray: _,
            aspectRatio: b,
            rotateToLine: c
        });
        x = te.useVertical, (te.notEnoughRoom || x || te.needsFlipping && $902e455d852cdfb8$var$uo({
            projectionContext: w,
            pitchedLabelPlaneMatrixInverse: i,
            symbol: S,
            fontSize: O,
            flip: !0,
            keepUpright: o,
            glyphOffsetArray: e1.glyphOffsetArray,
            dynamicLayoutVertexArray: _,
            aspectRatio: b,
            rotateToLine: c
        }).notEnoughRoom) && $902e455d852cdfb8$var$xo(S.numGlyphs, _);
    }
    n ? e1.text.dynamicLayoutVertexBuffer.updateData(_) : e1.icon.dynamicLayoutVertexBuffer.updateData(_);
}
function $902e455d852cdfb8$var$co(e1, t, n, r, i, a, o, s) {
    let c = a.glyphStartIndex + a.numGlyphs, l = a.lineStartIndex, u = a.lineStartIndex + a.lineLength, d = t.getoffsetX(a.glyphStartIndex), f = t.getoffsetX(c - 1), p = $902e455d852cdfb8$var$yo(e1 * d, n, r, i, a.segment, l, u, s, o);
    if (!p) return null;
    let m = $902e455d852cdfb8$var$yo(e1 * f, n, r, i, a.segment, l, u, s, o);
    return !m || s.projectionCache.anyProjectionOccluded ? null : {
        first: p,
        last: m
    };
}
function $902e455d852cdfb8$var$lo(e1, t, n, r) {
    return e1 === 1 && Math.abs(n.y - t.y) > Math.abs(n.x - t.x) * r ? {
        useVertical: !0
    } : (e1 === 2 ? t.y < n.y : t.x > n.x) ? {
        needsFlipping: !0
    } : null;
}
function $902e455d852cdfb8$var$uo(e1) {
    let { projectionContext: t, pitchedLabelPlaneMatrixInverse: n, symbol: r, fontSize: i, flip: a, keepUpright: o, glyphOffsetArray: s, dynamicLayoutVertexArray: c, aspectRatio: l, rotateToLine: u } = e1, d = i / 24, f = r.lineOffsetX * d, p = r.lineOffsetY * d, m;
    if (r.numGlyphs > 1) {
        let e1 = r.glyphStartIndex + r.numGlyphs, i = r.lineStartIndex, c = r.lineStartIndex + r.lineLength, h = $902e455d852cdfb8$var$co(d, s, f, p, a, r, u, t);
        if (!h) return {
            notEnoughRoom: !0
        };
        let g = $902e455d852cdfb8$var$ho(h.first.point.x, h.first.point.y, t, n), _ = $902e455d852cdfb8$var$ho(h.last.point.x, h.last.point.y, t, n);
        if (o && !a) {
            let e1 = $902e455d852cdfb8$var$lo(r.writingMode, g, _, l);
            if (e1) return e1;
        }
        m = [
            h.first
        ];
        for(let n = r.glyphStartIndex + 1; n < e1 - 1; n++){
            let e1 = $902e455d852cdfb8$var$yo(d * s.getoffsetX(n), f, p, a, r.segment, i, c, t, u);
            if (!e1) return {
                notEnoughRoom: !0
            };
            m.push(e1);
        }
        m.push(h.last);
    } else {
        if (o && !a) {
            let e1 = $902e455d852cdfb8$var$mo(t.tileAnchorPoint.x, t.tileAnchorPoint.y, t).point, i = r.lineStartIndex + r.segment + 1, a = new (0, $caapT.ji)(t.lineVertexArray.getx(i), t.lineVertexArray.gety(i)), o = $902e455d852cdfb8$var$mo(a.x, a.y, t), s = o.signedDistanceFromCamera > 0 ? o.point : $902e455d852cdfb8$var$fo(t.tileAnchorPoint, a, e1, 1, t), c = $902e455d852cdfb8$var$ho(e1.x, e1.y, t, n), u = $902e455d852cdfb8$var$ho(s.x, s.y, t, n), d = $902e455d852cdfb8$var$lo(r.writingMode, c, u, l);
            if (d) return d;
        }
        let e1 = $902e455d852cdfb8$var$yo(d * s.getoffsetX(r.glyphStartIndex), f, p, a, r.segment, r.lineStartIndex, r.lineStartIndex + r.lineLength, t, u);
        if (!e1 || t.projectionCache.anyProjectionOccluded) return {
            notEnoughRoom: !0
        };
        m = [
            e1
        ];
    }
    for (let e1 of m)(0, $caapT.R)(c, e1.point, e1.angle);
    return {};
}
function $902e455d852cdfb8$var$fo(e1, t, n, r, i) {
    let a = e1.add(e1.sub(t)._unit()), o = $902e455d852cdfb8$var$mo(a.x, a.y, i).point, s = n.sub(o);
    return n.add(s._mult(r / s.mag()));
}
function $902e455d852cdfb8$var$po(e1, t, n) {
    let r = t.projectionCache;
    if (r.projections[e1]) return r.projections[e1];
    let i = new (0, $caapT.ji)(t.lineVertexArray.getx(e1), t.lineVertexArray.gety(e1)), a = $902e455d852cdfb8$var$mo(i.x, i.y, t);
    if (a.signedDistanceFromCamera > 0) return r.projections[e1] = a.point, r.anyProjectionOccluded ||= a.isOccluded, a.point;
    let o = e1 - n.direction, s = n.distanceFromAnchor === 0 ? t.tileAnchorPoint : new (0, $caapT.ji)(t.lineVertexArray.getx(o), t.lineVertexArray.gety(o)), c = n.absOffsetX - n.distanceFromAnchor + 1;
    return $902e455d852cdfb8$var$fo(s, i, n.previousVertex, c, t);
}
function $902e455d852cdfb8$var$mo(e1, t, n) {
    let r = e1 + n.translation[0], i = t + n.translation[1], a;
    return n.pitchWithMap ? (a = $902e455d852cdfb8$var$io(r, i, n.pitchedLabelPlaneMatrix, n.getElevation), a.isOccluded = !1) : (a = n.transform.projectTileCoordinates(r, i, n.unwrappedTileID, n.getElevation), a.point.x = (a.point.x * .5 + .5) * n.width, a.point.y = (-a.point.y * .5 + .5) * n.height), a;
}
function $902e455d852cdfb8$var$ho(e1, t, n, r) {
    if (n.pitchWithMap) {
        let i = [
            e1,
            t,
            0,
            1
        ];
        return (0, $caapT.Gr)(i, i, r), n.transform.projectTileCoordinates(i[0] / i[3], i[1] / i[3], n.unwrappedTileID, n.getElevation).point;
    } else return {
        x: e1 / n.width * 2 - 1,
        y: 1 - t / n.height * 2
    };
}
function $902e455d852cdfb8$var$go(e1, t, n) {
    return n.transform.projectTileCoordinates(e1, t, n.unwrappedTileID, n.getElevation);
}
function $902e455d852cdfb8$var$_o(e1, t, n) {
    return e1._unit()._perp()._mult(t * n);
}
function $902e455d852cdfb8$var$vo(t, n, r, i, a, o, s, c, l) {
    if (c.projectionCache.offsets[t]) return c.projectionCache.offsets[t];
    let u = r.add(n);
    if (t + l.direction < i || t + l.direction >= a) return c.projectionCache.offsets[t] = u, u;
    let d = $902e455d852cdfb8$var$po(t + l.direction, c, l), f = $902e455d852cdfb8$var$_o(d.sub(r), s, l.direction), p = r.add(f), m = d.add(f);
    return c.projectionCache.offsets[t] = (0, $caapT.$n)(o, u, p, m) || u, c.projectionCache.offsets[t];
}
function $902e455d852cdfb8$var$yo(e1, t, n, r, i, a, o, s, c) {
    let l = r ? e1 - t : e1 + t, u = l > 0 ? 1 : -1, d = 0;
    r && (u *= -1, d = Math.PI), u < 0 && (d += Math.PI);
    let f = u > 0 ? a + i : a + i + 1, p;
    s.projectionCache.cachedAnchorPoint ? p = s.projectionCache.cachedAnchorPoint : (p = $902e455d852cdfb8$var$mo(s.tileAnchorPoint.x, s.tileAnchorPoint.y, s).point, s.projectionCache.cachedAnchorPoint = p);
    let m = p, h = p, g, _, v = 0, y = 0, b = Math.abs(l), x = [], S;
    for(; v + y <= b;){
        if (f += u, f < a || f >= o) return null;
        v += y, h = m, _ = g;
        let e1 = {
            absOffsetX: b,
            direction: u,
            distanceFromAnchor: v,
            previousVertex: h
        };
        if (m = $902e455d852cdfb8$var$po(f, s, e1), n === 0) x.push(h), S = m.sub(h);
        else {
            let t, r = m.sub(h);
            t = r.mag() === 0 ? $902e455d852cdfb8$var$_o($902e455d852cdfb8$var$po(f + u, s, e1).sub(m), n, u) : $902e455d852cdfb8$var$_o(r, n, u), _ ||= h.add(t), g = $902e455d852cdfb8$var$vo(f, t, m, a, o, _, n, s, e1), x.push(_), S = g.sub(_);
        }
        y = S.mag();
    }
    let C = (b - v) / y, w = S._mult(C)._add(_ || h), T = d + Math.atan2(m.y - h.y, m.x - h.x);
    return x.push(w), {
        point: w,
        angle: c ? T : 0,
        path: x
    };
}
const $902e455d852cdfb8$var$bo = new Float32Array([
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0
]);
function $902e455d852cdfb8$var$xo(e1, t) {
    for(let n = 0; n < e1; n++){
        let e1 = t.length;
        t.resize(e1 + 4), t.float32.set($902e455d852cdfb8$var$bo, e1 * 3);
    }
}
function $902e455d852cdfb8$var$So(e1, t, n) {
    let r = t[0], i = t[1];
    return e1[0] = n[0] * r + n[4] * i + n[12], e1[1] = n[1] * r + n[5] * i + n[13], e1[3] = n[3] * r + n[7] * i + n[15], e1;
}
function $902e455d852cdfb8$var$Co(e1, t) {
    let n = $902e455d852cdfb8$var$eo;
    return $902e455d852cdfb8$var$$a(n, t.pitchedLabelPlaneMatrix), e1.map((e1)=>{
        let r = $902e455d852cdfb8$var$io(e1.x, e1.y, n, t.getElevation), i = t.transform.projectTileCoordinates(r.point.x, r.point.y, t.unwrappedTileID, t.getElevation);
        return i.point.x = (i.point.x * .5 + .5) * t.width, i.point.y = (-i.point.y * .5 + .5) * t.height, i;
    });
}
function $902e455d852cdfb8$var$wo(e1) {
    let t = 0, n = 0, r = 0, i = 0;
    for(let a = 0; a < e1.length; a++)e1[a].isOccluded ? (r = a + 1, i = 0) : (i++, i > n && (n = i, t = r));
    return e1.slice(t, t + n);
}
var $902e455d852cdfb8$var$To = class {
    constructor(e1, t = new $902e455d852cdfb8$var$Xa(e1.width + 200, e1.height + 200, 25), n = new $902e455d852cdfb8$var$Xa(e1.width + 200, e1.height + 200, 25)){
        this.transform = e1, this.grid = t, this.ignoredGrid = n, this.pitchFactor = Math.cos(e1.pitch * Math.PI / 180) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + 100, this.screenBottomBoundary = e1.height + 100, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.perspectiveRatioCutoff = .6;
    }
    placeCollisionBox(e1, t, n, r, i, a, o, s, c, l, u, d) {
        let f = e1.anchorPointX + s[0], p = e1.anchorPointY + s[1], m = this.projectAndGetPerspectiveRatio(f, p, i, l, d), h = n * m.perspectiveRatio, g;
        if (!a && !o) {
            let t = m.x + (u ? u.x * h : 0), n = m.y + (u ? u.y * h : 0);
            g = {
                allPointsOccluded: !1,
                box: [
                    t + e1.x1 * h,
                    n + e1.y1 * h,
                    t + e1.x2 * h,
                    n + e1.y2 * h
                ]
            };
        } else g = this._projectCollisionBox(e1, h, r, i, a, o, s, m, l, u, d);
        let [_, v, y, b] = g.box, x = a ? g.allPointsOccluded : m.isOccluded, S = x;
        return S ||= m.perspectiveRatio < this.perspectiveRatioCutoff, S ||= !this.isInsideGrid(_, v, y, b), S || t !== `always` && this.grid.hitTest(_, v, y, b, t, c) ? {
            box: [
                _,
                v,
                y,
                b
            ],
            placeable: !1,
            offscreen: !1,
            occluded: x
        } : {
            box: [
                _,
                v,
                y,
                b
            ],
            placeable: !0,
            offscreen: this.isOffscreen(_, v, y, b),
            occluded: x
        };
    }
    placeCollisionCircles(e1, t, n, r, i, a, o, s, c, l, u, d, f, p) {
        let m = [], h = new (0, $caapT.ji)(t.anchorX, t.anchorY), g = this.getPerspectiveRatio(h.x, h.y, a, p), _ = (c ? i * this.transform.getPitchedTextCorrection(t.anchorX, t.anchorY, a) / g : i * g) / 24, v = {
            projections: {},
            offsets: {},
            cachedAnchorPoint: void 0,
            anyProjectionOccluded: !1
        }, y = t.lineOffsetX * _, b = t.lineOffsetY * _, x = {
            getElevation: p,
            pitchedLabelPlaneMatrix: o,
            lineVertexArray: n,
            pitchWithMap: c,
            projectionCache: v,
            transform: this.transform,
            tileAnchorPoint: h,
            unwrappedTileID: a,
            width: this.transform.width,
            height: this.transform.height,
            translation: f
        }, S = $902e455d852cdfb8$var$co(_, r, y, b, !1, t, !1, x), C = !1, w = !1, T = !0;
        if (S) {
            let t = u * .5 * g + d, n = new (0, $caapT.ji)(-100, -100), r = new (0, $caapT.ji)(this.screenRightBoundary, this.screenBottomBoundary), i = new $902e455d852cdfb8$var$Ja, a = S.first, o = S.last, f = [];
            for(let e1 = a.path.length - 1; e1 >= 1; e1--)f.push(a.path[e1]);
            for(let e1 = 1; e1 < o.path.length; e1++)f.push(o.path[e1]);
            let p = t * 2.5;
            if (c) {
                let e1 = this.projectPathToScreenSpace(f, x);
                f = e1.some((e1)=>e1.signedDistanceFromCamera <= 0) ? [] : e1.map((e1)=>e1.point);
            }
            let h = [];
            if (f.length > 0) {
                let e1 = f[0].clone(), t = f[0].clone();
                for(let n = 1; n < f.length; n++)e1.x = Math.min(e1.x, f[n].x), e1.y = Math.min(e1.y, f[n].y), t.x = Math.max(t.x, f[n].x), t.y = Math.max(t.y, f[n].y);
                h = e1.x >= n.x && t.x <= r.x && e1.y >= n.y && t.y <= r.y ? [
                    f
                ] : t.x < n.x || e1.x > r.x || t.y < n.y || e1.y > r.y ? [] : (0, $caapT.a)([
                    f
                ], n.x, n.y, r.x, r.y);
            }
            for (let n of h){
                i.reset(n, t * .25);
                let r = 0;
                r = i.length <= .5 * t ? 1 : Math.ceil(i.paddedLength / p) + 1;
                for(let n = 0; n < r; n++){
                    let a = n / Math.max(r - 1, 1), o = i.lerp(a), c = o.x + 100, u = o.y + 100;
                    m.push(c, u, t, 0);
                    let d = c - t, f = u - t, p = c + t, h = u + t;
                    if (T &&= this.isOffscreen(d, f, p, h), w ||= this.isInsideGrid(d, f, p, h), e1 !== `always` && this.grid.hitTestCircle(c, u, t, e1, l) && (C = !0, !s)) return {
                        circles: [],
                        offscreen: !1,
                        collisionDetected: C
                    };
                }
            }
        }
        return {
            circles: !s && C || !w || g < this.perspectiveRatioCutoff ? [] : m,
            offscreen: T,
            collisionDetected: C
        };
    }
    projectPathToScreenSpace(e1, t) {
        return $902e455d852cdfb8$var$wo($902e455d852cdfb8$var$Co(e1, t));
    }
    queryRenderedSymbols(e1) {
        if (e1.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0) return {};
        let t = [], n = new (0, $caapT.h);
        for (let r of e1){
            let e1 = new (0, $caapT.ji)(r.x + 100, r.y + 100);
            n.extend(e1), t.push(e1);
        }
        let { minX: r, minY: i, maxX: a, maxY: o } = n, s = this.grid.query(r, i, a, o).concat(this.ignoredGrid.query(r, i, a, o)), c = {}, l = {};
        for (let e1 of s){
            let n = e1.key;
            c[n.bucketInstanceId] === void 0 && (c[n.bucketInstanceId] = {}), !(c[n.bucketInstanceId][n.featureIndex] || !(0, $caapT.yt)(t, [
                new (0, $caapT.ji)(e1.x1, e1.y1),
                new (0, $caapT.ji)(e1.x2, e1.y1),
                new (0, $caapT.ji)(e1.x2, e1.y2),
                new (0, $caapT.ji)(e1.x1, e1.y2)
            ])) && (c[n.bucketInstanceId][n.featureIndex] = !0, l[n.bucketInstanceId] === void 0 && (l[n.bucketInstanceId] = []), l[n.bucketInstanceId].push(n.featureIndex));
        }
        return l;
    }
    insertCollisionBox(e1, t, n, r, i, a) {
        let o = n ? this.ignoredGrid : this.grid, s = {
            bucketInstanceId: r,
            featureIndex: i,
            collisionGroupID: a,
            overlapMode: t
        };
        o.insert(s, e1[0], e1[1], e1[2], e1[3]);
    }
    insertCollisionCircles(e1, t, n, r, i, a) {
        let o = n ? this.ignoredGrid : this.grid, s = {
            bucketInstanceId: r,
            featureIndex: i,
            collisionGroupID: a,
            overlapMode: t
        };
        for(let t = 0; t < e1.length; t += 4)o.insertCircle(s, e1[t], e1[t + 1], e1[t + 2]);
    }
    projectAndGetPerspectiveRatio(e1, t, n, r, i) {
        if (i) {
            let n;
            r ? (n = [
                e1,
                t,
                r(e1, t),
                1
            ], (0, $caapT.Gr)(n, n, i)) : (n = [
                e1,
                t,
                0,
                1
            ], $902e455d852cdfb8$var$So(n, n, i));
            let a = n[3];
            return {
                x: (n[0] / a + 1) / 2 * this.transform.width + 100,
                y: (-n[1] / a + 1) / 2 * this.transform.height + 100,
                perspectiveRatio: .5 + .5 * (this.transform.cameraToCenterDistance / a),
                isOccluded: !1,
                signedDistanceFromCamera: a
            };
        } else {
            let i = this.transform.projectTileCoordinates(e1, t, n, r);
            return {
                x: (i.point.x + 1) / 2 * this.transform.width + 100,
                y: (-i.point.y + 1) / 2 * this.transform.height + 100,
                perspectiveRatio: .5 + .5 * (this.transform.cameraToCenterDistance / i.signedDistanceFromCamera),
                isOccluded: i.isOccluded,
                signedDistanceFromCamera: i.signedDistanceFromCamera
            };
        }
    }
    getPerspectiveRatio(e1, t, n, r) {
        let i = this.transform.projectTileCoordinates(e1, t, n, r);
        return .5 + .5 * (this.transform.cameraToCenterDistance / i.signedDistanceFromCamera);
    }
    isOffscreen(e1, t, n, r) {
        return n < 100 || e1 >= this.screenRightBoundary || r < 100 || t > this.screenBottomBoundary;
    }
    isInsideGrid(e1, t, n, r) {
        return n >= 0 && e1 < this.gridRightBoundary && r >= 0 && t < this.gridBottomBoundary;
    }
    getViewportMatrix() {
        let e1 = (0, $caapT.gi)([]);
        return (0, $caapT.Ti)(e1, e1, [
            -100,
            -100,
            0
        ]), e1;
    }
    _projectCollisionBox(e1, t, n, r, i, a, o, s, c, l, u) {
        let d = 1, f = 0, p = 0, m = 1, h = e1.anchorPointX + o[0], g = e1.anchorPointY + o[1];
        if (a && !i) {
            let e1 = this.projectAndGetPerspectiveRatio(h + 1, g, r, c, u), t = e1.x - s.x, n = e1.y - s.y, i = Math.atan(n / t) + (t < 0 ? Math.PI : 0), a = Math.sin(i), o = Math.cos(i);
            d = o, f = a, p = -a, m = o;
        } else if (!a && i) {
            let e1 = $902e455d852cdfb8$var$ro(this.transform);
            d = e1.vecEast[0], f = e1.vecEast[1], p = e1.vecSouth[0], m = e1.vecSouth[1];
        }
        let _ = s.x, v = s.y, y = t;
        if (i && (_ = h, v = g, y = 2 ** -(this.transform.zoom - n.overscaledZ), y *= this.transform.getPitchedTextCorrection(h, g, r), !l)) {
            let e1 = (0, $caapT.In)(.5 + .5 * (s.signedDistanceFromCamera / this.transform.cameraToCenterDistance), 0, 4);
            y *= e1;
        }
        l && (_ += d * l.x * y + p * l.y * y, v += f * l.x * y + m * l.y * y);
        let b = e1.x1 * y, x = e1.x2 * y, S = (b + x) / 2, C = e1.y1 * y, w = e1.y2 * y, T = (C + w) / 2, ee = [
            {
                offsetX: b,
                offsetY: C
            },
            {
                offsetX: S,
                offsetY: C
            },
            {
                offsetX: x,
                offsetY: C
            },
            {
                offsetX: x,
                offsetY: T
            },
            {
                offsetX: x,
                offsetY: w
            },
            {
                offsetX: S,
                offsetY: w
            },
            {
                offsetX: b,
                offsetY: w
            },
            {
                offsetX: b,
                offsetY: T
            }
        ], E = [];
        for (let { offsetX: e1, offsetY: t } of ee)E.push(new (0, $caapT.ji)(_ + d * e1 + p * t, v + f * e1 + m * t));
        let D = !1;
        if (i) {
            let e1 = E.map((e1)=>this.projectAndGetPerspectiveRatio(e1.x, e1.y, r, c, u));
            D = e1.some((e1)=>!e1.isOccluded), E = e1.map((e1)=>new (0, $caapT.ji)(e1.x, e1.y));
        } else D = !0;
        return {
            box: (0, $caapT.er)(E),
            allPointsOccluded: !D
        };
    }
}, $902e455d852cdfb8$var$Eo = class {
    constructor(e1, t, n, r){
        e1 ? this.opacity = Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t : -t))) : this.opacity = r && n ? 1 : 0, this.placed = n;
    }
    isHidden() {
        return this.opacity === 0 && !this.placed;
    }
}, $902e455d852cdfb8$var$Do = class {
    constructor(e1, t, n, r, i){
        this.text = new $902e455d852cdfb8$var$Eo(e1 ? e1.text : null, t, n, i), this.icon = new $902e455d852cdfb8$var$Eo(e1 ? e1.icon : null, t, r, i);
    }
    isHidden() {
        return this.text.isHidden() && this.icon.isHidden();
    }
}, $902e455d852cdfb8$var$Oo = class {
    constructor(e1, t, n){
        this.text = e1, this.icon = t, this.skipFade = n;
    }
}, $902e455d852cdfb8$var$ko = class {
    constructor(e1, t, n, r, i){
        this.bucketInstanceId = e1, this.featureIndex = t, this.sourceLayerIndex = n, this.bucketIndex = r, this.tileID = i;
    }
}, $902e455d852cdfb8$var$Ao = class {
    constructor(e1){
        this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
    }
    get(e1) {
        if (this.crossSourceCollisions) return {
            ID: 0,
            predicate: null
        };
        if (!this.collisionGroups[e1]) {
            let t = ++this.maxGroupID;
            this.collisionGroups[e1] = {
                ID: t,
                predicate: (e1)=>e1.collisionGroupID === t
            };
        }
        return this.collisionGroups[e1];
    }
};
function $902e455d852cdfb8$var$jo(e1, t, n, r, i) {
    let { horizontalAlign: a, verticalAlign: o } = (0, $caapT.U)(e1), s = -(a - .5) * t, c = -(o - .5) * n;
    return new (0, $caapT.ji)(s + r[0] * i, c + r[1] * i);
}
var $902e455d852cdfb8$var$Mo = class {
    constructor(e1, t, n, r, i){
        this.transform = e1.clone(), this.terrain = t, this.collisionIndex = new $902e455d852cdfb8$var$To(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = n, this.retainedQueryData = {}, this.collisionGroups = new $902e455d852cdfb8$var$Ao(r), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = i, i && (i.prevPlacement = void 0), this.placedOrientations = {};
    }
    _getTerrainElevationFunc(e1) {
        let t = this.terrain;
        return t ? (n, r)=>t.getElevation(e1, n, r) : null;
    }
    getBucketParts(e1, t, n, r) {
        let i = n.getBucket(t), a = n.latestFeatureIndex;
        if (!i || !a || t.id !== i.layerIds[0]) return;
        let o = n.collisionBoxArray, s = i.layers[0].layout, c = i.layers[0].paint, l = 2 ** (this.transform.zoom - n.tileID.overscaledZ), u = n.tileSize / (0, $caapT.Pr), d = n.tileID.toUnwrapped(), f = s.get(`text-rotation-alignment`) === `map`, p = (0, $caapT.Nr)(n, 1, this.transform.zoom), m = (0, $caapT.Or)(this.collisionIndex.transform, n, c.get(`text-translate`), c.get(`text-translate-anchor`)), h = (0, $caapT.Or)(this.collisionIndex.transform, n, c.get(`icon-translate`), c.get(`icon-translate-anchor`)), g = $902e455d852cdfb8$var$to(f, this.transform, p);
        this.retainedQueryData[i.bucketInstanceId] = new $902e455d852cdfb8$var$ko(i.bucketInstanceId, a, i.sourceLayerIndex, i.index, n.tileID);
        let _ = {
            bucket: i,
            layout: s,
            translationText: m,
            translationIcon: h,
            unwrappedTileID: d,
            pitchedLabelPlaneMatrix: g,
            scale: l,
            textPixelRatio: u,
            holdingForFade: n.holdingForSymbolFade(),
            collisionBoxArray: o,
            partiallyEvaluatedTextSize: (0, $caapT.V)(i.textSizeData, this.transform.zoom),
            collisionGroup: this.collisionGroups.get(i.sourceID)
        };
        if (r) for (let t of i.sortKeyRanges){
            let { sortKey: n, symbolInstanceStart: r, symbolInstanceEnd: i } = t;
            e1.push({
                sortKey: n,
                symbolInstanceStart: r,
                symbolInstanceEnd: i,
                parameters: _
            });
        }
        else e1.push({
            symbolInstanceStart: 0,
            symbolInstanceEnd: i.symbolInstances.length,
            parameters: _
        });
    }
    attemptAnchorPlacement(e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y) {
        let b = (0, $caapT.r)[e1.textAnchor], x = [
            e1.textOffset0,
            e1.textOffset1
        ], S = $902e455d852cdfb8$var$jo(b, n, r, x, i), C = this.collisionIndex.placeCollisionBox(t, d, s, c, l, o, a, h, u.predicate, v, S, y);
        if (!(_ && !this.collisionIndex.placeCollisionBox(_, d, s, c, l, o, a, g, u.predicate, v, S, y).placeable) && C.placeable) {
            let e1;
            if (this.prevPlacement?.variableOffsets[f.crossTileID] && this.prevPlacement?.placements[f.crossTileID]?.text && (e1 = this.prevPlacement.variableOffsets[f.crossTileID].anchor), f.crossTileID === 0) throw Error(`symbolInstance.crossTileID can't be 0`);
            return this.variableOffsets[f.crossTileID] = {
                textOffset: x,
                width: n,
                height: r,
                anchor: b,
                textBoxScale: i,
                prevAnchor: e1
            }, this.markUsedJustification(p, b, f, m), p.allowVerticalPlacement && (this.markUsedOrientation(p, m, f), this.placedOrientations[f.crossTileID] = m), {
                shift: S,
                placedGlyphBoxes: C
            };
        }
    }
    placeLayerBucketPart(e1, t, n) {
        let { bucket: r, layout: i, translationText: o, translationIcon: c, unwrappedTileID: l, pitchedLabelPlaneMatrix: u, textPixelRatio: d, holdingForFade: f, collisionBoxArray: p, partiallyEvaluatedTextSize: m, collisionGroup: h } = e1.parameters, g = i.get(`text-optional`), _ = i.get(`icon-optional`), v = (0, $caapT.z)(i, `text-overlap`, `text-allow-overlap`), y = v === `always`, b = (0, $caapT.z)(i, `icon-overlap`, `icon-allow-overlap`), x = b === `always`, S = i.get(`text-rotation-alignment`) === `map`, C = i.get(`text-pitch-alignment`) === `map`, w = i.get(`icon-text-fit`) !== `none`, T = i.get(`symbol-z-order`) === `viewport-y`, ee = y && (x || !r.hasIconData() || _), E = x && (y || !r.hasTextData() || g);
        !r.collisionArrays && p && r.deserializeCollisionBoxes(p);
        let D = this.retainedQueryData[r.bucketInstanceId].tileID, O = this._getTerrainElevationFunc(D), te = this.transform.getFastPathSimpleProjectionMatrix(D), k = (e1, p, x)=>{
            if (t[e1.crossTileID]) return;
            if (f) {
                this.placements[e1.crossTileID] = new $902e455d852cdfb8$var$Oo(!1, !1, !1);
                return;
            }
            let T = !1, k = !1, A = !0, ne = null, re = {
                box: null,
                placeable: !1,
                offscreen: null,
                occluded: !1
            }, ie = {
                box: null,
                placeable: !1,
                offscreen: null
            }, ae = null, oe = null, j = null, se = 0, ce = 0, le = 0;
            p.textFeatureIndex ? se = p.textFeatureIndex : e1.useRuntimeCollisionCircles && (se = e1.featureIndex), p.verticalTextFeatureIndex && (ce = p.verticalTextFeatureIndex);
            let ue = p.textBox;
            if (ue) {
                let t = (t)=>{
                    let n = 1;
                    if (r.allowVerticalPlacement && !t && this.prevPlacement) {
                        let t = this.prevPlacement.placedOrientations[e1.crossTileID];
                        t && (this.placedOrientations[e1.crossTileID] = t, n = t, this.markUsedOrientation(r, n, e1));
                    }
                    return n;
                }, i = (t, n)=>{
                    if (r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && p.verticalTextBox) {
                        for (let e1 of r.writingModes)if (e1 === 2 ? (re = n(), ie = re) : re = t(), re?.placeable) break;
                    } else re = t();
                }, a = e1.textAnchorOffsetStartIndex, s = e1.textAnchorOffsetEndIndex;
                if (s === a) {
                    let n = (t, n)=>{
                        let i = this.collisionIndex.placeCollisionBox(t, v, d, D, l, C, S, o, h.predicate, O, void 0, te);
                        return i?.placeable && (this.markUsedOrientation(r, n, e1), this.placedOrientations[e1.crossTileID] = n), i;
                    };
                    i(()=>n(ue, 1), ()=>{
                        let t = p.verticalTextBox;
                        return r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && t ? n(t, 2) : {
                            box: null,
                            offscreen: null
                        };
                    }), t(re?.placeable);
                } else {
                    let u = (0, $caapT.r)[this.prevPlacement?.variableOffsets[e1.crossTileID]?.anchor], f = (t, i, f)=>{
                        let p = t.x2 - t.x1, m = t.y2 - t.y1, g = e1.textBoxScale, _ = w && b === `never` ? i : null, y = null, x = v === `never` ? 1 : 2, ee = `never`;
                        u && x++;
                        for(let n = 0; n < x; n++){
                            for(let n = a; n < s; n++){
                                let i = r.textAnchorOffsets.get(n);
                                if (u && i.textAnchor !== u) continue;
                                let a = this.attemptAnchorPlacement(i, t, p, m, g, S, C, d, D, l, h, ee, e1, r, f, o, c, _, O);
                                if (a && (y = a.placedGlyphBoxes, y?.placeable)) return T = !0, ne = a.shift, y;
                            }
                            u ? u = null : ee = v;
                        }
                        return n && !y && (y = {
                            box: this.collisionIndex.placeCollisionBox(ue, `always`, d, D, l, C, S, o, h.predicate, O, void 0, te).box,
                            offscreen: !1,
                            placeable: !1,
                            occluded: !1
                        }), y;
                    };
                    i(()=>f(ue, p.iconBox, 1), ()=>{
                        let t = p.verticalTextBox, n = re?.placeable;
                        return r.allowVerticalPlacement && !n && e1.numVerticalGlyphVertices > 0 && t ? f(t, p.verticalIconBox, 2) : {
                            box: null,
                            occluded: !0,
                            offscreen: null
                        };
                    }), re && (T = re.placeable, A = re.offscreen);
                    let m = t(re?.placeable);
                    if (!T && this.prevPlacement) {
                        let t = this.prevPlacement.variableOffsets[e1.crossTileID];
                        t && (this.variableOffsets[e1.crossTileID] = t, this.markUsedJustification(r, t.anchor, e1, m));
                    }
                }
            }
            if (ae = re, T = ae?.placeable, A = ae?.offscreen, e1.useRuntimeCollisionCircles && e1.centerJustifiedTextSymbolIndex >= 0) {
                let t = r.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), c = (0, $caapT.B)(r.textSizeData, m, t), d = i.get(`text-padding`), f = e1.collisionCircleDiameter;
                oe = this.collisionIndex.placeCollisionCircles(v, t, r.lineVertexArray, r.glyphOffsetArray, c, l, u, n, C, h.predicate, f, d, o, O), oe.circles.length && oe.collisionDetected && !n && (0, $caapT.Ar)(`Collisions detected, but collision boxes are not shown`), T = y || oe.circles.length > 0 && !oe.collisionDetected, A &&= oe.offscreen;
            }
            if (p.iconFeatureIndex && (le = p.iconFeatureIndex), p.iconBox) {
                let e1 = (e1)=>this.collisionIndex.placeCollisionBox(e1, b, d, D, l, C, S, c, h.predicate, O, w && ne ? ne : void 0, te);
                ie && ie.placeable && p.verticalIconBox ? (j = e1(p.verticalIconBox), k = j.placeable) : (j = e1(p.iconBox), k = j.placeable), A &&= j.offscreen;
            }
            let de = g || e1.numHorizontalGlyphVertices === 0 && e1.numVerticalGlyphVertices === 0, fe = _ || e1.numIconVertices === 0;
            !de && !fe ? k = T = k && T : fe ? de || (k &&= T) : T = k && T;
            let pe = T && ae.placeable, me = k && j.placeable;
            if (pe && (ie && ie.placeable && ce ? this.collisionIndex.insertCollisionBox(ae.box, v, i.get(`text-ignore-placement`), r.bucketInstanceId, ce, h.ID) : this.collisionIndex.insertCollisionBox(ae.box, v, i.get(`text-ignore-placement`), r.bucketInstanceId, se, h.ID)), me && this.collisionIndex.insertCollisionBox(j.box, b, i.get(`icon-ignore-placement`), r.bucketInstanceId, le, h.ID), oe && T && this.collisionIndex.insertCollisionCircles(oe.circles, v, i.get(`text-ignore-placement`), r.bucketInstanceId, se, h.ID), n && this.storeCollisionData(r.bucketInstanceId, x, p, ae, j, oe), e1.crossTileID === 0) throw Error(`symbolInstance.crossTileID can't be 0`);
            if (r.bucketInstanceId === 0) throw Error(`bucket.bucketInstanceId can't be 0`);
            let he = (T || ee) && !ae?.occluded, ge = (k || E) && !j?.occluded;
            this.placements[e1.crossTileID] = new $902e455d852cdfb8$var$Oo(he, ge, A || r.justReloaded), t[e1.crossTileID] = !0;
        };
        if (T) {
            if (e1.symbolInstanceStart !== 0) throw Error(`bucket.bucketInstanceId should be 0`);
            let t = r.getSortedSymbolIndexes(-this.transform.bearingInRadians);
            for(let e1 = t.length - 1; e1 >= 0; --e1){
                let n = t[e1];
                k(r.symbolInstances.get(n), r.collisionArrays[n], n);
            }
        } else for(let t = e1.symbolInstanceStart; t < e1.symbolInstanceEnd; t++)k(r.symbolInstances.get(t), r.collisionArrays[t], t);
        r.justReloaded = !1;
    }
    storeCollisionData(e1, t, n, r, i, a) {
        if (n.textBox || n.iconBox) {
            let a;
            this.collisionBoxArrays.has(e1) ? a = this.collisionBoxArrays.get(e1) : (a = new Map, this.collisionBoxArrays.set(e1, a));
            let o;
            a.has(t) ? o = a.get(t) : (o = {
                text: null,
                icon: null
            }, a.set(t, o)), n.textBox && (o.text = r.box), n.iconBox && (o.icon = i.box);
        }
        if (a) {
            let t = this.collisionCircleArrays[e1];
            t === void 0 && (t = this.collisionCircleArrays[e1] = []);
            for(let e1 = 0; e1 < a.circles.length; e1 += 4)t.push(a.circles[e1 + 0] - 100), t.push(a.circles[e1 + 1] - 100), t.push(a.circles[e1 + 2]), t.push(+!!a.collisionDetected);
        }
    }
    markUsedJustification(e1, t, n, r) {
        let i = {
            left: n.leftJustifiedTextSymbolIndex,
            center: n.centerJustifiedTextSymbolIndex,
            right: n.rightJustifiedTextSymbolIndex
        }, a;
        a = r === 2 ? n.verticalPlacedTextSymbolIndex : i[(0, $caapT.t)(t)];
        let o = [
            n.leftJustifiedTextSymbolIndex,
            n.centerJustifiedTextSymbolIndex,
            n.rightJustifiedTextSymbolIndex,
            n.verticalPlacedTextSymbolIndex
        ];
        for (let t of o)t >= 0 && (a >= 0 && t !== a ? e1.text.placedSymbolArray.get(t).crossTileID = 0 : e1.text.placedSymbolArray.get(t).crossTileID = n.crossTileID);
    }
    markUsedOrientation(e1, t, n) {
        let r = t === 1 || t === 3 ? t : 0, i = t === 2 ? t : 0, a = [
            n.leftJustifiedTextSymbolIndex,
            n.centerJustifiedTextSymbolIndex,
            n.rightJustifiedTextSymbolIndex
        ];
        for (let t of a)e1.text.placedSymbolArray.get(t).placedOrientation = r;
        n.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(n.verticalPlacedTextSymbolIndex).placedOrientation = i);
    }
    commit(e1) {
        this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
        let t = this.prevPlacement, n = !1;
        this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
        let r = t ? t.symbolFadeChange(e1) : 1, i = t ? t.opacities : {}, a = t ? t.variableOffsets : {}, o = t ? t.placedOrientations : {};
        for(let e1 in this.placements){
            let t = this.placements[e1], a = i[e1];
            a ? (this.opacities[e1] = new $902e455d852cdfb8$var$Do(a, r, t.text, t.icon), n ||= t.text !== a.text.placed, n ||= t.icon !== a.icon.placed) : (this.opacities[e1] = new $902e455d852cdfb8$var$Do(null, r, t.text, t.icon, t.skipFade), n ||= t.text || t.icon);
        }
        for(let e1 in i){
            let t = i[e1];
            if (!this.opacities[e1]) {
                let i = new $902e455d852cdfb8$var$Do(t, r, !1, !1);
                i.isHidden() || (this.opacities[e1] = i, n ||= t.text.placed, n ||= t.icon.placed);
            }
        }
        for(let e1 in a)!this.variableOffsets[e1] && this.opacities[e1] && !this.opacities[e1].isHidden() && (this.variableOffsets[e1] = a[e1]);
        for(let e1 in o)!this.placedOrientations[e1] && this.opacities[e1] && !this.opacities[e1].isHidden() && (this.placedOrientations[e1] = o[e1]);
        if (t && t.lastPlacementChangeTime === void 0) throw Error(`Last placement time for previous placement is not defined`);
        n ? this.lastPlacementChangeTime = e1 : typeof this.lastPlacementChangeTime != `number` && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e1);
    }
    updateLayerOpacities(e1, t) {
        let n = {};
        for (let r of t){
            let t = r.getBucket(e1);
            t && r.latestFeatureIndex && e1.id === t.layerIds[0] && this.updateBucketOpacities(t, r.tileID, n, r.collisionBoxArray);
        }
    }
    updateBucketOpacities(e1, t, n, r) {
        e1.hasTextData() && (e1.text.opacityVertexArray.clear(), e1.text.hasVisibleVertices = !1), e1.hasIconData() && (e1.icon.opacityVertexArray.clear(), e1.icon.hasVisibleVertices = !1), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
        let i = e1.layers[0], a = i.layout, o = new $902e455d852cdfb8$var$Do(null, 0, !1, !1, !0), s = a.get(`text-allow-overlap`), c = a.get(`icon-allow-overlap`), l = i._unevaluatedLayout.hasValue(`text-variable-anchor`) || i._unevaluatedLayout.hasValue(`text-variable-anchor-offset`), u = a.get(`text-rotation-alignment`) === `map`, d = a.get(`text-pitch-alignment`) === `map`, f = a.get(`icon-text-fit`) !== `none`, p = new $902e455d852cdfb8$var$Do(null, 0, s && (c || !e1.hasIconData() || a.get(`icon-optional`)), c && (s || !e1.hasTextData() || a.get(`text-optional`)), !0);
        !e1.collisionArrays && r && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(r);
        let m = (e1, t, n)=>{
            for(let r = 0; r < t / 4; r++)e1.opacityVertexArray.emplaceBack(n);
            e1.hasVisibleVertices ||= n !== $902e455d852cdfb8$var$zo;
        }, h = this.collisionBoxArrays.get(e1.bucketInstanceId);
        for(let t = 0; t < e1.symbolInstances.length; t++){
            let r = e1.symbolInstances.get(t), { numHorizontalGlyphVertices: i, numVerticalGlyphVertices: a, crossTileID: s } = r, c = n[s], g = this.opacities[s];
            c ? g = o : g || (g = p, this.opacities[s] = g), n[s] = !0;
            let _ = i > 0 || a > 0, v = r.numIconVertices > 0, y = this.placedOrientations[r.crossTileID], b = y === 2, x = y === 1 || y === 3;
            if (_) {
                let t = $902e455d852cdfb8$var$Ro(g.text), n = b ? $902e455d852cdfb8$var$zo : t;
                m(e1.text, i, n);
                let o = x ? $902e455d852cdfb8$var$zo : t;
                m(e1.text, a, o);
                let s = g.text.isHidden(), c = [
                    r.rightJustifiedTextSymbolIndex,
                    r.centerJustifiedTextSymbolIndex,
                    r.leftJustifiedTextSymbolIndex
                ];
                for (let t of c)t >= 0 && (e1.text.placedSymbolArray.get(t).hidden = s || b ? 1 : 0);
                r.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(r.verticalPlacedTextSymbolIndex).hidden = s || x ? 1 : 0);
                let l = this.variableOffsets[r.crossTileID];
                l && this.markUsedJustification(e1, l.anchor, r, y);
                let u = this.placedOrientations[r.crossTileID];
                u && (this.markUsedJustification(e1, `left`, r, u), this.markUsedOrientation(e1, u, r));
            }
            if (v) {
                let t = $902e455d852cdfb8$var$Ro(g.icon), n = !(f && r.verticalPlacedIconSymbolIndex && b);
                if (r.placedIconSymbolIndex >= 0) {
                    let i = n ? t : $902e455d852cdfb8$var$zo;
                    m(e1.icon, r.numIconVertices, i), e1.icon.placedSymbolArray.get(r.placedIconSymbolIndex).hidden = g.icon.isHidden();
                }
                if (r.verticalPlacedIconSymbolIndex >= 0) {
                    let i = n ? $902e455d852cdfb8$var$zo : t;
                    m(e1.icon, r.numVerticalIconVertices, i), e1.icon.placedSymbolArray.get(r.verticalPlacedIconSymbolIndex).hidden = g.icon.isHidden();
                }
            }
            let S = h?.has(t) ? h.get(t) : {
                text: null,
                icon: null
            };
            if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                let n = e1.collisionArrays[t];
                if (n) {
                    let t = new (0, $caapT.ji)(0, 0);
                    if (n.textBox || n.verticalTextBox) {
                        let r = !0;
                        if (l) {
                            let e1 = this.variableOffsets[s];
                            e1 ? (t = $902e455d852cdfb8$var$jo(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textBoxScale), u && t._rotate(d ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : r = !1;
                        }
                        if (n.textBox || n.verticalTextBox) {
                            let i;
                            n.textBox && (i = b), n.verticalTextBox && (i = x), $902e455d852cdfb8$var$No(e1.textCollisionBox.collisionVertexArray, g.text.placed, !r || i, S.text, t.x, t.y);
                        }
                    }
                    if (n.iconBox || n.verticalIconBox) {
                        let r = !!(!x && n.verticalIconBox), i;
                        n.iconBox && (i = r), n.verticalIconBox && (i = !r), $902e455d852cdfb8$var$No(e1.iconCollisionBox.collisionVertexArray, g.icon.placed, i, S.icon, f ? t.x : 0, f ? t.y : 0);
                    }
                }
            }
        }
        if (e1.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.text.opacityVertexArray.length !== e1.text.layoutVertexArray.length / 4) throw Error(`bucket.text.opacityVertexArray.length (= ${e1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e1.text.layoutVertexArray.length}) / 4`);
        if (e1.icon.opacityVertexArray.length !== e1.icon.layoutVertexArray.length / 4) throw Error(`bucket.icon.opacityVertexArray.length (= ${e1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e1.icon.layoutVertexArray.length}) / 4`);
        e1.bucketInstanceId in this.collisionCircleArrays && (e1.collisionCircleArray = this.collisionCircleArrays[e1.bucketInstanceId], delete this.collisionCircleArrays[e1.bucketInstanceId]);
    }
    symbolFadeChange(e1) {
        return this.fadeDuration === 0 ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
    }
    zoomAdjustment(e1) {
        return Math.max(0, (this.transform.zoom - e1) / 1.5);
    }
    hasTransitions(e1) {
        return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
    }
    stillRecent(e1, t) {
        let n = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
        return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * n > e1;
    }
    setStale() {
        this.stale = !0;
    }
};
function $902e455d852cdfb8$var$No(e1, t, n, r, i, a) {
    (!r || r.length === 0) && (r = [
        0,
        0,
        0,
        0
    ]);
    let o = r[0] - 100, s = r[1] - 100, c = r[2] - 100, l = r[3] - 100;
    e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, o, s), e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, c, s), e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, c, l), e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, o, l);
}
const $902e455d852cdfb8$var$Po = 2 ** 25, $902e455d852cdfb8$var$Fo = 2 ** 24, $902e455d852cdfb8$var$Io = 2 ** 17, $902e455d852cdfb8$var$Lo = 2 ** 16;
function $902e455d852cdfb8$var$Ro(e1) {
    if (e1.opacity === 0 && !e1.placed) return 0;
    if (e1.opacity === 1 && e1.placed) return 4294967295;
    let t = +!!e1.placed, n = Math.floor(e1.opacity * 127);
    return n * $902e455d852cdfb8$var$Po + t * $902e455d852cdfb8$var$Fo + n * $902e455d852cdfb8$var$Io + t * $902e455d852cdfb8$var$Lo + n * 512 + t * 256 + n * 2 + t;
}
const $902e455d852cdfb8$var$zo = 0;
var $902e455d852cdfb8$var$Bo = class {
    constructor(e1){
        this._sortAcrossTiles = e1.layout.get(`symbol-z-order`) !== `viewport-y` && !e1.layout.get(`symbol-sort-key`).isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
    }
    continuePlacement(e1, t, n, r, i) {
        let a = this._bucketParts;
        for(; this._currentTileIndex < e1.length;){
            let n = e1[this._currentTileIndex];
            if (t.getBucketParts(a, r, n, this._sortAcrossTiles), this._currentTileIndex++, i()) return !0;
        }
        for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort((e1, t)=>e1.sortKey - t.sortKey)); this._currentPartIndex < a.length;){
            let e1 = a[this._currentPartIndex];
            if (t.placeLayerBucketPart(e1, this._seenCrossTileIDs, n), this._currentPartIndex++, i()) return !0;
        }
        return !1;
    }
}, $902e455d852cdfb8$var$Vo = class {
    constructor(e1, t, n, r, i, a, o, s){
        this.placement = new $902e455d852cdfb8$var$Mo(e1, t, a, o, s), this._currentPlacementIndex = n.length - 1, this._forceFullPlacement = r, this._showCollisionBoxes = i, this._done = !1;
    }
    isDone() {
        return this._done;
    }
    continuePlacement(e1, t, n) {
        let r = $902e455d852cdfb8$export$461939dd4422153(), i = ()=>!this._forceFullPlacement && $902e455d852cdfb8$export$461939dd4422153() - r > 2;
        for(; this._currentPlacementIndex >= 0;){
            let r = t[e1[this._currentPlacementIndex]], a = this.placement.collisionIndex.transform.zoom;
            if ((0, $caapT.I)(r) && r.layout && (!r.minzoom || r.minzoom <= a) && (!r.maxzoom || r.maxzoom > a)) {
                if (this._inProgressLayer ||= new $902e455d852cdfb8$var$Bo(r), this._inProgressLayer.continuePlacement(n[r.source], this.placement, this._showCollisionBoxes, r, i)) return;
                delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
        }
        this._done = !0;
    }
    commit(e1) {
        return this.placement.commit(e1), this.placement;
    }
};
const $902e455d852cdfb8$var$Ho = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
], $902e455d852cdfb8$var$q = new Uint32Array(96);
var $902e455d852cdfb8$var$Uo = class e1 {
    static from(t) {
        if (!t || t.byteLength === void 0 || t.buffer) throw Error(`Data must be an instance of ArrayBuffer or SharedArrayBuffer.`);
        let [n, r] = new Uint8Array(t, 0, 2);
        if (n !== 219) throw Error(`Data does not appear to be in a KDBush format.`);
        let i = r >> 4;
        if (i !== 1) throw Error(`Got v${i} data when expected v1.`);
        let a = $902e455d852cdfb8$var$Ho[r & 15];
        if (!a) throw Error(`Unrecognized array type.`);
        let [o] = new Uint16Array(t, 2, 1), [s] = new Uint32Array(t, 4, 1);
        return new e1(s, o, a, void 0, t);
    }
    constructor(e1, t = 64, n = Float64Array, r = ArrayBuffer, i){
        if (isNaN(e1) || e1 < 0) throw Error(`Unexpected numItems value: ${e1}.`);
        this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = n, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
        let a = $902e455d852cdfb8$var$Ho.indexOf(this.ArrayType), o = e1 * 2 * this.ArrayType.BYTES_PER_ELEMENT, s = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, c = (8 - s % 8) % 8;
        if (a < 0) throw Error(`Unexpected typed array class: ${n}.`);
        if (i) this.data = i, this.ids = new this.IndexArrayType(i, 8, e1), this.coords = new n(i, 8 + s + c, e1 * 2), this._pos = e1 * 2, this._finished = !0;
        else {
            let i = this.data = new r(8 + o + s + c);
            this.ids = new this.IndexArrayType(i, 8, e1), this.coords = new n(i, 8 + s + c, e1 * 2), this._pos = 0, this._finished = !1, new Uint8Array(i, 0, 2).set([
                219,
                16 + a
            ]), new Uint16Array(i, 2, 1)[0] = t, new Uint32Array(i, 4, 1)[0] = e1;
        }
    }
    add(e1, t) {
        let n = this._pos >> 1;
        return this.ids[n] = n, this.coords[this._pos++] = e1, this.coords[this._pos++] = t, n;
    }
    finish() {
        let e1 = this._pos >> 1;
        if (e1 !== this.numItems) throw Error(`Added ${e1} items when expected ${this.numItems}.`);
        return $902e455d852cdfb8$var$Wo(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
    }
    range(e1, t, n, r) {
        if (!this._finished) throw Error(`Data not yet indexed - call index.finish().`);
        let { ids: i, coords: a, nodeSize: o } = this;
        $902e455d852cdfb8$var$q[0] = 0, $902e455d852cdfb8$var$q[1] = i.length - 1, $902e455d852cdfb8$var$q[2] = 0;
        let s = 3, c = [];
        for(; s > 0;){
            let l = $902e455d852cdfb8$var$q[--s], u = $902e455d852cdfb8$var$q[--s], d = $902e455d852cdfb8$var$q[--s];
            if (u - d <= o) {
                for(let o = d; o <= u; o++){
                    let s = a[2 * o], l = a[2 * o + 1];
                    s >= e1 && s <= n && l >= t && l <= r && c.push(i[o]);
                }
                continue;
            }
            let f = d + u >> 1, p = a[2 * f], m = a[2 * f + 1];
            p >= e1 && p <= n && m >= t && m <= r && c.push(i[f]), (l === 0 ? e1 <= p : t <= m) && ($902e455d852cdfb8$var$q[s++] = d, $902e455d852cdfb8$var$q[s++] = f - 1, $902e455d852cdfb8$var$q[s++] = 1 - l), (l === 0 ? n >= p : r >= m) && ($902e455d852cdfb8$var$q[s++] = f + 1, $902e455d852cdfb8$var$q[s++] = u, $902e455d852cdfb8$var$q[s++] = 1 - l);
        }
        return c;
    }
    within(e1, t, n) {
        let r = [];
        return this.withinInto(e1, t, n, r), r;
    }
    withinInto(e1, t, n, r) {
        if (!this._finished) throw Error(`Data not yet indexed - call index.finish().`);
        let { ids: i, coords: a, nodeSize: o } = this;
        $902e455d852cdfb8$var$q[0] = 0, $902e455d852cdfb8$var$q[1] = i.length - 1, $902e455d852cdfb8$var$q[2] = 0;
        let s = 3, c = 0, l = n * n;
        for(; s > 0;){
            let u = $902e455d852cdfb8$var$q[--s], d = $902e455d852cdfb8$var$q[--s], f = $902e455d852cdfb8$var$q[--s];
            if (d - f <= o) {
                for(let n = f; n <= d; n++)$902e455d852cdfb8$var$Jo(a[2 * n], a[2 * n + 1], e1, t) <= l && (r[c++] = i[n]);
                continue;
            }
            let p = f + d >> 1, m = a[2 * p], h = a[2 * p + 1];
            $902e455d852cdfb8$var$Jo(m, h, e1, t) <= l && (r[c++] = i[p]), (u === 0 ? e1 - n <= m : t - n <= h) && ($902e455d852cdfb8$var$q[s++] = f, $902e455d852cdfb8$var$q[s++] = p - 1, $902e455d852cdfb8$var$q[s++] = 1 - u), (u === 0 ? e1 + n >= m : t + n >= h) && ($902e455d852cdfb8$var$q[s++] = p + 1, $902e455d852cdfb8$var$q[s++] = d, $902e455d852cdfb8$var$q[s++] = 1 - u);
        }
        return c;
    }
};
function $902e455d852cdfb8$var$Wo(e1, t, n, r, i, a) {
    if (i - r <= n) return;
    let o = r + i >> 1;
    $902e455d852cdfb8$var$Go(e1, t, o, r, i, a), $902e455d852cdfb8$var$Wo(e1, t, n, r, o - 1, 1 - a), $902e455d852cdfb8$var$Wo(e1, t, n, o + 1, i, 1 - a);
}
function $902e455d852cdfb8$var$Go(e1, t, n, r, i, a) {
    for(; i > r;){
        if (i - r > 600) {
            let o = i - r + 1, s = n - r + 1, c = Math.log(o), l = .5 * Math.exp(2 * c / 3), u = .5 * Math.sqrt(c * l * (o - l) / o) * (s - o / 2 < 0 ? -1 : 1);
            $902e455d852cdfb8$var$Go(e1, t, n, Math.max(r, Math.floor(n - s * l / o + u)), Math.min(i, Math.floor(n + (o - s) * l / o + u)), a);
        }
        let o = t[2 * n + a], s = r, c = i;
        for($902e455d852cdfb8$var$Ko(e1, t, r, n), t[2 * i + a] > o && $902e455d852cdfb8$var$Ko(e1, t, r, i); s < c;){
            for($902e455d852cdfb8$var$Ko(e1, t, s, c), s++, c--; t[2 * s + a] < o;)s++;
            for(; t[2 * c + a] > o;)c--;
        }
        t[2 * r + a] === o ? $902e455d852cdfb8$var$Ko(e1, t, r, c) : (c++, $902e455d852cdfb8$var$Ko(e1, t, c, i)), c <= n && (r = c + 1), n <= c && (i = c - 1);
    }
}
function $902e455d852cdfb8$var$Ko(e1, t, n, r) {
    $902e455d852cdfb8$var$qo(e1, n, r), $902e455d852cdfb8$var$qo(t, 2 * n, 2 * r), $902e455d852cdfb8$var$qo(t, 2 * n + 1, 2 * r + 1);
}
function $902e455d852cdfb8$var$qo(e1, t, n) {
    let r = e1[t];
    e1[t] = e1[n], e1[n] = r;
}
function $902e455d852cdfb8$var$Jo(e1, t, n, r) {
    let i = e1 - n, a = t - r;
    return i * i + a * a;
}
const $902e455d852cdfb8$var$Yo = 512 / (0, $caapT.Pr) / 2;
var $902e455d852cdfb8$var$Xo = class {
    constructor(e1, t, n){
        this.tileID = e1, this.bucketInstanceId = n, this._symbolsByKey = {};
        let r = new Map;
        for(let e1 = 0; e1 < t.length; e1++){
            let n = t.get(e1), i = n.key, a = r.get(i);
            a ? a.push(n) : r.set(i, [
                n
            ]);
        }
        for (let [e1, t] of r){
            let n = {
                positions: t.map((e1)=>({
                        x: Math.floor(e1.anchorX * $902e455d852cdfb8$var$Yo),
                        y: Math.floor(e1.anchorY * $902e455d852cdfb8$var$Yo)
                    })),
                crossTileIDs: t.map((e1)=>e1.crossTileID)
            };
            if (n.positions.length > 128) {
                let e1 = new $902e455d852cdfb8$var$Uo(n.positions.length, 16, Uint16Array);
                for (let { x: t, y: r } of n.positions)e1.add(t, r);
                e1.finish(), delete n.positions, n.index = e1;
            }
            this._symbolsByKey[e1] = n;
        }
    }
    getScaledCoordinates(e1, t) {
        let { x: n, y: r, z: i } = this.tileID.canonical, { x: a, y: o, z: s } = t.canonical, c = s - i, l = $902e455d852cdfb8$var$Yo / 2 ** c, u = (a * (0, $caapT.Pr) + e1.anchorX) * l, d = (o * (0, $caapT.Pr) + e1.anchorY) * l, f = n * (0, $caapT.Pr) * $902e455d852cdfb8$var$Yo, p = r * (0, $caapT.Pr) * $902e455d852cdfb8$var$Yo;
        return {
            x: Math.floor(u - f),
            y: Math.floor(d - p)
        };
    }
    findMatches(e1, t, n) {
        let r = this.tileID.canonical.z < t.canonical.z ? 1 : 2 ** (this.tileID.canonical.z - t.canonical.z);
        for(let i = 0; i < e1.length; i++){
            let a = e1.get(i);
            if (a.crossTileID) continue;
            let o = this._symbolsByKey[a.key];
            if (!o) continue;
            let s = this.getScaledCoordinates(a, t);
            if (o.index) {
                let e1 = o.index.range(s.x - r, s.y - r, s.x + r, s.y + r).sort();
                for (let t of e1){
                    let e1 = o.crossTileIDs[t];
                    if (!n[e1]) {
                        n[e1] = !0, a.crossTileID = e1;
                        break;
                    }
                }
            } else if (o.positions) for(let e1 = 0; e1 < o.positions.length; e1++){
                let t = o.positions[e1], i = o.crossTileIDs[e1];
                if (Math.abs(t.x - s.x) <= r && Math.abs(t.y - s.y) <= r && !n[i]) {
                    n[i] = !0, a.crossTileID = i;
                    break;
                }
            }
        }
    }
    getCrossTileIDsLists() {
        return Object.values(this._symbolsByKey).map(({ crossTileIDs: e1 })=>e1);
    }
}, $902e455d852cdfb8$var$Zo = class {
    constructor(){
        this.maxCrossTileID = 0;
    }
    generate() {
        return ++this.maxCrossTileID;
    }
}, $902e455d852cdfb8$var$Qo = class {
    constructor(){
        this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
    }
    handleWrapJump(e1) {
        let t = Math.round((e1 - this.lng) / 360);
        if (t !== 0) for(let e1 in this.indexes){
            let n = this.indexes[e1], r = {};
            for(let e1 in n){
                let i = n[e1];
                i.tileID = i.tileID.unwrapTo(i.tileID.wrap + t), r[i.tileID.key] = i;
            }
            this.indexes[e1] = r;
        }
        this.lng = e1;
    }
    addBucket(e1, t, n) {
        if (this.indexes[e1.overscaledZ]?.[e1.key]) {
            if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t.bucketInstanceId) return !1;
            this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
        }
        for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
            let n = t.symbolInstances.get(e1);
            n.crossTileID = 0;
        }
        this.usedCrossTileIDs[e1.overscaledZ] ||= {};
        let r = this.usedCrossTileIDs[e1.overscaledZ];
        for(let n in this.indexes){
            let i = this.indexes[n];
            if (Number(n) > e1.overscaledZ) for(let n in i){
                let a = i[n];
                a.tileID.isChildOf(e1) && a.findMatches(t.symbolInstances, e1, r);
            }
            else {
                let a = i[e1.scaledTo(Number(n)).key];
                a && a.findMatches(t.symbolInstances, e1, r);
            }
        }
        for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
            let i = t.symbolInstances.get(e1);
            i.crossTileID || (i.crossTileID = n.generate(), r[i.crossTileID] = !0);
        }
        return this.indexes[e1.overscaledZ] === void 0 && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new $902e455d852cdfb8$var$Xo(e1, t.symbolInstances, t.bucketInstanceId), !0;
    }
    removeBucketCrossTileIDs(e1, t) {
        for (let n of t.getCrossTileIDsLists())for (let t of n)delete this.usedCrossTileIDs[e1][t];
    }
    removeStaleBuckets(e1) {
        let t = !1;
        for(let n in this.indexes){
            let r = this.indexes[n];
            for(let i in r)e1[r[i].bucketInstanceId] || (this.removeBucketCrossTileIDs(n, r[i]), delete r[i], t = !0);
        }
        return t;
    }
}, $902e455d852cdfb8$var$$o = class {
    constructor(){
        this.layerIndexes = {}, this.crossTileIDs = new $902e455d852cdfb8$var$Zo, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
    }
    addLayer(e1, t, n) {
        let r = this.layerIndexes[e1.id];
        r === void 0 && (r = this.layerIndexes[e1.id] = new $902e455d852cdfb8$var$Qo);
        let i = !1, a = {};
        r.handleWrapJump(n);
        for (let n of t){
            let t = n.getBucket(e1);
            e1.id === t?.layerIds[0] && (t.bucketInstanceId ||= (this.maxBucketInstanceId += 1, this.maxBucketInstanceId), r.addBucket(n.tileID, t, this.crossTileIDs) && (i = !0), a[t.bucketInstanceId] = !0);
        }
        return r.removeStaleBuckets(a) && (i = !0), i;
    }
    pruneUnusedLayers(e1) {
        let t = {};
        for (let n of e1)t[n] = !0;
        for(let e1 in this.layerIndexes)t[e1] || delete this.layerIndexes[e1];
    }
}, $902e455d852cdfb8$var$es = `#ifdef GL_ES
precision mediump float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
out highp vec4 fragColor;`, $902e455d852cdfb8$var$ts = `#ifdef GL_ES
precision highp float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
vec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0
);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c
);}
#ifdef TERRAIN3D
uniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;
#endif
const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {
#ifdef TERRAIN3D
highp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));
#else
return 1.0;
#endif
}float calculate_visibility(vec4 pos) {
#ifdef TERRAIN3D
vec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;
#else
return 1.0;
#endif
}float ele(vec2 pos) {
#ifdef TERRAIN3D
vec4 rgb=(texture(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;
#else
return 0.0;
#endif
}float get_elevation(vec2 pos) {
#ifdef TERRAIN3D
#ifdef GLOBE
if ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}
#endif
vec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;
#else
return 0.0;
#endif
}const float PI=3.141592653589793;uniform mat4 u_projection_matrix;`, $902e455d852cdfb8$var$ns = `uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, $902e455d852cdfb8$var$rs = `layout(location=0) in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}`, $902e455d852cdfb8$var$is = `uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, $902e455d852cdfb8$var$as = `uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}`, $902e455d852cdfb8$var$os = `in vec3 v_data;flat in float v_visibility;
#pragma maplibre: define highp vec4 color
#pragma maplibre: define mediump float radius
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 stroke_color
#pragma maplibre: define mediump float stroke_width
#pragma maplibre: define lowp float stroke_opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump float radius
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 stroke_color
#pragma maplibre: initialize mediump float stroke_width
#pragma maplibre: initialize lowp float stroke_opacity
vec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, $902e455d852cdfb8$var$ss = `uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;uniform vec2 u_translate;layout(location=0) in vec2 a_pos;out vec3 v_data;flat out float v_visibility;
#pragma maplibre: define highp vec4 color
#pragma maplibre: define mediump float radius
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 stroke_color
#pragma maplibre: define mediump float stroke_width
#pragma maplibre: define lowp float stroke_opacity
void main(void) {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump float radius
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 stroke_color
#pragma maplibre: initialize mediump float stroke_width
#pragma maplibre: initialize lowp float stroke_opacity
vec2 pos_raw=a_pos+32768.0;vec2 extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);vec2 circle_center=floor(pos_raw/8.0)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {
#ifdef GLOBE
vec3 center_vector=projectToSphere(circle_center);
#endif
float angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {
#ifdef GLOBE
vec4 projected_center=interpolateProjection(circle_center,center_vector,ele);
#else
vec4 projected_center=projectTileWithElevation(circle_center,ele);
#endif
corner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}
#ifdef GLOBE
vec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);
#else
gl_Position=projectTileWithElevation(corner_position,ele);
#endif
} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}`, $902e455d852cdfb8$var$cs = `void main() {fragColor=vec4(1.0);}`;
const $902e455d852cdfb8$var$ls = {
    prelude: $902e455d852cdfb8$var$J($902e455d852cdfb8$var$es, $902e455d852cdfb8$var$ts),
    projectionMercator: $902e455d852cdfb8$var$J(``, `float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}`),
    projectionGlobe: $902e455d852cdfb8$var$J(``, `#define GLOBE_RADIUS 6371008.8
uniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos
);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float spherical_y=2.0*atan(exp(PI-(mercator_pos_y*PI*2.0)))-PI*0.5;return cos(spherical_y);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY); 
if (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;vec2 spherical;spherical.x=mercator_pos.x*PI*2.0+PI;spherical.y=2.0*atan(exp(PI-(mercator_pos.y*PI*2.0)))-PI*0.5;float len=cos(spherical.y);vec3 pos=vec3(sin(spherical.x)*len,sin(spherical.y),cos(spherical.x)*len
);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}`),
    background: $902e455d852cdfb8$var$J($902e455d852cdfb8$var$ns, $902e455d852cdfb8$var$rs),
    backgroundPattern: $902e455d852cdfb8$var$J($902e455d852cdfb8$var$is, $902e455d852cdfb8$var$as),
    circle: $902e455d852cdfb8$var$J($902e455d852cdfb8$var$os, $902e455d852cdfb8$var$ss),
    clippingMask: $902e455d852cdfb8$var$J($902e455d852cdfb8$var$cs, `layout(location=0) in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}`),
    heatmap: $902e455d852cdfb8$var$J(`uniform highp float u_intensity;in vec2 v_extrude;
#pragma maplibre: define highp float weight
#define GAUSS_COEF 0.3989422804014327
void main() {
#pragma maplibre: initialize highp float weight
float d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;layout(location=0) in vec2 a_pos;out vec2 v_extrude;
#pragma maplibre: define highp float weight
#pragma maplibre: define mediump float radius
const highp float ZERO=1.0/255.0/16.0;
#define GAUSS_COEF 0.3989422804014327
void main(void) {
#pragma maplibre: initialize highp float weight
#pragma maplibre: initialize mediump float radius
vec2 pos_raw=a_pos+32768.0;vec2 unscaled_extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=floor(pos_raw/8.0);
#ifdef GLOBE
vec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);
#else
gl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));
#endif
}`),
    heatmapTexture: $902e455d852cdfb8$var$J(`uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(0.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_world;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}`),
    collisionBox: $902e455d852cdfb8$var$J(`flat in float v_placed;flat in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}`, `layout(location=0) in vec2 a_anchor_pos;layout(location=1) in vec2 a_placed;layout(location=2) in vec2 a_box_real;uniform vec2 u_pixel_extrude_scale;flat out float v_placed;flat out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}`),
    collisionCircle: $902e455d852cdfb8$var$J(`flat in float v_radius;in vec2 v_extrude;flat in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}`, `layout(location=0) in vec2 a_pos;layout(location=1) in float a_radius;layout(location=2) in vec2 a_flags;uniform vec2 u_viewport_size;flat out float v_radius;out vec2 v_extrude;flat out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}`),
    colorRelief: $902e455d852cdfb8$var$J(`#ifdef GL_ES
precision highp float;
#endif
uniform sampler2D u_image;uniform vec4 u_unpack;uniform sampler2D u_elevation_stops;uniform sampler2D u_color_stops;uniform int u_color_ramp_size;uniform float u_opacity;in vec2 v_pos;float getElevation(vec2 coord) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}float getElevationStop(int stop) {float x=(float(stop)+0.5)/float(u_color_ramp_size);vec4 data=texture(u_elevation_stops,vec2(x,0))*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {float el=getElevation(v_pos);int r=(u_color_ramp_size-1);int l=0;float el_l=getElevationStop(l);float el_r=getElevationStop(r);while(r-l > 1){int m=(r+l)/2;float el_m=getElevationStop(m);if(el < el_m){r=m;el_r=el_m;}else
{l=m;el_l=el_m;}}float x=(float(l)+(el-el_l)/(el_r-el_l)+0.5)/float(u_color_ramp_size);fragColor=u_opacity*texture(u_color_stops,vec2(x,0));
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_dimension;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_pos/8192.0)*scale+epsilon;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}`),
    debug: $902e455d852cdfb8$var$J(`uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}`, `layout(location=0) in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}`),
    depth: $902e455d852cdfb8$var$J($902e455d852cdfb8$var$cs, `layout(location=0) in vec2 a_pos;void main() {
#ifdef GLOBE
gl_Position=projectTileFor3D(a_pos,0.0);
#else
gl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);
#endif
}`),
    fill: $902e455d852cdfb8$var$J(`#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float opacity
fragColor=color*opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float opacity
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}gl_Position=projectTile(a_pos+u_fill_translate,a_pos);}`),
    fillOutline: $902e455d852cdfb8$var$J(`in vec2 v_pos;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define highp vec4 outline_color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 outline_color
#pragma maplibre: initialize lowp float opacity
float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_world;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define highp vec4 outline_color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 outline_color
#pragma maplibre: initialize lowp float opacity
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
}`),
    fillOutlinePattern: $902e455d852cdfb8$var$J(`uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=mix(color1,color2,u_fade)*alpha*opacity;
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
}`),
    fillPattern: $902e455d852cdfb8$var$J(`#ifdef GL_ES
precision highp float;
#endif
uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_fade)*opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}`),
    fillExtrusion: $902e455d852cdfb8$var$J(`in vec4 v_color;void main() {fragColor=v_color;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;layout(location=1) in vec4 a_normal_ed;
#ifdef TERRAIN3D
layout(location=2) in vec2 a_centroid;
#endif
out vec4 v_color;
#pragma maplibre: define highp float base
#pragma maplibre: define highp float height
#pragma maplibre: define highp vec4 color
void main() {
#pragma maplibre: initialize highp float base
#pragma maplibre: initialize highp float height
#pragma maplibre: initialize highp vec4 color
vec3 normal=a_normal_ed.xyz;
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;
#ifdef GLOBE
vec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);
#else
gl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);
#endif
float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);
#ifdef GLOBE
mat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);
#endif
directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}`),
    fillExtrusionPattern: $902e455d852cdfb8$var$J(`uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;
#pragma maplibre: define lowp float base
#pragma maplibre: define lowp float height
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float base
#pragma maplibre: initialize lowp float height
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;layout(location=0) in vec2 a_pos;layout(location=1) in vec4 a_normal_ed;
#ifdef TERRAIN3D
layout(location=2) in vec2 a_centroid;
#endif
#ifdef GLOBE
out vec3 v_sphere_pos;
#endif
out vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;
#pragma maplibre: define lowp float base
#pragma maplibre: define lowp float height
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float base
#pragma maplibre: initialize lowp float height
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;
#ifdef GLOBE
vec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);
#else
gl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);
#endif
vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0
? a_pos
: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}`),
    hillshadePrepare: $902e455d852cdfb8$var$J(`#ifdef GL_ES
precision highp float;
#endif
uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {vec2 epsilon=1.0/u_dimension;float tileSize=u_dimension.x-2.0;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))*tileSize/pow(2.0,exaggeration+(28.2562-u_zoom));fragColor=clamp(vec4(deriv.x/8.0+0.5,deriv.y/8.0+0.5,1.0,1.0),0.0,1.0);
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_dimension;layout(location=0) in vec2 a_pos;layout(location=1) in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}`),
    hillshade: $902e455d852cdfb8$var$J(`uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform float u_exaggeration;uniform vec4 u_accent;uniform int u_method;uniform float u_altitudes[NUM_ILLUMINATION_SOURCES];uniform float u_azimuths[NUM_ILLUMINATION_SOURCES];uniform vec4 u_shadows[NUM_ILLUMINATION_SOURCES];uniform vec4 u_highlights[NUM_ILLUMINATION_SOURCES];
#define PI 3.141592653589793
#define STANDARD 0
#define COMBINED 1
#define IGOR 2
#define MULTIDIRECTIONAL 3
#define BASIC 4
float get_aspect(vec2 deriv){return deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);}void igor_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float aspect=get_aspect(deriv);float azimuth=u_azimuths[0]+PI;float slope_stength=atan(length(deriv))*2.0/PI;float aspect_strength=1.0-abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);float shadow_strength=slope_stength*aspect_strength;float highlight_strength=slope_stength*(1.0-aspect_strength);fragColor=u_shadows[0]*shadow_strength+u_highlights[0]*highlight_strength;}void standard_hillshade(vec2 deriv){float azimuth=u_azimuths[0]+PI;float slope=atan(0.625*length(deriv));float aspect=get_aspect(deriv);float intensity=u_exaggeration;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadows[0],u_highlights[0],shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;}void basic_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor=u_highlights[0]*(2.0*shade-1.0);}else
{fragColor=u_shadows[0]*(1.0-2.0*shade);}}void multidirectional_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;fragColor=vec4(0,0,0,0);for(int i=0; i < NUM_ILLUMINATION_SOURCES; i++){float cos_alt=cos(u_altitudes[i]);float sin_alt=sin(u_altitudes[i]);float cos_az=-cos(u_azimuths[i]);float sin_az=-sin(u_azimuths[i]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor+=u_highlights[i]*(2.0*shade-1.0)/float(NUM_ILLUMINATION_SOURCES);}else
{fragColor+=u_shadows[i]*(1.0-2.0*shade)/float(NUM_ILLUMINATION_SOURCES);}}}void combined_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=acos((sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv)));cang=clamp(cang,0.0,PI/2.0);float shade=cang*atan(length(deriv))*4.0/PI/PI;float highlight=(PI/2.0-cang)*atan(length(deriv))*4.0/PI/PI;fragColor=u_shadows[0]*shade+u_highlights[0]*highlight;}void main() {vec4 pixel=texture(u_image,v_pos);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));vec2 deriv=((pixel.rg*8.0)-4.0)/scaleFactor;if (u_method==BASIC) {basic_hillshade(deriv);} else if (u_method==COMBINED) {combined_hillshade(deriv);} else if (u_method==IGOR) {igor_hillshade(deriv);} else if (u_method==MULTIDIRECTIONAL) {multidirectional_hillshade(deriv);} else if (u_method==STANDARD) {standard_hillshade(deriv);} else {standard_hillshade(deriv);}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}`),
    line: $902e455d852cdfb8$var$J(`uniform lowp float u_device_pixel_ratio;flat in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
layout(location=0) in vec2 a_pos_normal;layout(location=1) in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`),
    lineGradient: $902e455d852cdfb8$var$J(`uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;flat in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
layout(location=0) in vec2 a_pos_normal;layout(location=1) in vec4 a_data;layout(location=2) in float a_uv_x;layout(location=3) in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`),
    linePattern: $902e455d852cdfb8$var$J(`#ifdef GL_ES
precision highp float;
#endif
uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;flat in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;flat in float v_width;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
layout(location=0) in vec2 a_pos_normal;layout(location=1) in vec4 a_data;uniform vec2 u_translation;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;flat out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;flat out float v_width;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}`),
    lineSDF: $902e455d852cdfb8$var$J(`uniform lowp float u_device_pixel_ratio;uniform lowp float u_lineatlas_width;uniform sampler2D u_image;uniform float u_mix;in vec2 v_normal;flat in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0/u_device_pixel_ratio)/min(dasharray_from.w,dasharray_to.w);alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
layout(location=0) in vec2 a_pos_normal;layout(location=1) in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;flat out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
float u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}`),
    lineGradientSDF: $902e455d852cdfb8$var$J(`uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform sampler2D u_image_dash;uniform float u_mix;uniform lowp float u_lineatlas_width;in vec2 v_normal;flat in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;in highp vec2 v_uv;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);float sdfdist_a=texture(u_image_dash,v_tex_a).a;float sdfdist_b=texture(u_image_dash,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0)/min(dasharray_from.w,dasharray_to.w);float dash_alpha=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*dash_alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
layout(location=0) in vec2 a_pos_normal;layout(location=1) in vec4 a_data;layout(location=2) in float a_uv_x;layout(location=3) in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;out vec2 v_tex_a;out vec2 v_tex_b;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;float texel_height=1.0/u_image_height;float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
float u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}`),
    layerOpacity: $902e455d852cdfb8$var$J(`uniform sampler2D u_image;uniform float u_opacity;in vec2 v_pos;void main() {fragColor=texture(u_image,v_pos)*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(0.0);
#endif
}`, `layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos.x*2.0-1.0,1.0-a_pos.y*2.0,0.0,1.0);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}`),
    raster: $902e455d852cdfb8$var$J(`uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec2 v_pos0;in vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0);vec4 color1=texture(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;layout(location=0) in vec2 a_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 position=mix(mix(u_coords_top.xy,u_coords_top.zw,fractionalPos.x),mix(u_coords_bottom.xy,u_coords_bottom.zw,fractionalPos.x),fractionalPos.y);gl_Position=projectTile(position,position);v_pos0=((fractionalPos-0.5)/u_buffer_scale)+0.5;
#ifdef GLOBE
if (a_pos.y <-32767.5) {v_pos0.y=0.0;}if (a_pos.y > 32766.5) {v_pos0.y=1.0;}
#endif
v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}`),
    symbolIcon: $902e455d852cdfb8$var$J(`uniform sampler2D u_texture;in vec2 v_tex;flat in float v_total_opacity;void main() {fragColor=texture(u_texture,v_tex)*v_total_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `layout(location=0) in vec4 a_pos_offset;layout(location=1) in vec4 a_data;layout(location=2) in vec4 a_pixeloffset;layout(location=3) in vec3 a_projected_pos;layout(location=4) in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;out vec2 v_tex;flat out float v_total_opacity;
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize lowp float opacity
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_total_opacity=opacity*max(0.0,min(visibility,fade_opacity[0]+fade_change));if (v_total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;
#ifdef GLOBE
if(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}
#endif
vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;}`),
    symbolSDF: $902e455d852cdfb8$var$J(`#define SDF_PX 8.0
uniform bool u_is_halo;uniform bool u_is_plain;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
float EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float total_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out_text,color_alpha_out_halo;if (u_is_plain){highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);color_alpha_out_text=total_opacity*alpha*fill_color;}if (u_is_halo) {float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);float inner_edge_halo=inner_edge+gamma_halo*gamma_scale;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(inner_edge_halo-gamma_scaled_halo,inner_edge_halo+gamma_scaled_halo,dist);highp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha_halo= min(smoothstep(halo_edge-gamma_scaled_halo,halo_edge+gamma_scaled_halo,dist),1.0-alpha_halo);color_alpha_out_halo=total_opacity*alpha_halo*halo_color;}if (u_is_plain && u_is_halo) {fragColor=color_alpha_out_text+(1.-color_alpha_out_text.a)*color_alpha_out_halo;} else if (u_is_halo){fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out_text;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `layout(location=0) in vec4 a_pos_offset;layout(location=1) in vec4 a_data;layout(location=2) in vec4 a_pixeloffset;layout(location=3) in vec3 a_projected_pos;layout(location=4) in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;out vec2 v_data0;out vec3 v_data1;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy/16.0;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;
#ifdef GLOBE
if(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}
#endif
vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,total_opacity);}`),
    symbolTextAndIcon: $902e455d852cdfb8$var$J(`#define SDF_PX 8.0
#define SDF 1.0
#define ICON 0.0
uniform bool u_is_halo;uniform bool u_is_text;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;in vec4 v_data0;in vec3 v_data1;flat in float v_is_sdf;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
float total_opacity=v_data1[2];if (v_is_sdf==ICON) {vec2 tex_icon=v_data0.zw;fragColor=texture(u_texture_icon,tex_icon)*total_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
return;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out,color_alpha_out_halo;if (u_is_text) {highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);color_alpha_out=fill_color*(alpha*total_opacity);}if (u_is_halo) {highp float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);lowp float buff_halo=(6.0-halo_width/fontScale)/SDF_PX;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(buff_halo-gamma_scaled_halo,buff_halo+gamma_scaled_halo,dist);color_alpha_out_halo=halo_color*(alpha_halo*total_opacity);}if (u_is_text && u_is_halo) {fragColor=color_alpha_out+(1.-color_alpha_out.a)*color_alpha_out_halo;} else if (u_is_halo) {fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `layout(location=0) in vec4 a_pos_offset;layout(location=1) in vec4 a_data;layout(location=2) in vec3 a_projected_pos;layout(location=3) in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;out vec4 v_data0;out vec3 v_data1;flat out float v_is_sdf;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;
#ifdef GLOBE
if(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}
#endif
vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec3(gamma_scale,size,total_opacity);v_is_sdf=is_sdf;}`),
    terrain: $902e455d852cdfb8$var$J(`uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && u_fog_ground_blend_opacity > 0.0 && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}`, `layout(location=0) in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}`),
    terrainDepth: $902e455d852cdfb8$var$J(`in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}`, `layout(location=0) in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}`),
    terrainCoords: $902e455d852cdfb8$var$J(`precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;in vec2 v_texture_pos;void main() {vec4 rgba=texture(u_texture,v_texture_pos);fragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}`, `layout(location=0) in vec3 a_pos3d;uniform float u_ele_delta;out vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);}`),
    projectionErrorMeasurement: $902e455d852cdfb8$var$J(`flat in vec4 v_output_error_encoded;void main() {fragColor=v_output_error_encoded;}`, `layout(location=0) in vec2 a_pos;uniform highp float u_input;uniform highp float u_output_expected;flat out vec4 v_output_error_encoded;void main() {float real_output=2.0*atan(exp(PI-(u_input*PI*2.0)))-PI*0.5;float error=real_output-u_output_expected;float abs_error=abs(error)*128.0;v_output_error_encoded.x=min(floor(abs_error*256.0),255.0)/255.0;abs_error-=v_output_error_encoded.x;v_output_error_encoded.y=min(floor(abs_error*65536.0),255.0)/255.0;abs_error-=v_output_error_encoded.x/255.0;v_output_error_encoded.z=min(floor(abs_error*16777216.0),255.0)/255.0;v_output_error_encoded.w=error >=0.0 ? 1.0 : 0.0;gl_Position=vec4(a_pos,0.0,1.0);}`),
    atmosphere: $902e455d852cdfb8$var$J(`#ifdef GL_ES
precision highp float;
#endif
in vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758
);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}`, `layout(location=0) in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}`),
    sky: $902e455d852cdfb8$var$J(`uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}`, `layout(location=0) in vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}`)
};
function $902e455d852cdfb8$var$J(e1, t) {
    let n = /#pragma maplibre: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, r = t.match(/in ([\w]+) ([\w]+)/g), i = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), a = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = a ? a.concat(i) : i, s = r ? r.length : 0, c = {};
    return e1 = e1.replace(n, (e1, t, n, r, i)=>(c[i] = !0, t === `define` ? `
#ifndef HAS_UNIFORM_u_${i}
in ${n} ${r} ${i};
#else
uniform ${n} ${r} u_${i};
#endif
` : `
#ifdef HAS_UNIFORM_u_${i}
    ${n} ${r} ${i} = u_${i};
#endif
`)), t = t.replace(n, (e1, t, n, r, i)=>{
        let a = r === `float` ? `vec2` : `vec4`, o = i.match(/color/) ? `color` : a;
        return c[i] ? t === `define` ? `
#ifndef HAS_UNIFORM_u_${i}
uniform lowp float u_${i}_t;
layout(location = ${s++}) in ${n} ${a} a_${i};
out ${n} ${r} ${i};
#else
uniform ${n} ${r} u_${i};
#endif
` : o === `vec4` ? `
#ifndef HAS_UNIFORM_u_${i}
    ${i} = a_${i};
#else
    ${n} ${r} ${i} = u_${i};
#endif
` : `
#ifndef HAS_UNIFORM_u_${i}
    ${i} = unpack_mix_${o}(a_${i}, u_${i}_t);
#else
    ${n} ${r} ${i} = u_${i};
#endif
` : t === `define` ? `
#ifndef HAS_UNIFORM_u_${i}
uniform lowp float u_${i}_t;
layout(location = ${s++}) in ${n} ${a} a_${i};
#else
uniform ${n} ${r} u_${i};
#endif
` : o === `vec4` ? `
#ifndef HAS_UNIFORM_u_${i}
    ${n} ${r} ${i} = a_${i};
#else
    ${n} ${r} ${i} = u_${i};
#endif
` : `
#ifndef HAS_UNIFORM_u_${i}
    ${n} ${r} ${i} = unpack_mix_${o}(a_${i}, u_${i}_t);
#else
    ${n} ${r} ${i} = u_${i};
#endif
`;
    }), {
        fragmentSource: e1,
        vertexSource: t,
        staticAttributes: r,
        staticUniforms: o
    };
}
var $902e455d852cdfb8$var$us = class {
    constructor(e1, t, n){
        this.vertexBuffer = e1, this.indexBuffer = t, this.segments = n;
    }
    destroy() {
        this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
    }
};
const $902e455d852cdfb8$var$ds = (0, $caapT.zt)([
    {
        name: `a_pos`,
        type: `Int16`,
        components: 2
    }
]), $902e455d852cdfb8$var$fs = `#define PROJECTION_MERCATOR`, $902e455d852cdfb8$var$ps = `mercator`;
var $902e455d852cdfb8$var$ms = class {
    constructor(){
        this._cachedMesh = null;
    }
    get name() {
        return `mercator`;
    }
    get useSubdivision() {
        return !1;
    }
    get shaderVariantName() {
        return $902e455d852cdfb8$var$ps;
    }
    get shaderDefine() {
        return $902e455d852cdfb8$var$fs;
    }
    get shaderPreludeCode() {
        return $902e455d852cdfb8$var$ls.projectionMercator;
    }
    get vertexShaderPreludeCode() {
        return $902e455d852cdfb8$var$ls.projectionMercator.vertexSource;
    }
    get subdivisionGranularity() {
        return (0, $caapT.ct).noSubdivision;
    }
    get useGlobeControls() {
        return !1;
    }
    get transitionState() {
        return 0;
    }
    get latitudeErrorCorrectionRadians() {
        return 0;
    }
    destroy() {}
    updateGPUdependent(e1) {}
    getMeshFromTileID(e1, t, n, r, i) {
        if (this._cachedMesh) return this._cachedMesh;
        let a = new (0, $caapT.Ft);
        a.emplaceBack(0, 0), a.emplaceBack((0, $caapT.Pr), 0), a.emplaceBack(0, (0, $caapT.Pr)), a.emplaceBack((0, $caapT.Pr), (0, $caapT.Pr));
        let s = e1.createVertexBuffer(a, $902e455d852cdfb8$var$ds.members), c = (0, $caapT.At).simpleSegment(0, 0, 4, 2), l = new (0, $caapT.Rt);
        l.emplaceBack(1, 0, 2), l.emplaceBack(1, 2, 3);
        let u = e1.createIndexBuffer(l);
        return this._cachedMesh = new $902e455d852cdfb8$var$us(s, u, c), this._cachedMesh;
    }
    recalculate() {}
    hasTransition() {
        return !1;
    }
    setErrorQueryLatitudeDegrees(e1) {}
}, $902e455d852cdfb8$export$45cce0bd6c1f342a = class e1 {
    constructor(e1 = 0, t = 0, n = 0, r = 0){
        if (isNaN(e1) || e1 < 0 || isNaN(t) || t < 0 || isNaN(n) || n < 0 || isNaN(r) || r < 0) throw Error(`Invalid value for edge-insets, top, bottom, left and right must all be numbers`);
        this.top = e1, this.bottom = t, this.left = n, this.right = r;
    }
    interpolate(e1, t, n) {
        return t.top != null && e1.top != null && (this.top = (0, $caapT.un).number(e1.top, t.top, n)), t.bottom != null && e1.bottom != null && (this.bottom = (0, $caapT.un).number(e1.bottom, t.bottom, n)), t.left != null && e1.left != null && (this.left = (0, $caapT.un).number(e1.left, t.left, n)), t.right != null && e1.right != null && (this.right = (0, $caapT.un).number(e1.right, t.right, n)), this;
    }
    getCenter(e1, t) {
        return new (0, $caapT.ji)((0, $caapT.In)((this.left + e1 - this.right) / 2, 0, e1), (0, $caapT.In)((this.top + t - this.bottom) / 2, 0, t));
    }
    equals(e1) {
        return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
    }
    clone() {
        return new e1(this.top, this.bottom, this.left, this.right);
    }
    toJSON() {
        return {
            top: this.top,
            bottom: this.bottom,
            left: this.left,
            right: this.right
        };
    }
};
function $902e455d852cdfb8$var$gs(e1, t) {
    if (!e1.renderWorldCopies || e1.lngRange) return;
    let n = t.lng - e1.center.lng;
    t.lng += n > 180 ? -360 : n < -180 ? 360 : 0;
}
function $902e455d852cdfb8$var$_s(e1) {
    return Math.max(0, Math.floor(e1));
}
var $902e455d852cdfb8$var$vs = class {
    constructor(e1, t){
        this.applyConstrain = (e1, t)=>this._constrainOverride === null ? this._callbacks.defaultConstrain(e1, t) : this._constrainOverride(e1, t), this._callbacks = e1, this._tileSize = 512, this._renderWorldCopies = t?.renderWorldCopies === void 0 || !!t?.renderWorldCopies, this._minZoom = t?.minZoom || 0, this._maxZoom = t?.maxZoom || 22, this._minPitch = t?.minPitch === void 0 || t?.minPitch === null ? 0 : t?.minPitch, this._maxPitch = t?.maxPitch === void 0 || t?.maxPitch === null ? 60 : t?.maxPitch, this._constrainOverride = t?.constrainOverride ?? null, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new (0, $caapT.k)(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = $902e455d852cdfb8$var$_s(this._zoom), this._scale = (0, $caapT.Mr)(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new $902e455d852cdfb8$export$45cce0bd6c1f342a, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
    }
    apply(e1, t, n) {
        this._constrainOverride = e1.constrainOverride, this._latRange = e1.latRange, this._lngRange = e1.lngRange, this._width = e1.width, this._height = e1.height, this._center = e1.center, this._elevation = e1.elevation, this._minElevationForCurrentTile = e1.minElevationForCurrentTile, this._zoom = e1.zoom, this._tileZoom = $902e455d852cdfb8$var$_s(this._zoom), this._scale = (0, $caapT.Mr)(this._zoom), this._bearingInRadians = e1.bearingInRadians, this._fovInRadians = e1.fovInRadians, this._pitchInRadians = e1.pitchInRadians, this._rollInRadians = e1.rollInRadians, this._unmodified = e1.unmodified, this._edgeInsets = new $902e455d852cdfb8$export$45cce0bd6c1f342a(e1.padding.top, e1.padding.bottom, e1.padding.left, e1.padding.right), this._minZoom = e1.minZoom, this._maxZoom = e1.maxZoom, this._minPitch = e1.minPitch, this._maxPitch = e1.maxPitch, this._renderWorldCopies = e1.renderWorldCopies, this._cameraToCenterDistance = e1.cameraToCenterDistance, this._nearZ = e1.nearZ, this._farZ = e1.farZ, this._autoCalculateNearFarZ = !n && e1.autoCalculateNearFarZ, t && this.constrainInternal(), this._calcMatrices();
    }
    get pixelsToClipSpaceMatrix() {
        return this._pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._clipSpaceToPixelsMatrix;
    }
    get minElevationForCurrentTile() {
        return this._minElevationForCurrentTile;
    }
    setMinElevationForCurrentTile(e1) {
        this._minElevationForCurrentTile = e1;
    }
    get tileSize() {
        return this._tileSize;
    }
    get tileZoom() {
        return this._tileZoom;
    }
    get scale() {
        return this._scale;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get bearingInRadians() {
        return this._bearingInRadians;
    }
    get lngRange() {
        return this._lngRange;
    }
    get latRange() {
        return this._latRange;
    }
    get pixelsToGLUnits() {
        return this._pixelsToGLUnits;
    }
    get minZoom() {
        return this._minZoom;
    }
    setMinZoom(e1) {
        this._minZoom !== e1 && (this._minZoom = e1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
    }
    get maxZoom() {
        return this._maxZoom;
    }
    setMaxZoom(e1) {
        this._maxZoom !== e1 && (this._maxZoom = e1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
    }
    get minPitch() {
        return this._minPitch;
    }
    setMinPitch(e1) {
        this._minPitch !== e1 && (this._minPitch = e1, this.setPitch(Math.max(this.pitch, e1)));
    }
    get maxPitch() {
        return this._maxPitch;
    }
    setMaxPitch(e1) {
        this._maxPitch !== e1 && (this._maxPitch = e1, this.setPitch(Math.min(this.pitch, e1)));
    }
    get renderWorldCopies() {
        return this._renderWorldCopies;
    }
    setRenderWorldCopies(e1) {
        e1 === void 0 ? e1 = !0 : e1 === null && (e1 = !1), this._renderWorldCopies = e1;
    }
    get constrainOverride() {
        return this._constrainOverride;
    }
    setConstrainOverride(e1) {
        e1 === void 0 && (e1 = null), this._constrainOverride !== e1 && (this._constrainOverride = e1, this.constrainInternal(), this._calcMatrices());
    }
    get worldSize() {
        return this._tileSize * this._scale;
    }
    get centerOffset() {
        return this.centerPoint._sub(this.size._div(2));
    }
    get size() {
        return new (0, $caapT.ji)(this._width, this._height);
    }
    get bearing() {
        return this._bearingInRadians / Math.PI * 180;
    }
    setBearing(e1) {
        let t = (0, $caapT.jr)(e1, -180, 180) * Math.PI / 180;
        this._bearingInRadians !== t && (this._unmodified = !1, this._bearingInRadians = t, this._calcMatrices(), this._rotationMatrix = $902e455d852cdfb8$var$xr(), $902e455d852cdfb8$var$Cr(this._rotationMatrix, this._rotationMatrix, -this._bearingInRadians));
    }
    get rotationMatrix() {
        return this._rotationMatrix;
    }
    get pitchInRadians() {
        return this._pitchInRadians;
    }
    get pitch() {
        return this._pitchInRadians / Math.PI * 180;
    }
    setPitch(e1) {
        let t = (0, $caapT.In)(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
        this._pitchInRadians !== t && (this._unmodified = !1, this._pitchInRadians = t, this._calcMatrices());
    }
    get rollInRadians() {
        return this._rollInRadians;
    }
    get roll() {
        return this._rollInRadians / Math.PI * 180;
    }
    setRoll(e1) {
        let t = e1 / 180 * Math.PI;
        this._rollInRadians !== t && (this._unmodified = !1, this._rollInRadians = t, this._calcMatrices());
    }
    get fovInRadians() {
        return this._fovInRadians;
    }
    get fov() {
        return (0, $caapT.vr)(this._fovInRadians);
    }
    setFov(e1) {
        e1 = (0, $caapT.In)(e1, .1, 150), this.fov !== e1 && (this._unmodified = !1, this._fovInRadians = (0, $caapT.Gn)(e1), this._calcMatrices());
    }
    get zoom() {
        return this._zoom;
    }
    setZoom(e1) {
        let t = this.applyConstrain(this._center, e1).zoom;
        this._zoom !== t && (this._unmodified = !1, this._zoom = t, this._tileZoom = Math.max(0, Math.floor(t)), this._scale = (0, $caapT.Mr)(t), this.constrainInternal(), this._calcMatrices());
    }
    get center() {
        return this._center;
    }
    setCenter(e1) {
        (e1.lat !== this._center.lat || e1.lng !== this._center.lng) && (this._unmodified = !1, this._center = e1, this.constrainInternal(), this._calcMatrices());
    }
    get elevation() {
        return this._elevation;
    }
    setElevation(e1) {
        e1 !== this._elevation && (this._elevation = e1, this.constrainInternal(), this._calcMatrices());
    }
    get padding() {
        return this._edgeInsets.toJSON();
    }
    setPadding(e1) {
        this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
    }
    get centerPoint() {
        return this._edgeInsets.getCenter(this._width, this._height);
    }
    get pixelsPerMeter() {
        return this._pixelPerMeter;
    }
    get unmodified() {
        return this._unmodified;
    }
    get cameraToCenterDistance() {
        return this._cameraToCenterDistance;
    }
    get nearZ() {
        return this._nearZ;
    }
    get farZ() {
        return this._farZ;
    }
    get autoCalculateNearFarZ() {
        return this._autoCalculateNearFarZ;
    }
    overrideNearFarZ(e1, t) {
        this._autoCalculateNearFarZ = !1, this._nearZ = e1, this._farZ = t, this._calcMatrices();
    }
    clearNearFarZOverride() {
        this._autoCalculateNearFarZ = !0, this._calcMatrices();
    }
    isPaddingEqual(e1) {
        return this._edgeInsets.equals(e1);
    }
    interpolatePadding(e1, t, n) {
        this._unmodified = !1, this._edgeInsets.interpolate(e1, t, n), this.constrainInternal(), this._calcMatrices();
    }
    resize(e1, t, n = !0) {
        this._width = e1, this._height = t, n && this.constrainInternal(), this._calcMatrices();
    }
    getMaxBounds() {
        return this._latRange?.length !== 2 || this._lngRange?.length !== 2 ? null : new $902e455d852cdfb8$export$266d2884f61535d3([
            this._lngRange[0],
            this._latRange[0]
        ], [
            this._lngRange[1],
            this._latRange[1]
        ]);
    }
    setMaxBounds(e1) {
        e1 ? (this._lngRange = [
            e1.getWest(),
            e1.getEast()
        ], this._latRange = [
            e1.getSouth(),
            e1.getNorth()
        ], this.constrainInternal()) : (this._lngRange = null, this._latRange = [
            -(0, $caapT.jn),
            (0, $caapT.jn)
        ]);
    }
    getCameraQueryGeometry(e1, t) {
        if (t.length === 1) return [
            t[0],
            e1
        ];
        {
            let { minX: n, minY: r, maxX: i, maxY: a } = (0, $caapT.h).fromPoints(t).extend(e1);
            return [
                new (0, $caapT.ji)(n, r),
                new (0, $caapT.ji)(i, r),
                new (0, $caapT.ji)(i, a),
                new (0, $caapT.ji)(n, a),
                new (0, $caapT.ji)(n, r)
            ];
        }
    }
    constrainInternal() {
        if (!this.center || !this._width || !this._height || this._constraining) return;
        this._constraining = !0;
        let e1 = this._unmodified, { center: t, zoom: n } = this.applyConstrain(this.center, this.zoom);
        this.setCenter(t), this.setZoom(n), this._unmodified = e1, this._constraining = !1;
    }
    _calcMatrices() {
        if (this._width && this._height) {
            this._pixelsToGLUnits = [
                2 / this._width,
                -2 / this._height
            ];
            let e1 = (0, $caapT.gi)(new Float64Array(16));
            (0, $caapT.wi)(e1, e1, [
                this._width / 2,
                -this._height / 2,
                1
            ]), (0, $caapT.Ti)(e1, e1, [
                1,
                -1,
                0
            ]), this._clipSpaceToPixelsMatrix = e1, e1 = (0, $caapT.gi)(new Float64Array(16)), (0, $caapT.wi)(e1, e1, [
                1,
                -1,
                1
            ]), (0, $caapT.Ti)(e1, e1, [
                -1,
                -1,
                0
            ]), (0, $caapT.wi)(e1, e1, [
                2 / this._width,
                2 / this._height,
                1
            ]), this._pixelsToClipSpaceMatrix = e1;
            let t = this.fovInRadians / 2;
            this._cameraToCenterDistance = .5 / Math.tan(t) * this._height;
        }
        this._callbacks.calcMatrices();
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        let i = n === void 0 ? this.bearing : n, a = r = r === void 0 ? this.pitch : r, { distanceToCenter: o, clampedElevation: s } = this._distanceToCenterFromAltElevationPitch(t, this.elevation, a), { x: c, y: l } = $902e455d852cdfb8$var$ka(a, i), u = (0, $caapT.S).fromLngLat(e1, t), f = (0, $caapT.C)(1, u.y), p, m, h = 0;
        do {
            if (h += 1, h > 10) break;
            m = o / f;
            let e1 = c * m, t = l * m;
            p = new (0, $caapT.S)(u.x + e1, u.y + t), f = 1 / p.meterInMercatorCoordinateUnits();
        }while (Math.abs(o - m * f) > 1e-12);
        return {
            center: p.toLngLat(),
            elevation: s,
            zoom: (0, $caapT.wr)(this.height / 2 / Math.tan(this.fovInRadians / 2) / m / this.tileSize)
        };
    }
    recalculateZoomAndCenter(e1) {
        if (this.elevation - e1 === 0) return;
        let t = 1 / this.worldSize, n = (0, $caapT.O)(1, this.center.lat) * this.worldSize, r = (0, $caapT.S).fromLngLat(this.center, this.elevation), i = r.x / t, a = r.y / t, o = r.z / t, s = this.pitch, c = this.bearing, { x: l, y: u, z: d } = $902e455d852cdfb8$var$ka(s, c), f = this.cameraToCenterDistance, p = i + f * -l, m = a + f * -u, h = o + f * d, { distanceToCenter: g, clampedElevation: _ } = this._distanceToCenterFromAltElevationPitch(h / n, e1, s), v = g * n, y = p + l * v, b = m + u * v, x = new (0, $caapT.S)(y * t, b * t, 0).toLngLat(), S = (0, $caapT.O)(1, x.lat), C = (0, $caapT.wr)(this.height / 2 / Math.tan(this.fovInRadians / 2) / g / S / this.tileSize);
        this._elevation = _, this._center = x, this.setZoom(C);
    }
    _distanceToCenterFromAltElevationPitch(e1, t, n) {
        let r = -Math.cos((0, $caapT.Gn)(n)), i = e1 - t, a, o = t;
        return r * i >= 0 || Math.abs(r) < .1 ? (a = 1e4, o = e1 + a * r) : a = -i / r, {
            distanceToCenter: a,
            clampedElevation: o
        };
    }
    getCameraPoint() {
        let e1 = this.pitchInRadians, t = Math.tan(e1) * (this.cameraToCenterDistance || 1);
        return this.centerPoint.add(new (0, $caapT.ji)(t * Math.sin(this.rollInRadians), t * Math.cos(this.rollInRadians)));
    }
    getCameraAltitude() {
        return Math.cos(this.pitchInRadians) * this._cameraToCenterDistance / this._pixelPerMeter + this.elevation;
    }
    getCameraLngLat() {
        let e1 = (0, $caapT.O)(1, this.center.lat) * this.worldSize, t = this.cameraToCenterDistance / e1;
        return $902e455d852cdfb8$var$Oa(this.center, this.elevation, this.pitch, this.bearing, t).toLngLat();
    }
    getMercatorTileCoordinates(e1) {
        if (!e1) return [
            0,
            0,
            1,
            1
        ];
        let t = e1.canonical.z >= 0 ? 1 << e1.canonical.z : 2 ** e1.canonical.z;
        return [
            e1.canonical.x / t,
            e1.canonical.y / t,
            1 / t / (0, $caapT.Pr),
            1 / t / (0, $caapT.Pr)
        ];
    }
}, $902e455d852cdfb8$var$ys = class e1 {
    constructor(e1, t){
        this.min = e1, this.max = t, this.center = (0, $caapT.ri)([], (0, $caapT.Kr)([], this.min, this.max), .5);
    }
    quadrant(t) {
        let n = [
            t % 2 == 0,
            t < 2
        ], r = (0, $caapT.qr)(this.min), i = (0, $caapT.qr)(this.max);
        for(let e1 = 0; e1 < n.length; e1++)r[e1] = n[e1] ? this.min[e1] : this.center[e1], i[e1] = n[e1] ? this.center[e1] : this.max[e1];
        return i[2] = this.max[2], new e1(r, i);
    }
    distanceX(e1) {
        return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
    }
    distanceY(e1) {
        return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
    }
    intersectsFrustum(e1) {
        let t = !0;
        for (let n of e1.planes){
            let e1 = this.intersectsPlane(n);
            if (e1 === 0) return 0;
            e1 === 1 && (t = !1);
        }
        return t ? 2 : e1.aabb.min[0] > this.max[0] || e1.aabb.min[1] > this.max[1] || e1.aabb.min[2] > this.max[2] || e1.aabb.max[0] < this.min[0] || e1.aabb.max[1] < this.min[1] || e1.aabb.max[2] < this.min[2] ? 0 : 1;
    }
    intersectsPlane(e1) {
        let t = e1[3], n = e1[3];
        for(let r = 0; r < 3; r++)e1[r] > 0 ? (t += e1[r] * this.min[r], n += e1[r] * this.max[r]) : (n += e1[r] * this.min[r], t += e1[r] * this.max[r]);
        return t >= 0 ? 2 : n < 0 ? 0 : 1;
    }
}, $902e455d852cdfb8$var$bs = class {
    distanceToTile2d(e1, t, n, r) {
        let i = r, a = i.distanceX([
            e1,
            t
        ]), o = i.distanceY([
            e1,
            t
        ]);
        return Math.hypot(a, o);
    }
    getWrap(e1, t, n) {
        return n;
    }
    getTileBoundingVolume(e1, t, n, r) {
        let i = 0, a = 0;
        if (r?.terrain) {
            let o = new (0, $caapT._)(e1.z, t, e1.z, e1.x, e1.y), s = r.terrain.getMinMaxElevation(o);
            i = s.minElevation ?? Math.min(0, n), a = s.maxElevation ?? Math.max(0, n);
        }
        let o = 1 << e1.z;
        return new $902e455d852cdfb8$var$ys([
            t + e1.x / o,
            e1.y / o,
            i
        ], [
            t + (e1.x + 1) / o,
            (e1.y + 1) / o,
            a
        ]);
    }
    allowVariableZoom(e1, t) {
        let n = (0, $caapT.In)(78.5 - e1.fov * (Math.abs(Math.cos(e1.rollInRadians)) * e1.height + Math.abs(Math.sin(e1.rollInRadians)) * e1.width) / e1.height / 2, 0, 60);
        return !!t.terrain || e1.pitch > n;
    }
    allowWorldCopies() {
        return !0;
    }
    prepareNextFrame() {}
}, $902e455d852cdfb8$var$xs = class e1 {
    constructor(e1, t, n){
        this.points = e1, this.planes = t, this.aabb = n;
    }
    static fromInvProjectionMatrix(n, r = 1, i = 0, a, o) {
        let s = [
            [
                -1,
                1,
                -1,
                1
            ],
            [
                1,
                1,
                -1,
                1
            ],
            [
                1,
                -1,
                -1,
                1
            ],
            [
                -1,
                -1,
                -1,
                1
            ],
            [
                -1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1
            ],
            [
                1,
                -1,
                1,
                1
            ],
            [
                -1,
                -1,
                1,
                1
            ]
        ], c = o ? [
            [
                6,
                5,
                4
            ],
            [
                0,
                1,
                2
            ],
            [
                0,
                3,
                7
            ],
            [
                2,
                1,
                5
            ],
            [
                3,
                2,
                6
            ],
            [
                0,
                4,
                5
            ]
        ] : [
            [
                0,
                1,
                2
            ],
            [
                6,
                5,
                4
            ],
            [
                0,
                3,
                7
            ],
            [
                2,
                1,
                5
            ],
            [
                3,
                2,
                6
            ],
            [
                0,
                4,
                5
            ]
        ], l = 2 ** i, u = s.map((e1)=>$902e455d852cdfb8$var$Ss(e1, n, r, l));
        a && $902e455d852cdfb8$var$Cs(u, c[0], a, o);
        let d = c.map((e1)=>{
            let n = (0, $caapT.$r)([], (0, $caapT.Jr)([], (0, $caapT.ai)([], u[e1[0]], u[e1[1]]), (0, $caapT.ai)([], u[e1[2]], u[e1[1]]))), r = -(0, $caapT.Yr)(n, u[e1[1]]);
            return n.concat(r);
        }), f = [
            1 / 0,
            1 / 0,
            1 / 0
        ], p = [
            -1 / 0,
            -1 / 0,
            -1 / 0
        ];
        for (let e1 of u)for(let t = 0; t < 3; t++)f[t] = Math.min(f[t], e1[t]), p[t] = Math.max(p[t], e1[t]);
        return new e1(u, d, new $902e455d852cdfb8$var$ys(f, p));
    }
};
function $902e455d852cdfb8$var$Ss(e1, t, n, r) {
    let i = (0, $caapT.Gr)([], e1, t), a = 1 / i[3] / n * r;
    return (0, $caapT.Ur)(i, i, [
        a,
        a,
        1 / i[3],
        a
    ]);
}
function $902e455d852cdfb8$var$Cs(e1, t, n, r) {
    let i = r ? 4 : 0, a = r ? 0 : 4, o = 0, s = [], c = [];
    for(let t = 0; t < 4; t++){
        let n = (0, $caapT.ai)([], e1[t + a], e1[t + i]), r = (0, $caapT.Zr)(n);
        (0, $caapT.ri)(n, n, 1 / r), s.push(r), c.push(n);
    }
    for(let t = 0; t < 4; t++){
        let r = (0, $caapT.yr)(e1[t + i], c[t], n);
        o = r !== null && r >= 0 ? Math.max(o, r) : Math.max(o, s[t]);
    }
    let l = $902e455d852cdfb8$var$ws(e1, t), u = $902e455d852cdfb8$var$Ts(n, l);
    if (u !== null) {
        let e1 = u / (0, $caapT.Yr)(c[0], l);
        o = Math.min(o, e1);
    }
    for(let t = 0; t < 4; t++){
        let n = Math.min(o, s[t]);
        e1[t + a] = [
            e1[t + i][0] + c[t][0] * n,
            e1[t + i][1] + c[t][1] * n,
            e1[t + i][2] + c[t][2] * n,
            1
        ];
    }
}
function $902e455d852cdfb8$var$ws(e1, n) {
    let r = (0, $caapT.ai)([], e1[n[0]], e1[n[1]]), i = (0, $caapT.ai)([], e1[n[2]], e1[n[1]]), a = [
        0,
        0,
        0,
        0
    ];
    return (0, $caapT.$r)(a, (0, $caapT.Jr)([], r, i)), a[3] = -(0, $caapT.Yr)(a, e1[n[0]]), a;
}
function $902e455d852cdfb8$var$Ts(e1, t) {
    let n = (0, $caapT.Wr)([], e1, 1 / (0, $caapT.Xr)(e1)), r = (0, $caapT.ai)([], t, (0, $caapT.ri)([], n, (0, $caapT.Yr)(t, n))), i = (0, $caapT.Xr)(r);
    if (i > 0) {
        let e1 = Math.sqrt(1 - n[3] * n[3]);
        return (0, $caapT._r)(t, (0, $caapT.Kr)([], (0, $caapT.ri)([], n, -n[3]), (0, $caapT.ri)([], r, e1 / i)));
    } else return null;
}
var $902e455d852cdfb8$var$Es = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, n) {
        this._helper.interpolatePadding(e1, t, n);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t, n = !0) {
        this._helper.resize(e1, t, n);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    setTransitionState(e1, t) {}
    constructor(e1){
        this._posMatrixCache = new Map, this._alignedPosMatrixCache = new Map, this._fogMatrixCacheF32 = new Map, this.defaultConstrain = (e1, t)=>{
            t = (0, $caapT.In)(+t, this.minZoom, this.maxZoom);
            let n = {
                center: new (0, $caapT.k)(e1.lng, e1.lat),
                zoom: t
            }, r = this._helper._lngRange;
            !this._helper._renderWorldCopies && r === null && (r = [
                -179.9999999999,
                179.9999999999
            ]);
            let i = this.tileSize * (0, $caapT.Mr)(n.zoom), a = 0, o = i, s = 0, c = i, l = 0, u = 0, { x: d, y: f } = this.size;
            if (this._helper._latRange) {
                let e1 = this._helper._latRange;
                a = (0, $caapT.D)(e1[1]) * i, o = (0, $caapT.D)(e1[0]) * i, o - a < f && (l = f / (o - a));
            }
            r && (s = (0, $caapT.jr)((0, $caapT.E)(r[0]) * i, 0, i), c = (0, $caapT.jr)((0, $caapT.E)(r[1]) * i, 0, i), c < s && (c += i), c - s < d && (u = d / (c - s)));
            let { x: p, y: m } = $902e455d852cdfb8$var$wa(i, e1), h, _, v = Math.max(u || 0, l || 0);
            if (v) return n.center = $902e455d852cdfb8$var$Ta(i, new (0, $caapT.ji)(u ? (c + s) / 2 : p, l ? (o + a) / 2 : m)).wrap(), n.zoom += (0, $caapT.wr)(v), n;
            if (this._helper._latRange) {
                let e1 = f / 2;
                m - e1 < a && (_ = a + e1), m + e1 > o && (_ = o - e1);
            }
            if (r) {
                let e1 = (s + c) / 2, t = p;
                this._helper._renderWorldCopies && (t = (0, $caapT.jr)(p, e1 - i / 2, e1 + i / 2));
                let n = d / 2;
                t - n < s && (h = s + n), t + n > c && (h = c - n);
            }
            return (h !== void 0 || _ !== void 0) && (n.center = $902e455d852cdfb8$var$Ta(i, new (0, $caapT.ji)(h ?? p, _ ?? m)).wrap()), n;
        }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $902e455d852cdfb8$var$vs({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._coveringTilesDetailsProvider = new $902e455d852cdfb8$var$bs;
    }
    clone() {
        let t = new e1;
        return t.apply(this, !1), t;
    }
    apply(e1, t, n) {
        this._helper.apply(e1, t, n);
    }
    get cameraPosition() {
        return this._cameraPosition;
    }
    get projectionMatrix() {
        return this._projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this._viewProjMatrix;
    }
    get inverseProjectionMatrix() {
        return this._invProjMatrix;
    }
    get mercatorMatrix() {
        return this._mercatorMatrix;
    }
    getVisibleUnwrappedCoordinates(e1) {
        let t = [
            new (0, $caapT.v)(0, e1)
        ];
        if (this._helper._renderWorldCopies) {
            let n = this.screenPointToMercatorCoordinate(new (0, $caapT.ji)(0, 0)), r = this.screenPointToMercatorCoordinate(new (0, $caapT.ji)(this._helper._width, 0)), i = this.screenPointToMercatorCoordinate(new (0, $caapT.ji)(this._helper._width, this._helper._height)), a = this.screenPointToMercatorCoordinate(new (0, $caapT.ji)(0, this._helper._height)), o = Math.floor(Math.min(n.x, r.x, i.x, a.x)), s = Math.floor(Math.max(n.x, r.x, i.x, a.x));
            for(let n = o - 1; n <= s + 1; n++)n !== 0 && t.push(new (0, $caapT.v)(n, e1));
        }
        return t;
    }
    getCameraFrustum() {
        return $902e455d852cdfb8$var$xs.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
    }
    getClippingPlane() {
        return null;
    }
    getCoveringTilesDetailsProvider() {
        return this._coveringTilesDetailsProvider;
    }
    recalculateZoomAndCenter(e1) {
        let t = this.screenPointToLocation(this.centerPoint, e1), n = e1 ? e1.getElevationForLngLatZoom(t, this._helper._tileZoom) : 0;
        this._helper.recalculateZoomAndCenter(n);
    }
    setLocationAtPoint(e1, t) {
        let n = (0, $caapT.O)(this.elevation, this.center.lat), r = this.screenPointToMercatorCoordinateAtZ(t, n), i = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, n), a = (0, $caapT.S).fromLngLat(e1), o = new (0, $caapT.S)(a.x - (r.x - i.x), a.y - (r.y - i.y));
        this.setCenter(o?.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
    }
    locationToScreenPoint(e1, t) {
        return t ? this.coordinatePoint((0, $caapT.S).fromLngLat(e1), t.getElevationForLngLat(e1, this), this._pixelMatrix3D) : this.coordinatePoint((0, $caapT.S).fromLngLat(e1));
    }
    screenPointToLocation(e1, t) {
        return this.screenPointToMercatorCoordinate(e1, t)?.toLngLat();
    }
    screenPointToMercatorCoordinate(e1, t) {
        if (t) {
            let n = t.pointCoordinate(e1);
            if (n != null) return n;
        }
        return this.screenPointToMercatorCoordinateAtZ(e1);
    }
    screenPointToMercatorCoordinateAtZ(e1, t) {
        let n = t || 0, r = [
            e1.x,
            e1.y,
            0,
            1
        ], i = [
            e1.x,
            e1.y,
            1,
            1
        ];
        (0, $caapT.Gr)(r, r, this._pixelMatrixInverse), (0, $caapT.Gr)(i, i, this._pixelMatrixInverse);
        let a = r[3], o = i[3], s = r[0] / a, c = i[0] / o, l = r[1] / a, u = i[1] / o, d = r[2] / a, f = i[2] / o, p = d === f ? 0 : (n - d) / (f - d);
        return new (0, $caapT.S)((0, $caapT.un).number(s, c, p) / this.worldSize, (0, $caapT.un).number(l, u, p) / this.worldSize, n);
    }
    coordinatePoint(e1, t = 0, n = this._pixelMatrix) {
        let r = [
            e1.x * this.worldSize,
            e1.y * this.worldSize,
            t,
            1
        ];
        return (0, $caapT.Gr)(r, r, n), new (0, $caapT.ji)(r[0] / r[3], r[1] / r[3]);
    }
    getBounds() {
        let e1 = Math.max(0, this._helper._height / 2 - $902e455d852cdfb8$var$Ea(this));
        return new $902e455d852cdfb8$export$266d2884f61535d3().extend(this.screenPointToLocation(new (0, $caapT.ji)(0, e1))).extend(this.screenPointToLocation(new (0, $caapT.ji)(this._helper._width, e1))).extend(this.screenPointToLocation(new (0, $caapT.ji)(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new (0, $caapT.ji)(0, this._helper._height)));
    }
    isPointOnMapSurface(e1, t) {
        return t ? t.pointCoordinate(e1) != null : e1.y > this.height / 2 - $902e455d852cdfb8$var$Ea(this);
    }
    calculatePosMatrix(e1, t = !1, n = !1) {
        let r = e1.key ?? (0, $caapT.y)(e1.wrap, e1.canonical.z, e1.canonical.z, e1.canonical.x, e1.canonical.y), i = t ? this._alignedPosMatrixCache : this._posMatrixCache;
        if (i.has(r)) {
            let e1 = i.get(r);
            return n ? e1.f32 : e1.f64;
        }
        let a = $902e455d852cdfb8$var$Da(e1, this.worldSize);
        (0, $caapT.vi)(a, t ? this._alignedProjMatrix : this._viewProjMatrix, a);
        let o = {
            f64: a,
            f32: new Float32Array(a)
        };
        return i.set(r, o), n ? o.f32 : o.f64;
    }
    calculateFogMatrix(e1) {
        let t = e1.key, n = this._fogMatrixCacheF32;
        if (n.has(t)) return n.get(t);
        let r = $902e455d852cdfb8$var$Da(e1, this.worldSize);
        return (0, $caapT.vi)(r, this._fogMatrix, r), n.set(t, new Float32Array(r)), n.get(t);
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
    }
    _calculateNearFarZIfNeeded(e1, t, n) {
        if (!this._helper.autoCalculateNearFarZ) return;
        let r = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), i = e1 - r * this._helper._pixelPerMeter / Math.cos(t), a = r < 0 ? i : e1, o = Math.PI / 2 + this.pitchInRadians, s = (0, $caapT.Gn)(this.fov) * (Math.abs(Math.cos((0, $caapT.Gn)(this.roll))) * this.height + Math.abs(Math.sin((0, $caapT.Gn)(this.roll))) * this.width) / this.height * (.5 + n.y / this.height), c = Math.sin(s) * a / Math.sin((0, $caapT.In)(Math.PI - o - s, .01, Math.PI - .01)), l = $902e455d852cdfb8$var$Ea(this), u = Math.atan(l / this._helper.cameraToCenterDistance), d = (0, $caapT.Gn)(90 - $902e455d852cdfb8$var$Sa), f = u > d ? 2 * u * (.5 + n.y / (l * 2)) : d, p = Math.sin(f) * a / Math.sin((0, $caapT.In)(Math.PI - o - f, .01, Math.PI - .01)), m = Math.min(c, p);
        this._helper._farZ = (Math.cos(Math.PI / 2 - t) * m + a) * 1.01, this._helper._nearZ = this._helper._height / 50;
    }
    _calcMatrices() {
        if (!this._helper._height) return;
        let e1 = this.centerOffset, t = $902e455d852cdfb8$var$wa(this.worldSize, this.center), n = t.x, r = t.y;
        this._helper._pixelPerMeter = (0, $caapT.O)(1, this.center.lat) * this.worldSize;
        let i = (0, $caapT.Gn)(Math.min(this.pitch, $902e455d852cdfb8$var$Sa)), a = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(i));
        this._calculateNearFarZIfNeeded(a, i, e1);
        let o;
        o = new Float64Array(16), (0, $caapT.bi)(o, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), $902e455d852cdfb8$var$Qa(this._invProjMatrix, o), o[8] = -e1.x * 2 / this._helper._width, o[9] = e1.y * 2 / this._helper._height, this._projectionMatrix = (0, $caapT.ui)(o), (0, $caapT.wi)(o, o, [
            1,
            -1,
            1
        ]), (0, $caapT.Ti)(o, o, [
            0,
            0,
            -this._helper.cameraToCenterDistance
        ]), (0, $caapT.Ci)(o, o, -this.rollInRadians), (0, $caapT.xi)(o, o, this.pitchInRadians), (0, $caapT.Ci)(o, o, -this.bearingInRadians), (0, $caapT.Ti)(o, o, [
            -n,
            -r,
            0
        ]), this._mercatorMatrix = (0, $caapT.wi)([], o, [
            this.worldSize,
            this.worldSize,
            this.worldSize
        ]), (0, $caapT.wi)(o, o, [
            1,
            1,
            this._helper._pixelPerMeter
        ]), this._pixelMatrix = (0, $caapT.vi)(new Float64Array(16), this.clipSpaceToPixelsMatrix, o), (0, $caapT.Ti)(o, o, [
            0,
            0,
            -this.elevation
        ]), this._viewProjMatrix = o, this._invViewProjMatrix = (0, $caapT._i)([], o);
        let s = [
            0,
            0,
            -1,
            1
        ];
        (0, $caapT.Gr)(s, s, this._invViewProjMatrix), this._cameraPosition = [
            s[0] / s[3],
            s[1] / s[3],
            s[2] / s[3]
        ], this._fogMatrix = new Float64Array(16), (0, $caapT.bi)(this._fogMatrix, this.fovInRadians, this.width / this.height, a, this._helper._farZ), this._fogMatrix[8] = -e1.x * 2 / this.width, this._fogMatrix[9] = e1.y * 2 / this.height, (0, $caapT.wi)(this._fogMatrix, this._fogMatrix, [
            1,
            -1,
            1
        ]), (0, $caapT.Ti)(this._fogMatrix, this._fogMatrix, [
            0,
            0,
            -this.cameraToCenterDistance
        ]), (0, $caapT.Ci)(this._fogMatrix, this._fogMatrix, -this.rollInRadians), (0, $caapT.xi)(this._fogMatrix, this._fogMatrix, this.pitchInRadians), (0, $caapT.Ci)(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), (0, $caapT.Ti)(this._fogMatrix, this._fogMatrix, [
            -n,
            -r,
            0
        ]), (0, $caapT.wi)(this._fogMatrix, this._fogMatrix, [
            1,
            1,
            this._helper._pixelPerMeter
        ]), (0, $caapT.Ti)(this._fogMatrix, this._fogMatrix, [
            0,
            0,
            -this.elevation
        ]), this._pixelMatrix3D = (0, $caapT.vi)(new Float64Array(16), this.clipSpaceToPixelsMatrix, o);
        let c = this._helper._width % 2 / 2, l = this._helper._height % 2 / 2, u = Math.cos(this.bearingInRadians), d = Math.sin(-this.bearingInRadians), p = n - Math.round(n) + u * c + d * l, m = r - Math.round(r) + u * l + d * c, h = new Float64Array(o);
        if ((0, $caapT.Ti)(h, h, [
            p > .5 ? p - 1 : p,
            m > .5 ? m - 1 : m,
            0
        ]), this._alignedProjMatrix = h, o = (0, $caapT._i)(new Float64Array(16), this._pixelMatrix), !o) throw Error(`failed to invert matrix`);
        this._pixelMatrixInverse = o, this._clearMatrixCaches();
    }
    _clearMatrixCaches() {
        this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
    }
    maxPitchScaleFactor() {
        if (!this._pixelMatrixInverse) return 1;
        let e1 = this.screenPointToMercatorCoordinate(new (0, $caapT.ji)(0, 0)), t = [
            e1.x * this.worldSize,
            e1.y * this.worldSize,
            0,
            1
        ];
        return (0, $caapT.Gr)(t, t, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return this._helper.getCameraAltitude();
    }
    getCameraLngLat() {
        let e1 = (0, $caapT.O)(1, this.center.lat) * this.worldSize, t = this._helper.cameraToCenterDistance / e1;
        return $902e455d852cdfb8$var$Oa(this.center, this.elevation, this.pitch, this.bearing, t).toLngLat();
    }
    lngLatToCameraDepth(e1, t) {
        let n = (0, $caapT.S).fromLngLat(e1), r = [
            n.x * this.worldSize,
            n.y * this.worldSize,
            t,
            1
        ];
        return (0, $caapT.Gr)(r, r, this._viewProjMatrix), r[2] / r[3];
    }
    getProjectionData(e1) {
        let { overscaledTileID: t, aligned: n, applyTerrainMatrix: r } = e1, i = this._helper.getMercatorTileCoordinates(t), a = t ? this.calculatePosMatrix(t, n, !0) : null, o;
        return o = t?.terrainRttPosMatrix32f && r ? t.terrainRttPosMatrix32f : a || (0, $caapT.Rn)(), {
            mainMatrix: o,
            tileMercatorCoords: i,
            clippingPlane: [
                0,
                0,
                0,
                0
            ],
            projectionTransition: 0,
            fallbackMatrix: o
        };
    }
    isLocationOccluded(e1) {
        return !1;
    }
    getPixelScale() {
        return 1;
    }
    getCircleRadiusCorrection() {
        return 1;
    }
    getPitchedTextCorrection(e1, t, n) {
        return 1;
    }
    transformLightDirection(e1) {
        return (0, $caapT.qr)(e1);
    }
    getRayDirectionFromPixel(e1) {
        throw Error(`Not implemented.`);
    }
    projectTileCoordinates(e1, t, n, r) {
        let i = this.calculatePosMatrix(n), a;
        r ? (a = [
            e1,
            t,
            r(e1, t),
            1
        ], (0, $caapT.Gr)(a, a, i)) : (a = [
            e1,
            t,
            0,
            1
        ], $902e455d852cdfb8$var$So(a, a, i));
        let o = a[3];
        return {
            point: new (0, $caapT.ji)(a[0] / o, a[1] / o),
            signedDistanceFromCamera: o,
            isOccluded: !1
        };
    }
    populateCache(e1) {
        for (let t of e1)this.calculatePosMatrix(t);
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = new (0, $caapT._)(0, 0, 0, 0, 0), n = this.getProjectionData({
            overscaledTileID: t,
            applyGlobeMatrix: e1
        }), r = $902e455d852cdfb8$var$Da(t, this.worldSize);
        (0, $caapT.vi)(r, this._viewProjMatrix, r);
        let i = [
            (0, $caapT.Pr),
            (0, $caapT.Pr),
            this.worldSize / this._helper.pixelsPerMeter
        ], a = (0, $caapT.Bn)();
        return (0, $caapT.wi)(a, r, i), {
            ...n,
            tileMercatorCoords: [
                0,
                0,
                1,
                1
            ],
            fallbackMatrix: a,
            mainMatrix: a
        };
    }
    getFastPathSimpleProjectionMatrix(e1) {
        return this.calculatePosMatrix(e1);
    }
};
function $902e455d852cdfb8$var$Ds() {
    (0, $caapT.Ar)(`Map cannot fit within canvas with the given bounds, padding, and/or offset.`);
}
function $902e455d852cdfb8$var$Os(e1) {
    if (e1.useSlerp) {
        if (e1.k < 1) {
            let t = (0, $caapT.Cr)(e1.startEulerAngles.roll, e1.startEulerAngles.pitch, e1.startEulerAngles.bearing), n = (0, $caapT.Cr)(e1.endEulerAngles.roll, e1.endEulerAngles.pitch, e1.endEulerAngles.bearing), r = new Float64Array(4);
            (0, $caapT.Hr)(r, t, n, e1.k);
            let i = (0, $caapT.ir)(r);
            e1.tr.setRoll(i.roll), e1.tr.setPitch(i.pitch), e1.tr.setBearing(i.bearing);
        } else e1.tr.setRoll(e1.endEulerAngles.roll), e1.tr.setPitch(e1.endEulerAngles.pitch), e1.tr.setBearing(e1.endEulerAngles.bearing);
    } else e1.tr.setRoll((0, $caapT.un).number(e1.startEulerAngles.roll, e1.endEulerAngles.roll, e1.k)), e1.tr.setPitch((0, $caapT.un).number(e1.startEulerAngles.pitch, e1.endEulerAngles.pitch, e1.k)), e1.tr.setBearing((0, $caapT.un).number(e1.startEulerAngles.bearing, e1.endEulerAngles.bearing, e1.k));
}
function $902e455d852cdfb8$var$ks(e1, t, n, r, i) {
    let a = i.padding, o = $902e455d852cdfb8$var$wa(i.worldSize, n.getNorthWest()), s = $902e455d852cdfb8$var$wa(i.worldSize, n.getNorthEast()), c = $902e455d852cdfb8$var$wa(i.worldSize, n.getSouthEast()), l = $902e455d852cdfb8$var$wa(i.worldSize, n.getSouthWest()), u = (0, $caapT.Gn)(-r), d = o.rotate(u), f = s.rotate(u), p = c.rotate(u), m = l.rotate(u), h = new (0, $caapT.ji)(Math.max(d.x, f.x, m.x, p.x), Math.max(d.y, f.y, m.y, p.y)), g = new (0, $caapT.ji)(Math.min(d.x, f.x, m.x, p.x), Math.min(d.y, f.y, m.y, p.y)), _ = h.sub(g), v = i.width - (a.left + a.right + t.left + t.right), y = i.height - (a.top + a.bottom + t.top + t.bottom), b = v / _.x, x = y / _.y;
    if (x < 0 || b < 0) {
        $902e455d852cdfb8$var$Ds();
        return;
    }
    let S = Math.min((0, $caapT.wr)(i.scale * Math.min(b, x)), e1.maxZoom), C = (0, $caapT.ji).convert(e1.offset), w = new (0, $caapT.ji)((t.left - t.right) / 2, (t.top - t.bottom) / 2).rotate((0, $caapT.Gn)(r)), T = C.add(w).mult(i.scale / (0, $caapT.Mr)(S));
    return {
        center: $902e455d852cdfb8$var$Ta(i.worldSize, o.add(c).div(2).sub(T)),
        zoom: S,
        bearing: r
    };
}
var $902e455d852cdfb8$var$As = class {
    get useGlobeControls() {
        return !1;
    }
    handlePanInertia(e1, t) {
        let n = e1.mag(), r = Math.abs($902e455d852cdfb8$var$Ea(t));
        return {
            easingOffset: e1.mult(Math.min(r * .75 / n, 1)),
            easingCenter: t.center
        };
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta), e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
    }
    handleMapControlsPan(e1, t, n) {
        e1.around.distSqr(t.centerPoint) < .01 || t.setLocationAtPoint(n, e1.around);
    }
    cameraForBoxAndBearing(e1, t, n, r, i) {
        return $902e455d852cdfb8$var$ks(e1, t, n, r, i);
    }
    handleJumpToCenterZoom(e1, t) {
        let n = t.zoom === void 0 ? e1.zoom : +t.zoom;
        e1.zoom !== n && e1.setZoom(+t.zoom), t.center !== void 0 && e1.setCenter((0, $caapT.k).convert(t.center));
    }
    handleEaseTo(e1, t) {
        let n = e1.zoom, r = e1.padding, i = {
            roll: e1.roll,
            pitch: e1.pitch,
            bearing: e1.bearing
        }, a = {
            roll: t.roll === void 0 ? e1.roll : t.roll,
            pitch: t.pitch === void 0 ? e1.pitch : t.pitch,
            bearing: t.bearing === void 0 ? e1.bearing : t.bearing
        }, o = t.zoom !== void 0, s = !e1.isPaddingEqual(t.padding), c = !1, l = o ? +t.zoom : e1.zoom, u = e1.centerPoint.add(t.offsetAsPoint), d = e1.screenPointToLocation(u), { center: f, zoom: p } = e1.applyConstrain((0, $caapT.k).convert(t.center || d), l ?? n);
        $902e455d852cdfb8$var$gs(e1, f);
        let m = $902e455d852cdfb8$var$wa(e1.worldSize, d), h = $902e455d852cdfb8$var$wa(e1.worldSize, f).sub(m), g = (0, $caapT.Mr)(p - n);
        return c = p !== n, {
            easeFunc: (o)=>{
                if (c && e1.setZoom((0, $caapT.un).number(n, p, o)), (0, $caapT.Sr)(i, a) || $902e455d852cdfb8$var$Os({
                    startEulerAngles: i,
                    endEulerAngles: a,
                    tr: e1,
                    k: o,
                    useSlerp: i.roll != a.roll
                }), s && (e1.interpolatePadding(r, t.padding, o), u = e1.centerPoint.add(t.offsetAsPoint)), t.around) e1.setLocationAtPoint(t.around, t.aroundPoint);
                else {
                    let t = (0, $caapT.Mr)(e1.zoom - n), r = (p > n ? Math.min(2, g) : Math.max(.5, g)) ** (1 - o), i = $902e455d852cdfb8$var$Ta(e1.worldSize, m.add(h.mult(o * r)).mult(t));
                    e1.setLocationAtPoint(e1.renderWorldCopies ? i.wrap() : i, u);
                }
            },
            isZooming: c,
            elevationCenter: f
        };
    }
    handleFlyTo(e1, t) {
        let n = t.zoom !== void 0, r = e1.zoom, i = e1.applyConstrain((0, $caapT.k).convert(t.center || t.locationAtOffset), n ? +t.zoom : r), a = i.center, o = i.zoom;
        $902e455d852cdfb8$var$gs(e1, a);
        let s = e1.worldSize, c = $902e455d852cdfb8$var$wa(s, t.locationAtOffset), l = $902e455d852cdfb8$var$wa(s, a).sub(c), u = l.mag(), d = (0, $caapT.Mr)(o - r), f = t.minZoom === void 0 ? e1.minZoom : +t.minZoom, p = Math.max(f, e1.minZoom), m = Math.min(p, r, o), h = e1.applyConstrain(a, m).zoom;
        return {
            easeFunc: (t, n, i, u)=>{
                e1.setZoom(t === 1 ? o : r + (0, $caapT.wr)(n));
                let d = t === 1 ? a : $902e455d852cdfb8$var$Ta(s, c.add(l.mult(i)));
                e1.setLocationAtPoint(e1.renderWorldCopies ? d.wrap() : d, u);
            },
            scaleOfZoom: d,
            targetCenter: a,
            scaleOfMinZoom: (0, $caapT.Mr)(h - r),
            pixelPathLength: u
        };
    }
};
let $902e455d852cdfb8$var$js;
const $902e455d852cdfb8$var$Ms = ()=>$902e455d852cdfb8$var$js ||= new (0, $caapT.Ht)({
        type: new (0, $caapT.Vt)((0, $caapT.dn).projection.type, `type`)
    });
var $902e455d852cdfb8$var$Y = class {
    constructor(e1, t, n){
        this.blendFunction = e1, this.blendColor = t, this.mask = n;
    }
};
$902e455d852cdfb8$var$Y.Replace = [
    1,
    0
], $902e455d852cdfb8$var$Y.disabled = new $902e455d852cdfb8$var$Y($902e455d852cdfb8$var$Y.Replace, (0, $caapT.tn).transparent, [
    !1,
    !1,
    !1,
    !1
]), $902e455d852cdfb8$var$Y.unblended = new $902e455d852cdfb8$var$Y($902e455d852cdfb8$var$Y.Replace, (0, $caapT.tn).transparent, [
    !0,
    !0,
    !0,
    !0
]), $902e455d852cdfb8$var$Y.alphaBlended = new $902e455d852cdfb8$var$Y([
    1,
    771
], (0, $caapT.tn).transparent, [
    !0,
    !0,
    !0,
    !0
]);
const $902e455d852cdfb8$var$Ns = 1029, $902e455d852cdfb8$var$Ps = 2305;
var $902e455d852cdfb8$var$X = class {
    constructor(e1, t, n){
        this.enable = e1, this.mode = t, this.frontFace = n;
    }
};
$902e455d852cdfb8$var$X.disabled = new $902e455d852cdfb8$var$X(!1, $902e455d852cdfb8$var$Ns, $902e455d852cdfb8$var$Ps), $902e455d852cdfb8$var$X.backCCW = new $902e455d852cdfb8$var$X(!0, $902e455d852cdfb8$var$Ns, $902e455d852cdfb8$var$Ps), $902e455d852cdfb8$var$X.frontCCW = new $902e455d852cdfb8$var$X(!0, 1028, $902e455d852cdfb8$var$Ps);
var $902e455d852cdfb8$var$Z = class {
    constructor(e1, t, n){
        this.func = e1, this.mask = t, this.range = n;
    }
};
$902e455d852cdfb8$var$Z.ReadOnly = !1, $902e455d852cdfb8$var$Z.ReadWrite = !0, $902e455d852cdfb8$var$Z.disabled = new $902e455d852cdfb8$var$Z(519, $902e455d852cdfb8$var$Z.ReadOnly, [
    0,
    1
]);
const $902e455d852cdfb8$var$Fs = 7680;
var $902e455d852cdfb8$var$Q = class {
    constructor(e1, t, n, r, i, a){
        this.test = e1, this.ref = t, this.mask = n, this.fail = r, this.depthFail = i, this.pass = a;
    }
};
$902e455d852cdfb8$var$Q.disabled = new $902e455d852cdfb8$var$Q({
    func: 519,
    mask: 0
}, 0, 0, $902e455d852cdfb8$var$Fs, $902e455d852cdfb8$var$Fs, $902e455d852cdfb8$var$Fs);
const $902e455d852cdfb8$var$Is = (e1, t)=>({
        u_input: new (0, $caapT.xt)(e1, t.u_input),
        u_output_expected: new (0, $caapT.xt)(e1, t.u_output_expected)
    }), $902e455d852cdfb8$var$Ls = (e1, t)=>({
        u_input: e1,
        u_output_expected: t
    });
var $902e455d852cdfb8$var$Rs = class e1 {
    get awaitingQuery() {
        return !!this._readbackQueue;
    }
    constructor(e1){
        this._readbackWaitFrames = 4, this._measureWaitFrames = 6, this._texWidth = 1, this._texHeight = 1, this._measuredError = 0, this._updateCount = 0, this._lastReadbackFrame = -1000, this._readbackQueue = null, this._cachedRenderContext = e1;
        let t = e1.context, n = t.gl;
        this._texFormat = n.RGBA, this._texType = n.UNSIGNED_BYTE;
        let r = new (0, $caapT.Ft);
        r.emplaceBack(-1, -1), r.emplaceBack(2, -1), r.emplaceBack(-1, 2);
        let i = new (0, $caapT.Rt);
        i.emplaceBack(0, 1, 2), this._fullscreenTriangle = new $902e455d852cdfb8$var$us(t.createVertexBuffer(r, $902e455d852cdfb8$var$ds.members), t.createIndexBuffer(i), (0, $caapT.At).simpleSegment(0, 0, r.length, i.length)), this._resultBuffer = new Uint8Array(4), t.activeTexture.set(n.TEXTURE1);
        let a = n.createTexture();
        n.bindTexture(n.TEXTURE_2D, a), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.NEAREST), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.NEAREST), n.texStorage2D(n.TEXTURE_2D, 1, n.RGBA8, this._texWidth, this._texHeight), this._fbo = t.createFramebuffer(this._texWidth, this._texHeight, !1, !1), this._fbo.colorAttachment.set(a), this._pbo = n.createBuffer(), n.bindBuffer(n.PIXEL_PACK_BUFFER, this._pbo), n.bufferData(n.PIXEL_PACK_BUFFER, 4, n.STREAM_READ), n.bindBuffer(n.PIXEL_PACK_BUFFER, null);
    }
    destroy() {
        let e1 = this._cachedRenderContext.context.gl;
        this._fullscreenTriangle.destroy(), this._fbo.destroy(), e1.deleteBuffer(this._pbo), this._fullscreenTriangle = null, this._fbo = null, this._pbo = null, this._resultBuffer = null;
    }
    updateErrorLoop(e1, t) {
        let n = this._updateCount;
        return this._readbackQueue ? n >= this._readbackQueue.frameNumberIssued + this._readbackWaitFrames && this._tryReadback() : n >= this._lastReadbackFrame + this._measureWaitFrames && this._renderErrorTexture(e1, t), this._updateCount++, this._measuredError;
    }
    _bindFramebuffer() {
        let e1 = this._cachedRenderContext.context, t = e1.gl;
        e1.activeTexture.set(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, this._fbo.colorAttachment.get()), e1.bindFramebuffer.set(this._fbo.framebuffer);
    }
    _renderErrorTexture(e1, t) {
        let n = this._cachedRenderContext.context, r = n.gl;
        this._bindFramebuffer(), n.viewport.set([
            0,
            0,
            this._texWidth,
            this._texHeight
        ]), n.clear({
            color: (0, $caapT.tn).transparent
        }), this._cachedRenderContext.useProgram(`projectionErrorMeasurement`).draw(n, r.TRIANGLES, $902e455d852cdfb8$var$Z.disabled, $902e455d852cdfb8$var$Q.disabled, $902e455d852cdfb8$var$Y.unblended, $902e455d852cdfb8$var$X.disabled, $902e455d852cdfb8$var$Ls(e1, t), null, null, `$clipping`, this._fullscreenTriangle.vertexBuffer, this._fullscreenTriangle.indexBuffer, this._fullscreenTriangle.segments), r.bindBuffer(r.PIXEL_PACK_BUFFER, this._pbo), r.readBuffer(r.COLOR_ATTACHMENT0), r.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, 0), r.bindBuffer(r.PIXEL_PACK_BUFFER, null);
        let i = r.fenceSync(r.SYNC_GPU_COMMANDS_COMPLETE, 0);
        r.flush(), this._readbackQueue = {
            frameNumberIssued: this._updateCount,
            sync: i
        };
    }
    _tryReadback() {
        let t = this._cachedRenderContext.context.gl;
        if (!this._readbackQueue) return;
        let n = t.clientWaitSync(this._readbackQueue.sync, 0, 0);
        if (n === t.WAIT_FAILED) {
            (0, $caapT.Ar)(`WebGL2 clientWaitSync failed.`), this._readbackQueue = null, this._lastReadbackFrame = this._updateCount;
            return;
        }
        n !== t.TIMEOUT_EXPIRED && (t.bindBuffer(t.PIXEL_PACK_BUFFER, this._pbo), t.getBufferSubData(t.PIXEL_PACK_BUFFER, 0, this._resultBuffer, 0, 4), t.bindBuffer(t.PIXEL_PACK_BUFFER, null), this._readbackQueue = null, this._measuredError = e1._parseRGBA8float(this._resultBuffer), this._lastReadbackFrame = this._updateCount);
    }
    static _parseRGBA8float(e1) {
        let t = 0;
        return t += e1[0] / 256, t += e1[1] / 65536, t += e1[2] / 16777216, e1[3] < 127 && (t = -t), t / 128;
    }
};
const $902e455d852cdfb8$var$zs = (0, $caapT.Pr) / 128;
function $902e455d852cdfb8$var$Bs(e1, t) {
    let n = $902e455d852cdfb8$export$54e626fcf5dbddb3(t, `16bit`), r = (0, $caapT.Ft).deserialize({
        arrayBuffer: n.vertices,
        length: n.vertices.byteLength / 2 / 2
    }), i = (0, $caapT.Rt).deserialize({
        arrayBuffer: n.indices,
        length: n.indices.byteLength / 2 / 3
    });
    return new $902e455d852cdfb8$var$us(e1.createVertexBuffer(r, $902e455d852cdfb8$var$ds.members), e1.createIndexBuffer(i), (0, $caapT.At).simpleSegment(0, 0, r.length, i.length));
}
function $902e455d852cdfb8$export$54e626fcf5dbddb3(e1, t) {
    let n = e1.granularity === void 0 ? 1 : Math.max(e1.granularity, 1), r = n + (e1.generateBorders ? 2 : 0), i = n + (e1.extendToNorthPole || e1.generateBorders ? 1 : 0) + (e1.extendToSouthPole || e1.generateBorders ? 1 : 0), a = r + 1, o = i + 1, s = e1.generateBorders ? -1 : 0, c = e1.generateBorders || e1.extendToNorthPole ? -1 : 0, l = n + +!!e1.generateBorders, u = n + (e1.generateBorders || e1.extendToSouthPole ? 1 : 0), d = a * o, f = r * i * 6, p = a * o > 65536;
    if (p && t === `16bit`) throw Error(`Granularity is too large and meshes would not fit inside 16 bit vertex indices.`);
    let m = p || t === `32bit`, h = new Int16Array(d * 2), g = 0;
    for(let t = c; t <= u; t++)for(let r = s; r <= l; r++){
        let i = r / n * (0, $caapT.Pr);
        r === -1 && (i = -$902e455d852cdfb8$var$zs), r === n + 1 && (i = (0, $caapT.Pr) + $902e455d852cdfb8$var$zs);
        let a = t / n * (0, $caapT.Pr);
        t === -1 && (a = e1.extendToNorthPole ? (0, $caapT.at) : -$902e455d852cdfb8$var$zs), t === n + 1 && (a = e1.extendToSouthPole ? (0, $caapT.ot) : (0, $caapT.Pr) + $902e455d852cdfb8$var$zs), h[g++] = i, h[g++] = a;
    }
    let _ = m ? new Uint32Array(f) : new Uint16Array(f), v = 0;
    for(let e1 = 0; e1 < i; e1++)for(let t = 0; t < r; t++){
        let n = t + e1 * a, r = t + 1 + e1 * a, i = t + (e1 + 1) * a, o = t + 1 + (e1 + 1) * a;
        _[v++] = n, _[v++] = i, _[v++] = r, _[v++] = r, _[v++] = i, _[v++] = o;
    }
    return {
        vertices: h.buffer.slice(0),
        indices: _.buffer.slice(0),
        uses32bitIndices: m
    };
}
const $902e455d852cdfb8$var$Hs = {
    errorTransitionTimeSeconds: .5
}, $902e455d852cdfb8$var$Us = new (0, $caapT.ct)({
    fill: new (0, $caapT.st)(128, 2),
    line: new (0, $caapT.st)(512, 0),
    tile: new (0, $caapT.st)(128, 32),
    stencil: new (0, $caapT.st)(128, 1),
    circle: 3
});
var $902e455d852cdfb8$var$Ws = class {
    constructor(){
        this._tileMeshCache = {}, this._errorCorrectionUsable = 0, this._errorMeasurementLastValue = 0, this._errorCorrectionPreviousValue = 0, this._errorMeasurementLastChangeTime = -1000;
    }
    get name() {
        return `vertical-perspective`;
    }
    get transitionState() {
        return 1;
    }
    get useSubdivision() {
        return !0;
    }
    get shaderVariantName() {
        return `globe`;
    }
    get shaderDefine() {
        return `#define GLOBE`;
    }
    get shaderPreludeCode() {
        return $902e455d852cdfb8$var$ls.projectionGlobe;
    }
    get vertexShaderPreludeCode() {
        return $902e455d852cdfb8$var$ls.projectionMercator.vertexSource;
    }
    get subdivisionGranularity() {
        return $902e455d852cdfb8$var$Us;
    }
    get useGlobeControls() {
        return !0;
    }
    get latitudeErrorCorrectionRadians() {
        return this._errorCorrectionUsable;
    }
    destroy() {
        this._errorMeasurement && this._errorMeasurement.destroy();
    }
    updateGPUdependent(e1) {
        this._errorMeasurement ||= new $902e455d852cdfb8$var$Rs(e1);
        let t = (0, $caapT.D)(this._errorQueryLatitudeDegrees), n = 2 * Math.atan(Math.exp(Math.PI - t * Math.PI * 2)) - Math.PI * .5, r = this._errorMeasurement.updateErrorLoop(t, n), i = $902e455d852cdfb8$export$461939dd4422153();
        r !== this._errorMeasurementLastValue && (this._errorCorrectionPreviousValue = this._errorCorrectionUsable, this._errorMeasurementLastValue = r, this._errorMeasurementLastChangeTime = i);
        let a = (i - this._errorMeasurementLastChangeTime) / 1e3, o = Math.min(Math.max(a / $902e455d852cdfb8$var$Hs.errorTransitionTimeSeconds, 0), 1), s = -this._errorMeasurementLastValue;
        this._errorCorrectionUsable = (0, $caapT.dr)(this._errorCorrectionPreviousValue, s, (0, $caapT.Jn)(o));
    }
    _getMeshKey(e1) {
        return `${e1.granularity.toString(36)}_${e1.generateBorders ? `b` : ``}${e1.extendToNorthPole ? `n` : ``}${e1.extendToSouthPole ? `s` : ``}`;
    }
    getMeshFromTileID(e1, t, n, r, i) {
        let a = (i === `stencil` ? $902e455d852cdfb8$var$Us.stencil : $902e455d852cdfb8$var$Us.tile).getGranularityForZoomLevel(t.z), o = t.y === 0 && r, s = t.y === (1 << t.z) - 1 && r;
        return this._getMesh(e1, {
            granularity: a,
            generateBorders: n,
            extendToNorthPole: o,
            extendToSouthPole: s
        });
    }
    _getMesh(e1, t) {
        let n = this._getMeshKey(t);
        if (n in this._tileMeshCache) return this._tileMeshCache[n];
        let r = $902e455d852cdfb8$var$Bs(e1, t);
        return this._tileMeshCache[n] = r, r;
    }
    recalculate(e1) {}
    hasTransition() {
        let e1 = $902e455d852cdfb8$export$461939dd4422153(), t = !1;
        return t ||= (e1 - this._errorMeasurementLastChangeTime) / 1e3 < $902e455d852cdfb8$var$Hs.errorTransitionTimeSeconds + .2, t ||= this._errorMeasurement?.awaitingQuery, t;
    }
    setErrorQueryLatitudeDegrees(e1) {
        this._errorQueryLatitudeDegrees = e1;
    }
}, $902e455d852cdfb8$var$Gs = class extends (0, $caapT.mn) {
    constructor(e1){
        super(), this._transitionable = new (0, $caapT.Wt)($902e455d852cdfb8$var$Ms(), `projection`, void 0), this.setProjection(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new (0, $caapT.Gt)(0)), this._mercatorProjection = new $902e455d852cdfb8$var$ms, this._verticalPerspectiveProjection = new $902e455d852cdfb8$var$Ws;
    }
    get transitionState() {
        let e1 = this.properties.get(`type`);
        if (typeof e1 == `string` && e1 === `mercator`) return 0;
        if (typeof e1 == `string` && e1 === `vertical-perspective`) return 1;
        if (e1 instanceof (0, $caapT.nn)) {
            if (e1.from === `vertical-perspective` && e1.to === `mercator`) return 1 - e1.transition;
            if (e1.from === `mercator` && e1.to === `vertical-perspective`) return e1.transition;
        }
        return 1;
    }
    get useGlobeRendering() {
        return this.transitionState > 0;
    }
    get latitudeErrorCorrectionRadians() {
        return this._verticalPerspectiveProjection.latitudeErrorCorrectionRadians;
    }
    get currentProjection() {
        return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
    }
    get name() {
        return `globe`;
    }
    get useSubdivision() {
        return this.currentProjection.useSubdivision;
    }
    get shaderVariantName() {
        return this.currentProjection.shaderVariantName;
    }
    get shaderDefine() {
        return this.currentProjection.shaderDefine;
    }
    get shaderPreludeCode() {
        return this.currentProjection.shaderPreludeCode;
    }
    get vertexShaderPreludeCode() {
        return this.currentProjection.vertexShaderPreludeCode;
    }
    get subdivisionGranularity() {
        return this.currentProjection.subdivisionGranularity;
    }
    get useGlobeControls() {
        return this.transitionState > 0;
    }
    destroy() {
        this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
    }
    updateGPUdependent(e1) {
        this._mercatorProjection.updateGPUdependent(e1), this._verticalPerspectiveProjection.updateGPUdependent(e1);
    }
    getMeshFromTileID(e1, t, n, r, i) {
        return this.currentProjection.getMeshFromTileID(e1, t, n, r, i);
    }
    setProjection(e1) {
        this._transitionable.setValue(`type`, e1?.type || `mercator`);
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
    setErrorQueryLatitudeDegrees(e1) {
        this._verticalPerspectiveProjection.setErrorQueryLatitudeDegrees(e1), this._mercatorProjection.setErrorQueryLatitudeDegrees(e1);
    }
};
function $902e455d852cdfb8$var$Ks(e1) {
    let t = $902e455d852cdfb8$var$Qs(e1.worldSize, e1.center.lat);
    return 2 * Math.PI * t;
}
function $902e455d852cdfb8$var$qs(e1, t, n) {
    let r = (0, $caapT.Yr)($902e455d852cdfb8$var$Zs(t), $902e455d852cdfb8$var$Zs(n)), i = Math.acos(r), a = $902e455d852cdfb8$var$Ks(e1);
    return i / (2 * Math.PI) * a;
}
function $902e455d852cdfb8$var$Js(e1, t) {
    return [
        (0, $caapT.pr)(e1 * Math.PI * 2 + Math.PI, Math.PI * 2),
        2 * Math.atan(Math.exp(Math.PI - t * Math.PI * 2)) - Math.PI * .5
    ];
}
function $902e455d852cdfb8$var$Ys(e1, t) {
    let n = Math.cos(t), r = new Float64Array(3);
    return r[0] = Math.sin(e1) * n, r[1] = Math.sin(t), r[2] = Math.cos(e1) * n, r;
}
function $902e455d852cdfb8$var$Xs(e1, t, n, r, i) {
    let a = 1 / (1 << i), o = e1 / (0, $caapT.Pr) * a + n * a, s = t / (0, $caapT.Pr) * a + r * a, c = (0, $caapT.pr)(o * Math.PI * 2 + Math.PI, Math.PI * 2), l = 2 * Math.atan(Math.exp(Math.PI - s * Math.PI * 2)) - Math.PI * .5, u = Math.cos(l), d = new Float64Array(3);
    return d[0] = Math.sin(c) * u, d[1] = Math.sin(l), d[2] = Math.cos(c) * u, d;
}
function $902e455d852cdfb8$var$Zs(e1) {
    return $902e455d852cdfb8$var$Ys(e1.lng * Math.PI / 180, e1.lat * Math.PI / 180);
}
function $902e455d852cdfb8$var$Qs(e1, t) {
    return e1 / (2 * Math.PI) / Math.cos(t * Math.PI / 180);
}
function $902e455d852cdfb8$var$$s(e1) {
    let t = Math.asin(e1[1]) / Math.PI * 180, n = Math.sqrt(e1[0] * e1[0] + e1[2] * e1[2]);
    if (n > 1e-6) {
        let r = e1[0] / n, i = e1[2] / n, a = Math.acos(i);
        return new (0, $caapT.k)((0, $caapT.jr)((r > 0 ? a : -a) / Math.PI * 180, -180, 180), t);
    } else return new (0, $caapT.k)(0, t);
}
function $902e455d852cdfb8$var$ec(e1) {
    let t = (0, $caapT.Vn)();
    return t[0] = e1[0] * -e1[3], t[1] = e1[1] * -e1[3], t[2] = e1[2] * -e1[3], {
        center: t,
        radius: Math.sqrt(1 - e1[3] * e1[3])
    };
}
function $902e455d852cdfb8$var$tc(e1, t, n) {
    let r = (0, $caapT.Vn)();
    (0, $caapT.ai)(r, n, e1);
    let i = (0, $caapT.Vn)();
    return (0, $caapT.ii)(i, e1, r, t / (0, $caapT.Xr)(r)), i;
}
function $902e455d852cdfb8$var$nc(e1) {
    return Math.cos(e1 * Math.PI / 180);
}
function $902e455d852cdfb8$var$rc(e1, t) {
    let n = $902e455d852cdfb8$var$nc(e1);
    return (0, $caapT.wr)($902e455d852cdfb8$var$nc(t) / n);
}
function $902e455d852cdfb8$var$ic(e1, t) {
    return 360 / $902e455d852cdfb8$var$Ks({
        worldSize: e1,
        center: {
            lat: t
        }
    });
}
function $902e455d852cdfb8$var$ac(e1, t) {
    let n = e1.rotate(t.bearingInRadians), r = t.zoom + $902e455d852cdfb8$var$rc(t.center.lat, 0), i = (0, $caapT.dr)(1 / $902e455d852cdfb8$var$nc(t.center.lat), 1 / $902e455d852cdfb8$var$nc(Math.min(Math.abs(t.center.lat), 60)), (0, $caapT.xr)(r, 7, 3, 0, 1)), a = $902e455d852cdfb8$var$ic(t.worldSize, t.center.lat);
    return new (0, $caapT.k)(t.center.lng - n.x * a * i, (0, $caapT.In)(t.center.lat + n.y * a, -(0, $caapT.jn), (0, $caapT.jn)));
}
function $902e455d852cdfb8$var$oc(e1) {
    let t = .5 * e1, n = Math.sin(t), r = Math.cos(t);
    return Math.log(n + r) - Math.log(r - n);
}
function $902e455d852cdfb8$var$sc(e1, t, n, r) {
    let i = e1.lat + n * r;
    if (Math.abs(n) > 1) {
        let a = e1.lat + n, o = (Math.sign(a) === Math.sign(e1.lat) ? Math.abs(e1.lat) : -Math.abs(e1.lat)) * Math.PI / 180, s = Math.abs(e1.lat + n) * Math.PI / 180, c = $902e455d852cdfb8$var$oc(o + r * (s - o)), l = $902e455d852cdfb8$var$oc(o), u = $902e455d852cdfb8$var$oc(s), d = (c - l) / (u - l);
        return new (0, $caapT.k)(e1.lng + t * d, i);
    } else return new (0, $caapT.k)(e1.lng + t * r, i);
}
var $902e455d852cdfb8$var$cc = class {
    constructor(e1){
        this._cachePrevious = new Map, this._cache = new Map, this._hadAnyChanges = !1, this._boundingVolumeFactory = e1;
    }
    swapBuffers() {
        if (!this._hadAnyChanges) return;
        let e1 = this._cachePrevious;
        this._cachePrevious = this._cache, this._cache = e1, this._cache.clear(), this._hadAnyChanges = !1;
    }
    getTileBoundingVolume(e1, t, n, r) {
        let i = `${e1.z}_${e1.x}_${e1.y}_${r?.terrain ? `t` : ``}`, a = this._cache.get(i);
        if (a) return a;
        let o = this._cachePrevious.get(i);
        if (o) return this._cache.set(i, o), o;
        let s = this._boundingVolumeFactory(e1, t, n, r);
        return this._cache.set(i, s), this._hadAnyChanges = !0, s;
    }
}, $902e455d852cdfb8$var$lc = class e1 {
    constructor(e1, t, n, r){
        this.min = n, this.max = r, this.points = e1, this.planes = t;
    }
    static fromAabb(t, n) {
        let r = [];
        for(let e1 = 0; e1 < 8; e1++)r.push([
            (e1 >> 0 & 1) == 1 ? n[0] : t[0],
            (e1 >> 1 & 1) == 1 ? n[1] : t[1],
            (e1 >> 2 & 1) == 1 ? n[2] : t[2]
        ]);
        return new e1(r, [
            [
                -1,
                0,
                0,
                n[0]
            ],
            [
                1,
                0,
                0,
                -t[0]
            ],
            [
                0,
                -1,
                0,
                n[1]
            ],
            [
                0,
                1,
                0,
                -t[1]
            ],
            [
                0,
                0,
                -1,
                n[2]
            ],
            [
                0,
                0,
                1,
                -t[2]
            ]
        ], t, n);
    }
    static fromCenterSizeAngles(t, n, r) {
        let i = (0, $caapT.Vr)([], r[0], r[1], r[2]), a = (0, $caapT.ci)([], [
            n[0],
            0,
            0
        ], i), o = (0, $caapT.ci)([], [
            0,
            n[1],
            0
        ], i), s = (0, $caapT.ci)([], [
            0,
            0,
            n[2]
        ], i), c = [
            ...t
        ], l = [
            ...t
        ];
        for(let e1 = 0; e1 < 8; e1++)for(let n = 0; n < 3; n++){
            let r = t[n] + a[n] * ((e1 >> 0 & 1) == 1 ? 1 : -1) + o[n] * ((e1 >> 1 & 1) == 1 ? 1 : -1) + s[n] * ((e1 >> 2 & 1) == 1 ? 1 : -1);
            c[n] = Math.min(c[n], r), l[n] = Math.max(l[n], r);
        }
        let u = [];
        for(let e1 = 0; e1 < 8; e1++){
            let n = [
                ...t
            ];
            (0, $caapT.Kr)(n, n, (0, $caapT.ri)([], a, (e1 >> 0 & 1) == 1 ? 1 : -1)), (0, $caapT.Kr)(n, n, (0, $caapT.ri)([], o, (e1 >> 1 & 1) == 1 ? 1 : -1)), (0, $caapT.Kr)(n, n, (0, $caapT.ri)([], s, (e1 >> 2 & 1) == 1 ? 1 : -1)), u.push(n);
        }
        return new e1(u, [
            [
                ...a,
                -(0, $caapT.Yr)(a, u[0])
            ],
            [
                ...o,
                -(0, $caapT.Yr)(o, u[0])
            ],
            [
                ...s,
                -(0, $caapT.Yr)(s, u[0])
            ],
            [
                -a[0],
                -a[1],
                -a[2],
                -(0, $caapT.Yr)(a, u[7])
            ],
            [
                -o[0],
                -o[1],
                -o[2],
                -(0, $caapT.Yr)(o, u[7])
            ],
            [
                -s[0],
                -s[1],
                -s[2],
                -(0, $caapT.Yr)(s, u[7])
            ]
        ], c, l);
    }
    intersectsFrustum(e1) {
        let t = !0, n = this.points.length, r = this.planes.length, i = e1.planes.length, a = e1.points.length;
        for(let r = 0; r < i; r++){
            let i = e1.planes[r], a = 0;
            for(let e1 = 0; e1 < n; e1++){
                let t = this.points[e1];
                i[0] * t[0] + i[1] * t[1] + i[2] * t[2] + i[3] >= 0 && a++;
            }
            if (a === 0) return 0;
            a < n && (t = !1);
        }
        if (t) return 2;
        for(let t = 0; t < r; t++){
            let n = this.planes[t], r = 0;
            for(let t = 0; t < a; t++){
                let i = e1.points[t];
                n[0] * i[0] + n[1] * i[1] + n[2] * i[2] + n[3] >= 0 && r++;
            }
            if (r === 0) return 0;
        }
        return 1;
    }
    intersectsPlane(e1) {
        let t = this.points.length, n = 0;
        for(let r = 0; r < t; r++){
            let t = this.points[r];
            e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3] >= 0 && n++;
        }
        return n === t ? 2 : n === 0 ? 0 : 1;
    }
};
function $902e455d852cdfb8$var$uc(e1, t, n) {
    let r = e1 - t;
    return r < 0 ? -r : Math.max(0, r - n);
}
function $902e455d852cdfb8$var$dc(e1, t, n, r, i) {
    let a = e1 - n, o;
    return o = a < 0 ? Math.min(-a, 1 + a - i) : a > i ? Math.min(Math.max(a - i, 0), 1 - a) : 0, Math.max(o, $902e455d852cdfb8$var$uc(t, r, i));
}
var $902e455d852cdfb8$var$fc = class {
    constructor(){
        this._boundingVolumeCache = new $902e455d852cdfb8$var$cc(this._computeTileBoundingVolume);
    }
    prepareNextFrame() {
        this._boundingVolumeCache.swapBuffers();
    }
    distanceToTile2d(e1, t, n, r) {
        let i = 1 << n.z, a = 1 / i, o = n.x / i, s = n.y / i, c = 0.5, l = 2;
        return l = Math.min(l, $902e455d852cdfb8$var$dc(e1, t, o, s, a)), l = Math.min(l, $902e455d852cdfb8$var$dc(e1, t, o + c, -s - a, a)), l = Math.min(l, $902e455d852cdfb8$var$dc(e1, t, o + c, 2 - s - a, a)), l;
    }
    getWrap(e1, t, n) {
        let r = 1 << t.z, i = 1 / r, a = t.x / r, o = $902e455d852cdfb8$var$uc(e1.x, a, i), s = $902e455d852cdfb8$var$uc(e1.x, a - 1, i), c = $902e455d852cdfb8$var$uc(e1.x, a + 1, i), l = Math.min(o, s, c);
        return l === c ? 1 : l === s ? -1 : 0;
    }
    allowVariableZoom(e1, t) {
        return $902e455d852cdfb8$var$Pa(e1, t) > 4;
    }
    allowWorldCopies() {
        return !1;
    }
    getTileBoundingVolume(e1, t, n, r) {
        return this._boundingVolumeCache.getTileBoundingVolume(e1, t, n, r);
    }
    _computeTileBoundingVolume(e1, n, i, a) {
        let o = 0, s = 0;
        if (a?.terrain) {
            let t = new (0, $caapT._)(e1.z, n, e1.z, e1.x, e1.y), r = a.terrain.getMinMaxElevation(t);
            o = r.minElevation ?? Math.min(0, i), s = r.maxElevation ?? Math.max(0, i);
        }
        if (o /= (0, $caapT.A), s /= (0, $caapT.A), o += 1, s += 1, e1.z <= 0) return $902e455d852cdfb8$var$lc.fromAabb([
            -s,
            -s,
            -s
        ], [
            s,
            s,
            s
        ]);
        if (e1.z === 1) return $902e455d852cdfb8$var$lc.fromAabb([
            e1.x === 0 ? -s : 0,
            e1.y === 0 ? 0 : -s,
            -s
        ], [
            e1.x === 0 ? 0 : s,
            e1.y === 0 ? s : 0,
            s
        ]);
        {
            let n = [
                $902e455d852cdfb8$var$Xs(0, 0, e1.x, e1.y, e1.z),
                $902e455d852cdfb8$var$Xs((0, $caapT.Pr), 0, e1.x, e1.y, e1.z),
                $902e455d852cdfb8$var$Xs((0, $caapT.Pr), (0, $caapT.Pr), e1.x, e1.y, e1.z),
                $902e455d852cdfb8$var$Xs(0, (0, $caapT.Pr), e1.x, e1.y, e1.z)
            ], r = [];
            for (let e1 of n)r.push((0, $caapT.ri)([], e1, s));
            if (s !== o) for (let e1 of n)r.push((0, $caapT.ri)([], e1, o));
            e1.y === 0 && r.push([
                0,
                1,
                0
            ]), e1.y === (1 << e1.z) - 1 && r.push([
                0,
                -1,
                0
            ]);
            let i = [
                1,
                1,
                1
            ], a = [
                -1,
                -1,
                -1
            ];
            for (let e1 of r)for(let t = 0; t < 3; t++)i[t] = Math.min(i[t], e1[t]), a[t] = Math.max(a[t], e1[t]);
            let c = $902e455d852cdfb8$var$Xs((0, $caapT.Pr) / 2, (0, $caapT.Pr) / 2, e1.x, e1.y, e1.z), l = (0, $caapT.Jr)([], [
                0,
                1,
                0
            ], c);
            (0, $caapT.$r)(l, l);
            let u = (0, $caapT.Jr)([], c, l);
            (0, $caapT.$r)(u, u);
            let d = (0, $caapT.Jr)([], n[2], n[1]);
            (0, $caapT.$r)(d, d);
            let f = (0, $caapT.Jr)([], n[0], n[3]);
            (0, $caapT.$r)(f, f), r.push((0, $caapT.ri)([], c, s)), e1.y >= (1 << e1.z) / 2 && r.push((0, $caapT.ri)([], $902e455d852cdfb8$var$Xs((0, $caapT.Pr) / 2, 0, e1.x, e1.y, e1.z), s)), e1.y < (1 << e1.z) / 2 && r.push((0, $caapT.ri)([], $902e455d852cdfb8$var$Xs((0, $caapT.Pr) / 2, (0, $caapT.Pr), e1.x, e1.y, e1.z), s));
            let p = $902e455d852cdfb8$var$pc(c, r), m = $902e455d852cdfb8$var$pc(u, r), h = [
                -c[0],
                -c[1],
                -c[2],
                p.max
            ], g = [
                c[0],
                c[1],
                c[2],
                -p.min
            ], _ = [
                -u[0],
                -u[1],
                -u[2],
                m.max
            ], v = [
                u[0],
                u[1],
                u[2],
                -m.min
            ], b = [
                ...d,
                0
            ], x = [
                ...f,
                0
            ], S = [];
            return e1.y === 0 ? S.push((0, $caapT.Dr)(x, b, h), (0, $caapT.Dr)(x, b, g)) : S.push((0, $caapT.Dr)(_, b, h), (0, $caapT.Dr)(_, b, g), (0, $caapT.Dr)(_, x, h), (0, $caapT.Dr)(_, x, g)), e1.y === (1 << e1.z) - 1 ? S.push((0, $caapT.Dr)(x, b, h), (0, $caapT.Dr)(x, b, g)) : S.push((0, $caapT.Dr)(v, b, h), (0, $caapT.Dr)(v, b, g), (0, $caapT.Dr)(v, x, h), (0, $caapT.Dr)(v, x, g)), new $902e455d852cdfb8$var$lc(S, [
                h,
                g,
                _,
                v,
                b,
                x
            ], i, a);
        }
    }
};
function $902e455d852cdfb8$var$pc(e1, t) {
    let n = 1 / 0, r = -1 / 0;
    for (let i of t){
        let t = (0, $caapT.Yr)(e1, i);
        n = Math.min(n, t), r = Math.max(r, t);
    }
    return {
        min: n,
        max: r
    };
}
var $902e455d852cdfb8$var$mc = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, n) {
        this._helper.interpolatePadding(e1, t, n);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t) {
        this._helper.resize(e1, t);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    setTransitionState(e1) {}
    constructor(e1){
        this._cachedClippingPlane = (0, $caapT.Hn)(), this._projectionMatrix = (0, $caapT.zn)(), this._globeViewProjMatrix32f = (0, $caapT.Rn)(), this._globeViewProjMatrixNoCorrection = (0, $caapT.zn)(), this._globeViewProjMatrixNoCorrectionInverted = (0, $caapT.zn)(), this._globeProjMatrixInverted = (0, $caapT.zn)(), this._cameraPosition = (0, $caapT.Vn)(), this._globeLatitudeErrorCorrectionRadians = 0, this.defaultConstrain = (e1, t)=>{
            let n = (0, $caapT.In)(e1.lat, -(0, $caapT.jn), (0, $caapT.jn)), r = (0, $caapT.In)(+t, this.minZoom + $902e455d852cdfb8$var$rc(0, n), this.maxZoom);
            return {
                center: new (0, $caapT.k)(e1.lng, n),
                zoom: r
            };
        }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $902e455d852cdfb8$var$vs({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._coveringTilesDetailsProvider = new $902e455d852cdfb8$var$fc;
    }
    clone() {
        let t = new e1;
        return t.apply(this, !1), t;
    }
    apply(e1, t, n) {
        this._globeLatitudeErrorCorrectionRadians = n || 0, this._helper.apply(e1, t);
    }
    get projectionMatrix() {
        return this._projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this._globeViewProjMatrixNoCorrection;
    }
    get inverseProjectionMatrix() {
        return this._globeProjMatrixInverted;
    }
    get cameraPosition() {
        let e1 = (0, $caapT.Vn)();
        return e1[0] = this._cameraPosition[0], e1[1] = this._cameraPosition[1], e1[2] = this._cameraPosition[2], e1;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    getProjectionData(e1) {
        let { overscaledTileID: t, applyGlobeMatrix: n } = e1, r = this._helper.getMercatorTileCoordinates(t);
        return {
            mainMatrix: this._globeViewProjMatrix32f,
            tileMercatorCoords: r,
            clippingPlane: this._cachedClippingPlane,
            projectionTransition: +!!n,
            fallbackMatrix: this._globeViewProjMatrix32f
        };
    }
    _computeClippingPlane(e1) {
        let t = this.pitchInRadians, n = this.cameraToCenterDistance / e1, r = Math.sin(t) * n, i = Math.cos(t) * n + 1, a = 1 / Math.sqrt(r * r + i * i) * 1, o = -r, s = i, c = Math.sqrt(o * o + s * s);
        o /= c, s /= c;
        let l = [
            0,
            o,
            s
        ];
        (0, $caapT.ni)(l, l, [
            0,
            0,
            0
        ], -this.bearingInRadians), (0, $caapT.ei)(l, l, [
            0,
            0,
            0
        ], -1 * this.center.lat * Math.PI / 180), (0, $caapT.ti)(l, l, [
            0,
            0,
            0
        ], this.center.lng * Math.PI / 180);
        let u = 1 / (0, $caapT.Zr)(l);
        return (0, $caapT.ri)(l, l, u), [
            ...l,
            -a * u
        ];
    }
    isLocationOccluded(e1) {
        return !this.isSurfacePointVisible($902e455d852cdfb8$var$Zs(e1));
    }
    transformLightDirection(e1) {
        let n = this._helper._center.lng * Math.PI / 180, r = this._helper._center.lat * Math.PI / 180, i = Math.cos(r), a = [
            Math.sin(n) * i,
            Math.sin(r),
            Math.cos(n) * i
        ], o = [
            a[2],
            0,
            -a[0]
        ], s = [
            0,
            0,
            0
        ];
        (0, $caapT.Jr)(s, o, a), (0, $caapT.$r)(o, o), (0, $caapT.$r)(s, s);
        let c = [
            o[0] * e1[0] + s[0] * e1[1] + a[0] * e1[2],
            o[1] * e1[0] + s[1] * e1[1] + a[1] * e1[2],
            o[2] * e1[0] + s[2] * e1[1] + a[2] * e1[2]
        ], l = [
            0,
            0,
            0
        ];
        return (0, $caapT.$r)(l, c), l;
    }
    getPixelScale() {
        return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
    }
    getCircleRadiusCorrection() {
        return Math.cos(this._helper._center.lat * Math.PI / 180);
    }
    getPitchedTextCorrection(e1, t, n) {
        let r = $902e455d852cdfb8$var$Ca(e1, t, n.canonical), i = $902e455d852cdfb8$var$Js(r.x, r.y);
        return this.getCircleRadiusCorrection() / Math.cos(i[1]);
    }
    projectTileCoordinates(e1, t, n, i) {
        let a = n.canonical, o = $902e455d852cdfb8$var$Xs(e1, t, a.x, a.y, a.z), s = 1 + (i ? i(e1, t) : 0) / (0, $caapT.A), c = [
            o[0] * s,
            o[1] * s,
            o[2] * s,
            1
        ];
        (0, $caapT.Gr)(c, c, this._globeViewProjMatrixNoCorrection);
        let l = this._cachedClippingPlane, u = l[0] * o[0] + l[1] * o[1] + l[2] * o[2] + l[3] < 0;
        return {
            point: new (0, $caapT.ji)(c[0] / c[3], c[1] / c[3]),
            signedDistanceFromCamera: c[3],
            isOccluded: u
        };
    }
    _calcMatrices() {
        if (!this._helper._width || !this._helper._height) return;
        let e1 = $902e455d852cdfb8$var$Qs(this.worldSize, this.center.lat), t = (0, $caapT.Bn)(), n = (0, $caapT.Bn)();
        this._helper.autoCalculateNearFarZ && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + e1 * 2), (0, $caapT.bi)(t, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
        let r = this.centerOffset;
        t[8] = -r.x * 2 / this._helper._width, t[9] = r.y * 2 / this._helper._height, this._projectionMatrix = (0, $caapT.ui)(t), this._globeProjMatrixInverted = (0, $caapT.Bn)(), (0, $caapT._i)(this._globeProjMatrixInverted, t), (0, $caapT.Ti)(t, t, [
            0,
            0,
            -this.cameraToCenterDistance
        ]), (0, $caapT.Ci)(t, t, this.rollInRadians), (0, $caapT.xi)(t, t, -this.pitchInRadians), (0, $caapT.Ci)(t, t, this.bearingInRadians), (0, $caapT.Ti)(t, t, [
            0,
            0,
            -e1
        ]);
        let i = (0, $caapT.Vn)();
        i[0] = e1, i[1] = e1, i[2] = e1, (0, $caapT.xi)(n, t, this.center.lat * Math.PI / 180), (0, $caapT.Si)(n, n, -this.center.lng * Math.PI / 180), (0, $caapT.wi)(n, n, i), this._globeViewProjMatrixNoCorrection = n, (0, $caapT.xi)(t, t, this.center.lat * Math.PI / 180 - this._globeLatitudeErrorCorrectionRadians), (0, $caapT.Si)(t, t, -this.center.lng * Math.PI / 180), (0, $caapT.wi)(t, t, i), this._globeViewProjMatrix32f = new Float32Array(t), this._globeViewProjMatrixNoCorrectionInverted = (0, $caapT.Bn)(), (0, $caapT._i)(this._globeViewProjMatrixNoCorrectionInverted, n);
        let a = (0, $caapT.Vn)();
        this._cameraPosition = (0, $caapT.Vn)(), this._cameraPosition[2] = this.cameraToCenterDistance / e1, (0, $caapT.ni)(this._cameraPosition, this._cameraPosition, a, -this.rollInRadians), (0, $caapT.ei)(this._cameraPosition, this._cameraPosition, a, this.pitchInRadians), (0, $caapT.ni)(this._cameraPosition, this._cameraPosition, a, -this.bearingInRadians), (0, $caapT.Kr)(this._cameraPosition, this._cameraPosition, [
            0,
            0,
            1
        ]), (0, $caapT.ei)(this._cameraPosition, this._cameraPosition, a, -this.center.lat * Math.PI / 180), (0, $caapT.ti)(this._cameraPosition, this._cameraPosition, a, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(e1);
        let o = (0, $caapT.ui)(this._globeViewProjMatrixNoCorrectionInverted);
        (0, $caapT.wi)(o, o, [
            1,
            1,
            -1
        ]), this._cachedFrustum = $902e455d852cdfb8$var$xs.fromInvProjectionMatrix(o, 1, 0, this._cachedClippingPlane, !0);
    }
    calculateFogMatrix(e1) {
        (0, $caapT.Ar)(`calculateFogMatrix is not supported on globe projection.`);
        let t = (0, $caapT.Bn)();
        return (0, $caapT.gi)(t), t;
    }
    getVisibleUnwrappedCoordinates(e1) {
        return [
            new (0, $caapT.v)(0, e1)
        ];
    }
    getCameraFrustum() {
        return this._cachedFrustum;
    }
    getClippingPlane() {
        return this._cachedClippingPlane;
    }
    getCoveringTilesDetailsProvider() {
        return this._coveringTilesDetailsProvider;
    }
    recalculateZoomAndCenter(e1) {
        if (e1) {
            (0, $caapT.Ar)(`terrain is not fully supported on vertical perspective projection.`);
            return;
        }
        this._helper.recalculateZoomAndCenter(0);
    }
    maxPitchScaleFactor() {
        return 1;
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return this._helper.getCameraAltitude();
    }
    getCameraLngLat() {
        return this._helper.getCameraLngLat();
    }
    lngLatToCameraDepth(e1, t) {
        if (!this._globeViewProjMatrixNoCorrection) return 1;
        let n = $902e455d852cdfb8$var$Zs(e1);
        (0, $caapT.ri)(n, n, 1 + t / (0, $caapT.A));
        let i = (0, $caapT.Hn)();
        return (0, $caapT.Gr)(i, [
            n[0],
            n[1],
            n[2],
            1
        ], this._globeViewProjMatrixNoCorrection), i[2] / i[3];
    }
    populateCache(e1) {}
    getBounds() {
        let e1 = this.width * .5, t = this.height * .5, n = [
            new (0, $caapT.ji)(0, 0),
            new (0, $caapT.ji)(e1, 0),
            new (0, $caapT.ji)(this.width, 0),
            new (0, $caapT.ji)(this.width, t),
            new (0, $caapT.ji)(this.width, this.height),
            new (0, $caapT.ji)(e1, this.height),
            new (0, $caapT.ji)(0, this.height),
            new (0, $caapT.ji)(0, t)
        ], r = [];
        for (let e1 of n)r.push(this.unprojectScreenPoint(e1));
        let i = 0, a = 0, o = 0, s = 0, c = this.center;
        for (let e1 of r){
            let t = (0, $caapT.Kn)(c.lng, e1.lng), n = (0, $caapT.Kn)(c.lat, e1.lat);
            t < a && (a = t), t > i && (i = t), n < s && (s = n), n > o && (o = n);
        }
        let l = [
            c.lng + a,
            c.lat + s,
            c.lng + i,
            c.lat + o
        ];
        return this.isSurfacePointOnScreen([
            0,
            1,
            0
        ]) && (l[3] = 90, l[0] = -180, l[2] = 180), this.isSurfacePointOnScreen([
            0,
            -1,
            0
        ]) && (l[1] = -90, l[0] = -180, l[2] = 180), new $902e455d852cdfb8$export$266d2884f61535d3(l);
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
    }
    setLocationAtPoint(e1, t) {
        let n = $902e455d852cdfb8$var$Zs(this.unprojectScreenPoint(t)), r = $902e455d852cdfb8$var$Zs(e1), i = (0, $caapT.Vn)();
        (0, $caapT.li)(i);
        let a = (0, $caapT.Vn)();
        (0, $caapT.ti)(a, n, i, -this.center.lng * Math.PI / 180), (0, $caapT.ei)(a, a, i, this.center.lat * Math.PI / 180);
        let o = r[0] * r[0] + r[2] * r[2], s = a[0] * a[0];
        if (o < s) return;
        let c = Math.sqrt(o - s), l = -c, u = (0, $caapT.Mn)(r[0], r[2], a[0], c), d = (0, $caapT.Mn)(r[0], r[2], a[0], l), f = (0, $caapT.Vn)();
        (0, $caapT.ti)(f, r, i, -u);
        let p = (0, $caapT.Mn)(f[1], f[2], a[1], a[2]), m = (0, $caapT.Vn)();
        (0, $caapT.ti)(m, r, i, -d);
        let h = (0, $caapT.Mn)(m[1], m[2], a[1], a[2]), g = Math.PI * .5, _ = p >= -g && p <= g, v = h >= -g && h <= g, y, b;
        if (_ && v) {
            let e1 = this.center.lng * Math.PI / 180, t = this.center.lat * Math.PI / 180, n = (0, $caapT.qn)(u, e1), r = (0, $caapT.qn)(p, t), i = (0, $caapT.qn)(d, e1), a = (0, $caapT.qn)(h, t);
            n + r < i + a ? (y = u, b = p) : (y = d, b = h);
        } else if (_) y = u, b = p;
        else if (v) y = d, b = h;
        else return;
        let x = y / Math.PI * 180, S = b / Math.PI * 180, C = this.center.lat;
        this.setCenter(new (0, $caapT.k)(x, (0, $caapT.In)(S, -90, 90))), this.setZoom(this.zoom + $902e455d852cdfb8$var$rc(C, this.center.lat));
    }
    locationToScreenPoint(e1, t) {
        let n = $902e455d852cdfb8$var$Zs(e1);
        return t && (0, $caapT.ri)(n, n, 1 + t.getElevationForLngLatZoom(e1, this._helper._tileZoom) / (0, $caapT.A)), this._projectSurfacePointToScreen(n);
    }
    _projectSurfacePointToScreen(e1) {
        let t = (0, $caapT.Hn)();
        return (0, $caapT.Gr)(t, [
            ...e1,
            1
        ], this._globeViewProjMatrixNoCorrection), t[0] /= t[3], t[1] /= t[3], new (0, $caapT.ji)((t[0] * .5 + .5) * this.width, (-t[1] * .5 + .5) * this.height);
    }
    screenPointToMercatorCoordinate(e1, t) {
        if (t) {
            let n = t.pointCoordinate(e1);
            if (n) return n;
        }
        return (0, $caapT.S).fromLngLat(this.unprojectScreenPoint(e1));
    }
    screenPointToLocation(e1, t) {
        return this.screenPointToMercatorCoordinate(e1, t)?.toLngLat();
    }
    isPointOnMapSurface(e1, t) {
        let n = this._cameraPosition, r = this.getRayDirectionFromPixel(e1);
        return !!this.rayPlanetIntersection(n, r);
    }
    getRayDirectionFromPixel(e1) {
        let n = (0, $caapT.Hn)();
        n[0] = e1.x / this.width * 2 - 1, n[1] = (e1.y / this.height * 2 - 1) * -1, n[2] = 1, n[3] = 1, (0, $caapT.Gr)(n, n, this._globeViewProjMatrixNoCorrectionInverted), n[0] /= n[3], n[1] /= n[3], n[2] /= n[3];
        let r = (0, $caapT.Vn)();
        r[0] = n[0] - this._cameraPosition[0], r[1] = n[1] - this._cameraPosition[1], r[2] = n[2] - this._cameraPosition[2];
        let i = (0, $caapT.Vn)();
        return (0, $caapT.$r)(i, r), i;
    }
    isSurfacePointVisible(e1) {
        let t = this._cachedClippingPlane;
        return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2] + t[3] >= 0;
    }
    isSurfacePointOnScreen(e1) {
        if (!this.isSurfacePointVisible(e1)) return !1;
        let t = (0, $caapT.Hn)();
        return (0, $caapT.Gr)(t, [
            ...e1,
            1
        ], this._globeViewProjMatrixNoCorrection), t[0] /= t[3], t[1] /= t[3], t[2] /= t[3], t[0] > -1 && t[0] < 1 && t[1] > -1 && t[1] < 1 && t[2] > -1 && t[2] < 1;
    }
    rayPlanetIntersection(e1, t) {
        let n = (0, $caapT.Yr)(e1, t), r = (0, $caapT.Vn)(), i = (0, $caapT.Vn)();
        (0, $caapT.ri)(i, t, n), (0, $caapT.ai)(r, e1, i);
        let a = 1 - (0, $caapT.Yr)(r, r);
        if (a < 0) return null;
        let o = (0, $caapT.Yr)(e1, e1) - 1, s = -n + (n < 0 ? 1 : -1) * Math.sqrt(a), c = o / s, l = s;
        return {
            tMin: Math.min(c, l),
            tMax: Math.max(c, l)
        };
    }
    unprojectScreenPoint(e1) {
        let n = this._cameraPosition, r = this.getRayDirectionFromPixel(e1), i = this.rayPlanetIntersection(n, r);
        if (i) {
            let e1 = (0, $caapT.Vn)();
            (0, $caapT.Kr)(e1, n, [
                r[0] * i.tMin,
                r[1] * i.tMin,
                r[2] * i.tMin
            ]);
            let a = (0, $caapT.Vn)();
            return (0, $caapT.$r)(a, e1), $902e455d852cdfb8$var$$s(a);
        }
        let a = this._cachedClippingPlane, o = a[0] * r[0] + a[1] * r[1] + a[2] * r[2], s = -(0, $caapT._r)(a, n) / o, c = (0, $caapT.Vn)();
        if (s > 0) (0, $caapT.Kr)(c, n, [
            r[0] * s,
            r[1] * s,
            r[2] * s
        ]);
        else {
            let e1 = (0, $caapT.Vn)();
            (0, $caapT.Kr)(e1, n, [
                r[0] * 2,
                r[1] * 2,
                r[2] * 2
            ]);
            let t = (0, $caapT._r)(this._cachedClippingPlane, e1);
            (0, $caapT.ai)(c, e1, [
                this._cachedClippingPlane[0] * t,
                this._cachedClippingPlane[1] * t,
                this._cachedClippingPlane[2] * t
            ]);
        }
        let l = $902e455d852cdfb8$var$ec(a);
        return $902e455d852cdfb8$var$$s($902e455d852cdfb8$var$tc(l.center, l.radius, c));
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = this.getProjectionData({
            overscaledTileID: new (0, $caapT._)(0, 0, 0, 0, 0),
            applyGlobeMatrix: e1
        });
        return t.tileMercatorCoords = [
            0,
            0,
            1,
            1
        ], t;
    }
    getFastPathSimpleProjectionMatrix(e1) {}
}, $902e455d852cdfb8$var$hc = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, n) {
        this._helper.interpolatePadding(e1, t, n);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t, n = !0) {
        this._helper.resize(e1, t, n);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    get isGlobeRendering() {
        return this._globeness > 0;
    }
    setTransitionState(e1, t) {
        this._globeness = e1, this._globeLatitudeErrorCorrectionRadians = t, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().prepareNextFrame(), this._mercatorTransform.getCoveringTilesDetailsProvider().prepareNextFrame();
    }
    get currentTransform() {
        return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
    }
    constructor(e1){
        this._globeLatitudeErrorCorrectionRadians = 0, this._globeness = 1, this.defaultConstrain = (e1, t)=>this.currentTransform.defaultConstrain(e1, t), this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $902e455d852cdfb8$var$vs({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._globeness = 1, this._mercatorTransform = new $902e455d852cdfb8$var$Es, this._verticalPerspectiveTransform = new $902e455d852cdfb8$var$mc;
    }
    clone() {
        let t = new e1;
        return t._globeness = this._globeness, t._globeLatitudeErrorCorrectionRadians = this._globeLatitudeErrorCorrectionRadians, t.apply(this, !1), t;
    }
    apply(e1, t) {
        this._helper.apply(e1, t), this._mercatorTransform.apply(this, !1), this._verticalPerspectiveTransform.apply(this, !1, this._globeLatitudeErrorCorrectionRadians);
    }
    get projectionMatrix() {
        return this.currentTransform.projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this.currentTransform.modelViewProjectionMatrix;
    }
    get inverseProjectionMatrix() {
        return this.currentTransform.inverseProjectionMatrix;
    }
    get cameraPosition() {
        return this.currentTransform.cameraPosition;
    }
    getProjectionData(e1) {
        let t = this._mercatorTransform.getProjectionData(e1), n = this._verticalPerspectiveTransform.getProjectionData(e1);
        return {
            mainMatrix: this.isGlobeRendering ? n.mainMatrix : t.mainMatrix,
            clippingPlane: n.clippingPlane,
            tileMercatorCoords: n.tileMercatorCoords,
            projectionTransition: e1.applyGlobeMatrix ? this._globeness : 0,
            fallbackMatrix: t.fallbackMatrix
        };
    }
    isLocationOccluded(e1) {
        return this.currentTransform.isLocationOccluded(e1);
    }
    transformLightDirection(e1) {
        return this.currentTransform.transformLightDirection(e1);
    }
    getPixelScale() {
        return (0, $caapT.dr)(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
    }
    getCircleRadiusCorrection() {
        return (0, $caapT.dr)(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
    }
    getPitchedTextCorrection(e1, t, n) {
        return (0, $caapT.dr)(this._mercatorTransform.getPitchedTextCorrection(e1, t, n), this._verticalPerspectiveTransform.getPitchedTextCorrection(e1, t, n), this._globeness);
    }
    projectTileCoordinates(e1, t, n, r) {
        return this.currentTransform.projectTileCoordinates(e1, t, n, r);
    }
    _calcMatrices() {
        !this._helper._width || !this._helper._height || (this._verticalPerspectiveTransform.apply(this, !1, this._globeLatitudeErrorCorrectionRadians), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, !0, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
    }
    calculateFogMatrix(e1) {
        return this.currentTransform.calculateFogMatrix(e1);
    }
    getVisibleUnwrappedCoordinates(e1) {
        return this.currentTransform.getVisibleUnwrappedCoordinates(e1);
    }
    getCameraFrustum() {
        return this.currentTransform.getCameraFrustum();
    }
    getClippingPlane() {
        return this.currentTransform.getClippingPlane();
    }
    getCoveringTilesDetailsProvider() {
        return this.currentTransform.getCoveringTilesDetailsProvider();
    }
    recalculateZoomAndCenter(e1) {
        this.currentTransform.recalculateZoomAndCenter(e1);
    }
    maxPitchScaleFactor() {
        return this._mercatorTransform.maxPitchScaleFactor();
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return this._helper.getCameraAltitude();
    }
    getCameraLngLat() {
        return this._helper.getCameraLngLat();
    }
    lngLatToCameraDepth(e1, t) {
        return this.currentTransform.lngLatToCameraDepth(e1, t);
    }
    populateCache(e1) {
        this._mercatorTransform.populateCache(e1), this._verticalPerspectiveTransform.populateCache(e1);
    }
    getBounds() {
        return this.currentTransform.getBounds();
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
    }
    setLocationAtPoint(e1, t) {
        if (!this.isGlobeRendering) {
            this._mercatorTransform.setLocationAtPoint(e1, t), this.apply(this._mercatorTransform, !1);
            return;
        }
        this._verticalPerspectiveTransform.setLocationAtPoint(e1, t), this.apply(this._verticalPerspectiveTransform, !1);
    }
    locationToScreenPoint(e1, t) {
        return this.currentTransform.locationToScreenPoint(e1, t);
    }
    screenPointToMercatorCoordinate(e1, t) {
        return this.currentTransform.screenPointToMercatorCoordinate(e1, t);
    }
    screenPointToLocation(e1, t) {
        return this.currentTransform.screenPointToLocation(e1, t);
    }
    isPointOnMapSurface(e1, t) {
        return this.currentTransform.isPointOnMapSurface(e1, t);
    }
    getRayDirectionFromPixel(e1) {
        return this._verticalPerspectiveTransform.getRayDirectionFromPixel(e1);
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = this._mercatorTransform.getProjectionDataForCustomLayer(e1);
        if (!this.isGlobeRendering) return t;
        let n = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(e1);
        return n.fallbackMatrix = t.mainMatrix, n;
    }
    getFastPathSimpleProjectionMatrix(e1) {
        return this.currentTransform.getFastPathSimpleProjectionMatrix(e1);
    }
}, $902e455d852cdfb8$var$gc = class e1 {
    get useGlobeControls() {
        return !0;
    }
    handlePanInertia(e1, t) {
        let n = $902e455d852cdfb8$var$ac(e1, t);
        return Math.abs(n.lng - t.center.lng) > 180 && (n.lng = t.center.lng + 179.5 * Math.sign(n.lng - t.center.lng)), {
            easingCenter: n,
            easingOffset: new (0, $caapT.ji)(0, 0)
        };
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        let n = e1.around, r = t.screenPointToLocation(n);
        e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta);
        let i = t.zoom;
        e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
        let a = t.zoom - i;
        if (a === 0) return;
        let o = (0, $caapT.Kn)(t.center.lng, r.lng), s = o / (Math.abs(o / 180) + 1), c = (0, $caapT.Kn)(t.center.lat, r.lat), l = t.getRayDirectionFromPixel(n), u = t.cameraPosition, d = (0, $caapT.Yr)(u, l) * -1, f = (0, $caapT.Vn)();
        (0, $caapT.Kr)(f, u, [
            l[0] * d,
            l[1] * d,
            l[2] * d
        ]);
        let p = (0, $caapT.Zr)(f) - 1, m = Math.exp(-Math.max(p - .3, 0) * .5), h = $902e455d852cdfb8$var$Qs(t.worldSize, t.center.lat) / Math.min(t.width, t.height), g = (0, $caapT.xr)(h, .9, .5, 1, .25), _ = (1 - (0, $caapT.Mr)(-a)) * Math.min(m, g), v = t.center.lat, y = t.zoom, b = new (0, $caapT.k)(t.center.lng + s * _, (0, $caapT.In)(t.center.lat + c * _, -(0, $caapT.jn), (0, $caapT.jn)));
        t.setLocationAtPoint(r, n);
        let x = t.center, S = (0, $caapT.xr)(Math.abs(o), 45, 85, 0, 1), C = (0, $caapT.xr)(h, .75, .35, 0, 1), w = Math.max(S, C) ** .25, T = (0, $caapT.Kn)(x.lng, b.lng), ee = (0, $caapT.Kn)(x.lat, b.lat);
        t.setCenter(new (0, $caapT.k)(x.lng + T * w, x.lat + ee * w).wrap()), t.setZoom(y + $902e455d852cdfb8$var$rc(v, t.center.lat));
    }
    handleMapControlsPan(e1, t, n) {
        if (!e1.panDelta) return;
        let r = t.center.lat, i = t.zoom;
        t.setCenter($902e455d852cdfb8$var$ac(e1.panDelta, t).wrap()), t.setZoom(i + $902e455d852cdfb8$var$rc(r, t.center.lat));
    }
    cameraForBoxAndBearing(t, n, r, i, a) {
        let o = $902e455d852cdfb8$var$ks(t, n, r, i, a), s = n.left / a.width * 2 - 1, c = (a.width - n.right) / a.width * 2 - 1, l = n.top / a.height * -2 + 1, u = (a.height - n.bottom) / a.height * -2 + 1, d = (0, $caapT.Kn)(r.getWest(), r.getEast()) < 0, f = d ? r.getEast() : r.getWest(), p = d ? r.getWest() : r.getEast(), m = Math.max(r.getNorth(), r.getSouth()), h = Math.min(r.getNorth(), r.getSouth()), g = f + (0, $caapT.Kn)(f, p) * .5, _ = m + (0, $caapT.Kn)(m, h) * .5, v = a.clone();
        v.setCenter(o.center), v.setBearing(o.bearing), v.setPitch(0), v.setRoll(0), v.setZoom(o.zoom);
        let y = v.modelViewProjectionMatrix, b = [
            $902e455d852cdfb8$var$Zs(r.getNorthWest()),
            $902e455d852cdfb8$var$Zs(r.getNorthEast()),
            $902e455d852cdfb8$var$Zs(r.getSouthWest()),
            $902e455d852cdfb8$var$Zs(r.getSouthEast()),
            $902e455d852cdfb8$var$Zs(new (0, $caapT.k)(p, _)),
            $902e455d852cdfb8$var$Zs(new (0, $caapT.k)(f, _)),
            $902e455d852cdfb8$var$Zs(new (0, $caapT.k)(g, m)),
            $902e455d852cdfb8$var$Zs(new (0, $caapT.k)(g, h))
        ], x = $902e455d852cdfb8$var$Zs(o.center), S = 1 / 0;
        for (let t of b)s < 0 && (S = e1.getLesserNonNegativeNonNull(S, e1.solveVectorScale(t, x, y, `x`, s))), c > 0 && (S = e1.getLesserNonNegativeNonNull(S, e1.solveVectorScale(t, x, y, `x`, c))), l > 0 && (S = e1.getLesserNonNegativeNonNull(S, e1.solveVectorScale(t, x, y, `y`, l))), u < 0 && (S = e1.getLesserNonNegativeNonNull(S, e1.solveVectorScale(t, x, y, `y`, u)));
        if (!Number.isFinite(S) || S === 0) {
            $902e455d852cdfb8$var$Ds();
            return;
        }
        return o.zoom = Math.min(v.zoom + (0, $caapT.wr)(S), t.maxZoom), o;
    }
    handleJumpToCenterZoom(e1, t) {
        let n = e1.center.lat, r = e1.applyConstrain(t.center ? (0, $caapT.k).convert(t.center) : e1.center, e1.zoom).center;
        e1.setCenter(r.wrap());
        let i = t.zoom === void 0 ? e1.zoom + $902e455d852cdfb8$var$rc(n, r.lat) : +t.zoom;
        e1.zoom !== i && e1.setZoom(i);
    }
    handleEaseTo(e1, t) {
        let n = e1.zoom, r = e1.center, i = e1.padding, o = {
            roll: e1.roll,
            pitch: e1.pitch,
            bearing: e1.bearing
        }, s = {
            roll: t.roll === void 0 ? e1.roll : t.roll,
            pitch: t.pitch === void 0 ? e1.pitch : t.pitch,
            bearing: t.bearing === void 0 ? e1.bearing : t.bearing
        }, c = t.zoom !== void 0, l = !e1.isPaddingEqual(t.padding), u = !1, d = t.center ? (0, $caapT.k).convert(t.center) : r, f = e1.applyConstrain(d, n).center;
        $902e455d852cdfb8$var$gs(e1, f);
        let p = e1.clone();
        p.setCenter(f), p.setZoom(c ? +t.zoom : n + $902e455d852cdfb8$var$rc(r.lat, d.lat)), p.setBearing(t.bearing);
        let m = new (0, $caapT.ji)((0, $caapT.In)(e1.centerPoint.x + t.offsetAsPoint.x, 0, e1.width), (0, $caapT.In)(e1.centerPoint.y + t.offsetAsPoint.y, 0, e1.height));
        p.setLocationAtPoint(f, m);
        let h = (t.offset && t.offsetAsPoint.mag()) > 0 ? p.center : f, g = c ? +t.zoom : n + $902e455d852cdfb8$var$rc(r.lat, h.lat), _ = n + $902e455d852cdfb8$var$rc(r.lat, 0), v = g + $902e455d852cdfb8$var$rc(h.lat, 0), y = (0, $caapT.Kn)(r.lng, h.lng), b = (0, $caapT.Kn)(r.lat, h.lat), x = (0, $caapT.Mr)(v - _);
        return u = g !== n, {
            easeFunc: (n)=>{
                if ((0, $caapT.Sr)(o, s) || $902e455d852cdfb8$var$Os({
                    startEulerAngles: o,
                    endEulerAngles: s,
                    tr: e1,
                    k: n,
                    useSlerp: o.roll != s.roll
                }), l && e1.interpolatePadding(i, t.padding, n), t.around) (0, $caapT.Ar)(`Easing around a point is not supported under globe projection.`), e1.setLocationAtPoint(t.around, t.aroundPoint);
                else {
                    let t = n * (v > _ ? Math.min(2, x) : Math.max(.5, x)) ** (1 - n), i = $902e455d852cdfb8$var$sc(r, y, b, t);
                    e1.setCenter(i.wrap());
                }
                if (u) {
                    let t = (0, $caapT.un).number(_, v, n) + $902e455d852cdfb8$var$rc(0, e1.center.lat);
                    e1.setZoom(t);
                }
            },
            isZooming: u,
            elevationCenter: h
        };
    }
    handleFlyTo(e1, t) {
        let n = t.zoom !== void 0, r = e1.center, i = e1.zoom, a = e1.padding, o = !e1.isPaddingEqual(t.padding), s = e1.applyConstrain((0, $caapT.k).convert(t.center || t.locationAtOffset), i).center, c = n ? +t.zoom : e1.zoom + $902e455d852cdfb8$var$rc(e1.center.lat, s.lat), l = e1.clone();
        l.setCenter(s), l.setZoom(c), l.setBearing(t.bearing);
        let u = new (0, $caapT.ji)((0, $caapT.In)(e1.centerPoint.x + t.offsetAsPoint.x, 0, e1.width), (0, $caapT.In)(e1.centerPoint.y + t.offsetAsPoint.y, 0, e1.height));
        l.setLocationAtPoint(s, u);
        let d = l.center;
        $902e455d852cdfb8$var$gs(e1, d);
        let f = $902e455d852cdfb8$var$qs(e1, r, d), p = i + $902e455d852cdfb8$var$rc(r.lat, 0), m = c + $902e455d852cdfb8$var$rc(d.lat, 0), h = (0, $caapT.Mr)(m - p), g = typeof t.minZoom == `number` ? +t.minZoom : e1.minZoom, _ = Math.max(g, e1.minZoom) + $902e455d852cdfb8$var$rc(d.lat, 0), v = Math.min(_, p, m) + $902e455d852cdfb8$var$rc(0, d.lat), y = (0, $caapT.Mr)(e1.applyConstrain(d, v).zoom + $902e455d852cdfb8$var$rc(d.lat, 0) - p), b = (0, $caapT.Kn)(r.lng, d.lng), x = (0, $caapT.Kn)(r.lat, d.lat);
        return {
            easeFunc: (n, i, s, l)=>{
                let u = $902e455d852cdfb8$var$sc(r, b, x, s);
                o && e1.interpolatePadding(a, t.padding, n);
                let f = n === 1 ? d : u;
                e1.setCenter(f.wrap());
                let m = p + (0, $caapT.wr)(i);
                e1.setZoom(n === 1 ? c : m + $902e455d852cdfb8$var$rc(0, f.lat));
            },
            scaleOfZoom: h,
            targetCenter: d,
            scaleOfMinZoom: y,
            pixelPathLength: f
        };
    }
    static solveVectorScale(e1, t, n, r, i) {
        let a = i, o = r === `x` ? [
            n[0],
            n[4],
            n[8],
            n[12]
        ] : [
            n[1],
            n[5],
            n[9],
            n[13]
        ], s = [
            n[3],
            n[7],
            n[11],
            n[15]
        ], c = e1[0] * o[0] + e1[1] * o[1] + e1[2] * o[2], l = e1[0] * s[0] + e1[1] * s[1] + e1[2] * s[2], u = t[0] * o[0] + t[1] * o[1] + t[2] * o[2], d = t[0] * s[0] + t[1] * s[1] + t[2] * s[2], f = (u + o[3] - a * d - a * s[3]) / (u - c - a * d + a * l);
        return u + a * l === c + a * d || s[3] * (c - u) + o[3] * (d - l) + c * d === u * l ? null : f;
    }
    static getLesserNonNegativeNonNull(e1, t) {
        return t !== null && t >= 0 && t < e1 ? t : e1;
    }
}, $902e455d852cdfb8$var$_c = class {
    constructor(e1){
        this._globe = e1, this._mercatorCameraHelper = new $902e455d852cdfb8$var$As, this._verticalPerspectiveCameraHelper = new $902e455d852cdfb8$var$gc;
    }
    get useGlobeControls() {
        return this._globe.useGlobeRendering;
    }
    get currentHelper() {
        return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
    }
    handlePanInertia(e1, t) {
        return this.currentHelper.handlePanInertia(e1, t);
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        this.currentHelper.handleMapControlsRollPitchBearingZoom(e1, t);
    }
    handleMapControlsPan(e1, t, n) {
        this.currentHelper.handleMapControlsPan(e1, t, n);
    }
    cameraForBoxAndBearing(e1, t, n, r, i) {
        return this.currentHelper.cameraForBoxAndBearing(e1, t, n, r, i);
    }
    handleJumpToCenterZoom(e1, t) {
        this.currentHelper.handleJumpToCenterZoom(e1, t);
    }
    handleEaseTo(e1, t) {
        return this.currentHelper.handleEaseTo(e1, t);
    }
    handleFlyTo(e1, t) {
        return this.currentHelper.handleFlyTo(e1, t);
    }
};
function $902e455d852cdfb8$var$vc(e1, t) {
    let n = {
        constrainOverride: t
    };
    if (Array.isArray(e1)) {
        let t = new $902e455d852cdfb8$var$Gs({
            type: e1
        });
        return {
            projection: t,
            transform: new $902e455d852cdfb8$var$hc(n),
            cameraHelper: new $902e455d852cdfb8$var$_c(t)
        };
    }
    switch(e1){
        case `mercator`:
            return {
                projection: new $902e455d852cdfb8$var$ms,
                transform: new $902e455d852cdfb8$var$Es(n),
                cameraHelper: new $902e455d852cdfb8$var$As
            };
        case `globe`:
            {
                let e1 = new $902e455d852cdfb8$var$Gs({
                    type: [
                        `interpolate`,
                        [
                            `linear`
                        ],
                        [
                            `zoom`
                        ],
                        11,
                        `vertical-perspective`,
                        12,
                        `mercator`
                    ]
                });
                return {
                    projection: e1,
                    transform: new $902e455d852cdfb8$var$hc(n),
                    cameraHelper: new $902e455d852cdfb8$var$_c(e1)
                };
            }
        case `vertical-perspective`:
            return {
                projection: new $902e455d852cdfb8$var$Ws,
                transform: new $902e455d852cdfb8$var$mc(n),
                cameraHelper: new $902e455d852cdfb8$var$gc
            };
        default:
            return (0, $caapT.Ar)(`Unknown projection name: ${e1}. Falling back to mercator projection.`), {
                projection: new $902e455d852cdfb8$var$ms,
                transform: new $902e455d852cdfb8$var$Es(n),
                cameraHelper: new $902e455d852cdfb8$var$As
            };
    }
}
const $902e455d852cdfb8$var$yc = (0, $caapT.sn)();
var $902e455d852cdfb8$export$d9e45bc13d335801 = class extends (0, $caapT.mn) {
    constructor(e1, t = {}){
        super(), this._rtlPluginLoaded = ()=>{
            for(let e1 in this.tileManagers){
                let t = this.tileManagers[e1].getSource().type;
                (t === `vector` || t === `geojson`) && this.tileManagers[e1].reload();
            }
        }, this.map = e1, this.dispatcher = new $902e455d852cdfb8$var$wi($902e455d852cdfb8$var$xi(), e1._getMapId()), this.dispatcher.registerMessageHandler(`GG`, (e1, t)=>this.getGlyphs(e1, t)), this.dispatcher.registerMessageHandler(`GI`, (e1, t)=>this.getImages(e1, t)), this.dispatcher.registerMessageHandler(`GDA`, (e1, t)=>this.getDashes(e1, t)), this.imageManager = new $902e455d852cdfb8$var$Yr, this.imageManager.setEventedParent(this), this.imageManager.setMissingImageResolver(e1._missingStyleImageResolver);
        let n = e1._container?.lang || typeof document < `u` && document.documentElement?.lang || void 0;
        this.glyphManager = new $902e455d852cdfb8$var$ri(e1._requestManager, t.localIdeographFontFamily, n), this.lineAtlas = new $902e455d852cdfb8$var$ui(256, 512), this.crossTileSymbolIndex = new $902e455d852cdfb8$var$$o, this._setInitialValues(), this._resetUpdates(), this.dispatcher.broadcast(`SR`, (0, $caapT.yn)()), $902e455d852cdfb8$var$va().on($902e455d852cdfb8$var$ha, this._rtlPluginLoaded), this.on(`data`, (e1)=>{
            if (e1.dataType !== `source` || e1.sourceDataType !== `metadata`) return;
            let t = this.tileManagers[e1.sourceId];
            if (!t) return;
            let n = t.getSource();
            if (n?.vectorLayerIds) for(let e1 in this._layers){
                let t = this._layers[e1];
                t.source === n.id && this._validateLayer(t);
            }
        });
    }
    _setInitialValues() {
        this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.tileManagers = {}, this.zoomHistory = new (0, $caapT.Jt), this._availableImages = [], this._imagesListDirty = !1, this._globalState = {}, this._serializedLayers = {}, this.stylesheet = null, this.light = null, this.sky = null, this.projection && (this.projection.destroy(), delete this.projection), this._loaded = !1, this._changed = !1, this._updatedLayers = {}, this._updatedSources = {}, this._changedImages = {}, this._glyphsDidChange = !1, this._updatedPaintProps = {}, this._layerOrderChanged = !1, this.crossTileSymbolIndex = new (this.crossTileSymbolIndex?.constructor || Object), this.pauseablePlacement = void 0, this.placement = void 0, this.z = 0;
    }
    setGlobalStateProperty(e1, t) {
        this._checkLoaded();
        let n = t === null ? this.stylesheet.state?.[e1]?.default ?? null : t;
        if ((0, $caapT.Un)(n, this._globalState[e1])) return this;
        this._globalState[e1] = n, this._applyGlobalStateChanges([
            e1
        ]);
    }
    getGlobalState() {
        return this._globalState;
    }
    setGlobalState(e1) {
        this._checkLoaded();
        let t = [];
        for(let n in e1)(0, $caapT.Un)(this._globalState[n], e1[n].default) || (t.push(n), this._globalState[n] = e1[n].default);
        this._applyGlobalStateChanges(t);
    }
    _applyGlobalStateChanges(e1) {
        if (e1.length === 0) return;
        let t = new Set, n = {};
        for (let r of e1){
            n[r] = this._globalState[r];
            for(let e1 in this._layers){
                let n = this._layers[e1], i = n.getLayoutAffectingGlobalStateRefs(), a = n.getPaintAffectingGlobalStateRefs(), o = n.getVisibilityAffectingGlobalStateRefs();
                if (i.has(r) && t.add(n.source), a.has(r)) for (let { name: e1, value: t } of a.get(r))this._updatePaintProperty(n, e1, t);
                o?.has(r) && (n.recalculateVisibility(), this._updateLayer(n));
            }
        }
        this.dispatcher.broadcast(`UGS`, n);
        for(let e1 in this.tileManagers)t.has(e1) && (this._reloadSource(e1), this._changed = !0);
    }
    async loadURL(e1, t = {}, n) {
        this.fire(new $902e455d852cdfb8$export$49025a11e3fe5bd0(`dataloading`)), t.validate = typeof t.validate != `boolean` || t.validate, this._loadStyleRequest = new AbortController;
        let r = this._loadStyleRequest;
        try {
            let i = await this.map._requestManager.transformRequest(e1, `Style`);
            (0, $caapT.kn)(r.signal);
            let a = await (0, $caapT.vn)(i, r);
            this._loadStyleRequest === r && (this._loadStyleRequest = null), this._load(a.data, t, n);
        } catch (e1) {
            this._loadStyleRequest === r && (this._loadStyleRequest = null), e1 && !r.signal.aborted && this.fire(new (0, $caapT.fn)((0, $caapT.Yn)(e1)));
        }
    }
    loadJSON(e1, t = {}, n) {
        this.fire(new $902e455d852cdfb8$export$49025a11e3fe5bd0(`dataloading`)), this._frameRequest = new AbortController, $902e455d852cdfb8$var$Dr.frameAsync(this._frameRequest, this.map._ownerWindow).then(()=>{
            this._frameRequest = null, t.validate = t.validate !== !1, this._load(e1, t, n);
        }).catch(()=>{});
    }
    loadEmpty() {
        this.fire(new $902e455d852cdfb8$export$49025a11e3fe5bd0(`dataloading`)), this._load($902e455d852cdfb8$var$yc, {
            validate: !1
        });
    }
    _load(e1, t, n) {
        let r = t.transformStyle ? t.transformStyle(n, e1) : e1;
        if (!(t.validate && (0, $caapT.en)(this, r))) {
            r = {
                ...r
            }, this._loaded = !0, this.stylesheet = r;
            for(let e1 in r.sources)this.addSource(e1, r.sources[e1], {
                validate: !1
            });
            r.sprite ? this._loadSprite(r.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(r.glyphs), this._createLayers(), this.light = new $902e455d852cdfb8$var$oi(this.stylesheet.light), this._setProjectionInternal(this.stylesheet.projection?.type || `mercator`), this.sky = new $902e455d852cdfb8$var$li(this.stylesheet.sky), this.map.setTerrain(this.stylesheet.terrain ?? null, {
                validate: !1
            }), this.fire(new $902e455d852cdfb8$export$49025a11e3fe5bd0(`data`)), this.fire(new $902e455d852cdfb8$export$444e55cd0e2f4f3a);
        }
    }
    _createLayers() {
        let e1 = (0, $caapT.an)(this.stylesheet.layers);
        this.setGlobalState(this.stylesheet.state ?? null), this.dispatcher.broadcast(`SL`, e1), this._order = e1.map((e1)=>e1.id), this._layers = {}, this._serializedLayers = null;
        for (let t of e1){
            let e1 = (0, $caapT.M)(t, this._globalState);
            if (e1.setEventedParent(this, {
                layer: {
                    id: t.id
                }
            }), this._layers[t.id] = e1, (0, $caapT.Bt)(e1) && this.tileManagers[e1.source]) {
                let n = t.paint?.[`raster-fade-duration`] ?? e1.paint.get(`raster-fade-duration`);
                this.tileManagers[e1.source].setRasterFadeDuration(n);
            }
        }
    }
    _loadSprite(e1, t = !1, n) {
        this.imageManager.setLoaded(!1);
        let r = new AbortController;
        this._spriteRequest = r;
        let i;
        $902e455d852cdfb8$var$qr(e1, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((e1)=>{
            if (this._spriteRequest = null, e1) for(let n in e1){
                this._spritesImagesIds[n] = [];
                let r = this._spritesImagesIds[n] ? this._spritesImagesIds[n].filter((t)=>!(t in e1)) : [];
                for (let e1 of r)this.imageManager.removeImage(e1), this._changedImages[e1] = !0;
                for(let r in e1[n]){
                    let i = n === "default" ? r : `${n}:${r}`;
                    this._spritesImagesIds[n].push(i), i in this.imageManager.images ? this.imageManager.updateImage(i, e1[n][r], !1) : this.imageManager.addImage(i, e1[n][r]), t && (this._changedImages[i] = !0);
                }
            }
        }).catch((e1)=>{
            this._spriteRequest = null, i = e1, r.signal.aborted || this.fire(new (0, $caapT.fn)(i));
        }).finally(()=>{
            this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), t && (this._changed = !0), this.dispatcher.broadcast(`SI`, this._availableImages), this.fire(new $902e455d852cdfb8$export$49025a11e3fe5bd0(`data`)), n && n(i);
        });
    }
    _unloadSprite() {
        for (let e1 of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(e1), this._changedImages[e1] = !0;
        this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._imagesListDirty = !0, this._changed = !0, this.fire(new $902e455d852cdfb8$export$49025a11e3fe5bd0(`data`));
    }
    _validateLayer(e1) {
        let t = this.tileManagers[e1.source];
        if (!t) return;
        let n = e1.sourceLayer;
        if (!n) return;
        let r = t.getSource();
        (r.type === `geojson` || r.vectorLayerIds && !r.vectorLayerIds.includes(n)) && this.fire(new (0, $caapT.fn)(Error(`Source layer "${n}" does not exist on source "${r.id}" as specified by style layer "${e1.id}".`)));
    }
    loaded() {
        if (!this._loaded || Object.keys(this._updatedSources).length) return !1;
        for(let e1 in this.tileManagers)if (!this.tileManagers[e1].loaded()) return !1;
        return this.imageManager.isLoaded();
    }
    _serializeByIds(e1, t = !1) {
        let n = this._serializedAllLayers();
        if (!e1 || e1.length === 0) return Object.values(t ? (0, $caapT.Ln)(n) : n);
        let r = [];
        for (let i of e1)if (n[i]) {
            let e1 = t ? (0, $caapT.Ln)(n[i]) : n[i];
            r.push(e1);
        }
        return r;
    }
    _serializedAllLayers() {
        let e1 = this._serializedLayers;
        if (e1) return e1;
        e1 = this._serializedLayers = {};
        let t = Object.keys(this._layers);
        for (let n of t){
            let t = this._layers[n];
            t.type !== `custom` && (e1[n] = t.serialize());
        }
        return e1;
    }
    hasTransitions() {
        if (this.light?.hasTransition() || this.sky?.hasTransition() || this.projection?.hasTransition()) return !0;
        for(let e1 in this.tileManagers)if (this.tileManagers[e1].hasTransition()) return !0;
        for(let e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
        return !1;
    }
    _checkLoaded() {
        if (!this._loaded) throw Error(`Style is not done loading.`);
    }
    update(e1) {
        if (!this._loaded) return;
        let t = this._changed;
        if (t) {
            this._imagesListDirty &&= (this.dispatcher.broadcast(`SI`, this._availableImages), !1);
            let t = Object.keys(this._updatedLayers), n = Object.keys(this._removedLayers);
            (t.length || n.length) && this._updateWorkerLayers(t, n);
            for(let e1 in this._updatedSources){
                let t = this._updatedSources[e1];
                if (t === `reload`) this._reloadSource(e1);
                else if (t === `clear`) this._clearSource(e1);
                else throw Error(`Invalid action ${t}`);
            }
            this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
            for(let t in this._updatedPaintProps)this._layers[t].updateTransitions(e1);
            this.light.updateTransitions(e1), this.sky.updateTransitions(e1), this._resetUpdates();
        }
        let n = {};
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            n[e1] = t.used, t.used = !1;
        }
        for (let t of this._order){
            let n = this._layers[t];
            n.recalculate(e1, this._availableImages), !n.isHidden(e1.zoom) && n.source && (this.tileManagers[n.source].used = !0);
        }
        for(let e1 in n){
            let t = this.tileManagers[e1];
            !!n[e1] != !!t.used && t.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `visibility`,
                sourceId: e1
            }));
        }
        this.light.recalculate(e1), this.sky.recalculate(e1), this.projection.recalculate(e1), this.z = e1.zoom, t && this.fire(new $902e455d852cdfb8$export$49025a11e3fe5bd0(`data`));
    }
    _updateTilesForChangedImages() {
        let e1 = Object.keys(this._changedImages);
        if (e1.length) {
            for(let t in this.tileManagers)this.tileManagers[t].reloadTilesForDependencies([
                `icons`,
                `patterns`
            ], e1);
            this._changedImages = {};
        }
    }
    _updateTilesForChangedGlyphs() {
        if (this._glyphsDidChange) {
            for(let e1 in this.tileManagers)this.tileManagers[e1].reloadTilesForDependencies([
                `glyphs`
            ], [
                ``
            ]);
            this._glyphsDidChange = !1;
        }
    }
    _updateWorkerLayers(e1, t) {
        this.dispatcher.broadcast(`UL`, {
            layers: this._serializeByIds(e1, !1),
            removedIds: t
        });
    }
    _resetUpdates() {
        this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
    }
    setState(e1, t = {}) {
        this._checkLoaded();
        let n = this.serialize();
        if (e1 = t.transformStyle ? t.transformStyle(n, e1) : e1, (t.validate ?? !0) && (0, $caapT.en)(this, e1)) return !1;
        e1 = (0, $caapT.Ln)(e1), e1.layers = (0, $caapT.an)(e1.layers);
        let r = (0, $caapT.on)(n, e1), i = this._getOperationsToPerform(r);
        if (i.unimplemented.length > 0) throw Error(`Unimplemented: ${i.unimplemented.join(`, `)}.`);
        if (i.operations.length === 0) return !1;
        for (let e1 of i.operations)e1();
        return this.stylesheet = e1, this._serializedLayers = null, this.fire(new $902e455d852cdfb8$export$444e55cd0e2f4f3a({
            style: this
        })), !0;
    }
    _getOperationsToPerform(e1) {
        let t = [], n = [];
        for (let r of e1)switch(r.command){
            case `setCenter`:
            case `setZoom`:
            case `setBearing`:
            case `setPitch`:
            case `setRoll`:
                continue;
            case `addLayer`:
                t.push(()=>this.addLayer.apply(this, r.args));
                break;
            case `removeLayer`:
                t.push(()=>this.removeLayer.apply(this, r.args));
                break;
            case `setPaintProperty`:
                t.push(()=>this.setPaintProperty.apply(this, r.args));
                break;
            case `setLayoutProperty`:
                t.push(()=>this.setLayoutProperty.apply(this, r.args));
                break;
            case `setFilter`:
                t.push(()=>this.setFilter.apply(this, r.args));
                break;
            case `addSource`:
                t.push(()=>this.addSource.apply(this, r.args));
                break;
            case `removeSource`:
                t.push(()=>this.removeSource.apply(this, r.args));
                break;
            case `setLayerZoomRange`:
                t.push(()=>this.setLayerZoomRange.apply(this, r.args));
                break;
            case `setLight`:
                t.push(()=>this.setLight.apply(this, r.args));
                break;
            case `setGeoJSONSourceData`:
                t.push(()=>this.setGeoJSONSourceData.apply(this, r.args));
                break;
            case `setGlyphs`:
                t.push(()=>this.setGlyphs.apply(this, r.args));
                break;
            case `setSprite`:
                t.push(()=>this.setSprite.apply(this, r.args));
                break;
            case `setTerrain`:
                t.push(()=>this.map.setTerrain.apply(this, r.args));
                break;
            case `setSky`:
                t.push(()=>this.setSky.apply(this, r.args));
                break;
            case `setProjection`:
                this.setProjection.apply(this, r.args);
                break;
            case `setGlobalState`:
                t.push(()=>this.setGlobalState.apply(this, r.args));
                break;
            case `setTransition`:
                t.push(()=>{});
                break;
            default:
                n.push(r.command);
                break;
        }
        return {
            operations: t,
            unimplemented: n
        };
    }
    addImage(e1, t) {
        if (this.getImage(e1)) {
            this.fire(new (0, $caapT.fn)(Error(`An image named "${e1}" already exists.`)));
            return;
        }
        this.imageManager.addImage(e1, t), this._afterImageUpdated(e1);
    }
    updateImage(e1, t) {
        this.imageManager.updateImage(e1, t);
    }
    getImage(e1) {
        return this.imageManager.getImage(e1);
    }
    setMissingImageResolver(e1) {
        this.imageManager.setMissingImageResolver(e1);
    }
    removeImage(e1) {
        if (!this.getImage(e1)) {
            this.fire(new (0, $caapT.fn)(Error(`An image named "${e1}" does not exist.`)));
            return;
        }
        this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
    }
    _afterImageUpdated(e1) {
        this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._imagesListDirty = !0, this._changed = !0, this.fire(new $902e455d852cdfb8$export$49025a11e3fe5bd0(`data`));
    }
    listImages() {
        return this._checkLoaded(), this.imageManager.listImages();
    }
    addSource(e1, t, r = {}) {
        if (this._checkLoaded(), this.tileManagers[e1] !== void 0) throw Error(`Source "${e1}" already exists.`);
        if (!t.type) throw Error(`The type property must be defined, but only the following properties were given: ${Object.keys(t).join(`, `)}.`);
        if ((0, $caapT.Xt).has(t.type) && this._validate((0, $caapT.$t).source, `sources.${e1}`, t, null, r)) return;
        this.map?._collectResourceTiming && (t.collectResourceTiming = !0);
        let i = this.tileManagers[e1] = new $902e455d852cdfb8$var$qa(e1, t, this.dispatcher);
        i.style = this, i.setEventedParent(this, ()=>({
                isSourceLoaded: i.loaded(),
                source: i.serialize(),
                sourceId: e1
            })), i.onAdd(this.map), this._changed = !0;
    }
    removeSource(e1) {
        if (this._checkLoaded(), this.tileManagers[e1] === void 0) throw Error(`There is no source with this ID=${e1}`);
        for(let t in this._layers)if (this._layers[t].source === e1) return this.fire(new (0, $caapT.fn)(Error(`Source "${e1}" cannot be removed while layer "${t}" is using it.`)));
        let t = this.tileManagers[e1];
        delete this.tileManagers[e1], delete this._updatedSources[e1], t.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `metadata`,
            sourceId: e1
        })), t.setEventedParent(null), t.onRemove(this.map), this._changed = !0;
    }
    setGeoJSONSourceData(e1, t) {
        if (this._checkLoaded(), this.tileManagers[e1] === void 0) throw Error(`There is no source with this ID=${e1}`);
        let n = this.tileManagers[e1].getSource();
        if (n.type !== `geojson`) throw Error(`geojsonSource.type is ${n.type}, which is !== 'geojson`);
        n.setData(t), this._changed = !0;
    }
    getSource(e1) {
        return this.tileManagers[e1]?.getSource();
    }
    addLayer(e1, t, r = {}) {
        this._checkLoaded();
        let i = e1.id;
        if (this.getLayer(i)) {
            this.fire(new (0, $caapT.fn)(Error(`Layer "${i}" already exists on this map.`)));
            return;
        }
        let a;
        if (e1.type === `custom`) {
            if ((0, $caapT.Zt)(this, (0, $caapT.P)(e1))) return;
            a = (0, $caapT.M)(e1, this._globalState);
        } else {
            if (`source` in e1 && typeof e1.source == `object` && (this.addSource(i, e1.source), e1 = (0, $caapT.Ln)(e1), e1 = (0, $caapT.Zn)(e1, {
                source: i
            })), this._validate((0, $caapT.$t).layer, `layers.${i}`, e1, {
                arrayIndex: -1
            }, r)) return;
            a = (0, $caapT.M)(e1, this._globalState), this._validateLayer(a), a.setEventedParent(this, {
                layer: {
                    id: i
                }
            });
        }
        let o = t ? this._order.indexOf(t) : this._order.length;
        if (t && o === -1) {
            this.fire(new (0, $caapT.fn)(Error(`Cannot add layer "${i}" before non-existing layer "${t}".`)));
            return;
        }
        if (this._order.splice(o, 0, i), this._layerOrderChanged = !0, this._layers[i] = a, this._removedLayers[i] && a.source && a.type !== `custom`) {
            let e1 = this._removedLayers[i];
            delete this._removedLayers[i], e1.type === a.type ? (this._updatedSources[a.source] = `reload`, this.tileManagers[a.source].pause()) : this._updatedSources[a.source] = `clear`;
        }
        this._updateLayer(a), a.onAdd && a.onAdd(this.map);
    }
    moveLayer(e1, t) {
        if (this._checkLoaded(), this._changed = !0, !this._layers[e1]) {
            this.fire(new (0, $caapT.fn)(Error(`The layer '${e1}' does not exist in the map's style and cannot be moved.`)));
            return;
        }
        if (e1 === t) return;
        let n = this._order.indexOf(e1);
        this._order.splice(n, 1);
        let r = t ? this._order.indexOf(t) : this._order.length;
        if (t && r === -1) {
            this.fire(new (0, $caapT.fn)(Error(`Cannot move layer "${e1}" before non-existing layer "${t}".`)));
            return;
        }
        this._order.splice(r, 0, e1), this._layerOrderChanged = !0;
    }
    removeLayer(e1) {
        this._checkLoaded();
        let t = this._layers[e1];
        if (!t) {
            this.fire(new (0, $caapT.fn)(Error(`Cannot remove non-existing layer "${e1}".`)));
            return;
        }
        t.setEventedParent(null);
        let n = this._order.indexOf(e1);
        this._order.splice(n, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = t, delete this._layers[e1], this._serializedLayers && delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], t.onRemove && t.onRemove(this.map);
    }
    getLayer(e1) {
        return this._layers[e1];
    }
    getLayersOrder() {
        return [
            ...this._order
        ];
    }
    hasLayer(e1) {
        return e1 in this._layers;
    }
    setLayerZoomRange(e1, t, n) {
        this._checkLoaded();
        let r = this.getLayer(e1);
        if (!r) {
            this.fire(new (0, $caapT.fn)(Error(`Cannot set the zoom range of non-existing layer "${e1}".`)));
            return;
        }
        (r.minzoom !== t || r.maxzoom !== n) && (t != null && (r.minzoom = t), n != null && (r.maxzoom = n), this._updateLayer(r));
    }
    setFilter(e1, t, r = {}) {
        this._checkLoaded();
        let i = this.getLayer(e1);
        if (!i) {
            this.fire(new (0, $caapT.fn)(Error(`Cannot filter non-existing layer "${e1}".`)));
            return;
        }
        if (!(0, $caapT.Un)(i.filter, t)) {
            if (t == null) {
                i.setFilter(void 0), this._updateLayer(i);
                return;
            }
            this._validate((0, $caapT.$t).filter, `layers.${i.id}.filter`, t, null, r) || (i.setFilter((0, $caapT.Ln)(t)), this._updateLayer(i));
        }
    }
    getFilter(e1) {
        return (0, $caapT.Ln)(this.getLayer(e1).filter);
    }
    setLayoutProperty(e1, t, n, r = {}) {
        this._checkLoaded();
        let i = this.getLayer(e1);
        if (!i) {
            this.fire(new (0, $caapT.fn)(Error(`Cannot style non-existing layer "${e1}".`)));
            return;
        }
        (0, $caapT.Un)(i.getLayoutProperty(t), n) || (i.setLayoutProperty(t, n, r), this._updateLayer(i));
    }
    getLayoutProperty(e1, t) {
        let n = this.getLayer(e1);
        if (!n) {
            this.fire(new (0, $caapT.fn)(Error(`Cannot get style of non-existing layer "${e1}".`)));
            return;
        }
        return n.getLayoutProperty(t);
    }
    setPaintProperty(e1, t, n, r = {}) {
        this._checkLoaded();
        let i = this.getLayer(e1);
        if (!i) {
            this.fire(new (0, $caapT.fn)(Error(`Cannot style non-existing layer "${e1}".`)));
            return;
        }
        (0, $caapT.Un)(i.getPaintProperty(t), n) || this._updatePaintProperty(i, t, n, r);
    }
    _updatePaintProperty(e1, t, n, r = {}) {
        e1.setPaintProperty(t, n, r) && this._updateLayer(e1), (0, $caapT.Bt)(e1) && t === `raster-fade-duration` && this.tileManagers[e1.source].setRasterFadeDuration(n), this._changed = !0, this._updatedPaintProps[e1.id] = !0, this._serializedLayers = null;
    }
    getPaintProperty(e1, t) {
        return this.getLayer(e1).getPaintProperty(t);
    }
    setFeatureState(e1, t) {
        this._checkLoaded();
        let n = e1.source, r = e1.sourceLayer, i = this.tileManagers[n];
        if (i === void 0) {
            this.fire(new (0, $caapT.fn)(Error(`The source '${n}' does not exist in the map's style.`)));
            return;
        }
        let a = i.getSource().type;
        if (a === `geojson` && r) {
            this.fire(new (0, $caapT.fn)(Error(`GeoJSON sources cannot have a sourceLayer parameter.`)));
            return;
        }
        if (a === `vector` && !r) {
            this.fire(new (0, $caapT.fn)(Error(`The sourceLayer parameter must be provided for vector source types.`)));
            return;
        }
        if (e1.id === void 0) {
            this.fire(new (0, $caapT.fn)(Error(`The feature id parameter must be provided.`)));
            return;
        }
        let o = [
            `__proto__`,
            `constructor`,
            `prototype`
        ];
        if (t && Object.keys(t).some((e1)=>o.includes(e1))) {
            this.fire(new (0, $caapT.fn)(Error(`The feature state should not include one of the following keys: ${o}`)));
            return;
        }
        i.setFeatureState(r, e1.id, t);
    }
    removeFeatureState(e1, t) {
        this._checkLoaded();
        let n = e1.source, r = this.tileManagers[n];
        if (r === void 0) {
            this.fire(new (0, $caapT.fn)(Error(`The source '${n}' does not exist in the map's style.`)));
            return;
        }
        let i = r.getSource().type, a = i === `vector` ? e1.sourceLayer : void 0;
        if (i === `vector` && !a) {
            this.fire(new (0, $caapT.fn)(Error(`The sourceLayer parameter must be provided for vector source types.`)));
            return;
        }
        if (t && typeof e1.id != `string` && typeof e1.id != `number`) {
            this.fire(new (0, $caapT.fn)(Error(`A feature id is required to remove its specific state property.`)));
            return;
        }
        r.removeFeatureState(a, e1.id, t);
    }
    getFeatureState(e1) {
        this._checkLoaded();
        let t = e1.source, n = e1.sourceLayer, r = this.tileManagers[t];
        if (r === void 0) {
            this.fire(new (0, $caapT.fn)(Error(`The source '${t}' does not exist in the map's style.`)));
            return;
        }
        if (r.getSource().type === `vector` && !n) {
            this.fire(new (0, $caapT.fn)(Error(`The sourceLayer parameter must be provided for vector source types.`)));
            return;
        }
        return e1.id === void 0 && this.fire(new (0, $caapT.fn)(Error(`The feature id parameter must be provided.`))), r.getFeatureState(n, e1.id);
    }
    getTransition() {
        return (0, $caapT.Zn)({
            duration: 300,
            delay: 0
        }, this.stylesheet?.transition);
    }
    serialize() {
        if (!this._loaded) return;
        let e1 = (0, $caapT.fr)(this.tileManagers, (e1)=>e1.serialize()), t = this._serializeByIds(this._order, !0), n = this.map.getTerrain() || void 0, r = this.stylesheet;
        return (0, $caapT.Qn)({
            version: r.version,
            name: r.name,
            metadata: r.metadata,
            light: r.light,
            sky: r.sky,
            center: r.center,
            zoom: r.zoom,
            bearing: r.bearing,
            pitch: r.pitch,
            sprite: r.sprite,
            glyphs: r.glyphs,
            transition: r.transition,
            projection: r.projection,
            sources: e1,
            layers: t,
            terrain: n
        }, (e1)=>e1 !== void 0);
    }
    _updateLayer(e1) {
        this._updatedLayers[e1.id] = !0, e1.source && !this._updatedSources[e1.source] && this.tileManagers[e1.source].getSource().type !== `raster` && (this._updatedSources[e1.source] = `reload`, this.tileManagers[e1.source].pause()), this._serializedLayers = null, this._changed = !0;
    }
    _flattenAndSortRenderedFeatures(e1) {
        let t = (e1)=>this._layers[e1].type === `fill-extrusion`, n = {}, r = [];
        for(let i = this._order.length - 1; i >= 0; i--){
            let a = this._order[i];
            if (t(a)) {
                n[a] = i;
                for (let t of e1){
                    let e1 = t[a];
                    if (e1) for (let t of e1)r.push(t);
                }
            }
        }
        r.sort((e1, t)=>t.intersectionZ - e1.intersectionZ);
        let i = [];
        for(let a = this._order.length - 1; a >= 0; a--){
            let o = this._order[a];
            if (t(o)) for(let e1 = r.length - 1; e1 >= 0; e1--){
                let t = r[e1].feature;
                if (n[t.layer.id] < a) break;
                i.push(t), r.pop();
            }
            else for (let t of e1){
                let e1 = t[o];
                if (e1) for (let t of e1)i.push(t.feature);
            }
        }
        return i;
    }
    queryRenderedFeatures(e1, t, r) {
        t?.filter && this._validate((0, $caapT.$t).filter, `queryRenderedFeatures.filter`, t.filter, null, t);
        let i = {};
        if (t?.layers) {
            if (!(Array.isArray(t.layers) || t.layers instanceof Set)) return this.fire(new (0, $caapT.fn)(Error(`parameters.layers must be an Array or a Set of strings`))), [];
            for (let e1 of t.layers){
                let t = this._layers[e1];
                if (!t) return this.fire(new (0, $caapT.fn)(Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                i[t.source] = !0;
            }
        }
        let a = [];
        t.availableImages = this._availableImages;
        let o = this._serializedAllLayers(), s = t.layers instanceof Set ? t.layers : Array.isArray(t.layers) ? new Set(t.layers) : null, c = {
            ...t,
            layers: s,
            globalState: this._globalState
        };
        for(let n in this.tileManagers)t.layers && !i[n] || a.push($902e455d852cdfb8$var$ki(this.tileManagers[n], this._layers, o, e1, c, r, this.map.terrain ? (e1, t, n)=>this.map.terrain.getElevation(e1, t, n) : void 0));
        return this.placement && a.push($902e455d852cdfb8$var$Ai(this._layers, o, this.tileManagers, e1, c, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(a);
    }
    querySourceFeatures(e1, t) {
        t?.filter && this._validate((0, $caapT.$t).filter, `querySourceFeatures.filter`, t.filter, null, t);
        let r = this.tileManagers[e1];
        return r ? $902e455d852cdfb8$var$ji(r, t ? {
            ...t,
            globalState: this._globalState
        } : {
            globalState: this._globalState
        }) : [];
    }
    getLight() {
        return this.light.getLight();
    }
    setLight(e1, t = {}) {
        this._checkLoaded();
        let n = this.light.getLight(), r = !1;
        for(let t in e1)if (!(0, $caapT.Un)(e1[t], n[t])) {
            r = !0;
            break;
        }
        if (!r) return;
        let i = {
            now: $902e455d852cdfb8$export$461939dd4422153(),
            transition: (0, $caapT.Zn)({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.light.setLight(e1, t), this.light.updateTransitions(i);
    }
    getProjection() {
        return this.stylesheet?.projection;
    }
    setProjection(e1) {
        this._checkLoaded();
        let t = e1 ?? {
            type: `mercator`
        };
        if (this.stylesheet.projection = e1, this.projection) {
            if (this.projection.name === t.type) return;
            this.projection.destroy(), delete this.projection;
        }
        this._setProjectionInternal(t.type);
    }
    getSky() {
        return this.stylesheet?.sky;
    }
    setSky(e1, t = {}) {
        this._checkLoaded();
        let n = this.getSky(), r = !1;
        if (!e1 && !n) return;
        if (e1 && !n) r = !0;
        else if (!e1 && n) r = !0;
        else for(let t in e1)if (!(0, $caapT.Un)(e1[t], n[t])) {
            r = !0;
            break;
        }
        if (!r) return;
        let i = {
            now: $902e455d852cdfb8$export$461939dd4422153(),
            transition: (0, $caapT.Zn)({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.stylesheet.sky = e1, this.sky.setSky(e1, t), this.sky.updateTransitions(i);
    }
    _setProjectionInternal(e1) {
        let t = $902e455d852cdfb8$var$vc(e1, this.map._camera?.transform.constrainOverride);
        this.projection = t.projection, this.map.migrateProjection(t.transform, t.cameraHelper);
        for(let e1 in this.tileManagers)this.tileManagers[e1].reload();
    }
    _validate(e1, t, n, r, i = {}) {
        return (0, $caapT.Qt)(this, e1, {
            key: t,
            style: this.serialize(),
            value: n,
            ...r
        }, i);
    }
    _remove(e1 = !0) {
        this._frameRequest &&= (this._frameRequest.abort(), null), this._loadStyleRequest &&= (this._loadStyleRequest.abort(), null), this._spriteRequest &&= (this._spriteRequest.abort(), null), $902e455d852cdfb8$var$va().off($902e455d852cdfb8$var$ha, this._rtlPluginLoaded);
        for(let e1 in this._layers)this._layers[e1].setEventedParent(null);
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            t.setEventedParent(null), t.onRemove(this.map);
        }
        this.imageManager.setEventedParent(null), this.setEventedParent(null), e1 && this.dispatcher.broadcast(`RM`, void 0), this.dispatcher.remove(e1);
    }
    _clearSource(e1) {
        this.tileManagers[e1].clearTiles();
    }
    _reloadSource(e1) {
        this.tileManagers[e1].resume(), this.tileManagers[e1].reload();
    }
    _updateSources(e1) {
        for(let t in this.tileManagers)this.tileManagers[t].update(e1, this.map.terrain);
    }
    _generateCollisionBoxes() {
        for(let e1 in this.tileManagers)this._reloadSource(e1);
    }
    _updatePlacement(e1, t, n, r, i = !1) {
        let a = !1, o = !1, s = {};
        for (let t of this._order){
            let n = this._layers[t];
            if (n.type !== `symbol`) continue;
            if (!s[n.source]) {
                let e1 = this.tileManagers[n.source];
                s[n.source] = e1.getRenderableIds(!0).map((t)=>e1.getTileByID(t)).sort((e1, t)=>t.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t.tileID) ? -1 : 1));
            }
            let r = this.crossTileSymbolIndex.addLayer(n, s[n.source], e1.center.lng);
            a ||= r;
        }
        if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), i ||= this._layerOrderChanged || n === 0, (i || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent($902e455d852cdfb8$export$461939dd4422153(), e1.zoom)) && (this.pauseablePlacement = new $902e455d852cdfb8$var$Vo(e1, this.map.terrain, this._order, i, t, n, r, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, s), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit($902e455d852cdfb8$export$461939dd4422153()), o = !0), a && this.pauseablePlacement.placement.setStale()), o || a) for (let e1 of this._order){
            let t = this._layers[e1];
            t.type === `symbol` && this.placement.updateLayerOpacities(t, s[t.source]);
        }
        return !this.pauseablePlacement.isDone() || this.placement.hasTransitions($902e455d852cdfb8$export$461939dd4422153());
    }
    _releaseSymbolFadeTiles() {
        for(let e1 in this.tileManagers)this.tileManagers[e1].releaseSymbolFadeTiles();
    }
    async getImages(e1, t) {
        let n = await this.imageManager.getImages(t.icons);
        this._updateTilesForChangedImages();
        let r = this.tileManagers[t.source];
        return r && r.setDependencies(t.tileID.key, t.type, t.icons), n;
    }
    async getGlyphs(e1, t) {
        let n = await this.glyphManager.getGlyphs(t.stacks), r = this.tileManagers[t.source];
        return r && r.setDependencies(t.tileID.key, t.type, [
            ``
        ]), n;
    }
    getGlyphsUrl() {
        return this.stylesheet.glyphs || null;
    }
    setGlyphs(e1, t = {}) {
        this._checkLoaded(), !(e1 && this._validate((0, $caapT.$t).glyphs, `glyphs`, e1, null, t)) && (this._glyphsDidChange = !0, this.stylesheet.glyphs = e1, this.glyphManager.entries = {}, this.glyphManager.setURL(e1));
    }
    async getDashes(e1, t) {
        let n = {};
        for (let [e1, r] of Object.entries(t.dashes))n[e1] = this.lineAtlas.getDash(r.dasharray, r.round);
        return n;
    }
    addSprite(e1, t, r = {}, i) {
        this._checkLoaded();
        let a = [
            {
                id: e1,
                url: t
            }
        ], o = [
            ...$902e455d852cdfb8$var$Gr(this.stylesheet.sprite),
            ...a
        ];
        this._validate((0, $caapT.$t).sprite, `sprite`, o, null, r) || (this.stylesheet.sprite = o, this._loadSprite(a, !0, i));
    }
    removeSprite(e1) {
        this._checkLoaded();
        let t = $902e455d852cdfb8$var$Gr(this.stylesheet.sprite);
        if (!t.find((t)=>t.id === e1)) {
            this.fire(new (0, $caapT.fn)(Error(`Sprite "${e1}" doesn't exists on this map.`)));
            return;
        }
        if (this._spritesImagesIds[e1]) for (let t of this._spritesImagesIds[e1])this.imageManager.removeImage(t), this._changedImages[t] = !0;
        t.splice(t.findIndex((t)=>t.id === e1), 1), this.stylesheet.sprite = t.length > 0 ? t : void 0, delete this._spritesImagesIds[e1], this._availableImages = this.imageManager.listImages(), this._imagesListDirty = !0, this._changed = !0, this.fire(new $902e455d852cdfb8$export$49025a11e3fe5bd0(`data`));
    }
    getSprite() {
        return $902e455d852cdfb8$var$Gr(this.stylesheet.sprite);
    }
    setSprite(e1, t = {}, r) {
        this._checkLoaded(), !(e1 && this._validate((0, $caapT.$t).sprite, `sprite`, e1, null, t)) && (this.stylesheet.sprite = e1, e1 ? this._loadSprite(e1, !0, r) : (this._unloadSprite(), r && r(null)));
    }
    destroy() {
        this._frameRequest &&= (this._frameRequest.abort(), null), this._loadStyleRequest &&= (this._loadStyleRequest.abort(), null), this._spriteRequest &&= (this._spriteRequest.abort(), null);
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            t.setEventedParent(null), t.onRemove(this.map);
        }
        this.tileManagers = {}, this.imageManager && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this._availableImages = [], this._spritesImagesIds = {}), this.glyphManager && this.glyphManager.destroy();
        for(let e1 in this._layers){
            let t = this._layers[e1];
            t.setEventedParent(null), t.onRemove && t.onRemove(this.map);
        }
        this._setInitialValues(), this.setEventedParent(null), this.dispatcher.unregisterMessageHandler(`GG`), this.dispatcher.unregisterMessageHandler(`GI`), this.dispatcher.unregisterMessageHandler(`GDA`), this.dispatcher.remove(!0), this._listeners = {}, this._oneTimeListeners = {};
    }
};
const $902e455d852cdfb8$var$xc = (0, $caapT.zt)([
    {
        name: `a_pos`,
        type: `Int16`,
        components: 2
    },
    {
        name: `a_texture_pos`,
        type: `Int16`,
        components: 2
    }
]);
var $902e455d852cdfb8$var$Sc = class {
    constructor(){
        this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
    }
    bind(e1, t, n, r, i, a, o, s, c) {
        this.context = e1;
        let l = this.boundPaintVertexBuffers.length !== r.length;
        for(let e1 = 0; !l && e1 < r.length; e1++)this.boundPaintVertexBuffers[e1] !== r[e1] && (l = !0);
        !this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== n || l || this.boundIndexBuffer !== i || this.boundVertexOffset !== a || this.boundDynamicVertexBuffer !== o || this.boundDynamicVertexBuffer2 !== s || this.boundDynamicVertexBuffer3 !== c ? this.freshBind(t, n, r, i, a, o, s, c) : (e1.bindVertexArray.set(this.vao), o && o.bind(), i?.dynamicDraw && i.bind(), s && s.bind(), c && c.bind());
    }
    freshBind(e1, t, n, r, i, a, o, s) {
        let c = e1.numAttributes, l = this.context, u = l.gl;
        this.vao && this.destroy(), this.vao = l.createVertexArray(), l.bindVertexArray.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = n, this.boundIndexBuffer = r, this.boundVertexOffset = i, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = o, this.boundDynamicVertexBuffer3 = s, t.enableAttributes(u, e1);
        for (let t of n)t.enableAttributes(u, e1);
        a && a.enableAttributes(u, e1), o && o.enableAttributes(u, e1), s && s.enableAttributes(u, e1), t.bind(), t.setVertexAttribPointers(u, e1, i);
        for (let t of n)t.bind(), t.setVertexAttribPointers(u, e1, i);
        a && (a.bind(), a.setVertexAttribPointers(u, e1, i)), r && r.bind(), o && (o.bind(), o.setVertexAttribPointers(u, e1, i)), s && (s.bind(), s.setVertexAttribPointers(u, e1, i)), l.currentNumAttributes = c;
    }
    destroy() {
        this.vao &&= (this.context.deleteVertexArray(this.vao), null);
    }
};
const $902e455d852cdfb8$var$Cc = (e1, t)=>({
        u_depth: new (0, $caapT.St)(e1, t.u_depth),
        u_terrain: new (0, $caapT.St)(e1, t.u_terrain),
        u_terrain_dim: new (0, $caapT.xt)(e1, t.u_terrain_dim),
        u_terrain_matrix: new (0, $caapT.kt)(e1, t.u_terrain_matrix),
        u_terrain_unpack: new (0, $caapT.Tt)(e1, t.u_terrain_unpack),
        u_terrain_exaggeration: new (0, $caapT.xt)(e1, t.u_terrain_exaggeration)
    }), $902e455d852cdfb8$var$wc = (e1, t)=>({
        u_texture: new (0, $caapT.St)(e1, t.u_texture),
        u_ele_delta: new (0, $caapT.xt)(e1, t.u_ele_delta),
        u_fog_matrix: new (0, $caapT.kt)(e1, t.u_fog_matrix),
        u_fog_color: new (0, $caapT.Et)(e1, t.u_fog_color),
        u_fog_ground_blend: new (0, $caapT.xt)(e1, t.u_fog_ground_blend),
        u_fog_ground_blend_opacity: new (0, $caapT.xt)(e1, t.u_fog_ground_blend_opacity),
        u_horizon_color: new (0, $caapT.Et)(e1, t.u_horizon_color),
        u_horizon_fog_blend: new (0, $caapT.xt)(e1, t.u_horizon_fog_blend),
        u_is_globe_mode: new (0, $caapT.xt)(e1, t.u_is_globe_mode)
    }), $902e455d852cdfb8$var$Tc = (e1, t)=>({
        u_ele_delta: new (0, $caapT.xt)(e1, t.u_ele_delta)
    }), $902e455d852cdfb8$var$Ec = (e1, t)=>({
        u_texture: new (0, $caapT.St)(e1, t.u_texture),
        u_terrain_coords_id: new (0, $caapT.xt)(e1, t.u_terrain_coords_id),
        u_ele_delta: new (0, $caapT.xt)(e1, t.u_ele_delta)
    }), $902e455d852cdfb8$var$Dc = (e1, t, n, r, i)=>({
        u_texture: 0,
        u_ele_delta: e1,
        u_fog_matrix: t,
        u_fog_color: n ? n.properties.get(`fog-color`) : (0, $caapT.tn).white,
        u_fog_ground_blend: n ? n.properties.get(`fog-ground-blend`) : 1,
        u_fog_ground_blend_opacity: i ? 0 : n ? n.calculateFogBlendOpacity(r) : 0,
        u_horizon_color: n ? n.properties.get(`horizon-color`) : (0, $caapT.tn).white,
        u_horizon_fog_blend: n ? n.properties.get(`horizon-fog-blend`) : 1,
        u_is_globe_mode: +!!i
    }), $902e455d852cdfb8$var$Oc = (e1)=>({
        u_ele_delta: e1
    }), $902e455d852cdfb8$var$kc = (e1, t)=>({
        u_terrain_coords_id: e1 / 255,
        u_texture: 0,
        u_ele_delta: t
    }), $902e455d852cdfb8$var$Ac = (e1, t)=>({
        u_projection_matrix: new (0, $caapT.kt)(e1, t.u_projection_matrix),
        u_projection_tile_mercator_coords: new (0, $caapT.Tt)(e1, t.u_projection_tile_mercator_coords),
        u_projection_clipping_plane: new (0, $caapT.Tt)(e1, t.u_projection_clipping_plane),
        u_projection_transition: new (0, $caapT.xt)(e1, t.u_projection_transition),
        u_projection_fallback_matrix: new (0, $caapT.kt)(e1, t.u_projection_fallback_matrix)
    }), $902e455d852cdfb8$var$jc = {
    mainMatrix: `u_projection_matrix`,
    tileMercatorCoords: `u_projection_tile_mercator_coords`,
    clippingPlane: `u_projection_clipping_plane`,
    projectionTransition: `u_projection_transition`,
    fallbackMatrix: `u_projection_fallback_matrix`
};
function $902e455d852cdfb8$var$Mc(e1) {
    let t = [];
    for (let n of e1){
        if (n === null) continue;
        let e1 = n.split(` `);
        t.push(e1.pop());
    }
    return t;
}
var $902e455d852cdfb8$var$Nc = class {
    constructor(e1, t, n, r, i, a, o, s, c = []){
        let l = e1.gl;
        this.program = l.createProgram();
        let u = $902e455d852cdfb8$var$Mc(t.staticAttributes), d = n ? n.getBinderAttributes() : [], f = u.concat(d), p = $902e455d852cdfb8$var$ls.prelude.staticUniforms ? $902e455d852cdfb8$var$Mc($902e455d852cdfb8$var$ls.prelude.staticUniforms) : [], m = o.staticUniforms ? $902e455d852cdfb8$var$Mc(o.staticUniforms) : [], h = t.staticUniforms ? $902e455d852cdfb8$var$Mc(t.staticUniforms) : [], g = n ? n.getBinderUniforms() : [], _ = p.concat(m).concat(h).concat(g), v = [];
        for (let e1 of _)v.includes(e1) || v.push(e1);
        let y = n ? n.defines() : [];
        y.unshift(`#version 300 es`), i && y.push(`#define OVERDRAW_INSPECTOR;`), a && y.push(`#define TERRAIN3D;`), s && y.push(s), c && y.push(...c);
        let b = y.concat($902e455d852cdfb8$var$ls.prelude.fragmentSource, o.fragmentSource, t.fragmentSource).join(`
`), x = y.concat($902e455d852cdfb8$var$ls.prelude.vertexSource, o.vertexSource, t.vertexSource).join(`
`), S = l.createShader(l.FRAGMENT_SHADER);
        if (l.isContextLost()) {
            this.failedToCreate = !0;
            return;
        }
        if (l.shaderSource(S, b), l.compileShader(S), !l.getShaderParameter(S, l.COMPILE_STATUS)) throw Error(`Could not compile fragment shader: ${l.getShaderInfoLog(S)}`);
        l.attachShader(this.program, S);
        let C = l.createShader(l.VERTEX_SHADER);
        if (l.isContextLost()) {
            this.failedToCreate = !0;
            return;
        }
        if (l.shaderSource(C, x), l.compileShader(C), !l.getShaderParameter(C, l.COMPILE_STATUS)) throw Error(`Could not compile vertex shader: ${l.getShaderInfoLog(C)}`);
        l.attachShader(this.program, C), this.attributes = {};
        let w = {};
        this.numAttributes = f.length;
        for(let e1 = 0; e1 < this.numAttributes; e1++)f[e1] && (this.attributes[f[e1]] = e1);
        l.linkProgram(this.program);
        for(let e1 in this.attributes){
            let t = l.getAttribLocation(this.program, e1);
            t >= 0 && (this.attributes[e1] = t);
        }
        if (!l.getProgramParameter(this.program, l.LINK_STATUS)) throw Error(`Program failed to link: ${l.getProgramInfoLog(this.program)}`);
        l.deleteShader(C), l.deleteShader(S);
        for (let e1 of v)if (e1 && !w[e1]) {
            let t = l.getUniformLocation(this.program, e1);
            t && (w[e1] = t);
        }
        this.fixedUniforms = r(e1, w), this.terrainUniforms = $902e455d852cdfb8$var$Cc(e1, w), this.projectionUniforms = $902e455d852cdfb8$var$Ac(e1, w), this.binderUniforms = n ? n.getUniforms(e1, w) : [];
    }
    draw(e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v) {
        let y = e1.gl;
        if (this.failedToCreate) return;
        if (e1.program.set(this.program), e1.setDepthMode(n), e1.setStencilMode(r), e1.setColorMode(i), e1.setCullFace(a), s) {
            e1.activeTexture.set(y.TEXTURE2), y.bindTexture(y.TEXTURE_2D, s.depthTexture), e1.activeTexture.set(y.TEXTURE3), y.bindTexture(y.TEXTURE_2D, s.texture);
            for(let e1 in this.terrainUniforms)this.terrainUniforms[e1].set(s[e1]);
        }
        if (c) for(let e1 in c){
            let t = $902e455d852cdfb8$var$jc[e1];
            this.projectionUniforms[t].set(c[e1]);
        }
        if (o) for(let e1 in this.fixedUniforms)this.fixedUniforms[e1].set(o[e1]);
        h && h.setUniforms(e1, this.binderUniforms, p, {
            zoom: m
        });
        let b = 0;
        switch(t){
            case y.LINES:
                b = 2;
                break;
            case y.TRIANGLES:
                b = 3;
                break;
            case y.LINE_STRIP:
                b = 1;
                break;
        }
        for (let n of f.get())n.vaos ||= {}, n.vaos[l] ||= new $902e455d852cdfb8$var$Sc, n.vaos[l].bind(e1, this, u, h ? h.getPaintVertexBuffers() : [], d, n.vertexOffset, g, _, v), y.drawElements(t, n.primitiveLength * b, y.UNSIGNED_SHORT, n.primitiveOffset * b * 2);
    }
};
function $902e455d852cdfb8$var$Pc(e1, t, n) {
    let r = 1 / (0, $caapT.Nr)(n, 1, t.transform.tileZoom), i = 2 ** n.tileID.overscaledZ, a = n.tileSize * 2 ** t.transform.tileZoom / i, o = a * (n.tileID.canonical.x + n.tileID.wrap * i), s = a * n.tileID.canonical.y;
    return {
        u_image: 0,
        u_texsize: n.imageAtlasTexture.size,
        u_scale: [
            r,
            e1.fromScale,
            e1.toScale
        ],
        u_fade: e1.t,
        u_pixel_coord_upper: [
            o >> 16,
            s >> 16
        ],
        u_pixel_coord_lower: [
            o & 65535,
            s & 65535
        ]
    };
}
function $902e455d852cdfb8$var$Fc(e1, t, n, r) {
    let i = n.imageManager.getPattern(e1.from.toString()), a = n.imageManager.getPattern(e1.to.toString()), { width: o, height: s } = n.imageManager.getPixelSize(), c = 2 ** r.tileID.overscaledZ, l = r.tileSize * 2 ** n.transform.tileZoom / c, u = l * (r.tileID.canonical.x + r.tileID.wrap * c), d = l * r.tileID.canonical.y;
    return {
        u_image: 0,
        u_pattern_tl_a: i.tl,
        u_pattern_br_a: i.br,
        u_pattern_tl_b: a.tl,
        u_pattern_br_b: a.br,
        u_texsize: [
            o,
            s
        ],
        u_mix: t.t,
        u_pattern_size_a: i.displaySize,
        u_pattern_size_b: a.displaySize,
        u_scale_a: t.fromScale,
        u_scale_b: t.toScale,
        u_tile_units_to_pixels: 1 / (0, $caapT.Nr)(r, 1, n.transform.tileZoom),
        u_pixel_coord_upper: [
            u >> 16,
            d >> 16
        ],
        u_pixel_coord_lower: [
            u & 65535,
            d & 65535
        ]
    };
}
const $902e455d852cdfb8$var$Ic = (e1, t)=>({
        u_lightpos: new (0, $caapT.wt)(e1, t.u_lightpos),
        u_lightpos_globe: new (0, $caapT.wt)(e1, t.u_lightpos_globe),
        u_lightintensity: new (0, $caapT.xt)(e1, t.u_lightintensity),
        u_lightcolor: new (0, $caapT.wt)(e1, t.u_lightcolor),
        u_vertical_gradient: new (0, $caapT.xt)(e1, t.u_vertical_gradient),
        u_opacity: new (0, $caapT.xt)(e1, t.u_opacity),
        u_fill_translate: new (0, $caapT.Ct)(e1, t.u_fill_translate)
    }), $902e455d852cdfb8$var$Lc = (e1, t)=>({
        u_lightpos: new (0, $caapT.wt)(e1, t.u_lightpos),
        u_lightpos_globe: new (0, $caapT.wt)(e1, t.u_lightpos_globe),
        u_lightintensity: new (0, $caapT.xt)(e1, t.u_lightintensity),
        u_lightcolor: new (0, $caapT.wt)(e1, t.u_lightcolor),
        u_vertical_gradient: new (0, $caapT.xt)(e1, t.u_vertical_gradient),
        u_height_factor: new (0, $caapT.xt)(e1, t.u_height_factor),
        u_opacity: new (0, $caapT.xt)(e1, t.u_opacity),
        u_fill_translate: new (0, $caapT.Ct)(e1, t.u_fill_translate),
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_texsize: new (0, $caapT.Ct)(e1, t.u_texsize),
        u_pixel_coord_upper: new (0, $caapT.Ct)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $caapT.Ct)(e1, t.u_pixel_coord_lower),
        u_scale: new (0, $caapT.wt)(e1, t.u_scale),
        u_fade: new (0, $caapT.xt)(e1, t.u_fade)
    }), $902e455d852cdfb8$var$Rc = (e1, t, n, r)=>{
    let i = e1.style.light, a = i.getCartesianPosition(), o = (0, $caapT.Ei)();
    i.properties.get(`anchor`) === `viewport` && (0, $caapT.Di)(o, e1.transform.bearingInRadians), (0, $caapT.oi)(a, a, o);
    let s = e1.transform.transformLightDirection(a), c = i.properties.get(`color`);
    return {
        u_lightpos: a,
        u_lightpos_globe: s,
        u_lightintensity: i.properties.get(`intensity`),
        u_lightcolor: [
            c.r,
            c.g,
            c.b
        ],
        u_vertical_gradient: +t,
        u_opacity: n,
        u_fill_translate: r
    };
}, $902e455d852cdfb8$var$zc = (e1, t, n, r, i, a, o)=>(0, $caapT.Zn)($902e455d852cdfb8$var$Rc(e1, t, n, r), $902e455d852cdfb8$var$Pc(a, e1, o), {
        u_height_factor: -(2 ** i.overscaledZ) / o.tileSize / 8
    }), $902e455d852cdfb8$var$Bc = (e1, t)=>({
        u_fill_translate: new (0, $caapT.Ct)(e1, t.u_fill_translate)
    }), $902e455d852cdfb8$var$Vc = (e1, t)=>({
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_texsize: new (0, $caapT.Ct)(e1, t.u_texsize),
        u_pixel_coord_upper: new (0, $caapT.Ct)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $caapT.Ct)(e1, t.u_pixel_coord_lower),
        u_scale: new (0, $caapT.wt)(e1, t.u_scale),
        u_fade: new (0, $caapT.xt)(e1, t.u_fade),
        u_fill_translate: new (0, $caapT.Ct)(e1, t.u_fill_translate)
    }), $902e455d852cdfb8$var$Hc = (e1, t)=>({
        u_world: new (0, $caapT.Ct)(e1, t.u_world),
        u_fill_translate: new (0, $caapT.Ct)(e1, t.u_fill_translate)
    }), $902e455d852cdfb8$var$Uc = (e1, t)=>({
        u_world: new (0, $caapT.Ct)(e1, t.u_world),
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_texsize: new (0, $caapT.Ct)(e1, t.u_texsize),
        u_pixel_coord_upper: new (0, $caapT.Ct)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $caapT.Ct)(e1, t.u_pixel_coord_lower),
        u_scale: new (0, $caapT.wt)(e1, t.u_scale),
        u_fade: new (0, $caapT.xt)(e1, t.u_fade),
        u_fill_translate: new (0, $caapT.Ct)(e1, t.u_fill_translate)
    }), $902e455d852cdfb8$var$Wc = (e1, t, n, r)=>(0, $caapT.Zn)($902e455d852cdfb8$var$Pc(t, e1, n), {
        u_fill_translate: r
    }), $902e455d852cdfb8$var$Gc = (e1)=>({
        u_fill_translate: e1
    }), $902e455d852cdfb8$var$Kc = (e1, t)=>({
        u_world: e1,
        u_fill_translate: t
    }), $902e455d852cdfb8$var$qc = (e1, t, n, r, i)=>(0, $caapT.Zn)($902e455d852cdfb8$var$Wc(e1, t, n, i), {
        u_world: r
    }), $902e455d852cdfb8$var$Jc = (e1, t)=>({
        u_camera_to_center_distance: new (0, $caapT.xt)(e1, t.u_camera_to_center_distance),
        u_scale_with_map: new (0, $caapT.St)(e1, t.u_scale_with_map),
        u_pitch_with_map: new (0, $caapT.St)(e1, t.u_pitch_with_map),
        u_extrude_scale: new (0, $caapT.Ct)(e1, t.u_extrude_scale),
        u_device_pixel_ratio: new (0, $caapT.xt)(e1, t.u_device_pixel_ratio),
        u_globe_extrude_scale: new (0, $caapT.xt)(e1, t.u_globe_extrude_scale),
        u_translate: new (0, $caapT.Ct)(e1, t.u_translate)
    }), $902e455d852cdfb8$var$Yc = (e1, t, n, r, i)=>{
    let a = e1.transform, o, s, c = 0;
    if (n.paint.get(`circle-pitch-alignment`) === `map`) {
        let e1 = (0, $caapT.Nr)(t, 1, a.zoom);
        o = !0, s = [
            e1,
            e1
        ], c = e1 / ((0, $caapT.Pr) * 2 ** t.tileID.overscaledZ) * 2 * Math.PI * i;
    } else o = !1, s = a.pixelsToGLUnits;
    return {
        u_camera_to_center_distance: a.cameraToCenterDistance,
        u_scale_with_map: +(n.paint.get(`circle-pitch-scale`) === `map`),
        u_pitch_with_map: +o,
        u_device_pixel_ratio: e1.pixelRatio,
        u_extrude_scale: s,
        u_globe_extrude_scale: c,
        u_translate: r
    };
}, $902e455d852cdfb8$var$Xc = (e1, t)=>({
        u_pixel_extrude_scale: new (0, $caapT.Ct)(e1, t.u_pixel_extrude_scale)
    }), $902e455d852cdfb8$var$Zc = (e1, t)=>({
        u_viewport_size: new (0, $caapT.Ct)(e1, t.u_viewport_size)
    }), $902e455d852cdfb8$var$Qc = (e1)=>({
        u_pixel_extrude_scale: [
            1 / e1.width,
            1 / e1.height
        ]
    }), $902e455d852cdfb8$var$$c = (e1)=>({
        u_viewport_size: [
            e1.width,
            e1.height
        ]
    }), $902e455d852cdfb8$var$el = (e1, t)=>({
        u_color: new (0, $caapT.Et)(e1, t.u_color),
        u_overlay: new (0, $caapT.St)(e1, t.u_overlay),
        u_overlay_scale: new (0, $caapT.xt)(e1, t.u_overlay_scale)
    }), $902e455d852cdfb8$var$tl = (e1, t = 1)=>({
        u_color: e1,
        u_overlay: 0,
        u_overlay_scale: t
    }), $902e455d852cdfb8$var$nl = (e1, t)=>({
        u_extrude_scale: new (0, $caapT.xt)(e1, t.u_extrude_scale),
        u_intensity: new (0, $caapT.xt)(e1, t.u_intensity),
        u_globe_extrude_scale: new (0, $caapT.xt)(e1, t.u_globe_extrude_scale)
    }), $902e455d852cdfb8$var$rl = (e1, t)=>({
        u_matrix: new (0, $caapT.kt)(e1, t.u_matrix),
        u_world: new (0, $caapT.Ct)(e1, t.u_world),
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_color_ramp: new (0, $caapT.St)(e1, t.u_color_ramp),
        u_opacity: new (0, $caapT.xt)(e1, t.u_opacity)
    }), $902e455d852cdfb8$var$il = (e1, t, n, r)=>{
    let i = (0, $caapT.Nr)(e1, 1, t) / ((0, $caapT.Pr) * 2 ** e1.tileID.overscaledZ) * 2 * Math.PI * r;
    return {
        u_extrude_scale: (0, $caapT.Nr)(e1, 1, t),
        u_intensity: n,
        u_globe_extrude_scale: i
    };
}, $902e455d852cdfb8$var$al = (e1, t, n, r)=>{
    let i = (0, $caapT.fi)();
    (0, $caapT.yi)(i, 0, e1.width, e1.height, 0, 0, 1);
    let a = e1.context.gl;
    return {
        u_matrix: i,
        u_world: [
            a.drawingBufferWidth,
            a.drawingBufferHeight
        ],
        u_image: n,
        u_color_ramp: r,
        u_opacity: t.paint.get(`heatmap-opacity`)
    };
}, $902e455d852cdfb8$var$ol = (e1, t)=>({
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_latrange: new (0, $caapT.Ct)(e1, t.u_latrange),
        u_exaggeration: new (0, $caapT.xt)(e1, t.u_exaggeration),
        u_altitudes: new (0, $caapT.Ot)(e1, t.u_altitudes),
        u_azimuths: new (0, $caapT.Ot)(e1, t.u_azimuths),
        u_accent: new (0, $caapT.Et)(e1, t.u_accent),
        u_method: new (0, $caapT.St)(e1, t.u_method),
        u_shadows: new (0, $caapT.Dt)(e1, t.u_shadows),
        u_highlights: new (0, $caapT.Dt)(e1, t.u_highlights)
    }), $902e455d852cdfb8$var$sl = (e1, t)=>({
        u_matrix: new (0, $caapT.kt)(e1, t.u_matrix),
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_dimension: new (0, $caapT.Ct)(e1, t.u_dimension),
        u_zoom: new (0, $caapT.xt)(e1, t.u_zoom),
        u_unpack: new (0, $caapT.Tt)(e1, t.u_unpack)
    }), $902e455d852cdfb8$var$cl = (e1, t, n)=>{
    let r = n.paint.get(`hillshade-accent-color`), i;
    switch(n.paint.get(`hillshade-method`)){
        case `basic`:
            i = 4;
            break;
        case `combined`:
            i = 1;
            break;
        case `igor`:
            i = 2;
            break;
        case `multidirectional`:
            i = 3;
            break;
        default:
            i = 0;
            break;
    }
    let a = n.getIlluminationProperties();
    for(let t = 0; t < a.directionRadians.length; t++)n.paint.get(`hillshade-illumination-anchor`) === `viewport` && (a.directionRadians[t] += e1.transform.bearingInRadians);
    return {
        u_image: 0,
        u_latrange: $902e455d852cdfb8$var$ul(e1, t.tileID),
        u_exaggeration: n.paint.get(`hillshade-exaggeration`),
        u_altitudes: a.altitudeRadians,
        u_azimuths: a.directionRadians,
        u_accent: r,
        u_method: i,
        u_highlights: a.highlightColor,
        u_shadows: a.shadowColor
    };
}, $902e455d852cdfb8$var$ll = (e1, t)=>{
    let n = t.stride, r = (0, $caapT.fi)();
    return (0, $caapT.yi)(r, 0, (0, $caapT.Pr), -(0, $caapT.Pr), 0, 0, 1), (0, $caapT.Ti)(r, r, [
        0,
        -(0, $caapT.Pr),
        0
    ]), {
        u_matrix: r,
        u_image: 1,
        u_dimension: [
            n,
            n
        ],
        u_zoom: e1.overscaledZ,
        u_unpack: t.getUnpackVector()
    };
};
function $902e455d852cdfb8$var$ul(e1, t) {
    let n = 2 ** t.canonical.z, r = t.canonical.y;
    return [
        new (0, $caapT.S)(0, r / n).toLngLat().lat,
        new (0, $caapT.S)(0, (r + 1) / n).toLngLat().lat
    ];
}
const $902e455d852cdfb8$var$dl = (e1, t)=>({
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_unpack: new (0, $caapT.Tt)(e1, t.u_unpack),
        u_dimension: new (0, $caapT.Ct)(e1, t.u_dimension),
        u_elevation_stops: new (0, $caapT.St)(e1, t.u_elevation_stops),
        u_color_stops: new (0, $caapT.St)(e1, t.u_color_stops),
        u_color_ramp_size: new (0, $caapT.St)(e1, t.u_color_ramp_size),
        u_opacity: new (0, $caapT.xt)(e1, t.u_opacity)
    }), $902e455d852cdfb8$var$fl = (e1, t, n = 0)=>({
        u_image: 0,
        u_unpack: t.getUnpackVector(),
        u_dimension: [
            t.stride,
            t.stride
        ],
        u_elevation_stops: 1,
        u_color_stops: 4,
        u_color_ramp_size: n,
        u_opacity: e1.paint.get(`color-relief-opacity`)
    }), $902e455d852cdfb8$var$pl = (e1, t)=>({
        u_translation: new (0, $caapT.Ct)(e1, t.u_translation),
        u_ratio: new (0, $caapT.xt)(e1, t.u_ratio),
        u_device_pixel_ratio: new (0, $caapT.xt)(e1, t.u_device_pixel_ratio),
        u_units_to_pixels: new (0, $caapT.Ct)(e1, t.u_units_to_pixels)
    }), $902e455d852cdfb8$var$ml = (e1, t)=>({
        u_translation: new (0, $caapT.Ct)(e1, t.u_translation),
        u_ratio: new (0, $caapT.xt)(e1, t.u_ratio),
        u_device_pixel_ratio: new (0, $caapT.xt)(e1, t.u_device_pixel_ratio),
        u_units_to_pixels: new (0, $caapT.Ct)(e1, t.u_units_to_pixels),
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_image_height: new (0, $caapT.xt)(e1, t.u_image_height)
    }), $902e455d852cdfb8$var$hl = (e1, t)=>({
        u_translation: new (0, $caapT.Ct)(e1, t.u_translation),
        u_texsize: new (0, $caapT.Ct)(e1, t.u_texsize),
        u_ratio: new (0, $caapT.xt)(e1, t.u_ratio),
        u_device_pixel_ratio: new (0, $caapT.xt)(e1, t.u_device_pixel_ratio),
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_units_to_pixels: new (0, $caapT.Ct)(e1, t.u_units_to_pixels),
        u_scale: new (0, $caapT.wt)(e1, t.u_scale),
        u_fade: new (0, $caapT.xt)(e1, t.u_fade)
    }), $902e455d852cdfb8$var$gl = (e1, t)=>({
        u_translation: new (0, $caapT.Ct)(e1, t.u_translation),
        u_ratio: new (0, $caapT.xt)(e1, t.u_ratio),
        u_device_pixel_ratio: new (0, $caapT.xt)(e1, t.u_device_pixel_ratio),
        u_units_to_pixels: new (0, $caapT.Ct)(e1, t.u_units_to_pixels),
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_mix: new (0, $caapT.xt)(e1, t.u_mix),
        u_tileratio: new (0, $caapT.xt)(e1, t.u_tileratio),
        u_crossfade_from: new (0, $caapT.xt)(e1, t.u_crossfade_from),
        u_crossfade_to: new (0, $caapT.xt)(e1, t.u_crossfade_to),
        u_lineatlas_width: new (0, $caapT.xt)(e1, t.u_lineatlas_width),
        u_lineatlas_height: new (0, $caapT.xt)(e1, t.u_lineatlas_height)
    }), $902e455d852cdfb8$var$_l = (e1, t)=>({
        u_translation: new (0, $caapT.Ct)(e1, t.u_translation),
        u_ratio: new (0, $caapT.xt)(e1, t.u_ratio),
        u_device_pixel_ratio: new (0, $caapT.xt)(e1, t.u_device_pixel_ratio),
        u_units_to_pixels: new (0, $caapT.Ct)(e1, t.u_units_to_pixels),
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_image_height: new (0, $caapT.xt)(e1, t.u_image_height),
        u_tileratio: new (0, $caapT.xt)(e1, t.u_tileratio),
        u_crossfade_from: new (0, $caapT.xt)(e1, t.u_crossfade_from),
        u_crossfade_to: new (0, $caapT.xt)(e1, t.u_crossfade_to),
        u_image_dash: new (0, $caapT.St)(e1, t.u_image_dash),
        u_mix: new (0, $caapT.xt)(e1, t.u_mix),
        u_lineatlas_width: new (0, $caapT.xt)(e1, t.u_lineatlas_width),
        u_lineatlas_height: new (0, $caapT.xt)(e1, t.u_lineatlas_height)
    }), $902e455d852cdfb8$var$vl = (e1, t, n, r)=>{
    let i = e1.transform;
    return {
        u_translation: $902e455d852cdfb8$var$wl(e1, t, n),
        u_ratio: r / (0, $caapT.Nr)(t, 1, i.zoom),
        u_device_pixel_ratio: e1.pixelRatio,
        u_units_to_pixels: [
            1 / i.pixelsToGLUnits[0],
            1 / i.pixelsToGLUnits[1]
        ]
    };
}, $902e455d852cdfb8$var$yl = (e1, t, n, r, i)=>(0, $caapT.Zn)($902e455d852cdfb8$var$vl(e1, t, n, r), {
        u_image: 0,
        u_image_height: i
    }), $902e455d852cdfb8$var$bl = (e1, t, n, r, i)=>{
    let a = e1.transform, o = $902e455d852cdfb8$var$Cl(t, a);
    return {
        u_translation: $902e455d852cdfb8$var$wl(e1, t, n),
        u_texsize: t.imageAtlasTexture.size,
        u_ratio: r / (0, $caapT.Nr)(t, 1, a.zoom),
        u_device_pixel_ratio: e1.pixelRatio,
        u_image: 0,
        u_scale: [
            o,
            i.fromScale,
            i.toScale
        ],
        u_fade: i.t,
        u_units_to_pixels: [
            1 / a.pixelsToGLUnits[0],
            1 / a.pixelsToGLUnits[1]
        ]
    };
}, $902e455d852cdfb8$var$xl = (e1, t, n, r, i)=>{
    let a = e1.transform, o = $902e455d852cdfb8$var$Cl(t, a);
    return (0, $caapT.Zn)($902e455d852cdfb8$var$vl(e1, t, n, r), {
        u_tileratio: o,
        u_crossfade_from: i.fromScale,
        u_crossfade_to: i.toScale,
        u_image: 0,
        u_mix: i.t,
        u_lineatlas_width: e1.lineAtlas.width,
        u_lineatlas_height: e1.lineAtlas.height
    });
}, $902e455d852cdfb8$var$Sl = (e1, t, n, r, i, a)=>{
    let o = e1.transform, s = $902e455d852cdfb8$var$Cl(t, o);
    return (0, $caapT.Zn)($902e455d852cdfb8$var$vl(e1, t, n, r), {
        u_image: 0,
        u_image_height: a,
        u_tileratio: s,
        u_crossfade_from: i.fromScale,
        u_crossfade_to: i.toScale,
        u_image_dash: 1,
        u_mix: i.t,
        u_lineatlas_width: e1.lineAtlas.width,
        u_lineatlas_height: e1.lineAtlas.height
    });
};
function $902e455d852cdfb8$var$Cl(e1, t) {
    return 1 / (0, $caapT.Nr)(e1, 1, t.tileZoom);
}
function $902e455d852cdfb8$var$wl(e1, t, n) {
    return (0, $caapT.Or)(e1.transform, t, n.paint.get(`line-translate`), n.paint.get(`line-translate-anchor`));
}
const $902e455d852cdfb8$var$Tl = (e1, t)=>({
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_opacity: new (0, $caapT.xt)(e1, t.u_opacity)
    }), $902e455d852cdfb8$var$El = (e1, t)=>({
        u_image: t,
        u_opacity: e1
    }), $902e455d852cdfb8$var$Dl = (e1, t)=>({
        u_tl_parent: new (0, $caapT.Ct)(e1, t.u_tl_parent),
        u_scale_parent: new (0, $caapT.xt)(e1, t.u_scale_parent),
        u_buffer_scale: new (0, $caapT.xt)(e1, t.u_buffer_scale),
        u_fade_t: new (0, $caapT.xt)(e1, t.u_fade_t),
        u_opacity: new (0, $caapT.xt)(e1, t.u_opacity),
        u_image0: new (0, $caapT.St)(e1, t.u_image0),
        u_image1: new (0, $caapT.St)(e1, t.u_image1),
        u_brightness_low: new (0, $caapT.xt)(e1, t.u_brightness_low),
        u_brightness_high: new (0, $caapT.xt)(e1, t.u_brightness_high),
        u_saturation_factor: new (0, $caapT.xt)(e1, t.u_saturation_factor),
        u_contrast_factor: new (0, $caapT.xt)(e1, t.u_contrast_factor),
        u_spin_weights: new (0, $caapT.wt)(e1, t.u_spin_weights),
        u_coords_top: new (0, $caapT.Tt)(e1, t.u_coords_top),
        u_coords_bottom: new (0, $caapT.Tt)(e1, t.u_coords_bottom)
    }), $902e455d852cdfb8$var$Ol = (e1, t, n, r, i)=>({
        u_tl_parent: e1,
        u_scale_parent: t,
        u_buffer_scale: 1,
        u_fade_t: n.mix,
        u_opacity: n.opacity * r.paint.get(`raster-opacity`),
        u_image0: 0,
        u_image1: 1,
        u_brightness_low: r.paint.get(`raster-brightness-min`),
        u_brightness_high: r.paint.get(`raster-brightness-max`),
        u_saturation_factor: $902e455d852cdfb8$var$jl(r.paint.get(`raster-saturation`)),
        u_contrast_factor: $902e455d852cdfb8$var$Al(r.paint.get(`raster-contrast`)),
        u_spin_weights: $902e455d852cdfb8$var$kl(r.paint.get(`raster-hue-rotate`)),
        u_coords_top: [
            i[0].x,
            i[0].y,
            i[1].x,
            i[1].y
        ],
        u_coords_bottom: [
            i[3].x,
            i[3].y,
            i[2].x,
            i[2].y
        ]
    });
function $902e455d852cdfb8$var$kl(e1) {
    e1 *= Math.PI / 180;
    let t = Math.sin(e1), n = Math.cos(e1);
    return [
        (2 * n + 1) / 3,
        (-Math.sqrt(3) * t - n + 1) / 3,
        (Math.sqrt(3) * t - n + 1) / 3
    ];
}
function $902e455d852cdfb8$var$Al(e1) {
    return e1 > 0 ? 1 / (1 - e1) : 1 + e1;
}
function $902e455d852cdfb8$var$jl(e1) {
    return e1 > 0 ? 1 - 1 / (1.001 - e1) : -e1;
}
const $902e455d852cdfb8$var$Ml = (e1, t)=>({
        u_is_size_zoom_constant: new (0, $caapT.St)(e1, t.u_is_size_zoom_constant),
        u_is_size_feature_constant: new (0, $caapT.St)(e1, t.u_is_size_feature_constant),
        u_size_t: new (0, $caapT.xt)(e1, t.u_size_t),
        u_size: new (0, $caapT.xt)(e1, t.u_size),
        u_camera_to_center_distance: new (0, $caapT.xt)(e1, t.u_camera_to_center_distance),
        u_pitch: new (0, $caapT.xt)(e1, t.u_pitch),
        u_rotate_symbol: new (0, $caapT.St)(e1, t.u_rotate_symbol),
        u_aspect_ratio: new (0, $caapT.xt)(e1, t.u_aspect_ratio),
        u_fade_change: new (0, $caapT.xt)(e1, t.u_fade_change),
        u_label_plane_matrix: new (0, $caapT.kt)(e1, t.u_label_plane_matrix),
        u_coord_matrix: new (0, $caapT.kt)(e1, t.u_coord_matrix),
        u_is_text: new (0, $caapT.St)(e1, t.u_is_text),
        u_pitch_with_map: new (0, $caapT.St)(e1, t.u_pitch_with_map),
        u_is_along_line: new (0, $caapT.St)(e1, t.u_is_along_line),
        u_is_variable_anchor: new (0, $caapT.St)(e1, t.u_is_variable_anchor),
        u_texsize: new (0, $caapT.Ct)(e1, t.u_texsize),
        u_texture: new (0, $caapT.St)(e1, t.u_texture),
        u_translation: new (0, $caapT.Ct)(e1, t.u_translation),
        u_pitched_scale: new (0, $caapT.xt)(e1, t.u_pitched_scale),
        u_is_offset: new (0, $caapT.St)(e1, t.u_is_offset)
    }), $902e455d852cdfb8$var$Nl = (e1, t)=>({
        u_is_size_zoom_constant: new (0, $caapT.St)(e1, t.u_is_size_zoom_constant),
        u_is_size_feature_constant: new (0, $caapT.St)(e1, t.u_is_size_feature_constant),
        u_size_t: new (0, $caapT.xt)(e1, t.u_size_t),
        u_size: new (0, $caapT.xt)(e1, t.u_size),
        u_camera_to_center_distance: new (0, $caapT.xt)(e1, t.u_camera_to_center_distance),
        u_pitch: new (0, $caapT.xt)(e1, t.u_pitch),
        u_rotate_symbol: new (0, $caapT.St)(e1, t.u_rotate_symbol),
        u_aspect_ratio: new (0, $caapT.xt)(e1, t.u_aspect_ratio),
        u_fade_change: new (0, $caapT.xt)(e1, t.u_fade_change),
        u_label_plane_matrix: new (0, $caapT.kt)(e1, t.u_label_plane_matrix),
        u_coord_matrix: new (0, $caapT.kt)(e1, t.u_coord_matrix),
        u_is_text: new (0, $caapT.St)(e1, t.u_is_text),
        u_pitch_with_map: new (0, $caapT.St)(e1, t.u_pitch_with_map),
        u_is_along_line: new (0, $caapT.St)(e1, t.u_is_along_line),
        u_is_variable_anchor: new (0, $caapT.St)(e1, t.u_is_variable_anchor),
        u_texsize: new (0, $caapT.Ct)(e1, t.u_texsize),
        u_texture: new (0, $caapT.St)(e1, t.u_texture),
        u_gamma_scale: new (0, $caapT.xt)(e1, t.u_gamma_scale),
        u_device_pixel_ratio: new (0, $caapT.xt)(e1, t.u_device_pixel_ratio),
        u_is_halo: new (0, $caapT.St)(e1, t.u_is_halo),
        u_is_plain: new (0, $caapT.St)(e1, t.u_is_plain),
        u_translation: new (0, $caapT.Ct)(e1, t.u_translation),
        u_pitched_scale: new (0, $caapT.xt)(e1, t.u_pitched_scale),
        u_is_offset: new (0, $caapT.St)(e1, t.u_is_offset)
    }), $902e455d852cdfb8$var$Pl = (e1, t)=>({
        u_is_size_zoom_constant: new (0, $caapT.St)(e1, t.u_is_size_zoom_constant),
        u_is_size_feature_constant: new (0, $caapT.St)(e1, t.u_is_size_feature_constant),
        u_size_t: new (0, $caapT.xt)(e1, t.u_size_t),
        u_size: new (0, $caapT.xt)(e1, t.u_size),
        u_camera_to_center_distance: new (0, $caapT.xt)(e1, t.u_camera_to_center_distance),
        u_pitch: new (0, $caapT.xt)(e1, t.u_pitch),
        u_rotate_symbol: new (0, $caapT.St)(e1, t.u_rotate_symbol),
        u_aspect_ratio: new (0, $caapT.xt)(e1, t.u_aspect_ratio),
        u_fade_change: new (0, $caapT.xt)(e1, t.u_fade_change),
        u_label_plane_matrix: new (0, $caapT.kt)(e1, t.u_label_plane_matrix),
        u_coord_matrix: new (0, $caapT.kt)(e1, t.u_coord_matrix),
        u_is_text: new (0, $caapT.St)(e1, t.u_is_text),
        u_pitch_with_map: new (0, $caapT.St)(e1, t.u_pitch_with_map),
        u_is_along_line: new (0, $caapT.St)(e1, t.u_is_along_line),
        u_is_variable_anchor: new (0, $caapT.St)(e1, t.u_is_variable_anchor),
        u_texsize: new (0, $caapT.Ct)(e1, t.u_texsize),
        u_texsize_icon: new (0, $caapT.Ct)(e1, t.u_texsize_icon),
        u_texture: new (0, $caapT.St)(e1, t.u_texture),
        u_texture_icon: new (0, $caapT.St)(e1, t.u_texture_icon),
        u_gamma_scale: new (0, $caapT.xt)(e1, t.u_gamma_scale),
        u_device_pixel_ratio: new (0, $caapT.xt)(e1, t.u_device_pixel_ratio),
        u_is_halo: new (0, $caapT.St)(e1, t.u_is_halo),
        u_translation: new (0, $caapT.Ct)(e1, t.u_translation),
        u_pitched_scale: new (0, $caapT.xt)(e1, t.u_pitched_scale),
        u_is_offset: new (0, $caapT.St)(e1, t.u_is_offset)
    }), $902e455d852cdfb8$var$Fl = (e1, t, n, r, i, a, o, s, c, l, u, d, f, p)=>{
    let m = o.transform;
    return {
        u_is_size_zoom_constant: +(e1 === `constant` || e1 === `source`),
        u_is_size_feature_constant: +(e1 === `constant` || e1 === `camera`),
        u_size_t: t ? t.uSizeT : 0,
        u_size: t ? t.uSize : 0,
        u_camera_to_center_distance: m.cameraToCenterDistance,
        u_pitch: m.pitch / 360 * 2 * Math.PI,
        u_rotate_symbol: +n,
        u_aspect_ratio: m.width / m.height,
        u_fade_change: o.options.fadeDuration ? o.symbolFadeChange : 1,
        u_label_plane_matrix: s,
        u_coord_matrix: c,
        u_is_text: +u,
        u_pitch_with_map: +r,
        u_is_along_line: i,
        u_is_variable_anchor: a,
        u_texsize: d,
        u_texture: 0,
        u_translation: l,
        u_pitched_scale: f,
        u_is_offset: p
    };
}, $902e455d852cdfb8$var$Il = (e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m)=>{
    let h = o.transform;
    return (0, $caapT.Zn)($902e455d852cdfb8$var$Fl(e1, t, n, r, i, a, o, s, c, l, u, d, p, m), {
        u_gamma_scale: r ? Math.cos(h.pitch * Math.PI / 180) * h.cameraToCenterDistance : 1,
        u_device_pixel_ratio: o.pixelRatio,
        u_is_halo: +!!f,
        u_is_plain: 1
    });
}, $902e455d852cdfb8$var$Ll = (e1, t, n, r, i, a, o, s, c, l, u, d, f, p)=>(0, $caapT.Zn)($902e455d852cdfb8$var$Il(e1, t, n, r, i, a, o, s, c, l, !0, u, !0, f, p), {
        u_texsize_icon: d,
        u_texture_icon: 1
    }), $902e455d852cdfb8$var$Rl = (e1, t)=>({
        u_opacity: new (0, $caapT.xt)(e1, t.u_opacity),
        u_color: new (0, $caapT.Et)(e1, t.u_color)
    }), $902e455d852cdfb8$var$zl = (e1, t)=>({
        u_opacity: new (0, $caapT.xt)(e1, t.u_opacity),
        u_image: new (0, $caapT.St)(e1, t.u_image),
        u_pattern_tl_a: new (0, $caapT.Ct)(e1, t.u_pattern_tl_a),
        u_pattern_br_a: new (0, $caapT.Ct)(e1, t.u_pattern_br_a),
        u_pattern_tl_b: new (0, $caapT.Ct)(e1, t.u_pattern_tl_b),
        u_pattern_br_b: new (0, $caapT.Ct)(e1, t.u_pattern_br_b),
        u_texsize: new (0, $caapT.Ct)(e1, t.u_texsize),
        u_mix: new (0, $caapT.xt)(e1, t.u_mix),
        u_pattern_size_a: new (0, $caapT.Ct)(e1, t.u_pattern_size_a),
        u_pattern_size_b: new (0, $caapT.Ct)(e1, t.u_pattern_size_b),
        u_scale_a: new (0, $caapT.xt)(e1, t.u_scale_a),
        u_scale_b: new (0, $caapT.xt)(e1, t.u_scale_b),
        u_pixel_coord_upper: new (0, $caapT.Ct)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $caapT.Ct)(e1, t.u_pixel_coord_lower),
        u_tile_units_to_pixels: new (0, $caapT.xt)(e1, t.u_tile_units_to_pixels)
    }), $902e455d852cdfb8$var$Bl = (e1, t)=>({
        u_opacity: e1,
        u_color: t
    }), $902e455d852cdfb8$var$Vl = (e1, t, n, r, i)=>(0, $caapT.Zn)($902e455d852cdfb8$var$Fc(n, i, t, r), {
        u_opacity: e1
    }), $902e455d852cdfb8$var$Hl = (e1, t)=>({
        u_sun_pos: new (0, $caapT.wt)(e1, t.u_sun_pos),
        u_atmosphere_blend: new (0, $caapT.xt)(e1, t.u_atmosphere_blend),
        u_globe_position: new (0, $caapT.wt)(e1, t.u_globe_position),
        u_globe_radius: new (0, $caapT.xt)(e1, t.u_globe_radius),
        u_inv_proj_matrix: new (0, $caapT.kt)(e1, t.u_inv_proj_matrix)
    }), $902e455d852cdfb8$var$Ul = (e1, t, n, r, i)=>({
        u_sun_pos: e1,
        u_atmosphere_blend: t,
        u_globe_position: n,
        u_globe_radius: r,
        u_inv_proj_matrix: i
    }), $902e455d852cdfb8$var$Wl = (e1, t)=>({
        u_sky_color: new (0, $caapT.Et)(e1, t.u_sky_color),
        u_horizon_color: new (0, $caapT.Et)(e1, t.u_horizon_color),
        u_horizon: new (0, $caapT.Ct)(e1, t.u_horizon),
        u_horizon_normal: new (0, $caapT.Ct)(e1, t.u_horizon_normal),
        u_sky_horizon_blend: new (0, $caapT.xt)(e1, t.u_sky_horizon_blend),
        u_sky_blend: new (0, $caapT.xt)(e1, t.u_sky_blend)
    }), $902e455d852cdfb8$var$Gl = (e1, t, n)=>{
    let r = Math.cos(t.rollInRadians), i = Math.sin(t.rollInRadians), a = $902e455d852cdfb8$var$Ea(t), o = t.getProjectionData({
        overscaledTileID: null,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    }).projectionTransition;
    return {
        u_sky_color: e1.properties.get(`sky-color`),
        u_horizon_color: e1.properties.get(`horizon-color`),
        u_horizon: [
            (t.width / 2 - a * i) * n,
            (t.height / 2 + a * r) * n
        ],
        u_horizon_normal: [
            -i,
            r
        ],
        u_sky_horizon_blend: e1.properties.get(`sky-horizon-blend`) * t.height / 2 * n,
        u_sky_blend: o
    };
}, $902e455d852cdfb8$var$Kl = (e1, t)=>{}, $902e455d852cdfb8$var$ql = {
    fillExtrusion: $902e455d852cdfb8$var$Ic,
    fillExtrusionPattern: $902e455d852cdfb8$var$Lc,
    fill: $902e455d852cdfb8$var$Bc,
    fillPattern: $902e455d852cdfb8$var$Vc,
    fillOutline: $902e455d852cdfb8$var$Hc,
    fillOutlinePattern: $902e455d852cdfb8$var$Uc,
    circle: $902e455d852cdfb8$var$Jc,
    collisionBox: $902e455d852cdfb8$var$Xc,
    collisionCircle: $902e455d852cdfb8$var$Zc,
    debug: $902e455d852cdfb8$var$el,
    depth: $902e455d852cdfb8$var$Kl,
    clippingMask: $902e455d852cdfb8$var$Kl,
    heatmap: $902e455d852cdfb8$var$nl,
    heatmapTexture: $902e455d852cdfb8$var$rl,
    hillshade: $902e455d852cdfb8$var$ol,
    hillshadePrepare: $902e455d852cdfb8$var$sl,
    colorRelief: $902e455d852cdfb8$var$dl,
    line: $902e455d852cdfb8$var$pl,
    lineGradient: $902e455d852cdfb8$var$ml,
    linePattern: $902e455d852cdfb8$var$hl,
    lineSDF: $902e455d852cdfb8$var$gl,
    lineGradientSDF: $902e455d852cdfb8$var$_l,
    layerOpacity: $902e455d852cdfb8$var$Tl,
    raster: $902e455d852cdfb8$var$Dl,
    symbolIcon: $902e455d852cdfb8$var$Ml,
    symbolSDF: $902e455d852cdfb8$var$Nl,
    symbolTextAndIcon: $902e455d852cdfb8$var$Pl,
    background: $902e455d852cdfb8$var$Rl,
    backgroundPattern: $902e455d852cdfb8$var$zl,
    terrain: $902e455d852cdfb8$var$wc,
    terrainDepth: $902e455d852cdfb8$var$Tc,
    terrainCoords: $902e455d852cdfb8$var$Ec,
    projectionErrorMeasurement: $902e455d852cdfb8$var$Is,
    atmosphere: $902e455d852cdfb8$var$Hl,
    sky: $902e455d852cdfb8$var$Wl
};
var $902e455d852cdfb8$var$Jl = class {
    constructor(e1, t, n){
        this.context = e1;
        let r = e1.gl;
        this.buffer = r.createBuffer(), this.dynamicDraw = !!n, this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), r.bufferData(r.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
    }
    bind() {
        this.context.bindElementBuffer.set(this.buffer);
    }
    updateData(e1) {
        let t = this.context.gl;
        if (!this.dynamicDraw) throw Error(`Attempted to update data while not in dynamic mode.`);
        this.context.unbindVAO(), this.bind(), t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
};
const $902e455d852cdfb8$var$Yl = {
    Int8: `BYTE`,
    Uint8: `UNSIGNED_BYTE`,
    Int16: `SHORT`,
    Uint16: `UNSIGNED_SHORT`,
    Int32: `INT`,
    Uint32: `UNSIGNED_INT`,
    Float32: `FLOAT`
};
var $902e455d852cdfb8$var$Xl = class {
    constructor(e1, t, n, r){
        this.length = t.length, this.attributes = n, this.itemSize = t.bytesPerElement, this.dynamicDraw = r, this.context = e1;
        let i = e1.gl;
        this.buffer = i.createBuffer(), e1.bindVertexBuffer.set(this.buffer), i.bufferData(i.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? i.DYNAMIC_DRAW : i.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
    }
    bind() {
        this.context.bindVertexBuffer.set(this.buffer);
    }
    updateData(e1) {
        if (e1.length !== this.length) throw Error(`Length of new data is ${e1.length}, which doesn't match current length of ${this.length}`);
        let t = this.context.gl;
        this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e1.arrayBuffer);
    }
    enableAttributes(e1, t) {
        for (let n of this.attributes){
            let r = t.attributes[n.name];
            r !== void 0 && e1.enableVertexAttribArray(r);
        }
    }
    setVertexAttribPointers(e1, t, n) {
        for (let r of this.attributes){
            let i = t.attributes[r.name];
            i !== void 0 && e1.vertexAttribPointer(i, r.components, e1[$902e455d852cdfb8$var$Yl[r.type]], !1, this.itemSize, r.offset + this.itemSize * (n || 0));
        }
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
}, $902e455d852cdfb8$var$$ = class {
    constructor(e1){
        this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
    }
    get() {
        return this.current;
    }
    set(e1) {}
    getDefault() {
        return this.default;
    }
    setDefault() {
        this.set(this.default);
    }
}, $902e455d852cdfb8$var$Zl = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return (0, $caapT.tn).transparent;
    }
    set(e1) {
        let t = this.current;
        e1.r === t.r && e1.g === t.g && e1.b === t.b && e1.a === t.a && !this.dirty || (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$Ql = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return 1;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$$l = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return 0;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$eu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return [
            !0,
            !0,
            !0,
            !0
        ];
    }
    set(e1) {
        let t = this.current;
        e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && !this.dirty || (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$tu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return !0;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$nu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return 255;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$ru = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return {
            func: this.gl.ALWAYS,
            ref: 0,
            mask: 255
        };
    }
    set(e1) {
        let t = this.current;
        e1.func === t.func && e1.ref === t.ref && e1.mask === t.mask && !this.dirty || (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$iu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        let e1 = this.gl;
        return [
            e1.KEEP,
            e1.KEEP,
            e1.KEEP
        ];
    }
    set(e1) {
        let t = this.current;
        e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && !this.dirty || (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$au = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$ou = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return [
            0,
            1
        ];
    }
    set(e1) {
        let t = this.current;
        e1[0] === t[0] && e1[1] === t[1] && !this.dirty || (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$su = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$cu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return this.gl.LESS;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$lu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$uu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        let e1 = this.gl;
        return [
            e1.ONE,
            e1.ZERO
        ];
    }
    set(e1) {
        let t = this.current;
        e1[0] === t[0] && e1[1] === t[1] && !this.dirty || (this.gl.blendFunc(e1[0], e1[1]), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$du = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return (0, $caapT.tn).transparent;
    }
    set(e1) {
        let t = this.current;
        e1.r === t.r && e1.g === t.g && e1.b === t.b && e1.a === t.a && !this.dirty || (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$fu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return this.gl.FUNC_ADD;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.blendEquation(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$pu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$mu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return this.gl.BACK;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$hu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return this.gl.CCW;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$gu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return null;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$_u = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return this.gl.TEXTURE0;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$vu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        let e1 = this.gl;
        return [
            0,
            0,
            e1.drawingBufferWidth,
            e1.drawingBufferHeight
        ];
    }
    set(e1) {
        let t = this.current;
        e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && !this.dirty || (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$yu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindFramebuffer(t.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$bu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindRenderbuffer(t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$xu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindTexture(t.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$Su = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindBuffer(t.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$Cu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return null;
    }
    set(e1) {
        let t = this.gl;
        t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$wu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return null;
    }
    set(e1) {
        e1 === this.current && !this.dirty || (this.gl.bindVertexArray(e1), this.current = e1, this.dirty = !1);
    }
}, $902e455d852cdfb8$var$Tu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return 4;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$Eu = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$Du = class extends $902e455d852cdfb8$var$$ {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$Ou = class extends $902e455d852cdfb8$var$$ {
    constructor(e1, t){
        super(e1), this.context = e1, this.parent = t;
    }
    getDefault() {
        return null;
    }
}, $902e455d852cdfb8$var$ku = class extends $902e455d852cdfb8$var$Ou {
    setDirty() {
        this.dirty = !0;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$Au = class extends $902e455d852cdfb8$var$Ou {
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$ju = class extends $902e455d852cdfb8$var$Ou {
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $902e455d852cdfb8$var$Mu = class {
    constructor(e1, t, n, r, i){
        this.context = e1, this.width = t, this.height = n;
        let a = e1.gl, o = this.framebuffer = a.createFramebuffer();
        if (this.colorAttachment = new $902e455d852cdfb8$var$ku(e1, o), r) this.depthAttachment = i ? new $902e455d852cdfb8$var$ju(e1, o) : new $902e455d852cdfb8$var$Au(e1, o);
        else if (i) throw Error(`Stencil cannot be set without depth`);
    }
    destroy() {
        let e1 = this.context.gl, t = this.colorAttachment.get();
        if (t && e1.deleteTexture(t), this.depthAttachment) {
            let t = this.depthAttachment.get();
            t && e1.deleteRenderbuffer(t);
        }
        e1.deleteFramebuffer(this.framebuffer);
    }
}, $902e455d852cdfb8$var$Nu = class {
    constructor(e1){
        this.gl = e1, this.clearColor = new $902e455d852cdfb8$var$Zl(this), this.clearDepth = new $902e455d852cdfb8$var$Ql(this), this.clearStencil = new $902e455d852cdfb8$var$$l(this), this.colorMask = new $902e455d852cdfb8$var$eu(this), this.depthMask = new $902e455d852cdfb8$var$tu(this), this.stencilMask = new $902e455d852cdfb8$var$nu(this), this.stencilFunc = new $902e455d852cdfb8$var$ru(this), this.stencilOp = new $902e455d852cdfb8$var$iu(this), this.stencilTest = new $902e455d852cdfb8$var$au(this), this.depthRange = new $902e455d852cdfb8$var$ou(this), this.depthTest = new $902e455d852cdfb8$var$su(this), this.depthFunc = new $902e455d852cdfb8$var$cu(this), this.blend = new $902e455d852cdfb8$var$lu(this), this.blendFunc = new $902e455d852cdfb8$var$uu(this), this.blendColor = new $902e455d852cdfb8$var$du(this), this.blendEquation = new $902e455d852cdfb8$var$fu(this), this.cullFace = new $902e455d852cdfb8$var$pu(this), this.cullFaceSide = new $902e455d852cdfb8$var$mu(this), this.frontFace = new $902e455d852cdfb8$var$hu(this), this.program = new $902e455d852cdfb8$var$gu(this), this.activeTexture = new $902e455d852cdfb8$var$_u(this), this.viewport = new $902e455d852cdfb8$var$vu(this), this.bindFramebuffer = new $902e455d852cdfb8$var$yu(this), this.bindRenderbuffer = new $902e455d852cdfb8$var$bu(this), this.bindTexture = new $902e455d852cdfb8$var$xu(this), this.bindVertexBuffer = new $902e455d852cdfb8$var$Su(this), this.bindElementBuffer = new $902e455d852cdfb8$var$Cu(this), this.bindVertexArray = new $902e455d852cdfb8$var$wu(this), this.pixelStoreUnpack = new $902e455d852cdfb8$var$Tu(this), this.pixelStoreUnpackPremultiplyAlpha = new $902e455d852cdfb8$var$Eu(this), this.pixelStoreUnpackFlipY = new $902e455d852cdfb8$var$Du(this), this.extTextureFilterAnisotropic = e1.getExtension(`EXT_texture_filter_anisotropic`), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), e1.getExtension(`EXT_color_buffer_half_float`), e1.getExtension(`EXT_color_buffer_float`);
    }
    setDefault() {
        this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
    }
    setDirty() {
        this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
    }
    createIndexBuffer(e1, t) {
        return new $902e455d852cdfb8$var$Jl(this, e1, t);
    }
    createVertexBuffer(e1, t, n) {
        return new $902e455d852cdfb8$var$Xl(this, e1, t, n);
    }
    createRenderbuffer(e1, t, n) {
        let r = this.gl, i = r.createRenderbuffer();
        return this.bindRenderbuffer.set(i), r.renderbufferStorage(r.RENDERBUFFER, e1, t, n), this.bindRenderbuffer.set(null), i;
    }
    createFramebuffer(e1, t, n, r) {
        return new $902e455d852cdfb8$var$Mu(this, e1, t, n, r);
    }
    clear({ color: e1, depth: t, stencil: n }) {
        let r = this.gl, i = 0;
        e1 && (i |= r.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
            !0,
            !0,
            !0,
            !0
        ])), t !== void 0 && (i |= r.DEPTH_BUFFER_BIT, this.depthRange.set([
            0,
            1
        ]), this.clearDepth.set(t), this.depthMask.set(!0)), n !== void 0 && (i |= r.STENCIL_BUFFER_BIT, this.clearStencil.set(n), this.stencilMask.set(255)), r.clear(i);
    }
    setCullFace(e1) {
        e1.enable === !1 ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
    }
    setDepthMode(e1) {
        e1.func === this.gl.ALWAYS && !e1.mask ? this.depthTest.set(!1) : (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range));
    }
    setStencilMode(e1) {
        e1.test.func === this.gl.ALWAYS && !e1.mask ? this.stencilTest.set(!1) : (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
            e1.fail,
            e1.depthFail,
            e1.pass
        ]), this.stencilFunc.set({
            func: e1.test.func,
            ref: e1.ref,
            mask: e1.test.mask
        }));
    }
    setColorMode(e1) {
        (0, $caapT.Un)(e1.blendFunction, $902e455d852cdfb8$var$Y.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
    }
    createVertexArray() {
        return this.gl.createVertexArray();
    }
    deleteVertexArray(e1) {
        this.gl.deleteVertexArray(e1);
    }
    unbindVAO() {
        this.bindVertexArray.set(null);
    }
};
let $902e455d852cdfb8$var$Pu;
function $902e455d852cdfb8$var$Fu(e1, t, n, r, i) {
    let a = e1.context, s = e1.transform, c = a.gl, l = e1.useProgram(`collisionBox`), u = [], d = 0, f = 0;
    for (let o of r){
        let r = t.getTile(o).getBucket(n);
        if (!r) continue;
        let p = i ? r.textCollisionBox : r.iconCollisionBox, m = r.collisionCircleArray;
        m.length > 0 && (u.push({
            circleArray: m,
            circleOffset: f,
            coord: o
        }), d += m.length / 4, f = d), p && l.draw(a, c.LINES, $902e455d852cdfb8$var$Z.disabled, $902e455d852cdfb8$var$Q.disabled, e1.colorModeForRenderPass(), $902e455d852cdfb8$var$X.disabled, $902e455d852cdfb8$var$Qc(e1.transform), e1.style.map.terrain?.getTerrainData(o), s.getProjectionData({
            overscaledTileID: o,
            applyGlobeMatrix: !0,
            applyTerrainMatrix: !0
        }), n.id, p.layoutVertexBuffer, p.indexBuffer, p.segments, null, e1.transform.zoom, null, null, p.collisionVertexBuffer);
    }
    if (!i || !u.length) return;
    let p = e1.useProgram(`collisionCircle`), m = new (0, $caapT.Mt);
    m.resize(d * 4), m._trim();
    let h = 0;
    for (let e1 of u)for(let t = 0; t < e1.circleArray.length / 4; t++){
        let n = t * 4, r = e1.circleArray[n + 0], i = e1.circleArray[n + 1], a = e1.circleArray[n + 2], o = e1.circleArray[n + 3];
        m.emplace(h++, r, i, a, o, 0), m.emplace(h++, r, i, a, o, 1), m.emplace(h++, r, i, a, o, 2), m.emplace(h++, r, i, a, o, 3);
    }
    (!$902e455d852cdfb8$var$Pu || $902e455d852cdfb8$var$Pu.length < d * 2) && ($902e455d852cdfb8$var$Pu = $902e455d852cdfb8$var$Iu(d));
    let g = a.createIndexBuffer($902e455d852cdfb8$var$Pu, !0), _ = a.createVertexBuffer(m, (0, $caapT.X).members, !0);
    for (let t of u){
        let r = $902e455d852cdfb8$var$$c(e1.transform);
        p.draw(a, c.TRIANGLES, $902e455d852cdfb8$var$Z.disabled, $902e455d852cdfb8$var$Q.disabled, e1.colorModeForRenderPass(), $902e455d852cdfb8$var$X.disabled, r, e1.style.map.terrain?.getTerrainData(t.coord), null, n.id, _, g, (0, $caapT.At).simpleSegment(0, t.circleOffset * 2, t.circleArray.length, t.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
    }
    _.destroy(), g.destroy();
}
function $902e455d852cdfb8$var$Iu(e1) {
    let t = e1 * 2, n = new (0, $caapT.It);
    n.resize(t), n._trim();
    for(let e1 = 0; e1 < t; e1++){
        let t = e1 * 6;
        n.uint16[t + 0] = e1 * 4 + 0, n.uint16[t + 1] = e1 * 4 + 1, n.uint16[t + 2] = e1 * 4 + 2, n.uint16[t + 3] = e1 * 4 + 2, n.uint16[t + 4] = e1 * 4 + 3, n.uint16[t + 5] = e1 * 4 + 0;
    }
    return n;
}
const $902e455d852cdfb8$var$Lu = (0, $caapT.gi)(new Float32Array(16));
function $902e455d852cdfb8$var$Ru(e1, t, n, r, i, a) {
    if (e1.renderPass !== `translucent`) return;
    let { isRenderingToTexture: o } = a, s = $902e455d852cdfb8$var$Q.disabled, c = e1.colorModeForRenderPass();
    (n._unevaluatedLayout.hasValue(`text-variable-anchor`) || n._unevaluatedLayout.hasValue(`text-variable-anchor-offset`)) && $902e455d852cdfb8$var$Bu(r, e1, n, t, n.layout.get(`text-rotation-alignment`), n.layout.get(`text-pitch-alignment`), n.paint.get(`text-translate`), n.paint.get(`text-translate-anchor`), i), n.paint.get(`icon-opacity`).constantOr(1) !== 0 && $902e455d852cdfb8$var$Wu(e1, t, n, r, !1, n.paint.get(`icon-translate`), n.paint.get(`icon-translate-anchor`), n.layout.get(`icon-rotation-alignment`), n.layout.get(`icon-pitch-alignment`), n.layout.get(`icon-keep-upright`), s, c, o), n.paint.get(`text-opacity`).constantOr(1) !== 0 && $902e455d852cdfb8$var$Wu(e1, t, n, r, !0, n.paint.get(`text-translate`), n.paint.get(`text-translate-anchor`), n.layout.get(`text-rotation-alignment`), n.layout.get(`text-pitch-alignment`), n.layout.get(`text-keep-upright`), s, c, o), t.map.showCollisionBoxes && ($902e455d852cdfb8$var$Fu(e1, t, n, r, !0), $902e455d852cdfb8$var$Fu(e1, t, n, r, !1));
}
function $902e455d852cdfb8$var$zu(e1, t, n, r, i, a) {
    let { horizontalAlign: o, verticalAlign: s } = (0, $caapT.U)(e1), c = -(o - .5) * t, l = -(s - .5) * n;
    return new (0, $caapT.ji)((c / i + r[0]) * a, (l / i + r[1]) * a);
}
function $902e455d852cdfb8$var$Bu(e1, t, n, r, i, a, o, s, c) {
    let l = t.transform, u = t.style.map.terrain, d = i === `map`, f = a === `map`;
    for (let i of e1){
        let e1 = r.getTile(i), a = e1.getBucket(n);
        if (!a?.text?.segments.get().length) continue;
        let p = a.textSizeData, m = (0, $caapT.V)(p, l.zoom), h = (0, $caapT.Nr)(e1, 1, t.transform.zoom), g = $902e455d852cdfb8$var$to(d, t.transform, h), _ = n.layout.get(`icon-text-fit`) !== `none` && a.hasIconData();
        if (m) {
            let t = 2 ** (l.zoom - e1.tileID.overscaledZ), n = u ? (e1, t)=>u.getElevation(i, e1, t) : null;
            $902e455d852cdfb8$var$Hu(a, d, f, c, l, g, t, m, _, (0, $caapT.Or)(l, e1, o, s), i.toUnwrapped(), n);
        }
    }
}
function $902e455d852cdfb8$var$Vu(e1, t, n, r, i, a) {
    let o = t.tileAnchorPoint.add(new (0, $caapT.ji)(t.translation[0], t.translation[1]));
    if (t.pitchWithMap) {
        let e1 = r.mult(a);
        n || (e1 = e1.rotate(-i));
        let s = o.add(e1);
        return $902e455d852cdfb8$var$io(s.x, s.y, t.pitchedLabelPlaneMatrix, t.getElevation).point;
    } else if (n) {
        let n = $902e455d852cdfb8$var$mo(t.tileAnchorPoint.x + 1, t.tileAnchorPoint.y, t).point.sub(e1), i = Math.atan(n.y / n.x) + (n.x < 0 ? Math.PI : 0);
        return e1.add(r.rotate(i));
    } else return e1.add(r);
}
function $902e455d852cdfb8$var$Hu(e1, t, n, r, i, a, o, c, l, u, d, f) {
    let p = e1.text.placedSymbolArray, m = e1.text.dynamicLayoutVertexArray, h = e1.icon.dynamicLayoutVertexArray, g = {};
    m.clear();
    for(let h = 0; h < p.length; h++){
        let _ = p.get(h), v = e1.allowVerticalPlacement && !_.placedOrientation, y = !_.hidden && _.crossTileID && !v ? r[_.crossTileID] : null;
        if (!y) $902e455d852cdfb8$var$xo(_.numGlyphs, m);
        else {
            let r = new (0, $caapT.ji)(_.anchorX, _.anchorY), p = {
                getElevation: f,
                width: i.width,
                height: i.height,
                pitchedLabelPlaneMatrix: a,
                lineVertexArray: null,
                pitchWithMap: n,
                transform: i,
                projectionCache: null,
                tileAnchorPoint: r,
                translation: u,
                unwrappedTileID: d
            }, h = n ? $902e455d852cdfb8$var$go(r.x, r.y, p) : $902e455d852cdfb8$var$mo(r.x, r.y, p), v = $902e455d852cdfb8$var$ao(i.cameraToCenterDistance, h.signedDistanceFromCamera), b = (0, $caapT.B)(e1.textSizeData, c, _) * v / 24;
            n && (b *= e1.tilePixelRatio / o);
            let { width: x, height: S, anchor: C, textOffset: w, textBoxScale: T } = y, ee = $902e455d852cdfb8$var$zu(C, x, S, w, T, b), E = i.getPitchedTextCorrection(r.x + u[0], r.y + u[1], d), D = $902e455d852cdfb8$var$Vu(h.point, p, t, ee, -i.bearingInRadians, E), O = e1.allowVerticalPlacement && _.placedOrientation === 2 ? Math.PI / 2 : 0;
            for(let e1 = 0; e1 < _.numGlyphs; e1++)(0, $caapT.R)(m, D, O);
            l && _.associatedIconIndex >= 0 && (g[_.associatedIconIndex] = {
                shiftedAnchor: D,
                angle: O
            });
        }
    }
    if (l) {
        h.clear();
        let t = e1.icon.placedSymbolArray;
        for(let e1 = 0; e1 < t.length; e1++){
            let n = t.get(e1);
            if (n.hidden) $902e455d852cdfb8$var$xo(n.numGlyphs, h);
            else {
                let t = g[e1];
                if (!t) $902e455d852cdfb8$var$xo(n.numGlyphs, h);
                else for(let e1 = 0; e1 < n.numGlyphs; e1++)(0, $caapT.R)(h, t.shiftedAnchor, t.angle);
            }
        }
        e1.icon.dynamicLayoutVertexBuffer.updateData(h);
    }
    e1.text.dynamicLayoutVertexBuffer.updateData(m);
}
function $902e455d852cdfb8$var$Uu(e1, t, n) {
    return n.iconsInText && t ? `symbolTextAndIcon` : e1 ? `symbolSDF` : `symbolIcon`;
}
function $902e455d852cdfb8$var$Wu(e1, t, n, r, i, a, s, c, l, u, d, f, p) {
    let m = e1.context, h = m.gl, g = e1.transform, _ = c === `map`, v = l === `map`, y = c !== `viewport` && n.layout.get(`symbol-placement`) !== `point`, b = _ && !v && !y, x = !n.layout.get(`symbol-sort-key`).isConstant(), S = !1, C = e1.getDepthModeForSublayer(0, $902e455d852cdfb8$var$Z.ReadOnly), w = n._unevaluatedLayout.hasValue(`text-variable-anchor`) || n._unevaluatedLayout.hasValue(`text-variable-anchor-offset`), T = [], ee = g.getCircleRadiusCorrection();
    for (let c of r){
        let r = t.getTile(c), l = r.getBucket(n);
        if (!l) continue;
        let d = i ? l.text : l.icon;
        if (!d?.segments.get().length || !d.hasVisibleVertices) continue;
        let f = d.programConfigurations.get(n.id), m = i || l.sdfIcons, C = i ? l.textSizeData : l.iconSizeData, E = v || g.pitch !== 0, D = e1.useProgram($902e455d852cdfb8$var$Uu(m, i, l), f), O = (0, $caapT.V)(C, g.zoom), te = e1.style.map.terrain?.getTerrainData(c), k, A = [
            0,
            0
        ], ne, re, ie = null, ae;
        if (i) {
            if (ne = r.glyphAtlasTexture, re = h.LINEAR, k = r.glyphAtlasTexture.size, l.iconsInText) {
                A = r.imageAtlasTexture.size, ie = r.imageAtlasTexture;
                let t = C.kind === `composite` || C.kind === `camera`;
                ae = E || e1.options.rotating || e1.options.zooming || t ? h.LINEAR : h.NEAREST;
            }
        } else {
            let t = n.layout.get(`icon-size`).constantOr(0) !== 1 || l.iconsNeedLinear;
            ne = r.imageAtlasTexture, re = m || e1.options.rotating || e1.options.zooming || t || E ? h.LINEAR : h.NEAREST, k = r.imageAtlasTexture.size;
        }
        let oe = (0, $caapT.Nr)(r, 1, e1.transform.zoom), j = $902e455d852cdfb8$var$to(_, e1.transform, oe), se = $902e455d852cdfb8$var$no(v, _, e1.transform, oe), ce = (0, $caapT.Or)(g, r, a, s), le = g.getProjectionData({
            overscaledTileID: c,
            applyGlobeMatrix: !p,
            applyTerrainMatrix: !0
        }), ue = w && l.hasTextData(), de = n.layout.get(`icon-text-fit`) !== `none` && ue && l.hasIconData(), fe = n._unevaluatedLayout.hasValue(`icon-offset`);
        if (y) {
            let t = (0, $caapT.fi)();
            $902e455d852cdfb8$var$Za(t, j);
            let r = e1.style.map.terrain ? (t, n)=>e1.style.map.terrain.getElevation(c, t, n) : null;
            $902e455d852cdfb8$var$so(l, e1, i, j, t, v, u, n.layout.get(`text-rotation-alignment`) === `map`, c.toUnwrapped(), g.width, g.height, ce, r);
        }
        let pe = i && w || de, me = v ? j : e1.transform.clipSpaceToPixelsMatrix, he = y || pe ? $902e455d852cdfb8$var$Lu : me, ge = m && n.paint.get(i ? `text-halo-width` : `icon-halo-width`).constantOr(1) !== 0, _e;
        _e = m ? l.iconsInText ? $902e455d852cdfb8$var$Ll(C.kind, O, b, v, y, pe, e1, he, se, ce, k, A, ee, fe) : $902e455d852cdfb8$var$Il(C.kind, O, b, v, y, pe, e1, he, se, ce, i, k, ge, ee, fe) : $902e455d852cdfb8$var$Fl(C.kind, O, b, v, y, pe, e1, he, se, ce, i, k, ee, fe);
        let ve = {
            program: D,
            buffers: d,
            uniformValues: _e,
            projectionData: le,
            atlasTexture: ne,
            atlasTextureIcon: ie,
            atlasInterpolation: re,
            atlasInterpolationIcon: ae,
            isSDF: m,
            hasHalo: ge
        };
        if (x && l.canOverlap) {
            S = !0;
            let e1 = d.segments.get();
            for (let t of e1)T.push({
                segments: new (0, $caapT.At)([
                    t
                ]),
                sortKey: t.sortKey,
                state: ve,
                terrainData: te
            });
        } else T.push({
            segments: d.segments,
            sortKey: 0,
            state: ve,
            terrainData: te
        });
    }
    S && T.sort((e1, t)=>e1.sortKey - t.sortKey);
    let E = n.paint.get(i ? `text-halo-width` : `icon-halo-width`).constantOr(null) ?? 1 / 0, D = n.layout.get(`text-letter-spacing`).constantOr(0) * 24 < 0 || E > 1;
    for (let t of T){
        let r = t.state;
        m.activeTexture.set(h.TEXTURE0), r.atlasTexture.bind(r.atlasInterpolation, h.CLAMP_TO_EDGE), r.atlasTextureIcon && (m.activeTexture.set(h.TEXTURE1), r.atlasTextureIcon && r.atlasTextureIcon.bind(r.atlasInterpolationIcon, h.CLAMP_TO_EDGE));
        let i = r.isSDF && r.hasHalo;
        if (i) {
            let i = r.uniformValues;
            i.u_is_halo = 1, D && (i.u_is_plain = 0, $902e455d852cdfb8$var$Gu(r.buffers, t.segments, n, e1, r.program, C, d, f, i, r.projectionData, t.terrainData), i.u_is_halo = 0, i.u_is_plain = 1);
        }
        $902e455d852cdfb8$var$Gu(r.buffers, t.segments, n, e1, r.program, C, d, f, r.uniformValues, r.projectionData, t.terrainData), i && !D && (r.uniformValues.u_is_halo = 0);
    }
}
function $902e455d852cdfb8$var$Gu(e1, t, n, r, i, a, o, s, c, l, u) {
    let d = r.context, f = d.gl;
    i.draw(d, f.TRIANGLES, a, o, s, $902e455d852cdfb8$var$X.backCCW, c, u, l, n.id, e1.layoutVertexBuffer, e1.indexBuffer, t, n.paint, r.transform.zoom, e1.programConfigurations.get(n.id), e1.dynamicLayoutVertexBuffer, e1.opacityVertexBuffer);
}
function $902e455d852cdfb8$var$Ku(e1, t, n, r, i) {
    if (e1.renderPass !== `translucent`) return;
    let { isRenderingToTexture: a } = i, s = n.paint.get(`circle-opacity`), c = n.paint.get(`circle-stroke-width`), l = n.paint.get(`circle-stroke-opacity`), u = !n.layout.get(`circle-sort-key`).isConstant();
    if (s.constantOr(1) === 0 && (c.constantOr(1) === 0 || l.constantOr(1) === 0)) return;
    let d = e1.context, f = d.gl, p = e1.transform, m = e1.getDepthModeForSublayer(0, $902e455d852cdfb8$var$Z.ReadOnly), h = $902e455d852cdfb8$var$Q.disabled, g = e1.colorModeForRenderPass(), _ = [], v = p.getCircleRadiusCorrection();
    for (let i of r){
        let r = t.getTile(i), s = r.getBucket(n);
        if (!s) continue;
        let c = (0, $caapT.Or)(p, r, n.paint.get(`circle-translate`), n.paint.get(`circle-translate-anchor`)), l = s.programConfigurations.get(n.id), d = e1.useProgram(`circle`, l), f = s.layoutVertexBuffer, m = s.indexBuffer, h = e1.style.map.terrain?.getTerrainData(i), g = {
            programConfiguration: l,
            program: d,
            layoutVertexBuffer: f,
            indexBuffer: m,
            uniformValues: $902e455d852cdfb8$var$Yc(e1, r, n, c, v),
            terrainData: h,
            projectionData: p.getProjectionData({
                overscaledTileID: i,
                applyGlobeMatrix: !a,
                applyTerrainMatrix: !0
            })
        };
        if (u) {
            let e1 = s.segments.get();
            for (let t of e1)_.push({
                segments: new (0, $caapT.At)([
                    t
                ]),
                sortKey: t.sortKey,
                state: g
            });
        } else _.push({
            segments: s.segments,
            sortKey: 0,
            state: g
        });
    }
    u && _.sort((e1, t)=>e1.sortKey - t.sortKey);
    for (let t of _){
        let { programConfiguration: r, program: i, layoutVertexBuffer: a, indexBuffer: o, uniformValues: s, terrainData: c, projectionData: l } = t.state, u = t.segments;
        i.draw(d, f.TRIANGLES, m, h, g, $902e455d852cdfb8$var$X.backCCW, s, c, l, n.id, a, o, u, n.paint, e1.transform.zoom, r);
    }
}
function $902e455d852cdfb8$var$qu(e1, t, n, r, i) {
    if (n.paint.get(`heatmap-opacity`) === 0) return;
    let a = e1.context, { isRenderingToTexture: o, isRenderingGlobe: s } = i;
    if (e1.style.map.terrain) {
        for (let i of r){
            let r = t.getTile(i);
            t.hasRenderableParent(i) || (e1.renderPass === `offscreen` ? $902e455d852cdfb8$var$Xu(e1, r, n, i, s) : e1.renderPass === `translucent` && $902e455d852cdfb8$var$Zu(e1, n, i, o, s));
        }
        a.viewport.set([
            0,
            0,
            e1.width,
            e1.height
        ]);
    } else e1.renderPass === `offscreen` ? $902e455d852cdfb8$var$Ju(e1, t, n, r) : e1.renderPass === `translucent` && $902e455d852cdfb8$var$Yu(e1, n);
}
function $902e455d852cdfb8$var$Ju(e1, t, n, r) {
    let i = e1.context, a = i.gl, o = e1.transform, s = $902e455d852cdfb8$var$Q.disabled, c = new $902e455d852cdfb8$var$Y([
        a.ONE,
        a.ONE
    ], (0, $caapT.tn).transparent, [
        !0,
        !0,
        !0,
        !0
    ]);
    $902e455d852cdfb8$var$Qu(i, e1, n), i.clear({
        color: (0, $caapT.tn).transparent
    });
    for (let l of r){
        if (t.hasRenderableParent(l)) continue;
        let r = t.getTile(l), u = r.getBucket(n);
        if (!u) continue;
        let d = u.programConfigurations.get(n.id), f = e1.useProgram(`heatmap`, d), p = o.getProjectionData({
            overscaledTileID: l,
            applyGlobeMatrix: !0,
            applyTerrainMatrix: !1
        }), m = o.getCircleRadiusCorrection();
        f.draw(i, a.TRIANGLES, $902e455d852cdfb8$var$Z.disabled, s, c, $902e455d852cdfb8$var$X.backCCW, $902e455d852cdfb8$var$il(r, o.zoom, n.paint.get(`heatmap-intensity`), m), null, p, n.id, u.layoutVertexBuffer, u.indexBuffer, u.segments, n.paint, o.zoom, d);
    }
    i.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
}
function $902e455d852cdfb8$var$Yu(e1, t) {
    let n = e1.context, r = n.gl;
    n.setColorMode(e1.colorModeForRenderPass());
    let i = t.heatmapFbos.get((0, $caapT.pt));
    i && (n.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, i.colorAttachment.get()), n.activeTexture.set(r.TEXTURE1), $902e455d852cdfb8$var$ed(n, t).bind(r.LINEAR, r.CLAMP_TO_EDGE), e1.useProgram(`heatmapTexture`).draw(n, r.TRIANGLES, $902e455d852cdfb8$var$Z.disabled, $902e455d852cdfb8$var$Q.disabled, e1.colorModeForRenderPass(), $902e455d852cdfb8$var$X.disabled, $902e455d852cdfb8$var$al(e1, t, 0, 1), null, null, t.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, t.paint, e1.transform.zoom));
}
function $902e455d852cdfb8$var$Xu(e1, t, n, r, i) {
    let a = e1.context, o = a.gl, s = $902e455d852cdfb8$var$Q.disabled, c = new $902e455d852cdfb8$var$Y([
        o.ONE,
        o.ONE
    ], (0, $caapT.tn).transparent, [
        !0,
        !0,
        !0,
        !0
    ]), l = t.getBucket(n);
    if (!l) return;
    let u = r.key, d = n.heatmapFbos.get(u);
    d || (d = $902e455d852cdfb8$var$$u(a, t.tileSize, t.tileSize), n.heatmapFbos.set(u, d)), a.bindFramebuffer.set(d.framebuffer), a.viewport.set([
        0,
        0,
        t.tileSize,
        t.tileSize
    ]), a.clear({
        color: (0, $caapT.tn).transparent
    });
    let f = l.programConfigurations.get(n.id), p = e1.useProgram(`heatmap`, f, !i), m = e1.transform.getProjectionData({
        overscaledTileID: t.tileID,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    }), h = e1.style.map.terrain.getTerrainData(r);
    p.draw(a, o.TRIANGLES, $902e455d852cdfb8$var$Z.disabled, s, c, $902e455d852cdfb8$var$X.disabled, $902e455d852cdfb8$var$il(t, e1.transform.zoom, n.paint.get(`heatmap-intensity`), 1), h, m, n.id, l.layoutVertexBuffer, l.indexBuffer, l.segments, n.paint, e1.transform.zoom, f);
}
function $902e455d852cdfb8$var$Zu(e1, t, n, r, i) {
    let a = e1.context, o = a.gl, s = e1.transform;
    a.setColorMode(e1.colorModeForRenderPass());
    let c = $902e455d852cdfb8$var$ed(a, t), l = n.key, u = t.heatmapFbos.get(l);
    if (!u) return;
    a.activeTexture.set(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, u.colorAttachment.get()), a.activeTexture.set(o.TEXTURE1), c.bind(o.LINEAR, o.CLAMP_TO_EDGE);
    let d = s.getProjectionData({
        overscaledTileID: n,
        applyTerrainMatrix: i,
        applyGlobeMatrix: !r
    });
    e1.useProgram(`heatmapTexture`).draw(a, o.TRIANGLES, $902e455d852cdfb8$var$Z.disabled, $902e455d852cdfb8$var$Q.disabled, e1.colorModeForRenderPass(), $902e455d852cdfb8$var$X.disabled, $902e455d852cdfb8$var$al(e1, t, 0, 1), null, d, t.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments, t.paint, s.zoom), u.destroy(), t.heatmapFbos.delete(l);
}
function $902e455d852cdfb8$var$Qu(e1, t, n) {
    let r = e1.gl;
    e1.activeTexture.set(r.TEXTURE1), e1.viewport.set([
        0,
        0,
        t.width / 4,
        t.height / 4
    ]);
    let i = n.heatmapFbos.get((0, $caapT.pt));
    i ? (r.bindTexture(r.TEXTURE_2D, i.colorAttachment.get()), e1.bindFramebuffer.set(i.framebuffer)) : (i = $902e455d852cdfb8$var$$u(e1, t.width / 4, t.height / 4), n.heatmapFbos.set((0, $caapT.pt), i));
}
function $902e455d852cdfb8$var$$u(e1, t, n) {
    let r = e1.gl, i = r.createTexture();
    r.bindTexture(r.TEXTURE_2D, i), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texStorage2D(r.TEXTURE_2D, 1, r.RGBA16F, t, n);
    let a = e1.createFramebuffer(t, n, !1, !1);
    return a.colorAttachment.set(i), a;
}
function $902e455d852cdfb8$var$ed(e1, t) {
    return t.colorRampTexture ||= new (0, $caapT.dt)(e1, t.colorRamp, e1.gl.RGBA), t.colorRampTexture;
}
function $902e455d852cdfb8$var$td(e1, t, n, r) {
    let i = e1.context, a = i.bindFramebuffer.get(), o = i.viewport.get(), [, , s, c] = o;
    return $902e455d852cdfb8$var$nd(e1, s, c), i.viewport.set([
        0,
        0,
        s,
        c
    ]), i.clear({
        color: (0, $caapT.tn).transparent,
        depth: 1,
        stencil: 0
    }), e1.currentStencilSource = void 0, e1.renderTileClippingMasks(t, n, r), {
        compositeTarget: a,
        compositeViewport: o
    };
}
function $902e455d852cdfb8$var$nd(e1, t, n) {
    let r = e1.context.gl;
    if (!e1.layerOpacityFbo) {
        let i = e1.context.createFramebuffer(t, n, !0, !0), a = r.createTexture();
        r.bindTexture(r.TEXTURE_2D, a), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, t, n, 0, r.RGBA, r.UNSIGNED_BYTE, null), i.colorAttachment.set(a), i.depthAttachment.set(e1.context.createRenderbuffer(r.DEPTH_STENCIL, t, n)), e1.layerOpacityFbo = i, e1.context.bindFramebuffer.set(e1.layerOpacityFbo.framebuffer);
        return;
    }
    if (e1.layerOpacityFbo.width === t && e1.layerOpacityFbo.height === n) {
        e1.context.bindFramebuffer.set(e1.layerOpacityFbo.framebuffer);
        return;
    }
    let i = e1.layerOpacityFbo;
    r.bindTexture(r.TEXTURE_2D, i.colorAttachment.get()), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, t, n, 0, r.RGBA, r.UNSIGNED_BYTE, null), e1.context.bindRenderbuffer.set(i.depthAttachment.get()), r.renderbufferStorage(r.RENDERBUFFER, r.DEPTH_STENCIL, t, n), e1.context.bindRenderbuffer.set(null), i.width = t, i.height = n, e1.context.bindFramebuffer.set(i.framebuffer);
}
function $902e455d852cdfb8$var$rd(e1, t, n, r) {
    let i = e1.context, a = i.gl;
    i.bindFramebuffer.set(n.compositeTarget), i.viewport.set(n.compositeViewport), i.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, e1.layerOpacityFbo.colorAttachment.get()), e1.useProgram(`layerOpacity`).draw(i, a.TRIANGLES, $902e455d852cdfb8$var$Z.disabled, $902e455d852cdfb8$var$Q.disabled, e1.colorModeForRenderPass(), $902e455d852cdfb8$var$X.disabled, $902e455d852cdfb8$var$El(t, 0), null, null, r.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, r.paint, e1.transform.zoom), e1.currentStencilSource = void 0;
}
function $902e455d852cdfb8$var$id(e1, t, n, r, i, a, o, s) {
    let c = 256;
    if (i.stepInterpolant) {
        let r = t.getSource().maxzoom, i = o.canonical.z === r ? Math.ceil(1 << e1.transform.maxZoom - o.canonical.z) : 1;
        c = (0, $caapT.In)((0, $caapT.mr)(a.maxLineLength / (0, $caapT.Pr) * 1024 * i), 256, n.maxTextureSize);
    }
    return s.gradient = (0, $caapT.ht)({
        expression: i.gradientExpression(),
        evaluationKey: `lineProgress`,
        resolution: c,
        image: s.gradient || void 0,
        clips: a.lineClipsArray
    }), s.texture ? s.texture.update(s.gradient) : s.texture = new (0, $caapT.dt)(n, s.gradient, r.RGBA), s.version = i.gradientVersion, s.texture;
}
function $902e455d852cdfb8$var$ad(e1, t, n, r, i) {
    e1.activeTexture.set(t.TEXTURE0), n.imageAtlasTexture.bind(t.LINEAR, t.CLAMP_TO_EDGE), r.updatePaintBuffers(i);
}
function $902e455d852cdfb8$var$od(e1, t, n, r, i, a) {
    (i || e1.lineAtlas.dirty) && (t.activeTexture.set(n.TEXTURE0), e1.lineAtlas.bind(t)), r.updatePaintBuffers(a);
}
function $902e455d852cdfb8$var$sd(e1, t, n, r, i, a, o) {
    let s = a.gradients[i.id], c = s.texture;
    i.gradientVersion !== s.version && (c = $902e455d852cdfb8$var$id(e1, t, n, r, i, a, o, s)), n.activeTexture.set(r.TEXTURE0), c.bind(i.stepInterpolant ? r.NEAREST : r.LINEAR, r.CLAMP_TO_EDGE);
}
function $902e455d852cdfb8$var$cd(e1, t, n, r, i, a, o, s, c) {
    let l = a.gradients[i.id], u = l.texture;
    i.gradientVersion !== l.version && (u = $902e455d852cdfb8$var$id(e1, t, n, r, i, a, o, l)), n.activeTexture.set(r.TEXTURE0), u.bind(i.stepInterpolant ? r.NEAREST : r.LINEAR, r.CLAMP_TO_EDGE), n.activeTexture.set(r.TEXTURE1), e1.lineAtlas.bind(n), s.updatePaintBuffers(c);
}
function $902e455d852cdfb8$var$ld(e1, t, n, r, i) {
    if (e1.renderPass !== `translucent`) return;
    let a = n.paint.get(`line-opacity`), o = n.paint.get(`line-width`), s = n.paint.get(`line-layer-opacity`);
    if (a.constantOr(1) === 0 || o.constantOr(1) === 0 || s === 0) return;
    let c = !!e1.style.map.terrain;
    if (s < 1) {
        let a = $902e455d852cdfb8$var$td(e1, n, r, c);
        $902e455d852cdfb8$var$ud(e1, t, n, r, i, c), $902e455d852cdfb8$var$rd(e1, s, a, n);
        return;
    }
    $902e455d852cdfb8$var$ud(e1, t, n, r, i, c);
}
function $902e455d852cdfb8$var$ud(e1, t, n, r, i, a) {
    let { isRenderingToTexture: o } = i, s = e1.getDepthModeForSublayer(0, $902e455d852cdfb8$var$Z.ReadOnly), c = e1.colorModeForRenderPass(), l = n.paint.get(`line-dasharray`), u = l.constantOr(1), d = n.paint.get(`line-pattern`), f = d.constantOr(1), p = n.paint.get(`line-gradient`), m = n.getCrossfadeParameters(), h;
    h = f ? `linePattern` : u && p ? `lineGradientSDF` : u ? `lineSDF` : p ? `lineGradient` : `line`;
    let g = e1.context, _ = g.gl, v = e1.transform, y = !0;
    for (let i of r){
        let r = t.getTile(i);
        if (f && !r.patternsLoaded()) continue;
        let b = r.getBucket(n);
        if (!b) continue;
        let x = b.programConfigurations.get(n.id), S = e1.context.program.get(), C = e1.useProgram(h, x), w = y || C.program !== S, T = a ? e1.getTerrainDataForTile(i, o) : null, ee = d.constantOr(null), E = l?.constantOr(null);
        if (ee && r.imageAtlas) {
            let e1 = r.imageAtlas, t = e1.patternPositions[ee.to.toString()], n = e1.patternPositions[ee.from.toString()];
            t && n && x.setConstantPatternPositions(t, n);
        } else if (E) {
            let t = n.layout.get(`line-cap`).constantOr(null) === `round`, r = e1.lineAtlas.getDash(E.to, t), i = e1.lineAtlas.getDash(E.from, t);
            x.setConstantDashPositions(r, i);
        }
        let D = v.getProjectionData({
            overscaledTileID: i,
            applyGlobeMatrix: !o,
            applyTerrainMatrix: !0
        }), O = v.getPixelScale(), te;
        f ? (te = $902e455d852cdfb8$var$bl(e1, r, n, O, m), $902e455d852cdfb8$var$ad(g, _, r, x, m)) : u && p ? (te = $902e455d852cdfb8$var$Sl(e1, r, n, O, m, b.lineClipsArray.length), $902e455d852cdfb8$var$cd(e1, t, g, _, n, b, i, x, m)) : u ? (te = $902e455d852cdfb8$var$xl(e1, r, n, O, m), $902e455d852cdfb8$var$od(e1, g, _, x, w, m)) : p ? (te = $902e455d852cdfb8$var$yl(e1, r, n, O, b.lineClipsArray.length), $902e455d852cdfb8$var$sd(e1, t, g, _, n, b, i)) : te = $902e455d852cdfb8$var$vl(e1, r, n, O);
        let k = e1.stencilModeForClipping(i);
        C.draw(g, _.TRIANGLES, s, k, c, $902e455d852cdfb8$var$X.disabled, te, T, D, n.id, b.layoutVertexBuffer, b.indexBuffer, b.segments, n.paint, e1.transform.zoom, x, b.layoutVertexBuffer2), y = !1;
    }
}
function $902e455d852cdfb8$var$dd(e1, t, n, r, i) {
    if (!n || !r?.imageAtlas) return;
    let a = r.imageAtlas.patternPositions, o = a[n.to.toString()], s = a[n.from.toString()];
    if (!o && s && (o = s), !s && o && (s = o), !o || !s) {
        let e1 = i.getPaintProperty(t);
        o = a[e1], s = a[e1];
    }
    o && s && e1.setConstantPatternPositions(o, s);
}
function $902e455d852cdfb8$var$fd(e1, t, n, r, i) {
    let a = n.paint.get(`fill-color`), o = n.paint.get(`fill-opacity`), s = n.paint.get(`fill-layer-opacity`);
    if (o.constantOr(1) === 0 || s === 0) return;
    if (s < 1) {
        if (e1.renderPass !== `translucent`) return;
        let a = $902e455d852cdfb8$var$td(e1, n, r, !!e1.style.map.terrain);
        $902e455d852cdfb8$var$pd(e1, t, n, r, i), $902e455d852cdfb8$var$rd(e1, s, a, n);
        return;
    }
    let c = n.paint.get(`fill-pattern`), l = e1.opaquePassEnabledForLayer() && !c.constantOr(1) && a.constantOr((0, $caapT.tn).transparent).a === 1 && o.constantOr(0) === 1;
    if (l && e1.renderPass === `opaque`) {
        let { isRenderingToTexture: a } = i, o = e1.colorModeForRenderPass();
        $902e455d852cdfb8$var$hd(e1, t, n, r, e1.getDepthModeForSublayer(1, $902e455d852cdfb8$var$Z.ReadWrite), o, !1, a);
        return;
    }
    if (l && e1.renderPass === `translucent`) {
        $902e455d852cdfb8$var$md(e1, t, n, r, i);
        return;
    }
    e1.renderPass === `translucent` && $902e455d852cdfb8$var$pd(e1, t, n, r, i);
}
function $902e455d852cdfb8$var$pd(e1, t, n, r, i) {
    let { isRenderingToTexture: a } = i, o = e1.colorModeForRenderPass();
    $902e455d852cdfb8$var$hd(e1, t, n, r, e1.getDepthModeForSublayer(1, $902e455d852cdfb8$var$Z.ReadOnly), o, !1, a), $902e455d852cdfb8$var$md(e1, t, n, r, i);
}
function $902e455d852cdfb8$var$md(e1, t, n, r, i) {
    if (!n.paint.get(`fill-antialias`)) return;
    let { isRenderingToTexture: a } = i, o = e1.colorModeForRenderPass();
    $902e455d852cdfb8$var$hd(e1, t, n, r, e1.getDepthModeForSublayer(n.getPaintProperty(`fill-outline-color`) ? 2 : 0, $902e455d852cdfb8$var$Z.ReadOnly), o, !0, a);
}
function $902e455d852cdfb8$var$hd(e1, t, n, r, i, a, o, s) {
    let c = e1.context.gl, l = `fill-pattern`, u = n.paint.get(l), d = u?.constantOr(1), f = n.getCrossfadeParameters(), p, m, h, g, _, v = e1.transform, y = n.paint.get(`fill-translate`), b = n.paint.get(`fill-translate-anchor`);
    o ? (m = d && !n.getPaintProperty(`fill-outline-color`) ? `fillOutlinePattern` : `fillOutline`, p = c.LINES) : (m = d ? `fillPattern` : `fill`, p = c.TRIANGLES);
    let x = u.constantOr(null);
    for (let u of r){
        let r = t.getTile(u);
        if (d && !r.patternsLoaded()) continue;
        let S = r.getBucket(n);
        if (!S) continue;
        let C = S.programConfigurations.get(n.id), w = e1.useProgram(m, C), T = e1.getTerrainDataForTile(u, s);
        d && (e1.context.activeTexture.set(c.TEXTURE0), r.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), C.updatePaintBuffers(f)), $902e455d852cdfb8$var$dd(C, l, x, r, n);
        let ee = v.getProjectionData({
            overscaledTileID: u,
            applyGlobeMatrix: !s,
            applyTerrainMatrix: !0
        }), E = (0, $caapT.Or)(v, r, y, b);
        if (!o) g = S.indexBuffer, _ = S.segments, h = d ? $902e455d852cdfb8$var$Wc(e1, f, r, E) : $902e455d852cdfb8$var$Gc(E);
        else {
            g = S.indexBuffer2, _ = S.segments2;
            let t = [
                c.drawingBufferWidth,
                c.drawingBufferHeight
            ];
            h = m === `fillOutlinePattern` && d ? $902e455d852cdfb8$var$qc(e1, f, r, t, E) : $902e455d852cdfb8$var$Kc(t, E);
        }
        let D = e1.stencilModeForClipping(u);
        w.draw(e1.context, p, i, D, a, $902e455d852cdfb8$var$X.backCCW, h, T, ee, n.id, S.layoutVertexBuffer, g, _, n.paint, e1.transform.zoom, C);
    }
}
function $902e455d852cdfb8$var$gd(e1, t, n, r, i) {
    let a = n.paint.get(`fill-extrusion-opacity`);
    if (a === 0) return;
    let { isRenderingToTexture: o } = i;
    if (e1.renderPass === `translucent`) {
        let i = new $902e455d852cdfb8$var$Z(e1.context.gl.LEQUAL, $902e455d852cdfb8$var$Z.ReadWrite, e1.depthRangeFor3D);
        if (a === 1 && !n.paint.get(`fill-extrusion-pattern`).constantOr(1)) {
            let a = e1.colorModeForRenderPass();
            $902e455d852cdfb8$var$_d(e1, t, n, r, i, $902e455d852cdfb8$var$Q.disabled, a, o);
        } else $902e455d852cdfb8$var$_d(e1, t, n, r, i, $902e455d852cdfb8$var$Q.disabled, $902e455d852cdfb8$var$Y.disabled, o), $902e455d852cdfb8$var$_d(e1, t, n, r, i, e1.stencilModeFor3D(), e1.colorModeForRenderPass(), o);
    }
}
function $902e455d852cdfb8$var$_d(e1, t, n, r, i, a, o, s) {
    let c = e1.context, l = c.gl, u = `fill-extrusion-pattern`, d = n.paint.get(u), f = d.constantOr(1), p = n.getCrossfadeParameters(), m = n.paint.get(`fill-extrusion-opacity`), h = d.constantOr(null), g = e1.transform;
    for (let d of r){
        let r = t.getTile(d), _ = r.getBucket(n);
        if (!_) continue;
        let v = e1.style.map.terrain?.getTerrainData(d), y = _.programConfigurations.get(n.id), b = e1.useProgram(f ? `fillExtrusionPattern` : `fillExtrusion`, y);
        f && (e1.context.activeTexture.set(l.TEXTURE0), r.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), y.updatePaintBuffers(p));
        let x = g.getProjectionData({
            overscaledTileID: d,
            applyGlobeMatrix: !s,
            applyTerrainMatrix: !0
        });
        $902e455d852cdfb8$var$dd(y, u, h, r, n);
        let S = (0, $caapT.Or)(g, r, n.paint.get(`fill-extrusion-translate`), n.paint.get(`fill-extrusion-translate-anchor`)), C = n.paint.get(`fill-extrusion-vertical-gradient`), w = f ? $902e455d852cdfb8$var$zc(e1, C, m, S, d, p, r) : $902e455d852cdfb8$var$Rc(e1, C, m, S);
        b.draw(c, c.gl.TRIANGLES, i, a, o, $902e455d852cdfb8$var$X.backCCW, w, v, x, n.id, _.layoutVertexBuffer, _.indexBuffer, _.segments, n.paint, e1.transform.zoom, y, e1.style.map.terrain && _.centroidVertexBuffer);
    }
}
function $902e455d852cdfb8$var$vd(e1, t, n, r, i) {
    if (e1.renderPass !== `offscreen` && e1.renderPass !== `translucent`) return;
    let { isRenderingToTexture: a } = i, o = e1.context, s = e1.style.projection.useSubdivision, c = e1.getDepthModeForSublayer(0, $902e455d852cdfb8$var$Z.ReadOnly), l = e1.colorModeForRenderPass();
    if (e1.renderPass === `offscreen`) $902e455d852cdfb8$var$bd(e1, t, r, n, c, $902e455d852cdfb8$var$Q.disabled, l), o.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
    else if (e1.renderPass === `translucent`) {
        if (s) {
            let [i, o, s] = e1.stencilConfigForOverlapTwoPass(r);
            $902e455d852cdfb8$var$yd(e1, t, n, s, i, c, l, !1, a), $902e455d852cdfb8$var$yd(e1, t, n, s, o, c, l, !0, a);
        } else {
            let [i, o] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
            $902e455d852cdfb8$var$yd(e1, t, n, o, i, c, l, !1, a);
        }
    }
}
function $902e455d852cdfb8$var$yd(e1, t, n, r, i, a, o, s, c) {
    let l = e1.style.projection, u = e1.context, d = e1.transform, f = u.gl, p = [
        `#define NUM_ILLUMINATION_SOURCES ${n.paint.get(`hillshade-highlight-color`).values.length}`
    ], m = e1.useProgram(`hillshade`, null, !1, p), h = !e1.options.moving;
    for (let p of r){
        let r = t.getTile(p), g = r.fbo;
        if (!g) continue;
        let _ = l.getMeshFromTileID(u, p.canonical, s, !0, `raster`), v = e1.getTerrainDataForTile(p, c);
        u.activeTexture.set(f.TEXTURE0), f.bindTexture(f.TEXTURE_2D, g.colorAttachment.get());
        let y = d.getProjectionData({
            overscaledTileID: p,
            aligned: h,
            applyGlobeMatrix: !c,
            applyTerrainMatrix: !0
        });
        m.draw(u, f.TRIANGLES, a, i[p.overscaledZ], o, $902e455d852cdfb8$var$X.backCCW, $902e455d852cdfb8$var$cl(e1, r, n), v, y, n.id, _.vertexBuffer, _.indexBuffer, _.segments);
    }
}
function $902e455d852cdfb8$var$bd(e1, t, n, r, i, a, o) {
    let s = e1.context, c = s.gl, l = r.paint.get(`resampling`) === `nearest` ? c.NEAREST : c.LINEAR;
    for (let u of n){
        let n = t.getTile(u), d = n.dem;
        if (!d?.data || !n.needsHillshadePrepare) continue;
        let f = d.dim, p = d.stride, m = d.getPixels();
        if (s.activeTexture.set(c.TEXTURE1), s.pixelStoreUnpackPremultiplyAlpha.set(!1), n.demTexture ||= e1.getTileTexture(p), n.demTexture) {
            let e1 = n.demTexture;
            e1.update(m, {
                premultiply: !1
            }), e1.bind(c.NEAREST, c.CLAMP_TO_EDGE);
        } else n.demTexture = new (0, $caapT.dt)(s, m, c.RGBA, {
            premultiply: !1
        }), n.demTexture.bind(c.NEAREST, c.CLAMP_TO_EDGE);
        s.activeTexture.set(c.TEXTURE0);
        let h = n.fbo;
        if (!h) {
            let e1 = new (0, $caapT.dt)(s, {
                width: f,
                height: f,
                data: null
            }, c.RGBA);
            e1.bind(l, c.CLAMP_TO_EDGE), h = n.fbo = s.createFramebuffer(f, f, !0, !1), h.colorAttachment.set(e1.texture);
        }
        s.bindFramebuffer.set(h.framebuffer), s.viewport.set([
            0,
            0,
            f,
            f
        ]), e1.useProgram(`hillshadePrepare`).draw(s, c.TRIANGLES, i, a, o, $902e455d852cdfb8$var$X.disabled, $902e455d852cdfb8$var$ll(n.tileID, d), null, null, r.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), n.needsHillshadePrepare = !1;
    }
}
function $902e455d852cdfb8$var$xd(e1, t, n, r, i) {
    if (e1.renderPass !== `translucent` || !r.length) return;
    let { isRenderingToTexture: a } = i, o = e1.style.projection.useSubdivision, s = e1.getDepthModeForSublayer(0, $902e455d852cdfb8$var$Z.ReadOnly), c = e1.colorModeForRenderPass();
    if (o) {
        let [i, o, l] = e1.stencilConfigForOverlapTwoPass(r);
        $902e455d852cdfb8$var$Cd(e1, t, n, l, i, s, c, !1, a), $902e455d852cdfb8$var$Cd(e1, t, n, l, o, s, c, !0, a);
    } else {
        let [i, o] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
        $902e455d852cdfb8$var$Cd(e1, t, n, o, i, s, c, !1, a);
    }
}
let $902e455d852cdfb8$var$Sd = 0;
function $902e455d852cdfb8$var$Cd(e1, t, n, r, i, a, o, s, c) {
    let l = e1.style.projection, u = e1.context, d = e1.transform, f = u.gl, p = e1.useProgram(`colorRelief`), m = !e1.options.moving, h = n.paint.get(`resampling`) === `nearest` ? f.NEAREST : f.LINEAR, g = !0, _ = 0;
    for (let v of r){
        let r = t.getTile(v), y = r.dem;
        if (g) {
            $902e455d852cdfb8$var$Sd ||= f.getParameter(f.MAX_TEXTURE_SIZE);
            let e1 = $902e455d852cdfb8$var$Sd, { elevationTexture: t, colorTexture: r } = n.getColorRampTextures(u, e1, y.getUnpackVector());
            u.activeTexture.set(f.TEXTURE1), t.bind(f.NEAREST, f.CLAMP_TO_EDGE), u.activeTexture.set(f.TEXTURE4), r.bind(f.LINEAR, f.CLAMP_TO_EDGE), g = !1, _ = t.size[0];
        }
        if (!y?.data) continue;
        let b = y.stride, x = y.getPixels();
        if (u.activeTexture.set(f.TEXTURE0), u.pixelStoreUnpackPremultiplyAlpha.set(!1), r.demTexture ||= e1.getTileTexture(b), r.demTexture) {
            let e1 = r.demTexture;
            e1.update(x, {
                premultiply: !1
            }), e1.bind(h, f.CLAMP_TO_EDGE);
        } else r.demTexture = new (0, $caapT.dt)(u, x, f.RGBA, {
            premultiply: !1
        }), r.demTexture.bind(h, f.CLAMP_TO_EDGE);
        let S = l.getMeshFromTileID(u, v.canonical, s, !0, `raster`), C = e1.getTerrainDataForTile(v, c), w = d.getProjectionData({
            overscaledTileID: v,
            aligned: m,
            applyGlobeMatrix: !c,
            applyTerrainMatrix: !0
        });
        p.draw(u, f.TRIANGLES, a, i[v.overscaledZ], o, $902e455d852cdfb8$var$X.backCCW, $902e455d852cdfb8$var$fl(n, r.dem, _), C, w, n.id, S.vertexBuffer, S.indexBuffer, S.segments);
    }
}
const $902e455d852cdfb8$var$wd = [
    new (0, $caapT.ji)(0, 0),
    new (0, $caapT.ji)((0, $caapT.Pr), 0),
    new (0, $caapT.ji)((0, $caapT.Pr), (0, $caapT.Pr)),
    new (0, $caapT.ji)(0, (0, $caapT.Pr))
];
function $902e455d852cdfb8$var$Td(e1, t, n, r, i) {
    if (e1.renderPass !== `translucent` || n.paint.get(`raster-opacity`) === 0 || !r.length) return;
    let { isRenderingToTexture: a } = i, o = t.getSource(), s = e1.style.projection.useSubdivision;
    if (o instanceof $902e455d852cdfb8$export$280e9a68c3ffd919) $902e455d852cdfb8$var$Ed(e1, t, n, r, null, !1, !1, o.tileCoords, o.flippedWindingOrder, a);
    else if (s) {
        let [i, o, s] = e1.stencilConfigForOverlapTwoPass(r);
        $902e455d852cdfb8$var$Ed(e1, t, n, s, i, !1, !0, $902e455d852cdfb8$var$wd, !1, a), $902e455d852cdfb8$var$Ed(e1, t, n, s, o, !0, !0, $902e455d852cdfb8$var$wd, !1, a);
    } else {
        let [i, o] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
        $902e455d852cdfb8$var$Ed(e1, t, n, o, i, !1, !0, $902e455d852cdfb8$var$wd, !1, a);
    }
}
function $902e455d852cdfb8$var$Ed(e1, t, n, r, i, a, o, s, c = !1, l = !1) {
    let u = r[r.length - 1].overscaledZ, d = e1.context, f = d.gl, p = e1.useProgram(`raster`), m = e1.transform, h = e1.style.projection, g = e1.colorModeForRenderPass(), _ = !e1.options.moving, v = n.paint.get(`raster-opacity`), y = n.paint.get(`resampling`) === `nearest` || n.paint.get(`raster-resampling`) === `nearest` ? f.NEAREST : f.LINEAR, b = n.paint.get(`raster-fade-duration`), x = !!e1.style.map.terrain;
    for (let S of r){
        let r = e1.getDepthModeForSublayer(S.overscaledZ - u, v === 1 ? $902e455d852cdfb8$var$Z.ReadWrite : $902e455d852cdfb8$var$Z.ReadOnly, f.LESS), C = t.getTile(S);
        d.activeTexture.set(f.TEXTURE0), C.texture.bind(y, f.CLAMP_TO_EDGE, f.LINEAR_MIPMAP_NEAREST), d.activeTexture.set(f.TEXTURE1);
        let { parentTile: w, parentScaleBy: T, parentTopLeft: ee, fadeValues: E } = $902e455d852cdfb8$var$Dd(C, t, b, x);
        C.fadeOpacity = E.tileOpacity, w ? (w.fadeOpacity = E.parentTileOpacity, w.texture.bind(y, f.CLAMP_TO_EDGE, f.LINEAR_MIPMAP_NEAREST)) : C.texture.bind(y, f.CLAMP_TO_EDGE, f.LINEAR_MIPMAP_NEAREST), C.texture.useMipmap && d.extTextureFilterAnisotropic && e1.transform.pitch > e1.options.anisotropicFilterPitch && f.texParameterf(f.TEXTURE_2D, d.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, d.extTextureFilterAnisotropicMax);
        let D = e1.getTerrainDataForTile(S, l), O = m.getProjectionData({
            overscaledTileID: S,
            aligned: _,
            applyGlobeMatrix: !l,
            applyTerrainMatrix: !0
        }), te = $902e455d852cdfb8$var$Ol(ee, T, E.fadeMix, n, s), k = h.getMeshFromTileID(d, S.canonical, a, o, `raster`), A = i ? i[S.overscaledZ] : $902e455d852cdfb8$var$Q.disabled;
        p.draw(d, f.TRIANGLES, r, A, g, c ? $902e455d852cdfb8$var$X.frontCCW : $902e455d852cdfb8$var$X.backCCW, te, D, O, n.id, k.vertexBuffer, k.indexBuffer, k.segments);
    }
}
function $902e455d852cdfb8$var$Dd(e1, t, n, r) {
    let i = {
        parentTile: null,
        parentScaleBy: 1,
        parentTopLeft: [
            0,
            0
        ],
        fadeValues: {
            tileOpacity: 1,
            parentTileOpacity: 1,
            fadeMix: {
                opacity: 1,
                mix: 0
            }
        }
    };
    if (n === 0 || r) return i;
    if (e1.fadingParentID) {
        let r = t.getLoadedTile(e1.fadingParentID);
        if (!r) return i;
        let a = 2 ** (r.tileID.overscaledZ - e1.tileID.overscaledZ);
        return {
            parentTile: r,
            parentScaleBy: a,
            parentTopLeft: [
                e1.tileID.canonical.x * a % 1,
                e1.tileID.canonical.y * a % 1
            ],
            fadeValues: $902e455d852cdfb8$var$Od(e1, r, n)
        };
    }
    return e1.selfFading ? {
        parentTile: null,
        parentScaleBy: 1,
        parentTopLeft: [
            0,
            0
        ],
        fadeValues: $902e455d852cdfb8$var$kd(e1, n)
    } : i;
}
function $902e455d852cdfb8$var$Od(e1, t, n) {
    let r = $902e455d852cdfb8$export$461939dd4422153(), i = (r - e1.timeAdded) / n, a = (r - t.timeAdded) / n, o = e1.fadingDirection === 1, s = (0, $caapT.In)(i, 0, 1), c = (0, $caapT.In)(1 - a, 0, 1), l = o ? s : c;
    return {
        tileOpacity: l,
        parentTileOpacity: o ? c : s,
        fadeMix: {
            opacity: 1,
            mix: 1 - l
        }
    };
}
function $902e455d852cdfb8$var$kd(e1, t) {
    let n = (0, $caapT.In)(($902e455d852cdfb8$export$461939dd4422153() - e1.timeAdded) / t, 0, 1);
    return {
        tileOpacity: n,
        fadeMix: {
            opacity: n,
            mix: 0
        }
    };
}
function $902e455d852cdfb8$var$Ad(e1, t, n, r, i) {
    let a = n.paint.get(`background-color`), o = n.paint.get(`background-opacity`);
    if (o === 0) return;
    let { isRenderingToTexture: s } = i, c = e1.context, l = c.gl, u = e1.style.projection, d = e1.transform, f = d.tileSize, p = n.paint.get(`background-pattern`);
    if (e1.isPatternMissing(p)) return;
    let m = !p && a.a === 1 && o === 1 && e1.opaquePassEnabledForLayer() ? `opaque` : `translucent`;
    if (e1.renderPass !== m) return;
    let h = $902e455d852cdfb8$var$Q.disabled, g = e1.getDepthModeForSublayer(0, m === `opaque` ? $902e455d852cdfb8$var$Z.ReadWrite : $902e455d852cdfb8$var$Z.ReadOnly), _ = e1.colorModeForRenderPass(), v = e1.useProgram(p ? `backgroundPattern` : `background`), y = r || $902e455d852cdfb8$var$Fa(d, {
        tileSize: f,
        terrain: e1.style.map.terrain
    });
    p && (c.activeTexture.set(l.TEXTURE0), e1.imageManager.bind(e1.context));
    let b = n.getCrossfadeParameters();
    for (let t of y){
        let r = d.getProjectionData({
            overscaledTileID: t,
            applyGlobeMatrix: !s,
            applyTerrainMatrix: !0
        }), i = p ? $902e455d852cdfb8$var$Vl(o, e1, p, {
            tileID: t,
            tileSize: f
        }, b) : $902e455d852cdfb8$var$Bl(o, a), m = e1.getTerrainDataForTile(t, s), y = u.getMeshFromTileID(c, t.canonical, !1, !0, `raster`);
        v.draw(c, l.TRIANGLES, g, h, _, $902e455d852cdfb8$var$X.backCCW, i, m, r, n.id, y.vertexBuffer, y.indexBuffer, y.segments);
    }
}
const $902e455d852cdfb8$var$jd = new (0, $caapT.tn)(1, 0, 0, 1), $902e455d852cdfb8$var$Md = new (0, $caapT.tn)(0, 1, 0, 1), $902e455d852cdfb8$var$Nd = new (0, $caapT.tn)(0, 0, 1, 1), $902e455d852cdfb8$var$Pd = new (0, $caapT.tn)(1, 0, 1, 1), $902e455d852cdfb8$var$Fd = new (0, $caapT.tn)(0, 1, 1, 1);
function $902e455d852cdfb8$var$Id(e1) {
    let t = e1.transform.padding;
    $902e455d852cdfb8$var$Rd(e1, e1.transform.height - (t.top || 0), 3, $902e455d852cdfb8$var$jd), $902e455d852cdfb8$var$Rd(e1, t.bottom || 0, 3, $902e455d852cdfb8$var$Md), $902e455d852cdfb8$var$zd(e1, t.left || 0, 3, $902e455d852cdfb8$var$Nd), $902e455d852cdfb8$var$zd(e1, e1.transform.width - (t.right || 0), 3, $902e455d852cdfb8$var$Pd);
    let n = e1.transform.centerPoint;
    $902e455d852cdfb8$var$Ld(e1, n.x, e1.transform.height - n.y, $902e455d852cdfb8$var$Fd);
}
function $902e455d852cdfb8$var$Ld(e1, t, n, r) {
    $902e455d852cdfb8$var$Bd(e1, t - 1, n - 10, 2, 20, r), $902e455d852cdfb8$var$Bd(e1, t - 10, n - 1, 20, 2, r);
}
function $902e455d852cdfb8$var$Rd(e1, t, n, r) {
    $902e455d852cdfb8$var$Bd(e1, 0, t + n / 2, e1.transform.width, n, r);
}
function $902e455d852cdfb8$var$zd(e1, t, n, r) {
    $902e455d852cdfb8$var$Bd(e1, t - n / 2, 0, n, e1.transform.height, r);
}
function $902e455d852cdfb8$var$Bd(e1, t, n, r, i, a) {
    let o = e1.context, s = o.gl;
    s.enable(s.SCISSOR_TEST), s.scissor(t * e1.pixelRatio, n * e1.pixelRatio, r * e1.pixelRatio, i * e1.pixelRatio), o.clear({
        color: a
    }), s.disable(s.SCISSOR_TEST);
}
function $902e455d852cdfb8$var$Vd(e1, t, n) {
    for (let r of n)$902e455d852cdfb8$var$Hd(e1, t, r);
}
function $902e455d852cdfb8$var$Hd(e1, t, n) {
    let r = e1.context, i = r.gl, a = e1.useProgram(`debug`), o = $902e455d852cdfb8$var$Z.disabled, s = $902e455d852cdfb8$var$Q.disabled, c = e1.colorModeForRenderPass(), l = `$debug`, u = e1.style.map.terrain?.getTerrainData(n);
    r.activeTexture.set(i.TEXTURE0);
    let d = t.getTileByID(n.key).latestRawTileData?.byteLength || 0, f = Math.floor(d / 1024), p = t.getTile(n).tileSize, m = 512 / Math.min(p, 512) * (n.overscaledZ / e1.transform.zoom) * .5, h = n.canonical.toString();
    n.overscaledZ !== n.canonical.z && (h += ` => ${n.overscaledZ}`), $902e455d852cdfb8$var$Ud(e1, `${h} ${f}kB`);
    let g = e1.transform.getProjectionData({
        overscaledTileID: n,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    });
    a.draw(r, i.TRIANGLES, o, s, $902e455d852cdfb8$var$Y.alphaBlended, $902e455d852cdfb8$var$X.disabled, $902e455d852cdfb8$var$tl((0, $caapT.tn).transparent, m), null, g, l, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments), a.draw(r, i.LINE_STRIP, o, s, c, $902e455d852cdfb8$var$X.disabled, $902e455d852cdfb8$var$tl((0, $caapT.tn).red), u, g, l, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
}
function $902e455d852cdfb8$var$Ud(e1, t) {
    e1.initDebugOverlayCanvas();
    let n = e1.debugOverlayCanvas, r = e1.context.gl, i = e1.debugOverlayCanvas.getContext(`2d`);
    i.clearRect(0, 0, n.width, n.height), i.shadowColor = `white`, i.shadowBlur = 2, i.lineWidth = 1.5, i.strokeStyle = `white`, i.textBaseline = `top`, i.font = `bold 36px Open Sans, sans-serif`, i.fillText(t, 5, 5), i.strokeText(t, 5, 5), e1.debugOverlayTexture.update(n), e1.debugOverlayTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
}
function $902e455d852cdfb8$var$Wd(e1, t) {
    let n = null, r = Object.values(e1._layers).flatMap((n)=>n.source && !n.isHidden(t) ? [
            e1.tileManagers[n.source]
        ] : []), i = r.filter((e1)=>e1.getSource().type === `vector`), a = r.filter((e1)=>e1.getSource().type !== `vector`), o = (e1)=>{
        (!n || n.getSource().maxzoom < e1.getSource().maxzoom) && (n = e1);
    };
    for (let e1 of i)o(e1);
    if (!n) for (let e1 of a)o(e1);
    return n;
}
function $902e455d852cdfb8$var$Gd(e1, t, n, r) {
    let { isRenderingGlobe: i } = r, a = e1.context, o = n.implementation, s = e1.style.projection, c = e1.transform, l = c.getProjectionDataForCustomLayer(i), u = {
        farZ: c.farZ,
        nearZ: c.nearZ,
        fov: c.fov * Math.PI / 180,
        modelViewProjectionMatrix: c.modelViewProjectionMatrix,
        projectionMatrix: c.projectionMatrix,
        shaderData: {
            variantName: s.shaderVariantName,
            vertexShaderPrelude: `const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n${s.shaderPreludeCode.vertexSource}`,
            define: s.shaderDefine
        },
        defaultProjectionData: l,
        getProjectionData: (e1)=>c.getProjectionData({
                overscaledTileID: new (0, $caapT._)(e1.tileID.canonical.z, e1.tileID.wrap ?? 0, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y),
                aligned: e1.aligned,
                applyGlobeMatrix: e1.applyGlobeMatrix,
                applyTerrainMatrix: e1.applyTerrainMatrix
            })
    }, d = o.renderingMode ? o.renderingMode : `2d`;
    if (e1.renderPass === `offscreen`) {
        let t = o.prerender;
        t && (e1.setCustomLayerDefaults(), a.setColorMode(e1.colorModeForRenderPass()), t.call(o, a.gl, u), a.setDirty(), e1.setBaseState());
    } else if (e1.renderPass === `translucent`) {
        e1.setCustomLayerDefaults(), a.setColorMode(e1.colorModeForRenderPass()), a.setStencilMode($902e455d852cdfb8$var$Q.disabled);
        let t = d === `3d` ? e1.getDepthModeFor3D() : e1.getDepthModeForSublayer(0, $902e455d852cdfb8$var$Z.ReadOnly);
        a.setDepthMode(t), o.render(a.gl, u), a.setDirty(), e1.setBaseState(), a.bindFramebuffer.set(null);
    }
}
function $902e455d852cdfb8$var$Kd(e1, t) {
    let n = e1.context, r = n.gl, i = e1.transform, a = $902e455d852cdfb8$var$Y.unblended, o = new $902e455d852cdfb8$var$Z(r.LEQUAL, $902e455d852cdfb8$var$Z.ReadWrite, [
        0,
        1
    ]), s = t.tileManager.getRenderableTiles(), c = e1.useProgram(`terrainDepth`);
    n.bindFramebuffer.set(t.getFramebuffer(`depth`).framebuffer), n.viewport.set([
        0,
        0,
        e1.width / devicePixelRatio,
        e1.height / devicePixelRatio
    ]), n.clear({
        color: (0, $caapT.tn).transparent,
        depth: 1
    });
    for (let e1 of s){
        let s = t.getTerrainMesh(e1.tileID), l = t.getTerrainData(e1.tileID), u = i.getProjectionData({
            overscaledTileID: e1.tileID,
            applyTerrainMatrix: !1,
            applyGlobeMatrix: !0
        }), d = $902e455d852cdfb8$var$Oc(t.getSkirtLength(i.zoom));
        c.draw(n, r.TRIANGLES, o, $902e455d852cdfb8$var$Q.disabled, a, $902e455d852cdfb8$var$X.backCCW, d, l, u, `terrain`, s.vertexBuffer, s.indexBuffer, s.segments);
    }
    n.bindFramebuffer.set(null), n.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
}
function $902e455d852cdfb8$var$qd(e1, t) {
    let n = e1.context, r = n.gl, i = e1.transform, a = $902e455d852cdfb8$var$Y.unblended, o = new $902e455d852cdfb8$var$Z(r.LEQUAL, $902e455d852cdfb8$var$Z.ReadWrite, [
        0,
        1
    ]), s = t.getCoordsTexture(), c = t.tileManager.getRenderableTiles(), l = e1.useProgram(`terrainCoords`);
    n.bindFramebuffer.set(t.getFramebuffer(`coords`).framebuffer), n.viewport.set([
        0,
        0,
        e1.width / devicePixelRatio,
        e1.height / devicePixelRatio
    ]), n.clear({
        color: (0, $caapT.tn).transparent,
        depth: 1
    }), t.coordsIndex = [];
    for (let e1 of c){
        let c = t.getTerrainMesh(e1.tileID), u = t.getTerrainData(e1.tileID);
        n.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, s.texture);
        let d = $902e455d852cdfb8$var$kc(255 - t.coordsIndex.length, t.getSkirtLength(i.zoom)), f = i.getProjectionData({
            overscaledTileID: e1.tileID,
            applyTerrainMatrix: !1,
            applyGlobeMatrix: !0
        });
        l.draw(n, r.TRIANGLES, o, $902e455d852cdfb8$var$Q.disabled, a, $902e455d852cdfb8$var$X.backCCW, d, u, f, `terrain`, c.vertexBuffer, c.indexBuffer, c.segments), t.coordsIndex.push(e1.tileID.key);
    }
    n.bindFramebuffer.set(null), n.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
}
function $902e455d852cdfb8$var$Jd(e1, t, n, r) {
    let { isRenderingGlobe: i } = r, a = e1.context, o = a.gl, s = e1.transform, c = e1.colorModeForRenderPass(), l = e1.getDepthModeFor3D(), u = e1.useProgram(`terrain`);
    a.bindFramebuffer.set(null), a.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
    for (let r of n){
        let n = t.getTerrainMesh(r.tileID), d = e1.renderToTexture.getTexture(r), f = t.getTerrainData(r.tileID);
        a.activeTexture.set(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, d.texture);
        let p = $902e455d852cdfb8$var$Dc(t.getSkirtLength(s.zoom), s.calculateFogMatrix(r.tileID.toUnwrapped()), e1.style.sky, s.pitch, i), m = s.getProjectionData({
            overscaledTileID: r.tileID,
            applyTerrainMatrix: !1,
            applyGlobeMatrix: !0
        });
        u.draw(a, o.TRIANGLES, l, $902e455d852cdfb8$var$Q.disabled, c, $902e455d852cdfb8$var$X.backCCW, p, f, m, `terrain`, n.vertexBuffer, n.indexBuffer, n.segments);
    }
}
function $902e455d852cdfb8$var$Yd(e1, t) {
    if (!t.mesh) {
        let n = new (0, $caapT.Ft);
        n.emplaceBack(-1, -1), n.emplaceBack(1, -1), n.emplaceBack(1, 1), n.emplaceBack(-1, 1);
        let r = new (0, $caapT.Rt);
        r.emplaceBack(0, 1, 2), r.emplaceBack(0, 2, 3), t.mesh = new $902e455d852cdfb8$var$us(e1.createVertexBuffer(n, $902e455d852cdfb8$var$ds.members), e1.createIndexBuffer(r), (0, $caapT.At).simpleSegment(0, 0, n.length, r.length));
    }
    return t.mesh;
}
function $902e455d852cdfb8$var$Xd(e1, t) {
    let n = e1.context, r = n.gl, i = $902e455d852cdfb8$var$Gl(t, e1.transform, e1.pixelRatio), a = new $902e455d852cdfb8$var$Z(r.LEQUAL, $902e455d852cdfb8$var$Z.ReadWrite, [
        0,
        1
    ]), o = $902e455d852cdfb8$var$Q.disabled, s = e1.colorModeForRenderPass(), c = e1.useProgram(`sky`), l = $902e455d852cdfb8$var$Yd(n, t);
    c.draw(n, r.TRIANGLES, a, o, s, $902e455d852cdfb8$var$X.disabled, i, null, void 0, `sky`, l.vertexBuffer, l.indexBuffer, l.segments);
}
function $902e455d852cdfb8$var$Zd(e1, t) {
    let n = e1.getCartesianPosition();
    (0, $caapT.Qr)(n, n);
    let r = (0, $caapT.gi)(new Float64Array(16));
    return e1.properties.get(`anchor`) === `map` && ((0, $caapT.Ci)(r, r, t.rollInRadians), (0, $caapT.xi)(r, r, -t.pitchInRadians), (0, $caapT.Ci)(r, r, t.bearingInRadians), (0, $caapT.xi)(r, r, t.center.lat * Math.PI / 180), (0, $caapT.Si)(r, r, -t.center.lng * Math.PI / 180)), (0, $caapT.si)(n, n, r), n;
}
function $902e455d852cdfb8$var$Qd(e1, t, n) {
    let r = e1.context, i = r.gl, a = e1.useProgram(`atmosphere`), o = new $902e455d852cdfb8$var$Z(i.LEQUAL, $902e455d852cdfb8$var$Z.ReadOnly, [
        0,
        1
    ]), s = e1.transform, c = $902e455d852cdfb8$var$Zd(n, e1.transform), l = s.getProjectionData({
        overscaledTileID: null,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    }), u = t.properties.get(`atmosphere-blend`) * l.projectionTransition;
    if (u === 0) return;
    let d = $902e455d852cdfb8$var$Qs(s.worldSize, s.center.lat), f = s.inverseProjectionMatrix, p = new Float64Array(4);
    p[3] = 1, (0, $caapT.Gr)(p, p, s.modelViewProjectionMatrix), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1, (0, $caapT.Gr)(p, p, f), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1;
    let m = $902e455d852cdfb8$var$Ul(c, u, [
        p[0],
        p[1],
        p[2]
    ], d, f), h = $902e455d852cdfb8$var$Yd(r, t);
    a.draw(r, i.TRIANGLES, o, $902e455d852cdfb8$var$Q.disabled, $902e455d852cdfb8$var$Y.alphaBlended, $902e455d852cdfb8$var$X.disabled, m, null, null, `atmosphere`, h.vertexBuffer, h.indexBuffer, h.segments);
}
const $902e455d852cdfb8$var$$d = {
    symbol: $902e455d852cdfb8$var$Ru,
    circle: $902e455d852cdfb8$var$Ku,
    heatmap: $902e455d852cdfb8$var$qu,
    line: $902e455d852cdfb8$var$ld,
    fill: $902e455d852cdfb8$var$fd,
    fillExtrusion: $902e455d852cdfb8$var$gd,
    hillshade: $902e455d852cdfb8$var$vd,
    colorRelief: $902e455d852cdfb8$var$xd,
    raster: $902e455d852cdfb8$var$Td,
    background: $902e455d852cdfb8$var$Ad,
    sky: $902e455d852cdfb8$var$Xd,
    atmosphere: $902e455d852cdfb8$var$Qd,
    custom: $902e455d852cdfb8$var$Gd,
    debug: $902e455d852cdfb8$var$Vd,
    debugPadding: $902e455d852cdfb8$var$Id,
    terrainDepth: $902e455d852cdfb8$var$Kd,
    terrainCoords: $902e455d852cdfb8$var$qd
};
var $902e455d852cdfb8$var$ef = class e1 {
    constructor(e1, t){
        this.drawFunctions = $902e455d852cdfb8$var$$d, this.context = new $902e455d852cdfb8$var$Nu(e1), this.transform = t, this.layerOpacityFbo = null, this._tileTextures = {}, this._rttObjectRecyclePool = [], this._rttSharedFbo = null, this.terrainFacilitator = {
            depthDirty: !0,
            coordsDirty: !1,
            matrix: (0, $caapT.gi)(new Float64Array(16)),
            renderTime: 0
        }, this.setup(), this.numSublayers = $902e455d852cdfb8$var$qa.maxOverzooming + $902e455d852cdfb8$var$qa.maxUnderzooming + 1, this.depthEpsilon = 1 / 2 ** 16, this.crossTileSymbolIndex = new $902e455d852cdfb8$var$$o;
    }
    resize(e1, t, n) {
        if (this.width = Math.floor(e1 * n), this.height = Math.floor(t * n), this.pixelRatio = n, this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.style) for (let e1 of this.style._order)this.style._layers[e1].resize();
    }
    setup() {
        let e1 = this.context, t = new (0, $caapT.Ft);
        t.emplaceBack(0, 0), t.emplaceBack((0, $caapT.Pr), 0), t.emplaceBack(0, (0, $caapT.Pr)), t.emplaceBack((0, $caapT.Pr), (0, $caapT.Pr)), this.tileExtentBuffer = e1.createVertexBuffer(t, $902e455d852cdfb8$var$ds.members), this.tileExtentSegments = (0, $caapT.At).simpleSegment(0, 0, 4, 2);
        let n = new (0, $caapT.Ft);
        n.emplaceBack(0, 0), n.emplaceBack((0, $caapT.Pr), 0), n.emplaceBack(0, (0, $caapT.Pr)), n.emplaceBack((0, $caapT.Pr), (0, $caapT.Pr)), this.debugBuffer = e1.createVertexBuffer(n, $902e455d852cdfb8$var$ds.members), this.debugSegments = (0, $caapT.At).simpleSegment(0, 0, 4, 5);
        let r = new (0, $caapT.Lt);
        r.emplaceBack(0, 0, 0, 0), r.emplaceBack((0, $caapT.Pr), 0, (0, $caapT.Pr), 0), r.emplaceBack(0, (0, $caapT.Pr), 0, (0, $caapT.Pr)), r.emplaceBack((0, $caapT.Pr), (0, $caapT.Pr), (0, $caapT.Pr), (0, $caapT.Pr)), this.rasterBoundsBuffer = e1.createVertexBuffer(r, $902e455d852cdfb8$var$xc.members), this.rasterBoundsSegments = (0, $caapT.At).simpleSegment(0, 0, 4, 2);
        let i = new (0, $caapT.Ft);
        i.emplaceBack(0, 0), i.emplaceBack((0, $caapT.Pr), 0), i.emplaceBack(0, (0, $caapT.Pr)), i.emplaceBack((0, $caapT.Pr), (0, $caapT.Pr)), this.rasterBoundsBufferPosOnly = e1.createVertexBuffer(i, $902e455d852cdfb8$var$ds.members), this.rasterBoundsSegmentsPosOnly = (0, $caapT.At).simpleSegment(0, 0, 4, 5);
        let a = new (0, $caapT.Ft);
        a.emplaceBack(0, 0), a.emplaceBack(1, 0), a.emplaceBack(0, 1), a.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(a, $902e455d852cdfb8$var$ds.members), this.viewportSegments = (0, $caapT.At).simpleSegment(0, 0, 4, 2);
        let s = new (0, $caapT.Nt);
        s.emplaceBack(0), s.emplaceBack(1), s.emplaceBack(3), s.emplaceBack(2), s.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(s);
        let c = new (0, $caapT.Rt);
        c.emplaceBack(1, 0, 2), c.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(c);
        let l = this.context.gl;
        this.stencilClearMode = new $902e455d852cdfb8$var$Q({
            func: l.ALWAYS,
            mask: 0
        }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.tileExtentMesh = new $902e455d852cdfb8$var$us(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
    }
    clearStencil() {
        let e1 = this.context, t = e1.gl;
        this.nextStencilID = 1, this.currentStencilSource = void 0;
        let n = (0, $caapT.fi)();
        (0, $caapT.yi)(n, 0, this.width, this.height, 0, 0, 1), (0, $caapT.wi)(n, n, [
            t.drawingBufferWidth,
            t.drawingBufferHeight,
            0
        ]);
        let r = {
            mainMatrix: n,
            tileMercatorCoords: [
                0,
                0,
                1,
                1
            ],
            clippingPlane: [
                0,
                0,
                0,
                0
            ],
            projectionTransition: 0,
            fallbackMatrix: n
        };
        this.useProgram(`clippingMask`, null, !0).draw(e1, t.TRIANGLES, $902e455d852cdfb8$var$Z.disabled, this.stencilClearMode, $902e455d852cdfb8$var$Y.disabled, $902e455d852cdfb8$var$X.disabled, null, null, r, `$clipping`, this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
    }
    renderTileClippingMasks(e1, t, n) {
        if (this.currentStencilSource === e1.source || !e1.isTileClipped() || !t?.length) return;
        this.currentStencilSource = e1.source, this.nextStencilID + t.length > 256 && this.clearStencil();
        let r = this.context;
        r.setColorMode($902e455d852cdfb8$var$Y.disabled), r.setDepthMode($902e455d852cdfb8$var$Z.disabled);
        let i = {};
        for (let e1 of t)i[e1.key] = this.nextStencilID++;
        this._renderTileMasks(i, t, n, !0), this._renderTileMasks(i, t, n, !1), this._tileClippingMaskIDs = i;
    }
    _renderTileMasks(e1, t, n, r) {
        let i = this.context, a = i.gl, o = this.style.projection, s = this.transform, c = this.useProgram(`clippingMask`);
        for (let l of t){
            let t = e1[l.key], u = this.getTerrainDataForTile(l, n), d = o.getMeshFromTileID(this.context, l.canonical, r, !0, `stencil`), f = s.getProjectionData({
                overscaledTileID: l,
                applyGlobeMatrix: !n,
                applyTerrainMatrix: !0
            });
            c.draw(i, a.TRIANGLES, $902e455d852cdfb8$var$Z.disabled, new $902e455d852cdfb8$var$Q({
                func: a.ALWAYS,
                mask: 0
            }, t, 255, a.KEEP, a.KEEP, a.REPLACE), $902e455d852cdfb8$var$Y.disabled, n ? $902e455d852cdfb8$var$X.disabled : $902e455d852cdfb8$var$X.backCCW, null, u, f, `$clipping`, d.vertexBuffer, d.indexBuffer, d.segments);
        }
    }
    getTerrainDataForTile(e1, t) {
        return t && this.style.projection?.name === `mercator` ? null : this.style.map.terrain?.getTerrainData(e1) || null;
    }
    _renderTilesDepthBuffer() {
        let e1 = this.context, t = e1.gl, n = this.style.projection, r = this.transform, i = this.useProgram(`depth`), a = this.getDepthModeFor3D(), o = $902e455d852cdfb8$var$Fa(r, {
            tileSize: r.tileSize
        });
        for (let s of o){
            let o = this.style.map.terrain?.getTerrainData(s), c = n.getMeshFromTileID(this.context, s.canonical, !0, !0, `raster`), l = r.getProjectionData({
                overscaledTileID: s,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            });
            i.draw(e1, t.TRIANGLES, a, $902e455d852cdfb8$var$Q.disabled, $902e455d852cdfb8$var$Y.disabled, $902e455d852cdfb8$var$X.backCCW, null, o, l, `$clipping`, c.vertexBuffer, c.indexBuffer, c.segments);
        }
    }
    stencilModeFor3D() {
        this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
        let e1 = this.nextStencilID++, t = this.context.gl;
        return new $902e455d852cdfb8$var$Q({
            func: t.NOTEQUAL,
            mask: 255
        }, e1, 255, t.KEEP, t.KEEP, t.REPLACE);
    }
    stencilModeForClipping(e1) {
        let t = this.context.gl;
        return new $902e455d852cdfb8$var$Q({
            func: t.EQUAL,
            mask: 255
        }, this._tileClippingMaskIDs[e1.key], 0, t.KEEP, t.KEEP, t.REPLACE);
    }
    getStencilConfigForOverlapAndUpdateStencilID(e1) {
        let t = this.context.gl, n = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), r = n[n.length - 1].overscaledZ, i = n[0].overscaledZ - r + 1;
        if (i > 1) {
            this.currentStencilSource = void 0, this.nextStencilID + i > 256 && this.clearStencil();
            let e1 = {};
            for(let n = 0; n < i; n++)e1[n + r] = new $902e455d852cdfb8$var$Q({
                func: t.GEQUAL,
                mask: 255
            }, n + this.nextStencilID, 255, t.KEEP, t.KEEP, t.REPLACE);
            return this.nextStencilID += i, [
                e1,
                n
            ];
        }
        return [
            {
                [r]: $902e455d852cdfb8$var$Q.disabled
            },
            n
        ];
    }
    stencilConfigForOverlapTwoPass(e1) {
        let t = this.context.gl, n = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), r = n[n.length - 1].overscaledZ, i = n[0].overscaledZ - r + 1;
        if (this.clearStencil(), i > 1) {
            let e1 = {}, a = {};
            for(let n = 0; n < i; n++)e1[n + r] = new $902e455d852cdfb8$var$Q({
                func: t.GREATER,
                mask: 255
            }, i + 1 + n, 255, t.KEEP, t.KEEP, t.REPLACE), a[n + r] = new $902e455d852cdfb8$var$Q({
                func: t.GREATER,
                mask: 255
            }, 1 + n, 255, t.KEEP, t.KEEP, t.REPLACE);
            return this.nextStencilID = i * 2 + 1, [
                e1,
                a,
                n
            ];
        } else return this.nextStencilID = 3, [
            {
                [r]: new $902e455d852cdfb8$var$Q({
                    func: t.GREATER,
                    mask: 255
                }, 2, 255, t.KEEP, t.KEEP, t.REPLACE)
            },
            {
                [r]: new $902e455d852cdfb8$var$Q({
                    func: t.GREATER,
                    mask: 255
                }, 1, 255, t.KEEP, t.KEEP, t.REPLACE)
            },
            n
        ];
    }
    colorModeForRenderPass() {
        let e1 = this.context.gl;
        if (this._showOverdrawInspector) {
            let t = 1 / 8;
            return new $902e455d852cdfb8$var$Y([
                e1.CONSTANT_COLOR,
                e1.ONE
            ], new (0, $caapT.tn)(t, t, t, 0), [
                !0,
                !0,
                !0,
                !0
            ]);
        } else if (this.renderPass === `opaque`) return $902e455d852cdfb8$var$Y.unblended;
        else return $902e455d852cdfb8$var$Y.alphaBlended;
    }
    getDepthModeForSublayer(e1, t, n) {
        if (!this.opaquePassEnabledForLayer()) return $902e455d852cdfb8$var$Z.disabled;
        let r = 1 - ((1 + this.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
        return new $902e455d852cdfb8$var$Z(n || this.context.gl.LEQUAL, t, [
            r,
            r
        ]);
    }
    getDepthModeFor3D() {
        return new $902e455d852cdfb8$var$Z(this.context.gl.LEQUAL, $902e455d852cdfb8$var$Z.ReadWrite, this.depthRangeFor3D);
    }
    opaquePassEnabledForLayer() {
        return this.currentLayer < this.opaquePassCutoff;
    }
    render(e1, t) {
        this.style = e1, this.options = t, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange($902e455d852cdfb8$export$461939dd4422153()), this.imageManager.beginFrame();
        let n = this.style._order, r = this.style.tileManagers, i = {}, a = {}, o = {}, s = {
            isRenderingToTexture: !1,
            isRenderingGlobe: e1.projection?.transitionState > 0
        };
        for(let e1 in r){
            let t = r[e1];
            t.used && t.prepare(this.context), i[e1] = t.getVisibleCoordinates(!1), a[e1] = i[e1].slice().reverse(), o[e1] = t.getVisibleCoordinates(!0).reverse();
        }
        this.opaquePassCutoff = 1 / 0;
        for(let e1 = 0; e1 < n.length; e1++){
            let t = n[e1];
            if (this.style._layers[t].is3D()) {
                this.opaquePassCutoff = e1;
                break;
            }
        }
        this.maybeDrawDepth(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = `offscreen`;
        for (let e1 of n){
            let t = this.style._layers[e1];
            if (!t.hasOffscreenPass() || t.isHidden(this.transform.zoom)) continue;
            let n = a[t.source];
            t.type !== `custom` && !n.length || this.renderLayer(this, r[t.source], t, n, s);
        }
        if (this.style.projection?.updateGPUdependent({
            context: this.context,
            useProgram: (e1)=>this.useProgram(e1)
        }), this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.context.bindFramebuffer.set(null), this.context.clear({
            color: t.showOverdrawInspector ? (0, $caapT.tn).black : (0, $caapT.tn).transparent,
            depth: 1
        }), this.clearStencil(), this.style.sky && this.drawFunctions.sky(this, this.style.sky), this._showOverdrawInspector = t.showOverdrawInspector, this.depthRangeFor3D = [
            0,
            1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
        ], !this.renderToTexture) for(this.renderPass = `opaque`, this.currentLayer = n.length - 1; this.currentLayer >= 0; this.currentLayer--){
            let e1 = this.style._layers[n[this.currentLayer]], t = r[e1.source], a = i[e1.source];
            this.renderTileClippingMasks(e1, a, !1), this.renderLayer(this, t, e1, a, s);
        }
        this.renderPass = `translucent`;
        let c = !1;
        for(this.currentLayer = 0; this.currentLayer < n.length; this.currentLayer++){
            let e1 = this.style._layers[n[this.currentLayer]], t = r[e1.source];
            if (this.renderToTexture?.renderLayer(e1, s)) continue;
            !this.opaquePassEnabledForLayer() && !c && (c = !0, s.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
            let l = (e1.type === `symbol` ? o : a)[e1.source];
            this.renderTileClippingMasks(e1, i[e1.source], !!this.renderToTexture), this.renderLayer(this, t, e1, l, s);
        }
        if (s.isRenderingGlobe && this.drawFunctions.atmosphere(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
            let e1 = $902e455d852cdfb8$var$Wd(this.style, this.transform.zoom);
            e1 && this.drawFunctions.debug(this, e1, e1.getVisibleCoordinates());
        }
        this.options.showPadding && this.drawFunctions.debugPadding(this), this.context.setDefault();
    }
    maybeDrawDepth(e1) {
        if (!this.style?.map?.terrain) return;
        let t = this.terrainFacilitator.matrix, n = this.transform.modelViewProjectionMatrix, r = this.terrainFacilitator.depthDirty;
        r ||= e1 ? !(0, $caapT.mi)(t, n) : !(0, $caapT.pi)(t, n), r ||= this.style.map.terrain.tileManager.anyTilesAfterTime(this.terrainFacilitator.renderTime), r && ((0, $caapT.di)(t, n), this.terrainFacilitator.renderTime = $902e455d852cdfb8$export$461939dd4422153(), this.terrainFacilitator.depthDirty = !1, this.terrainFacilitator.coordsDirty = !0, this.drawFunctions.terrainDepth(this, this.style.map.terrain));
    }
    maybeDrawCoords() {
        !this.style?.map?.terrain || !this.terrainFacilitator.coordsDirty || (this.terrainFacilitator.coordsDirty = !1, this.drawFunctions.terrainCoords(this, this.style.map.terrain));
    }
    renderLayer(e1, t, n, r, i) {
        if (n.isHidden(this.transform.zoom) || n.type !== `background` && n.type !== `custom` && !(r || []).length) return;
        this.id = n.id;
        let a = this.drawFunctions;
        (0, $caapT.I)(n) ? a.symbol(e1, t, n, r, this.style.placement.variableOffsets, i) : (0, $caapT.vt)(n) ? a.circle(e1, t, n, r, i) : (0, $caapT.mt)(n) ? a.heatmap(e1, t, n, r, i) : (0, $caapT.Z)(n) ? a.line(e1, t, n, r, i) : (0, $caapT.rt)(n) ? a.fill(e1, t, n, r, i) : (0, $caapT.et)(n) ? a.fillExtrusion(e1, t, n, r, i) : (0, $caapT.ft)(n) ? a.hillshade(e1, t, n, r, i) : (0, $caapT.lt)(n) ? a.colorRelief(e1, t, n, r, i) : (0, $caapT.Bt)(n) ? a.raster(e1, t, n, r, i) : (0, $caapT.F)(n) ? a.background(e1, t, n, r, i) : (0, $caapT.N)(n) && a.custom(e1, t, n, i);
    }
    static{
        this.MAX_TEXTURE_POOL_SIZE_PER_BUCKET = 50;
    }
    saveTileTexture(t) {
        let n = this._tileTextures[t.size[0]];
        n ? n.length < e1.MAX_TEXTURE_POOL_SIZE_PER_BUCKET ? n.push(t) : t.destroy() : this._tileTextures[t.size[0]] = [
            t
        ];
    }
    getTileTexture(e1) {
        let t = this._tileTextures[e1];
        return t && t.length > 0 ? t.pop() : null;
    }
    acquireRTT(e1) {
        let t = this.context.gl, n = this._rttObjectRecyclePool.pop();
        if (n) return n.size !== e1 && (t.bindTexture(t.TEXTURE_2D, n.texture.texture), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, e1, e1, 0, t.RGBA, t.UNSIGNED_BYTE, null), n.texture.size = [
            e1,
            e1
        ], n.size = e1), n;
        let r = new (0, $caapT.dt)(this.context, {
            width: e1,
            height: e1,
            data: null
        }, t.RGBA);
        return r.bind(t.LINEAR, t.CLAMP_TO_EDGE), this.context.extTextureFilterAnisotropic && t.texParameterf(t.TEXTURE_2D, this.context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.context.extTextureFilterAnisotropicMax), {
            texture: r,
            size: e1
        };
    }
    bindRTT(e1) {
        let t = this.context.gl, n = e1.size;
        if (!this._rttSharedFbo) {
            let e1 = this.context.createFramebuffer(n, n, !0, !0), r = this.context.createRenderbuffer(t.DEPTH_STENCIL, n, n);
            e1.depthAttachment.set(r), this._rttSharedFbo = {
                fbo: e1,
                depthRenderbuffer: r,
                size: n
            };
        }
        this._rttSharedFbo.size !== n && (this.context.bindRenderbuffer.set(this._rttSharedFbo.depthRenderbuffer), t.renderbufferStorage(t.RENDERBUFFER, t.DEPTH_STENCIL, n, n), this.context.bindRenderbuffer.set(null), this._rttSharedFbo.fbo.width = n, this._rttSharedFbo.fbo.height = n, this._rttSharedFbo.size = n), this._rttSharedFbo.fbo.colorAttachment.set(e1.texture.texture), this.context.bindFramebuffer.set(this._rttSharedFbo.fbo.framebuffer);
    }
    releaseRTT(e1) {
        this._rttObjectRecyclePool.push(e1);
    }
    isPatternMissing(e1) {
        if (!e1) return !1;
        if (!e1.from || !e1.to) return !0;
        let t = this.imageManager.getPattern(e1.from.toString()), n = this.imageManager.getPattern(e1.to.toString());
        return !t || !n;
    }
    useProgram(e1, t, n = !1, r = []) {
        this.cache ||= {};
        let i = !!this.style.map.terrain, a = this.style.projection, o = n ? $902e455d852cdfb8$var$ls.projectionMercator : a.shaderPreludeCode, s = n ? $902e455d852cdfb8$var$fs : a.shaderDefine, c = `/${n ? $902e455d852cdfb8$var$ps : a.shaderVariantName}`, l = t ? t.cacheKey : ``, u = this._showOverdrawInspector ? `/overdraw` : ``, d = i ? `/terrain` : ``, f = r ? `/${r.join(`/`)}` : ``, p = e1 + l + c + u + d + f;
        return this.cache[p] ||= new $902e455d852cdfb8$var$Nc(this.context, $902e455d852cdfb8$var$ls[e1], t, $902e455d852cdfb8$var$ql[e1], this._showOverdrawInspector, i, o, s, r), this.cache[p];
    }
    setCustomLayerDefaults() {
        this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
    }
    setBaseState() {
        let e1 = this.context.gl;
        this.context.cullFace.set(!1), this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.context.blendEquation.set(e1.FUNC_ADD);
    }
    initDebugOverlayCanvas() {
        if (this.debugOverlayCanvas == null) {
            this.debugOverlayCanvas = document.createElement(`canvas`), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512;
            let e1 = this.context.gl;
            this.debugOverlayTexture = new (0, $caapT.dt)(this.context, this.debugOverlayCanvas, e1.RGBA);
        }
    }
    destroy() {
        if (this._tileTextures) {
            for(let e1 in this._tileTextures){
                let t = this._tileTextures[e1];
                if (t) for (let e1 of t)e1.destroy();
            }
            this._tileTextures = {};
        }
        for (let e1 of this._rttObjectRecyclePool)e1.texture.destroy();
        if (this._rttObjectRecyclePool = [], this._rttSharedFbo) {
            this._rttSharedFbo.fbo.colorAttachment.set(null), this._rttSharedFbo.fbo.depthAttachment.set(null);
            let e1 = this.context.gl;
            e1.deleteRenderbuffer(this._rttSharedFbo.depthRenderbuffer), e1.deleteFramebuffer(this._rttSharedFbo.fbo.framebuffer), this._rttSharedFbo = null;
        }
        if (this.layerOpacityFbo?.destroy(), this.layerOpacityFbo = null, this.tileExtentBuffer && this.tileExtentBuffer.destroy(), this.debugBuffer && this.debugBuffer.destroy(), this.rasterBoundsBuffer && this.rasterBoundsBuffer.destroy(), this.rasterBoundsBufferPosOnly && this.rasterBoundsBufferPosOnly.destroy(), this.viewportBuffer && this.viewportBuffer.destroy(), this.tileBorderIndexBuffer && this.tileBorderIndexBuffer.destroy(), this.quadTriangleIndexBuffer && this.quadTriangleIndexBuffer.destroy(), this.tileExtentMesh && this.tileExtentMesh.vertexBuffer?.destroy(), this.tileExtentMesh && this.tileExtentMesh.indexBuffer?.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.cache) {
            for(let e1 in this.cache){
                let t = this.cache[e1];
                t?.program && this.context.gl.deleteProgram(t.program);
            }
            this.cache = {};
        }
        this.context && this.context.setDefault();
    }
    overLimit() {
        let { drawingBufferWidth: e1, drawingBufferHeight: t } = this.context.gl;
        return this.width !== e1 || this.height !== t;
    }
}, $902e455d852cdfb8$export$68b5dc085315a832 = class extends Error {
    constructor(e1, t){
        super(`WebGL2 is required to display this map. We are sorry, but it seems that your browser does not support WebGL2, a technology for rendering 3D graphics on the web. Read more on https://wiki.openstreetmap.org/wiki/This_map_requires_WebGL`), this.name = `GPUInitializationError`, this.requestedAttributes = e1, this.statusMessage = t?.statusMessage ?? null;
    }
};
function $902e455d852cdfb8$var$nf(e1, t) {
    let n = !1, r = null, i, a = ()=>{
        r = null, n &&= (e1(...i), r = setTimeout(a, t), !1);
    };
    return (...e1)=>(n = !0, i = e1, r || a(), r);
}
var $902e455d852cdfb8$export$ab85ecd77ce6a5cd = class {
    constructor(e1){
        this._getHashParams = ()=>new URLSearchParams(window.location.hash.replace(`#`, ``)), this._getCurrentHash = ()=>{
            let e1 = this._getHashParams();
            return this._hashName ? (e1.get(this._hashName) || ``).split(`/`) : ([
                ...e1.keys()
            ][0] ?? ``).split(`/`);
        }, this._onHashChange = ()=>{
            let e1 = this._getCurrentHash();
            if (!this._isValidHash(e1)) return !1;
            let t = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(e1[3] || 0) : this._map.getBearing();
            return this._map.jumpTo({
                center: [
                    +e1[2],
                    +e1[1]
                ],
                zoom: +e1[0],
                bearing: t,
                pitch: +(e1[4] || 0)
            }), !0;
        }, this._updateHashUnthrottled = ()=>{
            let e1 = window.location.href.replace(/(#.*)?$/, this.getHashString());
            window.history.replaceState(window.history.state, null, e1);
        }, this._removeHash = ()=>{
            let e1 = this._getHashParams();
            if (this._hashName) e1.delete(this._hashName);
            else {
                let t = Array.from(e1.keys());
                t.length > 0 && e1.delete(t[0]);
            }
            let t = decodeURIComponent(e1.toString()).replace(/=&/g, `&`).replace(/=$/g, ``), n = t ? `#${t}` : ``, r = window.location.href.replace(/(#.+)?$/, n);
            r = r.replace(`&&`, `&`), window.history.replaceState(window.history.state, null, r);
        }, this._updateHash = $902e455d852cdfb8$var$nf(this._updateHashUnthrottled, 300), this._hashName = e1 && encodeURIComponent(e1);
    }
    addTo(e1) {
        return this._map = e1, addEventListener(`hashchange`, this._onHashChange, !1), this._map.on(`moveend`, this._updateHash), this;
    }
    remove() {
        return removeEventListener(`hashchange`, this._onHashChange, !1), this._map.off(`moveend`, this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
    }
    getHashString(e1) {
        let t = this._map.getCenter(), n = Math.round(this._map.getZoom() * 100) / 100, r = 10 ** Math.ceil((n * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), i = Math.round(t.lng * r) / r, a = Math.round(t.lat * r) / r, o = this._map.getBearing(), s = this._map.getPitch(), c = ``;
        if (e1 ? c += `/${i}/${a}/${n}` : c += `${n}/${a}/${i}`, (o || s) && (c += `/${Math.round(o * 10) / 10}`), s && (c += `/${Math.round(s)}`), this._hashName) {
            let e1 = this._getHashParams();
            return e1.set(this._hashName, c), `#${decodeURIComponent(e1.toString()).replace(/=&/g, `&`).replace(/=$/g, ``)}`;
        }
        return `#${c}`;
    }
    _isValidHash(e1) {
        if (e1.length < 3 || e1.some((e1)=>isNaN(+e1))) return !1;
        try {
            new (0, $caapT.k)(+e1[2], +e1[1]);
        } catch  {
            return !1;
        }
        let t = +e1[0], n = +(e1[3] || 0), r = +(e1[4] || 0);
        return t >= this._map.getMinZoom() && t <= this._map.getMaxZoom() && n >= -180 && n <= 180 && r >= this._map.getMinPitch() && r <= this._map.getMaxPitch();
    }
};
const $902e455d852cdfb8$var$af = {
    linearity: .3,
    easing: (0, $caapT.Fn)(0, 0, .3, 1)
}, $902e455d852cdfb8$var$of = (0, $caapT.Zn)({
    deceleration: 2500,
    maxSpeed: 1400
}, $902e455d852cdfb8$var$af), $902e455d852cdfb8$var$sf = (0, $caapT.Zn)({
    deceleration: 20,
    maxSpeed: 1400
}, $902e455d852cdfb8$var$af), $902e455d852cdfb8$var$cf = (0, $caapT.Zn)({
    deceleration: 1e3,
    maxSpeed: 360
}, $902e455d852cdfb8$var$af), $902e455d852cdfb8$var$lf = (0, $caapT.Zn)({
    deceleration: 1e3,
    maxSpeed: 90
}, $902e455d852cdfb8$var$af), $902e455d852cdfb8$var$uf = (0, $caapT.Zn)({
    deceleration: 1e3,
    maxSpeed: 360
}, $902e455d852cdfb8$var$af);
var $902e455d852cdfb8$var$df = class {
    constructor(e1){
        this._map = e1, this.clear();
    }
    clear() {
        this._inertiaBuffer = [];
    }
    record(e1) {
        this._drainInertiaBuffer(), this._inertiaBuffer.push({
            time: $902e455d852cdfb8$export$461939dd4422153(),
            settings: e1
        });
    }
    _drainInertiaBuffer() {
        let e1 = this._inertiaBuffer, t = $902e455d852cdfb8$export$461939dd4422153();
        for(; e1.length > 0 && t - e1[0].time > 160;)e1.shift();
    }
    _onMoveEnd(e1) {
        if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
        let t = {
            zoom: 0,
            bearing: 0,
            pitch: 0,
            roll: 0,
            pan: new (0, $caapT.ji)(0, 0),
            pinchAround: void 0,
            around: void 0
        };
        for (let { settings: e1 } of this._inertiaBuffer)t.zoom += e1.zoomDelta || 0, t.bearing += e1.bearingDelta || 0, t.pitch += e1.pitchDelta || 0, t.roll += e1.rollDelta || 0, e1.panDelta && t.pan._add(e1.panDelta), e1.around && (t.around = e1.around), e1.pinchAround && (t.pinchAround = e1.pinchAround);
        let n = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r = {};
        if (t.pan.mag()) {
            let i = $902e455d852cdfb8$var$pf(t.pan.mag(), n, (0, $caapT.Zn)({}, $902e455d852cdfb8$var$of, e1 || {})), a = t.pan.mult(i.amount / t.pan.mag()), o = this._map._camera.cameraHelper.handlePanInertia(a, this._map._camera.transform);
            r.center = o.easingCenter, r.offset = o.easingOffset, $902e455d852cdfb8$var$ff(r, i);
        }
        if (t.zoom) {
            let e1 = $902e455d852cdfb8$var$pf(t.zoom, n, $902e455d852cdfb8$var$sf);
            r.zoom = (0, $caapT.Xn)(this._map.getZoom() + e1.amount, this._map.getZoomSnap(), e1.amount), $902e455d852cdfb8$var$ff(r, e1);
        }
        if (t.bearing) {
            let e1 = $902e455d852cdfb8$var$pf(t.bearing, n, $902e455d852cdfb8$var$cf);
            r.bearing = this._map.getBearing() + (0, $caapT.In)(e1.amount, -179, 179), $902e455d852cdfb8$var$ff(r, e1);
        }
        if (t.pitch) {
            let e1 = $902e455d852cdfb8$var$pf(t.pitch, n, $902e455d852cdfb8$var$lf);
            r.pitch = this._map.getPitch() + e1.amount, $902e455d852cdfb8$var$ff(r, e1);
        }
        if (t.roll) {
            let e1 = $902e455d852cdfb8$var$pf(t.roll, n, $902e455d852cdfb8$var$uf);
            r.roll = this._map.getRoll() + (0, $caapT.In)(e1.amount, -179, 179), $902e455d852cdfb8$var$ff(r, e1);
        }
        if (r.zoom || r.bearing) {
            let e1 = t.pinchAround === void 0 ? t.around : t.pinchAround;
            r.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
        }
        return this.clear(), (0, $caapT.Zn)(r, {
            noMoveStart: !0
        });
    }
};
function $902e455d852cdfb8$var$ff(e1, t) {
    (!e1.duration || e1.duration < t.duration) && (e1.duration = t.duration, e1.easing = t.easing);
}
function $902e455d852cdfb8$var$pf(e1, t, n) {
    let { maxSpeed: r, linearity: i, deceleration: a } = n, o = (0, $caapT.In)(e1 * i / (t / 1e3), -r, r), s = Math.abs(o) / (a * i);
    return {
        easing: n.easing,
        duration: s * 1e3,
        amount: s / 2 * o
    };
}
var $902e455d852cdfb8$var$mf = class {
    constructor(e1, t){
        this._map = e1, this._clickTolerance = t.clickTolerance;
    }
    reset() {
        delete this._mousedownPos;
    }
    wheel(e1) {
        return this._firePreventable(new $902e455d852cdfb8$export$10870e40d23509f(this._map, e1));
    }
    mousedown(e1, t) {
        return this._mousedownPos = t, this._firePreventable(new $902e455d852cdfb8$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mouseup(e1) {
        this._map.fire(new $902e455d852cdfb8$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    click(e1, t) {
        this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || this._map.fire(new $902e455d852cdfb8$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    dblclick(e1) {
        return this._firePreventable(new $902e455d852cdfb8$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mouseover(e1) {
        this._map.fire(new $902e455d852cdfb8$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mouseout(e1) {
        this._map.fire(new $902e455d852cdfb8$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    touchstart(e1) {
        return this._firePreventable(new $902e455d852cdfb8$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    touchmove(e1) {
        this._map.fire(new $902e455d852cdfb8$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    touchend(e1) {
        this._map.fire(new $902e455d852cdfb8$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    touchcancel(e1) {
        this._map.fire(new $902e455d852cdfb8$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    _firePreventable(e1) {
        if (this._map.fire(e1), e1.defaultPrevented) return {};
    }
    isEnabled() {
        return !0;
    }
    isActive() {
        return !1;
    }
    enable() {}
    disable() {}
}, $902e455d852cdfb8$var$hf = class {
    constructor(e1){
        this._map = e1;
    }
    reset() {
        this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
    }
    mousemove(e1) {
        this._map.fire(new $902e455d852cdfb8$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mousedown() {
        this._delayContextMenu = !0, this._ignoreContextMenu = !1;
    }
    mouseup() {
        this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new $902e455d852cdfb8$export$83f023c8e5acf676(`contextmenu`, this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
    }
    contextmenu(e1) {
        this._delayContextMenu ? this._contextMenuEvent = e1 : this._ignoreContextMenu || this._map.fire(new $902e455d852cdfb8$export$83f023c8e5acf676(e1.type, this._map, e1)), this._map.listens(`contextmenu`) && e1.preventDefault();
    }
    isEnabled() {
        return !0;
    }
    isActive() {
        return !1;
    }
    enable() {}
    disable() {}
}, $902e455d852cdfb8$export$bd01c6f06175f3af = class {
    constructor(e1, t, n){
        this._map = e1, this._tr = n, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t.clickTolerance || 1, t.boxZoom && typeof t.boxZoom == `object` && (this._boxZoomEnd = t.boxZoom.boxZoomEnd);
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active;
    }
    enable() {
        this.isEnabled() || (this._enabled = !0);
    }
    disable() {
        this.isEnabled() && (this._enabled = !1);
    }
    mousedown(e1, t) {
        this.isEnabled() && e1.shiftKey && e1.button === 0 && ($902e455d852cdfb8$var$W.disableDrag(), this._startPos = this._lastPos = t, this._active = !0);
    }
    mousemoveWindow(e1, t) {
        if (!this._active) return;
        let n = t;
        if (this._lastPos.equals(n) || !this._box && n.dist(this._startPos) < this._clickTolerance) return;
        let r = this._startPos;
        this._lastPos = n, this._box || (this._box = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-boxzoom`, this._container), this._container.classList.add(`maplibregl-crosshair`), this._fireEvent(`boxzoomstart`, e1));
        let i = Math.min(r.x, n.x), a = Math.max(r.x, n.x), o = Math.min(r.y, n.y), s = Math.max(r.y, n.y);
        this._box.style.transform = `translate(${i}px,${o}px)`, this._box.style.width = `${a - i}px`, this._box.style.height = `${s - o}px`;
    }
    mouseupWindow(e1, t) {
        if (!this._active || e1.button !== 0) return;
        let n = this._startPos, r = t;
        if (this.reset(), $902e455d852cdfb8$var$W.suppressClick(), n.x === r.x && n.y === r.y) this._fireEvent(`boxzoomcancel`, e1);
        else {
            if (this._map.fire(new $902e455d852cdfb8$export$702e4d7a848278fa(`boxzoomend`, {
                originalEvent: e1
            })), this._boxZoomEnd) {
                this._boxZoomEnd(this._map, n, r, e1);
                return;
            }
            return {
                cameraAnimation: (e1)=>e1.fitScreenCoordinates(n, r, this._tr.bearing, {
                        linear: !0
                    })
            };
        }
    }
    keydown(e1) {
        this._active && e1.keyCode === 27 && (this.reset(), this._fireEvent(`boxzoomcancel`, e1));
    }
    reset() {
        this._active = !1, this._container.classList.remove(`maplibregl-crosshair`), this._box &&= (this._box.remove(), null), $902e455d852cdfb8$var$W.enableDrag(), delete this._startPos, delete this._lastPos;
    }
    _fireEvent(e1, t) {
        return this._map.fire(new $902e455d852cdfb8$export$702e4d7a848278fa(e1, {
            originalEvent: t
        }));
    }
};
function $902e455d852cdfb8$var$_f(e1, t) {
    if (e1.length !== t.length) throw Error(`The number of touches and points are not equal - touches ${e1.length}, points ${t.length}`);
    let n = {};
    for(let r = 0; r < e1.length; r++)n[e1[r].identifier] = t[r];
    return n;
}
function $902e455d852cdfb8$var$vf(e1) {
    let t = new (0, $caapT.ji)(0, 0);
    for (let n of e1)t._add(n);
    return t.div(e1.length);
}
var $902e455d852cdfb8$var$yf = class {
    constructor(e1){
        this.reset(), this.numTouches = e1.numTouches;
    }
    reset() {
        delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
    }
    touchstart(e1, t, n) {
        (this.centroid || n.length > this.numTouches) && (this.aborted = !0), !this.aborted && (this.startTime === void 0 && (this.startTime = e1.timeStamp), n.length === this.numTouches && (this.centroid = $902e455d852cdfb8$var$vf(t), this.touches = $902e455d852cdfb8$var$_f(n, t)));
    }
    touchmove(e1, t, n) {
        if (this.aborted || !this.centroid) return;
        let r = $902e455d852cdfb8$var$_f(n, t);
        for(let e1 in this.touches){
            let t = this.touches[e1], n = r[e1];
            (!n || n.dist(t) > 30) && (this.aborted = !0);
        }
    }
    touchend(e1, t, n) {
        if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), n.length === 0) {
            let e1 = !this.aborted && this.centroid;
            if (this.reset(), e1) return e1;
        }
    }
}, $902e455d852cdfb8$var$bf = class {
    constructor(e1){
        this.singleTap = new $902e455d852cdfb8$var$yf(e1), this.numTaps = e1.numTaps, this.reset();
    }
    reset() {
        this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
    }
    touchstart(e1, t, n) {
        this.singleTap.touchstart(e1, t, n);
    }
    touchmove(e1, t, n) {
        this.singleTap.touchmove(e1, t, n);
    }
    touchend(e1, t, n) {
        let r = this.singleTap.touchend(e1, t, n);
        if (r) {
            let t = e1.timeStamp - this.lastTime < 500, n = !this.lastTap || this.lastTap.dist(r) < 30;
            if ((!t || !n) && this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = r, this.count === this.numTaps) return this.reset(), r;
        }
    }
}, $902e455d852cdfb8$var$xf = class {
    constructor(e1, t){
        this._tr = t, this._zoomIn = new $902e455d852cdfb8$var$bf({
            numTouches: 1,
            numTaps: 2
        }), this._zoomOut = new $902e455d852cdfb8$var$bf({
            numTouches: 2,
            numTaps: 1
        }), this.reset();
    }
    reset() {
        this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
    }
    touchstart(e1, t, n) {
        this._zoomIn.touchstart(e1, t, n), this._zoomOut.touchstart(e1, t, n);
    }
    touchmove(e1, t, n) {
        this._zoomIn.touchmove(e1, t, n), this._zoomOut.touchmove(e1, t, n);
    }
    touchend(e1, t, n) {
        let r = this._zoomIn.touchend(e1, t, n), i = this._zoomOut.touchend(e1, t, n), a = this._tr;
        if (r) return this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
            cameraAnimation: (t)=>t.easeTo({
                    duration: 300,
                    zoom: (0, $caapT.Xn)(a.zoom + 1, t.getZoomSnap()),
                    around: a.unproject(r)
                }, {
                    originalEvent: e1
                })
        };
        if (i) return this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
            cameraAnimation: (t)=>t.easeTo({
                    duration: 300,
                    zoom: (0, $caapT.Xn)(a.zoom - 1, t.getZoomSnap()),
                    around: a.unproject(i)
                }, {
                    originalEvent: e1
                })
        };
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $902e455d852cdfb8$var$Sf = class {
    constructor(e1){
        this._enabled = !!e1.enable, this._moveStateManager = e1.moveStateManager, this._clickTolerance = e1.clickTolerance || 1, this._moveFunction = e1.move, this._activateOnStart = !!e1.activateOnStart, e1.assignEvents(this), this.reset();
    }
    reset(e1) {
        this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(e1);
    }
    _move(...e1) {
        let t = this._moveFunction(...e1);
        if (t.bearingDelta || t.pitchDelta || t.rollDelta || t.around || t.panDelta) return this._active = !0, t;
    }
    dragStart(e1, t) {
        !this.isEnabled() || this._lastPoint || this._moveStateManager.isValidStartEvent(e1) && (this._moveStateManager.startMove(e1), this._lastPoint = Array.isArray(t) ? t[0] : t, this._activateOnStart && this._lastPoint && (this._active = !0));
    }
    dragMove(e1, t) {
        if (!this.isEnabled()) return;
        let n = this._lastPoint;
        if (!n) return;
        if (e1.preventDefault(), !this._moveStateManager.isValidMoveEvent(e1)) {
            this.reset(e1);
            return;
        }
        let r = Array.isArray(t) ? t[0] : t;
        if (!(!this._moved && r.dist(n) < this._clickTolerance)) return this._moved = !0, this._lastPoint = r, this._move(n, r);
    }
    dragEnd(e1) {
        !this.isEnabled() || !this._lastPoint || this._moveStateManager.isValidEndEvent(e1) && (this._moved && $902e455d852cdfb8$var$W.suppressClick(), this.reset(e1));
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
    getClickTolerance() {
        return this._clickTolerance;
    }
};
const $902e455d852cdfb8$var$Cf = {
    0: 1,
    2: 2
};
function $902e455d852cdfb8$var$wf(e1, t) {
    let n = $902e455d852cdfb8$var$Cf[t];
    return e1.buttons === void 0 || (e1.buttons & n) !== n;
}
var $902e455d852cdfb8$var$Tf = class {
    constructor(e1){
        this._correctEvent = e1.checkCorrectEvent;
    }
    startMove(e1) {
        this._eventButton = e1.button;
    }
    endMove(e1) {
        delete this._eventButton;
    }
    isValidStartEvent(e1) {
        return this._correctEvent(e1);
    }
    isValidMoveEvent(e1) {
        return !$902e455d852cdfb8$var$wf(e1, this._eventButton);
    }
    isValidEndEvent(e1) {
        return e1.button === this._eventButton;
    }
}, $902e455d852cdfb8$var$Ef = class {
    constructor(){
        this._firstTouch = void 0;
    }
    _isOneFingerTouch(e1) {
        return e1.targetTouches.length === 1;
    }
    _isSameTouchEvent(e1) {
        return e1.targetTouches[0].identifier === this._firstTouch;
    }
    startMove(e1) {
        this._firstTouch = e1.targetTouches[0].identifier;
    }
    endMove(e1) {
        delete this._firstTouch;
    }
    isValidStartEvent(e1) {
        return this._isOneFingerTouch(e1);
    }
    isValidMoveEvent(e1) {
        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
    }
    isValidEndEvent(e1) {
        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
    }
}, $902e455d852cdfb8$var$Df = class {
    constructor(e1 = new $902e455d852cdfb8$var$Tf({
        checkCorrectEvent: ()=>!0
    }), t = new $902e455d852cdfb8$var$Ef){
        this.mouseMoveStateManager = e1, this.oneFingerTouchMoveStateManager = t;
    }
    _executeRelevantHandler(e1, t, n) {
        if (e1 instanceof MouseEvent) return t(e1);
        if (typeof TouchEvent < `u` && e1 instanceof TouchEvent) return n(e1);
    }
    startMove(e1) {
        this._executeRelevantHandler(e1, (e1)=>{
            this.mouseMoveStateManager.startMove(e1);
        }, (e1)=>{
            this.oneFingerTouchMoveStateManager.startMove(e1);
        });
    }
    endMove(e1) {
        this._executeRelevantHandler(e1, (e1)=>{
            this.mouseMoveStateManager.endMove(e1);
        }, (e1)=>{
            this.oneFingerTouchMoveStateManager.endMove(e1);
        });
    }
    isValidStartEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidStartEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidStartEvent(e1));
    }
    isValidMoveEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidMoveEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidMoveEvent(e1));
    }
    isValidEndEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidEndEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidEndEvent(e1));
    }
};
const $902e455d852cdfb8$var$Of = (e1)=>{
    e1.mousedown = e1.dragStart, e1.mousemoveWindow = e1.dragMove, e1.mouseup = e1.dragEnd, e1.contextmenu = (e1)=>{
        e1.preventDefault();
    };
};
function $902e455d852cdfb8$var$kf({ enable: e1, clickTolerance: t }) {
    return new $902e455d852cdfb8$var$Sf({
        clickTolerance: t,
        move: (e1, t)=>({
                around: t,
                panDelta: t.sub(e1)
            }),
        activateOnStart: !0,
        moveStateManager: new $902e455d852cdfb8$var$Tf({
            checkCorrectEvent: (e1)=>e1.button === 0 && !e1.ctrlKey
        }),
        enable: e1,
        assignEvents: $902e455d852cdfb8$var$Of
    });
}
function $902e455d852cdfb8$var$Af({ enable: e1, clickTolerance: t, aroundCenter: n = !0, minPixelCenterThreshold: r = 100, rotateDegreesPerPixelMoved: i = .8 }, a) {
    return new $902e455d852cdfb8$var$Sf({
        clickTolerance: t,
        move: (e1, t)=>{
            let o = a();
            if (n && Math.abs(o.y - e1.y) > r) return {
                bearingDelta: (0, $caapT.tr)(new (0, $caapT.ji)(e1.x, t.y), t, o)
            };
            let s = (t.x - e1.x) * i;
            return n && t.y < o.y && (s = -s), {
                bearingDelta: s
            };
        },
        moveStateManager: new $902e455d852cdfb8$var$Tf({
            checkCorrectEvent: (e1)=>e1.button === 0 && e1.ctrlKey || e1.button === 2 && !e1.ctrlKey
        }),
        enable: e1,
        assignEvents: $902e455d852cdfb8$var$Of
    });
}
function $902e455d852cdfb8$var$jf({ enable: e1, clickTolerance: t, pitchDegreesPerPixelMoved: n = -0.5 }) {
    return new $902e455d852cdfb8$var$Sf({
        clickTolerance: t,
        move: (e1, t)=>({
                pitchDelta: (t.y - e1.y) * n
            }),
        moveStateManager: new $902e455d852cdfb8$var$Tf({
            checkCorrectEvent: (e1)=>e1.button === 0 && e1.ctrlKey || e1.button === 2
        }),
        enable: e1,
        assignEvents: $902e455d852cdfb8$var$Of
    });
}
function $902e455d852cdfb8$var$Mf({ enable: e1, clickTolerance: t, rollDegreesPerPixelMoved: n = .3 }, r) {
    return new $902e455d852cdfb8$var$Sf({
        clickTolerance: t,
        move: (e1, t)=>{
            let i = r(), a = (t.x - e1.x) * n;
            return t.y < i.y && (a = -a), {
                rollDelta: a
            };
        },
        moveStateManager: new $902e455d852cdfb8$var$Tf({
            checkCorrectEvent: (e1)=>e1.button === 2 && e1.ctrlKey
        }),
        enable: e1,
        assignEvents: $902e455d852cdfb8$var$Of
    });
}
var $902e455d852cdfb8$var$Nf = class {
    constructor(e1, t){
        this._clickTolerance = e1.clickTolerance || 1, this._map = t, this.reset();
    }
    reset() {
        this._active = !1, this._touches = {}, this._sum = new (0, $caapT.ji)(0, 0);
    }
    _shouldBePrevented(e1) {
        return e1 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
    }
    touchstart(e1, t, n) {
        return this._calculateTransform(e1, t, n);
    }
    touchmove(e1, t, n) {
        if (this._active) {
            if (this._shouldBePrevented(n.length)) {
                this._map.cooperativeGestures.notifyGestureBlocked(`touch_pan`, e1);
                return;
            }
            return e1.preventDefault(), this._calculateTransform(e1, t, n);
        }
    }
    touchend(e1, t, n) {
        this._calculateTransform(e1, t, n), this._active && this._shouldBePrevented(n.length) && this.reset();
    }
    touchcancel() {
        this.reset();
    }
    _calculateTransform(e1, t, n) {
        n.length > 0 && (this._active = !0);
        let r = $902e455d852cdfb8$var$_f(n, t), i = new (0, $caapT.ji)(0, 0), a = new (0, $caapT.ji)(0, 0), o = 0;
        for(let e1 in r){
            let t = r[e1], n = this._touches[e1];
            n && (i._add(t), a._add(t.sub(n)), o++, r[e1] = t);
        }
        if (this._touches = r, this._shouldBePrevented(o) || !a.mag()) return;
        let s = a.div(o);
        if (this._sum._add(s), !(this._sum.mag() < this._clickTolerance)) return {
            around: i.div(o),
            panDelta: s
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $902e455d852cdfb8$var$Pf = class {
    constructor(){
        this.reset();
    }
    reset() {
        this._active = !1, delete this._firstTwoTouches;
    }
    touchstart(e1, t, n) {
        this._firstTwoTouches || n.length < 2 || (this._firstTwoTouches = [
            n[0].identifier,
            n[1].identifier
        ], this._start([
            t[0],
            t[1]
        ]));
    }
    touchmove(e1, t, n) {
        if (!this._firstTwoTouches) return;
        e1.preventDefault();
        let [r, i] = this._firstTwoTouches, a = $902e455d852cdfb8$var$Ff(n, t, r), o = $902e455d852cdfb8$var$Ff(n, t, i);
        if (!a || !o) return;
        let s = this._aroundCenter ? null : a.add(o).div(2);
        return this._move([
            a,
            o
        ], s, e1);
    }
    touchend(e1, t, n) {
        if (!this._firstTwoTouches) return;
        let [r, i] = this._firstTwoTouches, a = $902e455d852cdfb8$var$Ff(n, t, r), o = $902e455d852cdfb8$var$Ff(n, t, i);
        a && o || (this._active && $902e455d852cdfb8$var$W.suppressClick(), this.reset());
    }
    touchcancel() {
        this.reset();
    }
    enable(e1) {
        this._enabled = !0, this._aroundCenter = !!e1 && e1.around === `center`;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active;
    }
};
function $902e455d852cdfb8$var$Ff(e1, t, n) {
    for(let r = 0; r < e1.length; r++)if (e1[r].identifier === n) return t[r];
}
const $902e455d852cdfb8$var$If = .1;
function $902e455d852cdfb8$var$Lf(e1, t) {
    return Math.log(e1 / t) / Math.LN2;
}
var $902e455d852cdfb8$export$db37e9f00445aa54 = class extends $902e455d852cdfb8$var$Pf {
    constructor(){
        super(), this._zoomRate = 1, this._zoomThreshold = $902e455d852cdfb8$var$If;
    }
    setZoomRate(e1) {
        this._zoomRate = e1 ?? 1;
    }
    setZoomThreshold(e1) {
        this._zoomThreshold = e1 ?? $902e455d852cdfb8$var$If;
    }
    reset() {
        super.reset(), delete this._distance, delete this._startDistance;
    }
    _start(e1) {
        this._startDistance = this._distance = e1[0].dist(e1[1]);
    }
    _move(e1, t) {
        let n = this._distance;
        if (this._distance = e1[0].dist(e1[1]), !(!this._active && Math.abs($902e455d852cdfb8$var$Lf(this._distance, this._startDistance)) < this._zoomThreshold)) return this._active = !0, {
            zoomDelta: $902e455d852cdfb8$var$Lf(this._distance, n) * this._zoomRate,
            pinchAround: t
        };
    }
};
function $902e455d852cdfb8$var$zf(e1, t) {
    return e1.angleWith(t) * 180 / Math.PI;
}
var $902e455d852cdfb8$export$6966aa20d1b4577f = class extends $902e455d852cdfb8$var$Pf {
    reset() {
        super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
    }
    _start(e1) {
        this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
    }
    _move(e1, t, n) {
        let r = this._vector;
        if (this._vector = e1[0].sub(e1[1]), !(!this._active && this._isBelowThreshold(this._vector))) return this._active = !0, {
            bearingDelta: $902e455d852cdfb8$var$zf(this._vector, r),
            pinchAround: t
        };
    }
    _isBelowThreshold(e1) {
        this._minDiameter = Math.min(this._minDiameter, e1.mag());
        let t = 25 / (Math.PI * this._minDiameter) * 360, n = $902e455d852cdfb8$var$zf(e1, this._startVector);
        return Math.abs(n) < t;
    }
};
function $902e455d852cdfb8$var$Vf(e1) {
    return Math.abs(e1.y) > Math.abs(e1.x);
}
var $902e455d852cdfb8$export$7ea266bd3010ae2a = class extends $902e455d852cdfb8$var$Pf {
    constructor(e1){
        super(), this._currentTouchCount = 0, this._map = e1;
    }
    reset() {
        super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
    }
    touchstart(e1, t, n) {
        super.touchstart(e1, t, n), this._currentTouchCount = n.length;
    }
    _start(e1) {
        this._lastPoints = e1, $902e455d852cdfb8$var$Vf(e1[0].sub(e1[1])) && (this._valid = !1);
    }
    _move(e1, t, n) {
        if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
        let r = e1[0].sub(this._lastPoints[0]), i = e1[1].sub(this._lastPoints[1]);
        if (this._valid = this.gestureBeginsVertically(r, i, n.timeStamp), this._valid) return this._lastPoints = e1, this._active = !0, {
            pitchDelta: (r.y + i.y) / 2 * -0.5
        };
    }
    gestureBeginsVertically(e1, t, n) {
        if (this._valid !== void 0) return this._valid;
        let r = e1.mag() >= 2, i = t.mag() >= 2;
        if (!r && !i) return;
        if (!r || !i) return this._firstMove === void 0 && (this._firstMove = n), n - this._firstMove < 100 && void 0;
        let a = e1.y > 0 == t.y > 0;
        return $902e455d852cdfb8$var$Vf(e1) && $902e455d852cdfb8$var$Vf(t) && a;
    }
};
const $902e455d852cdfb8$var$Uf = {
    panStep: 100,
    bearingStep: 15,
    pitchStep: 10
};
var $902e455d852cdfb8$export$474b8119f9aaf6a9 = class {
    constructor(e1, t){
        this._tr = t;
        let n = $902e455d852cdfb8$var$Uf;
        this._panStep = n.panStep, this._bearingStep = n.bearingStep, this._pitchStep = n.pitchStep, this._rotationDisabled = !1;
    }
    reset() {
        this._active = !1;
    }
    keydown(e1) {
        if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
        let t = 0, n = 0, r = 0, i = 0, a = 0;
        switch(e1.keyCode){
            case 61:
            case 107:
            case 171:
            case 187:
                t = 1;
                break;
            case 189:
            case 109:
            case 173:
                t = -1;
                break;
            case 37:
                e1.shiftKey ? n = -1 : (e1.preventDefault(), i = -1);
                break;
            case 39:
                e1.shiftKey ? n = 1 : (e1.preventDefault(), i = 1);
                break;
            case 38:
                e1.shiftKey ? r = 1 : (e1.preventDefault(), a = -1);
                break;
            case 40:
                e1.shiftKey ? r = -1 : (e1.preventDefault(), a = 1);
                break;
            default:
                return;
        }
        return this._rotationDisabled && (n = 0, r = 0), {
            cameraAnimation: (o)=>{
                let s = this._tr;
                o.easeTo({
                    duration: 300,
                    easeId: `keyboardHandler`,
                    easing: $902e455d852cdfb8$var$Gf,
                    zoom: t ? (0, $caapT.Xn)(s.zoom + t * (e1.shiftKey ? 2 : 1), o.getZoomSnap()) : s.zoom,
                    bearing: s.bearing + n * this._bearingStep,
                    pitch: s.pitch + r * this._pitchStep,
                    offset: [
                        -i * this._panStep,
                        -a * this._panStep
                    ],
                    center: s.center
                }, {
                    originalEvent: e1
                });
            }
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
    disableRotation() {
        this._rotationDisabled = !0;
    }
    enableRotation() {
        this._rotationDisabled = !1;
    }
};
function $902e455d852cdfb8$var$Gf(e1) {
    return e1 * (2 - e1);
}
const $902e455d852cdfb8$var$Kf = 4.000244140625;
var $902e455d852cdfb8$export$fd7a47efd2367414 = class {
    constructor(e1, t, n){
        this._onTimeout = (e1)=>{
            this._type = `wheel`, this._delta -= this._lastValue, this._active || this._start(e1);
        }, this._map = e1, this._tr = n, this._triggerRenderFrame = t, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
    }
    setZoomRate(e1) {
        this._defaultZoomRate = e1;
    }
    setWheelZoomRate(e1) {
        this._wheelZoomRate = e1;
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active || this._finishTimeout !== void 0;
    }
    isZooming() {
        return !!this._zooming;
    }
    enable(e1) {
        this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && e1.around === `center`);
    }
    disable() {
        this.isEnabled() && (this._enabled = !1);
    }
    _shouldBePrevented(e1) {
        return this._map.cooperativeGestures.isEnabled() ? !(e1.ctrlKey || this._map.cooperativeGestures.isBypassed(e1)) : !1;
    }
    wheel(e1) {
        if (!this.isEnabled()) return;
        if (this._shouldBePrevented(e1)) {
            this._map.cooperativeGestures.notifyGestureBlocked(`wheel_zoom`, e1);
            return;
        }
        let t = e1.deltaMode === WheelEvent.DOM_DELTA_LINE ? e1.deltaY * 40 : e1.deltaY, n = $902e455d852cdfb8$export$461939dd4422153(), r = n - (this._lastWheelEventTime || 0);
        this._lastWheelEventTime = n, t !== 0 && t % $902e455d852cdfb8$var$Kf == 0 ? this._type = `wheel` : t !== 0 && Math.abs(t) < 4 ? this._type = `trackpad` : r > 400 ? (this._type = null, this._lastValue = t, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(r * t) < 200 ? `trackpad` : `wheel`, this._timeout && (clearTimeout(this._timeout), this._timeout = null, t += this._lastValue)), e1.shiftKey && t && (t /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= t, this._active || this._start(e1)), e1.preventDefault();
    }
    _start(e1) {
        if (!this._delta) return;
        this._needsRerender = !1, this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
        let t = $902e455d852cdfb8$var$W.mousePos(this._map.getCanvas(), e1), n = this._tr;
        this._aroundCenter ? this._aroundPoint = n.transform.locationToScreenPoint((0, $caapT.k).convert(n.center)) : this._aroundPoint = t, this._needsRerender || (this._needsRerender = !0, this._triggerRenderFrame());
    }
    renderFrame() {
        if (!this._needsRerender || (this._needsRerender = !1, !this.isActive())) return;
        let e1 = this._tr.transform;
        if (typeof this._lastExpectedZoom == `number`) {
            let t = e1.zoom - this._lastExpectedZoom;
            typeof this._startZoom == `number` && (this._startZoom += t), typeof this._targetZoom == `number` && (this._targetZoom += t);
        }
        if (this._delta !== 0) {
            let t = this._type === `wheel` && Math.abs(this._delta) > $902e455d852cdfb8$var$Kf ? this._wheelZoomRate : this._defaultZoomRate, n = 2 / (1 + Math.exp(-Math.abs(this._delta * t)));
            this._delta < 0 && n !== 0 && (n = 1 / n);
            let r = typeof this._targetZoom == `number` ? (0, $caapT.Mr)(this._targetZoom) : e1.scale, i = e1.applyConstrain(e1.getCameraLngLat(), (0, $caapT.wr)(r * n)).zoom, a = this._map.getZoomSnap();
            if (this._type === `wheel` && a > 0) {
                let t = (0, $caapT.Xn)(e1.zoom, a);
                this._targetZoom = (0, $caapT.Xn)(i, a, i - t);
            } else this._targetZoom = i;
            this._type === `wheel` && (this._startZoom = e1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
        }
        let t = typeof this._targetZoom == `number` ? this._targetZoom : e1.zoom, n = this._startZoom, r = this._easing, i = !1, a;
        if (this._type === `wheel` && n && r) {
            let e1 = $902e455d852cdfb8$export$461939dd4422153() - this._lastWheelEventTime, o = Math.min((e1 + 5) / 200, 1), s = r(o);
            a = (0, $caapT.un).number(n, t, s), o < 1 ? this._needsRerender = !0 : i = !0;
        } else a = t, i = !0;
        return this._active = !0, i && (this._active = !1, this._finishTimeout = setTimeout(()=>{
            this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
        }, 200)), this._lastExpectedZoom = a, {
            noInertia: !0,
            needsRenderFrame: !i,
            zoomDelta: a - e1.zoom,
            around: this._aroundPoint,
            originalEvent: this._lastWheelEvent
        };
    }
    _smoothOutEasing(e1) {
        let t = (0, $caapT.Wn);
        if (this._prevEase) {
            let e1 = this._prevEase, n = ($902e455d852cdfb8$export$461939dd4422153() - e1.start) / e1.duration, r = e1.easing(n + .01) - e1.easing(n), i = .27 / Math.sqrt(r * r + 1e-4) * .01;
            t = (0, $caapT.Fn)(i, Math.sqrt(0.0729 - i * i), .25, 1);
        }
        return this._prevEase = {
            start: $902e455d852cdfb8$export$461939dd4422153(),
            duration: e1,
            easing: t
        }, t;
    }
    reset() {
        this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
    }
}, $902e455d852cdfb8$export$939799190379133f = class {
    constructor(e1, t){
        this._clickZoom = e1, this._tapZoom = t;
    }
    enable() {
        this._clickZoom.enable(), this._tapZoom.enable();
    }
    disable() {
        this._clickZoom.disable(), this._tapZoom.disable();
    }
    isEnabled() {
        return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
    }
    isActive() {
        return this._clickZoom.isActive() || this._tapZoom.isActive();
    }
}, $902e455d852cdfb8$var$Yf = class {
    constructor(e1, t){
        this._tr = t, this.reset();
    }
    reset() {
        this._active = !1;
    }
    dblclick(e1, t) {
        return e1.preventDefault(), {
            cameraAnimation: (n)=>{
                n.easeTo({
                    duration: 300,
                    zoom: (0, $caapT.Xn)(this._tr.zoom + (e1.shiftKey ? -1 : 1), n.getZoomSnap()),
                    around: this._tr.unproject(t)
                }, {
                    originalEvent: e1
                });
            }
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $902e455d852cdfb8$var$Xf = class {
    constructor(){
        this._tap = new $902e455d852cdfb8$var$bf({
            numTouches: 1,
            numTaps: 1
        }), this._zoomRate = 1, this.reset();
    }
    setZoomRate(e1) {
        this._zoomRate = e1 ?? 1;
    }
    reset() {
        this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
    }
    touchstart(e1, t, n) {
        if (!this._swipePoint) {
            if (!this._tapTime) this._tap.touchstart(e1, t, n);
            else {
                let r = t[0], i = e1.timeStamp - this._tapTime < 500, a = this._tapPoint.dist(r) < 30;
                !i || !a ? this.reset() : n.length > 0 && (this._swipePoint = r, this._swipeTouch = n[0].identifier);
            }
        }
    }
    touchmove(e1, t, n) {
        if (!this._tapTime) this._tap.touchmove(e1, t, n);
        else if (this._swipePoint) {
            if (n[0].identifier !== this._swipeTouch) return;
            let r = t[0], i = r.y - this._swipePoint.y;
            return this._swipePoint = r, e1.preventDefault(), this._active = !0, {
                zoomDelta: i / 128 * this._zoomRate
            };
        }
    }
    touchend(e1, t, n) {
        if (this._tapTime) this._swipePoint && n.length === 0 && this.reset();
        else {
            let r = this._tap.touchend(e1, t, n);
            r && (this._tapTime = e1.timeStamp, this._tapPoint = r);
        }
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $902e455d852cdfb8$export$69c4612f5624c3f0 = class {
    constructor(e1, t, n){
        this._el = e1, this._mousePan = t, this._touchPan = n;
    }
    enable(e1) {
        this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add(`maplibregl-touch-drag-pan`);
    }
    disable() {
        this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove(`maplibregl-touch-drag-pan`);
    }
    isEnabled() {
        return this._mousePan.isEnabled() && this._touchPan.isEnabled();
    }
    isActive() {
        return this._mousePan.isActive() || this._touchPan.isActive();
    }
}, $902e455d852cdfb8$export$fc9ed7efe29ccb64 = class {
    constructor(e1, t, n, r){
        this._pitchWithRotate = e1.pitchWithRotate, this._rollEnabled = e1.rollEnabled, this._mouseRotate = t, this._mousePitch = n, this._mouseRoll = r;
    }
    enable() {
        this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
    }
    disable() {
        this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
    }
    isEnabled() {
        return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
    }
    isActive() {
        return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
    }
}, $902e455d852cdfb8$export$69d5f25840cce15f = class {
    constructor(e1, t, n, r){
        this._el = e1, this._touchZoom = t, this._touchRotate = n, this._tapDragZoom = r, this._rotationDisabled = !1, this._enabled = !0;
    }
    enable(e1) {
        this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add(`maplibregl-touch-zoom-rotate`);
    }
    disable() {
        this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove(`maplibregl-touch-zoom-rotate`);
    }
    isEnabled() {
        return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
    }
    isActive() {
        return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
    }
    setZoomRate(e1) {
        this._touchZoom.setZoomRate(e1), this._tapDragZoom.setZoomRate(e1);
    }
    setZoomThreshold(e1) {
        this._touchZoom.setZoomThreshold(e1);
    }
    disableRotation() {
        this._rotationDisabled = !0, this._touchRotate.disable();
    }
    enableRotation() {
        this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
    }
}, $902e455d852cdfb8$export$eba3588e2069a729 = class {
    constructor(e1, t){
        this._bypassKey = navigator.userAgent.includes(`Mac`) ? `metaKey` : `ctrlKey`, this._map = e1, this._options = t, this._enabled = !1;
    }
    isActive() {
        return !1;
    }
    reset() {}
    _setupUI() {
        if (this._container) return;
        let e1 = this._map.getCanvasContainer();
        e1.classList.add(`maplibregl-cooperative-gestures`), this._container = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-cooperative-gesture-screen`, e1);
        let t = this._map._getUIString(`CooperativeGesturesHandler.WindowsHelpText`);
        this._bypassKey === `metaKey` && (t = this._map._getUIString(`CooperativeGesturesHandler.MacHelpText`));
        let n = this._map._getUIString(`CooperativeGesturesHandler.MobileHelpText`), r = document.createElement(`div`);
        r.className = `maplibregl-desktop-message`, r.textContent = t, this._container.appendChild(r);
        let i = document.createElement(`div`);
        i.className = `maplibregl-mobile-message`, i.textContent = n, this._container.appendChild(i), this._container.setAttribute(`aria-hidden`, `true`);
    }
    _destroyUI() {
        this._container && (this._container.remove(), this._map.getCanvasContainer().classList.remove(`maplibregl-cooperative-gestures`)), delete this._container;
    }
    enable() {
        this._setupUI(), this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this._destroyUI();
    }
    isEnabled() {
        return this._enabled;
    }
    isBypassed(e1) {
        return e1[this._bypassKey];
    }
    notifyGestureBlocked(e1, t) {
        this._enabled && (this._map.fire(new $902e455d852cdfb8$export$fc21b96c04d10d16(`cooperativegestureprevented`, {
            gestureType: e1,
            originalEvent: t
        })), this._container.classList.add(`maplibregl-show`), setTimeout(()=>{
            this._container.classList.remove(`maplibregl-show`);
        }, 100));
    }
}, $902e455d852cdfb8$var$tp = class {
    constructor(e1){
        this._camera = e1;
    }
    get transform() {
        return this._camera._requestedCameraState || this._camera.transform;
    }
    get center() {
        return {
            lng: this.transform.center.lng,
            lat: this.transform.center.lat
        };
    }
    get zoom() {
        return this.transform.zoom;
    }
    get pitch() {
        return this.transform.pitch;
    }
    get bearing() {
        return this.transform.bearing;
    }
    unproject(e1) {
        return this.transform.screenPointToLocation((0, $caapT.ji).convert(e1), this._camera.terrain);
    }
};
const $902e455d852cdfb8$var$np = (e1)=>e1.zoom || e1.drag || e1.roll || e1.pitch || e1.rotate;
var $902e455d852cdfb8$var$rp = class extends (0, $caapT.pn) {
};
function $902e455d852cdfb8$var$ip(e1) {
    return e1.panDelta?.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta || e1.rollDelta;
}
var $902e455d852cdfb8$var$ap = class {
    get _ownerDocument() {
        return this._el?.ownerDocument || document;
    }
    get _ownerWindow() {
        return this._el?.ownerDocument?.defaultView || window;
    }
    constructor(e1, t, n){
        this.handleWindowEvent = (e1)=>{
            this.handleEvent(e1, `${e1.type}Window`);
        }, this.handleEvent = (e1, t)=>{
            if (e1.type === `blur`) {
                this.stop(!0);
                return;
            }
            this._updatingCamera = !0;
            let n = e1.type === `renderFrame` ? void 0 : e1, r = {
                needsRenderFrame: !1
            }, i = {}, a = {};
            for (let { handlerName: o, handler: s, allowed: c } of this._handlers){
                if (!s.isEnabled()) continue;
                let l;
                if (this._blockedByActive(a, c, o)) s.reset();
                else if (s[t || e1.type]) {
                    if ((0, $caapT.or)(e1, t || e1.type)) {
                        let n = $902e455d852cdfb8$var$W.mousePos(this._map.getCanvas(), e1);
                        l = s[t || e1.type](e1, n);
                    } else if ((0, $caapT.cr)(e1, t || e1.type)) {
                        let n = e1.touches, r = this._getMapTouches(n), i = $902e455d852cdfb8$var$W.touchPos(this._map.getCanvas(), r);
                        l = s[t || e1.type](e1, i, r);
                    } else (0, $caapT.lr)(t || e1.type) || (l = s[t || e1.type](e1));
                    this.mergeHandlerResult(r, i, l, o, n), l?.needsRenderFrame && this._triggerRenderFrame();
                }
                (l || s.isActive()) && (a[o] = s);
            }
            let o = {};
            for(let e1 in this._previousActiveHandlers)a[e1] || (o[e1] = n);
            this._previousActiveHandlers = a, (Object.keys(o).length || $902e455d852cdfb8$var$ip(r)) && (this._changes.push([
                r,
                i,
                o
            ]), this._triggerRenderFrame()), (Object.keys(a).length || $902e455d852cdfb8$var$ip(r)) && this._camera.stop(!0), this._updatingCamera = !1;
            let { cameraAnimation: s } = r;
            s && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], s(this._map));
        }, this._map = e1, this._camera = t, this._transformProvider = new $902e455d852cdfb8$var$tp(this._camera), this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new $902e455d852cdfb8$var$df(e1), this._bearingSnap = n.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(n);
        let r = this._el;
        this._listeners = [
            [
                r,
                `touchstart`,
                {
                    passive: !0
                }
            ],
            [
                r,
                `touchmove`,
                {
                    passive: !1
                }
            ],
            [
                r,
                `touchend`,
                void 0
            ],
            [
                r,
                `touchcancel`,
                void 0
            ],
            [
                r,
                `mousedown`,
                void 0
            ],
            [
                r,
                `mousemove`,
                void 0
            ],
            [
                r,
                `mouseup`,
                void 0
            ],
            [
                this._ownerDocument,
                `mousemove`,
                {
                    capture: !0
                }
            ],
            [
                this._ownerDocument,
                `mouseup`,
                void 0
            ],
            [
                r,
                `mouseover`,
                void 0
            ],
            [
                r,
                `mouseout`,
                void 0
            ],
            [
                r,
                `dblclick`,
                void 0
            ],
            [
                r,
                `click`,
                void 0
            ],
            [
                r,
                `keydown`,
                {
                    capture: !1
                }
            ],
            [
                r,
                `keyup`,
                void 0
            ],
            [
                r,
                `wheel`,
                {
                    passive: !1
                }
            ],
            [
                r,
                `contextmenu`,
                void 0
            ],
            [
                this._ownerWindow,
                `blur`,
                void 0
            ]
        ];
        for (let [e1, t, n] of this._listeners)e1.addEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, n);
    }
    destroy() {
        for (let [e1, t, n] of this._listeners)e1.removeEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, n);
    }
    _addDefaultHandlers(e1) {
        let t = this._map, n = t.getCanvasContainer();
        this._add(`mapEvent`, new $902e455d852cdfb8$var$mf(t, e1));
        let r = t.boxZoom = new $902e455d852cdfb8$export$bd01c6f06175f3af(t, e1, this._transformProvider);
        this._add(`boxZoom`, r), e1.interactive && e1.boxZoom && r.enable();
        let i = t.cooperativeGestures = new $902e455d852cdfb8$export$eba3588e2069a729(t, e1.cooperativeGestures);
        this._add(`cooperativeGestures`, i), e1.cooperativeGestures && i.enable();
        let a = new $902e455d852cdfb8$var$xf(t, this._transformProvider), o = new $902e455d852cdfb8$var$Yf(t, this._transformProvider);
        t.doubleClickZoom = new $902e455d852cdfb8$export$939799190379133f(o, a), this._add(`tapZoom`, a), this._add(`clickZoom`, o), e1.interactive && e1.doubleClickZoom && t.doubleClickZoom.enable();
        let s = new $902e455d852cdfb8$var$Xf;
        this._add(`tapDragZoom`, s);
        let c = t.touchPitch = new $902e455d852cdfb8$export$7ea266bd3010ae2a(t);
        this._add(`touchPitch`, c), e1.interactive && e1.touchPitch && t.touchPitch.enable(e1.touchPitch);
        let l = ()=>t.project(t.getCenter()), u = $902e455d852cdfb8$var$Af(e1, l), d = $902e455d852cdfb8$var$jf(e1), f = $902e455d852cdfb8$var$Mf(e1, l);
        t.dragRotate = new $902e455d852cdfb8$export$fc9ed7efe29ccb64(e1, u, d, f), this._add(`mouseRotate`, u, [
            `mousePitch`
        ]), this._add(`mousePitch`, d, [
            `mouseRotate`,
            `mouseRoll`
        ]), this._add(`mouseRoll`, f, [
            `mousePitch`
        ]), e1.interactive && e1.dragRotate && t.dragRotate.enable();
        let p = $902e455d852cdfb8$var$kf(e1), m = new $902e455d852cdfb8$var$Nf(e1, t);
        t.dragPan = new $902e455d852cdfb8$export$69c4612f5624c3f0(n, p, m), this._add(`mousePan`, p), this._add(`touchPan`, m, [
            `touchZoom`,
            `touchRotate`
        ]), e1.interactive && e1.dragPan && t.dragPan.enable(e1.dragPan);
        let h = new $902e455d852cdfb8$export$6966aa20d1b4577f, g = new $902e455d852cdfb8$export$db37e9f00445aa54;
        t.touchZoomRotate = new $902e455d852cdfb8$export$69d5f25840cce15f(n, g, h, s), this._add(`touchRotate`, h, [
            `touchPan`,
            `touchZoom`
        ]), this._add(`touchZoom`, g, [
            `touchPan`,
            `touchRotate`
        ]), e1.interactive && e1.touchZoomRotate && t.touchZoomRotate.enable(e1.touchZoomRotate), this._add(`blockableMapEvent`, new $902e455d852cdfb8$var$hf(t));
        let _ = t.scrollZoom = new $902e455d852cdfb8$export$fd7a47efd2367414(t, ()=>this._triggerRenderFrame(), this._transformProvider);
        this._add(`scrollZoom`, _, [
            `mousePan`
        ]), e1.interactive && e1.scrollZoom && t.scrollZoom.enable(e1.scrollZoom);
        let v = t.keyboard = new $902e455d852cdfb8$export$474b8119f9aaf6a9(t, this._transformProvider);
        this._add(`keyboard`, v), e1.interactive && e1.keyboard && t.keyboard.enable();
    }
    _add(e1, t, n) {
        this._handlers.push({
            handlerName: e1,
            handler: t,
            allowed: n
        }), this._handlersById[e1] = t;
    }
    stop(e1) {
        if (!this._updatingCamera) {
            for (let { handler: e1 } of this._handlers)e1.reset();
            this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [];
        }
    }
    isActive() {
        for (let { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
        return !1;
    }
    isZooming() {
        return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
    }
    isRotating() {
        return !!this._eventsInProgress.rotate;
    }
    isMoving() {
        return !!$902e455d852cdfb8$var$np(this._eventsInProgress) || this.isZooming();
    }
    _blockedByActive(e1, t, n) {
        for(let r in e1)if (r !== n && !t?.includes(r)) return !0;
        return !1;
    }
    _getMapTouches(e1) {
        let t = [];
        for (let n of e1){
            let e1 = n.target;
            this._el.contains(e1) && t.push(n);
        }
        return t;
    }
    mergeHandlerResult(e1, t, n, r, i) {
        if (!n) return;
        (0, $caapT.Zn)(e1, n);
        let a = {
            handlerName: r,
            originalEvent: n.originalEvent || i
        };
        n.zoomDelta !== void 0 && (t.zoom = a), n.panDelta !== void 0 && (t.drag = a), n.rollDelta !== void 0 && (t.roll = a), n.pitchDelta !== void 0 && (t.pitch = a), n.bearingDelta !== void 0 && (t.rotate = a);
    }
    _applyChanges() {
        let e1 = {}, t = {}, n = {};
        for (let [r, i, a] of this._changes)r.panDelta && (e1.panDelta = (e1.panDelta || new (0, $caapT.ji)(0, 0))._add(r.panDelta)), r.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + r.pitchDelta), r.rollDelta && (e1.rollDelta = (e1.rollDelta || 0) + r.rollDelta), r.around !== void 0 && (e1.around = r.around), r.pinchAround !== void 0 && (e1.pinchAround = r.pinchAround), r.noInertia && (e1.noInertia = r.noInertia), (0, $caapT.Zn)(t, i), (0, $caapT.Zn)(n, a);
        this._updateMapTransform(e1, t, n), this._changes = [];
    }
    _updateMapTransform(e1, t, n) {
        let r = this._map, i = this._camera.getTransformForUpdate(), a = r.terrain;
        if (!$902e455d852cdfb8$var$ip(e1) && !(a && this._terrainMovement)) {
            this._fireEvents(t, n, !0);
            return;
        }
        this._camera.stop(!0);
        let { panDelta: o, zoomDelta: s, bearingDelta: c, pitchDelta: l, rollDelta: u, around: d, pinchAround: f } = e1;
        f !== void 0 && (d = f), d ||= this._camera.transform.centerPoint, a && !i.isPointOnMapSurface(d) && (d = i.centerPoint);
        let p = {
            panDelta: o,
            zoomDelta: s,
            rollDelta: u,
            pitchDelta: l,
            bearingDelta: c,
            around: d
        };
        this._camera.cameraHelper.useGlobeControls && !i.isPointOnMapSurface(d) && (d = i.centerPoint);
        let m = d.distSqr(i.centerPoint) < .01 ? i.center : i.screenPointToLocation(o ? d.sub(o) : d);
        this._handleMapControls({
            terrain: a,
            tr: i,
            deltasForHelper: p,
            preZoomAroundLoc: m,
            combinedEventsInProgress: t,
            panDelta: o
        }), this._camera.applyUpdatedTransform(i), this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(t, n, !0);
    }
    _handleMapControls({ terrain: e1, tr: t, deltasForHelper: n, preZoomAroundLoc: r, combinedEventsInProgress: i, panDelta: a }) {
        let o = this._camera.cameraHelper;
        if (o.handleMapControlsRollPitchBearingZoom(n, t), !e1) {
            o.handleMapControlsPan(n, t, r);
            return;
        }
        if (o.useGlobeControls) {
            !this._terrainMovement && (i.drag || i.zoom) && (this._terrainMovement = !0, this._camera.elevationFreeze = !0), o.handleMapControlsPan(n, t, r);
            return;
        }
        if (!this._terrainMovement && (i.drag || i.zoom)) {
            this._terrainMovement = !0, this._camera.elevationFreeze = !0, o.handleMapControlsPan(n, t, r);
            return;
        }
        if (i.drag && this._terrainMovement && a) {
            t.setCenter(t.screenPointToLocation(t.centerPoint.sub(a)));
            return;
        }
        o.handleMapControlsPan(n, t, r);
    }
    _fireEvents(e1, t, n) {
        let r = $902e455d852cdfb8$var$np(this._eventsInProgress), i = $902e455d852cdfb8$var$np(e1), a = {};
        for(let t in e1){
            let { originalEvent: n } = e1[t];
            this._eventsInProgress[t] || (a[`${t}start`] = n), this._eventsInProgress[t] = e1[t];
        }
        !r && i && this._fireEvent(`movestart`, i.originalEvent);
        for(let e1 in a)this._fireEvent(e1, a[e1]);
        i && this._fireEvent(`move`, i.originalEvent);
        for(let t in e1){
            let { originalEvent: n } = e1[t];
            this._fireEvent(t, n);
        }
        let o = {}, s;
        for(let e1 in this._eventsInProgress){
            let { handlerName: n, originalEvent: r } = this._eventsInProgress[e1];
            this._handlersById[n].isActive() || (delete this._eventsInProgress[e1], s = t[n] || r, o[`${e1}end`] = s);
        }
        for(let e1 in o)this._fireEvent(e1, o[e1]);
        let c = $902e455d852cdfb8$var$np(this._eventsInProgress), l = (r || i) && !c;
        if (l && this._terrainMovement) {
            this._camera.elevationFreeze = !1, this._terrainMovement = !1;
            let e1 = this._camera.getTransformForUpdate();
            this._map.getCenterClampedToGround() && e1.recalculateZoomAndCenter(this._map.terrain), this._camera.applyUpdatedTransform(e1);
        }
        if (n && l) {
            this._updatingCamera = !0;
            let e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), t = (e1)=>e1 !== 0 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
            e1 && (e1.essential || !$902e455d852cdfb8$var$Dr.prefersReducedMotion) ? (t(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), e1.freezeElevation = !0, this._map.easeTo(e1, {
                originalEvent: s
            })) : (this._map.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`moveend`, {
                originalEvent: s
            })), t(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
        }
    }
    _fireEvent(e1, t) {
        this._map.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(e1, t ? {
            originalEvent: t
        } : {}));
    }
    _requestFrame() {
        return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
            delete this._frameId, this.handleEvent(new $902e455d852cdfb8$var$rp(`renderFrame`, {
                timeStamp: e1
            })), this._applyChanges();
        });
    }
    _triggerRenderFrame() {
        this._frameId === void 0 && (this._frameId = this._requestFrame());
    }
}, $902e455d852cdfb8$var$op = class extends (0, $caapT.mn) {
    constructor(e1){
        super(), this._renderFrameCallback = ()=>{
            let e1 = Math.min(($902e455d852cdfb8$export$461939dd4422153() - this._easeStart) / this._easeOptions.duration, 1);
            this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
        }, this.transform = new $902e455d852cdfb8$var$Es, this.cameraHelper = new $902e455d852cdfb8$var$As, e1.minZoom !== void 0 && this.transform.setMinZoom(e1.minZoom), e1.maxZoom !== void 0 && this.transform.setMaxZoom(e1.maxZoom), e1.minPitch !== void 0 && this.transform.setMinPitch(e1.minPitch), e1.maxPitch !== void 0 && this.transform.setMaxPitch(e1.maxPitch), e1.renderWorldCopies !== void 0 && this.transform.setRenderWorldCopies(e1.renderWorldCopies), e1.transformConstrain !== null && this.transform.setConstrainOverride(e1.transformConstrain), this._moving = !1, this._zooming = !1, this._bearingSnap = e1.bearingSnap, this._zoomSnap = e1.zoomSnap, this._requestRenderFrame = e1.requestRenderFrame, this._cancelRenderFrame = e1.cancelRenderFrame, this.terrain = e1.terrain, this._centerClampedToGround = e1.centerClampedToGround ?? !0, this.transformCameraUpdate = e1.transformCameraUpdate ?? null, this._stopHandlers = e1.stopHandlers ?? (()=>{}), this.on(`moveend`, ()=>{
            delete this._requestedCameraState;
        });
    }
    migrateProjection(e1, t) {
        e1.apply(this.transform, !0), this.transform = e1, this.cameraHelper = t;
    }
    getCenter() {
        return new (0, $caapT.k)(this.transform.center.lng, this.transform.center.lat);
    }
    setCenter(e1, t) {
        return this.jumpTo({
            center: e1
        }, t);
    }
    getCenterElevation() {
        return this.transform.elevation;
    }
    setCenterElevation(e1, t) {
        return this.jumpTo({
            elevation: e1
        }, t), this;
    }
    getCenterClampedToGround() {
        return this._centerClampedToGround;
    }
    setCenterClampedToGround(e1) {
        this._centerClampedToGround = e1;
    }
    panBy(e1, t, n) {
        return e1 = (0, $caapT.ji).convert(e1).mult(-1), this.panTo(this.transform.center, (0, $caapT.Zn)({
            offset: e1
        }, t), n);
    }
    panTo(e1, t, n) {
        return this.easeTo((0, $caapT.Zn)({
            center: e1
        }, t), n);
    }
    getZoom() {
        return this.transform.zoom;
    }
    setZoom(e1, t) {
        return this.jumpTo({
            zoom: e1
        }, t), this;
    }
    zoomTo(e1, t, n) {
        return this.easeTo((0, $caapT.Zn)({
            zoom: e1
        }, t), n);
    }
    zoomIn(e1, t) {
        return this.zoomTo((0, $caapT.Xn)(this.getZoom() + 1, this._zoomSnap), e1, t), this;
    }
    zoomOut(e1, t) {
        return this.zoomTo((0, $caapT.Xn)(this.getZoom() - 1, this._zoomSnap), e1, t), this;
    }
    getVerticalFieldOfView() {
        return this.transform.fov;
    }
    setVerticalFieldOfView(e1, t) {
        return e1 != this.transform.fov && (this.transform.setFov(e1), this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`movestart`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`move`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`moveend`, t))), this;
    }
    getBearing() {
        return this.transform.bearing;
    }
    setZoomSnap(e1) {
        return this._zoomSnap = e1, this;
    }
    getZoomSnap() {
        return this._zoomSnap;
    }
    setBearing(e1, t) {
        return this.jumpTo({
            bearing: e1
        }, t), this;
    }
    getPadding() {
        return this.transform.padding;
    }
    setPadding(e1, t) {
        return this.jumpTo({
            padding: e1
        }, t), this;
    }
    rotateTo(e1, t, n) {
        return this.easeTo((0, $caapT.Zn)({
            bearing: e1
        }, t), n);
    }
    resetNorth(e1, t) {
        return this.rotateTo(0, (0, $caapT.Zn)({
            duration: 1e3
        }, e1), t), this;
    }
    resetNorthPitch(e1, t) {
        return this.easeTo((0, $caapT.Zn)({
            bearing: 0,
            pitch: 0,
            roll: 0,
            duration: 1e3
        }, e1), t), this;
    }
    snapToNorth(e1, t) {
        return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t) : this;
    }
    getPitch() {
        return this.transform.pitch;
    }
    setPitch(e1, t) {
        return this.jumpTo({
            pitch: e1
        }, t), this;
    }
    getRoll() {
        return this.transform.roll;
    }
    setRoll(e1, t) {
        return this.jumpTo({
            roll: e1
        }, t), this;
    }
    cameraForBounds(e1, t) {
        e1 = $902e455d852cdfb8$export$266d2884f61535d3.convert(e1).adjustAntiMeridian();
        let n = t?.bearing || 0;
        return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), n, t);
    }
    _cameraForBoxAndBearing(e1, t, n, r) {
        let i = {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
        };
        if (r = (0, $caapT.Zn)({
            padding: i,
            offset: [
                0,
                0
            ],
            maxZoom: this.transform.maxZoom
        }, r), typeof r.padding == `number`) {
            let e1 = r.padding;
            r.padding = {
                top: e1,
                bottom: e1,
                right: e1,
                left: e1
            };
        }
        let a = (0, $caapT.Zn)(i, r.padding);
        r.padding = a;
        let o = this.transform, s = new $902e455d852cdfb8$export$266d2884f61535d3(e1, t), c = this.cameraHelper.cameraForBoxAndBearing(r, a, s, n, o);
        return c && this._zoomSnap && (c.zoom = (0, $caapT.Xn)(c.zoom, this._zoomSnap, -1)), c;
    }
    fitBounds(e1, t, n) {
        return this._fitInternal(this.cameraForBounds(e1, t), t, n);
    }
    fitScreenCoordinates(e1, t, n, r, i) {
        return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation((0, $caapT.ji).convert(e1)), this.transform.screenPointToLocation((0, $caapT.ji).convert(t)), n, r), r, i);
    }
    _fitInternal(e1, t, n) {
        return e1 ? (t = (0, $caapT.Zn)(e1, t), delete t.padding, t.linear ? this.easeTo(t, n) : this.flyTo(t, n)) : this;
    }
    jumpTo(e1, t) {
        this.stop(), `zoom` in e1 && this._zoomSnap && (e1.zoom = (0, $caapT.Xn)(e1.zoom, this._zoomSnap));
        let n = this.getTransformForUpdate(), r = !1, i = !1, a = !1, o = n.zoom;
        this.terrain && n.setElevation(this.terrain.getElevationForLngLatZoom(e1.center ? (0, $caapT.k).convert(e1.center) : n.center, e1.zoom || n.tileZoom)), this.cameraHelper.handleJumpToCenterZoom(n, e1);
        let s = n.zoom !== o;
        return `elevation` in e1 && n.elevation !== +e1.elevation && n.setElevation(+e1.elevation), `bearing` in e1 && n.bearing !== +e1.bearing && (r = !0, n.setBearing(+e1.bearing)), `pitch` in e1 && n.pitch !== +e1.pitch && (i = !0, n.setPitch(+e1.pitch)), `roll` in e1 && n.roll !== +e1.roll && (a = !0, n.setRoll(+e1.roll)), e1.padding != null && !n.isPaddingEqual(e1.padding) && n.setPadding(e1.padding), this.applyUpdatedTransform(n), this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`movestart`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`move`, t)), s && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoomstart`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoom`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoomend`, t)), r && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rotatestart`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rotate`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rotateend`, t)), i && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitchstart`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitch`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitchend`, t)), a && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rollstart`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`roll`, t)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rollend`, t)), this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`moveend`, t));
    }
    calculateCameraOptionsFromTo(e1, t, n, r = 0) {
        let i = (0, $caapT.S).fromLngLat(e1, t), a = (0, $caapT.S).fromLngLat(n, r), o = a.x - i.x, s = a.y - i.y, c = a.z - i.z, l = Math.hypot(o, s, c);
        if (l === 0) throw Error(`Can't calculate camera options with same From and To`);
        let u = Math.hypot(o, s), d = (0, $caapT.wr)(this.transform.cameraToCenterDistance / l / this.transform.tileSize), f = Math.atan2(o, -s) * 180 / Math.PI, p = Math.acos(u / l) * 180 / Math.PI;
        return p = c < 0 ? 90 - p : 90 + p, {
            center: a.toLngLat(),
            elevation: r,
            zoom: d,
            pitch: p,
            bearing: f
        };
    }
    calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, n, r, i) {
        let a = this.transform.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
        return {
            center: a.center,
            elevation: a.elevation,
            zoom: a.zoom,
            bearing: n,
            pitch: r,
            roll: i
        };
    }
    easeTo(e1, t) {
        this._stop(!1, e1.easeId), e1 = (0, $caapT.Zn)({
            offset: [
                0,
                0
            ],
            duration: 500,
            easing: (0, $caapT.Wn)
        }, e1), `zoom` in e1 && this._zoomSnap && (e1.zoom = (0, $caapT.Xn)(e1.zoom, this._zoomSnap)), (e1.animate === !1 || !e1.essential && $902e455d852cdfb8$var$Dr.prefersReducedMotion) && (e1.duration = 0);
        let n = this.getTransformForUpdate(), r = this.getBearing(), i = n.pitch, a = n.roll, o = `bearing` in e1 ? this._normalizeBearing(e1.bearing, r) : r, s = `pitch` in e1 ? +e1.pitch : i, c = `roll` in e1 ? this._normalizeBearing(e1.roll, a) : a, l = `padding` in e1 ? e1.padding : n.padding, u = (0, $caapT.ji).convert(e1.offset), d, f;
        e1.around && (d = (0, $caapT.k).convert(e1.around), f = n.locationToScreenPoint(d));
        let p = {
            moving: this._moving,
            zooming: this._zooming,
            rotating: this._rotating,
            pitching: this._pitching,
            rolling: this._rolling
        }, m = this.cameraHelper.handleEaseTo(n, {
            bearing: o,
            pitch: s,
            roll: c,
            padding: l,
            around: d,
            aroundPoint: f,
            offsetAsPoint: u,
            offset: e1.offset,
            zoom: e1.zoom,
            center: e1.center
        });
        return this._rotating ||= r !== o, this._pitching ||= s !== i, this._rolling ||= c !== a, this._padding = !n.isPaddingEqual(l), this._zooming ||= m.isZooming, this._easeId = e1.easeId, this._prepareEase(t, e1.noMoveStart, p), this.terrain && this._prepareElevation(m.elevationCenter), this._ease((r)=>{
            m.easeFunc(r), this.terrain && !e1.freezeElevation && this._updateElevation(r), this.applyUpdatedTransform(n), this._fireMoveEvents(t);
        }, (n)=>{
            this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(t, n);
        }, e1), this;
    }
    _prepareEase(e1, t, n = {}) {
        this._moving = !0, !t && !n.moving && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`movestart`, e1)), this._zooming && !n.zooming && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoomstart`, e1)), this._rotating && !n.rotating && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rotatestart`, e1)), this._pitching && !n.pitching && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitchstart`, e1)), this._rolling && !n.rolling && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rollstart`, e1));
    }
    _prepareElevation(e1) {
        this._elevationCenter = e1, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(e1, this.transform.tileZoom), this.elevationFreeze = !0;
    }
    _updateElevation(e1) {
        (this._elevationStart === void 0 || this._elevationCenter === void 0) && this._prepareElevation(this.transform.center), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
        let t = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
        if (e1 < 1 && t !== this._elevationTarget) {
            let n = this._elevationTarget - this._elevationStart, r = (t - (n * e1 + this._elevationStart)) / (1 - e1);
            this._elevationStart += e1 * (n - r), this._elevationTarget = t;
        }
        this.transform.setElevation((0, $caapT.un).number(this._elevationStart, this._elevationTarget, e1));
    }
    _finalizeElevation() {
        this.elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
    }
    getTransformForUpdate() {
        return !this.transformCameraUpdate && !this.terrain ? this.transform : (this._requestedCameraState ||= this.transform.clone(), this._requestedCameraState);
    }
    _elevateCameraIfInsideTerrain(e1) {
        if (!this.terrain && e1.elevation >= 0 && e1.pitch <= 90) return {};
        let t = e1.getCameraLngLat(), n = e1.getCameraAltitude(), r = this.terrain ? this.terrain.getElevationForLngLatZoom(t, e1.zoom) : 0;
        if (n < r) {
            let n = this.calculateCameraOptionsFromTo(t, r, e1.center, e1.elevation);
            return {
                pitch: n.pitch,
                zoom: n.zoom
            };
        }
        return {};
    }
    applyUpdatedTransform(e1) {
        let t = [];
        if (t.push((e1)=>this._elevateCameraIfInsideTerrain(e1)), this.transformCameraUpdate && t.push((e1)=>this.transformCameraUpdate(e1)), !t.length) return;
        let n = e1.clone();
        for (let e1 of t){
            let t = n.clone(), { center: r, zoom: i, roll: a, pitch: o, bearing: s, elevation: c } = e1(t);
            r && t.setCenter(r), c !== void 0 && t.setElevation(c), i !== void 0 && t.setZoom(i), a !== void 0 && t.setRoll(a), o !== void 0 && t.setPitch(o), s !== void 0 && t.setBearing(s), n.apply(t, !1);
        }
        this.transform.apply(n, !1);
    }
    _fireMoveEvents(e1) {
        this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`move`, e1)), this._zooming && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoom`, e1)), this._rotating && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rotate`, e1)), this._pitching && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitch`, e1)), this._rolling && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`roll`, e1));
    }
    _afterEase(e1, t) {
        if (this._easeId && t && this._easeId === t) return;
        delete this._easeId;
        let n = this._zooming, r = this._rotating, i = this._pitching, a = this._rolling;
        this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, n && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoomend`, e1)), r && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rotateend`, e1)), i && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitchend`, e1)), a && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`rollend`, e1)), this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`moveend`, e1));
    }
    flyTo(e1, t) {
        if (!e1.essential && $902e455d852cdfb8$var$Dr.prefersReducedMotion) {
            let n = (0, $caapT.gr)(e1, [
                `center`,
                `zoom`,
                `bearing`,
                `pitch`,
                `roll`,
                `elevation`,
                `padding`
            ]);
            return this.jumpTo(n, t);
        }
        this.stop(), e1 = (0, $caapT.Zn)({
            offset: [
                0,
                0
            ],
            speed: 1.2,
            curve: 1.42,
            easing: (0, $caapT.Wn)
        }, e1), `zoom` in e1 && this._zoomSnap && (e1.zoom = (0, $caapT.Xn)(e1.zoom, this._zoomSnap));
        let n = this.getTransformForUpdate(), r = n.bearing, i = n.pitch, a = n.roll, o = n.padding, s = `bearing` in e1 ? this._normalizeBearing(e1.bearing, r) : r, c = `pitch` in e1 ? +e1.pitch : i, l = `roll` in e1 ? this._normalizeBearing(e1.roll, a) : a, u = `padding` in e1 ? e1.padding : n.padding, d = (0, $caapT.ji).convert(e1.offset), f = n.centerPoint.add(d), p = n.screenPointToLocation(f), m = this.cameraHelper.handleFlyTo(n, {
            bearing: s,
            pitch: c,
            roll: l,
            padding: u,
            locationAtOffset: p,
            offsetAsPoint: d,
            center: e1.center,
            minZoom: e1.minZoom,
            zoom: e1.zoom
        }), h = e1.curve, g = Math.max(n.width, n.height), _ = g / m.scaleOfZoom, v = m.pixelPathLength, y = g / m.scaleOfMinZoom;
        h = Math.min(h, Math.sqrt(y / v * 2));
        let b = h * h;
        function x(e1) {
            let t = (_ * _ - g * g + (e1 ? -1 : 1) * b * b * v * v) / (2 * (e1 ? _ : g) * b * v);
            return Math.log(Math.sqrt(t * t + 1) - t);
        }
        function S(e1) {
            return (Math.exp(e1) - Math.exp(-e1)) / 2;
        }
        function C(e1) {
            return (Math.exp(e1) + Math.exp(-e1)) / 2;
        }
        function w(e1) {
            return S(e1) / C(e1);
        }
        let T = x(!1), ee = function(e1) {
            return C(T) / C(T + h * e1);
        }, E = function(e1) {
            return g * ((C(T) * w(T + h * e1) - S(T)) / b) / v;
        }, D = (x(!0) - T) / h;
        if (Math.abs(v) < 2e-6 || !isFinite(D)) {
            if (Math.abs(g - _) < 1e-6) return this.easeTo(e1, t);
            let n = _ < g ? -1 : 1;
            D = Math.abs(Math.log(_ / g)) / h, E = ()=>0, ee = (e1)=>Math.exp(n * h * e1);
        }
        if (`duration` in e1) e1.duration = +e1.duration;
        else {
            let t = `screenSpeed` in e1 ? +e1.screenSpeed / h : +e1.speed;
            e1.duration = 1e3 * D / t;
        }
        return e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = r !== s, this._pitching = c !== i, this._rolling = l !== a, this._padding = !n.isPaddingEqual(u), this._prepareEase(t, !1), this.terrain && this._prepareElevation(m.targetCenter), this._ease((p)=>{
            let h = p * D, g = 1 / ee(h), _ = E(h);
            this._rotating && n.setBearing((0, $caapT.un).number(r, s, p)), this._pitching && n.setPitch((0, $caapT.un).number(i, c, p)), this._rolling && n.setRoll((0, $caapT.un).number(a, l, p)), this._padding && (n.interpolatePadding(o, u, p), f = n.centerPoint.add(d)), m.easeFunc(p, g, _, f), this.terrain && !e1.freezeElevation && this._updateElevation(p), this.applyUpdatedTransform(n), this._fireMoveEvents(t);
        }, ()=>{
            this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(t);
        }, e1), this;
    }
    isEasing() {
        return !!this._easeFrameId;
    }
    stop(e1) {
        return this._stop(e1);
    }
    _stop(e1, t) {
        if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
            let e1 = this._onEaseEnd;
            delete this._onEaseEnd, e1.call(this, t);
        }
        return e1 || this._stopHandlers(), this;
    }
    _ease(e1, t, n) {
        n.animate === !1 || n.duration === 0 ? (e1(1), t()) : (this._easeStart = $902e455d852cdfb8$export$461939dd4422153(), this._easeOptions = n, this._onEaseFrame = e1, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
    }
    _normalizeBearing(e1, t) {
        e1 = (0, $caapT.jr)(e1, -180, 180);
        let n = Math.abs(e1 - t);
        return Math.abs(e1 - 360 - t) < n && (e1 -= 360), Math.abs(e1 + 360 - t) < n && (e1 += 360), e1;
    }
    isMoving() {
        return this._moving;
    }
    isZooming() {
        return this._zooming;
    }
    isRotating() {
        return this._rotating;
    }
};
const $902e455d852cdfb8$var$sp = {
    compact: !0,
    customAttribution: `<a href="https://maplibre.org/" target="_blank">MapLibre</a>`
};
var $902e455d852cdfb8$export$5af5c3cc9905683 = class {
    constructor(e1 = $902e455d852cdfb8$var$sp){
        this._toggleAttribution = ()=>{
            this._container.classList.contains(`maplibregl-compact`) && (this._container.classList.contains(`maplibregl-compact-show`) ? (this._container.setAttribute(`open`, ``), this._container.classList.remove(`maplibregl-compact-show`)) : (this._container.classList.add(`maplibregl-compact-show`), this._container.removeAttribute(`open`)));
        }, this._updateData = (e1)=>{
            e1 && (e1.type === `terrain` || e1.dataType === `style` || e1.dataType === `source` && (e1.sourceDataType === `metadata` || e1.sourceDataType === `visibility`)) && this._updateAttributions();
        }, this._updateCompact = ()=>{
            this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact === !1 ? this._container.setAttribute(`open`, ``) : !this._container.classList.contains(`maplibregl-compact`) && !this._container.classList.contains(`maplibregl-attrib-empty`) && (this._container.setAttribute(`open`, ``), this._container.classList.add(`maplibregl-compact`, `maplibregl-compact-show`)) : (this._container.setAttribute(`open`, ``), this._container.classList.contains(`maplibregl-compact`) && this._container.classList.remove(`maplibregl-compact`, `maplibregl-compact-show`));
        }, this._updateCompactMinimize = ()=>{
            this._container.classList.contains(`maplibregl-compact`) && this._container.classList.contains(`maplibregl-compact-show`) && this._container.classList.remove(`maplibregl-compact-show`);
        }, this.options = e1;
    }
    getDefaultPosition() {
        return `bottom-right`;
    }
    onAdd(e1) {
        return this._map = e1, this._compact = this.options.compact, this._container = $902e455d852cdfb8$var$W.create(`details`, `maplibregl-ctrl maplibregl-ctrl-attrib`), this._compactButton = $902e455d852cdfb8$var$W.create(`summary`, `maplibregl-ctrl-attrib-button`, this._container), this._compactButton.addEventListener(`click`, this._toggleAttribution), this._setElementTitle(this._compactButton, `ToggleAttribution`), this._innerContainer = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-ctrl-attrib-inner`, this._container), this._updateAttributions(), this._updateCompact(), this._map.on(`styledata`, this._updateData), this._map.on(`sourcedata`, this._updateData), this._map.on(`terrain`, this._updateData), this._map.on(`resize`, this._updateCompact), this._map.on(`drag`, this._updateCompactMinimize), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`styledata`, this._updateData), this._map.off(`sourcedata`, this._updateData), this._map.off(`terrain`, this._updateData), this._map.off(`resize`, this._updateCompact), this._map.off(`drag`, this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
    }
    _setElementTitle(e1, t) {
        let n = this._map._getUIString(`AttributionControl.${t}`);
        e1.title = n, e1.setAttribute(`aria-label`, n);
    }
    _updateAttributions() {
        if (!this._map.style) return;
        let e1 = [];
        if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = e1.concat(this.options.customAttribution.map((e1)=>typeof e1 == `string` ? e1 : ``)) : typeof this.options.customAttribution == `string` && e1.push(this.options.customAttribution)), this._map.style.stylesheet) {
            let e1 = this._map.style.stylesheet;
            this.styleOwner = e1.owner, this.styleId = e1.id;
        }
        let t = this._map.style.tileManagers;
        for(let n in t){
            let r = t[n];
            if (r.used || r.usedForTerrain) {
                let t = r.getSource();
                t.attribution && !e1.includes(t.attribution) && e1.push(t.attribution);
            }
        }
        e1 = e1.filter((e1)=>String(e1).trim()), e1.sort((e1, t)=>e1.length - t.length), e1 = e1.filter((t, n)=>{
            for(let r = n + 1; r < e1.length; r++)if (e1[r].includes(t)) return !1;
            return !0;
        });
        let n = e1.join(` | `);
        n !== this._attribHTML && (this._attribHTML = n, e1.length ? (this._innerContainer.innerHTML = $902e455d852cdfb8$var$W.sanitize(n), this._container.classList.remove(`maplibregl-attrib-empty`)) : this._container.classList.add(`maplibregl-attrib-empty`), this._updateCompact(), this._editLink = null);
    }
}, $902e455d852cdfb8$export$6941d1bdee1234d4 = class {
    constructor(e1 = {}){
        this._updateCompact = ()=>{
            let e1 = this._container.children;
            if (e1.length) {
                let t = e1[0];
                this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact !== !1 && t.classList.add(`maplibregl-compact`) : t.classList.remove(`maplibregl-compact`);
            }
        }, this.options = e1;
    }
    getDefaultPosition() {
        return `bottom-left`;
    }
    onAdd(e1) {
        this._map = e1, this._compact = this.options?.compact, this._container = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-ctrl`);
        let t = $902e455d852cdfb8$var$W.create(`a`, `maplibregl-ctrl-logo`);
        return t.target = `_blank`, t.rel = `noopener nofollow`, t.href = `https://maplibre.org/`, t.setAttribute(`aria-label`, this._map._getUIString(`LogoControl.Title`)), t.setAttribute(`rel`, `noopener nofollow`), this._container.appendChild(t), this._container.style.display = `block`, this._map.on(`resize`, this._updateCompact), this._updateCompact(), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`resize`, this._updateCompact), this._map = void 0, this._compact = void 0;
    }
}, $902e455d852cdfb8$var$up = class {
    constructor(){
        this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
    }
    add(e1) {
        let t = ++this._id;
        return this._queue.push({
            callback: e1,
            id: t,
            cancelled: !1
        }), t;
    }
    remove(e1) {
        let t = this._currentlyRunning, n = t ? this._queue.concat(t) : this._queue;
        for (let t of n)if (t.id === e1) {
            t.cancelled = !0;
            return;
        }
    }
    run(e1 = 0) {
        if (this._currentlyRunning) throw Error(`Attempting to run(), but is already running.`);
        let t = this._currentlyRunning = this._queue;
        this._queue = [];
        for (let n of t)if (!n.cancelled && (n.callback(e1), this._cleared)) break;
        this._cleared = !1, this._currentlyRunning = !1;
    }
    clear() {
        this._currentlyRunning && (this._cleared = !0), this._queue = [];
    }
};
const $902e455d852cdfb8$var$dp = (0, $caapT.zt)([
    {
        name: `a_pos3d`,
        type: `Int16`,
        components: 3
    }
]);
var $902e455d852cdfb8$var$fp = class extends (0, $caapT.mn) {
    constructor(e1){
        super(), this._lastTilesetChange = $902e455d852cdfb8$export$461939dd4422153(), this.tileManager = e1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = e1._source.tileSize * 2 ** this.deltaZoom, e1.usedForTerrain = !0, e1.tileSize = this.tileSize;
    }
    destruct() {
        this.tileManager.usedForTerrain = !1, this.tileManager.tileSize = null, this.releaseAllRTT();
    }
    getSource() {
        return this.tileManager._source;
    }
    update(e1, t) {
        this.tileManager.update(e1, t), this._renderableTilesKeys = [];
        let n = {};
        for (let r of $902e455d852cdfb8$var$Fa(e1, {
            tileSize: this.tileSize,
            minzoom: this.minzoom,
            maxzoom: this.maxzoom,
            reparseOverscaled: !1,
            terrain: t,
            calculateTileZoom: this.tileManager._source.calculateTileZoom
        }))n[r.key] = !0, this._renderableTilesKeys.push(r.key), this._tiles[r.key] || (r.terrainRttPosMatrix32f = new Float32Array(16), (0, $caapT.yi)(r.terrainRttPosMatrix32f, 0, (0, $caapT.Pr), (0, $caapT.Pr), 0, 0, 1), this._tiles[r.key] = new $902e455d852cdfb8$var$ya(r, this.tileSize), this._lastTilesetChange = $902e455d852cdfb8$export$461939dd4422153());
        for(let e1 in this._tiles)n[e1] || (this._tiles[e1].releaseRTT(this.tileManager.map.painter), delete this._tiles[e1]);
    }
    releaseRTT(e1) {
        for(let t in this._tiles){
            let n = this._tiles[t];
            (n.tileID.equals(e1) || n.tileID.isChildOf(e1) || e1.isChildOf(n.tileID)) && n.releaseRTT(this.tileManager.map.painter);
        }
    }
    releaseAllRTT() {
        for(let e1 in this._tiles)this._tiles[e1].releaseRTT(this.tileManager.map.painter);
    }
    getRenderableTiles() {
        return this._renderableTilesKeys.map((e1)=>this.getTileByID(e1));
    }
    getTileByID(e1) {
        return this._tiles[e1];
    }
    getTerrainCoords(e1, t) {
        return t ? this._getTerrainCoordsForTileRanges(e1, t) : this._getTerrainCoordsForRegularTile(e1);
    }
    _getTerrainCoordsForRegularTile(e1) {
        let t = {};
        for (let n of this._renderableTilesKeys){
            let r = this._tiles[n].tileID, i = e1.clone(), a = (0, $caapT.Bn)();
            if (r.canonical.equals(e1.canonical)) (0, $caapT.yi)(a, 0, (0, $caapT.Pr), (0, $caapT.Pr), 0, 0, 1);
            else if (r.canonical.isChildOf(e1.canonical)) {
                let t = r.canonical.z - e1.canonical.z, n = r.canonical.x - (r.canonical.x >> t << t), i = r.canonical.y - (r.canonical.y >> t << t), o = (0, $caapT.Pr) >> t;
                (0, $caapT.yi)(a, 0, o, o, 0, 0, 1), (0, $caapT.Ti)(a, a, [
                    -n * o,
                    -i * o,
                    0
                ]);
            } else if (e1.canonical.isChildOf(r.canonical)) {
                let t = e1.canonical.z - r.canonical.z, n = e1.canonical.x - (e1.canonical.x >> t << t), i = e1.canonical.y - (e1.canonical.y >> t << t), o = (0, $caapT.Pr) >> t;
                (0, $caapT.yi)(a, 0, (0, $caapT.Pr), (0, $caapT.Pr), 0, 0, 1), (0, $caapT.Ti)(a, a, [
                    n * o,
                    i * o,
                    0
                ]), (0, $caapT.wi)(a, a, [
                    1 / 2 ** t,
                    1 / 2 ** t,
                    0
                ]);
            } else continue;
            i.terrainRttPosMatrix32f = new Float32Array(a), t[n] = i;
        }
        return t;
    }
    _getTerrainCoordsForTileRanges(e1, t) {
        let n = {};
        for (let r of this._renderableTilesKeys){
            let i = this._tiles[r].tileID;
            if (!this._isWithinTileRanges(i, t)) continue;
            let a = e1.clone(), o = (0, $caapT.Bn)();
            if (i.canonical.z === e1.canonical.z) {
                let t = e1.canonical.x - i.canonical.x + e1.wrap * (1 << e1.canonical.z), n = e1.canonical.y - i.canonical.y;
                (0, $caapT.yi)(o, 0, (0, $caapT.Pr), (0, $caapT.Pr), 0, 0, 1), (0, $caapT.Ti)(o, o, [
                    t * (0, $caapT.Pr),
                    n * (0, $caapT.Pr),
                    0
                ]);
            } else if (i.canonical.z > e1.canonical.z) {
                let t = i.canonical.z - e1.canonical.z, n = i.canonical.x - (i.canonical.x >> t << t) + e1.wrap * (1 << i.canonical.z), r = i.canonical.y - (i.canonical.y >> t << t), a = e1.canonical.x - (i.canonical.x >> t), s = e1.canonical.y - (i.canonical.y >> t), c = (0, $caapT.Pr) >> t;
                (0, $caapT.yi)(o, 0, c, c, 0, 0, 1), (0, $caapT.Ti)(o, o, [
                    -n * c + a * (0, $caapT.Pr),
                    -r * c + s * (0, $caapT.Pr),
                    0
                ]);
            } else {
                let t = e1.canonical.z - i.canonical.z, n = e1.canonical.x - (e1.canonical.x >> t << t) + e1.wrap * (1 << e1.canonical.z), r = e1.canonical.y - (e1.canonical.y >> t << t), a = (e1.canonical.x >> t) - i.canonical.x, s = (e1.canonical.y >> t) - i.canonical.y, c = (0, $caapT.Pr) << t;
                (0, $caapT.yi)(o, 0, c, c, 0, 0, 1), (0, $caapT.Ti)(o, o, [
                    n * (0, $caapT.Pr) + a * c,
                    r * (0, $caapT.Pr) + s * c,
                    0
                ]);
            }
            a.terrainRttPosMatrix32f = new Float32Array(o), n[r] = a;
        }
        return n;
    }
    getSourceTile(e1, t) {
        let n = this.tileManager._source, r = e1.overscaledZ - this.deltaZoom;
        if (r > n.maxzoom && (r = n.maxzoom), r < n.minzoom) return;
        this._sourceTileCache[e1.key] ||= e1.scaledTo(r).key;
        let i = this.findTileInCaches(this._sourceTileCache[e1.key]);
        if (!i?.dem && t) for(; r >= n.minzoom && !i?.dem;)i = this.findTileInCaches(e1.scaledTo(r--).key);
        return i;
    }
    findTileInCaches(e1) {
        let t = this.tileManager.getTileByID(e1);
        return t || (t = this.tileManager._outOfViewCache.getByKey(e1), t);
    }
    anyTilesAfterTime(e1 = $902e455d852cdfb8$export$461939dd4422153()) {
        return this._lastTilesetChange >= e1;
    }
    _isWithinTileRanges(e1, t) {
        let n = t[e1.canonical.z];
        return !!n && (e1.wrap > n.minWrap || e1.wrap < n.maxWrap || e1.canonical.x >= n.minTileXWrapped && e1.canonical.x <= n.maxTileXWrapped && e1.canonical.y >= n.minTileY && e1.canonical.y <= n.maxTileY);
    }
}, $902e455d852cdfb8$var$pp = class {
    constructor(e1, t, n, r = `auto`){
        this._meshCache = {}, this.painter = e1, this.tileManager = new $902e455d852cdfb8$var$fp(t), this.options = n, this.exaggeration = typeof n.exaggeration == `number` ? n.exaggeration : 1, this._terrainSkirtLength = r, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
    }
    destroy() {
        this._fbo &&= (this._fbo.destroy(), null), this._fboCoordsTexture &&= (this._fboCoordsTexture.destroy(), null), this._fboDepthTexture &&= (this._fboDepthTexture.destroy(), null), this._emptyDemTexture &&= (this._emptyDemTexture.destroy(), null), this._emptyDepthTexture &&= (this._emptyDepthTexture.destroy(), null), this._coordsTexture &&= (this._coordsTexture.destroy(), null);
        for(let e1 in this._meshCache)this._meshCache[e1].destroy();
        this._meshCache = {}, this.tileManager.destruct();
    }
    getDEMElevation(e1, t, n, r = (0, $caapT.Pr)) {
        let i = e1.normalizeCoordinates(t, n, r);
        if (!i) return 0;
        let a = this.getTerrainData(i.tileID), o = a.tile?.dem;
        if (!o) return 0;
        let s = (0, $caapT.zr)([], [
            i.x / r * (0, $caapT.Pr),
            i.y / r * (0, $caapT.Pr)
        ], a.u_terrain_matrix), c = [
            s[0] * o.dim,
            s[1] * o.dim
        ];
        return o.sampleBilinear(c[0], c[1]);
    }
    getElevationForLngLatZoom(e1, t) {
        if (!(0, $caapT.x)(t, e1.wrap())) return 0;
        let { tileID: n, mercatorX: r, mercatorY: i } = this._getOverscaledTileIDFromLngLatZoom(e1, t);
        return this.getElevation(n, r % (0, $caapT.Pr), i % (0, $caapT.Pr), (0, $caapT.Pr));
    }
    getElevationForLngLat(e1, t) {
        let n = $902e455d852cdfb8$var$Fa(t, {
            maxzoom: this.tileManager.maxzoom,
            minzoom: this.tileManager.minzoom,
            tileSize: 512,
            terrain: this
        }), r = 0;
        for (let e1 of n)e1.canonical.z > r && (r = Math.min(e1.canonical.z, this.tileManager.maxzoom));
        return this.getElevationForLngLatZoom(e1, r);
    }
    getElevation(e1, t, n, r = (0, $caapT.Pr)) {
        return this.getDEMElevation(e1, t, n, r) * this.exaggeration;
    }
    getTerrainData(e1) {
        if (!this._emptyDemTexture) {
            let e1 = this.painter.context, t = new (0, $caapT._t)({
                width: 1,
                height: 1
            }, new Uint8Array(4));
            this._emptyDepthTexture = new (0, $caapT.dt)(e1, t, e1.gl.RGBA, {
                premultiply: !1
            }), this._emptyDemUnpack = [
                0,
                0,
                0,
                0
            ], this._emptyDemTexture = new (0, $caapT.dt)(e1, new (0, $caapT._t)({
                width: 1,
                height: 1
            }), e1.gl.RGBA, {
                premultiply: !1
            }), this._emptyDemTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = (0, $caapT.gi)([]);
        }
        let t = this.tileManager.getSourceTile(e1, !0);
        if (t?.dem && (!t.demTexture || t.needsTerrainPrepare)) {
            let e1 = this.painter.context;
            t.demTexture ||= this.painter.getTileTexture(t.dem.stride), t.demTexture ? t.demTexture.update(t.dem.getPixels(), {
                premultiply: !1
            }) : t.demTexture = new (0, $caapT.dt)(e1, t.dem.getPixels(), e1.gl.RGBA, {
                premultiply: !1
            }), t.demTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), t.needsTerrainPrepare = !1;
        }
        let n = t && t.toString() + t.tileID.key + e1.key;
        if (n && !this._demMatrixCache[n]) {
            let r = this.tileManager.getSource().maxzoom, i = e1.canonical.z - t.tileID.canonical.z;
            e1.overscaledZ > e1.canonical.z && (e1.canonical.z >= r ? i = e1.canonical.z - r : (0, $caapT.Ar)(`cannot calculate elevation if elevation maxzoom > source.maxzoom`));
            let o = e1.canonical.x - (e1.canonical.x >> i << i), s = e1.canonical.y - (e1.canonical.y >> i << i), c = (0, $caapT.hi)(new Float64Array(16), [
                1 / ((0, $caapT.Pr) << i),
                1 / ((0, $caapT.Pr) << i),
                0
            ]);
            (0, $caapT.Ti)(c, c, [
                o * (0, $caapT.Pr),
                s * (0, $caapT.Pr),
                0
            ]), this._demMatrixCache[n] = {
                matrix: c,
                coord: e1
            };
        }
        return {
            u_depth: 2,
            u_terrain: 3,
            u_terrain_dim: t?.dem?.dim || 1,
            u_terrain_matrix: n ? this._demMatrixCache[n].matrix : this._emptyDemMatrix,
            u_terrain_unpack: t?.dem?.getUnpackVector() || this._emptyDemUnpack,
            u_terrain_exaggeration: this.exaggeration,
            texture: (t?.demTexture || this._emptyDemTexture).texture,
            depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
            tile: t
        };
    }
    getFramebuffer(e1) {
        let t = this.painter, n = t.width / devicePixelRatio, r = t.height / devicePixelRatio;
        return this._fbo && (this._fbo.width !== n || this._fbo.height !== r) && (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new (0, $caapT.dt)(t.context, {
            width: n,
            height: r,
            data: null
        }, t.context.gl.RGBA, {
            premultiply: !1
        }), this._fboCoordsTexture.bind(t.context.gl.NEAREST, t.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new (0, $caapT.dt)(t.context, {
            width: n,
            height: r,
            data: null
        }, t.context.gl.RGBA, {
            premultiply: !1
        }), this._fboDepthTexture.bind(t.context.gl.NEAREST, t.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = t.context.createFramebuffer(n, r, !0, !1), this._fbo.depthAttachment.set(t.context.createRenderbuffer(t.context.gl.DEPTH_COMPONENT16, n, r))), this._fbo.colorAttachment.set(e1 === `coords` ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
    }
    getCoordsTexture() {
        let e1 = this.painter.context;
        if (this._coordsTexture) return this._coordsTexture;
        let t = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
        for(let e1 = 0, n = 0; e1 < this._coordsTextureSize; e1++)for(let r = 0; r < this._coordsTextureSize; r++, n += 4)t[n + 0] = r & 255, t[n + 1] = e1 & 255, t[n + 2] = r >> 8 << 4 | e1 >> 8, t[n + 3] = 0;
        let n = new (0, $caapT.dt)(e1, new (0, $caapT._t)({
            width: this._coordsTextureSize,
            height: this._coordsTextureSize
        }, new Uint8Array(t.buffer)), e1.gl.RGBA, {
            premultiply: !1
        });
        return n.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._coordsTexture = n, n;
    }
    pointCoordinate(e1) {
        this.painter.maybeDrawDepth(!0), this.painter.maybeDrawCoords();
        let t = new Uint8Array(4), n = this.painter.context, r = n.gl, i = Math.round(e1.x * this.painter.pixelRatio / devicePixelRatio), a = Math.round(e1.y * this.painter.pixelRatio / devicePixelRatio), o = Math.round(this.painter.height / devicePixelRatio);
        n.bindFramebuffer.set(this.getFramebuffer(`coords`).framebuffer), r.readPixels(i, o - a - 1, 1, 1, r.RGBA, r.UNSIGNED_BYTE, t), n.bindFramebuffer.set(null);
        let s = t[0] + (t[2] >> 4 << 8), c = t[1] + ((t[2] & 15) << 8), l = this.coordsIndex[255 - t[3]], u = l && this.tileManager.getTileByID(l);
        if (!u) return null;
        let d = this._coordsTextureSize, f = (1 << u.tileID.canonical.z) * d;
        return new (0, $caapT.S)((u.tileID.canonical.x * d + s) / f + u.tileID.wrap, (u.tileID.canonical.y * d + c) / f, this.getElevation(u.tileID, s, c, d));
    }
    depthAtPoint(e1) {
        let t = new Uint8Array(4), n = this.painter.context, r = n.gl;
        return n.bindFramebuffer.set(this.getFramebuffer(`depth`).framebuffer), r.readPixels(e1.x, this.painter.height / devicePixelRatio - e1.y - 1, 1, 1, r.RGBA, r.UNSIGNED_BYTE, t), n.bindFramebuffer.set(null), (t[0] / 16777216 + t[1] / 65536 + t[2] / 256 + t[3]) / 256;
    }
    getTerrainMesh(e1) {
        let t = this.painter.style.projection?.transitionState > 0, n = t && e1.canonical.y === 0, r = t && e1.canonical.y === (1 << e1.canonical.z) - 1, i = `m_${n ? `n` : ``}_${r ? `s` : ``}`;
        if (this._meshCache[i]) return this._meshCache[i];
        let a = this.painter.context, s = new (0, $caapT.Pt), c = new (0, $caapT.Rt), l = this.meshSize, u = (0, $caapT.Pr) / l, d = l * l;
        for(let e1 = 0; e1 <= l; e1++)for(let t = 0; t <= l; t++)s.emplaceBack(t * u, e1 * u, 0);
        for(let e1 = 0; e1 < d; e1 += l + 1)for(let t = 0; t < l; t++)c.emplaceBack(t + e1, l + t + e1 + 1, l + t + e1 + 2), c.emplaceBack(t + e1, l + t + e1 + 2, t + e1 + 1);
        this._terrainSkirtLength !== `none` && this._buildSkirts(s, c, l, u, n, r);
        let f = new $902e455d852cdfb8$var$us(a.createVertexBuffer(s, $902e455d852cdfb8$var$dp.members), a.createIndexBuffer(c), (0, $caapT.At).simpleSegment(0, 0, s.length, c.length));
        return this._meshCache[i] = f, f;
    }
    getSkirtLength(e1) {
        return 2 * Math.PI * (0, $caapT.A) / 2 ** Math.max(e1, 0) / 5;
    }
    getMinTileElevationForLngLatZoom(e1, t) {
        if (!(0, $caapT.x)(t, e1.wrap())) return 0;
        let { tileID: n } = this._getOverscaledTileIDFromLngLatZoom(e1, t);
        return this.getMinMaxElevation(n).minElevation ?? 0;
    }
    getMinMaxElevation(e1) {
        let t = this.tileManager.getSourceTile(e1, !0), n = {
            minElevation: null,
            maxElevation: null
        };
        return t?.dem && (n.minElevation = t.dem.min * this.exaggeration, n.maxElevation = t.dem.max * this.exaggeration), n;
    }
    _getOverscaledTileIDFromLngLatZoom(e1, t) {
        let n = (0, $caapT.S).fromLngLat(e1.wrap()), r = (1 << t) * (0, $caapT.Pr), i = n.x * r, a = n.y * r;
        return {
            tileID: new (0, $caapT._)(t, 0, t, Math.floor(i / (0, $caapT.Pr)), Math.floor(a / (0, $caapT.Pr))),
            mercatorX: i,
            mercatorY: a
        };
    }
    _buildSkirts(e1, t, n, r, i, a) {
        let o = e1.length, s = o + (n + 1), c = (n + 1) * n, l = i ? (0, $caapT.at) : 0, u = +!i, d = a ? (0, $caapT.ot) : (0, $caapT.Pr), f = +!a;
        for(let t = 0; t <= n; t++)e1.emplaceBack(t * r, l, u);
        for(let t = 0; t <= n; t++)e1.emplaceBack(t * r, d, f);
        for(let e1 = 0; e1 < n; e1++)t.emplaceBack(c + e1, s + e1, s + e1 + 1), t.emplaceBack(c + e1, s + e1 + 1, c + e1 + 1), t.emplaceBack(0 + e1, o + e1 + 1, o + e1), t.emplaceBack(0 + e1, 0 + e1 + 1, o + e1 + 1);
        let p = e1.length, m = p + (n + 1) * 2;
        for (let t of [
            0,
            1
        ])for(let i = 0; i <= n; i++)for (let n of [
            0,
            1
        ])e1.emplaceBack(t * (0, $caapT.Pr), i * r, n);
        for(let e1 = 0; e1 < n * 2; e1 += 2)t.emplaceBack(p + e1, p + e1 + 1, p + e1 + 3), t.emplaceBack(p + e1, p + e1 + 3, p + e1 + 2), t.emplaceBack(m + e1, m + e1 + 3, m + e1 + 1), t.emplaceBack(m + e1, m + e1 + 2, m + e1 + 3);
    }
};
const $902e455d852cdfb8$var$mp = {
    background: !0,
    fill: !0,
    line: !0,
    raster: !0,
    hillshade: !0,
    "color-relief": !0
};
var $902e455d852cdfb8$var$hp = class {
    constructor(e1, t){
        this.painter = e1, this.terrain = t, this.rttSize = t.tileManager.tileSize * t.qualityFactor;
    }
    getTexture(e1) {
        return e1.getRTT(this._stacks.length - 1).texture;
    }
    prepareForRender(e1, t) {
        this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.tileManager.getRenderableTiles(), this._renderableLayerIds = e1._order.filter((n)=>!e1._layers[n].isHidden(t));
        let n = new Set;
        for (let t of this._renderableLayerIds){
            let r = e1._layers[t], i = r.source;
            i && $902e455d852cdfb8$var$mp[r.type] && n.add(i);
        }
        this._coordsAscending = {}, this._rttFingerprints = {};
        for (let t of n){
            let n = e1.tileManagers[t];
            if (!n) continue;
            this._coordsAscending[t] = {};
            let r = this._coordsAscending[t], i = n.getSource(), a = i instanceof $902e455d852cdfb8$export$280e9a68c3ffd919 ? i.terrainTileRanges : null;
            for (let e1 of n.getVisibleCoordinates()){
                let t = this.terrain.tileManager.getTerrainCoords(e1, a);
                for(let e1 in t)r[e1] ||= [], r[e1].push(t[e1]);
            }
            this._rttFingerprints[t] = {};
            let o = this._rttFingerprints[t], s = n.getState().revision;
            for(let e1 in r)o[e1] = `${r[e1].map((e1)=>e1.key).sort().join()}#${s}`;
        }
        for (let e1 of this._renderableTiles)for(let t in this._rttFingerprints){
            let n = this._rttFingerprints[t][e1.tileID.key];
            n && n !== e1.rttFingerprint[t] && e1.releaseRTT(this.painter);
        }
    }
    renderLayer(e1, t) {
        if (e1.isHidden(this.painter.transform.zoom)) return !1;
        let n = {
            ...t,
            isRenderingToTexture: !0
        }, r = e1.type, i = this.painter, a = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e1.id;
        if ($902e455d852cdfb8$var$mp[r] && ((!this._prevType || !$902e455d852cdfb8$var$mp[this._prevType]) && this._stacks.push([]), this._prevType = r, this._stacks[this._stacks.length - 1].push(e1.id), !a)) return !0;
        if ($902e455d852cdfb8$var$mp[this._prevType] || $902e455d852cdfb8$var$mp[r] && a) {
            this._prevType = r;
            let e1 = this._stacks.length - 1, t = this._stacks[e1] || [];
            for (let r of this._renderableTiles){
                if (this._rttTiles.push(r), r.getRTT(e1)) continue;
                let a = r.acquireRTT(i, e1, this.rttSize);
                i.bindRTT(a), i.context.clear({
                    color: (0, $caapT.tn).transparent,
                    stencil: 0
                }), i.currentStencilSource = void 0;
                for (let e1 of t){
                    let t = i.style._layers[e1], a = t.source ? this._coordsAscending[t.source][r.tileID.key] : [
                        r.tileID
                    ];
                    i.context.viewport.set([
                        0,
                        0,
                        this.rttSize,
                        this.rttSize
                    ]), i.renderTileClippingMasks(t, a, !0), i.renderLayer(i, i.style.tileManagers[t.source], t, a, n), t.source && (r.rttFingerprint[t.source] = this._rttFingerprints[t.source][r.tileID.key]);
                }
            }
            return $902e455d852cdfb8$var$Jd(this.painter, this.terrain, this._rttTiles, n), this._rttTiles = [], $902e455d852cdfb8$var$mp[r];
        }
        return !1;
    }
};
const $902e455d852cdfb8$var$gp = {
    "AttributionControl.ToggleAttribution": `Toggle attribution`,
    "AttributionControl.MapFeedback": `Map feedback`,
    "FullscreenControl.Enter": `Enter fullscreen`,
    "FullscreenControl.Exit": `Exit fullscreen`,
    "GeolocateControl.FindMyLocation": `Find my location`,
    "GeolocateControl.LocationNotAvailable": `Location not available`,
    "LogoControl.Title": `MapLibre logo`,
    "Map.Title": `Map`,
    "Marker.Title": `Map marker`,
    "NavigationControl.ResetBearing": `Drag to rotate map, click to reset north`,
    "NavigationControl.ZoomIn": `Zoom in`,
    "NavigationControl.ZoomOut": `Zoom out`,
    "Popup.Close": `Close popup`,
    "ScaleControl.Feet": `ft`,
    "ScaleControl.Meters": `m`,
    "ScaleControl.Kilometers": `km`,
    "ScaleControl.Miles": `mi`,
    "ScaleControl.NauticalMiles": `nm`,
    "GlobeControl.Enable": `Enable globe`,
    "GlobeControl.Disable": `Disable globe`,
    "TerrainControl.Enable": `Enable terrain`,
    "TerrainControl.Disable": `Disable terrain`,
    "CooperativeGesturesHandler.WindowsHelpText": `Use Ctrl + scroll to zoom the map`,
    "CooperativeGesturesHandler.MacHelpText": `Use \u{2318} + scroll to zoom the map`,
    "CooperativeGesturesHandler.MobileHelpText": `Use two fingers to move the map`
}, $902e455d852cdfb8$var$_p = $902e455d852cdfb8$var$br, $902e455d852cdfb8$var$vp = {
    hash: !1,
    interactive: !0,
    bearingSnap: 7,
    zoomSnap: 0,
    attributionControl: $902e455d852cdfb8$var$sp,
    maplibreLogo: !1,
    refreshExpiredTiles: !0,
    canvasContextAttributes: {
        antialias: !1,
        preserveDrawingBuffer: !1,
        powerPreference: `high-performance`,
        failIfMajorPerformanceCaveat: !1,
        desynchronized: !1,
        contextType: void 0
    },
    scrollZoom: !0,
    minZoom: -2,
    maxZoom: 22,
    minPitch: 0,
    maxPitch: 60,
    boxZoom: !0,
    dragRotate: !0,
    dragPan: !0,
    keyboard: !0,
    doubleClickZoom: !0,
    touchZoomRotate: !0,
    touchPitch: !0,
    cooperativeGestures: !1,
    trackResize: !0,
    center: [
        0,
        0
    ],
    elevation: 0,
    zoom: 0,
    bearing: 0,
    pitch: 0,
    roll: 0,
    renderWorldCopies: !0,
    maxTileCacheSize: null,
    maxTileCacheZoomLevels: (0, $caapT.En).MAX_TILE_CACHE_ZOOM_LEVELS,
    transformRequest: null,
    transformCameraUpdate: null,
    transformConstrain: null,
    fadeDuration: 300,
    crossSourceCollisions: !0,
    clickTolerance: 3,
    localIdeographFontFamily: `sans-serif`,
    pitchWithRotate: !0,
    rollEnabled: !1,
    reduceMotion: void 0,
    validateStyle: !0,
    maxCanvasSize: [
        4096,
        4096
    ],
    cancelPendingTileRequestsWhileZooming: !0,
    centerClampedToGround: !0,
    terrainSkirtLength: `auto`,
    zoomLevelsToOverscale: 4,
    anisotropicFilterPitch: 20
};
var $902e455d852cdfb8$export$a5c7b93649eaf8f8 = class extends (0, $caapT.mn) {
    get _ownerWindow() {
        return this._container?.ownerDocument?.defaultView || window;
    }
    constructor(e1){
        super(), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new $902e455d852cdfb8$var$up, this._controls = [], this._mapId = (0, $caapT.kr)(), this._missingStyleImageResolver = null, this._lostContextStyle = {
            style: null,
            images: null
        }, this._contextLost = (e1)=>{
            if (e1.preventDefault(), this._frameRequest &&= (this._frameRequest.abort(), null), this.painter.destroy(), this._lostContextStyle = this._getStyleAndImages(), !this.style) {
                this.fire(new $902e455d852cdfb8$export$3238995171e25bd5(`webglcontextlost`, {
                    originalEvent: e1
                }));
                return;
            }
            for (let e1 of Object.values(this.style._layers))if (e1.type === `custom` && console.warn(`Custom layer with id '${e1.id}' cannot be restored after WebGL context loss. You will need to re-add it manually after context restoration.`), e1._listeners) for (let [t] of Object.entries(e1._listeners))console.warn(`Custom layer with id '${e1.id}' had event listeners for event '${t}' which cannot be restored after WebGL context loss. You will need to re-add them manually after context restoration.`);
            this.style.destroy(), this.style = null, this.fire(new $902e455d852cdfb8$export$3238995171e25bd5(`webglcontextlost`, {
                originalEvent: e1
            }));
        }, this._contextRestored = (e1)=>{
            this._lostContextStyle.style && this.setStyle(this._lostContextStyle.style, {
                diff: !1
            }), this._lostContextStyle.images && this.style && (this.style.imageManager.images = this._lostContextStyle.images), this._lostContextStyle = {
                style: null,
                images: null
            }, this._setupPainter(), this.painter && (this.resize(), this._update(), this._resizeInternal(), this.fire(new $902e455d852cdfb8$export$3238995171e25bd5(`webglcontextrestored`, {
                originalEvent: e1
            })));
        }, this._onMapScroll = (e1)=>{
            if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
        }, this._onWindowOnline = ()=>{
            this._update();
        };
        let t = {
            ...$902e455d852cdfb8$var$vp,
            ...e1,
            canvasContextAttributes: {
                ...$902e455d852cdfb8$var$vp.canvasContextAttributes,
                ...e1.canvasContextAttributes
            }
        };
        if (t.minZoom != null && t.maxZoom != null && t.minZoom > t.maxZoom) throw Error(`maxZoom must be greater than or equal to minZoom`);
        if (t.minPitch != null && t.maxPitch != null && t.minPitch > t.maxPitch) throw Error(`maxPitch must be greater than or equal to minPitch`);
        if (t.minPitch != null && t.minPitch < 0) throw Error(`minPitch must be greater than or equal to 0`);
        if (t.maxPitch != null && t.maxPitch > 180) throw Error(`maxPitch must be less than or equal to 180`);
        if (this._camera = new $902e455d852cdfb8$var$op({
            minZoom: t.minZoom,
            maxZoom: t.maxZoom,
            minPitch: t.minPitch,
            maxPitch: t.maxPitch,
            bearingSnap: t.bearingSnap,
            zoomSnap: t.zoomSnap,
            renderWorldCopies: t.renderWorldCopies,
            centerClampedToGround: t.centerClampedToGround,
            terrain: this.terrain,
            transformConstrain: t.transformConstrain,
            requestRenderFrame: (e1)=>this._requestRenderFrame(e1),
            cancelRenderFrame: (e1)=>this._cancelRenderFrame(e1),
            transformCameraUpdate: t.transformCameraUpdate,
            stopHandlers: ()=>this._handlers?.stop(!1)
        }), this._camera.setEventedParent(this), this._interactive = t.interactive, this._maxTileCacheSize = t.maxTileCacheSize, this._maxTileCacheZoomLevels = t.maxTileCacheZoomLevels, this._canvasContextAttributes = {
            ...t.canvasContextAttributes
        }, this._trackResize = t.trackResize === !0, this._terrainSkirtLength = t.terrainSkirtLength, this._refreshExpiredTiles = t.refreshExpiredTiles === !0, this._fadeDuration = t.fadeDuration, this._crossSourceCollisions = t.crossSourceCollisions === !0, this._collectResourceTiming = t.collectResourceTiming === !0, this._locale = {
            ...$902e455d852cdfb8$var$gp,
            ...t.locale
        }, this._clickTolerance = t.clickTolerance, this._overridePixelRatio = t.pixelRatio, this._maxCanvasSize = t.maxCanvasSize, this._zoomLevelsToOverscale = t.zoomLevelsToOverscale, this.cancelPendingTileRequestsWhileZooming = t.cancelPendingTileRequestsWhileZooming === !0, this.setAnisotropicFilterPitch(t.anisotropicFilterPitch), t.reduceMotion !== void 0 && ($902e455d852cdfb8$var$Dr.prefersReducedMotion = t.reduceMotion), this._imageQueueHandle = $902e455d852cdfb8$var$Mr.addThrottleControl(()=>this.isMoving()), this._requestManager = new $902e455d852cdfb8$var$Nr(t.transformRequest), this._container = this._resolveContainer(t.container), t.maxBounds && this.setMaxBounds(t.maxBounds), this._setupContainer(), this._setupPainter(), !this.painter) return;
        this.on(`move`, ()=>this._update(!1)), this.on(`moveend`, ()=>this._update(!1)), this.on(`zoom`, ()=>this._update(!0)), this.on(`terrain`, ()=>{
            this.painter.terrainFacilitator.depthDirty = !0, this._update(!0);
        }), this.once(`idle`, ()=>this._idleTriggered = !0), this._handlers = new $902e455d852cdfb8$var$ap(this, this._camera, t), typeof window < `u` && (this._ownerWindow.addEventListener(`online`, this._onWindowOnline, !1), this._setupResizeObserver());
        let n = typeof t.hash == `string` && t.hash || void 0;
        this._hash = t.hash ? new $902e455d852cdfb8$export$ab85ecd77ce6a5cd(n).addTo(this) : void 0, this._hash?._onHashChange() || (this.jumpTo({
            center: t.center,
            elevation: t.elevation,
            zoom: t.zoom,
            bearing: t.bearing,
            pitch: t.pitch,
            roll: t.roll
        }), t.bounds && (this.resize(), this.fitBounds(t.bounds, (0, $caapT.Zn)({}, t.fitBoundsOptions, {
            duration: 0
        }))));
        let r = typeof t.style == `string` || t.style?.projection?.type !== `globe`;
        this.resize(null, r), this._localIdeographFontFamily = t.localIdeographFontFamily, this._validateStyle = t.validateStyle, t.style && this.setStyle(t.style, {
            localIdeographFontFamily: t.localIdeographFontFamily
        }), t.attributionControl && this.addControl(new $902e455d852cdfb8$export$5af5c3cc9905683(typeof t.attributionControl == `boolean` ? void 0 : t.attributionControl)), t.maplibreLogo && this.addControl(new $902e455d852cdfb8$export$6941d1bdee1234d4, t.logoPosition), this.on(`style.load`, ()=>{
            if (r || this._resizeTransform(), this._camera.transform.unmodified) {
                let e1 = (0, $caapT.gr)(this.style.stylesheet, [
                    `center`,
                    `zoom`,
                    `bearing`,
                    `pitch`,
                    `roll`
                ]);
                this.jumpTo(e1);
            }
        }), this.on(`data`, (e1)=>{
            this._update(e1.dataType === `style`), this.fire(e1.dataType === `style` ? new $902e455d852cdfb8$export$49025a11e3fe5bd0(`styledata`, e1) : new $902e455d852cdfb8$export$ae09c661b7a299b2(`sourcedata`, e1));
        }), this.on(`dataloading`, (e1)=>{
            this.fire(e1.dataType === `style` ? new $902e455d852cdfb8$export$49025a11e3fe5bd0(`styledataloading`, e1) : new $902e455d852cdfb8$export$ae09c661b7a299b2(`sourcedataloading`, e1));
        }), this.on(`dataabort`, (e1)=>{
            this.fire(new $902e455d852cdfb8$export$ae09c661b7a299b2(`sourcedataabort`, e1));
        });
    }
    _getMapId() {
        return this._mapId;
    }
    setGlobalStateProperty(e1, t) {
        return this.style.setGlobalStateProperty(e1, t), this._update(!0);
    }
    getGlobalState() {
        return this.style.getGlobalState();
    }
    addControl(e1, t) {
        if (t === void 0 && (t = e1.getDefaultPosition ? e1.getDefaultPosition() : `top-right`), !e1?.onAdd) return this.fire(new (0, $caapT.fn)(Error(`Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.`)));
        let n = e1.onAdd(this);
        this._controls.push(e1);
        let r = this._controlPositions[t];
        return t.includes(`bottom`) ? r.insertBefore(n, r.firstChild) : r.appendChild(n), this;
    }
    removeControl(e1) {
        if (!e1?.onRemove) return this.fire(new (0, $caapT.fn)(Error(`Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.`)));
        let t = this._controls.indexOf(e1);
        return t > -1 && this._controls.splice(t, 1), e1.onRemove(this), this;
    }
    hasControl(e1) {
        return this._controls.includes(e1);
    }
    coveringTiles(e1) {
        return $902e455d852cdfb8$var$Fa(this._camera.transform, e1);
    }
    setTransformCameraUpdate(e1) {
        this._camera.transformCameraUpdate = e1;
    }
    getCenter() {
        return new (0, $caapT.k)(this._camera.transform.center.lng, this._camera.transform.center.lat);
    }
    setCenter(e1, t) {
        return this._camera.setCenter(e1, t), this;
    }
    getCenterElevation() {
        return this._camera.transform.elevation;
    }
    setCenterElevation(e1, t) {
        return this._camera.setCenterElevation(e1, t), this;
    }
    setCenterClampedToGround(e1) {
        this._camera.setCenterClampedToGround(e1);
    }
    panBy(e1, t, n) {
        return this._camera.panBy(e1, t, n), this;
    }
    panTo(e1, t, n) {
        return this._camera.panTo(e1, t, n), this;
    }
    getZoom() {
        return this._camera.transform.zoom;
    }
    setZoom(e1, t) {
        return this._camera.setZoom(e1, t), this;
    }
    zoomTo(e1, t, n) {
        return this._camera.zoomTo(e1, t, n), this;
    }
    zoomIn(e1, t) {
        return this._camera.zoomIn(e1, t), this;
    }
    zoomOut(e1, t) {
        return this._camera.zoomOut(e1, t), this;
    }
    getVerticalFieldOfView() {
        return this._camera.transform.fov;
    }
    setVerticalFieldOfView(e1, t) {
        return this._camera.setVerticalFieldOfView(e1, t), this;
    }
    getBearing() {
        return this._camera.transform.bearing;
    }
    setBearing(e1, t) {
        return this._camera.setBearing(e1, t), this;
    }
    getZoomSnap() {
        return this._camera.getZoomSnap();
    }
    setZoomSnap(e1) {
        return this._camera.setZoomSnap(e1), this;
    }
    getPadding() {
        return this._camera.transform.padding;
    }
    setPadding(e1, t) {
        return this._camera.setPadding(e1, t), this;
    }
    rotateTo(e1, t, n) {
        return this._camera.rotateTo(e1, t, n), this;
    }
    resetNorth(e1, t) {
        return this._camera.resetNorth(e1, t), this;
    }
    resetNorthPitch(e1, t) {
        return this._camera.resetNorthPitch(e1, t), this;
    }
    snapToNorth(e1, t) {
        return this._camera.snapToNorth(e1, t), this;
    }
    getPitch() {
        return this._camera.transform.pitch;
    }
    setPitch(e1, t) {
        return this._camera.setPitch(e1, t), this;
    }
    getRoll() {
        return this._camera.transform.roll;
    }
    setRoll(e1, t) {
        return this._camera.setRoll(e1, t), this;
    }
    cameraForBounds(e1, t) {
        return this._camera.cameraForBounds(e1, t);
    }
    fitBounds(e1, t, n) {
        return this._camera.fitBounds(e1, t, n), this;
    }
    fitScreenCoordinates(e1, t, n, r, i) {
        return this._camera.fitScreenCoordinates(e1, t, n, r, i), this;
    }
    jumpTo(e1, t) {
        return this._camera.jumpTo(e1, t), this;
    }
    calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, n, r, i) {
        return this._camera.calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, n, r, i);
    }
    easeTo(e1, t) {
        return this._camera.easeTo(e1, t), this;
    }
    flyTo(e1, t) {
        return this._camera.flyTo(e1, t), this;
    }
    stop() {
        return this._camera.stop(), this;
    }
    queryTerrainElevation(e1) {
        return this.terrain ? this.terrain.getElevationForLngLat((0, $caapT.k).convert(e1), this._camera.transform) : null;
    }
    getCenterClampedToGround() {
        return this._camera.getCenterClampedToGround();
    }
    calculateCameraOptionsFromTo(e1, t, n, r) {
        return r == null && this.terrain && (r = this.terrain.getElevationForLngLat(n, this._camera.transform)), this._camera.calculateCameraOptionsFromTo(e1, t, n, r);
    }
    resize(e1, t = !0) {
        if (this._lostContextStyle.style !== null) return this;
        this._resizeInternal(t);
        let n = !this._camera._moving;
        return n && (this.stop(), this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`movestart`, e1)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`move`, e1))), this.fire(new $902e455d852cdfb8$export$fc21b96c04d10d16(`resize`, e1)), n && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`moveend`, e1)), this;
    }
    _resizeInternal(e1 = !0) {
        let [t, n] = this._containerDimensions(), r = this._getClampedPixelRatio(t, n);
        if (this._resizeCanvas(t, n, r), this.painter.resize(t, n, r), this.painter.overLimit()) {
            let e1 = this.painter.context.gl;
            this._maxCanvasSize = [
                e1.drawingBufferWidth,
                e1.drawingBufferHeight
            ];
            let r = this._getClampedPixelRatio(t, n);
            this._resizeCanvas(t, n, r), this.painter.resize(t, n, r);
        }
        this._resizeTransform(e1);
    }
    _resizeTransform(e1 = !0) {
        let [t, n] = this._containerDimensions();
        this._camera.transform.resize(t, n, e1), this._camera._requestedCameraState?.resize(t, n, e1);
    }
    _getClampedPixelRatio(e1, t) {
        let { 0: n, 1: r } = this._maxCanvasSize, i = this.getPixelRatio(), a = e1 * i, o = t * i, s = a > n ? n / a : 1, c = o > r ? r / o : 1;
        return Math.min(s, c) * i;
    }
    getPixelRatio() {
        return this._overridePixelRatio ?? devicePixelRatio;
    }
    setPixelRatio(e1) {
        this._overridePixelRatio = e1, this.resize();
    }
    getBounds() {
        return this._camera.transform.getBounds();
    }
    getMaxBounds() {
        return this._camera.transform.getMaxBounds();
    }
    setMaxBounds(e1) {
        return this._camera.transform.setMaxBounds($902e455d852cdfb8$export$266d2884f61535d3.convert(e1)), this._update();
    }
    setMinZoom(e1) {
        if (e1 ??= -2, e1 >= -2 && e1 <= this._camera.transform.maxZoom) {
            let t = this._camera.transform.zoom, n = this._camera.getTransformForUpdate();
            return n.setMinZoom(e1), this._camera.applyUpdatedTransform(n), this._update(), t !== this._camera.transform.zoom && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoomstart`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoom`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoomend`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`movestart`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`move`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`moveend`)), this;
        } else throw Error(`minZoom must be between -2 and the current maxZoom, inclusive`);
    }
    getMinZoom() {
        return this._camera.transform.minZoom;
    }
    setMaxZoom(e1) {
        if (e1 ??= 22, e1 >= this._camera.transform.minZoom) {
            let t = this._camera.transform.zoom, n = this._camera.getTransformForUpdate();
            return n.setMaxZoom(e1), this._camera.applyUpdatedTransform(n), this._update(), t !== this._camera.transform.zoom && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoomstart`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoom`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`zoomend`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`movestart`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`move`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`moveend`)), this;
        } else throw Error(`maxZoom must be greater than the current minZoom`);
    }
    getMaxZoom() {
        return this._camera.transform.maxZoom;
    }
    setMinPitch(e1) {
        if (e1 ??= 0, e1 < 0) throw Error(`minPitch must be greater than or equal to 0`);
        if (e1 >= 0 && e1 <= this._camera.transform.maxPitch) {
            let t = this._camera.transform.pitch, n = this._camera.getTransformForUpdate();
            return n.setMinPitch(e1), this._camera.applyUpdatedTransform(n), this._update(), t !== this._camera.transform.pitch && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitchstart`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitch`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitchend`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`movestart`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`move`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`moveend`)), this;
        } else throw Error(`minPitch must be between 0 and the current maxPitch, inclusive`);
    }
    getMinPitch() {
        return this._camera.transform.minPitch;
    }
    setMaxPitch(e1) {
        if (e1 ??= 60, e1 > 180) throw Error(`maxPitch must be less than or equal to 180`);
        if (e1 >= this._camera.transform.minPitch) {
            let t = this._camera.transform.pitch, n = this._camera.getTransformForUpdate();
            return n.setMaxPitch(e1), this._camera.applyUpdatedTransform(n), this._update(), t !== this._camera.transform.pitch && this.fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitchstart`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitch`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`pitchend`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`movestart`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`move`)).fire(new $902e455d852cdfb8$export$534b7a2acb0e16da(`moveend`)), this;
        } else throw Error(`maxPitch must be greater than the current minPitch`);
    }
    getMaxPitch() {
        return this._camera.transform.maxPitch;
    }
    getAnisotropicFilterPitch() {
        return this._anisotropicFilterPitch;
    }
    setAnisotropicFilterPitch(e1) {
        if (e1 ??= 20, e1 > 180) throw Error(`anisotropicFilterPitch must be less than or equal to 180`);
        if (e1 < 0) throw Error(`anisotropicFilterPitch must be greater than or equal to 0`);
        return this._anisotropicFilterPitch = e1, this._update();
    }
    getRenderWorldCopies() {
        return this._camera.transform.renderWorldCopies;
    }
    setRenderWorldCopies(e1) {
        return this._camera.transform.setRenderWorldCopies(e1), this._update();
    }
    setTransformConstrain(e1) {
        return this._camera.transform.setConstrainOverride(e1), this._update();
    }
    project(e1) {
        return this._camera.transform.locationToScreenPoint((0, $caapT.k).convert(e1), this.style && this.terrain);
    }
    unproject(e1) {
        return this._camera.transform.screenPointToLocation((0, $caapT.ji).convert(e1), this.terrain);
    }
    isMoving() {
        return this._camera.isMoving() || this._handlers?.isMoving() || !1;
    }
    isZooming() {
        return this._camera.isZooming() || this._handlers?.isZooming() || !1;
    }
    isRotating() {
        return this._camera.isRotating() || this._handlers?.isRotating() || !1;
    }
    _createDelegatedListener(e1, t, n) {
        if (e1 === `mouseenter` || e1 === `mouseover`) {
            let r = !1;
            return {
                layers: t,
                listener: n,
                delegates: {
                    mousemove: (i)=>{
                        let a = t.filter((e1)=>this.getLayer(e1)), o = a.length === 0 ? [] : this.queryRenderedFeatures(i.point, {
                            layers: a
                        });
                        o.length ? r || (r = !0, n.call(this, new $902e455d852cdfb8$export$83f023c8e5acf676(e1, this, i.originalEvent, {
                            features: o
                        }))) : r = !1;
                    },
                    mouseout: ()=>{
                        r = !1;
                    }
                }
            };
        } else if (e1 === `mouseleave` || e1 === `mouseout`) {
            let r = !1;
            return {
                layers: t,
                listener: n,
                delegates: {
                    mousemove: (i)=>{
                        let a = t.filter((e1)=>this.getLayer(e1));
                        (a.length === 0 ? [] : this.queryRenderedFeatures(i.point, {
                            layers: a
                        })).length ? r = !0 : r && (r = !1, n.call(this, new $902e455d852cdfb8$export$83f023c8e5acf676(e1, this, i.originalEvent)));
                    },
                    mouseout: (t)=>{
                        r && (r = !1, n.call(this, new $902e455d852cdfb8$export$83f023c8e5acf676(e1, this, t.originalEvent)));
                    }
                }
            };
        } else {
            let r = (e1)=>{
                let r = t.filter((e1)=>this.getLayer(e1)), i = r.length === 0 ? [] : this.queryRenderedFeatures(e1.point, {
                    layers: r
                });
                i.length && (e1.features = i, n.call(this, e1), delete e1.features);
            };
            return {
                layers: t,
                listener: n,
                delegates: {
                    [e1]: r
                }
            };
        }
    }
    _saveDelegatedListener(e1, t) {
        this._delegatedListeners ||= {}, this._delegatedListeners[e1] ||= [], this._delegatedListeners[e1].push(t);
    }
    _removeDelegatedListener(e1, t, n) {
        if (!this._delegatedListeners?.[e1]) return;
        let r = this._delegatedListeners[e1];
        for(let e1 = 0; e1 < r.length; e1++){
            let i = r[e1];
            if (i.listener === n && i.layers.length === t.length && i.layers.every((e1)=>t.includes(e1))) {
                for(let e1 in i.delegates)this.off(e1, i.delegates[e1]);
                r.splice(e1, 1);
                return;
            }
        }
    }
    on(e1, t, n) {
        if (n === void 0) return super.on(e1, t);
        let r = typeof t == `string` ? [
            t
        ] : t, i = this._createDelegatedListener(e1, r, n);
        this._saveDelegatedListener(e1, i);
        for(let e1 in i.delegates)this.on(e1, i.delegates[e1]);
        return {
            unsubscribe: ()=>{
                this._removeDelegatedListener(e1, r, n);
            }
        };
    }
    once(e1, t, n) {
        if (n === void 0) return super.once(e1, t);
        let r = typeof t == `string` ? [
            t
        ] : t, i = this._createDelegatedListener(e1, r, n);
        for(let t in i.delegates){
            let a = i.delegates[t];
            i.delegates[t] = (...t)=>{
                this._removeDelegatedListener(e1, r, n), a(...t);
            };
        }
        this._saveDelegatedListener(e1, i);
        for(let e1 in i.delegates)this.once(e1, i.delegates[e1]);
        return this;
    }
    off(e1, t, n) {
        if (n === void 0) return super.off(e1, t);
        let r = typeof t == `string` ? [
            t
        ] : t;
        return this._removeDelegatedListener(e1, r, n), this;
    }
    queryRenderedFeatures(e1, t) {
        if (!this.style) return [];
        let n, r = e1 instanceof (0, $caapT.ji) || Array.isArray(e1), i = r ? e1 : [
            [
                0,
                0
            ],
            [
                this._camera.transform.width,
                this._camera.transform.height
            ]
        ];
        if (t ||= (r ? {} : e1) || {}, i instanceof (0, $caapT.ji) || typeof i[0] == `number`) n = [
            (0, $caapT.ji).convert(i)
        ];
        else {
            let e1 = (0, $caapT.ji).convert(i[0]), t = (0, $caapT.ji).convert(i[1]);
            n = [
                e1,
                new (0, $caapT.ji)(t.x, e1.y),
                t,
                new (0, $caapT.ji)(e1.x, t.y),
                e1
            ];
        }
        return this.style.queryRenderedFeatures(n, t, this._camera.transform);
    }
    querySourceFeatures(e1, t) {
        return this.style.querySourceFeatures(e1, t);
    }
    setStyle(e1, t) {
        return t = (0, $caapT.Zn)({}, {
            localIdeographFontFamily: this._localIdeographFontFamily,
            validate: this._validateStyle
        }, t), t.diff !== !1 && t.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, t), this) : (this._localIdeographFontFamily = t.localIdeographFontFamily, this._updateStyle(e1, t));
    }
    setTransformRequest(e1) {
        return this._requestManager.setTransformRequest(e1), this;
    }
    _getUIString(e1) {
        let t = this._locale[e1];
        if (t == null) throw Error(`Missing UI string '${e1}'`);
        return t;
    }
    _updateStyle(e1, t) {
        if (this._diffStyleRequest?.abort(), this._diffStyleRequest = null, t.transformStyle && this.style && !this.style._loaded) {
            this.style.once(`style.load`, ()=>this._updateStyle(e1, t));
            return;
        }
        let n = this.style && t.transformStyle ? this.style.serialize() : void 0;
        if (this.style && (this.style.setEventedParent(null), this.style._remove(!e1)), e1) this.style = new $902e455d852cdfb8$export$d9e45bc13d335801(this, t || {});
        else return this._frameRequest &&= (this._frameRequest.abort(), null), this.style?.projection?.destroy(), delete this.style, this;
        return this.style.setEventedParent(this, {
            style: this.style
        }), typeof e1 == `string` ? this.style.loadURL(e1, t, n) : this.style.loadJSON(e1, t, n), this;
    }
    _lazyInitEmptyStyle() {
        this.style || (this.style = new $902e455d852cdfb8$export$d9e45bc13d335801(this, {}), this.style.setEventedParent(this, {
            style: this.style
        }), this.style.loadEmpty());
    }
    async _diffStyle(e1, t) {
        if (this._diffStyleRequest?.abort(), typeof e1 == `string`) {
            let n = e1;
            this._diffStyleRequest = new AbortController;
            let r = this._diffStyleRequest;
            try {
                let e1 = await this._requestManager.transformRequest(n, `Style`);
                if (r.signal.aborted) {
                    this._diffStyleRequest = null;
                    return;
                }
                let i = await (0, $caapT.vn)(e1, r);
                this._diffStyleRequest = null, this._updateDiff(i.data, t);
            } catch (e1) {
                this._diffStyleRequest = null, (0, $caapT.On)(e1) || this.fire(new (0, $caapT.fn)((0, $caapT.Yn)(e1)));
            }
        } else typeof e1 == `object` && (this._diffStyleRequest = null, this._updateDiff(e1, t));
    }
    _updateDiff(e1, t) {
        try {
            this.style.setState(e1, t) && this._update(!0);
        } catch (n) {
            (0, $caapT.Ar)(`Unable to perform style diff: ${(0, $caapT.Yn)(n).message}.  Rebuilding the style from scratch.`), this._updateStyle(e1, t);
        }
    }
    getStyle() {
        if (this.style) return this.style.serialize();
    }
    _getStyleAndImages() {
        return this.style ? {
            style: this.style.serialize(),
            images: this.style.imageManager.cloneImages()
        } : {
            style: null,
            images: {}
        };
    }
    isStyleLoaded() {
        if (!this.style) {
            (0, $caapT.Ar)(`There is no style added to the map.`);
            return;
        }
        return this.style.loaded();
    }
    addSource(e1, t) {
        return this._lazyInitEmptyStyle(), this.style.addSource(e1, t), this._update(!0);
    }
    isSourceLoaded(e1) {
        let t = this.style?.tileManagers[e1];
        if (t === void 0) {
            this.fire(new (0, $caapT.fn)(Error(`There is no tile manager with ID '${e1}'`)));
            return;
        }
        return t.loaded();
    }
    setTerrain(e1, t = {}) {
        if (this.style._checkLoaded(), e1 && (0, $caapT.Qt)(this, (0, $caapT.$t).terrain, {
            value: e1
        }, t)) return this;
        if (this._terrainDataCallback && this.style.off(`data`, this._terrainDataCallback), !e1) this.terrain && this.terrain.destroy(), this.terrain = null, this.painter.renderToTexture = null, this._camera.terrain = null, this._camera.transform.setMinElevationForCurrentTile(0), this.getCenterClampedToGround() && this._camera.transform.setElevation(0);
        else {
            let t = this.style.tileManagers[e1.source];
            if (!t) throw Error(`cannot load terrain, because there exists no source with ID: ${e1.source}`);
            this.terrain === null && t.reload();
            for(let t in this.style._layers){
                let n = this.style._layers[t];
                n.type === `hillshade` && n.source === e1.source && (0, $caapT.Ar)(`You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.`), n.type === `color-relief` && n.source === e1.source && (0, $caapT.Ar)(`You are using the same source for a color-relief layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.`);
            }
            this.terrain = new $902e455d852cdfb8$var$pp(this.painter, t, e1, this._terrainSkirtLength), this.painter.renderToTexture = new $902e455d852cdfb8$var$hp(this.painter, this.terrain), this._camera.terrain = this.terrain, this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), this._camera.transform.setElevation(this.terrain.getElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), this._terrainDataCallback = (t)=>{
                t.dataType === `style` ? this.terrain.tileManager.releaseAllRTT() : t.dataType === `source` && t.tile && (t.sourceId === e1.source && !this._camera.elevationFreeze && (this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), this.getCenterClampedToGround() && this._camera.transform.setElevation(this.terrain.getElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom))), t.source?.type === `image` ? this.terrain.tileManager.releaseAllRTT() : this.terrain.tileManager.releaseRTT(t.tile.tileID));
            }, this.style.on(`data`, this._terrainDataCallback);
        }
        return this.fire(new $902e455d852cdfb8$export$da1f2ab236a92d66({
            terrain: e1
        })), this;
    }
    getTerrain() {
        return this.terrain?.options ?? null;
    }
    areTilesLoaded() {
        let e1 = this.style?.tileManagers;
        for (let t of Object.values(e1))if (!t.areTilesLoaded()) return !1;
        return !0;
    }
    removeSource(e1) {
        return this.style.removeSource(e1), this._update(!0);
    }
    getSource(e1) {
        return this.style?.getSource(e1);
    }
    setSourceTileLodParams(e1, t, n) {
        if (n) {
            let r = this.getSource(n);
            if (!r) throw Error(`There is no source with ID "${n}", cannot set LOD parameters`);
            r.calculateTileZoom = $902e455d852cdfb8$var$Ma(Math.max(1, e1), Math.max(1, t));
        } else for(let n in this.style.tileManagers)this.style.tileManagers[n].getSource().calculateTileZoom = $902e455d852cdfb8$var$Ma(Math.max(1, e1), Math.max(1, t));
        return this._update(!0), this;
    }
    refreshTiles(e1, t) {
        let n = this.style.tileManagers[e1];
        if (!n) throw Error(`There is no tile manager with ID "${e1}", cannot refresh tile`);
        t === void 0 ? n.reload(!0) : n.refreshTiles(t.map((e1)=>new (0, $caapT.g)(e1.z, e1.x, e1.y)));
    }
    addImage(e1, t, n = {}) {
        this._lazyInitEmptyStyle();
        let r = this._createStyleImage(t, n);
        return r ? (this.style.addImage(e1, r), r.userImage?.onAdd && r.userImage.onAdd(this, e1), this) : this;
    }
    setMissingStyleImageResolver(e1) {
        return this._missingStyleImageResolver = e1, this.style?.setMissingImageResolver(e1), this;
    }
    _createStyleImage(e1, t = {}) {
        let { pixelRatio: n = 1, sdf: r = !1, stretchX: i, stretchY: a, content: o, textFitWidth: s, textFitHeight: c } = t;
        if (e1 instanceof HTMLImageElement || (0, $caapT.ar)(e1)) {
            let { width: t, height: l, data: u } = $902e455d852cdfb8$var$Dr.getImageData(e1);
            return {
                data: new (0, $caapT._t)({
                    width: t,
                    height: l
                }, u),
                pixelRatio: n,
                stretchX: i,
                stretchY: a,
                content: o,
                textFitWidth: s,
                textFitHeight: c,
                sdf: r,
                version: 0
            };
        } else if (e1.width === void 0 || e1.height === void 0) return this.fire(new (0, $caapT.fn)(Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`"))), null;
        else {
            let { width: t, height: l, data: u } = e1, d = e1;
            return {
                data: new (0, $caapT._t)({
                    width: t,
                    height: l
                }, new Uint8Array(u)),
                pixelRatio: n,
                stretchX: i,
                stretchY: a,
                content: o,
                textFitWidth: s,
                textFitHeight: c,
                sdf: r,
                version: 0,
                userImage: d
            };
        }
    }
    updateImage(e1, t) {
        let n = this.style.getImage(e1);
        if (!n) return this.fire(new (0, $caapT.fn)(Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
        let { width: r, height: i, data: a } = t instanceof HTMLImageElement || (0, $caapT.ar)(t) ? $902e455d852cdfb8$var$Dr.getImageData(t) : t;
        if (r === void 0 || i === void 0) return this.fire(new (0, $caapT.fn)(Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
        if (r !== n.data.width || i !== n.data.height) return this.fire(new (0, $caapT.fn)(Error(`The width and height of the updated image must be that same as the previous version of the image`)));
        let o = !(t instanceof HTMLImageElement || (0, $caapT.ar)(t));
        return n.data.replace(a, o), this.style.updateImage(e1, n), this;
    }
    getImage(e1) {
        return this.style.getImage(e1);
    }
    hasImage(e1) {
        return e1 ? !!this.style.getImage(e1) : (this.fire(new (0, $caapT.fn)(Error(`Missing required image id`))), !1);
    }
    removeImage(e1) {
        this.style.removeImage(e1);
    }
    async loadImage(e1) {
        return $902e455d852cdfb8$var$Mr.getImage(await this._requestManager.transformRequest(e1, `Image`), new AbortController);
    }
    listImages() {
        return this.style?.listImages() ?? [];
    }
    addLayer(e1, t) {
        return this._lazyInitEmptyStyle(), this.style.addLayer(e1, t), this._update(!0);
    }
    moveLayer(e1, t) {
        return this.style.moveLayer(e1, t), this._update(!0);
    }
    removeLayer(e1) {
        return this.style.removeLayer(e1), this._update(!0);
    }
    getLayer(e1) {
        return this.style?.getLayer(e1);
    }
    getLayersOrder() {
        return this.style?.getLayersOrder() ?? [];
    }
    setLayerZoomRange(e1, t, n) {
        return this.style.setLayerZoomRange(e1, t, n), this._update(!0);
    }
    setFilter(e1, t, n = {}) {
        return this.style?.setFilter(e1, t, n), this._update(!0);
    }
    getFilter(e1) {
        return this.style.getFilter(e1);
    }
    setPaintProperty(e1, t, n, r = {}) {
        return this.style?.setPaintProperty(e1, t, n, r), this._update(!0);
    }
    getPaintProperty(e1, t) {
        return this.style.getPaintProperty(e1, t);
    }
    setLayoutProperty(e1, t, n, r = {}) {
        return this.style.setLayoutProperty(e1, t, n, r), this._update(!0);
    }
    getLayoutProperty(e1, t) {
        return this.style.getLayoutProperty(e1, t);
    }
    setGlyphs(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setGlyphs(e1, t), this._update(!0);
    }
    getGlyphs() {
        return this.style.getGlyphsUrl();
    }
    addSprite(e1, t, n = {}) {
        return this._lazyInitEmptyStyle(), this.style.addSprite(e1, t, n, (e1)=>{
            e1 || this._update(!0);
        }), this;
    }
    removeSprite(e1) {
        return this._lazyInitEmptyStyle(), this.style.removeSprite(e1), this._update(!0);
    }
    getSprite() {
        return this.style.getSprite();
    }
    setSprite(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setSprite(e1, t, (e1)=>{
            e1 || this._update(!0);
        }), this;
    }
    setLight(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setLight(e1, t), this._update(!0);
    }
    getLight() {
        return this.style.getLight();
    }
    setSky(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setSky(e1, t), this._update(!0);
    }
    getSky() {
        return this.style.getSky();
    }
    setFeatureState(e1, t) {
        return this.style.setFeatureState(e1, t), this._update();
    }
    removeFeatureState(e1, t) {
        return this.style.removeFeatureState(e1, t), this._update();
    }
    getFeatureState(e1) {
        return this.style.getFeatureState(e1);
    }
    getContainer() {
        return this._container;
    }
    getCanvasContainer() {
        return this._canvasContainer;
    }
    getCanvas() {
        return this._canvas;
    }
    _containerDimensions() {
        let e1 = 0, t = 0;
        return this._container && (e1 = this._container.clientWidth || 400, t = this._container.clientHeight || 300), [
            e1,
            t
        ];
    }
    _setupResizeObserver() {
        let e1 = !1, t = $902e455d852cdfb8$var$nf((e1)=>{
            this._trackResize && !this._removed && (this.resize(e1), this.redraw());
        }, 50), n = this._ownerWindow.ResizeObserver ?? ResizeObserver;
        this._resizeObserver = new n((n)=>{
            if (!e1) {
                e1 = !0;
                return;
            }
            t(n);
        }), this._resizeObserver.observe(this._container);
    }
    _resolveContainer(e1) {
        if (typeof e1 == `string`) {
            let t = document.getElementById(e1);
            if (!t) throw Error(`Container '${e1}' not found.`);
            return t;
        }
        if (e1 instanceof HTMLElement || e1 && typeof e1 == `object` && e1.nodeType === 1) return e1;
        throw Error(`Invalid type: 'container' must be a String or HTMLElement.`);
    }
    _setupContainer() {
        let e1 = this._container;
        e1.classList.add(`maplibregl-map`);
        let t = this._canvasContainer = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-canvas-container`, e1);
        this._interactive && t.classList.add(`maplibregl-interactive`), this._canvas = $902e455d852cdfb8$var$W.create(`canvas`, `maplibregl-canvas`, t), this._canvas.addEventListener(`webglcontextlost`, this._contextLost, !1), this._canvas.addEventListener(`webglcontextrestored`, this._contextRestored, !1), this._canvas.setAttribute(`tabindex`, this._interactive ? `0` : `-1`), this._canvas.setAttribute(`aria-label`, this._getUIString(`Map.Title`)), this._canvas.setAttribute(`role`, `region`);
        let n = this._containerDimensions(), r = this._getClampedPixelRatio(n[0], n[1]);
        this._resizeCanvas(n[0], n[1], r);
        let i = this._controlContainer = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-control-container`, e1), a = this._controlPositions = {};
        for (let e1 of [
            `top-left`,
            `top-right`,
            `bottom-left`,
            `bottom-right`
        ])a[e1] = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-ctrl-${e1} `, i);
        this._container.addEventListener(`scroll`, this._onMapScroll, !1);
    }
    _resizeCanvas(e1, t, n) {
        this._canvas.width = Math.floor(n * e1), this._canvas.height = Math.floor(n * t), this._canvas.style.width = `${e1}px`, this._canvas.style.height = `${t}px`;
    }
    _setupPainter() {
        let e1 = {
            ...this._canvasContextAttributes,
            alpha: !0,
            depth: !0,
            stencil: !0,
            premultipliedAlpha: !0
        }, t = null;
        this._canvas.addEventListener(`webglcontextcreationerror`, (e1)=>{
            t = e1;
        }, {
            once: !0
        });
        let n = this._canvas.getContext(`webgl2`, e1);
        if (!n) {
            this.fire(new (0, $caapT.fn)(new $902e455d852cdfb8$export$68b5dc085315a832(e1, t)));
            return;
        }
        this.painter = new $902e455d852cdfb8$var$ef(n, this._camera.transform);
    }
    migrateProjection(e1, t) {
        this._camera.migrateProjection(e1, t), this.painter.transform = e1, this.fire(new $902e455d852cdfb8$export$f966cee55553279({
            newProjection: this.style.projection.name
        }));
    }
    loaded() {
        return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
    }
    _update(e1) {
        return this.style?._loaded ? (this._styleDirty ||= e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
    }
    _requestRenderFrame(e1) {
        return this._update(), this._renderTaskQueue.add(e1);
    }
    _cancelRenderFrame(e1) {
        this._renderTaskQueue.remove(e1);
    }
    _render(e1) {
        let t = this._idleTriggered ? this._fadeDuration : 0, n = this.style.projection?.transitionState > 0;
        if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), this._removed) return;
        let r = !1;
        if (this.style && this._styleDirty) {
            this._styleDirty = !1;
            let e1 = this._camera.transform.zoom, n = $902e455d852cdfb8$export$461939dd4422153();
            this.style.zoomHistory.update(e1, n);
            let i = new (0, $caapT.Gt)(e1, {
                now: n,
                fadeDuration: t,
                zoomHistory: this.style.zoomHistory,
                transition: this.style.getTransition()
            }), a = i.crossFadingFactor();
            (a !== 1 || a !== this._crossFadingFactor) && (r = !0, this._crossFadingFactor = a), this.style.update(i);
        }
        let i = this.style.projection?.transitionState > 0 !== n;
        this.style.projection?.setErrorQueryLatitudeDegrees(this._camera.transform.center.lat), this._camera.transform.setTransitionState(this.style.projection?.transitionState, this.style.projection?.latitudeErrorCorrectionRadians), this.style && (this._sourcesDirty || i) && (this._sourcesDirty = !1, this.style._updateSources(this._camera.transform)), this.terrain ? (this.terrain.tileManager.update(this._camera.transform, this.terrain), this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), !this._camera.elevationFreeze && this.getCenterClampedToGround() && this._camera.transform.setElevation(this.terrain.getElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom))) : (this._camera.transform.setMinElevationForCurrentTile(0), this.getCenterClampedToGround() && this._camera.transform.setElevation(0)), this._placementDirty = this.style?._updatePlacement(this._camera.transform, this.showCollisionBoxes, t, this._crossSourceCollisions, i), this.painter.render(this.style, {
            showTileBoundaries: this.showTileBoundaries,
            showOverdrawInspector: this._showOverdrawInspector,
            rotating: this.isRotating(),
            zooming: this.isZooming(),
            moving: this.isMoving(),
            fadeDuration: t,
            showPadding: this.showPadding,
            anisotropicFilterPitch: this.getAnisotropicFilterPitch()
        }), this.fire(new $902e455d852cdfb8$export$fc21b96c04d10d16(`render`)), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new $902e455d852cdfb8$export$fc21b96c04d10d16(`load`))), this.style && (this.style.hasTransitions() || r) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
        let a = this._sourcesDirty || this._styleDirty || this._placementDirty;
        return a || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new $902e455d852cdfb8$export$fc21b96c04d10d16(`idle`)), this._loaded && !this._fullyLoaded && !a && (this._fullyLoaded = !0), this;
    }
    redraw() {
        return this.style && (this._frameRequest &&= (this._frameRequest.abort(), null), this._render(0)), this;
    }
    remove() {
        this._hash && this._hash.remove();
        for (let e1 of this._controls)e1.onRemove(this);
        this._controls = [], this._frameRequest &&= (this._frameRequest.abort(), null), this._renderTaskQueue.clear(), this._diffStyleRequest?.abort(), this.painter.destroy(), this._handlers.destroy(), this.setStyle(null), typeof window < `u` && this._ownerWindow.removeEventListener(`online`, this._onWindowOnline, !1), $902e455d852cdfb8$var$Mr.removeThrottleControl(this._imageQueueHandle), this._resizeObserver?.disconnect();
        let e1 = this.painter.context.gl.getExtension(`WEBGL_lose_context`);
        e1?.loseContext && e1.loseContext(), this._canvas.removeEventListener(`webglcontextrestored`, this._contextRestored, !1), this._canvas.removeEventListener(`webglcontextlost`, this._contextLost, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._container.removeEventListener(`scroll`, this._onMapScroll, !1), this._container.classList.remove(`maplibregl-map`), this._removed = !0, this.fire(new $902e455d852cdfb8$export$fc21b96c04d10d16(`remove`));
    }
    triggerRepaint() {
        this.style && !this._frameRequest && (this._frameRequest = new AbortController, $902e455d852cdfb8$var$Dr.frame(this._frameRequest, (e1)=>{
            this._frameRequest = null;
            try {
                this._render(e1);
            } catch (e1) {
                if (!(0, $caapT.On)(e1)) throw e1;
            }
        }, ()=>{}, this._ownerWindow));
    }
    get showTileBoundaries() {
        return !!this._showTileBoundaries;
    }
    set showTileBoundaries(e1) {
        this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
    }
    get showPadding() {
        return !!this._showPadding;
    }
    set showPadding(e1) {
        this._showPadding !== e1 && (this._showPadding = e1, this._update());
    }
    get showCollisionBoxes() {
        return !!this._showCollisionBoxes;
    }
    set showCollisionBoxes(e1) {
        this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
    }
    get showOverdrawInspector() {
        return !!this._showOverdrawInspector;
    }
    set showOverdrawInspector(e1) {
        this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
    }
    get repaint() {
        return !!this._repaint;
    }
    set repaint(e1) {
        this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
    }
    get vertices() {
        return !!this._vertices;
    }
    set vertices(e1) {
        this._vertices = e1, this._update();
    }
    get version() {
        return $902e455d852cdfb8$var$_p;
    }
    getCameraTargetElevation() {
        return this._camera.transform.elevation;
    }
    getProjection() {
        return this.style.getProjection();
    }
    setProjection(e1) {
        return this._lazyInitEmptyStyle(), this.style.setProjection(e1), this._update(!0);
    }
};
const $902e455d852cdfb8$var$bp = {
    showCompass: !0,
    showZoom: !0,
    visualizePitch: !1,
    visualizeRoll: !0
};
var $902e455d852cdfb8$export$49a437922edc1bd9 = class {
    constructor(e1){
        this._updateZoomButtons = ()=>{
            let e1 = this._map.getZoom(), t = e1 === this._map.getMaxZoom(), n = e1 === this._map.getMinZoom();
            this._zoomInButton.disabled = t, this._zoomOutButton.disabled = n, this._zoomInButton.setAttribute(`aria-disabled`, t.toString()), this._zoomOutButton.setAttribute(`aria-disabled`, n.toString());
        }, this._rotateCompassArrow = ()=>{
            let e1 = this._map.getPitch(), t = this._map.getRoll(), n = this._map.getBearing(), r = 1 / Math.cos((0, $caapT.Gn)(e1)) ** .5;
            if (this.options.visualizePitch && this.options.visualizeRoll) {
                this._compassIcon.style.transform = `scale(${r}) rotateZ(${-t}deg) rotateX(${e1}deg) rotateZ(${-n}deg)`;
                return;
            }
            if (this.options.visualizePitch) {
                this._compassIcon.style.transform = `scale(${r}) rotateX(${e1}deg) rotateZ(${-n}deg)`;
                return;
            }
            if (this.options.visualizeRoll) {
                this._compassIcon.style.transform = `rotate(${-n - t}deg)`;
                return;
            }
            this._compassIcon.style.transform = `rotate(${-n}deg)`;
        }, this._setButtonTitle = (e1, t)=>{
            let n = this._map._getUIString(`NavigationControl.${t}`);
            e1.title = n, e1.setAttribute(`aria-label`, n);
        }, this.options = (0, $caapT.Zn)({}, $902e455d852cdfb8$var$bp, e1), this._container = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._container.addEventListener(`contextmenu`, (e1)=>e1.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton(`maplibregl-ctrl-zoom-in`, (e1)=>this._map.zoomIn({}, {
                originalEvent: e1
            })), $902e455d852cdfb8$var$W.create(`span`, `maplibregl-ctrl-icon`, this._zoomInButton).setAttribute(`aria-hidden`, `true`), this._zoomOutButton = this._createButton(`maplibregl-ctrl-zoom-out`, (e1)=>this._map.zoomOut({}, {
                originalEvent: e1
            })), $902e455d852cdfb8$var$W.create(`span`, `maplibregl-ctrl-icon`, this._zoomOutButton).setAttribute(`aria-hidden`, `true`)), this.options.showCompass && (this._compass = this._createButton(`maplibregl-ctrl-compass`, (e1)=>{
            this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                originalEvent: e1
            }) : this._map.resetNorth({}, {
                originalEvent: e1
            });
        }), this._compassIcon = $902e455d852cdfb8$var$W.create(`span`, `maplibregl-ctrl-icon`, this._compass), this._compassIcon.setAttribute(`aria-hidden`, `true`));
    }
    onAdd(e1) {
        return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, `ZoomIn`), this._setButtonTitle(this._zoomOutButton, `ZoomOut`), this._map.on(`zoom`, this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, `ResetBearing`), this.options.visualizePitch && this._map.on(`pitch`, this._rotateCompassArrow), this.options.visualizeRoll && this._map.on(`roll`, this._rotateCompassArrow), this._map.on(`rotate`, this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new $902e455d852cdfb8$var$Sp(this._map, this._compass, this.options.visualizePitch)), this._container;
    }
    onRemove() {
        this._container.remove(), this.options.showZoom && this._map.off(`zoom`, this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off(`pitch`, this._rotateCompassArrow), this.options.visualizeRoll && this._map.off(`roll`, this._rotateCompassArrow), this._map.off(`rotate`, this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
    }
    _createButton(e1, t) {
        let n = $902e455d852cdfb8$var$W.create(`button`, e1, this._container);
        return n.type = `button`, n.addEventListener(`click`, t), n;
    }
}, $902e455d852cdfb8$var$Sp = class {
    constructor(e1, t, n = !1){
        this.mousedown = (e1)=>{
            this.startMove(e1, $902e455d852cdfb8$var$W.mousePos(this.element, e1)), window.addEventListener(`mousemove`, this.mousemove), window.addEventListener(`mouseup`, this.mouseup);
        }, this.mousemove = (e1)=>{
            this.move(e1, $902e455d852cdfb8$var$W.mousePos(this.element, e1));
        }, this.mouseup = (e1)=>{
            this._rotatePitchHandler.dragEnd(e1), this.offTemp();
        }, this.touchstart = (e1)=>{
            e1.targetTouches.length === 1 ? (this._startPos = this._lastPos = $902e455d852cdfb8$var$W.touchPos(this.element, e1.targetTouches)[0], this.startMove(e1, this._startPos), window.addEventListener(`touchmove`, this.touchmove, {
                passive: !1
            }), window.addEventListener(`touchend`, this.touchend)) : this.reset();
        }, this.touchmove = (e1)=>{
            e1.targetTouches.length === 1 ? (this._lastPos = $902e455d852cdfb8$var$W.touchPos(this.element, e1.targetTouches)[0], this.move(e1, this._lastPos)) : this.reset();
        }, this.touchend = (e1)=>{
            e1.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
        }, this.reset = ()=>{
            this._rotatePitchHandler.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        }, this._clickTolerance = 10, this.element = t;
        let r = new $902e455d852cdfb8$var$Df;
        this._rotatePitchHandler = new $902e455d852cdfb8$var$Sf({
            clickTolerance: 3,
            move: (e1, r)=>{
                let i = t.getBoundingClientRect(), a = new (0, $caapT.ji)((i.bottom - i.top) / 2, (i.right - i.left) / 2);
                return {
                    bearingDelta: (0, $caapT.tr)(new (0, $caapT.ji)(e1.x, r.y), r, a),
                    pitchDelta: n ? (r.y - e1.y) * -0.5 : void 0
                };
            },
            moveStateManager: r,
            enable: !0,
            assignEvents: ()=>{}
        }), this.map = e1, t.addEventListener(`mousedown`, this.mousedown), t.addEventListener(`touchstart`, this.touchstart, {
            passive: !1
        }), t.addEventListener(`touchcancel`, this.reset);
    }
    startMove(e1, t) {
        this._rotatePitchHandler.dragStart(e1, t), $902e455d852cdfb8$var$W.disableDrag();
    }
    move(e1, t) {
        let n = this.map, { bearingDelta: r, pitchDelta: i } = this._rotatePitchHandler.dragMove(e1, t) || {};
        r && n.setBearing(n.getBearing() + r), i && n.setPitch(n.getPitch() + i);
    }
    off() {
        let e1 = this.element;
        e1.removeEventListener(`mousedown`, this.mousedown), e1.removeEventListener(`touchstart`, this.touchstart), window.removeEventListener(`touchmove`, this.touchmove), window.removeEventListener(`touchend`, this.touchend), e1.removeEventListener(`touchcancel`, this.reset), this.offTemp();
    }
    offTemp() {
        $902e455d852cdfb8$var$W.enableDrag(), window.removeEventListener(`mousemove`, this.mousemove), window.removeEventListener(`mouseup`, this.mouseup), window.removeEventListener(`touchmove`, this.touchmove), window.removeEventListener(`touchend`, this.touchend);
    }
};
let $902e455d852cdfb8$var$Cp;
async function $902e455d852cdfb8$var$wp(e1 = !1) {
    if ($902e455d852cdfb8$var$Cp !== void 0 && !e1) return $902e455d852cdfb8$var$Cp;
    if (window.navigator.permissions === void 0) return $902e455d852cdfb8$var$Cp = !!window.navigator.geolocation, $902e455d852cdfb8$var$Cp;
    try {
        $902e455d852cdfb8$var$Cp = (await window.navigator.permissions.query({
            name: `geolocation`
        })).state !== `denied`;
    } catch  {
        $902e455d852cdfb8$var$Cp = !!window.navigator.geolocation;
    }
    return $902e455d852cdfb8$var$Cp;
}
function $902e455d852cdfb8$var$Tp(e1, t, n, r = !1) {
    if (r || !n.getCoveringTilesDetailsProvider().allowWorldCopies()) return e1?.wrap();
    let i = new (0, $caapT.k)(e1.lng, e1.lat);
    if (e1 = new (0, $caapT.k)(e1.lng, e1.lat), t) {
        let r = new (0, $caapT.k)(e1.lng - 360, e1.lat), i = new (0, $caapT.k)(e1.lng + 360, e1.lat), a = n.locationToScreenPoint(e1).distSqr(t);
        n.locationToScreenPoint(r).distSqr(t) < a ? e1 = r : n.locationToScreenPoint(i).distSqr(t) < a && (e1 = i);
    }
    for(; Math.abs(e1.lng - n.center.lng) > 180;){
        let t = n.locationToScreenPoint(e1);
        if (t.x >= 0 && t.y >= 0 && t.x <= n.width && t.y <= n.height) break;
        e1.lng > n.center.lng ? e1.lng -= 360 : e1.lng += 360;
    }
    return e1.lng !== i.lng && n.isPointOnMapSurface(n.locationToScreenPoint(e1)) ? e1 : i;
}
const $902e455d852cdfb8$var$Ep = {
    center: `translate(-50%,-50%)`,
    top: `translate(-50%,0)`,
    "top-left": `translate(0,0)`,
    "top-right": `translate(-100%,0)`,
    bottom: `translate(-50%,-100%)`,
    "bottom-left": `translate(0,-100%)`,
    "bottom-right": `translate(-100%,-100%)`,
    left: `translate(0,-50%)`,
    right: `translate(-100%,-50%)`
};
function $902e455d852cdfb8$var$Dp(e1, t, n) {
    let r = e1.classList;
    for(let e1 in $902e455d852cdfb8$var$Ep)r.remove(`maplibregl-${n}-anchor-${e1}`);
    r.add(`maplibregl-${n}-anchor-${t}`);
}
var $902e455d852cdfb8$export$4da46cf7208441a7 = class extends (0, $caapT.pn) {
}, $902e455d852cdfb8$export$20d8ab55cf6e381 = class extends (0, $caapT.pn) {
}, $902e455d852cdfb8$export$e98856a975cab58e = class extends (0, $caapT.mn) {
    constructor(e1){
        if (super(), this._onClick = (e1)=>{
            this.fire(new $902e455d852cdfb8$export$20d8ab55cf6e381(`click`, {
                originalEvent: e1
            }));
        }, this._onKeyPress = (e1)=>{
            (e1.code === `Space` || e1.code === `Enter`) && this.togglePopup();
        }, this._onMapClick = (e1)=>{
            let t = e1.originalEvent.target, n = this._element;
            this._popup && (t === n || n.contains(t)) && this.togglePopup();
        }, this._update = (e1)=>{
            if (!this._map) return;
            let t = this._map.loaded() && !this._map.isMoving();
            (e1?.type === `terrain` || e1?.type === `render` && !t) && this._map.once(`render`, this._update), this._lngLat = $902e455d852cdfb8$var$Tp(this._lngLat, this._flatPos, this._map._camera.transform), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map._camera.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
            let n = ``;
            this._rotationAlignment === `viewport` || this._rotationAlignment === `auto` ? n = `rotateZ(${this._rotation}deg)` : this._rotationAlignment === `map` && (n = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
            let r = ``;
            this._pitchAlignment === `viewport` || this._pitchAlignment === `auto` ? r = `rotateX(0deg)` : this._pitchAlignment === `map` && (r = `rotateX(${this._map.getPitch()}deg)`), !this._subpixelPositioning && (!e1 || e1.type === `moveend`) && (this._pos = this._pos.round()), this._element.style.transform = `${$902e455d852cdfb8$var$Ep[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${r} ${n}`, $902e455d852cdfb8$var$Dr.frameAsync(new AbortController, this._map._ownerWindow).then(()=>{
                this._updateOpacity(e1?.type === `moveend`);
            }).catch(()=>{});
        }, this._onMove = (e1)=>{
            if (!this._isDragging) {
                let t = this._clickTolerance || this._map._clickTolerance;
                this._isDragging = e1.point.dist(this._pointerdownPos) >= t;
            }
            this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = `none`, this._state === `pending` && (this._state = `active`, this.fire(new $902e455d852cdfb8$export$4da46cf7208441a7(`dragstart`))), this.fire(new $902e455d852cdfb8$export$4da46cf7208441a7(`drag`)));
        }, this._onUp = ()=>{
            this._element.style.pointerEvents = `auto`, this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off(`mousemove`, this._onMove), this._map.off(`touchmove`, this._onMove), this._state === `active` && this.fire(new $902e455d852cdfb8$export$4da46cf7208441a7(`dragend`)), this._state = `inactive`;
        }, this._addDragHandler = (e1)=>{
            this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(this._pos).add(this._offset), this._pointerdownPos = e1.point, this._state = `pending`, this._map.on(`mousemove`, this._onMove), this._map.on(`touchmove`, this._onMove), this._map.once(`mouseup`, this._onUp), this._map.once(`touchend`, this._onUp));
        }, this._anchor = e1?.anchor || `center`, this._color = e1?.color || `#3FB1CE`, this._scale = e1?.scale || 1, this._draggable = e1?.draggable || !1, this._clickTolerance = e1?.clickTolerance || 0, this._subpixelPositioning = e1?.subpixelPositioning || !1, this._isDragging = !1, this._state = `inactive`, this._rotation = e1?.rotation || 0, this._rotationAlignment = e1?.rotationAlignment || `auto`, this._pitchAlignment = e1?.pitchAlignment && e1.pitchAlignment !== `auto` ? e1.pitchAlignment : this._rotationAlignment, this.setOpacity(e1?.opacity, e1?.opacityWhenCovered), e1?.element) this._element = e1.element, this._offset = (0, $caapT.ji).convert(e1?.offset || [
            0,
            0
        ]);
        else {
            this._defaultMarker = !0, this._element = $902e455d852cdfb8$var$W.create(`div`);
            let t = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `svg`);
            t.setAttributeNS(null, `display`, `block`), t.setAttributeNS(null, `height`, `41px`), t.setAttributeNS(null, `width`, `27px`), t.setAttributeNS(null, `viewBox`, `0 0 27 41`);
            let n = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `g`);
            n.setAttributeNS(null, `stroke`, `none`), n.setAttributeNS(null, `stroke-width`, `1`), n.setAttributeNS(null, `fill`, `none`), n.setAttributeNS(null, `fill-rule`, `evenodd`);
            let r = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `g`);
            r.setAttributeNS(null, `fill-rule`, `nonzero`);
            let i = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `g`);
            i.setAttributeNS(null, `transform`, `translate(3.0, 29.0)`), i.setAttributeNS(null, `fill`, `#000000`);
            for (let e1 of [
                {
                    rx: `10.5`,
                    ry: `5.25002273`
                },
                {
                    rx: `10.5`,
                    ry: `5.25002273`
                },
                {
                    rx: `9.5`,
                    ry: `4.77275007`
                },
                {
                    rx: `8.5`,
                    ry: `4.29549936`
                },
                {
                    rx: `7.5`,
                    ry: `3.81822308`
                },
                {
                    rx: `6.5`,
                    ry: `3.34094679`
                },
                {
                    rx: `5.5`,
                    ry: `2.86367051`
                },
                {
                    rx: `4.5`,
                    ry: `2.38636864`
                }
            ]){
                let t = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `ellipse`);
                t.setAttributeNS(null, `opacity`, `0.04`), t.setAttributeNS(null, `cx`, `10.5`), t.setAttributeNS(null, `cy`, `5.80029008`), t.setAttributeNS(null, `rx`, e1.rx), t.setAttributeNS(null, `ry`, e1.ry), i.appendChild(t);
            }
            let a = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `g`);
            a.setAttributeNS(null, `fill`, this._color);
            let o = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `path`);
            o.setAttributeNS(null, `d`, `M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z`), a.appendChild(o);
            let s = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `g`);
            s.setAttributeNS(null, `opacity`, `0.25`), s.setAttributeNS(null, `fill`, `#000000`);
            let c = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `path`);
            c.setAttributeNS(null, `d`, `M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z`), s.appendChild(c);
            let l = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `g`);
            l.setAttributeNS(null, `transform`, `translate(6.0, 7.0)`), l.setAttributeNS(null, `fill`, `#FFFFFF`);
            let u = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `g`);
            u.setAttributeNS(null, `transform`, `translate(8.0, 8.0)`);
            let d = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `circle`);
            d.setAttributeNS(null, `fill`, `#000000`), d.setAttributeNS(null, `opacity`, `0.25`), d.setAttributeNS(null, `cx`, `5.5`), d.setAttributeNS(null, `cy`, `5.5`), d.setAttributeNS(null, `r`, `5.4999962`);
            let f = $902e455d852cdfb8$var$W.createNS(`http://www.w3.org/2000/svg`, `circle`);
            f.setAttributeNS(null, `fill`, `#FFFFFF`), f.setAttributeNS(null, `cx`, `5.5`), f.setAttributeNS(null, `cy`, `5.5`), f.setAttributeNS(null, `r`, `5.4999962`), u.appendChild(d), u.appendChild(f), r.appendChild(i), r.appendChild(a), r.appendChild(s), r.appendChild(l), r.appendChild(u), t.appendChild(r), t.setAttributeNS(null, `height`, `${41 * this._scale}px`), t.setAttributeNS(null, `width`, `${27 * this._scale}px`), this._element.appendChild(t), this._offset = (0, $caapT.ji).convert(e1?.offset || [
                0,
                -14
            ]);
        }
        if (this._element.classList.add(`maplibregl-marker`), this._element.addEventListener(`dragstart`, (e1)=>{
            e1.preventDefault();
        }), this._element.addEventListener(`mousedown`, (e1)=>{
            e1.preventDefault();
        }), $902e455d852cdfb8$var$Dp(this._element, this._anchor, `marker`), e1?.className) for (let t of e1.className.split(` `))this._element.classList.add(t);
        this._popup = null;
    }
    addTo(e1) {
        return this.remove(), this._map = e1, this._element.hasAttribute(`aria-label`) || this._element.setAttribute(`aria-label`, e1._getUIString(`Marker.Title`)), this._element.hasAttribute(`role`) || this._element.setAttribute(`role`, `button`), e1.getCanvasContainer().appendChild(this._element), e1.on(`move`, this._update), e1.on(`moveend`, this._update), e1.on(`terrain`, this._update), e1.on(`projectiontransition`, this._update), this._element.addEventListener(`click`, this._onClick), this.setDraggable(this._draggable), this._update(), this._map.on(`click`, this._onMapClick), this;
    }
    remove() {
        return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off(`click`, this._onMapClick), this._map.off(`move`, this._update), this._map.off(`moveend`, this._update), this._map.off(`terrain`, this._update), this._map.off(`projectiontransition`, this._update), this._map.off(`mousedown`, this._addDragHandler), this._map.off(`touchstart`, this._addDragHandler), this._map.off(`mouseup`, this._onUp), this._map.off(`touchend`, this._onUp), this._map.off(`mousemove`, this._onMove), this._map.off(`touchmove`, this._onMove), delete this._map), this._element.removeEventListener(`click`, this._onClick), this._element.remove(), this._popup && this._popup.remove(), this;
    }
    getLngLat() {
        return this._lngLat;
    }
    setLngLat(e1) {
        return this._lngLat = (0, $caapT.k).convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
    }
    getElement() {
        return this._element;
    }
    setPopup(e1) {
        if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener(`keypress`, this._onKeyPress), this._originalTabIndex || this._element.removeAttribute(`tabindex`)), e1) {
            if (!(`offset` in e1.options)) {
                let t = 38.1, n = 13.5, r = 13.5 / Math.SQRT2;
                e1.options.offset = this._defaultMarker ? {
                    top: [
                        0,
                        0
                    ],
                    "top-left": [
                        0,
                        0
                    ],
                    "top-right": [
                        0,
                        0
                    ],
                    bottom: [
                        0,
                        -38.1
                    ],
                    "bottom-left": [
                        r,
                        (t - n + r) * -1
                    ],
                    "bottom-right": [
                        -r,
                        (t - n + r) * -1
                    ],
                    left: [
                        n,
                        (t - n) * -1
                    ],
                    right: [
                        -13.5,
                        (t - n) * -1
                    ]
                } : this._offset;
            }
            this._popup = e1, this._originalTabIndex = this._element.getAttribute(`tabindex`), this._originalTabIndex || this._element.setAttribute(`tabindex`, `0`), this._element.addEventListener(`keypress`, this._onKeyPress);
        }
        return this;
    }
    setSubpixelPositioning(e1) {
        return this._subpixelPositioning = e1, this;
    }
    getPopup() {
        return this._popup;
    }
    togglePopup() {
        let e1 = this._popup;
        if (this._element.style.opacity === this._opacityWhenCovered) return this;
        if (e1) e1.isOpen() ? e1.remove() : (e1.setLngLat(this._lngLat), e1.addTo(this._map));
        else return this;
        return this;
    }
    _updateOpacity(e1 = !1) {
        let t = this._map?.terrain, n = this._map._camera.transform.isLocationOccluded(this._lngLat);
        if (!t || n) {
            let e1 = n ? this._opacityWhenCovered : this._opacity;
            this._element.style.opacity !== e1 && (this._element.style.opacity = e1, this._element.classList.toggle(`maplibregl-marker-covered`, n));
            return;
        }
        if (e1) this._opacityTimeout = null;
        else {
            if (this._opacityTimeout) return;
            this._opacityTimeout = setTimeout(()=>{
                this._opacityTimeout = null;
            }, 100);
        }
        let r = this._map, i = r.terrain.depthAtPoint(this._pos), a = r.terrain.getElevationForLngLat(this._lngLat, r._camera.transform), o = r._camera.transform.lngLatToCameraDepth(this._lngLat, a), s = .006;
        if (o - i < s) {
            this._element.style.opacity = this._opacity, this._element.classList.remove(`maplibregl-marker-covered`);
            return;
        }
        let c = -this._offset.y / r._camera.transform.pixelsPerMeter, l = Math.sin(r.getPitch() * Math.PI / 180) * c, u = r.terrain.depthAtPoint(new (0, $caapT.ji)(this._pos.x, this._pos.y - this._offset.y)), d = r._camera.transform.lngLatToCameraDepth(this._lngLat, a + l) - u > s;
        this._popup?.isOpen() && d && this._popup.remove(), this._element.style.opacity = d ? this._opacityWhenCovered : this._opacity, this._element.classList.toggle(`maplibregl-marker-covered`, d);
    }
    getOffset() {
        return this._offset;
    }
    setOffset(e1) {
        return this._offset = (0, $caapT.ji).convert(e1), this._update(), this;
    }
    addClassName(e1) {
        this._element.classList.add(e1);
    }
    removeClassName(e1) {
        this._element.classList.remove(e1);
    }
    toggleClassName(e1) {
        return this._element.classList.toggle(e1);
    }
    setDraggable(e1) {
        return this._draggable = !!e1, this._map && (e1 ? (this._map.on(`mousedown`, this._addDragHandler), this._map.on(`touchstart`, this._addDragHandler)) : (this._map.off(`mousedown`, this._addDragHandler), this._map.off(`touchstart`, this._addDragHandler))), this;
    }
    isDraggable() {
        return this._draggable;
    }
    setRotation(e1) {
        return this._rotation = e1 || 0, this._update(), this;
    }
    getRotation() {
        return this._rotation;
    }
    setRotationAlignment(e1) {
        return this._rotationAlignment = e1 || `auto`, this._update(), this;
    }
    getRotationAlignment() {
        return this._rotationAlignment;
    }
    setPitchAlignment(e1) {
        return this._pitchAlignment = e1 && e1 !== `auto` ? e1 : this._rotationAlignment, this._update(), this;
    }
    getPitchAlignment() {
        return this._pitchAlignment;
    }
    setOpacity(e1, t) {
        return (this._opacity === void 0 || e1 === void 0 && t === void 0) && (this._opacity = `1`, this._opacityWhenCovered = `0.2`), e1 !== void 0 && (this._opacity = String(e1)), t !== void 0 && (this._opacityWhenCovered = String(t)), this._map && this._updateOpacity(!0), this;
    }
};
const $902e455d852cdfb8$var$jp = {
    positionOptions: {
        enableHighAccuracy: !1,
        maximumAge: 0,
        timeout: 6e3
    },
    fitBoundsOptions: {
        maxZoom: 15
    },
    trackUserLocation: !1,
    showAccuracyCircle: !0,
    showUserLocation: !0
};
let $902e455d852cdfb8$var$Mp = 0, $902e455d852cdfb8$var$Np = !1;
var $902e455d852cdfb8$export$caf365a3870a7616 = class extends (0, $caapT.pn) {
}, $902e455d852cdfb8$export$d3cbd8e3df821073 = class extends (0, $caapT.pn) {
}, $902e455d852cdfb8$export$319ba8bf7a75a42a = class extends (0, $caapT.pn) {
}, $902e455d852cdfb8$export$15e4ff48f7e9d8e0 = class extends (0, $caapT.mn) {
    constructor(e1){
        super(), this._onSuccess = (e1)=>{
            if (this._map) {
                if (this._isOutOfMapMaxBounds(e1)) {
                    this._setErrorState(), this.fire(new $902e455d852cdfb8$export$d3cbd8e3df821073(`outofmaxbounds`, e1)), this._updateMarker(), this._finish();
                    return;
                }
                if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                    case `WAITING_ACTIVE`:
                    case `ACTIVE_LOCK`:
                    case `ACTIVE_ERROR`:
                        this._watchState = `ACTIVE_LOCK`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active`);
                        break;
                    case `BACKGROUND`:
                    case `BACKGROUND_ERROR`:
                        this._watchState = `BACKGROUND`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-background`);
                        break;
                    default:
                        throw Error(`Unexpected watchState ${this._watchState}`);
                }
                this.options.showUserLocation && this._watchState !== `OFF` && this._updateMarker(e1), (!this.options.trackUserLocation || this._watchState === `ACTIVE_LOCK`) && this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove(`maplibregl-user-location-dot-stale`), this.fire(new $902e455d852cdfb8$export$d3cbd8e3df821073(`geolocate`, e1)), this._finish();
            }
        }, this._updateCamera = (e1)=>{
            let t = new (0, $caapT.k)(e1.coords.longitude, e1.coords.latitude), n = e1.coords.accuracy, r = (0, $caapT.Zn)({
                bearing: this._map.getBearing()
            }, this.options.fitBoundsOptions), i = $902e455d852cdfb8$export$266d2884f61535d3.fromLngLat(t, n);
            this._map.fitBounds(i, r, {
                geolocateSource: !0
            });
        }, this._updateMarker = (e1)=>{
            if (e1) {
                let t = new (0, $caapT.k)(e1.coords.longitude, e1.coords.latitude);
                this._accuracyCircleMarker.setLngLat(t).addTo(this._map), this._userLocationDotMarker.setLngLat(t).addTo(this._map), this._accuracy = e1.coords.accuracy, this._updateCircleRadiusIfNeeded();
            } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
        }, this._onUpdate = ()=>{
            this._updateCircleRadiusIfNeeded();
        }, this._onError = (e1)=>{
            if (this._map) {
                if (e1.code === 1) {
                    this._watchState = `OFF`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background-error`), this._geolocateButton.disabled = !0;
                    let e1 = this._map._getUIString(`GeolocateControl.LocationNotAvailable`);
                    this._geolocateButton.title = e1, this._geolocateButton.setAttribute(`aria-label`, e1), this._geolocationWatchID !== void 0 && this._clearWatch();
                } else if (e1.code === 3 && $902e455d852cdfb8$var$Np) return;
                else this._setErrorState();
                this._watchState !== `OFF` && this.options.showUserLocation && this._dotElement.classList.add(`maplibregl-user-location-dot-stale`), this.fire(new $902e455d852cdfb8$export$319ba8bf7a75a42a(`error`, e1)), this._finish();
            }
        }, this._finish = ()=>{
            this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
        }, this._onMoveStart = (e1)=>{
            if (!this._map) return;
            let t = e1?.[0] instanceof ResizeObserverEntry;
            !e1.geolocateSource && this._watchState === `ACTIVE_LOCK` && !t && !this._map.isZooming() && (this._watchState = `BACKGROUND`, this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this.fire(new $902e455d852cdfb8$export$caf365a3870a7616(`trackuserlocationend`)), this.fire(new $902e455d852cdfb8$export$caf365a3870a7616(`userlocationlostfocus`)));
        }, this._setupUI = ()=>{
            this._map && (this._container.addEventListener(`contextmenu`, (e1)=>{
                e1.preventDefault();
            }), this._geolocateButton = $902e455d852cdfb8$var$W.create(`button`, `maplibregl-ctrl-geolocate`, this._container), $902e455d852cdfb8$var$W.create(`span`, `maplibregl-ctrl-icon`, this._geolocateButton).setAttribute(`aria-hidden`, `true`), this._geolocateButton.type = `button`, this._geolocateButton.disabled = !0);
        }, this._finishSetupUI = (e1)=>{
            if (this._map) {
                if (e1 === !1) {
                    (0, $caapT.Ar)(`Geolocation support is not available so the GeolocateControl will be disabled.`);
                    let e1 = this._map._getUIString(`GeolocateControl.LocationNotAvailable`);
                    this._geolocateButton.disabled = !0, this._geolocateButton.title = e1, this._geolocateButton.setAttribute(`aria-label`, e1);
                } else {
                    let e1 = this._map._getUIString(`GeolocateControl.FindMyLocation`);
                    this._geolocateButton.disabled = !1, this._geolocateButton.title = e1, this._geolocateButton.setAttribute(`aria-label`, e1);
                }
                this.options.trackUserLocation && (this._geolocateButton.setAttribute(`aria-pressed`, `false`), this._watchState = `OFF`), this.options.showUserLocation && (this._dotElement = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-user-location-dot`), this._userLocationDotMarker = new $902e455d852cdfb8$export$e98856a975cab58e({
                    element: this._dotElement
                }), this._circleElement = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-user-location-accuracy-circle`), this._accuracyCircleMarker = new $902e455d852cdfb8$export$e98856a975cab58e({
                    element: this._circleElement,
                    pitchAlignment: `map`
                }), this.options.trackUserLocation && (this._watchState = `OFF`), this._map.on(`zoom`, this._onUpdate), this._map.on(`move`, this._onUpdate), this._map.on(`rotate`, this._onUpdate), this._map.on(`pitch`, this._onUpdate)), this._geolocateButton.addEventListener(`click`, ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on(`movestart`, this._onMoveStart);
            }
        }, this.options = (0, $caapT.Zn)({}, $902e455d852cdfb8$var$jp, e1);
    }
    onAdd(e1) {
        return this._map = e1, this._container = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._setupUI(), $902e455d852cdfb8$var$wp().then((e1)=>this._finishSetupUI(e1)), this._container;
    }
    onRemove() {
        this._geolocationWatchID !== void 0 && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off(`movestart`, this._onMoveStart), this._map.off(`zoom`, this._onUpdate), this._map.off(`move`, this._onUpdate), this._map.off(`rotate`, this._onUpdate), this._map.off(`pitch`, this._onUpdate), this._map = void 0, $902e455d852cdfb8$var$Mp = 0, $902e455d852cdfb8$var$Np = !1;
    }
    _isOutOfMapMaxBounds(e1) {
        let t = this._map.getMaxBounds(), n = e1.coords;
        return t && (n.longitude < t.getWest() || n.longitude > t.getEast() || n.latitude < t.getSouth() || n.latitude > t.getNorth());
    }
    _setErrorState() {
        switch(this._watchState){
            case `WAITING_ACTIVE`:
                this._watchState = `ACTIVE_ERROR`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active-error`);
                break;
            case `ACTIVE_LOCK`:
                this._watchState = `ACTIVE_ERROR`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`);
                break;
            case `BACKGROUND`:
                this._watchState = `BACKGROUND_ERROR`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-background-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`);
                break;
            case `ACTIVE_ERROR`:
            case `BACKGROUND_ERROR`:
                break;
            case `OFF`:
            case void 0:
                break;
            default:
                throw Error(`Unexpected watchState ${this._watchState}`);
        }
    }
    _updateCircleRadiusIfNeeded() {
        let e1 = this._userLocationDotMarker.getLngLat();
        if (!this.options.showUserLocation || !this.options.showAccuracyCircle || !this._accuracy || !e1) return;
        let t = this._map.project(e1), n = this._map.unproject([
            t.x + 100,
            t.y
        ]), r = e1.distanceTo(n) / 100, i = 2 * this._accuracy / r;
        this._circleElement.style.width = `${i.toFixed(2)}px`, this._circleElement.style.height = `${i.toFixed(2)}px`;
    }
    trigger() {
        if (!this._setup) return (0, $caapT.Ar)(`Geolocate control triggered before added to a map`), !1;
        if (this.options.trackUserLocation) {
            switch(this._watchState){
                case `OFF`:
                    this._watchState = `WAITING_ACTIVE`, this.fire(new $902e455d852cdfb8$export$caf365a3870a7616(`trackuserlocationstart`));
                    break;
                case `WAITING_ACTIVE`:
                case `ACTIVE_LOCK`:
                case `ACTIVE_ERROR`:
                case `BACKGROUND_ERROR`:
                    $902e455d852cdfb8$var$Mp--, $902e455d852cdfb8$var$Np = !1, this._watchState = `OFF`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background-error`), this.fire(new $902e455d852cdfb8$export$caf365a3870a7616(`trackuserlocationend`));
                    break;
                case `BACKGROUND`:
                    this._watchState = `ACTIVE_LOCK`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new $902e455d852cdfb8$export$caf365a3870a7616(`trackuserlocationstart`)), this.fire(new $902e455d852cdfb8$export$caf365a3870a7616(`userlocationfocus`));
                    break;
                default:
                    throw Error(`Unexpected watchState ${this._watchState}`);
            }
            switch(this._watchState){
                case `WAITING_ACTIVE`:
                    this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active`);
                    break;
                case `ACTIVE_LOCK`:
                    this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active`);
                    break;
                case `OFF`:
                    break;
                default:
                    throw Error(`Unexpected watchState ${this._watchState}`);
            }
            if (this._watchState === `OFF` && this._geolocationWatchID !== void 0) this._clearWatch();
            else if (this._geolocationWatchID === void 0) {
                this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.setAttribute(`aria-pressed`, `true`), $902e455d852cdfb8$var$Mp++;
                let e1;
                $902e455d852cdfb8$var$Mp > 1 ? (e1 = {
                    maximumAge: 6e5,
                    timeout: 0
                }, $902e455d852cdfb8$var$Np = !0) : (e1 = this.options.positionOptions, $902e455d852cdfb8$var$Np = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
            }
        } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
        return !0;
    }
    _clearWatch() {
        window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.setAttribute(`aria-pressed`, `false`), this.options.showUserLocation && this._updateMarker(null);
    }
};
const $902e455d852cdfb8$var$Rp = {
    maxWidth: 100,
    unit: `metric`
};
var $902e455d852cdfb8$export$1fb16e435eedcce9 = class {
    constructor(e1){
        this._onMove = ()=>{
            $902e455d852cdfb8$var$Bp(this._map, this._container, this.options);
        }, this.setUnit = (e1)=>{
            this.options.unit = e1, $902e455d852cdfb8$var$Bp(this._map, this._container, this.options);
        }, this.options = {
            ...$902e455d852cdfb8$var$Rp,
            ...e1
        };
    }
    getDefaultPosition() {
        return `bottom-left`;
    }
    onAdd(e1) {
        return this._map = e1, this._container = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-ctrl maplibregl-ctrl-scale`, e1.getContainer()), this._map.on(`move`, this._onMove), this._onMove(), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`move`, this._onMove), this._map = void 0;
    }
};
function $902e455d852cdfb8$var$Bp(e1, t, n) {
    let r = n?.maxWidth || 100, i = e1._container.clientHeight / 2, a = e1._container.clientWidth / 2, o = e1.unproject([
        a - r / 2,
        i
    ]), s = e1.unproject([
        a + r / 2,
        i
    ]), c = Math.round(e1.project(s).x - e1.project(o).x), l = Math.min(r, c, e1._container.clientWidth), u = o.distanceTo(s);
    if (n?.unit === `imperial`) {
        let n = 3.2808 * u;
        n > 5280 ? $902e455d852cdfb8$var$Vp(t, l, n / 5280, e1._getUIString(`ScaleControl.Miles`)) : $902e455d852cdfb8$var$Vp(t, l, n, e1._getUIString(`ScaleControl.Feet`));
    } else n?.unit === `nautical` ? $902e455d852cdfb8$var$Vp(t, l, u / 1852, e1._getUIString(`ScaleControl.NauticalMiles`)) : u >= 1e3 ? $902e455d852cdfb8$var$Vp(t, l, u / 1e3, e1._getUIString(`ScaleControl.Kilometers`)) : $902e455d852cdfb8$var$Vp(t, l, u, e1._getUIString(`ScaleControl.Meters`));
}
function $902e455d852cdfb8$var$Vp(e1, t, n, r) {
    let i = $902e455d852cdfb8$var$Up(n), a = i / n;
    e1.style.width = `${t * a}px`, e1.innerHTML = `${i}&nbsp;${r}`;
}
function $902e455d852cdfb8$var$Hp(e1) {
    let t = 10 ** Math.ceil(-Math.log(e1) / Math.LN10);
    return Math.round(e1 * t) / t;
}
function $902e455d852cdfb8$var$Up(e1) {
    let t = 10 ** (`${Math.floor(e1)}`.length - 1), n = e1 / t;
    return n = n >= 10 ? 10 : n >= 5 ? 5 : n >= 3 ? 3 : n >= 2 ? 2 : n >= 1 ? 1 : $902e455d852cdfb8$var$Hp(n), t * n;
}
var $902e455d852cdfb8$export$a2126d0731cda86b = class extends (0, $caapT.pn) {
}, $902e455d852cdfb8$export$91e8ffb52c2b32c5 = class extends (0, $caapT.mn) {
    constructor(e1 = {}){
        super(), this._onFullscreenChange = ()=>{
            let e1 = window.document.fullscreenElement || window.document.webkitFullscreenElement;
            for(; e1?.shadowRoot?.fullscreenElement;)e1 = e1.shadowRoot.fullscreenElement;
            e1 === this._container !== this._fullscreen && this._handleFullscreenChange();
        }, this._onClickFullscreen = ()=>{
            this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
        }, this._fullscreen = !1, this._pseudo = e1.pseudo ?? !1, e1?.container && (e1.container instanceof HTMLElement ? this._container = e1.container : (0, $caapT.Ar)(`Full screen control 'container' must be a DOM element.`)), `onfullscreenchange` in document ? this._fullscreenchange = `fullscreenchange` : `onmozfullscreenchange` in document ? this._fullscreenchange = `mozfullscreenchange` : `onwebkitfullscreenchange` in document ? this._fullscreenchange = `webkitfullscreenchange` : `onmsfullscreenchange` in document && (this._fullscreenchange = `MSFullscreenChange`);
    }
    onAdd(e1) {
        return this._map = e1, this._container ||= this._map.getContainer(), this._controlContainer = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._setupUI(), this._controlContainer;
    }
    onRemove() {
        this._controlContainer.remove(), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
    }
    _setupUI() {
        let e1 = this._fullscreenButton = $902e455d852cdfb8$var$W.create(`button`, `maplibregl-ctrl-fullscreen`, this._controlContainer);
        $902e455d852cdfb8$var$W.create(`span`, `maplibregl-ctrl-icon`, e1).setAttribute(`aria-hidden`, `true`), e1.type = `button`, this._updateTitle(), this._fullscreenButton.addEventListener(`click`, this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
    }
    _updateTitle() {
        let e1 = this._getTitle();
        this._fullscreenButton.setAttribute(`aria-label`, e1), this._fullscreenButton.title = e1;
    }
    _getTitle() {
        return this._map._getUIString(this._isFullscreen() ? `FullscreenControl.Exit` : `FullscreenControl.Enter`);
    }
    _isFullscreen() {
        return this._fullscreen;
    }
    _handleFullscreenChange() {
        this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle(`maplibregl-ctrl-shrink`), this._fullscreenButton.classList.toggle(`maplibregl-ctrl-fullscreen`), this._updateTitle(), this._fullscreen ? (this.fire(new $902e455d852cdfb8$export$a2126d0731cda86b(`fullscreenstart`)), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new $902e455d852cdfb8$export$a2126d0731cda86b(`fullscreenend`)), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
    }
    _exitFullscreen() {
        this._pseudo ? this._togglePseudoFullScreen() : window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
    }
    _requestFullscreen() {
        this._pseudo ? this._togglePseudoFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
    }
    _togglePseudoFullScreen() {
        this._container.classList.toggle(`maplibregl-pseudo-fullscreen`), this._handleFullscreenChange(), this._map.resize();
    }
}, $902e455d852cdfb8$export$cc733900d53f94f9 = class {
    constructor(e1){
        this._toggleTerrain = ()=>{
            this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
        }, this._updateTerrainIcon = ()=>{
            this._terrainButton.classList.remove(`maplibregl-ctrl-terrain`), this._terrainButton.classList.remove(`maplibregl-ctrl-terrain-enabled`), this._map.terrain ? (this._terrainButton.classList.add(`maplibregl-ctrl-terrain-enabled`), this._terrainButton.title = this._map._getUIString(`TerrainControl.Disable`)) : (this._terrainButton.classList.add(`maplibregl-ctrl-terrain`), this._terrainButton.title = this._map._getUIString(`TerrainControl.Enable`));
        }, this.options = e1;
    }
    onAdd(e1) {
        return this._map = e1, this._container = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._terrainButton = $902e455d852cdfb8$var$W.create(`button`, `maplibregl-ctrl-terrain`, this._container), $902e455d852cdfb8$var$W.create(`span`, `maplibregl-ctrl-icon`, this._terrainButton).setAttribute(`aria-hidden`, `true`), this._terrainButton.type = `button`, this._terrainButton.addEventListener(`click`, this._toggleTerrain), this._updateTerrainIcon(), this._map.on(`terrain`, this._updateTerrainIcon), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`terrain`, this._updateTerrainIcon), this._map = void 0;
    }
}, $902e455d852cdfb8$export$9618410ded3c9550 = class {
    constructor(){
        this._toggleProjection = ()=>{
            let e1 = this._map.getProjection()?.type;
            e1 === `mercator` || !e1 ? this._map.setProjection({
                type: `globe`
            }) : this._map.setProjection({
                type: `mercator`
            }), this._updateGlobeIcon();
        }, this._updateGlobeIcon = ()=>{
            this._globeButton.classList.remove(`maplibregl-ctrl-globe`), this._globeButton.classList.remove(`maplibregl-ctrl-globe-enabled`), this._map.getProjection()?.type === `globe` ? (this._globeButton.classList.add(`maplibregl-ctrl-globe-enabled`), this._globeButton.title = this._map._getUIString(`GlobeControl.Disable`)) : (this._globeButton.classList.add(`maplibregl-ctrl-globe`), this._globeButton.title = this._map._getUIString(`GlobeControl.Enable`));
        };
    }
    onAdd(e1) {
        return this._map = e1, this._container = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._globeButton = $902e455d852cdfb8$var$W.create(`button`, `maplibregl-ctrl-globe`, this._container), $902e455d852cdfb8$var$W.create(`span`, `maplibregl-ctrl-icon`, this._globeButton).setAttribute(`aria-hidden`, `true`), this._globeButton.type = `button`, this._globeButton.addEventListener(`click`, this._toggleProjection), this._updateGlobeIcon(), this._map.on(`styledata`, this._updateGlobeIcon), this._map.on(`projectiontransition`, this._updateGlobeIcon), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`styledata`, this._updateGlobeIcon), this._map.off(`projectiontransition`, this._updateGlobeIcon), this._globeButton.removeEventListener(`click`, this._toggleProjection), this._map = void 0;
    }
};
const $902e455d852cdfb8$var$Jp = {
    closeButton: !0,
    closeOnClick: !0,
    focusAfterOpen: !0,
    className: ``,
    maxWidth: `240px`,
    subpixelPositioning: !1,
    locationOccludedOpacity: void 0,
    padding: void 0
}, $902e455d852cdfb8$var$Yp = [
    `a[href]`,
    `[tabindex]:not([tabindex='-1'])`,
    `[contenteditable]:not([contenteditable='false'])`,
    `button:not([disabled])`,
    `input:not([disabled])`,
    `select:not([disabled])`,
    `textarea:not([disabled])`
].join(`, `);
var $902e455d852cdfb8$export$c09aca14b6b2f8f0 = class extends (0, $caapT.pn) {
}, $902e455d852cdfb8$export$129a32eedafa97c5 = class extends (0, $caapT.mn) {
    constructor(e1){
        super(), this._updateOpacity = ()=>{
            this.options.locationOccludedOpacity !== void 0 && (this._map._camera.transform.isLocationOccluded(this.getLngLat()) ? this._container.style.opacity = `${this.options.locationOccludedOpacity}` : this._container.style.opacity = ``);
        }, this.remove = ()=>(this._content && this._content.remove(), this._container && (this._container.remove(), delete this._container), this._map && (this._map.off(`move`, this._update), this._map.off(`move`, this._onClose), this._map.off(`click`, this._onClose), this._map.off(`remove`, this.remove), this._map.off(`terrain`, this._update), this._map.off(`projectiontransition`, this._update), this._map.off(`mousemove`, this._update), this._map.off(`mouseup`, this._update), this._map.off(`drag`, this._update), this._map._canvasContainer.classList.remove(`maplibregl-track-pointer`), delete this._map, this.fire(new $902e455d852cdfb8$export$c09aca14b6b2f8f0(`close`))), this), this._update = (e1)=>{
            let t = this._lngLat || this._trackPointer;
            if (!this._map || !t || !this._content) return;
            if (!this._container) {
                if (this._container = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-popup`, this._map.getContainer()), this._tip = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-popup-tip`, this._container), this._container.appendChild(this._content), this.options.className) for (let e1 of this.options.className.split(` `))this._container.classList.add(e1);
                this._closeButton && this._closeButton.setAttribute(`aria-label`, this._map._getUIString(`Popup.Close`)), this._trackPointer && this._container.classList.add(`maplibregl-popup-track-pointer`);
            }
            this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = $902e455d852cdfb8$var$Tp(this._lngLat, this._flatPos, this._map._camera.transform, this._trackPointer);
            let n;
            if (e1 && `point` in e1 && e1.point && (n = e1.point), this._trackPointer && !n) return;
            let r = this._flatPos = this._pos = this._trackPointer && n ? n : this._map.project(this._lngLat);
            this._map.terrain && (this._flatPos = this._trackPointer && n ? n : this._map._camera.transform.locationToScreenPoint(this._lngLat));
            let i = this.options.anchor, a = $902e455d852cdfb8$var$Qp(this.options.offset);
            if (!i) {
                let e1 = this._container.offsetWidth, t = this._container.offsetHeight, n = $902e455d852cdfb8$var$$p(this.options.padding), o;
                o = r.y + a.bottom.y < t + n.top ? [
                    `top`
                ] : r.y > this._map._camera.transform.height - t - n.bottom ? [
                    `bottom`
                ] : [], r.x < e1 / 2 + n.left ? o.push(`left`) : r.x > this._map._camera.transform.width - e1 / 2 - n.right && o.push(`right`), i = o.length === 0 ? `bottom` : o.join(`-`);
            }
            let o = r.add(a[i]);
            this.options.subpixelPositioning || (o = o.round()), this._container.style.transform = `${$902e455d852cdfb8$var$Ep[i]} translate(${o.x}px,${o.y}px)`, $902e455d852cdfb8$var$Dp(this._container, i, `popup`), this._updateOpacity();
        }, this._onClose = ()=>{
            this.remove();
        }, this.options = (0, $caapT.Zn)(Object.create($902e455d852cdfb8$var$Jp), e1);
    }
    addTo(e1) {
        return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on(`click`, this._onClose), this.options.closeOnMove && this._map.on(`move`, this._onClose), this._map.on(`remove`, this.remove), this._map.on(`terrain`, this._update), this._map.on(`projectiontransition`, this._update), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on(`mousemove`, this._update), this._map.on(`mouseup`, this._update), this._container && this._container.classList.add(`maplibregl-popup-track-pointer`), this._map._canvasContainer.classList.add(`maplibregl-track-pointer`)) : this._map.on(`move`, this._update), this.fire(new $902e455d852cdfb8$export$c09aca14b6b2f8f0(`open`)), this;
    }
    isOpen() {
        return !!this._map;
    }
    getLngLat() {
        return this._lngLat;
    }
    setLngLat(e1) {
        return this._lngLat = (0, $caapT.k).convert(e1), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on(`move`, this._update), this._map.off(`mousemove`, this._update), this._container && this._container.classList.remove(`maplibregl-popup-track-pointer`), this._map._canvasContainer.classList.remove(`maplibregl-track-pointer`)), this;
    }
    trackPointer() {
        return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off(`move`, this._update), this._map.on(`mousemove`, this._update), this._map.on(`drag`, this._update), this._container && this._container.classList.add(`maplibregl-popup-track-pointer`), this._map._canvasContainer.classList.add(`maplibregl-track-pointer`)), this;
    }
    getElement() {
        return this._container;
    }
    setText(e1) {
        return this.setDOMContent(document.createTextNode(e1));
    }
    setHTML(e1) {
        let t = document.createDocumentFragment(), n = document.createElement(`body`), r;
        for(n.innerHTML = e1; r = n.firstChild, r;)t.appendChild(r);
        return this.setDOMContent(t);
    }
    getMaxWidth() {
        return this._container?.style.maxWidth;
    }
    setMaxWidth(e1) {
        return this.options.maxWidth = e1, this._update(), this;
    }
    setDOMContent(e1) {
        if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
        else this._content = $902e455d852cdfb8$var$W.create(`div`, `maplibregl-popup-content`, this._container);
        return this._content.appendChild(e1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
    }
    addClassName(e1) {
        return this._container && this._container.classList.add(e1), this;
    }
    removeClassName(e1) {
        return this._container && this._container.classList.remove(e1), this;
    }
    setOffset(e1) {
        return this.options.offset = e1, this._update(), this;
    }
    toggleClassName(e1) {
        if (this._container) return this._container.classList.toggle(e1);
    }
    setSubpixelPositioning(e1) {
        this.options.subpixelPositioning = e1;
    }
    setPadding(e1) {
        this.options.padding = e1, this._update();
    }
    _createCloseButton() {
        this.options.closeButton && (this._closeButton = $902e455d852cdfb8$var$W.create(`button`, `maplibregl-popup-close-button`, this._content), this._closeButton.type = `button`, this._closeButton.innerHTML = `&#215;`, this._closeButton.addEventListener(`click`, this._onClose));
    }
    _focusFirstElement() {
        if (!this.options.focusAfterOpen || !this._container) return;
        let e1 = this._container.querySelector($902e455d852cdfb8$var$Yp);
        e1 && e1.focus();
    }
};
function $902e455d852cdfb8$var$Qp(e1) {
    if (!e1) return $902e455d852cdfb8$var$Qp(new (0, $caapT.ji)(0, 0));
    if (typeof e1 == `number`) {
        let t = Math.round(Math.abs(e1) / Math.SQRT2);
        return {
            center: new (0, $caapT.ji)(0, 0),
            top: new (0, $caapT.ji)(0, e1),
            "top-left": new (0, $caapT.ji)(t, t),
            "top-right": new (0, $caapT.ji)(-t, t),
            bottom: new (0, $caapT.ji)(0, -e1),
            "bottom-left": new (0, $caapT.ji)(t, -t),
            "bottom-right": new (0, $caapT.ji)(-t, -t),
            left: new (0, $caapT.ji)(e1, 0),
            right: new (0, $caapT.ji)(-e1, 0)
        };
    } else if (e1 instanceof (0, $caapT.ji) || Array.isArray(e1)) {
        let t = (0, $caapT.ji).convert(e1);
        return {
            center: t,
            top: t,
            "top-left": t,
            "top-right": t,
            bottom: t,
            "bottom-left": t,
            "bottom-right": t,
            left: t,
            right: t
        };
    } else return {
        center: (0, $caapT.ji).convert(e1.center || [
            0,
            0
        ]),
        top: (0, $caapT.ji).convert(e1.top || [
            0,
            0
        ]),
        "top-left": (0, $caapT.ji).convert(e1[`top-left`] || [
            0,
            0
        ]),
        "top-right": (0, $caapT.ji).convert(e1[`top-right`] || [
            0,
            0
        ]),
        bottom: (0, $caapT.ji).convert(e1.bottom || [
            0,
            0
        ]),
        "bottom-left": (0, $caapT.ji).convert(e1[`bottom-left`] || [
            0,
            0
        ]),
        "bottom-right": (0, $caapT.ji).convert(e1[`bottom-right`] || [
            0,
            0
        ]),
        left: (0, $caapT.ji).convert(e1.left || [
            0,
            0
        ]),
        right: (0, $caapT.ji).convert(e1.right || [
            0,
            0
        ])
    };
}
function $902e455d852cdfb8$var$$p(e1) {
    return e1 ? {
        top: e1.top ?? 0,
        right: e1.right ?? 0,
        bottom: e1.bottom ?? 0,
        left: e1.left ?? 0
    } : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
const $902e455d852cdfb8$var$em = $902e455d852cdfb8$var$br;
function $902e455d852cdfb8$export$80220802faa18fec(e1, t) {
    return $902e455d852cdfb8$var$va().setRTLTextPlugin(e1, t);
}
function $902e455d852cdfb8$export$c8f205afdabdaef4() {
    return $902e455d852cdfb8$var$va().getRTLTextPluginStatus();
}
function $902e455d852cdfb8$export$c506eb22e615ba4a() {
    return $902e455d852cdfb8$var$em;
}
function $902e455d852cdfb8$export$33e4148f0a10446f() {
    return $902e455d852cdfb8$var$vi.workerCount;
}
function $902e455d852cdfb8$export$ec8b1053ddd7f5bc(e1) {
    $902e455d852cdfb8$var$vi.workerCount = e1;
}
function $902e455d852cdfb8$export$8ac2684f98a393b0() {
    return (0, $caapT.En).MAX_PARALLEL_IMAGE_REQUESTS;
}
function $902e455d852cdfb8$export$9569597edc1f5cf3(e1) {
    (0, $caapT.En).MAX_PARALLEL_IMAGE_REQUESTS = e1;
}
function $902e455d852cdfb8$export$b01b5f33620cab52() {
    return (0, $caapT.En).WORKER_URL;
}
function $902e455d852cdfb8$export$f7f2857281fba5f0(e1) {
    (0, $caapT.En).WORKER_URL = e1;
}
async function $902e455d852cdfb8$export$9cdc513767f0ece9(e1) {
    await $902e455d852cdfb8$export$6f0c702cbe7d6ed8().broadcast(`IS`, e1);
}



var $eebadfeff4aeb973$exports = {};
$eebadfeff4aeb973$exports = JSON.parse("{\"version\":8,\"name\":\"NLS Basemap\",\"center\":[21.645,63.101],\"zoom\":11.35,\"sources\":{\"taustakartta\":{\"type\":\"vector\",\"url\":\"https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/tilejson/taustakartta/1.0.0/taustakartta/default/v21/WGS84_Pseudo-Mercator/tilejson.json?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2\"}},\"glyphs\":\"https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/glyphs/{fontstack}/{range}.pbf?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2\",\"layers\":[{\"id\":\"background\",\"type\":\"background\",\"paint\":{\"background-color\":\"#ffffff\"}},{\"id\":\"maasto_alue\",\"type\":\"fill\",\"source\":\"taustakartta\",\"source-layer\":\"maasto_alue\",\"filter\":[\"match\",[\"get\",\"kohdeluokka\"],[35411,35412,35421,35422,34300,34100,34700,38300,38700,39110,39120,39130,33000,38400,35401,35402],true,false],\"paint\":{\"fill-color\":[\"match\",[\"get\",\"kohdeluokka\"],[35421,35422,35401],\"hsla(200, 80%, 90%, 0.7)\",[34700,38600],\"hsla(208, 11%, 75%, 0.76)\",[38300,38700],\"hsl(207, 100%, 94%)\",[39120],\"hsla(44, 100%, 83%, 0.84)\",\"hsla(360, 100%, 100%, 0)\"]}},{\"id\":\"taajamaalue\",\"type\":\"fill\",\"source\":\"taustakartta\",\"source-layer\":\"maankaytto\",\"minzoom\":6,\"maxzoom\":13,\"filter\":[\"==\",\"kohdeluokka\",40200],\"paint\":{\"fill-color\":\"rgba(220,199,199,0.4)\"}},{\"id\":\"maankaytto\",\"type\":\"fill\",\"source\":\"taustakartta\",\"source-layer\":\"maankaytto\",\"filter\":[\"match\",[\"get\",\"kohdeluokka\"],[32611,32200,32612,32800,32900,33100,34300],true,false],\"paint\":{\"fill-color\":[\"match\",[\"get\",\"kohdeluokka\"],32611,\"#fffcd6\",32200,\"#eef6e0\",32612,\"#eef6e0\",32900,\"#eef6e0\",33100,\"#EEF6E0\",34300,\"#fffcf0\",32800,\"#fffceb\",\"hsla(360, 100%, 100%, 0)\"]}},{\"id\":\"lentokentta_alue\",\"type\":\"fill\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"Polygon\"],[\"match\",[\"get\",\"kohdeluokka\"],[32411,32412,32413,32414,32415,32416,32417,32418,32441,32442],true,false]],\"layout\":{},\"paint\":{\"fill-color\":[\"match\",[\"get\",\"kohdeluokka\"],[32411,23412],\"#fde9db\",[32413,32415,32416,32441,32442],\"#f7f7f3\",[32414,32417,32418],\"#fffcf4\",\"hsl(0,0%,80%)\"],\"fill-outline-color\":[\"match\",[\"get\",\"kohdeluokka\"],[32441,32442],\"#c8c4c5\",\"hsla(360, 100%, 100%, 0)\"]}},{\"id\":\"lentokentta_viiva\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"any\",[\"==\",\"kohdeluokka\",32431],[\"==\",\"kohdeluokka\",32432]],\"paint\":{\"line-width\":7,\"line-color\":\"#c8c4c5\"}},{\"id\":\"lentokentta_viiva2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"any\",[\"==\",\"kohdeluokka\",32431],[\"==\",\"kohdeluokka\",32432]],\"paint\":{\"line-width\":6,\"line-color\":\"#fde9db\"}},{\"id\":\"vesisto_alue_reuna\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"vesisto_alue\",\"paint\":{\"line-color\":\"#9ec9e8\",\"line-width\":0.5}},{\"id\":\"vesisto_alue\",\"type\":\"fill\",\"source\":\"taustakartta\",\"source-layer\":\"vesisto_alue\",\"paint\":{\"fill-color\":\"#caedfb\"}},{\"id\":\"maastoaluereuna\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"maastoaluereuna\",\"filter\":[\"all\",[\"in\",\"kartografinenluokka\",32200,32300,32411,32412,32413,32414,32415,32416,32417,32418,33100],[\"==\",\"kohdeluokka\",30211]],\"paint\":{\"line-color\":\"#c8c4c5\",\"line-width\":0.5}},{\"id\":\"keinotekoinen_rantaviiva\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"maastoaluereuna\",\"filter\":[\"==\",\"kohdeluokka\",30100],\"paint\":{\"line-color\":\"#c8c4c5\",\"line-width\":0.5}},{\"id\":\"vesisto_viiva\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"vesisto_viiva\",\"paint\":{\"line-color\":\"#caedfb\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.75,20,30]}},{\"id\":\"rakennus\",\"type\":\"fill\",\"source\":\"taustakartta\",\"source-layer\":\"rakennus\",\"paint\":{\"fill-color\":\"#e6e6e6\",\"fill-outline-color\":\"#adb0b3\"}},{\"id\":\"tiet tunnelissa\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141,12132,12131,12122,12121,12112,12111,12313,12314,12136],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-11],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[32,16],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajotie, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"lautta ja lossi\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12151,12152],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[6,8],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"laiva ja venevaylat\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[16511,16512],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[6,8],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"hallintorajat\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"hallintoalue\",\"paint\":{\"line-color\":\"#8668de\",\"line-width\":1,\"line-opacity\":0.5}},{\"id\":\"rakennelmat\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"rakennelma\",\"filter\":[\"any\",[\"==\",\"kohdeluokka\",45700],[\"==\",\"kohdeluokka\",45111],[\"==\",\"kohdeluokka\",45112],[\"==\",\"kohdeluokka\",44500]],\"paint\":{\"line-color\":\"#918a8c\",\"line-width\":0.5}},{\"id\":\"tienimet\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"<\",\"tasosijainti\",1]],\"layout\":{\"text-field\":\"{nimi_suomi}        {nimi_ruotsi}\",\"text-font\":[\"Liberation Sans NLSFI\"],\"symbol-placement\":\"line\",\"text-size\":11},\"paint\":{\"text-color\":\"rgba(69, 86, 71, 1)\",\"text-halo-color\":\"#fff\",\"text-halo-width\":1,\"text-halo-blur\":1}},{\"id\":\"nimisto-maasto-vedet\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"nimisto\",\"filter\":[\"match\",[\"get\",\"teema\"],[\"Maasto\",\"Vedet\"],true,false],\"layout\":{\"text-field\":[\"coalesce\",[\"get\",\"nimi_fin\"],[\"get\",\"nimi_swe\"],[\"get\",\"nimi_sme\"],[\"get\",\"nimi_sms\"],[\"get\",\"nimi_smn\"]],\"text-font\":[\"match\",[\"get\",\"teema\"],\"Vedet\",[\"literal\",[\"Liberation Sans NLSFI Left\"]],\"Maasto\",[\"literal\",[\"Liberation Sans NLSFI Right\"]],[\"literal\",[\"Liberation Sans NLSFI\"]]],\"text-size\":[\"interpolate\",[\"linear\"],[\"zoom\"],1,[\"step\",[\"get\",\"prioriteetti\"],20,3,16],10,[\"step\",[\"get\",\"prioriteetti\"],20,4,14],16,[\"step\",[\"get\",\"prioriteetti\"],22,5,12]],\"visibility\":\"visible\"},\"paint\":{\"text-halo-width\":2,\"text-halo-color\":\"rgba(255, 255, 255, 1)\",\"text-color\":[\"match\",[\"get\",\"teema\"],\"Vedet\",\"hsl(251, 71%, 50%)\",\"hsl(0, 0%, 20%)\"],\"text-halo-blur\":1}},{\"id\":\"nimisto\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"nimisto\",\"filter\":[\"all\",[\"!\",[\"match\",[\"get\",\"teema\"],[\"Maasto\",\"Vedet\"],true,false]],[\"!=\",[\"get\",\"alaryhma\"],\"Hallintoalueet\"],[\"match\",[\"get\",\"laji\"],[\"Kansallispuisto\",\"Luonnonpuisto\"],false,true]],\"layout\":{\"text-transform\":[\"match\",[\"get\",\"alaryhma\"],\"Rautatieliikennepaikat\",\"uppercase\",\"none\"],\"text-field\":[\"coalesce\",[\"get\",\"nimi_fin\"],[\"get\",\"nimi_swe\"],[\"get\",\"nimi_sme\"],[\"get\",\"nimi_sms\"],[\"get\",\"nimi_smn\"]],\"icon-ignore-placement\":true,\"icon-allow-overlap\":true,\"text-font\":[\"Liberation Sans NLSFI\"],\"text-size\":[\"interpolate\",[\"linear\"],[\"zoom\"],1,[\"interpolate\",[\"linear\"],[\"get\",\"prioriteetti\"],1,20,3,16],10,[\"interpolate\",[\"linear\"],[\"get\",\"prioriteetti\"],5,16,7,13],14,[\"interpolate\",[\"linear\"],[\"get\",\"prioriteetti\"],5,22,10,12]],\"visibility\":\"visible\"},\"paint\":{\"text-halo-width\":2,\"text-halo-color\":\"rgba(255, 255, 255, 1)\",\"text-color\":[\"match\",[\"get\",\"teema\"],\"Vedet\",\"hsl(251, 71%, 50%)\",\"Suojellut kohteet\",\"hsl(117, 79%, 31%)\",\"hsl(0, 0%, 15%)\"],\"text-halo-blur\":1}},{\"id\":\"nimisto_luonnopuistot\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"nimisto\",\"filter\":[\"match\",[\"get\",\"laji\"],[\"Kansallispuisto\",\"Luonnonpuisto\"],true,false],\"layout\":{\"text-field\":[\"coalesce\",[\"get\",\"nimi_fin\"],[\"get\",\"nimi_swe\"],[\"get\",\"nimi_sme\"],[\"get\",\"nimi_sms\"],[\"get\",\"nimi_smn\"]],\"icon-ignore-placement\":true,\"icon-allow-overlap\":false,\"text-font\":[\"Liberation Sans NLSFI\"],\"visibility\":\"visible\"},\"paint\":{\"text-halo-width\":2,\"text-halo-color\":\"rgba(255, 255, 255, 1)\",\"text-color\":\"hsl(117, 79%, 31%)\",\"text-halo-blur\":1}},{\"id\":\"nimisto_kunnat\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"nimisto\",\"filter\":[\"all\",[\"==\",[\"get\",\"alaryhma\"],\"Hallintoalueet\"],[\"==\",[\"get\",\"laji\"],\"Kunta\"]],\"layout\":{\"text-field\":[\"coalesce\",[\"get\",\"nimi_fin\"],[\"get\",\"nimi_swe\"],[\"get\",\"nimi_sme\"],[\"get\",\"nimi_sms\"],[\"get\",\"nimi_smn\"]],\"icon-ignore-placement\":false,\"icon-allow-overlap\":false,\"text-size\":[\"interpolate\",[\"exponential\",1.35],[\"zoom\"],1,16,14,28],\"text-font\":[\"step\",[\"zoom\"],[\"literal\",[\"Liberation Sans NLSFI\"]],6,[\"literal\",[\"Liberation Sans NLSFI Bold\"]]]},\"paint\":{\"text-halo-width\":2,\"text-halo-color\":\"rgb(255, 255, 255)\",\"text-color\":\"hsl(0, 0%, 25%)\",\"text-halo-blur\":1}}],\"id\":\"NLS-Basemap\"}");


var $5bbb94183af54b93$exports = {};
$5bbb94183af54b93$exports = JSON.parse("{\"version\":8,\"name\":\"NLS Basemap\",\"center\":[21.645,63.101],\"zoom\":11.35,\"sources\":{\"taustakartta\":{\"type\":\"vector\",\"url\":\"https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/tilejson/taustakartta/1.0.0/taustakartta/default/v21/WGS84_Pseudo-Mercator/tilejson.json?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2\"},\"rasteritaustakartta\":{\"type\":\"raster\",\"tileSize\":256,\"tiles\":[\"https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/ortokuva/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2\"]}},\"glyphs\":\"https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/glyphs/{fontstack}/{range}.pbf?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2\",\"layers\":[{\"id\":\"background\",\"type\":\"background\",\"paint\":{\"background-color\":\"white\"}},{\"id\":\"taustakartta\",\"type\":\"raster\",\"source\":\"rasteritaustakartta\"},{\"id\":\"taajamaalue\",\"type\":\"fill\",\"source\":\"taustakartta\",\"source-layer\":\"maankaytto\",\"minzoom\":6,\"maxzoom\":13,\"filter\":[\"==\",\"kohdeluokka\",40200],\"paint\":{\"fill-color\":\"rgba(220,199,199,0.2)\"}},{\"id\":\"vesisto_alue_reuna\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"vesisto_alue\",\"paint\":{\"line-color\":\"#9ec9e8\",\"line-width\":0.5}},{\"id\":\"maastoaluereuna\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"maastoaluereuna\",\"filter\":[\"all\",[\"in\",\"kartografinenluokka\",32200,32300,32411,32412,32413,32414,32415,32416,32417,32418,33100],[\"==\",\"kohdeluokka\",30211]],\"paint\":{\"line-color\":\"#c8c4c5\",\"line-width\":0.5}},{\"id\":\"keinotekoinen_rantaviiva\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"maastoaluereuna\",\"filter\":[\"==\",\"kohdeluokka\",30100],\"paint\":{\"line-color\":\"#c8c4c5\",\"line-width\":0.5}},{\"id\":\"vesisto_alue\",\"type\":\"fill\",\"source\":\"taustakartta\",\"source-layer\":\"vesisto_alue\",\"paint\":{\"fill-color\":\"rgba(0,0,80,0.4)\"}},{\"id\":\"vesisto_viiva\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"vesisto_viiva\",\"paint\":{\"line-color\":\"#caedfb\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.75,20,30]}},{\"id\":\"rakennus\",\"type\":\"fill\",\"source\":\"taustakartta\",\"source-layer\":\"rakennus\",\"paint\":{\"fill-color\":\"rgba(255,255,255,0.2)\",\"fill-outline-color\":\"#adb0b3\"}},{\"id\":\"tiet tunnelissa\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141,12132,12131,12122,12121,12112,12111,12313,12314,12136],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-11],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[32,16],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajotie, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, pinnan alla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[-1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, pinnalla\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[0],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#eeeeee\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 1\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[1],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 2\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[2],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 3\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[3],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 4\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[4],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"ajotie, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12141],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"ajopolku, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12316],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[12,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"polku, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12313],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[2,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"kavely- ja pyoratie, paallystamaton, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[1],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-dasharray\":[3,1.5],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"kavely- ja pyoratie, paallystetty, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12314],true,false],[\"match\",[\"get\",\"paallyste\"],[2],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#90ca6f\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,0.5,20,15]}},{\"id\":\"tiet_1a_1b_reuna, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,6,20,84]}},{\"id\":\"tiet_2a_2b_reuna, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,63]}},{\"id\":\"tiet_3a_3b_reuna, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,3,20,30]}},{\"id\":\"rautatie_reuna, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2,20,40]}},{\"id\":\"tiet_1a_1b_taytto, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12111,12112],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,4,20,80]}},{\"id\":\"tiet_2a_2b_taytto, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12121,12122],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,2.5,20,60]}},{\"id\":\"tiet_3a_3b_taytto, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12131,12132],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"rautatie_taytto, sillalla 5\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[14111,14110,14112,14131,14151,14152,14121],true,false],[\"match\",[\"get\",\"tasosijainti\"],[5],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#fcfcfc\",\"line-dasharray\":[2,2],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"lautta ja lossi\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[12151,12152],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[6,8],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1.5,20,30]}},{\"id\":\"laiva ja venevaylat\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"==\",[\"geometry-type\"],\"LineString\"],[\"match\",[\"get\",\"kohdeluokka\"],[16511,16512],true,false]],\"layout\":{},\"paint\":{\"line-color\":\"#ccc\",\"line-dasharray\":[6,8],\"line-width\":[\"interpolate\",[\"exponential\",1.55],[\"zoom\"],6,1,20,20]}},{\"id\":\"hallintorajat\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"hallintoalue\",\"paint\":{\"line-color\":\"#8668de\",\"line-width\":1,\"line-opacity\":0.5}},{\"id\":\"rakennelmat\",\"type\":\"line\",\"source\":\"taustakartta\",\"source-layer\":\"rakennelma\",\"filter\":[\"any\",[\"==\",\"kohdeluokka\",45700],[\"==\",\"kohdeluokka\",45111],[\"==\",\"kohdeluokka\",45112],[\"==\",\"kohdeluokka\",44500]],\"paint\":{\"line-color\":\"#918a8c\",\"line-width\":0.5}},{\"id\":\"tienimet\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"liikenne\",\"filter\":[\"all\",[\"<\",\"tasosijainti\",1]],\"layout\":{\"text-field\":\"{nimi_suomi}        {nimi_ruotsi}\",\"text-font\":[\"Liberation Sans NLSFI\"],\"symbol-placement\":\"line\",\"text-size\":11},\"paint\":{\"text-color\":\"rgba(69, 86, 71, 1)\",\"text-halo-color\":\"#fff\",\"text-halo-width\":1,\"text-halo-blur\":1}},{\"id\":\"nimisto-maasto-vedet\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"nimisto\",\"filter\":[\"match\",[\"get\",\"teema\"],[\"Maasto\",\"Vedet\"],true,false],\"layout\":{\"text-field\":[\"coalesce\",[\"get\",\"nimi_fin\"],[\"get\",\"nimi_swe\"],[\"get\",\"nimi_sme\"],[\"get\",\"nimi_sms\"],[\"get\",\"nimi_smn\"]],\"text-font\":[\"match\",[\"get\",\"teema\"],\"Vedet\",[\"literal\",[\"Liberation Sans NLSFI Left\"]],\"Maasto\",[\"literal\",[\"Liberation Sans NLSFI Right\"]],[\"literal\",[\"Liberation Sans NLSFI\"]]],\"text-size\":[\"interpolate\",[\"linear\"],[\"zoom\"],1,[\"step\",[\"get\",\"prioriteetti\"],20,3,16],10,[\"step\",[\"get\",\"prioriteetti\"],20,4,14],16,[\"step\",[\"get\",\"prioriteetti\"],22,5,12]],\"visibility\":\"visible\"},\"paint\":{\"text-halo-width\":2,\"text-halo-color\":\"rgba(255, 255, 255, 1)\",\"text-color\":[\"match\",[\"get\",\"teema\"],\"Vedet\",\"hsl(251, 71%, 50%)\",\"hsl(0, 0%, 20%)\"],\"text-halo-blur\":1}},{\"id\":\"nimisto\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"nimisto\",\"filter\":[\"all\",[\"!\",[\"match\",[\"get\",\"teema\"],[\"Maasto\",\"Vedet\"],true,false]],[\"!=\",[\"get\",\"alaryhma\"],\"Hallintoalueet\"],[\"match\",[\"get\",\"laji\"],[\"Kansallispuisto\",\"Luonnonpuisto\"],false,true]],\"layout\":{\"text-transform\":[\"match\",[\"get\",\"alaryhma\"],\"Rautatieliikennepaikat\",\"uppercase\",\"none\"],\"text-field\":[\"coalesce\",[\"get\",\"nimi_fin\"],[\"get\",\"nimi_swe\"],[\"get\",\"nimi_sme\"],[\"get\",\"nimi_sms\"],[\"get\",\"nimi_smn\"]],\"icon-ignore-placement\":true,\"icon-allow-overlap\":true,\"text-font\":[\"Liberation Sans NLSFI\"],\"text-size\":[\"interpolate\",[\"linear\"],[\"zoom\"],1,[\"interpolate\",[\"linear\"],[\"get\",\"prioriteetti\"],1,20,3,16],10,[\"interpolate\",[\"linear\"],[\"get\",\"prioriteetti\"],5,16,7,13],14,[\"interpolate\",[\"linear\"],[\"get\",\"prioriteetti\"],5,22,10,12]],\"visibility\":\"visible\"},\"paint\":{\"text-halo-width\":2,\"text-halo-color\":\"rgba(255, 255, 255, 1)\",\"text-color\":[\"match\",[\"get\",\"teema\"],\"Vedet\",\"hsl(251, 71%, 50%)\",\"Suojellut kohteet\",\"hsl(117, 79%, 31%)\",\"hsl(0, 0%, 15%)\"],\"text-halo-blur\":1}},{\"id\":\"nimisto_luonnopuistot\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"nimisto\",\"filter\":[\"match\",[\"get\",\"laji\"],[\"Kansallispuisto\",\"Luonnonpuisto\"],true,false],\"layout\":{\"text-field\":[\"coalesce\",[\"get\",\"nimi_fin\"],[\"get\",\"nimi_swe\"],[\"get\",\"nimi_sme\"],[\"get\",\"nimi_sms\"],[\"get\",\"nimi_smn\"]],\"icon-ignore-placement\":true,\"icon-allow-overlap\":false,\"text-font\":[\"Liberation Sans NLSFI\"],\"visibility\":\"visible\"},\"paint\":{\"text-halo-width\":2,\"text-halo-color\":\"rgba(255, 255, 255, 1)\",\"text-color\":\"hsl(117, 79%, 31%)\",\"text-halo-blur\":1}},{\"id\":\"nimisto_kunnat\",\"type\":\"symbol\",\"source\":\"taustakartta\",\"source-layer\":\"nimisto\",\"filter\":[\"all\",[\"==\",[\"get\",\"alaryhma\"],\"Hallintoalueet\"],[\"==\",[\"get\",\"laji\"],\"Kunta\"]],\"layout\":{\"text-field\":[\"coalesce\",[\"get\",\"nimi_fin\"],[\"get\",\"nimi_swe\"],[\"get\",\"nimi_sme\"],[\"get\",\"nimi_sms\"],[\"get\",\"nimi_smn\"]],\"icon-ignore-placement\":false,\"icon-allow-overlap\":false,\"text-size\":[\"interpolate\",[\"exponential\",1.35],[\"zoom\"],1,16,14,28],\"text-font\":[\"step\",[\"zoom\"],[\"literal\",[\"Liberation Sans NLSFI\"]],6,[\"literal\",[\"Liberation Sans NLSFI Bold\"]]]},\"paint\":{\"text-halo-width\":2,\"text-halo-color\":\"rgb(255, 255, 255)\",\"text-color\":\"hsl(0, 0%, 25%)\",\"text-halo-blur\":1}}],\"id\":\"NLS-Basemap\"}");


var $09617f29d066f076$exports = {};
$09617f29d066f076$exports = JSON.parse('{"version":8,"name":"NLS Basemap","center":[21.645,63.101],"zoom":11.35,"sources":{"point":{"type":"geojson","data":{"type":"FeatureCollection","features":[]}},"taustakartta":{"type":"vector","url":"https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/tilejson/taustakartta/1.0.0/taustakartta/default/v21/WGS84_Pseudo-Mercator/tilejson.json?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2"},"rasteritaustakartta":{"type":"raster","tileSize":256,"tiles":["https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/ortokuva/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2"]}},"glyphs":"https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/glyphs/{fontstack}/{range}.pbf?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2","layers":[{"id":"background","type":"background","paint":{"background-color":"white"}},{"id":"maasto_alue","type":"fill","source":"taustakartta","source-layer":"maasto_alue","filter":["match",["get","kohdeluokka"],[35300,35411,35412,35421,35422,34300,34100,34700,38300,38700,39110,39120,39130,33000,38400,38600,35401,35402],true,false],"paint":{"fill-color":["match",["get","kohdeluokka"],[35400,35411,35421,35401],"#CaEfEa",[35412,35422,35402],"#d9ead4",[35300],"#CaEfEa",[34100,38600],"hsla(208, 11%, 75%, 0.5)",[34700],"hsl(208, 27%, 85%)",[38300,38700,38400,39130],"hsl(207, 100%, 94%)",[39110],"hsla(44, 100%, 83%, 0.84)",[39120],"hsl(65, 57%, 91%)","hsla(360, 100%, 100%, 0)"]}},{"id":"maankaytto","type":"fill","source":"taustakartta","source-layer":"maankaytto","filter":["match",["get","kohdeluokka"],[32111,32112,32113,32200,32300,32500,32611,32612,32800,32900,33100,34300,38900,40200],true,false],"paint":{"fill-color":["match",["get","kohdeluokka"],40200,"#f8fbf5",32611,"#f9f4d2",32200,"hsl(87, 45%, 72%)",32612,"hsl(87, 45%, 72%)",32800,"hsl(87, 45%, 72%)",32900,"hsl(87, 45%, 72%)",33100,"hsl(87, 65%, 82%)",34300,"hsl(60, 55%, 80%)",32500,"#dde5dd","#f7f7f3"]}},{"id":"maankaytto_reuna","type":"line","source":"taustakartta","source-layer":"maankaytto","filter":["match",["get","kohdeluokka"],[33100],true,false],"paint":{"line-color":["match",["get","kohdeluokka"],[33100],"hsl(87, 15%, 52%)","hsl(87, 65%, 82%)"]}},{"id":"lentokentta_alue","type":"fill","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"Polygon"],["match",["get","kohdeluokka"],[32411,32412,32413,32414,32415,32416,32417,32418,32441,32442],true,false]],"layout":{},"paint":{"fill-color":["match",["get","kohdeluokka"],[32411,23412],"#d0d0d0",[32413,32415,32416,32441,32442],"#f0f0f0",[32414,32417,32418],"#e0e0e0","hsl(0,0%,80%)"],"fill-outline-color":["match",["get","kohdeluokka"],[32441,32442],"#c8c4c5","hsla(360, 100%, 100%, 0)"]}},{"id":"lentokentta_viiva","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["any",["==","kohdeluokka",32431],["==","kohdeluokka",32432]],"paint":{"line-width":7,"line-color":"#e0e0e0"}},{"id":"lentokentta_viiva2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["any",["==","kohdeluokka",32431],["==","kohdeluokka",32432]],"paint":{"line-width":12,"line-color":"#e0e0e0"}},{"id":"korkeus_viiva","type":"line","source":"taustakartta","source-layer":"korkeus","minzoom":0,"maxzoom":20,"paint":{"line-color":"rgba(252, 179, 110, 1)","line-width":1}},{"id":"korkeus_paaviiva","type":"line","source":"taustakartta","source-layer":"korkeus","minzoom":0,"filter":["all",["has","korkeusarvo"],["==",["%",["get","korkeusarvo"],20000],0]],"paint":{"line-color":"rgba(252, 179, 110, 1)","line-width":2.5}},{"id":"korkeus_paaviiva2","type":"line","source":"taustakartta","source-layer":"korkeus","minzoom":0,"maxzoom":20,"filter":["all",["has","korkeus"],["==",["%",["get","korkeus"],20],0]],"paint":{"line-color":"rgba(252, 179, 110, 1)","line-width":2}},{"id":"vesisto_alue_reuna","type":"line","source":"taustakartta","source-layer":"vesisto_alue","paint":{"line-color":"hsl(200, 80%, 75%)","line-width":2.5}},{"id":"vesisto_alue","type":"fill","source":"taustakartta","source-layer":"vesisto_alue","paint":{"fill-color":"hsl(200, 80%, 85%)"}},{"id":"vesisto_viiva","type":"line","source":"taustakartta","source-layer":"vesisto_viiva","filter":["in","kohdeluokka",36312,36314,36316],"paint":{"line-color":"#90C8FF","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,30]}},{"id":"vesisto_viiva_kapea","type":"line","source":"taustakartta","source-layer":"vesisto_viiva","filter":["==","kohdeluokka",36311],"paint":{"line-color":"#A0C8FF","line-width":2}},{"id":"maastoaluereuna","type":"line","source":"taustakartta","source-layer":"maastoaluereuna","filter":["all",["in","kartografinenluokka",32200,32300,32411,32412,32413,32414,32415,32416,32417,32418,33100],["==","kohdeluokka",30211]],"paint":{"line-color":"#c8c4c5","line-width":0.5}},{"id":"tiet tunnelissa","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141,12132,12131,12122,12121,12112,12111,12313,12314,12136],true,false],["match",["get","tasosijainti"],[-11],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[32,16],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajotie, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#595","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["linear"],["zoom"],5,2,10,4]}},{"id":"tiet_1a_1b_taytto, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#a1d99b","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,4]}},{"id":"ajotie, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#808080","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,20]}},{"id":"ajopolku, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#595","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#b0b0b0","line-dasharray":[4.5,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#508050","line-dasharray":[4.5,0.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1.2,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#205020","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["linear"],["zoom"],5,2,14,3]}},{"id":"tiet_1a_1b_taytto, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],3,4,20,80]}},{"id":"tiet_2a_2b_taytto, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#a1d99b","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#205020","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#a1d99b","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#a1d99b","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"lautta ja lossi","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12151,12152],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[6,8],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"laiva ja venevaylat","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[16511,16512,16521,16522],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-dasharray":[6,1,6],"line-width":1}},{"id":"hallintorajat","type":"line","source":"taustakartta","source-layer":"hallintoalue","paint":{"line-color":"#6000ff","line-width":2,"line-dasharray":[8.5,1.5,1.5,1.5]}},{"id":"rakennus","type":"fill","source":"taustakartta","source-layer":"rakennus","paint":{"fill-color":["match",["get","kohdeluokka"],[42110,42111,42112,42210,42211,42213],"#f57654",[42120,42121,42122,42220,42221,42222],"#d0d0c8",[42130,42131,42132,42230,42231,42232],"#fFaf9c",[42140,42141,42142,42240,42241,42242],"#d0d0a0","#d0d0d0"]}},{"id":"rakennus_reuna","type":"line","source":"taustakartta","source-layer":"rakennus","paint":{"line-color":"#505050"}},{"id":"rakennelmat","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["all",["!",["match",["get","tasosijainti"],[-1],true,false]],["!",["match",["get","kohdeluokka"],[45111,45112,44500,44591,22311,22312,26111,45700,44211,44213,22200],true,false]]],"paint":{"line-color":"red","line-width":5}},{"id":"rakennelmat_laituri","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",45111],["==","kohdeluokka",45112]],"paint":{"line-color":"#918a8c","line-width":3}},{"id":"rakennelmat_muurityms","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",45700]],"paint":{"line-color":"#554634","line-width":1}},{"id":"rakennelmat_muurityms1","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",45700]],"paint":{"line-color":"#554634","line-width":1,"line-offset":2}},{"id":"rakennelmat_aita_tekoaines","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",44211]],"paint":{"line-color":"#54587f","line-width":2,"line-dasharray":[20,1,0.5,1]}},{"id":"rakennelmat_aita_istutettu","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",44213]],"paint":{"line-color":"#20c020","line-width":3}},{"id":"rakennelmat_ilmarata","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",44500]],"paint":{"line-color":"#191000","line-width":1}},{"id":"rakennelmat_ilmarata_tolppa","type":"circle","source":"taustakartta","source-layer":"rakennelma","filter":["==","kohdeluokka",44591],"paint":{"circle-color":"#191000","circle-radius":3}},{"id":"rakennelmat_suurjannitelinja","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["all",["any",["match",["get","tasosijainti"],[1],true,false],["!",["has","tasosijainti"]]],["match",["get","kohdeluokka"],[22311,22312,22200],true,false]],"paint":{"line-color":"#c51b8a","line-width":2}},{"id":"rakennelmat_suurjannite_tolppa","type":"circle","source":"taustakartta","source-layer":"rakennelma","filter":["==","kohdeluokka",22392],"paint":{"circle-color":"#dd1c77","circle-radius":2}},{"id":"tienimet","type":"symbol","source":"taustakartta","source-layer":"liikenne","filter":["all",["<","tasosijainti",1]],"layout":{"text-field":"{nimi_suomi}        {nimi_ruotsi}","text-font":["Liberation Sans NLSFI"],"symbol-placement":"line","text-size":12},"paint":{"text-color":"#000","text-halo-color":"#fff","text-halo-width":1.5,"text-halo-blur":1}},{"id":"tienumerot","type":"symbol","source":"taustakartta","source-layer":"liikenne","filter":["all",["<","tieluokka",5],[">","tieluokka",0]],"layout":{"text-field":"{tienumero}","text-font":["Liberation Sans NLSFI"],"symbol-placement":"line","text-size":16},"paint":{"text-color":"#f00","text-halo-color":"#fff","text-halo-width":2,"text-halo-blur":1}},{"id":"nimisto-maasto-vedet","type":"symbol","source":"taustakartta","source-layer":"nimisto","filter":["match",["get","teema"],["Maasto","Vedet"],true,false],"layout":{"text-field":["coalesce",["get","nimi_fin"],["get","nimi_swe"],["get","nimi_sme"],["get","nimi_sms"],["get","nimi_smn"]],"text-font":["match",["get","teema"],"Vedet",["literal",["Liberation Sans NLSFI Left"]],"Maasto",["literal",["Liberation Sans NLSFI Right"]],["literal",["Liberation Sans NLSFI"]]],"text-size":["interpolate",["linear"],["zoom"],1,["step",["get","prioriteetti"],20,3,16],10,["step",["get","prioriteetti"],20,4,14],16,["step",["get","prioriteetti"],22,5,12]],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":["match",["get","teema"],"Vedet","hsl(251, 71%, 50%)","hsl(0, 0%, 20%)"],"text-halo-blur":1}},{"id":"nimisto","type":"symbol","source":"taustakartta","source-layer":"nimisto","filter":["all",["!",["match",["get","teema"],["Maasto","Vedet"],true,false]],["!=",["get","alaryhma"],"Hallintoalueet"],["match",["get","laji"],["Kansallispuisto","Luonnonpuisto"],false,true]],"layout":{"text-transform":["match",["get","alaryhma"],"Rautatieliikennepaikat","uppercase","none"],"text-field":["coalesce",["get","nimi_fin"],["get","nimi_swe"],["get","nimi_sme"],["get","nimi_sms"],["get","nimi_smn"]],"icon-ignore-placement":true,"icon-allow-overlap":true,"text-font":["Liberation Sans NLSFI"],"text-size":["interpolate",["linear"],["zoom"],1,["interpolate",["linear"],["get","prioriteetti"],1,20,3,16],10,["interpolate",["linear"],["get","prioriteetti"],5,16,7,13],14,["interpolate",["linear"],["get","prioriteetti"],5,22,10,12]],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":["match",["get","teema"],"Vedet","hsl(251, 71%, 50%)","Suojellut kohteet","hsl(117, 79%, 31%)","hsl(0, 0%, 15%)"],"text-halo-blur":1}},{"id":"nimisto_luonnopuistot","type":"symbol","source":"taustakartta","source-layer":"nimisto","filter":["match",["get","laji"],["Kansallispuisto","Luonnonpuisto"],true,false],"layout":{"text-field":["coalesce",["get","nimi_fin"],["get","nimi_swe"],["get","nimi_sme"],["get","nimi_sms"],["get","nimi_smn"]],"icon-ignore-placement":true,"icon-allow-overlap":false,"text-font":["Liberation Sans NLSFI"],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":"hsl(117, 79%, 31%)","text-halo-blur":1}},{"id":"nimisto_kunnat","type":"symbol","source":"taustakartta","source-layer":"nimisto","filter":["all",["==",["get","alaryhma"],"Hallintoalueet"],["==",["get","laji"],"Kunta"]],"layout":{"text-field":["coalesce",["get","nimi_fin"],["get","nimi_swe"],["get","nimi_sme"],["get","nimi_sms"],["get","nimi_smn"]],"icon-ignore-placement":false,"icon-allow-overlap":false,"text-size":["interpolate",["exponential",1.35],["zoom"],1,16,14,28],"text-font":["step",["zoom"],["literal",["Liberation Sans NLSFI"]],6,["literal",["Liberation Sans NLSFI Bold"]]]},"paint":{"text-halo-width":2,"text-halo-color":"rgb(255, 255, 255)","text-color":"hsl(0, 0%, 25%)","text-halo-blur":1}},{"id":"maasto_viiva_portti_este","type":"line","source":"taustakartta","source-layer":"maasto_viiva","filter":["any",["==","kohdeluokka",30300],["==","kohdeluokka",30400]],"paint":{"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"line-color":"blue"}},{"id":"maasto_viiva_jyrkanne","type":"line","source":"taustakartta","source-layer":"maasto_viiva","filter":["any",["==","kohdeluokka",34400],["==","kohdeluokka",34500]],"paint":{"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"line-color":"black"}},{"id":"maasto_viiva_jyrkanne_pykala","type":"line","source":"taustakartta","source-layer":"maasto_viiva","filter":["any",["==","kohdeluokka",34400]],"minzoom":14,"paint":{"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"line-color":"black","line-offset":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"line-dasharray":[0.1,1]}},{"id":"maasto_piste","type":"circle","source":"taustakartta","source-layer":"maasto_piste","filter":["in","kohdeluokka",34600,72310,38511,38512,39513],"paint":{"circle-radius":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"circle-color":"black"}},{"id":"suojelualueet","type":"line","source":"taustakartta","source-layer":"alueraja","filter":["in","kohdeluokka",72100,72200,72201,72202,72400,72500,72600,72800],"maxzoom":14,"paint":{"line-width":1,"line-color":"rgba(0,192,0,1)"}},{"id":"suojelualueet_reuna","type":"line","source":"taustakartta","source-layer":"alueraja","filter":["in","kohdeluokka",72100,72200,72201,72202,72400,72500,72600,72800],"minzoom":10,"maxzoom":15,"paint":{"line-width":3,"line-dasharray":[1,2],"line-color":"rgba(0,192,0,1)"}},{"id":"suoja_alueet","type":"line","source":"taustakartta","source-layer":"alueraja","filter":["in","kohdeluokka",62100,62200],"maxzoom":14,"paint":{"line-width":2,"line-color":"red","line-dasharray":[8.5,1.5,1.5,1.5]}},{"id":"poi","type":"circle","source":"taustakartta","source-layer":"poi","paint":{"circle-color":"red","circle-radius":3}},{"id":"poi_label","type":"symbol","source":"taustakartta","source-layer":"poi","layout":{"text-font":["Liberation Sans NLSFI"],"text-field":["case",["==",["get","kohdeluokka"],16126],"majakka",["==",["get","kohdeluokka"],45300],"savupiippu",["==",["get","kohdeluokka"],45800],"vesitorni",["==",["get","kohdeluokka"],45000],"n\xe4k\xf6torni",["==",["get","kohdeluokka"],45710],"tulentekopaikka",["==",["get","kohdeluokka"],44800],"masto",["==",["get","kohdeluokka"],45500],"tuulivoimala",["==",["get","kohdeluokka"],34900],"luontokohde",""],"text-size":12,"text-offset":[0,-1],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":"hsl(0, 0%, 20%)","text-halo-blur":1}},{"id":"maasto_poi","type":"circle","source":"taustakartta","source-layer":"maasto_piste","filter":["match",["get","kohdeluokka"],[34600,35100,72310,72320,72340],true,false],"paint":{"circle-color":"#8d7469","circle-radius":3}},{"id":"symbol_label","type":"symbol","source":"taustakartta","source-layer":"symboli","layout":{"text-font":["Liberation Sans NLSFI"],"text-field":["case",["==",["get","kohdeluokka"],12200],"(este)",""],"text-size":12,"text-offset":[0,0.5],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":"hsl(0, 0%, 20%)","text-halo-blur":1}},{"id":"maasto_poi_label","type":"symbol","source":"taustakartta","source-layer":"maasto_piste","layout":{"text-font":["Liberation Sans NLSFI"],"text-field":["case",["==",["get","kohdeluokka"],35100],"puu",["==",["get","kohdeluokka"],72310],"rauhoitettu kivi",["==",["get","kohdeluokka"],72320],"rauhoitettu puu",["==",["get","kohdeluokka"],72340],"muu rauhoitettu kohde",""],"text-size":12,"text-offset":[0,-1],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":"hsl(0, 0%, 20%)","text-halo-blur":1}},{"id":"point","source":"point","type":"circle","paint":{"circle-radius":20,"circle-color":"white","circle-stroke-color":"#000080","circle-stroke-width":2,"circle-opacity":0.5},"filter":["==","$type","Point"]}],"id":"NLS-Basemap"}');


var $74368cc7a58ab6d6$exports = {};
$74368cc7a58ab6d6$exports = JSON.parse('{"version":8,"name":"NLS Basemap","center":[21.645,63.101],"zoom":11.35,"sources":{"point":{"type":"geojson","data":{"type":"FeatureCollection","features":[]}},"taustakartta":{"type":"vector","url":"https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/tilejson/taustakartta/1.0.0/taustakartta/default/v21/WGS84_Pseudo-Mercator/tilejson.json?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2"},"rasteritaustakartta":{"type":"raster","tileSize":256,"tiles":["https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/ortokuva/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2"]}},"glyphs":"https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/glyphs/{fontstack}/{range}.pbf?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2","layers":[{"id":"background","type":"background","paint":{"background-color":"white"}},{"id":"maasto_alue","type":"fill","source":"taustakartta","source-layer":"maasto_alue","filter":["match",["get","kohdeluokka"],[35300,35411,35412,35421,35422,34300,34100,34700,38300,38700,39110,39120,39130,33000,38400,38600,35401,35402],true,false],"paint":{"fill-color":["match",["get","kohdeluokka"],[35400,35411,35421,35401],"#CaEfEa",[35412,35422,35402],"#d9ead4",[35300],"#CaEfEa",[34100,38600],"hsla(208, 11%, 75%, 0.5)",[34700],"hsl(208, 27%, 85%)",[38300,38700,38400,39130],"hsl(207, 100%, 94%)",[39110],"hsla(44, 100%, 83%, 0.84)",[39120],"hsl(65, 57%, 91%)","hsla(360, 100%, 100%, 0)"]}},{"id":"maankaytto","type":"fill","source":"taustakartta","source-layer":"maankaytto","filter":["match",["get","kohdeluokka"],[32111,32112,32113,32200,32300,32500,32611,32612,32800,32900,33100,34300,38900,40200],true,false],"paint":{"fill-color":["match",["get","kohdeluokka"],40200,"#f8fbf5",32611,"#f9f4d2",32200,"hsl(87, 45%, 72%)",32612,"hsl(87, 45%, 72%)",32800,"hsl(87, 45%, 72%)",32900,"hsl(87, 45%, 72%)",33100,"hsl(87, 65%, 82%)",34300,"hsl(60, 55%, 80%)",32500,"#dde5dd","#f7f7f3"]}},{"id":"maankaytto_reuna","type":"line","source":"taustakartta","source-layer":"maankaytto","filter":["match",["get","kohdeluokka"],[33100],true,false],"paint":{"line-color":["match",["get","kohdeluokka"],[33100],"hsl(87, 15%, 52%)","hsl(87, 65%, 82%)"]}},{"id":"lentokentta_alue","type":"fill","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"Polygon"],["match",["get","kohdeluokka"],[32411,32412,32413,32414,32415,32416,32417,32418,32441,32442],true,false]],"layout":{},"paint":{"fill-color":["match",["get","kohdeluokka"],[32411,23412],"#d0d0d0",[32413,32415,32416,32441,32442],"#f0f0f0",[32414,32417,32418],"#e0e0e0","hsl(0,0%,80%)"],"fill-outline-color":["match",["get","kohdeluokka"],[32441,32442],"#c8c4c5","hsla(360, 100%, 100%, 0)"]}},{"id":"lentokentta_viiva","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["any",["==","kohdeluokka",32431],["==","kohdeluokka",32432]],"paint":{"line-width":7,"line-color":"#e0e0e0"}},{"id":"lentokentta_viiva2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["any",["==","kohdeluokka",32431],["==","kohdeluokka",32432]],"paint":{"line-width":12,"line-color":"#e0e0e0"}},{"id":"korkeus_viiva","type":"line","source":"taustakartta","source-layer":"korkeus","minzoom":0,"maxzoom":20,"paint":{"line-color":"rgba(252, 179, 110, 1)","line-width":1}},{"id":"korkeus_paaviiva","type":"line","source":"taustakartta","source-layer":"korkeus","minzoom":0,"filter":["all",["has","korkeusarvo"],["==",["%",["get","korkeusarvo"],20000],0]],"paint":{"line-color":"rgba(252, 179, 110, 1)","line-width":2.5}},{"id":"korkeus_paaviiva2","type":"line","source":"taustakartta","source-layer":"korkeus","minzoom":0,"maxzoom":20,"filter":["all",["has","korkeus"],["==",["%",["get","korkeus"],20],0]],"paint":{"line-color":"rgba(252, 179, 110, 1)","line-width":2}},{"id":"vesisto_alue_reuna","type":"line","source":"taustakartta","source-layer":"vesisto_alue","paint":{"line-color":"hsl(200, 80%, 75%)","line-width":2.5}},{"id":"vesisto_alue","type":"fill","source":"taustakartta","source-layer":"vesisto_alue","paint":{"fill-color":"hsl(200, 80%, 85%)"}},{"id":"vesisto_viiva","type":"line","source":"taustakartta","source-layer":"vesisto_viiva","filter":["in","kohdeluokka",36312,36314,36316],"paint":{"line-color":"#90C8FF","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,30]}},{"id":"vesisto_viiva_kapea","type":"line","source":"taustakartta","source-layer":"vesisto_viiva","filter":["==","kohdeluokka",36311],"paint":{"line-color":"#A0C8FF","line-width":2}},{"id":"maastoaluereuna","type":"line","source":"taustakartta","source-layer":"maastoaluereuna","filter":["all",["in","kartografinenluokka",32200,32300,32411,32412,32413,32414,32415,32416,32417,32418,33100],["==","kohdeluokka",30211]],"paint":{"line-color":"#c8c4c5","line-width":0.5}},{"id":"tiet tunnelissa","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141,12132,12131,12122,12121,12112,12111,12313,12314,12136],true,false],["match",["get","tasosijainti"],[-11],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[32,16],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajotie, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#595","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["linear"],["zoom"],5,2,10,4]}},{"id":"tiet_1a_1b_taytto, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, pinnan alla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[-1],true,false]],"layout":{},"paint":{"line-color":"#a1d99b","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,4]}},{"id":"ajotie, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#808080","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,20]}},{"id":"ajopolku, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#595","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#b0b0b0","line-dasharray":[4.5,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#508050","line-dasharray":[4.5,0.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1.2,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#205020","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["linear"],["zoom"],5,2,14,3]}},{"id":"tiet_1a_1b_taytto, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],3,4,20,80]}},{"id":"tiet_2a_2b_taytto, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, pinnalla","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[0],true,false]],"layout":{},"paint":{"line-color":"#a1d99b","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#205020","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 1","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[1],true,false]],"layout":{},"paint":{"line-color":"#a1d99b","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 2","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[2],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 3","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[3],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 4","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[4],true,false]],"layout":{},"paint":{"line-color":"#a1d99b","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"ajotie, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12141],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"ajopolku, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12316],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[12,2],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"polku, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12313],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[2,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1,20,20]}},{"id":"kavely- ja pyoratie, paallystamaton, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[1],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-dasharray":[3,1.5],"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"kavely- ja pyoratie, paallystetty, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12314],true,false],["match",["get","paallyste"],[2],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#90ca6f","line-width":["interpolate",["exponential",1.55],["zoom"],6,0.5,20,15]}},{"id":"tiet_1a_1b_reuna, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,6,20,84]}},{"id":"tiet_2a_2b_reuna, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,63]}},{"id":"tiet_3a_3b_reuna, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#000","line-width":["interpolate",["exponential",1.55],["zoom"],6,3,20,30]}},{"id":"rautatie_reuna, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"tiet_1a_1b_taytto, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12111,12112],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,4,20,80]}},{"id":"tiet_2a_2b_taytto, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12121,12122],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,2.5,20,60]}},{"id":"tiet_3a_3b_taytto, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12131,12132],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"rautatie_taytto, sillalla 5","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[14111,14110,14112,14131,14121],true,false],["match",["get","tasosijainti"],[5],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-dasharray":[2,2],"line-width":["interpolate",["linear"],["zoom"],5,2,10,3]}},{"id":"lautta ja lossi","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[12151,12152],true,false]],"layout":{},"paint":{"line-color":"#ccc","line-dasharray":[6,8],"line-width":["interpolate",["exponential",1.55],["zoom"],6,1.5,20,30]}},{"id":"laiva ja venevaylat","type":"line","source":"taustakartta","source-layer":"liikenne","filter":["all",["==",["geometry-type"],"LineString"],["match",["get","kohdeluokka"],[16511,16512,16521,16522],true,false]],"layout":{},"paint":{"line-color":"#a0a0a0","line-dasharray":[6,1,6],"line-width":1}},{"id":"hallintorajat","type":"line","source":"taustakartta","source-layer":"hallintoalue","paint":{"line-color":"#6000ff","line-width":2,"line-dasharray":[8.5,1.5,1.5,1.5]}},{"id":"rakennus","type":"fill","source":"taustakartta","source-layer":"rakennus","paint":{"fill-color":["match",["get","kohdeluokka"],[42110,42111,42112,42210,42211,42213],"#f57654",[42120,42121,42122,42220,42221,42222],"#d0d0c8",[42130,42131,42132,42230,42231,42232],"#fFaf9c",[42140,42141,42142,42240,42241,42242],"#d0d0a0","#d0d0d0"]}},{"id":"rakennus_reuna","type":"line","source":"taustakartta","source-layer":"rakennus","paint":{"line-color":"#505050"}},{"id":"rakennelmat","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["all",["!",["match",["get","tasosijainti"],[-1],true,false]],["!",["match",["get","kohdeluokka"],[45111,45112,44500,44591,22311,22312,26111,45700,44211,44213,22200],true,false]]],"paint":{"line-color":"red","line-width":5}},{"id":"rakennelmat_laituri","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",45111],["==","kohdeluokka",45112]],"paint":{"line-color":"#918a8c","line-width":3}},{"id":"rakennelmat_muurityms","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",45700]],"paint":{"line-color":"#554634","line-width":1}},{"id":"rakennelmat_muurityms1","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",45700]],"paint":{"line-color":"#554634","line-width":1,"line-offset":2}},{"id":"rakennelmat_aita_tekoaines","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",44211]],"paint":{"line-color":"#54587f","line-width":2,"line-dasharray":[20,1,0.5,1]}},{"id":"rakennelmat_aita_istutettu","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",44213]],"paint":{"line-color":"#20c020","line-width":3}},{"id":"rakennelmat_ilmarata","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["any",["==","kohdeluokka",44500]],"paint":{"line-color":"#191000","line-width":1}},{"id":"rakennelmat_ilmarata_tolppa","type":"circle","source":"taustakartta","source-layer":"rakennelma","filter":["==","kohdeluokka",44591],"paint":{"circle-color":"#191000","circle-radius":3}},{"id":"rakennelmat_suurjannitelinja","type":"line","source":"taustakartta","source-layer":"rakennelma","filter":["all",["any",["match",["get","tasosijainti"],[1],true,false],["!",["has","tasosijainti"]]],["match",["get","kohdeluokka"],[22311,22312,22200],true,false]],"paint":{"line-color":"#c51b8a","line-width":2}},{"id":"rakennelmat_suurjannite_tolppa","type":"circle","source":"taustakartta","source-layer":"rakennelma","filter":["==","kohdeluokka",22392],"paint":{"circle-color":"#dd1c77","circle-radius":2}},{"id":"tienimet","type":"symbol","source":"taustakartta","source-layer":"liikenne","filter":["all",["<","tasosijainti",1]],"layout":{"text-field":"{nimi_suomi}        {nimi_ruotsi}","text-font":["Liberation Sans NLSFI"],"symbol-placement":"line","text-size":12},"paint":{"text-color":"#000","text-halo-color":"#fff","text-halo-width":1.5,"text-halo-blur":1}},{"id":"tienumerot","type":"symbol","source":"taustakartta","source-layer":"liikenne","filter":["all",["<","tieluokka",5],[">","tieluokka",0]],"layout":{"text-field":"{tienumero}","text-font":["Liberation Sans NLSFI"],"symbol-placement":"line","text-size":16},"paint":{"text-color":"#f00","text-halo-color":"#fff","text-halo-width":2,"text-halo-blur":1}},{"id":"nimisto-maasto-vedet","type":"symbol","source":"taustakartta","source-layer":"nimisto","filter":["match",["get","teema"],["Maasto","Vedet"],true,false],"layout":{"text-field":["coalesce",["get","nimi_fin"],["get","nimi_swe"],["get","nimi_sme"],["get","nimi_sms"],["get","nimi_smn"]],"text-font":["match",["get","teema"],"Vedet",["literal",["Liberation Sans NLSFI Left"]],"Maasto",["literal",["Liberation Sans NLSFI Right"]],["literal",["Liberation Sans NLSFI"]]],"text-size":["interpolate",["linear"],["zoom"],1,["step",["get","prioriteetti"],20,3,16],10,["step",["get","prioriteetti"],20,4,14],16,["step",["get","prioriteetti"],22,5,12]],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":["match",["get","teema"],"Vedet","hsl(251, 71%, 50%)","hsl(0, 0%, 20%)"],"text-halo-blur":1}},{"id":"nimisto","type":"symbol","source":"taustakartta","source-layer":"nimisto","filter":["all",["!",["match",["get","teema"],["Maasto","Vedet"],true,false]],["!=",["get","alaryhma"],"Hallintoalueet"],["match",["get","laji"],["Kansallispuisto","Luonnonpuisto"],false,true]],"layout":{"text-transform":["match",["get","alaryhma"],"Rautatieliikennepaikat","uppercase","none"],"text-field":["coalesce",["get","nimi_fin"],["get","nimi_swe"],["get","nimi_sme"],["get","nimi_sms"],["get","nimi_smn"]],"icon-ignore-placement":true,"icon-allow-overlap":true,"text-font":["Liberation Sans NLSFI"],"text-size":["interpolate",["linear"],["zoom"],1,["interpolate",["linear"],["get","prioriteetti"],1,20,3,16],10,["interpolate",["linear"],["get","prioriteetti"],5,16,7,13],14,["interpolate",["linear"],["get","prioriteetti"],5,22,10,12]],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":["match",["get","teema"],"Vedet","hsl(251, 71%, 50%)","Suojellut kohteet","hsl(117, 79%, 31%)","hsl(0, 0%, 15%)"],"text-halo-blur":1}},{"id":"nimisto_luonnopuistot","type":"symbol","source":"taustakartta","source-layer":"nimisto","filter":["match",["get","laji"],["Kansallispuisto","Luonnonpuisto"],true,false],"layout":{"text-field":["coalesce",["get","nimi_fin"],["get","nimi_swe"],["get","nimi_sme"],["get","nimi_sms"],["get","nimi_smn"]],"icon-ignore-placement":true,"icon-allow-overlap":false,"text-font":["Liberation Sans NLSFI"],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":"hsl(117, 79%, 31%)","text-halo-blur":1}},{"id":"nimisto_kunnat","type":"symbol","source":"taustakartta","source-layer":"nimisto","filter":["all",["==",["get","alaryhma"],"Hallintoalueet"],["==",["get","laji"],"Kunta"]],"layout":{"text-field":["coalesce",["get","nimi_fin"],["get","nimi_swe"],["get","nimi_sme"],["get","nimi_sms"],["get","nimi_smn"]],"icon-ignore-placement":false,"icon-allow-overlap":false,"text-size":["interpolate",["exponential",1.35],["zoom"],1,16,14,28],"text-font":["step",["zoom"],["literal",["Liberation Sans NLSFI"]],6,["literal",["Liberation Sans NLSFI Bold"]]]},"paint":{"text-halo-width":2,"text-halo-color":"rgb(255, 255, 255)","text-color":"hsl(0, 0%, 25%)","text-halo-blur":1}},{"id":"maasto_viiva_portti_este","type":"line","source":"taustakartta","source-layer":"maasto_viiva","filter":["any",["==","kohdeluokka",30300],["==","kohdeluokka",30400]],"paint":{"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"line-color":"blue"}},{"id":"maasto_viiva_jyrkanne","type":"line","source":"taustakartta","source-layer":"maasto_viiva","filter":["any",["==","kohdeluokka",34400],["==","kohdeluokka",34500]],"paint":{"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"line-color":"black"}},{"id":"maasto_viiva_jyrkanne_pykala","type":"line","source":"taustakartta","source-layer":"maasto_viiva","filter":["any",["==","kohdeluokka",34400]],"minzoom":14,"paint":{"line-width":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"line-color":"black","line-offset":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"line-dasharray":[0.1,1]}},{"id":"maasto_piste","type":"circle","source":"taustakartta","source-layer":"maasto_piste","filter":["in","kohdeluokka",34600,72310,38511,38512,39513],"paint":{"circle-radius":["interpolate",["exponential",1.55],["zoom"],6,0.75,20,30],"circle-color":"black"}},{"id":"suojelualueet","type":"line","source":"taustakartta","source-layer":"alueraja","filter":["in","kohdeluokka",72100,72200,72201,72202,72400,72500,72600,72800],"maxzoom":14,"paint":{"line-width":1,"line-color":"rgba(0,192,0,1)"}},{"id":"suojelualueet_reuna","type":"line","source":"taustakartta","source-layer":"alueraja","filter":["in","kohdeluokka",72100,72200,72201,72202,72400,72500,72600,72800],"minzoom":10,"maxzoom":15,"paint":{"line-width":3,"line-dasharray":[1,2],"line-color":"rgba(0,192,0,1)"}},{"id":"suoja_alueet","type":"line","source":"taustakartta","source-layer":"alueraja","filter":["in","kohdeluokka",62100,62200],"maxzoom":14,"paint":{"line-width":2,"line-color":"red","line-dasharray":[8.5,1.5,1.5,1.5]}},{"id":"poi","type":"circle","source":"taustakartta","source-layer":"poi","paint":{"circle-color":"red","circle-radius":3}},{"id":"poi_label","type":"symbol","source":"taustakartta","source-layer":"poi","layout":{"text-font":["Liberation Sans NLSFI"],"text-field":["case",["==",["get","kohdeluokka"],16126],"majakka",["==",["get","kohdeluokka"],45300],"savupiippu",["==",["get","kohdeluokka"],45800],"vesitorni",["==",["get","kohdeluokka"],45000],"n\xe4k\xf6torni",["==",["get","kohdeluokka"],45710],"tulentekopaikka",["==",["get","kohdeluokka"],44800],"masto",["==",["get","kohdeluokka"],45500],"tuulivoimala",["==",["get","kohdeluokka"],34900],"luontokohde",""],"text-size":12,"text-offset":[0,-1],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":"hsl(0, 0%, 20%)","text-halo-blur":1}},{"id":"maasto_poi","type":"circle","source":"taustakartta","source-layer":"maasto_piste","filter":["match",["get","kohdeluokka"],[34600,35100,72310,72320,72340],true,false],"paint":{"circle-color":"#8d7469","circle-radius":3}},{"id":"symbol_label","type":"symbol","source":"taustakartta","source-layer":"symboli","layout":{"text-font":["Liberation Sans NLSFI"],"text-field":["case",["==",["get","kohdeluokka"],12200],"(este)",""],"text-size":12,"text-offset":[0,0.5],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":"hsl(0, 0%, 20%)","text-halo-blur":1}},{"id":"maasto_poi_label","type":"symbol","source":"taustakartta","source-layer":"maasto_piste","layout":{"text-font":["Liberation Sans NLSFI"],"text-field":["case",["==",["get","kohdeluokka"],35100],"puu",["==",["get","kohdeluokka"],72310],"rauhoitettu kivi",["==",["get","kohdeluokka"],72320],"rauhoitettu puu",["==",["get","kohdeluokka"],72340],"muu rauhoitettu kohde",""],"text-size":12,"text-offset":[0,-1],"visibility":"visible"},"paint":{"text-halo-width":2,"text-halo-color":"rgba(255, 255, 255, 1)","text-color":"hsl(0, 0%, 20%)","text-halo-blur":1}},{"id":"point","source":"point","type":"circle","paint":{"circle-radius":20,"circle-color":"white","circle-stroke-color":"#000080","circle-stroke-width":2,"circle-opacity":0.5},"filter":["==","$type","Point"]}],"id":"NLS-Basemap"}');


// only boundaries
//import style from './maastotiedot.json';
const $0cf146259d57657d$var$styles = {
    'tausta': (0, (/*@__PURE__*/$parcel$interopDefault($eebadfeff4aeb973$exports))),
    'ortokuva': (0, (/*@__PURE__*/$parcel$interopDefault($5bbb94183af54b93$exports))),
    'maasto': (0, (/*@__PURE__*/$parcel$interopDefault($09617f29d066f076$exports))),
    'maasto-korkeusviivat': (0, (/*@__PURE__*/$parcel$interopDefault($74368cc7a58ab6d6$exports)))
}, $0cf146259d57657d$var$params = new URL(document.location).searchParams, $0cf146259d57657d$var$style = $0cf146259d57657d$var$styles[$0cf146259d57657d$var$params.get('style')] || (0, (/*@__PURE__*/$parcel$interopDefault($eebadfeff4aeb973$exports)));
// let's create the map
const $0cf146259d57657d$var$map = new (0, $902e455d852cdfb8$export$a5c7b93649eaf8f8)({
    container: 'map',
    hash: true,
    style: $0cf146259d57657d$var$style
});
window.map = $0cf146259d57657d$var$map;


//# sourceMappingURL=build-maplibre-webmercator.9e0087b9.js.map
